import * as go from 'gojs';

go.Diagram.licenseKey = '298647e0b36648c702d90676423d6bf919a175639c8418a30e0413f6e9083c06329fea2859d3829787ac4eff1f7d90d0dcc03e20c349023fe531dbdb11e18ea9bb3373e5140a4f88a45626969eff2bf1ae6a61f497e571a288288de0fba8c5cc08e0a3';
import pako from 'pako' ;
import { generateProcessReportHTML } from '@process-advisor/lib/htmlReportGenerator';

import { _base64ToArrayBuffer, wait, splitStringByByteLength, convertCSVtoArray, convertToCSV, getPreviousWeeks, getPreviousMonths, formattedDate, randomBetween, formatDate, getStandardDeviation, getMedianDuration } from '@process-advisor/process-miner/processMiner/ProcessMinerUtils';

import { animateLifecycleVariant, stopLifecycleAnimation } from '@process-advisor/process-miner/processMiner/animateLifecycleVariant/animateLifecycleVariant';
import { applyFilterEvents } from '@process-advisor/process-miner/api/methods/filters/applyFilterEvents';
import { updateGauges } from '@process-advisor/process-miner/api/methods/shared/updateGauges';
import { updateLoadingStatus } from '@process-advisor/process-miner/api/methods/data/updateLoadingStatus';
import { getSourceSystemFromAppVersion, getCapabilitiesForSource } from '@process-advisor/process-miner/sources/capabilities';


import { updateComments as updateCommentsEvent } from '@process-advisor/process-miner/api/methods/shared/updateComments';
import { updateDashboard  } from '@process-advisor/process-miner/api/methods/shared/updateDashboard';
import { updateAnalytic as updateAnalyticEvent } from '@process-advisor/process-miner/api/methods/shared/updateAnalytic';
import { updateDataTransformation } from '@process-advisor/process-miner/api/methods/data/updateDataTransformation';
import { updateCost } from '@process-advisor/process-miner/api/methods/shared/updateCost';
import { updateFilterAttributes } from '@process-advisor/process-miner/api/methods/shared/updateFilterAttributes';
import { changeBackgroundColor } from '@process-advisor/process-miner/api/methods/shared/changeBackroundColor';
import { alertMessage } from '@process-advisor/process-miner/api/methods/shared/alertMessage';
import { setFilterIcon } from '@process-advisor/process-miner/api/methods/navigation/setFilterIcon';
import { setConstraintIcon } from '@process-advisor/process-miner/api/methods/navigation/setConstraintIcon';
import { setDiscoveryIcon } from '@process-advisor/process-miner/api/methods/navigation/setDiscoveryIcon';
import { updateDiscoveryRules } from '@process-advisor/process-miner/api/methods/discoveryRules/updateDiscoveryRules';
import { updateFindings } from '@process-advisor/process-miner/api/methods/findings/updateFindings';
import { timeZoneList } from '@process-advisor/process-miner/processMiner/timeZones'

import { runWithoutLayoutAnimation } from '@process-advisor/process-miner/processMiner/runWithoutLayoutAnimation';
import { SidebarTab } from '@process-advisor/process-miner/shared/consts';
import { hideContextMenu, showContextMenu } from '@process-advisor/process-miner/api/methods/shared/contextMenu';
import { openDiscoveryRuleModal } from '@process-advisor/process-miner/api/methods/modals/discoveryRuleModal';
import { openStepCostModal } from '@process-advisor/process-miner/api/methods/modals/stepCostModal';
import { openStepMetricsModal } from '@process-advisor/process-miner/api/methods/modals/stepMetricsModal';
import { openActivityStepAnalysisModal } from '@process-advisor/process-miner/api/methods/modals/activityStepAnalysisModal';
import { openCommentsModal } from '@process-advisor/process-miner/api/methods/modals/commentsModal';
import { openProcessAnalyticsModal } from '@process-advisor/process-miner/api/methods/modals/processAnalyticsModal';
import { openTaskDetailModal } from '@process-advisor/process-miner/api/methods/modals/taskDetailModal';
import { openEventDetailModal } from '@process-advisor/process-miner/api/methods/modals/eventDetailModal';
import { openHistogramModal } from '@process-advisor/process-miner/api/methods/modals/histogramModal';
import { openWorkflowModal } from '@process-advisor/process-miner/api/methods/modals/workflowModal';
import { openVariantLifecycleModal } from '@process-advisor/process-miner/api/methods/modals/variantLifecycleModal';
import { openLifecycleModalMulti } from '@process-advisor/process-miner/api/methods/modals/taskLifecycleModal';
import { setAction_DecompositionTree } from '@process-advisor/process-miner/api/methods/navigation/setAction_DecompositionTree';
import { setAction_DiscoveryRules } from '@process-advisor/process-miner/api/methods/navigation/setAction_DiscoveryRules';
import { updateDiscoveryRulesGrid } from '@process-advisor/process-miner/api/methods/discoveryRules/updateDiscoveryRulesGrid';
import { setAction_Cluster } from '@process-advisor/process-miner/api/methods/navigation/setAction_Cluster';
import { setAction_Time } from '@process-advisor/process-miner/api/methods/navigation/setAction_Time';

import { setAction_InfluenceAnalysis } from '@process-advisor/process-miner/api/methods/navigation/setAction_InfluenceAnalysis';
import { setAction_Visualizer } from '@process-advisor/process-miner/api/methods/navigation/setAction_Visualizer';
import { CurvedLinkReshapingTool } from '@process-advisor/process-miner/processMiner/curvedLinkReshapingTool';
import { ZoomSlider } from '@process-advisor/process-miner/processMiner/zoomslider';

import { saveAs } from 'file-saver';
import Axios from 'axios';
import { readString } from 'react-papaparse';
import { now, isDate, truncate } from 'lodash';
import { Buffer } from 'buffer';
import { v4 as uuidv4 } from 'uuid';

import { openProgressModal } from '@process-advisor/process-miner/api/methods/modals/openProgressModal';
import { updateProgressModal } from '@process-advisor/process-miner/api/methods/modals/updateProgressModal';
import { closeProgressModal } from '@process-advisor/process-miner/api/methods/modals/closeProgressModal';
import { documentToSVG, elementToSVG, inlineResources} from 'dom-to-svg'
import { CANONICAL_PLATFORMS, canonicalSelectionFromLegacyTasks, canonicalToLegacyEventLog, debugCanonicalDataset, deriveCanonicalEvidenceMetrics, deriveCanonicalPeriodMetrics, mergeCanonicalPeriodRow, deriveCanonicalProcessMetrics, enrichCanonicalLifecycleDataset, enrichCanonicalConformanceDataset, legacyEventLogToCanonical, projectCanonicalDataset } from '@canonical-process';
import { loadCanonicalDatasetFromDatabase, saveCanonicalDatasetToDatabase } from '@process-advisor/lib/canonicalPersistence';


const ASSESSMENT_CREDIT_VALID_DAYS = 60;
const ASSESSMENT_CREDIT_VALID_MS = ASSESSMENT_CREDIT_VALID_DAYS * 24 * 60 * 60 * 1000;

const parseAssessmentCreditDate = (value) => {
    if (!value) return null;
    const date = value instanceof Date ? value : new Date(String(value));
    return Number.isFinite(date.getTime()) ? date : null;
};

const getAssessmentCreditAuthorizedAt = (source = {}) => (
    source?.authorizedAt
    || source?.ai_credit_authorized_at
    || source?.assessmentCreditAuthorizedAt
    || source?.createdAt
    || source?.authorization?.createdAt
    || source?.authorization?.authorizedAt
    || source?.authorization?.marker?.createdAt
    || source?.marker?.createdAt
    || source?.assessmentCreditMarker?.createdAt
    || null
);

const getAssessmentCreditExpiresAt = (source = {}) => {
    const explicit = parseAssessmentCreditDate(source?.expiresAt || source?.validUntil || source?.assessmentCreditExpiresAt || source?.authorization?.expiresAt || source?.authorization?.marker?.expiresAt || source?.marker?.expiresAt || source?.assessmentCreditMarker?.expiresAt);
    if (explicit) return explicit;
    const authorizedAt = parseAssessmentCreditDate(getAssessmentCreditAuthorizedAt(source));
    return authorizedAt ? new Date(authorizedAt.getTime() + ASSESSMENT_CREDIT_VALID_MS) : null;
};

const isAssessmentCreditAuthorizationExpired = (source = {}) => {
    const expiresAt = getAssessmentCreditExpiresAt(source);
    return expiresAt ? Date.now() > expiresAt.getTime() : false;
};

const isAssessmentCreditAuthorizationActive = (source = {}) => !isAssessmentCreditAuthorizationExpired(source);

const preserveProcessModelBillingFields = (processModel = {}) => ({
    ai_credit_authorized: processModel.ai_credit_authorized ?? false,
    ai_credit_authorized_at: processModel.ai_credit_authorized_at ?? null,
    ai_credit_authorization_id: processModel.ai_credit_authorization_id ?? null,
    ai_credit_authorized_count: processModel.ai_credit_authorized_count ?? 0,
    ai_credit_required_count: processModel.ai_credit_required_count ?? 0,
    ai_credit_record_count: processModel.ai_credit_record_count ?? 0,
    ai_credit_public_key_hash: processModel.ai_credit_public_key_hash ?? null,
    ai_credit_authorization_meta: processModel.ai_credit_authorization_meta ?? null,
});

const normalizeEditionAccess = (editionAccess = {}) => {
    const rawPlan = String(editionAccess?.plan || editionAccess?.pricing || '').trim().toLowerCase();
    const rawEdition = String(editionAccess?.edition || editionAccess?.appEdition || '').trim().toLowerCase();
    const plan = ['free', 'standard', 'lite', 'limited'].includes(rawPlan) || rawEdition === 'standard'
        ? 'free'
        : ['usage', 'usage-based', 'usage_based', 'assessment', 'consultant', 'partner'].includes(rawPlan)
            ? 'usage'
            : 'subscription';
    const assessmentCreditUnlocked = isAssessmentCreditUnlockedAccess(editionAccess);
    const isFree = plan === 'free' && !assessmentCreditUnlocked;
    const isUsage = plan === 'usage';
    const isTrial = plan === 'subscription' && !assessmentCreditUnlocked && (editionAccess?.isTrial === true || editionAccess?.isEvaluation === true);
    const isUsageLimited = isUsage && !assessmentCreditUnlocked && (editionAccess?.isUsageLimited === true || editionAccess?.isLimitedAccess === true || editionAccess?.enforceWorkItemLimit === true || editionAccess?.hasSubscriptionAccess === false);
    const parsedLimit = Number(editionAccess?.workItemLimit ?? editionAccess?.taskLimit);
    const defaultLimit = isFree ? 100 : isTrial ? 250 : isUsageLimited ? 100 : null;
    const workItemLimit = defaultLimit !== null
        ? (Number.isFinite(parsedLimit) && parsedLimit > 0 ? Math.floor(parsedLimit) : defaultLimit)
        : null;
    const enforceWorkItemLimit = workItemLimit !== null && (editionAccess?.enforceWorkItemLimit === true || isFree || isTrial || isUsageLimited);
    return {
        ...editionAccess,
        plan,
        pricing: plan,
        edition: isFree ? 'standard' : 'advanced',
        appEdition: isFree ? 'standard' : 'advanced',
        isFree,
        isUsage,
        isTrial,
        isUsageLimited,
        isLimitedAccess: isFree || isTrial || isUsageLimited,
        isEvaluation: isTrial,
        isSubscription: plan === 'subscription',
        isStandard: isFree,
        isAdvanced: !isFree,
        workItemLimit,
        taskLimit: workItemLimit,
        enforceWorkItemLimit,
        limitLabel: workItemLimit ? (isUsageLimited ? `${workItemLimit} work items/tasks in Evidence & Explorer` : `${workItemLimit} work items/tasks`) : 'Unlimited work items/tasks',
    };
};

const isSampleDatasetFlag = (value) => {
    if (value === true) return true;
    const raw = value && typeof value === 'object' ? (value.value ?? value.display_value ?? '') : value;
    const text = String(raw ?? '').trim().toLowerCase();
    return ['y', 'yes', 'true', 'sample'].includes(text);
};

const buildSampleEditionAccess = (editionAccess = {}, model = {}) => ({
    ...(editionAccess || {}),
    sample: 'Y',
    sampleDataset: true,
    isSample: true,
    requiresAssessmentCredits: false,
    isUsageLimited: false,
    isLimitedAccess: false,
    enforceWorkItemLimit: false,
    workItemLimit: null,
    taskLimit: null,
    showPlanBadge: false,
    showLimitLine: false,
});

const isSampleDatasetAccess = (editionAccess = {}) => (
    isSampleDatasetFlag(editionAccess?.sample)
    || isSampleDatasetFlag(editionAccess?.sampleDataset)
    || isSampleDatasetFlag(editionAccess?.isSample)
    || isSampleDatasetFlag(gSample)
);

const isAssessmentCreditUnlockedAccess = (editionAccess = {}) => (
    (editionAccess?.assessmentCreditAuthorized === true
    || editionAccess?.hasAssessmentCreditAuthorization === true
    || editionAccess?.datasetAiUnlocked === true
    || editionAccess?.aiCreditAuthorized === true)
    && isAssessmentCreditAuthorizationActive(editionAccess)
);

const isModelAssessmentCreditAuthorized = (model = {}) => (
    (model?.ai_credit_authorized === true
    || model?.ai_credit_authorized === 1
    || model?.ai_credit_authorized === '1'
    || String(model?.ai_credit_authorized || '').toLowerCase() === 'true'
    || model?.aiCreditAuthorized === true
    || model?.assessmentCreditAuthorized === true)
    && isAssessmentCreditAuthorizationActive(model)
);

const mergeAssessmentCreditFields = (loadedModel = {}, selectedModel = {}) => {
    if (!selectedModel || typeof selectedModel !== 'object') return loadedModel || {};
    const merged = { ...(loadedModel || {}) };
    const fields = [
        'ai_credit_authorized',
        'ai_credit_authorized_at',
        'ai_credit_authorization_id',
        'ai_credit_authorized_count',
        'ai_credit_required_count',
        'ai_credit_record_count',
        'ai_credit_public_key_hash',
        'ai_credit_authorization_meta',
    ];
    for (const field of fields) {
        if ((merged[field] === undefined || merged[field] === null || merged[field] === '' || merged[field] === false || merged[field] === 0)
            && selectedModel[field] !== undefined && selectedModel[field] !== null && selectedModel[field] !== '') {
            merged[field] = selectedModel[field];
        }
    }
    return merged;
};

const getWindowAssessmentCreditUnlock = (modelID = '', model = {}) => {
    if (typeof window === 'undefined') return null;
    const id = String(modelID || model?.id || '').trim();
    if (!id) return null;
    const marker = window.__PROCESS_ADVISOR_ASSESSMENT_CREDIT_UNLOCKS__?.[id];
    return marker?.authorized === true && isAssessmentCreditAuthorizationActive(marker) ? marker : null;
};

const buildAssessmentMarkerFromModel = (model = {}) => ({
    authorized: true,
    source: 'process-model-ai-credit',
    authorizationId: model?.ai_credit_authorization_id || null,
    authorizedCreditCount: Number(model?.ai_credit_authorized_count || model?.ai_credit_required_count || 1) || 1,
    requiredCredits: Number(model?.ai_credit_required_count || model?.ai_credit_authorized_count || 1) || 1,
    workItemCount: getAssessmentWorkItemCountFromModel(model),
    createdAt: model?.ai_credit_authorized_at || null,
    authorizedAt: model?.ai_credit_authorized_at || null,
    expiresAt: getAssessmentCreditExpiresAt(model)?.toISOString?.() || null,
    modelId: model?.id || '',
    modelTitle: model?.name || '',
});

const buildAssessmentUnlockedEditionAccess = (editionAccess = {}, marker = {}) => ({
    ...(editionAccess || {}),
    assessmentCreditAuthorized: true,
    hasAssessmentCreditAuthorization: true,
    datasetAiUnlocked: true,
    aiCreditAuthorized: true,
    assessmentCreditMarker: marker || null,
    assessmentCreditAuthorizedAt: getAssessmentCreditAuthorizedAt(marker) || null,
    assessmentCreditExpiresAt: getAssessmentCreditExpiresAt(marker)?.toISOString?.() || null,
    isUsageLimited: false,
    isLimitedAccess: false,
    enforceWorkItemLimit: false,
    workItemLimit: null,
    taskLimit: null,
    limitLabel: 'Assessment Credits applied',
    showPlanBadge: false,
    showLimitLine: false,
});

const getAssessmentWorkItemCountFromModel = (model = {}) => {
    const raw = model?.total_issues ?? model?.totalIssues ?? model?.work_items ?? model?.workItems ?? model?.tasks ?? model?.task_count ?? 0;
    const n = Number(raw);
    return Number.isFinite(n) && n > 0 ? n : 0;
};

const resolveDatasetAssessmentCreditAccess = async ({ AppVersion, editionAccess = {}, model = {}, modelID = '', title = '', customerID = '' } = {}) => {
    if (isAssessmentCreditUnlockedAccess(editionAccess)) return buildAssessmentUnlockedEditionAccess(editionAccess, editionAccess.assessmentCreditMarker || {});

    const runtimeMarker = getWindowAssessmentCreditUnlock(modelID, model);
    if (runtimeMarker) return buildAssessmentUnlockedEditionAccess(editionAccess, runtimeMarker);

    if (isSampleProcessModel(model)) return buildSampleEditionAccess(editionAccess, model);
    if (isModelAssessmentCreditAuthorized(model)) return buildAssessmentUnlockedEditionAccess(editionAccess, buildAssessmentMarkerFromModel(model));

    const platform = String(AppVersion || '').toUpperCase();
    if (platform !== 'FORGE' && platform !== 'SNOW') return editionAccess;
    if (isSampleDatasetAccess(editionAccess)) return editionAccess;

    const access = normalizeEditionAccess(editionAccess);
    // Assessment Credits can unlock datasets from either the free/limited Forge app
    // or the usage-based app. Do not restrict the backend authorization lookup to
    // usage pricing only, otherwise a paid dataset credit can still reopen/refresh
    // through the 100-work-item Free Plan cap.
    const isLimitedPlan = access.isLimitedAccess || access.enforceWorkItemLimit || access.hasSubscriptionAccess === false || access.workItemLimit;
    if (!isLimitedPlan) return editionAccess;

    try {
        const { invoke } = await loadForgeModule();
        if (typeof invoke !== 'function') return editionAccess;
        const recordCount = getAssessmentWorkItemCountFromModel(model);
        const status = await invoke('getAssessmentCreditAuthorization', {
            datasetId: modelID || model?.id || '',
            processModelId: modelID || model?.id || '',
            modelId: modelID || model?.id || '',
            datasetName: title || model?.name || '',
            modelTitle: title || model?.name || '',
            customerID: customerID || model?.customer_id || '',
            workItemCount: recordCount,
            recordCount,
            sample: model?.sample || editionAccess?.sample || 'N',
            sampleDataset: isSampleDatasetAccess(editionAccess),
            entitlementType: 'assessment_credit',
        }).catch(() => null);
        const authorized = status?.authorized === true || status?.allowed === true || status?.marker?.authorized === true;
        if (!authorized) return editionAccess;
        const marker = status?.marker || status || {};
        const unlocked = buildAssessmentUnlockedEditionAccess(editionAccess, marker);
        if (typeof window !== 'undefined') {
            try {
                window.__PROCESS_ADVISOR_ASSESSMENT_CREDIT_UNLOCKS__ = {
                    ...(window.__PROCESS_ADVISOR_ASSESSMENT_CREDIT_UNLOCKS__ || {}),
                    [String(modelID || model?.id || '')]: {
                        authorized: true,
                        modelId: modelID || model?.id || '',
                        modelTitle: title || model?.name || '',
                        recordCount,
                        requiredCredits: status?.requiredCredits || marker?.requiredCredits || 1,
                        authorizationId: marker?.authorizationId || status?.authorizationId || null,
                        authorizedAt: getAssessmentCreditAuthorizedAt(marker || status) || new Date().toISOString(),
                        expiresAt: getAssessmentCreditExpiresAt(marker || status)?.toISOString?.() || null,
                    },
                };
                window.dispatchEvent(new CustomEvent('metricus-assessment-credit-authorized', {
                    detail: {
                        initialCheck: true,
                        modelId: modelID || model?.id || '',
                        modelTitle: title || model?.name || '',
                        recordCount,
                        requiredCredits: status?.requiredCredits || marker?.requiredCredits || 1,
                        authorization: status,
                    },
                }));
            } catch (_) {}
        }
        return unlocked;
    } catch (error) {
        console.warn('[Plan access] Assessment Credit authorization check failed; keeping limited view.', error?.message || error);
        return editionAccess;
    }
};

const getEditionWorkItemLimit = (editionAccess = {}) => {
    if (isSampleDatasetAccess(editionAccess)) return null;
    const access = normalizeEditionAccess(editionAccess);
    return access.enforceWorkItemLimit ? access.workItemLimit : null;
};

const limitEventRowsToFirstWorkItems = (rows = [], limit = null) => {
    const max = Number(limit);
    if (!Array.isArray(rows) || !Number.isFinite(max) || max <= 0) return rows;
    const seen = new Set();
    const limitedRows = [];
    for (const row of rows) {
        const taskId = String(row?.task ?? row?.Task ?? row?.issue ?? row?.key ?? row?.id ?? '').trim();
        const key = taskId || `row-${limitedRows.length}`;
        if (!seen.has(key)) {
            if (seen.size >= max) continue;
            seen.add(key);
        }
        limitedRows.push(row);
    }
    return limitedRows;
};

const applyPlanLimitToLoadedEventLog = (editionAccess = {}) => {
    if (isAssessmentCreditUnlockedAccess(editionAccess)) {
        console.log('[Plan access] Assessment Credit authorised; skipping work item/task limit.');
        return;
    }
    if (isSampleDatasetAccess(editionAccess)) {
        console.log('[Plan access] Sample model detected; skipping work item/task limit.');
        return;
    }
    const access = normalizeEditionAccess(editionAccess);
    if (!access.enforceWorkItemLimit || !access.workItemLimit) return;
    const beforeRows = Array.isArray(gImportEventLogArray) ? gImportEventLogArray.length : 0;
    gImportEventLogArray = limitEventRowsToFirstWorkItems(gImportEventLogArray, access.workItemLimit);
    const afterRows = Array.isArray(gImportEventLogArray) ? gImportEventLogArray.length : 0;
    console.log(`[Plan access] Saved model limited to first ${access.workItemLimit} work items/tasks for ${access.limitScope || 'analysis'} (${beforeRows} rows -> ${afterRows} rows).`);
};

// Phase 1 refactor: split AppVersion-specific data access and event-log transformation
// SNOW support added: mirrors Forge architecture with x_metl3_pmo_model_array chunks

// SNOW API injected at runtime via setSNOWApi() - avoids webpack static import resolution
let gSnApi = null;
let gExtractSNEventLog = null;

export function setSNOWApi(snApi, extractSNEventLog) {
    gSnApi = snApi;
    gExtractSNEventLog = extractSNEventLog;
}

async function getSnApi() { return gSnApi; }
export async function getSNOWApi() { return gSnApi; }
async function getExtractSNEventLog() { return gExtractSNEventLog; }
import {
    getActivityTypesForge,
    getProcessModelForge,
    getCalendarForge,
    getJiraBaseUrlForge,
    getTotalIssueCountForge,
    fetchIssueBatchForge,
} from '@process-advisor/process-miner/processMiner/ProcessDataForge';

import { processEventLogTransform } from '@process-advisor/process-miner/processMiner/ProcessEventLog';
import { generateAndDownloadContent } from '@process-advisor/process-miner/processMiner/GenerateContent';
import { generateArrays as generateArraysImpl } from '@process-advisor/process-miner/processMiner/GenerateArrays';
import { generateLinks as generateLinksPV, generateNodes as generateNodesPV } from '@process-advisor/process-miner/processMiner/GeneratePV';
import { enrichProcessArrays } from '@process-advisor/process-miner/processMiner/processStatusMetrics';

const noopModule = {
  invoke: () => Promise.resolve({ active: true, type: 'COMMERCIAL', items: [], result: [], customer_id: '' }),
  requestJira: () => Promise.resolve({
    json: () => Promise.resolve({ groups: { items: [] }, accountId: '', values: [], siteUrl: '' })
  }),
  view: { getContext: () => Promise.resolve({ siteUrl: '', localId: '' }) },
  router: { navigate: () => Promise.resolve() },
};
let forgeModule = null;
const loadForgeModule = async () => {
  if (!forgeModule) {
    try {
      const mod = await import('@forge/bridge');
      forgeModule = (typeof mod.invoke === 'function') ? mod : noopModule;
    } catch(e) {
      forgeModule = noopModule;
    }
  }
  return forgeModule;
};


const queryString = window.location.search;
let urlHost = window.location.protocol + '//' + window.location.host;
const urlParams = new URLSearchParams(queryString);

let gCustomerID = ''
// time variables used for testing/optimization
let startTime = Date.now();
let finishTime = Date.now(); 

let ctr = 0;
let gApp = ''
let gSaveModel = false
let gDev = false;
let gEnvironment = 'Jira';
let gEntityUpper = 'Work Item';
let gEntityLower = 'work item';
if (gEnvironment === 'JiraForge') {
let gEntityUpper = 'Work Item';
let gEntityLower = 'work item';
}
if (gEnvironment === 'ServiceNow') {
    gEntityUpper = 'Task';
    gEntityLower = 'task';
}
if (urlHost.includes('localhost') === true) {gDev = true} 

let gModelID = '';
let gTaskTable = '';
let gProcessModelTitle = ''
let gAiExecutiveAssessment       = null;
let gAiImprovementOpportunities  = null;
let gAiOpportunities           = null;
let gAiBlueprint       = null;
let gAiWorkflowRedesign          = null;
let gAiImplementationRoadmap     = null;
let gAiFrameworkAssessment       = null;
let gAiConsultingReport          = null;
let gEventLogName = '';
let gUpdateEventLog = false;
let gImportEventLogArray = [];
let gCanonicalDataset = null;
let gWebCanonicalDataset = null;
let gWebModel = null;
let gCanonicalProcessMetrics = null;
let gCanonicalEvidenceMetrics = null;
let gCanonicalFilteredDataset = null;
let gCanonicalFilteredEvidenceMetrics = null;
let gTaskAttributes = [];
let gAttributePrivacy = {};  // { [fieldName|attributeID]: 'exclude'|'anonymize' }
let gSNVisualizerAttributeIDs = null; // SNOW-only: selected fields exposed in Explorer controls
let gAttributePrivacyAnonymizedValues = {};
let gAttributePrivacyAnonymizedCounters = {};
let gConsultingWorkspace = null;
let gEventAttributes = [];
let gUploadFileArray = [];
let gUploadFileHeader = [];
let gTransformation = [];
let gPersonArray = [];
let activePane = SidebarTab.eventLogTab;
let previousPane = SidebarTab.eventLogTab;
let gActiveAction = 'process_miner';
let gSourceAAVisualizer = false
let gLoadingStatus = '';
let gGaugesDisplayed = 0
let gActivityTypes = []
let gActivityGroupMap = {}  // populated from model.activity_group_mappings when useGroupMapping=true
let gActivityGroupMappingConfig = null
let gActivityType
let gDiscoveryRulesEdited = false
let gFindingsEdited = false
let gFilterStats = []
let gUniqueVariantsDiscovered = []
let gUniqueStepsDiscovered = []
let gUniqueActivitiesDiscovered = []
let gVariantAnalytics = []
let gActivityAnalytics = []
let gStepAnalytics = []
let gIssueAnalytics = []
let gEventAnalytics = []
let gModelMetrics = []
let gModelMetricsTotal = []
let gProcessingModelMetrics = false
let gAiBillingAccess = null

let gIssueComments = []
let gIssueWorklogs = []
let gActivityColors = []
let gActivityArray = [];
let gVariantEventsArray = [];
let gActivityIndexArray = [];
let gStepArray = [];
let gEventLogArray = [];
let gVariantArray = [];
let gTaskArray = [];
let gMetricArray = [];
let gAnalyticsTaskArray = [];
let gTasksFilteredArray = [];
let gAnalyticsEventArray = [];
let gModelFileName = gEntityUpper + 's';
let gDefaultVariantsSelected = 10;
let gCSV = [];
let gASALinks = [];
let gASANodes = [];
let gLifecycleSeries = [];
let gLifecycleCategory = [];
let gCalendar = 'None'
let gCalendarExists = false
let gCalendarDurationCache = null
let gCalendarUTC
let gWorkflowConfiguration = []
let gWorkflowTransitions = []
let gWorkflowVariants = []
let gStatusTypeMappings = [];
let gStatusTypeSummary = {};

function applyProcessArrayEnrichment() {
    const enriched = enrichProcessArrays({
        activityArray: gActivityArray,
        stepArray: gStepArray,
        eventLogArray: gEventLogArray,
        variantArray: gVariantArray,
        taskArray: gTaskArray,
        modelMetrics: gModelMetrics,
        modelMetricsTotal: gModelMetricsTotal,
        sourceSystem: getSourceSystem(),
        activityContext: getActivityContext(),
        activityGroupMappings: gActivityGroupMappingConfig
    });

    gActivityArray = enriched.activityArray || gActivityArray;
    gStepArray = enriched.stepArray || gStepArray;
    gEventLogArray = enriched.eventLogArray || gEventLogArray;
    gVariantArray = enriched.variantArray || gVariantArray;
    gTaskArray = enriched.taskArray || gTaskArray;
    gModelMetrics = enriched.modelMetrics || gModelMetrics;
    gModelMetricsTotal = enriched.modelMetricsTotal || gModelMetricsTotal;
    gStatusTypeMappings = enriched.statusTypeMappings || [];
    gStatusTypeSummary = enriched.statusTypeSummary || {};

    // Sprint 1 Increment 7: promote the same lifecycle/status classifications
    // used by the mature miner into the canonical model.  The canonical package
    // remains independent of Process Advisor by accepting mappings as input.
    if (gCanonicalDataset) {
        gCanonicalDataset = enrichCanonicalLifecycleDataset(gCanonicalDataset, {
            statusMappings: gStatusTypeMappings,
            activityContext: getActivityContext(),
        });
        gCanonicalProcessMetrics = deriveCanonicalProcessMetrics(gCanonicalDataset);
        gCanonicalEvidenceMetrics = deriveCanonicalEvidenceMetrics(gCanonicalDataset);
        refreshCanonicalFilterProjection('lifecycle-enrichment');

        if (typeof window !== 'undefined' && window.__PA_CANONICAL__) {
            window.__PA_CANONICAL__.dataset = gCanonicalDataset;
            window.__PA_CANONICAL__.cases = gCanonicalDataset.cases;
            window.__PA_CANONICAL__.events = gCanonicalDataset.events;
            window.__PA_CANONICAL__.metrics = gCanonicalProcessMetrics;
            window.__PA_CANONICAL__.evidenceMetrics = gCanonicalEvidenceMetrics;
            window.__PA_CANONICAL__.lifecycle = gCanonicalDataset.metadata?.lifecycle || null;
        }
    }
}

let gDataLoadType = '';
let gPlanTier = '';
let gSample = 'N';

let gClusterAttributeArray = [];
let gTaskStr = '';
let gClusterAttributes = [];
let gClusterValueType = 'high';
let gClusterMinMetric = 0;
let gClusterMaxMetric = 999999999;
let gClusterMinTasks = 1;
let gClusterMaxTasks = 999999999;
let gClusterRows = 20;
let gClusterAnalysisSteps = false
let gAnalytic = ''
let gInsights = []

let gDecompositionTreeTaskArray = [];
let gDecompositionTreeValueType = 'high';
let gDecompositionTreeMinTasks = 1;
let gDecompositionTreeMaxTasks = 999999999;
let gDecompositionTreeMinMetric = 0;
let gDecompositionTreeMaxMetric = 999999999;
let gDecompositionTreeAttribute = '';
let gDecompositionTreeMetric = 1;
let gRCDescription = '';
let gHistogramDescription = '';
let gHistogramTotal = '';
let gHistogramType = '';
let gTimeInActivitySource = 'time_in_activity';
let gInfluenceSource = ''
let gInfluenceDiscoveryRuleID = ''
let gClusterSource = ''
let gClusterDiscoveryRuleID = ''

let gInfluenceAnalysisAttributes = [];
let gInfluenceAnalysisMetric = 3;
let gInfluenceAnalysisInfluence = 'increase';
let gInfluenceAnalysisMinMetric = 0;
let gInfluenceAnalysisMaxMetric = 999999999;
let gInfluenceAnalysisMinTasks = 1;
let gInfluenceAnalysisMaxTasks = 999999999;
let gInfluenceAnalysisSteps = false;
let gClusterSourceDetails = []

let gMinDiagramWidth = 400;

let gTaskDetailExtract = 'summary';
let gEventDetailExtract = 'summary';

let gClusterMetric = 1;
let gSaveFilteredOnly = false;
let gInitialLoad = true;
let gInitialAALoad = true;
let gRebuildCtr = 0;
let userSessionToken;

let gAAGridState = []
let gVariantSlicerGridState;
let gVariantSlicerGridFilterState;
let gVariantFilterGridState;
let gStepFilterGridState;
let gCostsGridState;
let gActivityFilterGridState;
let gActivityTypeFilterGridState;
let gTaskAttributeFilterGridState;
let gEventAttributeFilterGridState;
let gDiscoveryRulesGridState;
let gFindingsGridState;

// default performance and task filters
let gFromTime 
let gToTime 

let gEventsTotal = 0;
let gTasksTotal = 0;

let gEventsAll = 0;
let gTasksAll = 0;
let gVariantsAll = 0;
let gActivitiesAll = 0;
let gStepsAll = 0;

let gEventsFiltered = 0;
let gTasksFiltered = 0;
let gVariantsFiltered = 0;
let gActivitiesFiltered = 0;
let gStepsFiltered = 0;

let gDiscoveryRuleSelectedRow = [];
let gFindingDetailProps = {};
let gFilterSelectedRow = 0;
let gCommentSelectedRow;

// working arrays
let gLinkArray = [];
let gLinkArrayFull = [];
let gAttributeArray = [];

let gModelComments = [];
let gDiscoveryRules = [];
let gFindings = [];
let gCosts = [];
let gFilterConditions = [];
let gNodeFilterConditions = [];
let gFilters = [];
let gFilterSets = 0;
let gTaskFilterAttributes = [];
let gTaskFilterActivities = [];
let gTaskFilterTime = [];
let gTaskFilterTasks = [];
let gFilterSelectedActivities = [];
let gFilterSelectedSteps = [];
let gFilterSelectedVariants = [];
let gDetailTaskVariantsSelected = [];
let gDetailTaskTasksSelected = [];
let gDetailTaskSummaryAttribute = '';
let gDetailEventSummaryAttribute = '';
let gTaskID = '';

let gSelectedTransformationMapping = '';
let gSelectedAttributes;
let gAttribute = '';
let gAttributeType = '';
let gPathFrom = [];
let gPathTo = [];
let gPathPredicate = '';

let gActualCost = 0;
let gForecastCost = 0;
let gPercCostSaving = 0;
let gCostSaving = 0;

let gVariants = 0;
let gIncludeStart = false;

//variables used by detail grids
let gDetailSource = '';
let gDetailVariant = null;
let gDetailActivity = null;
let gDetailDiscoveryRule = null
let gDetailNodeFrom = null;
let gDetailNodeTo = null;
let gDetailDescription = '';
let gASAType = null;
let gFilterTimeType = getEntityUpper()

// visualizer settings - start
let gProcessFlowDirection = 90;

let gShowLinkTasks = true;
let gShowLinkAvgDuration = true;
let gShowLinkPercTotal = true;

let gShowTooltipTasks = true;
let gShowTooltipPercTotal = true;
let gShowTooltipAvgDuration = true;
let gShowTooltipDeviation = true;
let gShowTooltipMinDuration = true;
let gShowTooltipMaxDuration = true;
let gShowTooltipMedDuration = false;
let gShowTooltipCommentsCustomer = false;
let gShowTooltipAvgCommentsCustomer = false;
let gShowTooltipCommentsInternal = false;
let gShowTooltipAvgCommentsInternal = false;
let gShowTooltipWorklogs = false;
let gShowTooltipAvgWorklogs = false;
let gShowTooltipAvgCost = false
let gShowTooltipPercCommentsInternal = false
let gShowTooltipPercCommentsCustomer = false
let gShowTooltipPercWorklogs = false
let gShowTooltipTotalTimespent = false
let gShowTooltipAvgTimespent = false


let gZoomToFit = false;

let gShowStartLabel = true;
let gShowEndLabel = true;

let gShowStartNode = true;
let gShowEndNode = true;

let gStepLabelFontSize = '6pt';

let gShowNodeTasks = true;
let gShowNodePercTotal = false;

let gNodeLabelFontSize = '7pt';

let gShowDurationDays = true;
let gShowDurationHours = true;
let gShowDurationMinutes = true;
let gShowDurationSeconds = false;

let gStepWidthTasks = true;
let gStepWidthDuration = false;
let gStepWidthStdDeviation = false;

let gHighlightLoops = false;

let gStepColourVolume = false;
let gStepColourDuration = true;
let gStepColourStdDeviation = false;

let gAnalyticsTaskAttribute = '';
let gAnalyticsTaskAttributeMetric = 1;
let gAnalyticsTaskHistoryMetric = 1;
let gAnalyticsEventAttribute = '';

let gActivityShape = 'RoundedRectangle';
let gColorStartNode = '#A09E9E';
let gColorEndNode = '#A09E9E';
let gColorLink = '#FDC819';
let gColorLinkSelect = '#727171';
let gAnimateColor = '#4A90E2';
let gLoopColor = '#0C78F6';
let gVisualizerBackgroundColor = '#FFFFFF';

let gSpacingColumn = 40;
let gSpacingLayer = 30;

let gASAMinTasks = 0;

// visualizer settings - end
let gDurationLabel = 'hrs';
let gStepSelectRetention = 'include';
let gActivitySelectRetention = 'include';
let gPathSelectRetention = 'include';

let gStepSelectOperator = 'or';
let gActivitySelectOperator = 'or';
let gPathSelectOperator = 'or';

let gLoopDashes = false;

let gDiagramPV = null;
let gDiagramDownload = null;
let gDiagramDecompositionTree = null;
let gDiagramCluster = null;
let gDiagramInfluenceAnalysis = null;
let gDiagramASA = null;
let gCurrentDiagram;
let gIssueTypes

let gIsolateVariant = 0;
let gAnimateVariant = 0;
let gLifecycleVariant = 0;
let gVariantLoops = null;
let gVariantPaneVariants = [];
let gTaskPaneVariants = [];
let gVariantTasksSliced = 0;
let gVariantsSliced = 0;
let gVariantEventsSliced = 0;
let gVariantStepsSliced = 0;
let gVariantActivitiesSliced = 0;
let gDiagramPVVariants = 0;
let gDiagramPVSteps = 0;
let gDiagramPVTasks = 0;
let gDiagramPVEvents = 0;
let gDiagramPVActivities = 0;
let gDiagramPVLoops = 0;
let gDiagramPVTaskLoops = 0;
let gSelectedProcessSteps = [];
let gVariantIsolate = false;
let gVariantAnimate = true;
let gVariantLifecycle = false;
let gSortIssues = true
let gSortAvgDuration = false

let gEventEmitter;
let gZoomSlider;
let gStepFilterSelection = [];
let gVariantFilterSelection = [];
let gActivityFilterSelection = [];
let gActivityTypeFilterSelection = [];

let gVariantsVisualizationGraphType = 1;
let gVariantsVisualizationMetric = 1;
let gTasksVisualizationGraphType = 1;
let gTasksVisualizationFilter = 0;
let gTasksVisualizationNumTasks = 30;
let gTasksVisualizationMetric = 1;
let gTasksVisualizationSort = 0;
let gHistogramArray = [];
let gTasksVisualizationSource = '';

let gStepColourCost

let gTimeAggregation = 'avg'
let gTimeMetric = 'duration'
let gTimeDurationFormat = 'DD:HH:MM' 
let gTimeActivity = -1
let gTimeActivityType = ''
let gTimeColors = true
let gTimeEndActivity = 'N/A'
let gAARows = []
let gAAValidKeys = []
let gAnalysisSource = ''

let gModelFromDate = ''
let gModelToDate = ''
let gJiraURL = ''
let gContextPath
let gAppVersion = ''

let currentTime = new Date().getTime();

gModelID = urlParams.get('model');
userSessionToken = urlParams.get('session');
gTaskTable = urlParams.get('table');
gModelFileName = urlParams.get('name');
gProcessModelTitle = urlParams.get('name');
const urlTaskAttributes = urlParams.getAll('task_attribute');

for (let i = 0; i < urlTaskAttributes.length; i++) {
    let vtpURL = {};
    vtpURL['id'] = 'ta' + i;
    vtpURL['field'] = urlTaskAttributes[i];
    gTaskAttributes.push(vtpURL);
}

export function setPlanTier(planTier) {
    gPlanTier = planTier;
}

export function setTaskID(taskID) {
    gTaskID = taskID.taskID;
    gDetailSource = 'task';
}

export function setEntity(entity, entities) {
    if (entity.initial === true && gEntityUpper != '') return;
    gEntityUpper = entity.entity || 'Work Item';
    gEntityLower = gEntityUpper.toLowerCase();
}

export function setEntityCSV(entity) {
    gEntityUpper = entity || 'Work Item';
    gEntityLower = gEntityUpper.toLowerCase();
}

export function getEntityUpper() {
    return gEntityUpper;
}

export function getModelFileName() {
    return gModelFileName;
}

export function getEntityLower() {
    return gEntityLower;
}

export function setAiBillingAccess(access) {
    gAiBillingAccess = access || null;
    if (typeof window !== 'undefined') {
        window.__PROCESS_ADVISOR_PLAN_ACCESS__ = gAiBillingAccess;
    }
}

export function getAiBillingAccess() {
    return gAiBillingAccess;
}

export function getAiBillingRecordCount() {
    const total = Number(gTasksTotal || gTaskArray.length || gModelMetricsTotal?.[0]?.total_tasks || gModelMetricsTotal?.[0]?.tasks || 0);
    return Number.isFinite(total) ? total : 0;
}


export function retrievePlanTier() {
    return gPlanTier;
}

export function setSample(sample) {
    gSample = sample;
}

export function eventLogName() {
    return gEventLogName;
}

export function updateEventLogFlag() {
    gUpdateEventLog = true;
}

export async function loadSNOWData() {
    gLoadingStatus = 'Loading event log';
    updateLoadingStatus({ eventEmitter: gEventEmitter });
    await wait();
    const values = await retrieveSNOWArray();
    loadSNOW(processData(values.event_log));
}


function processData(allText) {
    let lines = [];
    let tarr = [];

    let allTextLines = allText.split(/\r\n|\n/);
    for (let j = 0; j < allTextLines.length; j++) {
        allTextLines[j] = allTextLines[j].replaceAll('","', '^^');
        allTextLines[j] = allTextLines[j].replaceAll('"', '');
        allTextLines[j] = allTextLines[j].slice(0, -1)
    }
    let headers = allTextLines[0].split('^^');
    for (let j = 0; j < headers.length; j++) {
        tarr.push(headers[j]);
    }
    for (let i = 1; i < allTextLines.length; i++) {
        let data = allTextLines[i].split('^^');
        if (data.length == headers.length) {
            tarr = [];
            for (let j = 0; j < headers.length; j++) {
                tarr.push(data[j]);
            }
            lines.push(tarr);
        }
    }
    return lines;
}


export function uploadEventLog_File(csv, filename) {
    // called when event log CSV is dropped into papaparse object in import stepper
    gDataLoadType = 'File';
    gCSV = csv;
    gModelFileName = filename.substring(0, filename.lastIndexOf('.'));
    processEventLog_File();
}

export function processEventLog_File() { 
    if (gCSV.length === 0) return;

    gTransformation = [];
    gUploadFileHeader = [];
    let vtp = {};
    let numFields = 0;
    for (let i = 0; i <= 200; i++) {
        if (gCSV[0].data[i] == null) {
            break;
        }
        numFields++;
        vtp = {};
        vtp['headerName'] = gCSV[0].data[i];
        vtp['field'] = gCSV[0].data[i];
        vtp['dataType'] = 'text';
        vtp['mapping'] = '';
        gUploadFileHeader.push(vtp);
    }
    let taskExists = false;
    let activityExists = false;
    let activityTypeExists = false;
    let issueTypeExists = false;
    let timeStampExists = false;
    let resourceExists = false;
    for (let i = 0; i < gUploadFileHeader.length; i++) {
        vtp = {};
        const headerName = gUploadFileHeader[i].headerName;

        for (let j = 0; j < gTransformation.length; j++) {
            if (gTransformation[j].mapping == gEntityUpper + ' ID') {
                taskExists = true;
            }
            if (gTransformation[j].mapping == 'Activity') {
                activityExists = true;
            }
            if (gTransformation[j].mapping == 'Activity Type') {
                activityTypeExists = true;
            }
            if (gTransformation[j].mapping == 'Work Type') {
                issueTypeExists = true;
            }
            if (gTransformation[j].mapping == 'Timestamp') {
                timeStampExists = true;
            }
            if (gTransformation[j].mapping == 'Resource') {
                resourceExists = true;
            }
        }

        if ((headerName == 'Activity' || headerName =='activity') && activityExists == false) {
            vtp['field'] = headerName;
            vtp['mapping'] = 'Activity';
            vtp['dataType'] = 'Text';
            vtp['status'] = true;
            vtp['work_item'] = '';
            gTransformation.push(vtp);
            activityExists = true;
        }
        if ((headerName == 'Activity Type' || headerName == 'activity_type') && activityTypeExists == false) {
            vtp['field'] = headerName;
            vtp['mapping'] = 'Activity Type';
            vtp['dataType'] = 'Text';
            vtp['status'] = true;
            vtp['work_item'] = '';
            gTransformation.push(vtp);
            activityTypeExists = true;
        }
        if ((headerName == 'Work Type' || headerName == 'issue_type') && issueTypeExists == false) {
            vtp['field'] = headerName;
            vtp['mapping'] = 'Work Type';
            vtp['dataType'] = 'Text';
            vtp['status'] = true;
            vtp['work_item'] = '';
            gTransformation.push(vtp);
            issueTypeExists = true;
        }
        if ((headerName.includes(gEntityLower) || headerName.includes(gEntityUpper)) && taskExists == false) {
            vtp['field'] = headerName;
            vtp['mapping'] = gEntityUpper + ' ID';
            vtp['dataType'] = 'Text';
            vtp['status'] = true;
            vtp['work_item'] = '';
            gTransformation.push(vtp);
            taskExists = true;
        }
        if ((headerName.includes('Timestamp') || headerName.includes('timestamp')) && timeStampExists == false) {
            vtp['field'] = headerName;
            vtp['mapping'] = 'Timestamp';
            vtp['dataType'] = 'DateTime';
            vtp['status'] = true;
            vtp['work_item'] = '';
            gTransformation.push(vtp);
            timeStampExists = false;
        }
        if ((headerName.includes('Resource') || headerName.includes('resource')) && resourceExists == false) {
            vtp['field'] = headerName;
            vtp['mapping'] = 'Resource';
            vtp['dataType'] = 'Text';
            vtp['status'] = true;
            vtp['work_item'] = '';
            gTransformation.push(vtp);
        }
    }

    if (taskExists === false) {
        vtp = {};
        vtp['field'] = '';
        vtp['mapping'] = gEntityUpper + ' ID';
        vtp['dataType'] = 'Text';
        vtp['status'] = false;
        vtp['work_item'] = 'Please select the ' + gEntityUpper + ' ID column';
        gTransformation.push(vtp);
    }

    if (activityExists === false) {
        vtp = {};
        vtp['field'] = '';
        vtp['mapping'] = 'Activity';
        vtp['dataType'] = 'Text';
        vtp['status'] = false;
        vtp['work_item'] = 'Please select the Activity column';
        gTransformation.push(vtp);
    }
    if (activityTypeExists === false) {
        vtp = {};
        vtp['field'] = '';
        vtp['mapping'] = 'Activity Type';
        vtp['dataType'] = 'Text';
        vtp['status'] = false;
        vtp['work_item'] = 'Please select the Activity Type column';
        gTransformation.push(vtp);
    }

    if (timeStampExists === false) {
        vtp = {};
        vtp['field'] = '';
        vtp['mapping'] = 'Timestamp';
        vtp['dataType'] = 'Datetime';
        vtp['status'] = false;
        vtp['work_item'] = 'Please select the Timestamp column';
        gTransformation.push(vtp);
    }
    gUploadFileArray = [];
    vtp = {};
    for (let i = 1; i < gCSV.length - 1; i++) {
        vtp = {};
        for (let j = 0; j < numFields; j++) {
            vtp[gUploadFileHeader[j].field] = gCSV[i].data[j];
        }
        gUploadFileArray.push(vtp);
    }

    if (gEventEmitter) {
        updateDataTransformation({ eventEmitter: gEventEmitter });
    }
}

export function processEventLogCSV(customerID,projectName,saveModel,AppVersion) {
    if (projectName === '') {
        gProcessModelTitle = gModelFileName
    } else {
        gModelFileName = projectName
        gProcessModelTitle = projectName
    }
    gCustomerID = customerID
    return Promise.all([processCSV(saveModel,AppVersion)]); 
}

export async function processCSV(saveModel,AppVersion) {
    gImportEventLogArray = [];
    gCanonicalDataset = null;
    gCanonicalProcessMetrics = null;
    gCanonicalEvidenceMetrics = null;
    gCanonicalFilteredDataset = null;
    gCanonicalFilteredEvidenceMetrics = null;
    let key;
    let vtp = {};
    gTaskAttributes = [];
    gMetricArray = [];
    gActivityTypes = []
    gIssueTypes = []

    for (let i = 0; i < gUploadFileArray.length; i++) {
        if (gPlanTier != 'free' && gSample == null && i >= 500000) {
            alert('A maximum of 500K events are supported in this version of the Metricus process_miner');
            break;
        }
        let vtp = {};
        let taskAttributes = 0;
        let eventAttributes = 0;
        let metrics = 0;

        for (let j = 0; j < gTransformation.length; j++) {
            key = gTransformation[j].field;
            if (gTransformation[j].mapping === gEntityUpper + ' ID') {
                vtp['task'] = gUploadFileArray[i][key];
            }
            if (gTransformation[j].mapping === 'Activity') {
                vtp['activity'] = gUploadFileArray[i][key];
            }
            if (gTransformation[j].mapping === 'Activity Type') {
                vtp['activity_type'] = gUploadFileArray[i][key];
            }
            if (gTransformation[j].mapping === 'Work Type') {
                vtp['issue_type'] = gUploadFileArray[i][key];
            }
            if (gTransformation[j].mapping === 'Timestamp') {
                vtp['timestamp'] = gUploadFileArray[i][key];
            }
            if (gTransformation[j].mapping === gEntityUpper + ' Create Time') {
                vtp['create_time'] = gUploadFileArray[i][key];
            }
            if (gTransformation[j].mapping === gEntityUpper + ' Close Time') {
                vtp['close_time'] = gUploadFileArray[i][key];
            }

            if (gTransformation[j].mapping === 'Resource') {
                if (i == 0) {
                    vtp = [];
                    vtp['id'] = 'ea' + eventAttributes.toString();
                    vtp['field'] = key;
                    gEventAttributes.push(vtp);
                }
                vtp['resource'] = gUploadFileArray[i][key];
                eventAttributes++;
            }

            if (gTransformation[j].mapping === gEntityUpper + ' Attribute') {
                if (taskAttributes < 20) {
                    if (i == 0) {
                        vtp = {};
                        vtp['id'] = 'ta' + taskAttributes.toString();
                        vtp['field'] = key;
                        gTaskAttributes.push(vtp);
                    }
                    vtp['ta' + taskAttributes] = gUploadFileArray[i][key];
                    taskAttributes++;
                }
            }
            if (gTransformation[j].mapping === 'Event Attribute') {
                if (eventAttributes < 20) {
                    if (i == 0) {
                        vtp = {};
                        vtp['id'] = 'ea' + eventAttributes.toString();
                        vtp['field'] = key;
                        gEventAttributes.push(vtp);
                    }
                    vtp['ea' + eventAttributes] = gUploadFileArray[i][key];
                    eventAttributes++;
                }
            }
            if (gTransformation[j].mapping === 'Metric - True/False') {
                if (i == 0) {
                    vtp = {};
                    vtp['m'] = key;
                    vtp['t'] = 'true_false';
                    vtp['du'] = null;
                    vtp['id'] = metrics;
                    gMetricArray.push(vtp);
                }
                vtp['m' + metrics] = gUploadFileArray[i][key];
                metrics++;
            }
            if (gTransformation[j].mapping === 'Metric - Duration') {
                if (i == 0) {
                    vtp = {};
                    vtp['m'] = key;
                    vtp['t'] = 'duration';
                    vtp['du'] = null;
                    vtp['id'] = metrics;
                    gMetricArray.push(vtp);
                }
                vtp['m' + metrics] = gUploadFileArray[i][key];
                metrics++;
            }
            if (gTransformation[j].mapping === 'Metric - Amount') {
                if (i == 0) {
                    vtp = {};
                    vtp['m'] = key;
                    vtp['t'] = 'amount';
                    vtp['du'] = null;
                    vtp['id'] = metrics;
                    gMetricArray.push(vtp);
                }
                vtp['m' + metrics] = gUploadFileArray[i][key];
                metrics++;
            }
        }
        gUploadFileArray[i].id = i;
        gImportEventLogArray.push(vtp);
    }
    gIssueTypes = gImportEventLogArray[0].issue_type
    vtp = []
    vtp['id'] = 0
    vtp['activity_type'] = gImportEventLogArray[0].activity_type.toLowerCase()
    vtp['name'] = gImportEventLogArray[0].activity_type.toLowerCase()
    vtp['events'] = 0
    gActivityTypes.push(vtp)

    await processEventLog();  
    gAppVersion = AppVersion
    await loadAutomatedDiscoveryRules('generic') 
    await loadAutomatedDiscoveryRules('issueType')
    await saveEventLog('external',AppVersion)
}
export function processEventLogUpload() {
    return gUploadFileArray;
}

export function processEventLogHeaderUpload() {
    return gUploadFileHeader;
}


const PROCESS_PROGRESS_PREFIX = '__PA_PROGRESS__';

function formatProgressCount(value) {
    const n = Number(value || 0);
    if (!Number.isFinite(n)) return String(value || 0);
    return n.toLocaleString();
}

function setModelProcessingProgress({
    phase = 'Processing model',
    percent = 0,
    detail = '',
    primaryLabel = 'Status',
    primaryValue = 'Working',
    secondaryLabel = 'Step',
    secondaryValue = 'In progress',
    note = 'Process Advisor is preparing the selected process model.',
    runId = '',
    seq = 0,
} = {}) {
    gLoadingStatus = `${PROCESS_PROGRESS_PREFIX}${JSON.stringify({
        mode: 'extraction',
        phase,
        percent,
        detail,
        primaryLabel,
        primaryValue,
        secondaryLabel,
        secondaryValue,
        note,
        runId,
        seq,
    })}`;
    updateLoadingStatus({ eventEmitter: gEventEmitter });
}

async function handleDataRefresh(
    AppVersion,
    contextPath,
    model,
    modelID,
    SW_Model,
    title,
    license,
    stagilFieldsDC,
    app,
    fields,
    editionAccess = {}
) {
    if (AppVersion === 'SNOW') {
        return await handleDataRefreshSNOW(model, modelID, app, editionAccess);
    }

    // ── Jira (FORGE) refresh: fetch fresh data from Jira ──
    const progressRunId = `forge-refresh-${Date.now()}`;
    let progressSeq = 0;
    const step = (phase, percent, detail = '', primaryLabel = 'Status', primaryValue = 'Working', secondaryLabel = 'Step', secondaryValue = '') => {
        progressSeq += 1;
        setModelProcessingProgress({
            phase,
            percent,
            detail,
            primaryLabel,
            primaryValue,
            secondaryLabel,
            secondaryValue,
            runId: progressRunId,
            seq: progressSeq,
            note: 'Process Advisor is retrieving Jira work items, building the event log, and recalculating the process model.',
        });
    };

    // Initialise group mapping before building event log
    initGroupMapping(model);

    // 1. Build JQL and field strings from the saved model config
    step('Preparing Jira query', 5, 'Building JQL and selected field parameters', 'Status', 'Preparing', 'Platform', 'Jira');
    await wait();
    const fieldList = await loadJiraFields(fields || []);
    const { projectStr, issueTypeStr, fieldsStr, propertiesStr, allProjects, jql } =
        await buildQueryParameters(modelID, model, SW_Model, title, fieldList, stagilFieldsDC);
    rebuildAttributePrivacyByLabel();

    const jqlStr = buildJQLQuery(
        projectStr, issueTypeStr, allProjects,
        model.from_date, model.to_date, jql
    );

    // 2. Get total issue count
    step('Counting Jira work items', 12, 'Counting records matching the saved model scope', 'Work items', 'Counting', 'Query', 'JQL');
    await wait();
    const totalIssues = await getTotalIssueCount(AppVersion, contextPath, jqlStr);

    // 3. Fetch all issues from Jira
    step('Fetching Jira work items', 18, `Preparing to retrieve ${formatProgressCount(totalIssues)} work items`, 'Retrieved', `0 / ${formatProgressCount(totalIssues)}`, 'Events', '0');
    await wait();
    const { eventLog, comments, worklog, stagilIssuesForge } =
        await fetchAndProcessIssues(
            AppVersion, contextPath, jqlStr, fieldsStr, propertiesStr,
            totalIssues, license, stagilFieldsDC, model.anonymize, editionAccess,
            ({ processed = 0, total = totalIssues, events = 0 } = {}) => {
                const totalSafe = Math.max(1, Number(total || 0));
                const pct = 18 + Math.min(42, Math.round((Number(processed || 0) / totalSafe) * 42));
                step('Fetching Jira work items', pct, `Retrieved and processed ${formatProgressCount(processed)} of ${formatProgressCount(total)} work items`, 'Work items', `${formatProgressCount(processed)} / ${formatProgressCount(total)}`, 'Events', formatProgressCount(events));
            }
        );

    // 4. Build the in-memory event log arrays
    step('Building event log', 65, `Preparing ${formatProgressCount(eventLog.length)} events for process mining`, 'Events', formatProgressCount(eventLog.length), 'Work items', formatProgressCount(totalIssues));
    await wait();
    gIssueComments = comments;
    gIssueWorklogs = worklog;
    await buildEventLog(eventLog, model);

    // 5. Process the event log (transform → arrays → finalise)
    gProcessModelTitle = title;
    gMetricArray = [];
    gEventLogName = '';
    gDataLoadType = 'DB';

    step('Calculating process metrics', 78, 'Generating variants, activities, steps, transitions, and model metrics', 'Events', formatProgressCount(eventLog.length), 'Work items', formatProgressCount(totalIssues));
    await wait();
    await processEventLog();

    // 6. Save the refreshed event log back to storage
    await saveEventLog('internal', AppVersion);

    // 7. Resolve stagil fields if applicable
    if (stagilIssuesForge.length > 0 || (stagilFieldsDC && stagilFieldsDC.length > 0)) {
        await updatestagilFields(stagilFieldsDC, stagilIssuesForge, AppVersion, contextPath);
    }

    // 8. Load AI model data if applicable
    if (gModelID && app === 'PO') {
        step('Loading saved AI evidence', 88, 'Restoring saved Advisor, Evidence, and Discovery Rule content', 'Status', 'Loading', 'Model', 'AI data');
        await wait();
        await loadJiraModel(model);
    }

    // 9. Finalise
    step('Finalising model', 96, 'Applying filters and opening the refreshed model', 'Status', 'Finalising', 'Platform', 'Jira');
    return await finalizeModelData(app, model);
}


/**
 * Inject a platform-neutral canonical dataset for the Web/SaaS shell.
 * Jira and ServiceNow obtain their data through their platform adapters; the Web
 * shell already owns a canonical dataset after CSV/REST ingestion, so it hands
 * that dataset directly to the shared Process Advisor runtime.
 */
export function setWEBData(canonicalDataset, model = {}) {
    gWebCanonicalDataset = canonicalDataset || null;
    gWebModel = model || {};
}

export function clearWEBData() {
    gWebCanonicalDataset = null;
    gWebModel = null;
}

async function handleDataLoadWEB(model = {}, title = '') {
    if (!gWebCanonicalDataset || !Array.isArray(gWebCanonicalDataset.events) || !Array.isArray(gWebCanonicalDataset.cases)) {
        throw new Error('No canonical dataset has been supplied to Process Advisor Web.');
    }

    const dataset = gWebCanonicalDataset;
    const webProgress = (phase, percent, detail, primaryLabel, primaryValue, secondaryLabel, secondaryValue, note) => {
        gLoadingStatus = '__PA_PROGRESS__' + JSON.stringify({
            mode: 'extraction',
            phase,
            percent,
            detail,
            primaryLabel,
            primaryValue,
            secondaryLabel,
            secondaryValue,
            note,
        });
        updateLoadingStatus({ eventEmitter: gEventEmitter });
    };

    webProgress(
        'Building canonical metrics',
        18,
        `${Number(dataset.cases.length || 0).toLocaleString()} cases · ${Number(dataset.events.length || 0).toLocaleString()} events`,
        'Cases',
        Number(dataset.cases.length || 0).toLocaleString(),
        'Events',
        Number(dataset.events.length || 0).toLocaleString(),
        'Process Advisor is preparing the canonical model for analysis.'
    );
    await wait();

    const webModel = {
        ...(dataset.model || {}),
        ...(gWebModel || {}),
        ...(model || {}),
        name: title || model?.name || dataset.model?.name || 'Web Assessment',
    };

    gCanonicalDataset = dataset;
    gCanonicalProcessMetrics = deriveCanonicalProcessMetrics(dataset);
    gCanonicalEvidenceMetrics = deriveCanonicalEvidenceMetrics(dataset);
    gCanonicalFilteredDataset = null;
    gCanonicalFilteredEvidenceMetrics = null;

    webProgress(
        'Building process analytics',
        42,
        'Preparing activities, variants and process paths',
        'Cases',
        Number(dataset.cases.length || 0).toLocaleString(),
        'Events',
        Number(dataset.events.length || 0).toLocaleString(),
        'The canonical dataset is ready. Process analytics are now being assembled.'
    );
    await wait();

    // The existing visualiser still consumes the mature legacy in-memory rows.
    // Keep this bridge at the runtime boundary while Evidence/analytics continue
    // migrating natively to canonical cases/events.
    gImportEventLogArray = canonicalToLegacyEventLog(dataset);

    const caseDefs = Array.isArray(dataset?.attributeDefinitions?.case) ? dataset.attributeDefinitions.case : [];
    const eventDefs = Array.isArray(dataset?.attributeDefinitions?.event) ? dataset.attributeDefinitions.event : [];
    gTaskAttributes = caseDefs.map((def, i) => ({
        id: def?.id || def?.key || `ta${i}`,
        field: def?.name || def?.label || def?.sourceField || def?.id || `Attribute ${i + 1}`,
        label: def?.name || def?.label || def?.sourceField || def?.id || `Attribute ${i + 1}`,
        attributeID: def?.sourceField || def?.name || def?.id || `ta${i}`,
        schema: def?.dataType || 'string',
    }));
    gEventAttributes = [{ id: 'ea0', field: 'Resource' }, ...eventDefs.map((def, i) => ({
        id: def?.id || def?.key || `ea${i + 1}`,
        field: def?.name || def?.label || def?.sourceField || def?.id || `Event Attribute ${i + 1}`,
        attributeID: def?.sourceField || def?.name || def?.id || `ea${i + 1}`,
        schema: def?.dataType || 'string',
    }))];

    const activityType = dataset?.events?.find(e => e?.activityType)?.activityType || webModel?.activity_type || 'status';
    gActivityTypes = [{ id: 0, activity_type: activityType, name: activityType, events: dataset.events.length }];
    gIssueTypes = [webModel?.processType || webModel?.process_type || 'Imported Process'];
    gProcessModelTitle = webModel.name;
    gMetricArray = [];
    gEventLogName = '';
    gDataLoadType = 'WEB';
    gSample = 'N';

    debugCanonicalDataset(dataset, { stage: 'web-runtime-load', source: dataset?.source || {} });

    webProgress(
        'Building process model',
        58,
        'Calculating variants, transitions, rework and performance measures',
        'Cases',
        Number(dataset.cases.length || 0).toLocaleString(),
        'Events',
        Number(dataset.events.length || 0).toLocaleString(),
        'Large event logs can take a little time while the process model is calculated.'
    );
    await wait();
    await processEventLog();

    webProgress(
        'Completing model preparation',
        92,
        'Finalising the Process Advisor workspace',
        'Cases',
        Number(dataset.cases.length || 0).toLocaleString(),
        'Events',
        Number(dataset.events.length || 0).toLocaleString(),
        'Process analytics are complete. Opening the workspace.'
    );
    await wait();
    return await finalizeModelData('WEB', webModel);
}

export async function loadAppData(
    AppVersion,
    modelID,
    SW_Model,
    title,
    contextPath,
    refreshData,
    license,
    customerID,
    app,
    appTitle,
    stagilFieldsDC,
    fields,
    editionAccess = {}
) {

    try {
        // Initialize global variables
        gModelFileName = title
        await initializeGlobalVariables(AppVersion, modelID, customerID, contextPath, appTitle);

        if (String(AppVersion || '').toUpperCase() === 'WEB') {
            const webModel = { ...(gWebCanonicalDataset?.model || {}), ...(gWebModel || {}), ...(SW_Model || {}) };
            return await handleDataLoadWEB(webModel, title);
        }
        
        // Load or create analysis model
        // need to set sample
        const loadedModel = await loadProcessModel(AppVersion, modelID, [], SW_Model, title);
        const model = mergeAssessmentCreditFields(loadedModel, SW_Model);
        const selectedModelUnlocked = isModelAssessmentCreditAuthorized(SW_Model);
        const seedEditionAccess = selectedModelUnlocked
            ? buildAssessmentUnlockedEditionAccess(editionAccess, buildAssessmentMarkerFromModel({ ...(SW_Model || {}), id: modelID || SW_Model?.id, name: title || SW_Model?.name }))
            : editionAccess;
        const effectiveEditionAccess = await resolveDatasetAssessmentCreditAccess({
            AppVersion,
            editionAccess: seedEditionAccess,
            model,
            modelID,
            title,
            customerID,
        });
        if (AppVersion === 'SNOW') {
            const savedFlag = snValHelper(model?.event_log_saved ?? model?.EVENT_LOG_SAVED);
            const hasSavedEventLog = savedFlag === true || String(savedFlag || '').toLowerCase() === 'true' || String(savedFlag || '').toUpperCase() === 'Y';
            if (!hasSavedEventLog && refreshData !== true) {
                console.warn('[SNOW] No saved event log found; forcing fresh extraction instead of reopening stored chunks.');
                refreshData = true;
            }
        }
        if (refreshData === true) {
            return await handleDataRefresh(
                AppVersion,
                contextPath,
                model,
                modelID,
                SW_Model,
                title,
                license,
                stagilFieldsDC,
                app,
                fields,
                effectiveEditionAccess);
        } else {
            return await handleDataLoad(AppVersion, model, modelID, title, app, fields, effectiveEditionAccess);
        }

    } catch (error) {
        console.error('Error in loadAppData:', error);
        gLoadingStatus = 'Error loading data: ' + error.message;
        updateLoadingStatus({ eventEmitter: gEventEmitter });
        throw error;
    }

    
}

// Helper function to initialize global variables
async function initializeGlobalVariables(AppVersion, modelID, customerID, contextPath, appTitle) {
  
    gModelMetrics = [];
    gModelMetricsTotal = [];
    gInsights = '';
    gProcessingModelMetrics = false;
    gAppVersion = AppVersion;
    gUploadFileArray = [];
    gCustomerID = customerID;
    gModelID = modelID;
    gLoadingStatus = 'Initializing ' + appTitle;
    gActivityTypes = [];
    gIssueTypes = [];
    gWorkflowConfiguration = [];
    gWorkflowTransitions = [];
    gWorkflowVariants = [];
    gContextPath = contextPath;
    gCalendar = 'None';
    gCalendarExists = false;
    gCalendarDurationCache = null;
    
    updateLoadingStatus({ eventEmitter: gEventEmitter });
    await wait();
}


function snValHelper(v) {
    return (v && typeof v === 'object') ? (v.value ?? v.display_value ?? '') : (v ?? '');
}

function parseModelMultiValue(value) {
if (Array.isArray(value)) return value.map(v => snValHelper(v)).filter(Boolean);  // ← add this line
    const raw = snValHelper(value);
    if (Array.isArray(raw)) return raw.map(v => snValHelper(v)).filter(Boolean);
    if (typeof raw !== 'string') return [];
    const trimmed = raw.trim();
    if (!trimmed) return [];
    if (trimmed.startsWith('[') && trimmed.endsWith(']')) {
        try {
            const parsed = JSON.parse(trimmed);
            if (Array.isArray(parsed)) return parsed.map(v => snValHelper(v)).filter(Boolean);
        } catch (_) {}
    }
    if (trimmed.includes('^^')) return trimmed.split('^^').map(v => v.trim()).filter(Boolean);
    if (trimmed.includes(',')) return trimmed.split(',').map(v => v.trim()).filter(Boolean);
    return [trimmed];
}


function dispatchSNOWProcessingError(message, details = {}) {
    const payload = {
        message,
        details,
        actionLabel: 'Return to Process Models',
        canRecover: true,
    };
    try {
        window.__PROCESS_ADVISOR_SNOW_PROCESSING_ERROR__ = payload;
        window.dispatchEvent(new CustomEvent('process-advisor-snow-processing-error', { detail: payload }));
    } catch (_) {}
}

function throwSNOWProcessingConfigError(message, details = {}) {
    dispatchSNOWProcessingError(message, details);
    const error = new Error(message);
    error.code = 'SNOW_PROCESS_MODEL_ACTIVITY_TYPE_CONFIG';
    error.details = details;
    throw error;
}

// Helper function to load analysis model
async function loadProcessModel(AppVersion, modelID, activityTypes, SW_Model, title, sample) {
    if (!modelID) {
        return null;
    }
    
    try {
        let model;
        if (AppVersion === 'FORGE') {
            model = await getProcessModelForge(loadForgeModule, modelID);
        } else if (AppVersion === 'SNOW') {
            const snApi = await getSnApi();
            const result = await snApi.getProcessModel(modelID);
            model = Array.isArray(result) ? result[0] : result;
            if (model) {
                model.activity_types  = snValHelper(model.activity_types);
                model.attributes      = snValHelper(model.attributes);
                model.issue_types     = snValHelper(model.table) || snValHelper(model.issue_types) || 'incident';
                model.sample          = snValHelper(model.sample);
                model.category        = snValHelper(model.category);
            }
        }
        
        if (!model) {
            throw new Error('Model not found');
        }

        gSample = isSampleProcessModel(model) ? 'Y' : (model.sample || 'N');

        loadAttributePrivacyFromModel(model);
        loadSNVisualizerAttributesFromModel(model);

        gAiExecutiveAssessment       = model.ai_process_health_assessment       || null;
        gAiImprovementOpportunities  = model.ai_intelligence  || null;
        gAiOpportunities           = model.ai_consulting_report           || null;
        gAiBlueprint       = model.ai_blueprint       || null;
        gAiOpportunities          = model.ai_consulting_report          || null;
        gAiImplementationRoadmap     = model.ai_execution_strategy     || null;
        gAiFrameworkAssessment       = model.ai_framework_assessment    || null;
        gConsultingWorkspace        = normaliseConsultingWorkspace(model.consulting_workspace);

         // Process model data
        gModelFromDate = model.from_date + ' 00:00';
        gModelToDate = model.to_date + ' 23:59';
        gIssueTypes = parseModelMultiValue(model.issue_types);
        model.activity_types = parseModelMultiValue(model.activity_types);
        
        // Process activity types
        let sample = isSampleProcessModel(model);
        await processActivityTypes(model,sample);
        
        // Load calendar if exists
        if (model.calendar && model.calendar !== 'None' && model.calendar !== '') {
            await loadCalendar(AppVersion, model.calendar);
        }
        
        return model;
    } catch (error) {
        console.error('Error loading analysis model:', error);
        throw new Error('Failed to load analysis model: ' + error.message);
    }
}

// Helper function to process activity types


async function loadCalendar(AppVersion, calendarId) {
    gCalendar = 'None';
    gCalendarExists = false;
    gCalendarDurationCache = null;

    if (!calendarId || calendarId === 'None') return;

    try {
        if (AppVersion === 'SNOW') {
            const snApi = await getSnApi();
            if (!snApi?.getBusinessCalendar) return;
            const calendar = await snApi.getBusinessCalendar(calendarId);
            const hasTimes = Array.isArray(calendar?.times) && calendar.times.some(day =>
                day && day.isDisabled === false && Array.isArray(day.times) && day.times.length > 0
            );
            if (hasTimes) {
                gCalendar = calendar;
                gCalendarExists = true;
                gCalendarDurationCache = createBusinessCalendarCache(calendar);
            } else {
                console.warn('[Process Advisor] ServiceNow schedule has no parsable business-hour spans. Falling back to 24x7 elapsed time.', calendarId);
            }
            return;
        }

        if (AppVersion === 'FORGE') {
            const { invoke } = await loadForgeModule();
            const cals = await invoke('getCalendars').catch(() => []);
            const calendar = (cals || []).find(c => String(c.id) === String(calendarId) || String(c.sys_id) === String(calendarId));
            if (calendar) {
                if (typeof calendar.times === 'string') {
                    try { calendar.times = JSON.parse(calendar.times); } catch (_) {}
                }
                const hasTimes = Array.isArray(calendar.times) && calendar.times.some(day => day?.isDisabled === false && day?.times?.length > 0);
                if (hasTimes) {
                    gCalendar = calendar;
                    gCalendarExists = true;
                    gCalendarDurationCache = createBusinessCalendarCache(calendar);
                }
            }
        }
    } catch (err) {
        console.warn('loadCalendar failed; using 24x7 elapsed durations:', err?.message || err);
        gCalendar = 'None';
        gCalendarExists = false;
        gCalendarDurationCache = null;
    }
}

function parseBusinessTimeToSeconds(value, fallback = 0) {
    const raw = String(value || '').trim();
    const m = raw.match(/^(\d{1,2}):(\d{2})/);
    if (!m) return fallback;
    const h = Math.max(0, Math.min(23, parseInt(m[1], 10) || 0));
    const min = Math.max(0, Math.min(59, parseInt(m[2], 10) || 0));
    return h * 3600 + min * 60;
}

function createBusinessCalendarCache(calendar) {
    const byDow = Array.from({ length: 7 }, () => []);
    (calendar?.times || []).forEach(day => {
        if (!day || day.isDisabled === true) return;
        const dow = Number(day.id);
        if (dow < 0 || dow > 6) return;
        (day.times || []).forEach(slot => {
            const start = parseBusinessTimeToSeconds(slot.start, 0);
            let end = parseBusinessTimeToSeconds(slot.end, 86400);
            if (String(slot.end || '').startsWith('24:')) end = 86400;
            if (end > start) byDow[dow].push({ start, end });
        });
        byDow[dow].sort((a, b) => a.start - b.start);
    });
    return { byDow, dayCache: new Map(), prefixCache: new Map() };
}

function dateKeyUTC(date) {
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

function startOfLocalDay(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

function addLocalDays(date, days) {
    const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    d.setDate(d.getDate() + days);
    return d;
}

function paDowFromLocalDate(date) {
    const js = date.getDay();
    return js === 0 ? 6 : js - 1;
}

function businessSecondsForDay(dayStart) {
    if (!gCalendarDurationCache) return 0;
    const key = dateKeyUTC(dayStart);
    if (gCalendarDurationCache.dayCache.has(key)) return gCalendarDurationCache.dayCache.get(key).total;
    const slots = gCalendarDurationCache.byDow[paDowFromLocalDate(dayStart)] || [];
    const total = slots.reduce((sum, s) => sum + Math.max(0, s.end - s.start), 0);
    const info = { total, slots };
    gCalendarDurationCache.dayCache.set(key, info);
    return total;
}

function partialBusinessSeconds(dayStart, fromDate, toDate) {
    if (!gCalendarDurationCache || toDate <= fromDate) return 0;
    const slots = gCalendarDurationCache.byDow[paDowFromLocalDate(dayStart)] || [];
    if (!slots.length) return 0;
    const dayMs = dayStart.getTime();
    const fromSec = Math.max(0, Math.min(86400, (fromDate.getTime() - dayMs) / 1000));
    const toSec = Math.max(0, Math.min(86400, (toDate.getTime() - dayMs) / 1000));
    let total = 0;
    slots.forEach(slot => {
        const s = Math.max(slot.start, fromSec);
        const e = Math.min(slot.end, toSec);
        if (e > s) total += (e - s);
    });
    return total;
}

function fullBusinessSecondsBetween(startDayExclusive, endDayExclusive) {
    if (!gCalendarDurationCache || endDayExclusive <= startDayExclusive) return 0;
    let total = 0;
    for (let d = new Date(startDayExclusive); d < endDayExclusive; d.setDate(d.getDate() + 1)) {
        total += businessSecondsForDay(d);
    }
    return total;
}

function calculateBusinessDuration(fromTime, toTime) {
    const fromDate = new Date(String(fromTime || '').replace(' ', 'T'));
    const toDate = new Date(String(toTime || '').replace(' ', 'T'));
    if (!Number.isFinite(fromDate.getTime()) || !Number.isFinite(toDate.getTime()) || toDate <= fromDate) return 0;
    if (!gCalendarDurationCache) return (toDate - fromDate) / 1000;

    const fromDay = startOfLocalDay(fromDate);
    const toDay = startOfLocalDay(toDate);
    if (fromDay.getTime() === toDay.getTime()) {
        return partialBusinessSeconds(fromDay, fromDate, toDate);
    }

    const nextDay = addLocalDays(fromDay, 1);
    let total = partialBusinessSeconds(fromDay, fromDate, nextDay);
    total += fullBusinessSecondsBetween(nextDay, toDay);
    total += partialBusinessSeconds(toDay, toDay, toDate);
    return Math.max(0, total);
}

async function processActivityTypes(model,sample) {
    let activityTypeID = 0;
    if (gAppVersion === 'FORGE') {
        try {
            const { invoke } = await loadForgeModule();
            const allActivityTypes = await invoke('getActivityTypes');
            for (const actTypeId of model.activity_types) {
                const actType = allActivityTypes.find(at => at.id === actTypeId);
                if (actType) {
                    gActivityTypes.push({
                        id: actType.id,
                        activity_type: actType.field,
                        name: actType.name,
                        field: actType.field,
                        events: 0
                    });
                } else {
                    console.warn(`Activity type ID ${actTypeId} not found in backend`);
                }
            }
        } catch (error) {
            console.error('Error loading activity types from backend:', error);
        }
        model.projects = parseModelMultiValue(model.projects);
        model.attributes = parseModelMultiValue(model.attributes);
        return;
    }

    if (gAppVersion === 'SNOW') {
        const wantedIds = parseModelMultiValue(model.activity_types).map(String).filter(Boolean);

        if (!wantedIds.length) {
            throwSNOWProcessingConfigError(
                'This Process Model has no Activity Type selected. Return to Process Models, edit the model, select an Activity Type, check the record count, then save again.',
                { modelId: model.id || model.sys_id || '', modelName: model.name || '', activity_types: model.activity_types }
            );
        }

        try {
            const snApi = await getSnApi();
            const allActivityTypes = await snApi.getActivityTypes();
            const activityTypesById = new Map();

            const addActivityTypeKey = (key, actType) => {
                const value = String(snValHelper(key) || '').trim();
                if (value && !activityTypesById.has(value)) activityTypesById.set(value, actType);
            };

            (allActivityTypes || []).forEach(actType => {
                // Wizard-created and modal-created models have not always stored the
                // same identifier. Support the app id, ServiceNow sys_id, field name,
                // and activity_type so old models do not fail with the useless
                // "no activity" error.
                addActivityTypeKey(actType.id, actType);
                addActivityTypeKey(actType.sys_id, actType);
                addActivityTypeKey(actType.field, actType);
                addActivityTypeKey(actType.activity_type, actType);
                addActivityTypeKey(actType.name, actType);
            });

            const missingIds = [];
            const invalidRows = [];

            wantedIds.forEach(activityTypeId => {
                const actType = activityTypesById.get(activityTypeId);
                if (!actType) {
                    missingIds.push(activityTypeId);
                    return;
                }

                const id = String(snValHelper(actType.id) || '').trim();
                const sysId = String(snValHelper(actType.sys_id) || '').trim();
                const field = String(snValHelper(actType.field) || '').trim();
                const table = String(snValHelper(actType.table) || snValHelper(actType.source_table) || snValHelper(model.table) || '').trim();

                if (!id || !field || !table) {
                    invalidRows.push({ id, sys_id: sysId, field, table, name: snValHelper(actType.name) });
                    return;
                }

                gActivityTypes.push({
                    id,
                    sys_id: sysId,
                    activity_type: field,
                    name: snValHelper(actType.name) || field,
                    field,
                    table,
                    source_table: table,
                    type: snValHelper(actType.type) || 'audit_workflow',
                    events: 0
                });
            });

            if (missingIds.length || invalidRows.length || gActivityTypes.length === 0) {
                throwSNOWProcessingConfigError(
                    'This Process Model cannot be processed because its Activity Type configuration is invalid. Return to Process Models, edit the model, select a valid Activity Type, check the record count, then save again.',
                    {
                        modelId: model.id || model.sys_id || '',
                        modelName: model.name || '',
                        modelActivityTypeIds: wantedIds,
                        missingActivityTypeIds: missingIds,
                        invalidActivityTypes: invalidRows,
                        availableActivityTypeIds: (allActivityTypes || []).flatMap(a => [snValHelper(a.id), snValHelper(a.sys_id), snValHelper(a.field), snValHelper(a.activity_type), snValHelper(a.name)]).filter(Boolean),
                    }
                );
            }
        } catch (error) {
            if (error?.code === 'SNOW_PROCESS_MODEL_ACTIVITY_TYPE_CONFIG') throw error;
            throwSNOWProcessingConfigError(
                `Process Advisor could not load Activity Types for this Process Model: ${error?.message || error}. Return to Process Models and try again after checking the Activity Types table.`,
                { modelId: model.id || model.sys_id || '', modelName: model.name || '', cause: error?.message || String(error) }
            );
        }

        model.attributes = parseModelMultiValue(model.attributes);
    }
}


async function handleDataRefreshSNOW(model, modelID, app, editionAccess = {}) {
    const snApi             = await getSnApi();
    const extractSNEventLog = await getExtractSNEventLog();

    const attrList = parseModelMultiValue(model.attributes);

    // Resolve task attribute sys_ids to element names before extraction.
    gTaskAttributes = [];
    const looksLikeSysId = (v) => /^[0-9a-f]{32}$/i.test(String(v || ''));
    const areSysIds = attrList.some(looksLikeSysId);
    let resolvedAttrs = attrList.map(f => ({ element: f, label: f }));
    if (areSysIds && attrList.length > 0) {
        try {
            const resolved = await snApi.getFieldsBySysIds(attrList);
            resolvedAttrs = attrList.map(sysId => {
                const match = (resolved || []).find(r => String(r.sys_id) === String(sysId));
                return { element: match?.value || sysId, label: match?.label || match?.value || sysId };
            });
        } catch (err) {
            console.warn(' Could not resolve task attribute sys_ids:', err?.message || err);
        }
    }

    resolvedAttrs.forEach((a, i) => {
        gTaskAttributes.push({
            id: 'ta' + i,
            field: a.label || a.element,
            label: a.label || a.element,
            attributeID: a.element
        });
    });
    rebuildAttributePrivacyByLabel();

    const taskAttrs = resolvedAttrs.map(a => ({
        id: a.element,
        value: a.element,
        label: a.label || a.element,
        field: a.element
    }));

    const activityTypeIds = new Set(parseModelMultiValue(model.activity_types).map(String));
    // Join Process Model -> Activity Types by app-level Activity Type id only.
    let modelActivityTypes = gActivityTypes.filter(a =>
        activityTypeIds.has(String(a.id || ''))
    );

    if (modelActivityTypes.length === 0) {
        throwSNOWProcessingConfigError(
            'This Process Model cannot be processed because none of its Activity Type IDs match saved Activity Type records. Return to Process Models, edit the model, select a valid Activity Type, check the record count, then save again.',
            {
                modelId: modelID,
                modelName: model?.name || model?.NAME || '',
                modelActivityTypes: [...activityTypeIds],
                resolvedActivityTypes: (gActivityTypes || []).map(a => ({ id: a.id, field: a.field, table: a.table, sys_id: a.sys_id })),
            }
        );
    }

    const extractionResult = await extractSNEventLog(
        modelID,
        model,
        modelActivityTypes,
        taskAttrs,
        (msg) => {
            gLoadingStatus = msg;
            updateLoadingStatus({ eventEmitter: gEventEmitter });
        },
        normalizeEditionAccess(editionAccess)
    );

    const { totalTasks, totalEvents, eventLog, taskAttributes: extractedTaskAttributes } = extractionResult || {};
    // The ServiceNow adapter now emits canonical data directly at the extraction
    // boundary. buildEventLog() below rebuilds it after Activity Group Mapping so
    // the canonical activities exactly match what the shared miner visualises.
    gCanonicalDataset = extractionResult?.canonicalDataset || null;
    gCanonicalProcessMetrics = gCanonicalDataset ? deriveCanonicalProcessMetrics(gCanonicalDataset) : null;
    gCanonicalEvidenceMetrics = gCanonicalDataset ? deriveCanonicalEvidenceMetrics(gCanonicalDataset) : null;

    // Jira parity: the SN extraction now returns comment/work-note and
    // time-worked arrays in the same shape the Forge app produces. They must
    // be set before processEventLog() so event-boundary association works.
    gIssueComments = Array.isArray(extractionResult?.issueComments) ? extractionResult.issueComments : [];
    gIssueWorklogs = Array.isArray(extractionResult?.issueWorklogs) ? extractionResult.issueWorklogs : [];

    if (Array.isArray(extractedTaskAttributes) && extractedTaskAttributes.length > 0) {
        gTaskAttributes = extractedTaskAttributes.map((attr, i) => {
            const id = snValHelper(attr?.id) || `ta${i}`;
            const field = snValHelper(attr?.field) || snValHelper(attr?.value) || snValHelper(attr?.label) || id;
            const label = snValHelper(attr?.label) || field;
            return {
                id,
                field: label,
                label,
                attributeID: field,
                schema: snValHelper(attr?.schema) || 'string',
            };
        });
        rebuildAttributePrivacyByLabel();
    }

    // Critical: on refresh, do NOT call loadEventLogFromModel(). That would reload the just-saved
    // storage chunks and can mask extraction failures. Process the freshly extracted events in memory.
    gLoadingStatus = `Processing ${totalEvents} events from ${totalTasks} tasks...`;
    updateLoadingStatus({ eventEmitter: gEventEmitter });
    await wait();

    await buildEventLog(eventLog || [], model);

    // ServiceNow saves its legacy event-log chunks inside the extraction adapter.
    // Persist the canonical dataset here, after buildEventLog has applied Activity
    // Group Mapping and preserved native task_id/sys_id identity, so the saved
    // canonical model is exactly the one consumed by the shared engine.
    try {
        if (gCanonicalDataset && modelID) {
            const snApi = await getSnApi();
            const persisted = await saveCanonicalDatasetToDatabase({
                modelId: modelID,
                dataset: gCanonicalDataset,
                appVersion: 'SNOW',
                snApi,
                metadata: { saveType: 'extraction-refresh' },
            });
            if (persisted?.saved && persisted.dataset) {
                gCanonicalDataset = persisted.dataset;
                gCanonicalProcessMetrics = deriveCanonicalProcessMetrics(gCanonicalDataset);
                gCanonicalEvidenceMetrics = deriveCanonicalEvidenceMetrics(gCanonicalDataset);
            }
        }
    } catch (canonicalSaveError) {
        console.warn('[PA Canonical Persistence] ServiceNow refresh save failed; legacy model remains available', canonicalSaveError?.message || canonicalSaveError);
    }

    await processEventLog();

    if (modelID && app === 'PO') {
        gLoadingStatus = 'Loading model settings...';
        updateLoadingStatus({ eventEmitter: gEventEmitter });
        await wait();
        await loadJiraModel(model);
    }

    return await finalizeModelData(app, model);
}

async function updatestagilFields(stagilFieldsDC, stagilIssuesForge, AppVersion, contextPath) {
    
    if (false) {
        for (let i = 0; i < gTaskAttributes.length; i++) {
            for (let j = 0; j < stagilFieldsDC.length; j++) {
                if (stagilFieldsDC[j].value === gTaskAttributes[i].attributeID) {
                    let key = gTaskAttributes[i].id
                    const uniqueValues  = new Set();
                    gTaskArray.forEach(item => {
                        const value = item[key];
                        if (value !== null && value !== undefined && value !== "N/A") uniqueValues.add(value);
                    });
                    let issueIds = new Set(
                        Array.from(uniqueValues)
                            .flatMap(item => item.split(','))
                            .map(item => item.trim()))

                    let issueSummaries = await getIssueSummaries(Array.from(issueIds),AppVersion, contextPath)
                    issueSummaries = issueSummaries[0]

                    for (let k = 0; k < issueSummaries.length; k++) {
                        let task = issueSummaries[k].key
                        let summary = issueSummaries[k].fields.summary
                        for (let t = 0; t < gTaskArray.length; t++) {
                            gTaskArray[t][key] = gTaskArray[t][key].replace(', ','^^')    
                            gTaskArray[t][key] = gTaskArray[t][key].replace(task,summary)       
                        }
                    }
                }
            }
        }
    }
    if (AppVersion === 'FORGE') {
        const uniqueIssues = [...new Set(
        stagilIssuesForge.flatMap(item => 
            Object.values(item.properties || {})
                .flatMap(field => Object.values(field))
                .flat()
        )
        )].sort();

        let issueSummaries = await getIssueDetails(uniqueIssues)

        const result = stagilIssuesForge.flatMap(item => {
            const key = item.key;
            const rows = [];
    
            for (const prop in item.properties) {
                for (const fieldId in item.properties[prop]) {
                    const values = item.properties[prop][fieldId];
                    values.forEach(value => {
                        rows.push([key, fieldId, value]);
                    });
                }
            }
            return rows;
        });

        const keyToSummary = {};
        issueSummaries.forEach(issue => {
            keyToSummary[issue.key] = issue.summary;
        });

        // Replace the 3rd item in each row
        result.forEach(row => {
            const key = row[2];
            if (keyToSummary[key]) {
                row[2] = keyToSummary[key];
            }
        });
        const output = result.map(item => ({
            Key: item[0],
            AttributeID: item[1],
            Summary: item[2]
        }));
        const attributeIdToIdMap = new Map(
            gTaskAttributes.map(item => [item.attributeID, item.id])
        );

        // Add the id field to each object in the data array
        const issuesStagil = output.map(item => ({
            ...item,
            id: attributeIdToIdMap.get(item.AttributeID) || null
        }));
        gTaskArray = updateTaFields(gTaskArray,issuesStagil)

    }
}

function updateTaFields(taskArray, issuesStagil) {
    // Create a map to group issuesStagil items by Key
    const issueMap = {};
    
    issuesStagil.forEach(issue => {
        if (!issueMap[issue.Key]) {
            issueMap[issue.Key] = {};
        }
        
        // Handle multiple entries for the same ta field
        if (!issueMap[issue.Key][issue.id]) {
            issueMap[issue.Key][issue.id] = [];
        }
        issueMap[issue.Key][issue.id].push(issue.Summary);
    });
    
    // Update gTaskArray
    taskArray.forEach(task => {
        if (issueMap[task.k]) {
            // Update each ta field that has matching data
            Object.keys(issueMap[task.k]).forEach(taField => {
                const summaries = issueMap[task.k][taField];
                // If multiple summaries, join them with ^^; otherwise use the single value
                task[taField] = summaries.length > 1 ? summaries.join('^^') : summaries[0];
            });
        }
    });
    
    return taskArray;
}


async function getIssueSummaries(issueIds,AppVersion,contextPath) {
    const results = [];

        // Split into batches of MAX_RESULTS
        let MAX_RESULTS = 100
        for (let i = 0; i < issueIds.length; i += MAX_RESULTS) { 
            const batch = issueIds.slice(i, i + MAX_RESULTS);
            // Create JQL query for this batch
            const jql = `id IN (${batch.join(',')})`;
            try {

            if (false) {
                let request = await fetch(`${contextPath}/rest/api/2/search?jql=${jql}&fields=id,summary,key&maxResults=100&startAt=${i}`);  
                const response = await request.json();
                results.push(response.issues);
            }

            } catch (error) {
                console.error(`Error fetching batch starting at index ${i}:`, error.message);
                if (error.response) {
                    console.error('Response data:', error.response.data);
                }
            }
        }

    return results;
}


async function getIssueDetails(issueIds) {

  // Split into batches of 50
  const batchSize = 50;
  const batches = [];
  
  for (let i = 0; i < issueIds.length; i += batchSize) {
    batches.push(issueIds.slice(i, i + batchSize));
  }

  // Process each batch
  const allResults = [];
  const { requestJira } = await loadForgeModule();  
  for (let i = 0; i < batches.length; i++) {
    const batch = batches[i];
   
    try {
      // Construct JQL query for this batch
      const jql = `key IN (${batch.join(',')})`;
      
      // Handle pagination with token
      let nextPageToken = null;
      let pageNumber = 0;
      
      do {
        pageNumber++;
        
        // Build request body
        const requestBody = {
          jql: jql,
          fields: ['key', 'summary'],
          maxResults: 50
        };
        
        // Add pagination token if available
        if (nextPageToken) {
          requestBody.nextPageToken = nextPageToken;
        }
        
        // Make the API call
        const response = await requestJira(`/rest/api/3/search/jql`, { 
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(requestBody)
        });

        // Check response
        if (!response.ok) {
          const errorText = await response.text();
          console.error(`Error in batch ${i + 1}, page ${pageNumber}: ${response.status} - ${errorText}`);
          break;
        }

        const data = await response.json();
        
        // Extract key and summary from each issue
        const pageResults = data.issues.map(issue => ({
          key: issue.key,
          summary: issue.fields.summary
        }));
        
        allResults.push(...pageResults);
       
        // Get next page token for pagination
        nextPageToken = data.nextPageToken || null;
        
      } while (nextPageToken);
      
      
    } catch (error) {
      console.error(`Error processing batch ${i + 1}:`, error);
    }
  }

  return allResults;
}


// Helper function to load Jira fields
async function loadJiraFields(fields) {
    const fieldList = [{ value: 'Sprint', label: 'Sprint', schema: 'custom' }];
    return fields.concat(fieldList);
}

// Helper function to build query parameters
async function buildQueryParameters(modelID, model, SW_Model, title, fieldList, stagilFieldsDC) {
    gTaskAttributes = [];
    let projectStr = '(';
    let issueTypeStr = '(';
    let fieldsStr = '';
    let propertiesStr = ''
    let allProjects = false;

    let jql = model.jql
    const config = modelID ? model : SW_Model;
    // Parse ^^-delimited strings to arrays if not already parsed (e.g. externalData=true path skips processActivityTypes)
    if (model && typeof model.attributes === 'string') {
        model.attributes = JSON.parse('["' + model.attributes.replaceAll('^^', '","') + '"]');
    }
    if (model && typeof model.projects === 'string') {
        model.projects = JSON.parse('["' + model.projects.replaceAll('^^', '","') + '"]');
    }
    const projects = modelID ? model.projects : SW_Model.projects;
    const issueTypes = modelID ? gIssueTypes : SW_Model.issueTypes;
    const attributes = modelID ? model.attributes : SW_Model.attributes;

    if (!modelID) {
        gProcessModelTitle = title;
        gModelFromDate = SW_Model.fromDate + ' 00:00';
        gModelToDate = SW_Model.toDate + ' 23:59';
        
        gActivityTypes.push({
            id: 0,
            activity_type: SW_Model.selectedField,
            name: SW_Model.selectedField,
            events: 0
        });
    } else {
        gProcessModelTitle = model.name;
    }
    
    // Build project string
    for (let i = 0; i < projects.length; i++) {
        if (i > 0) projectStr += ',';
        projectStr += `'${projects[i]}'`;
        if (projects[i] === '***') allProjects = true;
    }
    projectStr += ')';
    
    // Build issue type string
    for (let i = 0; i < issueTypes.length; i++) {
        if (i > 0) issueTypeStr += ',';
        issueTypeStr += `'${issueTypes[i]}'`;
    }
    issueTypeStr += ')';
    
    // Ensure priority and resolution are included
    if (!attributes.includes('priority')) attributes.push('priority');
    if (!attributes.includes('resolution')) attributes.push('resolution');
    
    // Build fields string and task attributes, only include if not a stagil != 'stagil_asset_forge'
    let fields = 0
    let properties = 0
    for (let i = 0; i < attributes.length; i++) {
        
        const fieldInfo = fieldList.find(f => f.value === attributes[i]);
        if (fieldInfo.schema !== 'stagil_asset_forge') {
            if (fields > 0) fieldsStr += ',';
            fieldsStr += attributes[i];
            fields ++
        } else {
            if (properties > 0) propertiesStr += ',';
            propertiesStr += 'sajc-field-' + Math.abs(parseInt(attributes[i]));
            properties ++
        }

        gTaskAttributes.push({
            id: 'ta' + i,
            field: fieldInfo?.label || attributes[i],
            attributeID: attributes[i],
            schema: fieldInfo?.schema || 'string'
        });
    }
    // Ensure project and issue type are in task attributes
    if (!gTaskAttributes.some(ta => ta.field === 'Project')) {
        fieldsStr += ',project';
        gTaskAttributes.push({
            id: 'ta' + gTaskAttributes.length,
            field: 'Project',
            attributeID: 'project',
            schema: 'project'
        });
    }
    
    /*
    if (!gTaskAttributes.some(ta => ta.field === 'Issue Type')) {
        fieldsStr += ',issuetype';
        gTaskAttributes.push({
            id: 'ta' + gTaskAttributes.length,
            field: 'Issue Type',
            attributeID: 'issuetype',
            schema: 'issuetype'
        });
    }
    */
    fieldsStr += ',created,creator,summary,comment,worklog,resolutiondate';
    
    return { projectStr, issueTypeStr, fieldsStr, propertiesStr, allProjects , jql};
}

// Helper function to build JQL query
function buildJQLQuery(projectStr, issueTypeStr, allProjects, fromDate, toDate, jql) {
    const dateStr = ` AND createdDate >= '${fromDate}' and createdDate <= '${toDate}'`;
    const resolvedStr = ` AND resolution != EMPTY`;
    let jqlStr = ''
    if (allProjects) {
        jqlStr = 'issueType in ' + issueTypeStr + dateStr + resolvedStr;
    } else {
        jqlStr = 'project in ' + projectStr + ' and issueType in ' + issueTypeStr + dateStr + resolvedStr;
    }

    if (jql !== '' && jql !== null) jqlStr = jqlStr + ' and ' + jql
    return jqlStr
    
}

// Helper function to get total issue count
async function getTotalIssueCount(AppVersion, contextPath, jql) {
    try {
        if (AppVersion === 'FORGE') {
            return await getTotalIssueCountForge(loadForgeModule, jql);
        }
        if (false) {
            return 0;
        }
        
        return 0;
    } catch (error) {
        console.error('Error getting total issue count:', error);
        throw new Error('Failed to get total issue count: ' + error.message);
    }
}

// Helper function to fetch and process issues
async function fetchAndProcessIssues(
    AppVersion,
    contextPath,
    jql,
    fieldsStr,
    propertiesStr,
    totalIssues,
    license,
    stagilFieldsDC,
    anonymize,
    editionAccess = {},
    onProgress = null
) {
    const eventLog = [];
    const comments = [];
    const worklog = [];
    const sprintExists = gTaskAttributes.some(ta => ta.field === 'Sprint');
    
    const editionLimit = getEditionWorkItemLimit(editionAccess);
    if (editionLimit) {
        console.log(`[Plan access] Retrieval limit active: ${editionLimit} work items/tasks`);
    }
    
    let nextPageToken = null;
    let startAt = 0;
    let processedCount = 0;
    let isFirstPage = true;
    let stagilProperties = false
    let stagilIssuesForge = []
    if (propertiesStr !== '') stagilProperties = true
    
    // Use nextPageToken for FORGE (API v3), startAt for API v2
    const useTokenPagination = AppVersion === 'FORGE';
    let i = 1
    while (isFirstPage || (useTokenPagination ? nextPageToken : startAt < totalIssues)) {
        if (editionLimit && processedCount >= editionLimit) {
            gLoadingStatus = `Plan limit reached: ${editionLimit} of ${totalIssues} work items retrieved`;
            updateLoadingStatus({ eventEmitter: gEventEmitter });
            break;
        }
        
        if (typeof onProgress === 'function') {
            onProgress({ processed: processedCount, total: totalIssues, events: eventLog.length, batch: i });
        } else {
            gLoadingStatus = `Processing event log: ${processedCount} of ${totalIssues} issues`;
            updateLoadingStatus({ eventEmitter: gEventEmitter });
        }
        await wait();
        try {
            const issueData = await fetchIssueBatch(
                AppVersion,
                contextPath,
                jql,
                fieldsStr,
                propertiesStr,
                startAt,
                nextPageToken
            );
            
            const issuesToProcess = editionLimit ? issueData.issues.slice(0, Math.max(0, editionLimit - processedCount)) : issueData.issues;
            for (let issueIndex = 0; issueIndex < issuesToProcess.length; issueIndex += 1) {
                const issue = issuesToProcess[issueIndex];
                await processIssue(
                    issue,
                    eventLog,
                    comments,
                    worklog,
                    sprintExists,
                    stagilFieldsDC,
                    anonymize,
                    AppVersion,
                    contextPath,
                    stagilProperties
                );
                if (typeof onProgress === 'function') {
                    const currentProcessed = processedCount + issueIndex + 1;
                    if (currentProcessed === totalIssues || currentProcessed % 25 === 0 || issueIndex === issuesToProcess.length - 1) {
                        onProgress({ processed: currentProcessed, total: totalIssues, events: eventLog.length, batch: i });
                    }
                }
                if (propertiesStr !== '') {
                    let vtp = {}
                    vtp['key'] = issue.key
                    vtp['properties'] = issue.properties
                    stagilIssuesForge.push(vtp)
                }
            }            processedCount += issuesToProcess.length;
            if (typeof onProgress === 'function') {
                onProgress({ processed: processedCount, total: totalIssues, events: eventLog.length, batch: i });
            }
            i += 1;

            if (useTokenPagination) {
                nextPageToken = issueData.nextPageToken || null;
            } else {
                startAt += 100;
            }
            
            isFirstPage = false;
            
        } catch (error) {
            console.error(`Error processing batch at count ${processedCount}:`, error);
            throw new Error(`Failed to process issue batch: ${error.message}`);
        }
    }
    

    return { eventLog, comments, worklog, stagilIssuesForge };
}

// Helper function to fetch a batch of issues
async function fetchIssueBatch(AppVersion, contextPath, jql, fieldsStr, propertiesStr, startAt, nextPageToken) {
    try {
        if (AppVersion === 'FORGE') {
            return await fetchIssueBatchForge(loadForgeModule, jql, fieldsStr, propertiesStr, nextPageToken);
        }
        throw new Error('Unsupported AppVersion for Jira issue batch fetch: ' + AppVersion);
    } catch (error) {
        console.error('Error fetching issue batch:', error);
        throw error;
    }
}

// Helper function to process a single issue
async function processIssue(
    issue,
    eventLog,
    comments,
    worklog,
    sprintExists,
    stagilFieldsDC,
    anonymize,
    AppVersion,
    contextPath,
    stagilProperties
) {
    // Process comments
    const commentsIndices = processComments(issue, comments);
    
    // Process worklog
    const worklogIndices = processWorklog(issue, worklog);
    
    // Process history
    const history = issue.changelog.histories;
    history.sort((a, b) => a.created.localeCompare(b.created));
    
    // Determine sprint
    let sprint = '';
    if (sprintExists) {
        sprint = extractSprintFromHistory(history);
    }
    
    // Process history events
    let initialActivity = '';
    let initialActivityType = '';

    for (const historyItem of history) {
        for (const item of historyItem.items) {
            // Match on item.field (display name e.g. "Assignment Group") OR
            // item.fieldId (API key e.g. "customfield_10237") — Jira Cloud changelog
            // uses display name in item.field but API key in item.fieldId.
            // gActivityTypes stores the API key (from activity_type.field in DB).
            const activityType = gActivityTypes.find(
                at => at.activity_type.trim() === item.field.trim() ||
                      (item.fieldId && at.activity_type.trim() === item.fieldId.trim())
            );
            
            if (activityType) {
                const eventData = createEventFromHistory(
                    issue,
                    historyItem,
                    item,
                    sprint,
                    commentsIndices,
                    worklogIndices,
                    anonymize,
                    stagilFieldsDC,
                    AppVersion,
                    contextPath,
                    stagilProperties  
                );
                // Add task attributes with Stagil support
                await addTaskAttributesToEvent(
                    eventData.event, 
                    issue, 
                    sprint, 
                    anonymize, 
                    AppVersion, 
                    contextPath
                );
                
                eventLog.push(eventData.event);
                
                if (!initialActivity) {
                    initialActivity = getInitialActivity(item, anonymize);
                    initialActivityType = item.field.trim();
                }
            }
        }
    }
    
    // Add initial event if exists
    if (initialActivity) {
        const initialEvent = await createInitialEvent(
            issue,
            initialActivity,
            initialActivityType,
            sprint,
            commentsIndices,
            worklogIndices,
            anonymize,
            stagilFieldsDC,
            AppVersion,
            contextPath
        );
        eventLog.push(initialEvent);
    }
}

// Helper function to process comments
function processComments(issue, comments) {
    if (!issue.fields.comment || !issue.fields.comment.comments.length) {
        return { si: null, fi: null };
    }
    
    const startIndex = comments.length;
    
    for (const comment of issue.fields.comment.comments) {
        comments.push({
            timestamp: comment.created.substr(0, 19).replace('T', ' '),
            author: comment.author.displayName,
            task: issue.key,
            jsdPublic: comment.jsdPublic === true ? 'true' : 'false',
            accountType: comment.author.accountType
        });
    }
    
    const endIndex = comments.length - 1;
    return { si: startIndex, fi: endIndex };
}

// Helper function to process worklog
function processWorklog(issue, worklog) {
    if (!issue.fields.worklog || !issue.fields.worklog.worklogs.length) {
        return { si: null, fi: null };
    }
    
    const startIndex = worklog.length;
    
    for (const log of issue.fields.worklog.worklogs) {
        worklog.push({
            timestamp: log.created.substr(0, 19).replace('T', ' '),
            author: log.author.displayName,
            task: issue.key,
            timeSpentSeconds: log.timeSpentSeconds
        });
    }
    
    const endIndex = worklog.length - 1;
    return { si: startIndex, fi: endIndex };
}

// Helper function to extract sprint from history
function extractSprintFromHistory(history) {
    for (const historyItem of history) {
        for (const item of historyItem.items) {
            if (item.field === 'Sprint') {
                return item.toString || '';
            }
        }
    }
    return '';
}

// Helper function to create event from history
function createEventFromHistory(
    issue,
    historyItem,
    item,
    sprint,
    commentsIndices,
    worklogIndices,
    anonymize,
) {
    const event = {
        task: issue.key,
        timestamp: historyItem.created.substr(0, 19),
        summary: issue.fields.summary,
        activity_type: item.field.trim(),
        activity: getActivityValue(item, anonymize),
        resource: getResourceValue(historyItem, anonymize),
        comments_si: commentsIndices.si,
        comments_fi: commentsIndices.fi,
        worklog_si: worklogIndices.si,
        worklog_fi: worklogIndices.fi
    };
    
    // Add task attributes (will be processed async in the caller)
    return { event, needsAsyncProcessing: true, issue, sprint, anonymize };
}

// Helper function to get activity value
function getActivityValue(item, anonymize) {
    let activity = item.toString?.trim() || '';
    
    if (item.field.trim() === 'assignee') {
        if (!item.toString) activity = 'Unassigned';
        if (anonymize === 'true' && activity !== 'Unassigned') {
            activity = anonymizeCheck(item.to?.trim());
        }
    }
    
    return activity;
}

// Helper function to get initial activity
function getInitialActivity(item, anonymize) {
    if (!item.fromString) return '';
    
    if (item.field.trim() === 'assignee') {
        if (item.fromString === null) return 'Unassigned';
        if (anonymize === 'true' && item.fromString !== 'Unassigned') {
            return anonymizeCheck(item.from?.trim());
        }
    }
    
    return item.fromString.trim();
}

// Helper function to get resource value
function getResourceValue(historyItem, anonymize) {
    if (!historyItem.author) return 'N/A';
    
    if (anonymize === 'true') {
        return anonymizeCheck(historyItem.author.accountId);
    }
    
    return historyItem.author.displayName;
}

// Helper function to add task attributes to event
async function addTaskAttributesToEvent(event, issue, sprint, anonymize) {
    for (let i = 0; i < gTaskAttributes.length; i++) {
        const key = gTaskAttributes[i].attributeID;
        const field = issue.fields[key];
        
        if (gTaskAttributes[i].field === 'Sprint') {
            event['ta' + i] = sprint;
        } else if (!field) {
            event['ta' + i] = 'N/A';
        } else {
            event['ta' + i] = await extractFieldValue(
                field, 
                gTaskAttributes[i].schema, 
                anonymize, 
            );
        }
    }
}

// Helper function to extract field value based on schema
async function extractFieldValue(field, schema, anonymize) {
    const simpleSchemas = ['priority', 'project', 'resolution', 'issuetype', 'status'];
    
    if (simpleSchemas.includes(schema)) {
        return field.name || 'N/A';
    }
    
    if (schema === 'user') {
        if (anonymize === 'true') {
            return anonymizeCheck(field.accountId);
        }
        return field.displayName || 'N/A';
    }
    
    if (schema === 'option') {
        return field.value || 'N/A';
    }
    
    if (schema === 'array') {
        // Check if this is a Stagil Assets Advanced Link custom field
        if (Array.isArray(field) && field.length > 0) {
            const values = field.map(item => {
                if (typeof item === 'string') return item;
                return item.name || item.value || item.displayName || item.toString();
            });
            return values.join('^^');
        }
        return 'N/A';
    }
    
    if (schema === 'sd-customerrequesttype') {
        return field.requestType?.name || 'N/A';
    }
    
    return field.toString() || 'N/A';
}


// Helper function to create initial event
async function createInitialEvent(
    issue,
    initialActivity,
    initialActivityType,
    sprint,
    commentsIndices,
    worklogIndices,
    anonymize,
    stagilFieldsDC,
    AppVersion,
    contextPath
) {
    const event = {
        task: issue.key,
        timestamp: issue.fields.created.substr(0, 19),
        summary: issue.fields.summary,
        activity: initialActivity,
        activity_type: initialActivityType,
        resource: getCreatorValue(issue, anonymize),
        comments_si: commentsIndices.si,
        comments_fi: commentsIndices.fi,
        worklog_si: worklogIndices.si,
        worklog_fi: worklogIndices.fi
    };
    
    // Add task attributes with Stagil support
    await addTaskAttributesToEvent(
        event, 
        issue, 
        sprint, 
        stagilFieldsDC, 
        anonymize, 
        AppVersion, 
        contextPath
    );
    
    return event;
}

// Helper function to get creator value
function getCreatorValue(issue, anonymize) {
    if (!issue.fields.creator) return 'Unknown';
    
    if (anonymize === 'true') {
        return anonymizeCheck(issue.fields.creator.accountId);
    }
    
    return issue.fields.creator.displayName;
}

function canonicalPlatformFromAppVersion(appVersion = gAppVersion) {
    if (appVersion === 'FORGE') return CANONICAL_PLATFORMS.JIRA;
    if (appVersion === 'SNOW') return CANONICAL_PLATFORMS.SERVICENOW;
    return CANONICAL_PLATFORMS.UNKNOWN;
}

function refreshCanonicalFilterProjection(stage = 'runtime-filter') {
    if (!gCanonicalDataset) {
        gCanonicalFilteredDataset = null;
        gCanonicalFilteredEvidenceMetrics = null;
        return null;
    }

    const selection = canonicalSelectionFromLegacyTasks(gTaskArray || []);
    const noTaskStateYet = !Array.isArray(gTaskArray) || gTaskArray.length === 0;
    gCanonicalFilteredDataset = projectCanonicalDataset(gCanonicalDataset, {
        ...selection,
        includeAll: noTaskStateYet,
        emptyMeansAll: false,
        metadata: {
            ...(selection.metadata || {}),
            stage,
        },
    });
    gCanonicalFilteredEvidenceMetrics = deriveCanonicalEvidenceMetrics(gCanonicalFilteredDataset);

    // Keep the debug handle useful while filters are being applied.
    if (typeof window !== 'undefined' && window.__PA_CANONICAL__) {
        window.__PA_CANONICAL__.filteredDataset = gCanonicalFilteredDataset;
        window.__PA_CANONICAL__.filteredMetrics = gCanonicalFilteredEvidenceMetrics;
        window.__PA_CANONICAL__.filterSummary = {
            stage,
            cases: gCanonicalFilteredDataset?.cases?.length || 0,
            events: gCanonicalFilteredDataset?.events?.length || 0,
            sourceCases: gCanonicalDataset?.cases?.length || 0,
            sourceEvents: gCanonicalDataset?.events?.length || 0,
        };
    }
    return gCanonicalFilteredDataset;
}

function promoteCanonicalConformanceEvaluations() {
    if (!gCanonicalDataset) return;
    const configuredRuleIds = new Set((gDiscoveryRules || [])
        .filter(rule => rule?.category === 'Compliance')
        .map(rule => String(rule.discovery_rule_id)));
    const workflowConfigured = gAppVersion === 'FORGE'
        && Array.isArray(gWorkflowConfiguration) && gWorkflowConfiguration.length > 0;
    const complianceConfigured = configuredRuleIds.size > 0;
    let legacyComplianceDisagreements = 0;
    const evaluations = (gTaskArray || []).map(task => {
        const violatedRuleIds = new Set();
        if (complianceConfigured) {
            for (let i = task.si; i <= task.fi; i++) {
                for (const finding of (gEventLogArray[i]?.discovery_rules || [])) {
                    const id = String(finding?.discovery_rule_id || '');
                    if (configuredRuleIds.has(id)) violatedRuleIds.add(id);
                }
            }
        }
        if (complianceConfigured && Number(task.filtered) === 0
            && (Number(task.compliant) === 1) !== (violatedRuleIds.size === 0)) {
            legacyComplianceDisagreements += 1;
        }
        return {
            caseId: task.task_id ?? task.native_id ?? task.sys_id ?? task.issue_id ?? null,
            caseKey: task.k ?? task.task ?? task.key ?? null,
            // The existing configured happy-path matcher sets this flag above.
            workflowAlignment: workflowConfigured ? Number(task.workflow_alignment) === 1 : null,
            // Check exact rule IDs rather than the legacy substring comparison.
            compliant: complianceConfigured ? violatedRuleIds.size === 0 : null,
            violatedRuleIds: [...violatedRuleIds],
        };
    });
    if (legacyComplianceDisagreements > 0) {
        console.warn('[PA Canonical Conformance] Rule-evaluation parity difference for',
            legacyComplianceDisagreements,
            'selected work items; canonical uses exact discovery-rule IDs.');
    }
    gCanonicalDataset = enrichCanonicalConformanceDataset(gCanonicalDataset, {
        evaluations, workflowConfigured, complianceConfigured,
        source: 'process-advisor-configured-rule-evaluation',
    });
    gCanonicalEvidenceMetrics = deriveCanonicalEvidenceMetrics(gCanonicalDataset);
    if (typeof window !== 'undefined' && window.__PA_CANONICAL__) {
        window.__PA_CANONICAL__.dataset = gCanonicalDataset;
        window.__PA_CANONICAL__.cases = gCanonicalDataset.cases;
        window.__PA_CANONICAL__.conformance = {
            ...gCanonicalDataset.metadata?.conformance,
            legacyComplianceDisagreements,
        };
        window.__PA_CANONICAL__.caseConformance = key =>
            gCanonicalDataset.cases.find(c => String(c.key) === String(key)
                || String(c.id) === String(key))?.extensions?.conformance || null;
        window.__PA_CANONICAL__.evidenceMetrics = gCanonicalEvidenceMetrics;
    }
}

function overlayCanonicalTotalMetrics(legacyTotalRow) {
    refreshCanonicalFilterProjection('model-metrics-total');
    if (!gCanonicalFilteredEvidenceMetrics) return legacyTotalRow;

    const canonical = gCanonicalFilteredEvidenceMetrics;
    const direct = new Set(canonical?.metricProvenance?.directCanonical || []);
    const merged = { ...(legacyTotalRow || {}) };
    for (const key of direct) {
        if (canonical[key] !== undefined && canonical[key] !== null) merged[key] = canonical[key];
    }
    merged.canonical_metric_source = 'filtered-canonical-process';
    merged.canonical_case_count = canonical.work_items;
    merged.canonical_event_count = canonical.events;
    merged.metricProvenance = canonical.metricProvenance;
    return merged;
}

function rebuildCanonicalDataset(model = {}, eventRows = gImportEventLogArray, metadata = {}) {
    const rows = Array.isArray(eventRows) ? eventRows : [];
    if (!rows.length) {
        gCanonicalDataset = null;
        gCanonicalProcessMetrics = null;
        gCanonicalEvidenceMetrics = null;
        gCanonicalFilteredDataset = null;
        gCanonicalFilteredEvidenceMetrics = null;
        return null;
    }

    gCanonicalDataset = legacyEventLogToCanonical({
        platform: canonicalPlatformFromAppVersion(),
        eventLog: rows,
        taskAttributes: gTaskAttributes || [],
        eventAttributes: gEventAttributes || [],
        issueComments: gIssueComments || [],
        issueWorklogs: gIssueWorklogs || [],
        model: {
            id: model?.id || model?.sys_id || model?.model_id || '',
            name: model?.name || model?.NAME || gProcessModelTitle || '',
            processType: model?.process_type || model?.issue_types || model?.table || '',
        },
        metadata: {
            ...metadata,
            source: {
                appVersion: gAppVersion,
                ...(metadata?.source || {}),
            },
        },
    });
    gCanonicalProcessMetrics = deriveCanonicalProcessMetrics(gCanonicalDataset);
                gCanonicalEvidenceMetrics = deriveCanonicalEvidenceMetrics(gCanonicalDataset);
    refreshCanonicalFilterProjection(metadata?.source?.stage || 'canonical-rebuild');

    // Sprint 1 canonical-model debugging. This writes an expandable snapshot to
    // the browser console and exposes the live model at window.__PA_CANONICAL__.
    // It is diagnostic only and must not alter processing behaviour.
    debugCanonicalDataset(gCanonicalDataset, {
        label: `Process Advisor canonical model (${metadata?.source?.stage || 'runtime'})`,
        metrics: gCanonicalProcessMetrics,
        sampleSize: 10,
    });

    return gCanonicalDataset;
}

// Helper function to build event log
// ── Activity Group Mapping helpers ───────────────────────────────────────────
// Called once when model data is loaded.  Populates gActivityGroupMap from
// model.activity_group_mappings so that applyGroupMapping() can be used
// in both buildEventLog (refresh path) and loadEventLogFromModel (load path).
function initGroupMapping(model) {
    gActivityGroupMap = {};
    gActivityGroupMappingConfig = null;
    if (!model || !model.activity_group_mappings) return;
    try {
        const config = typeof model.activity_group_mappings === 'string' ? JSON.parse(model.activity_group_mappings) : model.activity_group_mappings;
        gActivityGroupMappingConfig = config;
        if (config.useGroupMapping === true && Array.isArray(config.mappings)) {
            config.mappings.forEach(m => {
                if (m.value && m.group) gActivityGroupMap[m.value] = m.group;
            });
        }
    } catch (e) {
        console.error('[GROUP_MAPPING] Failed to parse activity_group_mappings:', e);
    }
}

// Substitutes a raw activity value with its group label if one is defined.
// Falls back to the raw value if no mapping exists.
function applyGroupMapping(activityValue) {
    if (!activityValue || Object.keys(gActivityGroupMap).length === 0) return activityValue;
    return gActivityGroupMap[activityValue] ?? activityValue;
}
// ─────────────────────────────────────────────────────────────────────────────

async function buildEventLog(eventLog, model = {}) {
    gEventAttributes = [{ id: 'ea0', field: 'Resource' }];
    gImportEventLogArray = [];
    gCanonicalDataset = null;
    gCanonicalProcessMetrics = null;
    gCanonicalEvidenceMetrics = null;
    
    for (const event of eventLog) {
        const processedEvent = {
            task: event.task,
            // Preserve platform-native identity through the shared runtime. Jira uses
            // the native issue id when available; ServiceNow uses sys_id. Older rows
            // simply omit it and the canonical adapter falls back to the case key.
            task_id: event.task_id || event.case_id || event.sys_id || '',
            activity: applyGroupMapping(event.activity),  // substitute group label if mapping active
            activity_type: event.activity_type,
            timestamp: event.timestamp,
            resource: event.resource,
            summary: event.summary,
            comments_si: event.comments_si,
            comments_fi: event.comments_fi,
            worklog_si: event.worklog_si,
            worklog_fi: event.worklog_fi
        };
        
        for (let j = 0; j < gTaskAttributes.length; j++) {
            processedEvent['ta' + j] = event['ta' + j];
        }
        
        gImportEventLogArray.push(processedEvent);
    }
    gImportEventLogArray = [...gImportEventLogArray.sort((a, b) => a.task.localeCompare(b.task) || a.timestamp.localeCompare(b.timestamp))]
    rebuildCanonicalDataset(model, gImportEventLogArray, { source: { stage: 'fresh-extraction' } });
}

// Helper function to handle data load from database
async function handleDataLoad(AppVersion, model, modelID, title, app, fields, editionAccess = {}) {
    if (isModelAssessmentCreditAuthorized(model) && !isAssessmentCreditUnlockedAccess(editionAccess)) {
        editionAccess = buildAssessmentUnlockedEditionAccess(editionAccess, buildAssessmentMarkerFromModel(model));
    }
    const step = (msg) => {
        gLoadingStatus = msg;
        updateLoadingStatus({ eventEmitter: gEventEmitter });
    };

    step('Retrieving Model');
    await wait();

    // Initialise group mapping and AI privacy rules from model config before loading event log
    initGroupMapping(model);
    loadAttributePrivacyFromModel(model);
    loadSNVisualizerAttributesFromModel(model);

    try {
        step('Loading attributes');
        await loadTaskAttributesFromModel(model,fields);
        gEventAttributes = [{ id: 'ea0', field: 'Resource' }];

        step('Loading comments');
        await loadCommentsFromModel(model);

        step('Loading worklogs');
        await loadWorklogsFromModel(model);

        step('Loading event log');
        await loadEventLogFromModel(AppVersion, modelID, model);
        applyPlanLimitToLoadedEventLog(editionAccess);

        gProcessModelTitle = title;
        gMetricArray = [];
        gEventLogName = '';
        gDataLoadType = 'DB';
        step('Processing event log');
        await wait();
        await processEventLog();

        if (gModelID && app === 'PO') {
            step('Loading AI model data');
            await loadJiraModel(model);
        }

        step('Finalizing');
        const finalStats = await finalizeModelData(app, model);
        debugSNOWSavedDatasetPayloadState('handleDataLoad/reopen-saved-dataset', { model, modelID, finalStats });
        return finalStats;

    } catch (error) {
        // Surface the exact step and error message in the loading modal
        // so it's visible even when browser devtools are unavailable (Forge iframe).
        const failedStep = gLoadingStatus;
        const errMsg = error.message || error.msg || String(error);
        gLoadingStatus = `Error at "${failedStep}": ${errMsg}`;
        updateLoadingStatus({ eventEmitter: gEventEmitter });
        console.error(`handleDataLoad failed at step "${failedStep}":`, error);
        throw error;
    }
}

// AI privacy helpers. The editor can save rules keyed by Jira field ID
// (for example customfield_10237), display label (Assignment Group), or a
// slightly different casing/spacing of either. Keep all aliases so both the
// ProcessMiner sample path and the Consultant tabs resolve the same rules.
function normalizePrivacyKey(key) {
    return String(key || '')
        .trim()
        .toLowerCase()
        .replace(/[\s_\-]+/g, '');
}

function normalizePrivacyRule(rule) {
    const value = (rule && typeof rule === 'object')
        ? (rule.rule || rule.privacy || rule.action || rule.value || rule.mode)
        : rule;
    const normalized = String(value || '').trim().toLowerCase();
    return ['exclude', 'anonymize', 'include'].includes(normalized) ? normalized : '';
}

function parseAttributePrivacyRules(raw) {
    if (!raw || raw === '' || raw === 'null' || raw === 'undefined') return {};
    if (typeof raw === 'object') return raw;
    if (typeof raw !== 'string') return {};
    try {
        const parsed = JSON.parse(raw);
        return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (e) {
        console.warn('Unable to parse attribute_privacy rules:', e?.message || e);
        return {};
    }
}


function parseSNFieldControlsFromModel(model) {
    const rawSettings = snValHelper(model?.settings) || snValHelper(model?.SETTINGS) || '';
    if (!rawSettings) return null;
    try {
        const parsed = typeof rawSettings === 'string' ? JSON.parse(rawSettings) : rawSettings;
        return parsed?.serviceNowFieldControls || parsed?.snFieldControls || null;
    } catch (err) {
        console.warn('Could not parse ServiceNow field controls:', err?.message || err);
        return null;
    }
}


function parseJsonArrayField(raw) {
    const value = snValHelper(raw);
    if (Array.isArray(value)) return value;
    if (value === null || value === undefined || value === '') return null;
    try {
        const parsed = JSON.parse(String(value));
        return Array.isArray(parsed) ? parsed : null;
    } catch (_) { return null; }
}

function loadSNVisualizerAttributesFromModel(model) {
    gSNVisualizerAttributeIDs = null;
    if (gAppVersion !== 'SNOW') return;

    const rawExplorerAttributeConfig = model?.explorer_attributes ?? model?.u_explorer_attributes;
    const directExplorerAttributes = parseJsonArrayField(rawExplorerAttributeConfig);
    if (Array.isArray(directExplorerAttributes)) {
        gSNVisualizerAttributeIDs = new Set(directExplorerAttributes.map(v => String(v || '').trim().toLowerCase()).filter(Boolean));
        return;
    }

    const controls = parseSNFieldControlsFromModel(model);
    if (Array.isArray(controls?.visualizerAttributes)) {
        gSNVisualizerAttributeIDs = new Set(controls.visualizerAttributes.map(v => String(v || '').trim().toLowerCase()).filter(Boolean));
        return;
    }

}

function loadAttributePrivacyFromModel(model) {
    gAttributePrivacy = {};
    gAttributePrivacyAnonymizedValues = {};
    gAttributePrivacyAnonymizedCounters = {};

    const parsed = parseAttributePrivacyRules(model?.attribute_privacy);
    Object.entries(parsed).forEach(([key, value]) => {
        const rule = normalizePrivacyRule(value);
        const cleanKey = String(key || '').trim();
        if (!cleanKey || !rule || rule === 'include') return;
        gAttributePrivacy[cleanKey] = rule;
        gAttributePrivacy[normalizePrivacyKey(cleanKey)] = rule;
    });

    rebuildAttributePrivacyByLabel();
}

// Remaps/adds aliases from Jira field-ID keys (stored by AttributePrivacyEditor)
// to display-label keys (used by taskJSON).
// attr.attributeID = Jira field ID e.g. "priority", "customfield_10237"
// attr.field       = display label e.g. "Priority", "Assignment Group"
function rebuildAttributePrivacyByLabel() {
    if (!gAttributePrivacy || Object.keys(gAttributePrivacy).length === 0) return;
    if (!gTaskAttributes || gTaskAttributes.length === 0) return;

    const aliasKeyed = { ...gAttributePrivacy };
    gTaskAttributes.forEach((attr) => {
        const aliases = [attr.attributeID, attr.field, attr.label, attr.id]
            .filter(Boolean)
            .map(v => String(v).trim())
            .filter(Boolean);

        let rule = '';
        for (const alias of aliases) {
            rule = normalizePrivacyRule(aliasKeyed[alias]) || normalizePrivacyRule(aliasKeyed[normalizePrivacyKey(alias)]);
            if (rule) break;
        }

        if (!rule) return;
        aliases.forEach((alias) => {
            aliasKeyed[alias] = rule;
            aliasKeyed[normalizePrivacyKey(alias)] = rule;
        });
    });

    gAttributePrivacy = aliasKeyed;
}

function getAttributePrivacyRule(attrOrField) {
    if (!gAttributePrivacy || Object.keys(gAttributePrivacy).length === 0) return '';

    const aliases = typeof attrOrField === 'string'
        ? [attrOrField]
        : [attrOrField?.attributeID, attrOrField?.field, attrOrField?.label, attrOrField?.id];

    for (const alias of aliases.filter(Boolean)) {
        const key = String(alias).trim();
        const rule = normalizePrivacyRule(gAttributePrivacy[key]) || normalizePrivacyRule(gAttributePrivacy[normalizePrivacyKey(key)]);
        if (rule) return rule;
    }

    return '';
}

function anonymizePrivacyValue(field, value) {
    if (value === null || value === undefined) return value;
    const rawValue = String(value).trim();
    if (rawValue === '' || rawValue === 'N/A') return value;

    const fieldKey = normalizePrivacyKey(field || 'Attribute');
    const valueKey = `${fieldKey}::${rawValue}`;

    if (!gAttributePrivacyAnonymizedValues[valueKey]) {
        gAttributePrivacyAnonymizedCounters[fieldKey] = (gAttributePrivacyAnonymizedCounters[fieldKey] || 0) + 1;
        const cleanField = String(field || 'Attribute').trim() || 'Attribute';
        gAttributePrivacyAnonymizedValues[valueKey] = `Anonymized ${cleanField} ${gAttributePrivacyAnonymizedCounters[fieldKey]}`;
    }

    return gAttributePrivacyAnonymizedValues[valueKey];
}
 
function parseAttributeListFromModel(attributes) {
    if (Array.isArray(attributes)) return attributes.map(v => String(v || '').trim()).filter(Boolean);
    return String(attributes || '')
        .split(/\^\^|,/) // samples use ^^; regular saved models generally use comma
        .map(v => v.trim())
        .filter(Boolean);
}

function parseSavedTaskAttributesText(csvText) {
    const text = String(csvText || '').trim();
    if (!text) return [];

    const lines = text.split(/\r?\n/).map(line => line.trim()).filter(Boolean);
    if (!lines.length) return [];

    const delimiter = lines[0].includes('^') ? '^' : ',';
    const firstCells = lines[0].split(delimiter).map(v => v.trim());
    const looksLikeHeader = firstCells.some(c => ['id', 'field', 'label', 'attributeid', 'attributeID', 'name', 'schema', 'value'].includes(c));

    if (looksLikeHeader) {
        const headers = firstCells.map(h => h.trim());
        return lines.slice(1).map(line => {
            const cells = line.split(delimiter).map(v => v.trim());
            const row = {};
            headers.forEach((header, index) => { row[header] = cells[index] || ''; });
            return row;
        }).filter(row => snValHelper(row?.id) || snValHelper(row?.field) || snValHelper(row?.label) || snValHelper(row?.attributeID));
    }

    // Headerless sample format: ta0^Assignment Group
    return lines.map((line, index) => {
        const cells = line.split(delimiter).map(v => v.trim());
        return {
            id: cells[0] || `ta${index}`,
            label: cells[1] || cells[0] || `ta${index}`,
            field: cells[1] || cells[0] || `ta${index}`,
            attributeID: cells[1] || cells[0] || `ta${index}`,
            schema: cells[2] || 'string',
        };
    }).filter(row => snValHelper(row?.id) || snValHelper(row?.field) || snValHelper(row?.label) || snValHelper(row?.attributeID));
}

function loadSavedTaskAttributes(model) {
    const encoded = snValHelper(model?.task_attributes) || snValHelper(model?.TASK_ATTRIBUTES);
    if (!encoded) return false;

    try {
        const csvText = pako.inflate(_base64ToArrayBuffer(encoded, 'task_attributes'), { to: 'string' });
        const rows = parseSavedTaskAttributesText(csvText);
        if (!rows.length) return false;

        gTaskAttributes = rows.map((row, i) => {
            const id = snValHelper(row.id) || `ta${i}`;
            const attributeID = snValHelper(row.field) || snValHelper(row.attributeID) || snValHelper(row.value) || snValHelper(row.label) || id;
            const label = snValHelper(row.label) || snValHelper(row.name) || snValHelper(row.field) || attributeID;

            return {
                id,
                field: label,
                label,
                attributeID,
                schema: snValHelper(row.schema) || 'string'
            };
        });

        if (isSampleProcessModel(model)) {
            console.table(gTaskAttributes.map((attr, index) => ({ index, id: attr.id, label: attr.label, attributeID: attr.attributeID })));
        }

        return gTaskAttributes.length > 0;
    } catch (err) {
        console.warn('Could not load saved task_attributes; falling back to model.attributes:', err?.message || err);
        return false;
    }
}

async function loadTaskAttributesFromModel(model, fields) {
    // Saved event logs are headerless. On reopen, the ta0/ta1/... header should be
    // rebuilt from task_attributes when it exists. This is essential for sample
    // models and ServiceNow models, and safe for regular Forge/Jira models.
    if (loadSavedTaskAttributes(model)) {
        rebuildAttributePrivacyByLabel();
        return;
    }

    const attrList = parseAttributeListFromModel(model.attributes);

    if (model?.sample === 'Y') {
        console.table(attrList.map((attrValue, index) => ({ index, attrValue })));
        console.warn('No usable task_attributes payload was found. Headings/data can be misaligned if model.attributes order does not match ta0/ta1/... in the event log.');
    }

    gTaskAttributes = attrList.map((attrValue, i) => {
        const fieldInfo = Array.isArray(fields)
            ? fields.find(f => f.value === attrValue)
            : null;
        return {
            id: 'ta' + i,
            field: fieldInfo?.label || attrValue,
            attributeID: attrValue,
            schema: fieldInfo?.schema || 'string'
        };
    });
    rebuildAttributePrivacyByLabel();
}

    // Helper function to load comments from model
async function loadCommentsFromModel(model) {
    // On a SNOW refresh the freshly extracted arrays are already set and the
    // model record in memory predates the save — keep the fresh data. On a
    // saved-model open the arrays are empty and the persisted CSV loads.
    if (gAppVersion === 'SNOW' && gIssueComments.length > 0) { return; }
    if (!model.issue_comments) {
        return;
    }
    
    try {
        const tempArray = readString(
            pako.inflate(_base64ToArrayBuffer(model.issue_comments,'issue_comments'), { to: 'string' })
        );
        
        let temp = 'timestamp,author,task,jsdPublic,accountType\n';
        for (const row of tempArray.data) {
            temp += row + '\n';
        }
        
        if (tempArray.data.length > 0) {
            gIssueComments = convertCSVtoArray(temp);
        }
    } catch (error) {
        console.error('Error loading comments:', error);
        throw new Error('Failed to load comments: ' + (error.message || error.msg || error));
    }
}

// Helper function to load worklogs from model
async function loadWorklogsFromModel(model) {
    if (gAppVersion === 'SNOW' && gIssueWorklogs.length > 0) { return; }
    if (!model.issue_worklogs) {
        return;
    }
    
    try {
        const tempArray = readString(
            pako.inflate(_base64ToArrayBuffer(model.issue_worklogs,'issue_worklogs'), { to: 'string' })
        );
        
        let temp = 'timestamp,author,task,timeSpentSeconds\n';
        for (const row of tempArray.data) {
            temp += row + '\n';
        }
        
        if (tempArray.data.length > 0) {
            gIssueWorklogs = convertCSVtoArray(temp);
        }
    } catch (error) {
        console.error('Error loading worklogs:', error);
        throw new Error('Failed to load worklogs: ' + (error.message || error.msg || error));
    }
}


// Helper function to load event log from model
function isSampleProcessModel(model = {}) {
    const sampleValue = snValHelper(model?.sample ?? model?.SAMPLE);
    const categoryValue = snValHelper(model?.category ?? model?.CATEGORY);
    return sampleValue === true
        || sampleValue === 1
        || sampleValue === '1'
        || String(sampleValue || '').trim().toUpperCase() === 'Y'
        || String(sampleValue || '').trim().toLowerCase() === 'true'
        || String(categoryValue || '').trim().toLowerCase() === 'sample';
}

async function loadEventLogFromModel(AppVersion, modelID, model) {
    //try {
        let eventLogs;
        
        if (AppVersion === 'FORGE') {
            const { invoke } = await loadForgeModule();
            eventLogs = await invoke('getEventLog', { modelID });
        } else if (AppVersion === 'SNOW') {
            const snApi = await getSnApi();
            const chunks = await snApi.getEventLog(modelID);
            // Map SN {array, sequence} to Forge {event_log} format
            eventLogs = (chunks || []).map(ch => ({ event_log: ch.event_log }));
        }
        // Build event log from chunks.
        // Chunks are fragments of a single base64-encoded deflate stream — reassemble
        // the full base64 string before inflating. Inflating each fragment independently
        // fails with "incorrect header check" on chunk_1+.
        const fullBase64 = eventLogs
            .map(ch => ch.event_log || ch.EVENT_LOG || '')
            .join('');
        let eventLog = '';
        const arrayBuffer = _base64ToArrayBuffer(fullBase64, 'event_log_chunks');
        try {
            eventLog = pako.inflate(arrayBuffer, { to: 'string' });
        } catch (pakoErr) {
            // Recovery path for chunks saved with the old corrupt Buffer.from encoding.
            // The browser Buffer polyfill mis-encoded binary data as UTF-8, producing
            // malformed compressed bytes. Attempt to recover by re-interpreting the
            // raw bytes through TextDecoder with latin1 (which is byte-transparent).
            console.warn(`event_log primary decompression failed, attempting recovery:`, pakoErr.message || pakoErr);
            try {
                const latin1Decoded = new TextDecoder('latin1').decode(new Uint8Array(arrayBuffer));
                const recoveryBytes = new Uint8Array(latin1Decoded.length);
                for (let b = 0; b < latin1Decoded.length; b++) {
                    recoveryBytes[b] = latin1Decoded.charCodeAt(b) & 0xFF;
                }
                eventLog = pako.inflate(recoveryBytes, { to: 'string' });
                console.warn(`event_log recovery succeeded`);
            } catch (recoveryErr) {
                throw new Error(`event_log decompression failed: ${pakoErr.message || pakoErr.msg || pakoErr}`);
            }
        }
        // Build header + data and parse — identical for all platforms.
        // Sample event logs are stored headerless and each sample has its own base
        // column layout before ta0/ta1/... attributes. The Incidents sample includes
        // an extra summary column before ta0. If this is missed, ta columns shift left
        // and labels such as Priority show Company values.
        let temp;
        let baseHeader = '';
        if (isSampleProcessModel(model)) {
            if (model.name === 'Incidents - Status') {
                baseHeader = 'activity_type,task,activity,timestamp,resource,summary';
            } else if (model.name === 'Story - Status') {
                baseHeader = 'activity_type,task,activity,timestamp,resource';
            } else if (model.name === 'Epic - Status' || model.name === 'Bugs - Status') {
                baseHeader = 'task,activity,timestamp,resource,activity_type,issue_type';
            }
        }
        if (baseHeader === '') baseHeader = 'task,activity,activity_type,timestamp,resource,summary,comments_si,comments_fi,worklog_si,worklog_fi';
        let header;
        const taColumns = gTaskAttributes.map((_, j) => 'ta' + j).join(',');
        header = taColumns ? baseHeader + ',' + taColumns : baseHeader;

        if (isSampleProcessModel(model)) {
            const firstRow = String(eventLog || '').split(/\r?\n/).find(Boolean) || '';
            const dataColumns = firstRow ? firstRow.split('^').length : 0;
            const headerColumns = header.split(',').length;
            if (dataColumns && dataColumns !== headerColumns) {
                console.warn('Header/data column mismatch. Attribute headings may not align with ta0/ta1/... values.');
            }
        }

        temp = header + '\n' + eventLog;
        gImportEventLogArray = convertCSVtoArray(temp, AppVersion === 'SNOW');


        // Apply group mapping if active — substitutes activity values with group labels
        // so the visualiser shows mapped names even when loading from the saved event log.
        if (Object.keys(gActivityGroupMap).length > 0) {
            let mappedCount = 0;
            gImportEventLogArray = gImportEventLogArray.map(event => {
                const mapped = applyGroupMapping(event.activity);
                if (mapped !== event.activity) mappedCount++;
                return { ...event, activity: mapped };
            });
            }

        // Prefer the persisted canonical dataset when one exists. This preserves native
        // Jira issue IDs / ServiceNow sys_ids plus canonical extensions (SLA, comments,
        // worklogs) that cannot be reconstructed losslessly from the legacy CSV rows.
        // Older models have no canonical payload, so they transparently fall back to
        // rebuilding from the legacy event log.
        try {
            let persistedCanonical = null;
            if (AppVersion === 'FORGE') {
                const { invoke } = await loadForgeModule();
                persistedCanonical = await loadCanonicalDatasetFromDatabase({
                    modelId: modelID,
                    appVersion: AppVersion,
                    invoke,
                });
            } else if (AppVersion === 'SNOW') {
                const snApi = await getSnApi();
                persistedCanonical = await loadCanonicalDatasetFromDatabase({
                    modelId: modelID,
                    appVersion: AppVersion,
                    snApi,
                });
            }

            if (persistedCanonical?.found && persistedCanonical.dataset) {
                gCanonicalDataset = persistedCanonical.dataset;
                gCanonicalProcessMetrics = deriveCanonicalProcessMetrics(gCanonicalDataset);
                gCanonicalEvidenceMetrics = deriveCanonicalEvidenceMetrics(gCanonicalDataset);
                debugCanonicalDataset(gCanonicalDataset, {
                    stage: 'stored-canonical-persistence',
                    persistence: {
                        storageId: persistedCanonical.storageId,
                        chunks: persistedCanonical.chunks,
                        fallback: false,
                    },
                });
            } else {
                rebuildCanonicalDataset(model, gImportEventLogArray, {
                    source: { stage: 'stored-model-load', canonicalPersistenceFallback: true },
                });
            }
        } catch (canonicalLoadError) {
            console.warn('[PA Canonical Persistence] load failed; rebuilding canonical model from legacy rows', canonicalLoadError?.message || canonicalLoadError);
            rebuildCanonicalDataset(model, gImportEventLogArray, {
                source: { stage: 'stored-model-load', canonicalPersistenceFallback: true },
            });
        }

    //} catch (error) {
    //    console.error('Error loading event log:', error);
    //    throw new Error('Failed to load event log: ' + error.message);
    // }
}

// Helper function to finalize model data
async function finalizeModelData(app, model) {
    gApp = app;
    gEntityUpper = gEntityUpper || 'Work Item';
    gEntityLower = gEntityUpper.toLowerCase();
    // Find end and start nodes
    let endNode = 0;
    let startNode = 0;
    for (const activity of gActivityArray) {
        if (activity.end_node === true) endNode = activity.id;
        if (activity.start_node === true) startNode = activity.id;
    }
    
    // Count events
    let events = 0;
    for (const event of gEventLogArray) {
        if (event.t !== endNode) events++;
    }
    
    // Count steps
    let steps = 0;
    for (const step of gStepArray) {
        if (parseInt(step.to) !== endNode) steps++;
    }
    gLoadingStatus = 'Processing dashboard metrics';
    updateLoadingStatus({ eventEmitter: gEventEmitter });
    await wait();

    // update filters if they exist in the model
    if (model.filters != undefined && model.filters != '[]' && model.filters != '') {
        if (JSON.parse(model.filters).length > 0) await processFilters(JSON.parse(model.filters),'loadJiraModel',false);
    }
    ctr = 0
    for (let i = 0; i < gTaskArray.length; i++) if (gTaskArray[i].filtered === 0) (ctr ++)
    await modelMetrics('month', 6);
    ctr = 0
    for (let i = 0; i < gTaskArray.length; i++) if (gTaskArray[i].filtered === 0) (ctr ++)
    return modelStatistics();
}

export async function modelMetrics(period,numPeriods) { 
    // find out maximum date
    let maxDate = "1900/01/01 01:00:00"
    for (let i = 0; i < gTaskArray.length; i++) {
        if (gTaskArray[i].t1 > maxDate && gTaskArray[i].filtered === 0) maxDate = gTaskArray[i].t1
    }

    let minDate = "2500/01/01 01:00:00"
    for (let i = 0; i < gTaskArray.length; i++) {
        if (gTaskArray[i].t1 < minDate && gTaskArray[i].filtered === 0) minDate = gTaskArray[i].t1
    }

    // get the periods
    let periods = []
    if (period === 'month') periods = getPreviousMonths(maxDate,numPeriods)
    if (period === 'week') periods = getPreviousWeeks(maxDate,numPeriods)

    for (let j = 0; j < periods.length; j++) {
        periods[j].work_items = 0
        periods[j].duration = 0
        periods[j].sdarray = []
        periods[j].internal_comments = 0
        periods[j].customer_comments = 0
        periods[j].time_spent = 0
        periods[j].worklogs = 0
        periods[j].loops = 0
        periods[j].workflow_alignment = 0
        periods[j].compliant = 0
        periods[j].transitions = 0
        periods[j].cycle_time_started = 0
        periods[j].resolution_time = 0
        periods[j].touch_time = 0
        periods[j].wait_time = 0
        periods[j].admin_time = 0
        periods[j].queue_time = 0
        periods[j].flow_efficiency = 0

        const endDate = new Date(periods[j].end);
        endDate.setDate(endDate.getDate() + 1);

        periods[j].start_date = formattedDate(periods[j].start).substring(0, 10)
        periods[j].end_date = formattedDate(endDate).substring(0, 10)
        if (period === 'month') {
            const date = new Date(periods[j].start);
            const monthName = date.toLocaleString('default', { month: 'short' });
            const year = date.getFullYear();
            periods[j].period = `${monthName} ${year}`
        }
        if (period === 'week') {
            const dateString = new Date(periods[j].start);
            const date = new Date(dateString);
            const year = date.getFullYear();
            const startOfYear = new Date(year, 0, 1);
            const dayOfYear = Math.floor((date - startOfYear) / (24 * 60 * 60 * 1000)) + 1;
            const week = Math.ceil(dayOfYear / 7);
            periods[j].period = `${year}-W${week}`  
        }
    }
    gVariantArray.sort((a, b) => a.id - b.id);
    gTaskArray.sort((a, b) => a.id - b.id);
    gEventLogArray.sort((a, b) => a.id - b.id);

    for (let i = 0; i < gTaskArray.length; i++) {gTaskArray[i].workflow_alignment = 0; gTaskArray[i].compliant = 1}
    for (let i = 0; i < gWorkflowConfiguration.length; i++) {
        let matching_issues = gWorkflowConfiguration[i].matching_issues
        for (let j = 0; j < matching_issues.length; j++) gTaskArray[matching_issues[j].id].workflow_alignment = 1
    }

    let discoveryRulesStr = ''
    for (let i = 0; i < gDiscoveryRules.length; i++) {
        if (gDiscoveryRules[i].category === 'Compliance') discoveryRulesStr = discoveryRulesStr + 'f-' + gDiscoveryRules[i].discovery_rule_id + ':'
    }
    let endNode = 0;
    let startNode = 0;
    for (let i = 0; i < gActivityArray.length; i++) {
        if (gActivityArray[i].end_node == true) endNode = gActivityArray[i].id;
        if (gActivityArray[i].start_node == true) startNode = gActivityArray[i].id;
    }

    for (let i = 0; i < gTaskArray.length; i++) {
        if (gTaskArray[i].filtered === 0) {
            let transitions = 0
            for (let f = gTaskArray[i].si; f < gTaskArray[i].fi + 1; f++) {
                if (gEventLogArray[f].f !== startNode) transitions ++ 
                let discoveryRules = gEventLogArray[f].discovery_rules
                for (let j = 0; j < discoveryRules.length; j++) {
                    if (discoveryRulesStr.includes(discoveryRules[j].discovery_rule_id)) {gTaskArray[i].compliant = 0}
                }
                gTaskArray[i].transitions = transitions
            }
        }
    }

    for (let i = 0; i < gTaskArray.length; i++) {
        if (gTaskArray[i].filtered === 0) {
        let periodTask = -1
        for (let j = 0; j < periods.length; j++) {
            if (gTaskArray[i].t1.replaceAll('/','-') >= formattedDate(periods[j].start) && gTaskArray[i].t1.replaceAll('/','-') <= formattedDate(periods[j].end)) {
                periods[j].work_items ++
                periods[j].duration = periods[j].duration + gTaskArray[i].d
                periods[j].sdarray.push(gTaskArray[i].d)
                periods[j].workflow_alignment = periods[j].workflow_alignment + gTaskArray[i].workflow_alignment
                periods[j].compliant = periods[j].compliant + gTaskArray[i].compliant
                periods[j].transitions = periods[j].transitions + gTaskArray[i].transitions
                periods[j].cycle_time_started = periods[j].cycle_time_started + (gTaskArray[i].cycle_time_started_seconds || 0)
                periods[j].resolution_time = periods[j].resolution_time + (gTaskArray[i].resolution_time_seconds || 0)
                periods[j].touch_time = periods[j].touch_time + (gTaskArray[i].touch_time_seconds || 0)
                periods[j].wait_time = periods[j].wait_time + (gTaskArray[i].wait_time_seconds || 0)
                periods[j].admin_time = periods[j].admin_time + (gTaskArray[i].admin_time_seconds || 0)
                periods[j].queue_time = periods[j].queue_time + (gTaskArray[i].queue_time_seconds || 0)
                periods[j].flow_efficiency = periods[j].flow_efficiency + (gTaskArray[i].flow_efficiency || 0)

                let comments = gTaskArray[i].comments  
                let worklog = gTaskArray[i].worklog
                
                if (comments !== undefined) {
                    for (let c = 0; c < comments.length; c++) {
                        if (comments[c] !== undefined) {
                            if (comments[c].jsdPublic === 'true') periods[j].customer_comments ++
                            else periods[j].internal_comments ++
                        }
                    }
                }
                if (worklog !== undefined) {
                    for (let w = 0; w < worklog.length; w++) {
                        if (worklog[w] !== undefined) {
                            periods[j].worklogs ++
                            periods[j].time_spent = periods[j].time_spent + parseInt(worklog[w].timeSpentSeconds)  
                        }
                    }         
                }
                if (gVariantArray[gTaskArray[i].vid].loops > 0) periods[j].loops ++

                break
            }
        }
        }
    }

    const markMetricValidity = (row, invalidReason = 'No tracked data available for this metric in the selected period') => {
        const invalidWhenZero = [
            'avg_time_spent',
            'avg_customer_comments',
            'avg_internal_comments',
            'avg_worklogs'
        ];
        const lifecycleOnlyMetrics = [
            'avg_cycle_time_started',
            'avg_resolution_time',
            'avg_touch_time',
            'avg_wait_time',
            'avg_admin_time',
            'avg_queue_time',
            'avg_flow_efficiency'
        ];
        const ctx = getActivityContext ? getActivityContext() : null;
        const activityKind = String(ctx?.activity_kind || ctx?.analysis_type || '').toLowerCase();
        const isLifecycle = activityKind === 'lifecycle_status' || activityKind === 'status' || activityKind.includes('lifecycle');
        row.metric_validity = row.metric_validity || {};
        for (let i = 0; i < invalidWhenZero.length; i++) {
            const key = invalidWhenZero[i];
            const valid = Number(row[key] || 0) > 0;
            row.metric_validity[key] = valid;
            row[key + '_valid'] = valid;
            if (!valid) row[key + '_invalid_reason'] = invalidReason;
        }
        if (!isLifecycle) {
            const reason = 'This metric requires a lifecycle/status activity model. It is not meaningful for assignment group, assignee, category, or other non-status activity fields.';
            for (let i = 0; i < lifecycleOnlyMetrics.length; i++) {
                const key = lifecycleOnlyMetrics[i];
                row.metric_validity[key] = false;
                row[key + '_valid'] = false;
                row[key + '_invalid_reason'] = reason;
            }
        }
        return row;
    };

    const buildTotalMetricsRow = () => {
        const sdarray = [];
        const variantIds = new Set();
        const stepIds = new Set();
        const activityIds = new Set();

        const totals = {
            period: 'Model Total',
            period_type: 'total',
            start_date: minDate.substring(0, 10).replaceAll('/', '-'),
            end_date: maxDate.substring(0, 10).replaceAll('/', '-'),
            work_items: 0,
            duration: 0,
            internal_comments: 0,
            customer_comments: 0,
            time_spent: 0,
            worklogs: 0,
            loops: 0,
            workflow_alignment: 0,
            compliant: 0,
            transitions: 0,
            cycle_time_started: 0,
            resolution_time: 0,
            touch_time: 0,
            wait_time: 0,
            admin_time: 0,
            queue_time: 0,
            flow_efficiency: 0,
        };

        for (let i = 0; i < gTaskArray.length; i++) {
            if (gTaskArray[i].filtered !== 0) continue;

            totals.work_items ++;
            totals.duration += gTaskArray[i].d || 0;
            sdarray.push(gTaskArray[i].d || 0);
            totals.workflow_alignment += gTaskArray[i].workflow_alignment || 0;
            totals.compliant += gTaskArray[i].compliant || 0;
            totals.transitions += gTaskArray[i].transitions || 0;
            totals.cycle_time_started += gTaskArray[i].cycle_time_started_seconds || 0;
            totals.resolution_time += gTaskArray[i].resolution_time_seconds || 0;
            totals.touch_time += gTaskArray[i].touch_time_seconds || 0;
            totals.wait_time += gTaskArray[i].wait_time_seconds || 0;
            totals.admin_time += gTaskArray[i].admin_time_seconds || 0;
            totals.queue_time += gTaskArray[i].queue_time_seconds || 0;
            totals.flow_efficiency += gTaskArray[i].flow_efficiency || 0;

            const comments = gTaskArray[i].comments;
            const worklog = gTaskArray[i].worklog;
            if (comments !== undefined) {
                for (let c = 0; c < comments.length; c++) {
                    if (comments[c] !== undefined) {
                        if (comments[c].jsdPublic === 'true') totals.customer_comments ++;
                        else totals.internal_comments ++;
                    }
                }
            }
            if (worklog !== undefined) {
                for (let w = 0; w < worklog.length; w++) {
                    if (worklog[w] !== undefined) {
                        totals.worklogs ++;
                        totals.time_spent += parseInt(worklog[w].timeSpentSeconds) || 0;
                    }
                }
            }
            if (gVariantArray[gTaskArray[i].vid] && gVariantArray[gTaskArray[i].vid].loops > 0) totals.loops ++;

            for (let j = gTaskArray[i].si; j < gTaskArray[i].fi + 1; j++) {
                const event = gEventLogArray[j];
                if (!event) continue;
                if (event.vid !== undefined) variantIds.add(event.vid);
                if (event.sid !== undefined) stepIds.add(event.sid);
                if (event.f !== undefined) activityIds.add(event.f);
                if (event.t !== undefined) activityIds.add(event.t);
            }
        }

        const totalRow = {
            period: totals.period,
            period_type: totals.period_type,
            start_date: totals.start_date,
            end_date: totals.end_date,
            work_items: totals.work_items,
            std_deviation: getStandardDeviation(sdarray),
            variants: variantIds.size,
            activities: Math.max(activityIds.size - 1, 0),
            steps: stepIds.size,
            cycle_time: 0,
            avg_customer_comments: 0,
            avg_internal_comments: 0,
            avg_time_spent: 0,
            avg_transitions: 0,
            rework_rate: 0,
            avg_worklogs: 0,
            avg_cycle_time_started: 0,
            avg_resolution_time: 0,
            avg_touch_time: 0,
            avg_wait_time: 0,
            avg_admin_time: 0,
            avg_queue_time: 0,
            avg_flow_efficiency: 0,
            workflow_alignment: 0,
            compliance: 0,
        };

        if (totals.work_items > 0) {
            totalRow.cycle_time = totals.duration / totals.work_items;
            totalRow.avg_customer_comments = totals.customer_comments / totals.work_items;
            totalRow.avg_internal_comments = totals.internal_comments / totals.work_items;
            totalRow.avg_time_spent = totals.time_spent / totals.work_items;
            totalRow.avg_transitions = totals.transitions / totals.work_items;
            totalRow.rework_rate = totals.loops / totals.work_items;
            totalRow.avg_worklogs = totals.worklogs / totals.work_items;
            totalRow.avg_cycle_time_started = totals.cycle_time_started / totals.work_items;
            totalRow.avg_resolution_time = totals.resolution_time / totals.work_items;
            totalRow.avg_touch_time = totals.touch_time / totals.work_items;
            totalRow.avg_wait_time = totals.wait_time / totals.work_items;
            totalRow.avg_admin_time = totals.admin_time / totals.work_items;
            totalRow.avg_queue_time = totals.queue_time / totals.work_items;
            totalRow.avg_flow_efficiency = totals.flow_efficiency / totals.work_items;
            if (gAppVersion === 'FORGE') totalRow.workflow_alignment = totals.workflow_alignment / totals.work_items;
            totalRow.compliance = totals.compliant / totals.work_items;
        }

        return markMetricValidity(totalRow, 'No tracked data available for this metric in the selected model');
    };
    
    let metrics = []
    gProcessingModelMetrics = true
    for (let j = 0; j < periods.length; j++) {

        let vtp = {}

        let structure = await metricsProcessTimeFilter(periods[j].start_date,periods[j].end_date)  
        vtp['variants'] = structure[0]
        vtp['activities'] = structure[1]
        vtp['steps'] = structure[2]

        vtp['period'] = periods[j].period
        vtp['period_type'] = period
        vtp['start_date'] = periods[j].start_date
        vtp['end_date'] = periods[j].end_date
        vtp['work_items'] = periods[j].work_items
        vtp['std_deviation'] = getStandardDeviation(periods[j].sdarray)

        if (periods[j].work_items > 0) {
            vtp['cycle_time'] = periods[j].duration/periods[j].work_items
            vtp['avg_customer_comments'] = periods[j].customer_comments/periods[j].work_items
            vtp['avg_internal_comments'] = periods[j].internal_comments/periods[j].work_items
            vtp['avg_time_spent'] = periods[j].time_spent/periods[j].work_items
            vtp['avg_transitions'] = periods[j].transitions/periods[j].work_items
            vtp['rework_rate'] = periods[j].loops/periods[j].work_items
            vtp['avg_worklogs'] = periods[j].worklogs/periods[j].work_items
            vtp['avg_cycle_time_started'] = periods[j].cycle_time_started/periods[j].work_items
            vtp['avg_resolution_time'] = periods[j].resolution_time/periods[j].work_items
            vtp['avg_touch_time'] = periods[j].touch_time/periods[j].work_items
            vtp['avg_wait_time'] = periods[j].wait_time/periods[j].work_items
            vtp['avg_admin_time'] = periods[j].admin_time/periods[j].work_items
            vtp['avg_queue_time'] = periods[j].queue_time/periods[j].work_items
            vtp['avg_flow_efficiency'] = periods[j].flow_efficiency/periods[j].work_items
            if (gAppVersion === 'FORGE') vtp['workflow_alignment'] = periods[j].workflow_alignment/periods[j].work_items
            vtp['compliance'] = periods[j].compliant/periods[j].work_items
        } else {
            vtp['cycle_time'] = 0
            vtp['avg_customer_comments'] = 0
            vtp['avg_internal_comments'] = 0
            vtp['avg_time_spent'] = 0
            vtp['avg_transitions'] = 0
            vtp['rework_rate'] = 0
            vtp['avg_worklogs'] = 0
            vtp['avg_cycle_time_started'] = 0
            vtp['avg_resolution_time'] = 0
            vtp['avg_touch_time'] = 0
            vtp['avg_wait_time'] = 0
            vtp['avg_admin_time'] = 0
            vtp['avg_queue_time'] = 0
            vtp['avg_flow_efficiency'] = 0
            if (gAppVersion === 'FORGE') vtp['workflow_alignment'] = 0
            vtp['compliance'] = 0
        }
        
        markMetricValidity(vtp)
        metrics.push(vtp)
    }

//Incident Metrics for Demo
/*
    for (let j = 0; j < metrics.length; j++) {
        // Work Item Metrics
        metrics[j].work_items        = randomBetween(80, 200)
        metrics[j].cycle_time        = randomBetween(7 * 86400, 15 * 86400)   // 7–15 days in seconds
        metrics[j].avg_time_spent    = randomBetween(7200, 14400)              // 2–4 hours in seconds
        metrics[j].rework_rate       = randomBetween(0.1, 0.45)               // 10–45%
        metrics[j].std_deviation     = randomBetween(1 * 86400, 4 * 86400)    // 1–4 days in seconds

        // Process / Workflow Metrics
        metrics[j].variants          = randomBetween(50, 180)
        metrics[j].activities        = randomBetween(4, 10)
        metrics[j].steps             = randomBetween(15, 35)
        metrics[j].avg_transitions   = randomBetween(3.5, 6.5)
        metrics[j].workflow_alignment = randomBetween(0.6, 0.85)
        metrics[j].compliance        = randomBetween(0.7, 0.95)

        // Flow & Time Metrics
        metrics[j].avg_cycle_time_started = randomBetween(5 * 86400, 12 * 86400)  // 5–12 days
        metrics[j].avg_resolution_time    = randomBetween(6 * 86400, 14 * 86400)  // 6–14 days
        metrics[j].avg_touch_time         = randomBetween(3600, 10800)             // 1–3 hours
        metrics[j].avg_wait_time          = randomBetween(1 * 86400, 5 * 86400)   // 1–5 days
        metrics[j].avg_queue_time         = randomBetween(12 * 3600, 48 * 3600)   // 12–48 hours
        metrics[j].avg_admin_time         = randomBetween(3600, 7200)             // 1–2 hours
        metrics[j].avg_flow_efficiency    = randomBetween(0.08, 0.25)             // 8–25%

        // Collaboration & Effort Metrics
        metrics[j].avg_worklogs          = randomBetween(4, 9)
        metrics[j].avg_customer_comments = randomBetween(1, 5)
        metrics[j].avg_internal_comments = randomBetween(2, 7)
    }
*/
    gProcessingModelMetrics = false
    gModelMetrics = metrics
    gModelMetricsTotal = buildTotalMetricsRow()
    // Recompute the current Process Advisor conformance evaluations before the
    // canonical filtered-total overlay; period rows retain legacy semantics.
    promoteCanonicalConformanceEvaluations();
    // Lifecycle/status mappings must be promoted into the canonical dataset
    // before canonical Evidence period/total metrics are calculated.
    applyProcessArrayEnrichment();

    // Increment 9: retain the existing task filter, t1 period membership,
    // and start/end boundaries, but derive the matching history rows from
    // canonical cases/events/extensions. A mismatched period remains legacy
    // rather than reporting a deceptively different number of cases.
    if (gCanonicalDataset && Array.isArray(gModelMetrics)) {
        const members = (gTaskArray || [])
            .filter(task => Number(task?.filtered) === 0)
            .map(task => ({
                caseId: task?.task_id ?? task?.native_id ?? task?.sys_id ?? task?.issue_id,
                caseKey: task?.k ?? task?.task ?? task?.key,
                periodDate: task?.t1,
            }));
        const result = deriveCanonicalPeriodMetrics(gCanonicalDataset, gModelMetrics, members);
        const diagnostics = [];
        result.rows.forEach((canonicalRow, index) => {
            const legacyRow = gModelMetrics[index];
            const detail = result.diagnostics[index];
            // Protect the visible Evidence table against different date or
            // period-member semantics during this staged migration.
            if (!canonicalRow || !legacyRow || canonicalRow.periodMetrics.work_items !== legacyRow.work_items) {
                diagnostics.push({ ...detail, source: 'legacy-fallback',
                    legacyCases: legacyRow?.work_items ?? null });
                return;
            }
            const merged = mergeCanonicalPeriodRow(legacyRow, canonicalRow);
            gModelMetrics[index] = merged.row;
            // Existing validity conventions remain authoritative until their
            // migration; this refresh respects the current activity kind.
            markMetricValidity(gModelMetrics[index]);
            diagnostics.push({ ...detail, source: 'canonical-parity-gated',
                migratedFields: merged.migrated, retainedFields: merged.retained,
                differences: merged.differences });
        });
        if (typeof window !== 'undefined' && window.__PA_CANONICAL__) {
            window.__PA_CANONICAL__.periodMetrics = gModelMetrics;
            window.__PA_CANONICAL__.periodDiagnostics = diagnostics;
        }
        if (diagnostics.some(d => d.source === 'legacy-fallback' || (d.differences || []).length)) {
            console.warn('[PA Canonical Periods] Legacy fields retained where period membership or metric parity differs', diagnostics);
        } else {
            console.info('[PA Canonical Periods] Projected historical Evidence metrics', diagnostics);
        }
    }
    gModelMetricsTotal = overlayCanonicalTotalMetrics(gModelMetricsTotal)
}

async function metricsProcessTimeFilter(fromTime,toTime) {  

    let filteredEvents = []
    gEventLogArray.sort((a, b) => a.elid - b.elid);
    let fromDate = fromTime
    let toDate = toTime
    for (let i = 0; i < gTaskArray.length; i++) {
        if (gTaskArray[i].filtered === 0) {
            let year = gTaskArray[i].t1.substr(0, 4);
            let month = gTaskArray[i].t1.substr(5, 2) ;
            let day = gTaskArray[i].t1.substr(8, 2);
            let tempDate = year + '-' + month + '-' + day
            if (tempDate >= fromDate && tempDate < toDate) {
                for (let j = gTaskArray[i].si; j < gTaskArray[i].fi + 1; j++) {
                    let vtp = {};
                    vtp['elid'] = gEventLogArray[j].elid;
                    vtp['vid'] = gEventLogArray[j].vid;
                    vtp['sid'] = gEventLogArray[j].sid;
                    vtp['f'] = gEventLogArray[j].f;
                    vtp['t'] = gEventLogArray[j].t;
                    filteredEvents.push(vtp);
                }
            }
        }
    }
    let activities = new Set([
        ...filteredEvents.map(e => e.f), 
        ...filteredEvents.map(e => e.t)
    ]).size - 1;    
    let variants = new Set(filteredEvents.map(e => e.vid)).size;
    let steps = new Set(filteredEvents.map(e => e.sid)).size;
    return ([variants, activities, steps])
}


export function modelStatistics() {
    let endNode = 0;
    let startNode = 0;
    let activities = 0
    for (let i = 0; i < gActivityArray.length; i++) {
        if (gActivityArray[i].end_node == true) endNode = gActivityArray[i].id;
        if (gActivityArray[i].start_node == true) startNode = gActivityArray[i].id;
        if (gActivityArray[i].start_node == false && gActivityArray[i].end_node == false ) {
            if (gActivityArray[i].filtered === 0) activities ++ 
        }
    }
    let events = 0
    let total_events = 0
    for (let i = 0; i < gEventLogArray.length; i++) {
        if (gEventLogArray[i].f != startNode && gEventLogArray[i].t != endNode && gEventLogArray[i].filtered === 0)  events ++
        if (gEventLogArray[i].f != startNode && gEventLogArray[i].t != endNode )  total_events ++
    }
    let steps = 0
    for (let i = 0; i < gStepArray.length; i++) {
        if (parseInt(gStepArray[i].to) != endNode && gStepArray[i].filtered === 0)  steps ++
    }

    let tasks = 0
    let total_tasks = 0
    for (let i = 0; i < gTaskArray.length; i++) {
        if (gTaskArray[i].filtered === 0)  tasks ++
        total_tasks ++
    }

    let variants = 0
    for (let i = 0; i < gVariantArray.length; i++) {
        if (gVariantArray[i].filtered === 0)  variants ++
    }

    let discoveryRules = gDiscoveryRules.length
    let costs = gCosts.length

    gEventsTotal = total_events;
    gTasksTotal = total_tasks;

    let modelStats = []
    let vtp = [];
    vtp['events'] = events
    vtp['tasks'] = tasks
    vtp['variants'] = variants
    vtp['steps'] = steps
    vtp['activities'] = activities
    vtp['discovery_rules'] = discoveryRules
    vtp['costs'] = costs
    vtp['total_tasks'] = total_tasks
    vtp['total_events'] = total_events
    vtp['sample'] = gSample || 'N'
    modelStats.push(vtp);   
    return modelStats
}

export function processMinerGauges() {

    let modelStats = []
    let vtp = [];
    vtp['events'] = gDiagramPVEvents
    vtp['events_total'] = gVariantEventsSliced
    vtp['tasks'] = gDiagramPVTasks
    vtp['tasks_total'] = gVariantTasksSliced
    vtp['variants'] = gDiagramPVVariants
    vtp['variants_total'] = gVariantsSliced
    vtp['steps'] = gDiagramPVSteps
    vtp['steps_total'] = gVariantStepsSliced
    vtp['activities'] = gDiagramPVActivities
    vtp['activities_total'] = gVariantActivitiesSliced
    modelStats.push(vtp);   
    return modelStats

}

function anonymizeCheck(personID) {

    let found = false
    let id = 0
    let i = 0
    for (i = 0; i < gPersonArray.length; i++) {
        if (personID === gPersonArray[i]) {
            id = i
            found = true
            break
        }
    }
    let person = 0
    if (found == false) {
        gPersonArray.push(personID)
        person = 'Person ' + (i+1)
    }
    else {
        person = 'Person ' + id
    }

    return person
}


// Browser-safe base64 encoding of a pako-compressed Uint8Array.
// Buffer.from(binaryString).toString('base64') works in Node but the browser
// Buffer polyfill interprets the string as UTF-8, corrupting binary data for
// large payloads (8K+ events). Use native Uint8Array -> btoa instead.
function uint8ArrayToBase64(uint8Array) {
    let binary = '';
    const chunkSize = 8192; // process in chunks to avoid call stack limits
    for (let i = 0; i < uint8Array.length; i += chunkSize) {
        const chunk = uint8Array.subarray(i, i + chunkSize);
        binary += String.fromCharCode.apply(null, chunk);
    }
    return btoa(binary);
}

async function saveEventLog(type,AppVersion) { 

    gLoadingStatus = 'Save Event Log';
    updateLoadingStatus({ eventEmitter: gEventEmitter });
    await wait();

    if (false) {
        let BASE_URL = `https://process-optimizer-jira.metricus.com/api/eventlog/delete`;
        let API = Axios.create({ baseURL: BASE_URL });
        let res = await API.delete(gModelID);
    }
    if (AppVersion === 'FORGE') {
        const { invoke } = await loadForgeModule();
        await invoke('deleteEventLog', { id: gModelID});    
    }
    if (AppVersion === 'SNOW') {
        const snApi = await getSnApi();
        await snApi.deleteEventLogChunks(gModelID);
    }


    let fields = ''
    if (type === 'external') {
        let i = 0
        for(var key  in gImportEventLogArray[0]){ 
            if (i > 0) fields = fields + ','
            fields = fields + key
            i++
        }
    }

    // Use uint8ArrayToBase64 (browser-safe) instead of Buffer.from().toString('base64').
    // Buffer polyfill treats binary strings as UTF-8, corrupting large compressed payloads.
    const metric_array_64    = uint8ArrayToBase64(pako.deflate(convertToCSV(gMetricArray)));
    const task_attributes_64 = uint8ArrayToBase64(pako.deflate(convertToCSV(gTaskAttributes)));
    const event_attributes_64= uint8ArrayToBase64(pako.deflate(convertToCSV(gEventAttributes)));
    const event_log_64       = uint8ArrayToBase64(pako.deflate(convertToCSV(gImportEventLogArray)));
    const model_comments_64  = uint8ArrayToBase64(pako.deflate(convertToCSV(gModelComments)));
    const issue_comments_64  = uint8ArrayToBase64(pako.deflate(convertToCSV(gIssueComments)));
    const issue_worklogs_64  = uint8ArrayToBase64(pako.deflate(convertToCSV(gIssueWorklogs)));

    // PAKO compression
    //const chunks = event_log_64.match(/.{1,250000}/g); // Matches any character 1 to 3 times
    const chunks = splitStringByByteLength(event_log_64, 250000);

    // first save/update the process_model

    if (type === 'external') { 
        gModelID = uuidv4()
        // save analysis model
        let tempDiscoveryRules = [...gDiscoveryRules]
        /*
        for (let i = 0; i < tempDiscoveryRules.length; i++) {
            for (let k = 0; k < tempDiscoveryRules[i].filters.length; k++) {
                tempDiscoveryRules[i].filters[k].variants = []
            }
        }
            */
        const discoveryRules = JSON.stringify(tempDiscoveryRules)

        if (AppVersion === 'FORGE') {

            const { invoke } = await loadForgeModule();
            try {
                await invoke('createProcessModel', {
                id: gModelID,
                customer_id: gCustomerID,
                name: gModelFileName,
                description: gModelFileName,
                metric_array: metric_array_64,
                issue_comments: issue_comments_64,
                issue_worklogs: issue_worklogs_64,
                projects: '',
                issue_types: gIssueTypes,
                attributes: '',
                activity_types: gActivityTypes[0].activity_type,
                from_date: '',
                to_date: '',
                total_issues: gTaskArray.length,
                anonymize: '',
                attribute_privacy: null,
                consulting_workspace: JSON.stringify(gConsultingWorkspace || createDefaultConsultingWorkspace()),
                ai_report_scope: null,
                calendar: '',
                discovery_rules: discoveryRules,
                filters: '',
                settings: '',
                gauges: '',
                schedule_start: '',
                schedule_repeat: '',
                schedule_every: '',
                schedule_mon: '',
                schedule_tue: '',
                schedule_wed: '',
                schedule_thu: '',
                schedule_fri: '',
                schedule_sat: '',
                schedule_sun: '',
                schedule_time: '',
                schedule_timezone: '',
                next_schedule_time: '',
                previous_schedule_time: '',
                show_gauges: 0,
                confluence_space: "",
                confluence_parent_page: "",
                sample: 'N',
                event_log_saved: 'true',
                filtered_count: String(gTasksFiltered || gTaskArray.length || ''),
                ai_process_health_assessment: null,
                ai_intelligence: null,
                ai_consulting_report: null,
                ai_trend_analysis: null,
                ai_execution_strategy: null,
                ai_framework_assessment: null,
                ai_quick_healthcheck: null,
                activity_group_mappings: null});
            } catch (err) {
            } 

            try {
                for (let i = 0; i < chunks.length; i++) {
                    await invoke('createEventLog', { id: gModelID, chunk_no: i, event_log : chunks[i]});
                }
            } catch (err) {
            } finally {}

            // temp save json

            let data = JSON.stringify({
                id: gModelID,
                customer_id: gCustomerID,
                name: gModelFileName,
                description: gModelFileName,
                issue_comments: issue_comments_64,
                issue_worklogs: issue_worklogs_64,
                metric_array: metric_array_64,
                projects: '',
                issue_types: gIssueTypes,
                attributes: '',
                activity_types: gActivityTypes[0].activity_type,
                from_date: '',
                to_date: '',
                total_issues: gTaskArray.length,
                anonymize: '',
                calendar: '',
                discovery_rules: discoveryRules,
                filters: '',
                settings: '',
                gauges: '',
                schedule_start: '',
                schedule_repeat: '',
                schedule_every: '',
                schedule_mon: '',
                schedule_tue: '',
                schedule_wed: '',
                schedule_thu: '',
                schedule_fri: '',
                schedule_sat: '',
                schedule_sun: '',
                confluence_space: "",
                confluence_parent_page: "",
                schedule_time: '',
                schedule_timezone: '',
                next_schedule_time: '',
                previous_schedule_time: '',
                show_gauges: 0,
                sample: 'N'
            });  

            let fileName = 'process_model.json';
            let fileToSave = new Blob([data], {
                type: 'application/json',
                name: fileName,
            });
            saveAs(fileToSave, fileName);

            for (let i = 0; i < chunks.length; i++) {
                let data = JSON.stringify({
                    id: gModelID,
                    event_log: chunks[i],
                });

                let fileName = 'event_log' + i + '.json';
                let fileToSave = new Blob([data], {
                    type: 'application/json',
                    name: fileName,
                });
                saveAs(fileToSave, fileName);
            }
        }
    }

    if (type === 'internal') {
        if (AppVersion === 'FORGE') {
            const { invoke } = await loadForgeModule();
            let req = await invoke('getProcessModel', {modelID: gModelID });
            let processModels = req[0]
            await invoke('deleteProcessModel', {id: gModelID });
            try {
              await invoke('createProcessModel', {
                id: gModelID,
                ...preserveProcessModelBillingFields(processModels),
                customer_id: processModels.customer_id,
                name: processModels.name,
                description: processModels.description,
                projects: processModels.projects ,
                issue_types: processModels.issue_types ,
                attributes: processModels.attributes,
                category: processModels.category,
                jql: processModels.jql,
                activity_types: processModels.activity_types,
                from_date: processModels.from_date,
                to_date: processModels.to_date,
                total_issues: processModels.total_issues,
                anonymize: processModels.anonymize,
                attribute_privacy: processModels.attribute_privacy || null,
                consulting_workspace: JSON.stringify(gConsultingWorkspace || createDefaultConsultingWorkspace()),
                ai_report_scope: processModels.ai_report_scope || null,
                calendar: processModels.calendar,
                filters: processModels.filters,
                discovery_rules: processModels.discovery_rules,
                settings: processModels.settings,
                gauges: processModels.gauges,
                schedule_start: processModels.schedule_start,
                schedule_repeat: processModels.schedule_repeat,
                schedule_every: processModels.schedule_every,
                schedule_mon: processModels.schedule_mon,
                schedule_tue: processModels.schedule_tue,
                schedule_wed: processModels.schedule_wed,
                schedule_thu: processModels.schedule_thu,
                schedule_fri: processModels.schedule_fri,
                schedule_sat: processModels.schedule_sat,
                schedule_sun: processModels.schedule_sun,
                schedule_time: processModels.schedule_time,
                schedule_timezone: processModels.schedule_timezone,
                next_schedule_time: processModels.next_schedule_time,
                previous_schedule_time: processModels.previous_schedule_time,
                show_gauges: processModels.show_gauges,
                issue_comments: issue_comments_64,
                issue_worklogs: issue_worklogs_64,
                model_comments: model_comments_64,
                confluence_space : processModels.confluence_space,
                confluence_parent_page : processModels.confluence_parent_page,
                export_to_confluence : processModels.export_to_confluence,      
                metric_array: metric_array_64,
                filtered_count: String(gTasksFiltered || gTaskArray.length || ''),
                ai_process_health_assessment: processModels.ai_process_health_assessment || null,
                ai_intelligence: processModels.ai_intelligence || null,
                ai_consulting_report: processModels.ai_consulting_report || null,
                ai_trend_analysis: processModels.ai_trend_analysis || null,
                ai_execution_strategy: processModels.ai_execution_strategy || null,
                ai_framework_assessment: processModels.ai_framework_assessment || null,
                ai_quick_healthcheck: processModels.ai_quick_healthcheck || null,
                sample: processModels.sample,
                costs: processModels.costs,
                schedule_active: processModels.schedule_active,
                workflow_configuration: processModels.workflow_configuration,
                workflow_transitions: processModels.workflow_transitions,
                workflow_variants: processModels.workflow_variants,
                activity_group_mappings: processModels.activity_group_mappings || null,
                event_log_saved: 'true' });
            } catch (err) {
            } 
            // now save the event log
            try {
                for (let i = 0; i < chunks.length; i++) {
                    await invoke('createEventLog', { id: gModelID, chunk_no: i, event_log : chunks[i]});
                }
            } catch (err) {
            } finally {}
        }
        if (AppVersion === 'SNOW') {
            const snApi = await getSnApi();
            for (let i = 0; i < chunks.length; i++) {
                await snApi.createEventLogChunk(gModelID, i, chunks[i]);
            }
            await snApi.updateProcessModel(gModelID, {
                total_issues: String(gTaskArray.length),
            });
        }
    }

    // Sprint 1 Increment 4: persist the canonical dataset independently of the
    // legacy event-log CSV. The separate canonical_<modelId> namespace means old
    // models and current event-log readers remain untouched. Persistence failure is
    // non-fatal: the legacy model has already been saved and can still be reopened.
    try {
        if (gCanonicalDataset && gModelID) {
            let persistenceResult = null;
            if (AppVersion === 'FORGE') {
                const { invoke } = await loadForgeModule();
                persistenceResult = await saveCanonicalDatasetToDatabase({
                    modelId: gModelID,
                    dataset: gCanonicalDataset,
                    appVersion: AppVersion,
                    invoke,
                    metadata: { saveType: type },
                });
            } else if (AppVersion === 'SNOW') {
                const snApi = await getSnApi();
                persistenceResult = await saveCanonicalDatasetToDatabase({
                    modelId: gModelID,
                    dataset: gCanonicalDataset,
                    appVersion: AppVersion,
                    snApi,
                    metadata: { saveType: type },
                });
            }
            if (persistenceResult?.saved && persistenceResult.dataset) {
                gCanonicalDataset = persistenceResult.dataset;
                gCanonicalProcessMetrics = deriveCanonicalProcessMetrics(gCanonicalDataset);
                gCanonicalEvidenceMetrics = deriveCanonicalEvidenceMetrics(gCanonicalDataset);
                debugCanonicalDataset(gCanonicalDataset, {
                    stage: 'canonical-persisted',
                    persistence: {
                        storageId: persistenceResult.storageId,
                        chunks: persistenceResult.chunks,
                    },
                });
            }
        }
    } catch (canonicalSaveError) {
        console.warn('[PA Canonical Persistence] save failed; legacy model remains available', canonicalSaveError?.message || canonicalSaveError);
    }
}


function createDefaultConsultingWorkspace() {
    return {
        version: 3,
        objective: '',
        scope: '',
        businessArea: '',
        processOwner: '',
        stakeholders: '',
        targetSla: '',
        painPoints: '',
        workingHypothesis: '',
        notes: '',
        findings: [],
        actions: [],
        discovery_rules: [],
        deliverables: {},
        updatedAt: '',
    };
}

function normaliseConsultingWorkspace(value) {
    let parsed = value;
    if (typeof parsed === 'string') {
        try { parsed = JSON.parse(parsed); } catch (_) { parsed = null; }
    }
    const base = createDefaultConsultingWorkspace();
    if (!parsed || typeof parsed !== 'object') return base;
    return {
        ...base,
        ...parsed,
        version: Math.max(3, Number(parsed.version || 1)),
        findings: Array.isArray(parsed.findings) ? parsed.findings : [],
        actions: Array.isArray(parsed.actions) ? parsed.actions : [],
        discovery_rules: Array.isArray(parsed.discovery_rules) ? parsed.discovery_rules : [],
        deliverables: parsed.deliverables && typeof parsed.deliverables === 'object' ? parsed.deliverables : {},
    };
}

export function getConsultingWorkspace() {
    return normaliseConsultingWorkspace(gConsultingWorkspace);
}

export function setConsultingWorkspace(workspace) {
    gConsultingWorkspace = normaliseConsultingWorkspace(workspace);
    return gConsultingWorkspace;
}

function safeJsonParse(val, fallback = null) {
    if (!val || val === '' || val === 'undefined' || val === 'null') return fallback;
    try { return JSON.parse(val); } catch { return fallback; }
}

export async function loadJiraModel(model) {
    let modelExists = false;
    modelStatistics();
    gFilters = []; gDiscoveryRules = []; gCosts = []; gFilterConditions = [];

    const wc = safeJsonParse(model.workflow_configuration); if (wc) gWorkflowConfiguration = wc;
    const wt = safeJsonParse(model.workflow_transitions);   if (wt) gWorkflowTransitions = wt;
    const wv = safeJsonParse(model.workflow_variants);      if (wv) gWorkflowVariants = wv;

    // DiscoveryRules
    // ServiceNow originally stored these in the legacy `findings` column.
    // Newer builds may use `discovery_rules`. Read both so existing instances keep working.
    const discoveryRules = safeJsonParse(model.discovery_rules, null) || safeJsonParse(model.findings, []);
    if (discoveryRules.length > 0) {
        for (let i = 0; i < discoveryRules.length; i++) {
            gLoadingStatus = 'Processing discovery rule ' + (i + 1) + ' of ' + discoveryRules.length;
            updateLoadingStatus({ eventEmitter: gEventEmitter });
            await wait();
            gFilters.length = 0;
            discoveryRules[i].mode = 'new';
            await updateDiscoveryRule(discoveryRules[i], discoveryRules[i].discovery_rule_id, 'loadDiscoveryRulesModel');
            await resetFilters(false, 'loadJiraModel');
            if (discoveryRules[i].save_variants === true || discoveryRules[i].save_activities === true || discoveryRules[i].save_steps === true) {
                await saveDiscoveryChildDiscoveryRules();
            }
        }
        await resetFilters(false);
        generateArrays(false, false, 'loadJiraModel', '');
    }

    gLoadingStatus = 'Processing visualizations';
    updateLoadingStatus({ eventEmitter: gEventEmitter });
    await wait();

    // Costs
    const costs = safeJsonParse(model.costs, []);
    if (costs.length > 0) {
        await processCosts(costs);
        modelExists = true;
        gLoadingStatus = 'Update Discovery Rule Costs';
        updateLoadingStatus({ eventEmitter: gEventEmitter });
        await wait();
        updateCostMetrics('loadJiraModel');
        await updateDiscoveryRuleCosts();
    }

    // Comments
    if (model.model_comments && model.model_comments !== null && model.model_comments !== '') {
        let tempArray = readString(pako.inflate(_base64ToArrayBuffer(model.model_comments), { to: 'string' }));
        let temp = 'activity,fromNode,toNode,comment,createdBy,createTime,component,variantType,filterConditions,type,commentID\n';
        let i = 0;
        for (i = 0; i < tempArray.data.length; i++) { temp += tempArray.data[i] + '\n'; }
        if (i > 0) gModelComments = convertCSVtoArray(temp);
    }

    // Settings
    const visualizer_settings = safeJsonParse(model.settings, []);
    if (visualizer_settings.length > 0) {
        importVisualizerSettings(visualizer_settings);
        modelExists = true;
    }

    if (modelExists === true) {
        gLoadingStatus = 'Processing metrics';
        updateLoadingStatus({ eventEmitter: gEventEmitter });
        await wait();
        generateTaskAnalyticsArray();
        updateSlicedVariables();
        updateAttributes();
    }
}

async function processEventLog()  { 
    gLoadingStatus = 'Transform Event Log';
    updateLoadingStatus({ eventEmitter: gEventEmitter });
    await wait();

    if (!gCanonicalDataset && Array.isArray(gImportEventLogArray) && gImportEventLogArray.length) {
        rebuildCanonicalDataset({}, gImportEventLogArray, { source: { stage: 'process-event-log-fallback' } });
    }
    gCanonicalProcessMetrics = gCanonicalDataset ? deriveCanonicalProcessMetrics(gCanonicalDataset) : null;
    gCanonicalEvidenceMetrics = gCanonicalDataset ? deriveCanonicalEvidenceMetrics(gCanonicalDataset) : null;

    const result = await processEventLogTransform({
        importEventLogArray: gImportEventLogArray,
        canonicalDataset: gCanonicalDataset,
        taskAttributes: gTaskAttributes,
        eventAttributes: gEventAttributes,
        metricArray: gMetricArray,
        planTier: gPlanTier,
        sample: gSample,
        calendarExists: gCalendarExists,
        calculateDuration,
        issueComments: gIssueComments,
        issueWorklogs: gIssueWorklogs,
        importArrayActivityID,
        importArrayStepUpdate,
        arrayVariantID,
    });

    gActivityArray = result.activityArray;
    gActivityIndexArray = result.activityIndexArray;
    gStepArray = result.stepArray;
    gVariantArray = result.variantArray;
    gTaskArray = result.taskArray;
    gEventLogArray = result.eventLogArray;
    gVariantEventsArray = result.variantEventsArray;
    gIssueComments = result.issueComments;
    gIssueWorklogs = result.issueWorklogs;

    gClusterMinTasks = 1;
    gInfluenceAnalysisMinTasks = 1;
    gDecompositionTreeMinTasks = 1;
    gClusterMaxTasks = gTaskArray.length;
    gInfluenceAnalysisMaxTasks = gTaskArray.length;
    gDecompositionTreeMaxTasks = gTaskArray.length;

    updateActivityColors();
    await finaliseEventLog();
}

function updateActivityColors() {  

    gActivityColors = []

    let vtp = [];
    vtp['color_fill'] = '#4572A7';
    vtp['color_text'] = '#FFFFFF';
    vtp['color_select'] = '#727171';
    gActivityColors.push(vtp);

    vtp = [];
    vtp['color_fill'] = '#AA4643';
    vtp['color_text'] = '#FFFFFF';
    vtp['color_select'] = '#727171';
    gActivityColors.push(vtp);

    vtp = [];
    vtp['color_fill'] = '#89A54E';
    vtp['color_text'] = '#FFFFFF';
    vtp['color_select'] = '#727171';
    gActivityColors.push(vtp);

    vtp = [];
    vtp['color_fill'] = '#80699B';
    vtp['color_text'] = '#FFFFFF';
    vtp['color_select'] = '#727171';
    gActivityColors.push(vtp);

    vtp = [];
    vtp['color_fill'] = '#3D96AE';
    vtp['color_text'] = '#FFFFFF';
    vtp['color_select'] = '#727171';
    gActivityColors.push(vtp);

    vtp = [];
    vtp['color_fill'] = '#DB843D';
    vtp['color_text'] = '#FFFFFF';
    vtp['color_select'] = '#727171';
    gActivityColors.push(vtp);
    gActivityArray.sort((a, b) => a.activity_type.localeCompare(b.activity_type));
    let activityType = ''
    let index = 0
    for (let i = 2; i < gActivityArray.length; i++) {   // start at 2 to excluded start/end nodes
        if (i > 2 && gActivityArray[i].activity_type != activityType) {
            index ++
        }
        const colorIndex = index % gActivityColors.length;
        gActivityArray[i].color_fill = gActivityColors[colorIndex].color_fill
        gActivityArray[i].color_text = gActivityColors[colorIndex].color_text
        gActivityArray[i].color_select = gActivityColors[colorIndex].color_select

        activityType = gActivityArray[i].activity_type
    }

}

async function  finaliseEventLog() {
    gLoadingStatus = 'Finalising Event Log';
    updateLoadingStatus({ eventEmitter: gEventEmitter });
    await wait();

    if (gUpdateEventLog == false) {
    	gModelComments = [];
        gDiscoveryRules = [];
        gCosts = []
    }
    gFilterConditions = [];
    gFilters = [];
    gFilterSets = 0;
    gTaskFilterAttributes = [];
    gTaskFilterTime = [];
    gTaskFilterTasks = [];
    gSelectedTransformationMapping = '';

    updateEventLogArray();
    resetMinMaxTimes();

    if (gUpdateEventLog == true) {
        if (gDiscoveryRules.length > 0) {
            for (let i = 0; i < gDiscoveryRules.length; i++) {
                updateDiscoveryRule(gDiscoveryRules[i],'','finaliseEventLog');
            }
        }
        gUpdateEventLog = false;
    } else {
        generateArrays(false, true, 'initial load','');
    }

}

export function resetEventLog() {
    gDiscoveryRules = [];
    gCosts = []
    gModelComments = [];
    gIssueComments = [];
    gIssueWorklogs = [];

    gFilterConditions = [];
    gFilters = [];
    gFilterSets = 0;
    gTaskFilterAttributes = [];
    gTaskFilterTime = [];
    gTaskFilterTasks = [];
    gSelectedTransformationMapping = '';

    gImportEventLogArray = [];
    gCanonicalDataset = null;
    gCanonicalProcessMetrics = null;
    gCanonicalEvidenceMetrics = null;
    gTaskAttributes = [];
    gEventAttributes = [];

    gActivityArray = [];
    gActivityIndexArray = [];
    gStepArray = [];
    gEventLogArray = [];
    gVariantArray = [];
    gTaskArray = [];
    gMetricArray = [];
    gAnalyticsTaskArray = [];
    gAnalyticsEventArray = [];
    rebuildPVDiagram('resetEventLog');
}

export function resetModel() {
    gModelComments = [];
    gIssueComments = [];
    gIssueWorklogs = [];

    gDiscoveryRules = [];
    gCosts = []
    gFilterConditions = [];
    gFilters = [];
    gFilterSets = 0;
    gTaskFilterAttributes = [];
    gTaskFilterTime = [];
    gTaskFilterTasks = [];
    gSelectedTransformationMapping = '';
    gWorkflowConfiguration = []
    gWorkflowTransitions = []
    gWorkflowVariants = []

    resetDiscoveryRules();
    processEventLog();
}

export function arrayVariantID(variantArray, variantArrayIndex, variant, loops, steps) {
    if (variant == '' || variant == null) {
        return;
    }
    let variantID;
    let variantIndex;

    let variants = variantArray.length - 1;
    let index = variantArrayIndex.indexOf(variant, 0);

    if (index != -1) {
        variantID = variantArray[index].v;
        variantIndex = variantArray[index].id;
    } else {
        variants = variants + 1;
        let vtp = {};
        vtp['n'] = variant;
        vtp['v'] = variants;
        vtp['s'] = vtp['v'];
        vtp['t'] = 0;
        vtp['loops'] = loops;
        if (loops > 0) {
            vtp['l'] = true;
        } else {
            vtp['l'] = false;
        }
        vtp['d'] = false;
        vtp['id'] = variantArray.length;
        vtp['steps'] = steps;
        vtp['selected'] = false;
        
        vtp['max_timestamp'] = '';
        variantArray.push(vtp);

        variantID = vtp['v'];
        variantIndex = vtp['id'];

        variantArrayIndex.push(variant);
    }
    return [variantArray, variantID, variantIndex, variantArrayIndex];
}

export function importArrayStepUpdate(stepArray, stepArrayIndex, activity_source, activity_target) {
    let stepID;
    let steps = stepArray.length - 1;

    let step = activity_source + '-' + activity_target;
    let index = stepArrayIndex.indexOf(step, 0);

    if (index != -1) {
        stepID = stepArray[index].id;
    } else {
        let vtp = {};
        vtp['f'] = activity_source;
        vtp['t'] = activity_target;
        vtp['id'] = steps;
        vtp['l'] = false;
        vtp['d'] = false;
        vtp['c'] = true;
        vtp['s'] = steps;
        vtp['step'] = step;
        vtp['max_timestamp'] = '';      
        stepArray.push(vtp);
        stepID = steps;

        stepArrayIndex.push(step);
    }
    return [stepArray, stepID, stepArrayIndex];
}

export function importArrayActivityID(activityArray, activityIndexArray, activity_type, activity, start_node, end_node) {
    if (activity == null) {
        return;
    }
    let activityID;

    let activities = activityArray.length - 1;
    let index = activityIndexArray.indexOf(activity_type + activity, 0);

    if (index != -1) {
        activityID = activityArray[index].id;
    } else {
        let figure;
        if (start_node == true || end_node == true) {
            figure = 'Circle';
        } else {
            figure = 'Border';
        }
        activities = activities + 1;
        let vtp = {};
        vtp['activity'] = activity;
        vtp['activity_type'] = activity_type;
        vtp['id'] = activities;
        vtp['start_node'] = start_node;
        vtp['end_node'] = end_node;
        vtp['v'] = true;
        vtp['selected_tasks'] = 0;
        vtp['sliced_tasks'] = 0;
        vtp['tasks'] = 0;
        vtp['max_timestamp'] = '';
        vtp['f'] = figure;
        vtp['color_text'] = "#FFFFFF";  // default to white
        vtp['color_fill'] = "";
        vtp['color_select'] = "";

        activityArray.push(vtp);
        activityID = activities;

        activityIndexArray.push(activity_type + activity);
    }

    return [activityArray, activityID, activityIndexArray];
}


function normalizeTaskAttributeKey(value) {
    return String(value || '')
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '_')
        .replace(/^_+|_+$/g, '');
}

const SERVICE_NOW_DERIVED_SLA_ATTRIBUTE_KEYS = new Set([
    'sla_total_count',
    'sla_records',
    'task_sla_records',
    'sla_count',
    'sla_breached_count',
    'breached_sla_count',
    'sla_has_breach',
    'sla_breached',
    'has_sla_breach',
    'has_breached',
    'active_sla_count',
    'sla_active_count',
    'sla_paused_count',
    'paused_sla_count',
    'sla_completed_count',
    'completed_sla_count',
    'sla_cancelled_count',
    'cancelled_sla_count',
    'sla_business_elapsed_hours',
    'business_elapsed_hours',
    'sla_business_time_left_hours',
    'business_time_left_hours',
    'sla_pause_hours',
    'sla_max_business_percentage',
    'sla_names',
    'sla_name',
    'sla_stages',
    'sla_stage'
]);

const SERVICE_NOW_ATTRIBUTE_DISPLAY_LABELS = {
    priority: 'Priority',
    assignment_group: 'Assignment Group',
    assigned_to: 'Assigned To',
    opened_by: 'Opened By',
    closed_by: 'Closed By',
    category: 'Category',
    subcategory: 'Subcategory',
    business_service: 'Business Service',
    service_offering: 'Service Offering',
    cmdb_ci: 'Configuration Item',
    company: 'Company',
    location: 'Location',
    contact_type: 'Contact Type',
    impact: 'Impact',
    urgency: 'Urgency',
    severity: 'Severity'
};

function isServiceNowDerivedSlaAttribute(attr) {
    if (gAppVersion !== 'SNOW') return false;
    const candidates = [attr && attr.field, attr && attr.label, attr && attr.attributeID, attr && attr.id]
        .map(normalizeTaskAttributeKey)
        .filter(Boolean);
    return candidates.some(key => SERVICE_NOW_DERIVED_SLA_ATTRIBUTE_KEYS.has(key));
}

function serviceNowAttributeLabel(attr) {
    const raw = String((attr && (attr.field || attr.label || attr.attributeID || attr.id)) || '').trim();
    const key = normalizeTaskAttributeKey(raw);
    if (SERVICE_NOW_ATTRIBUTE_DISPLAY_LABELS[key]) return SERVICE_NOW_ATTRIBUTE_DISPLAY_LABELS[key];
    if (!raw) return 'Attribute';
    return raw
        .replace(/[_\-]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .split(' ')
        .map(word => {
            const lower = String(word || '').toLowerCase();
            if (lower === 'sla') return 'SLA';
            if (lower === 'ci') return 'CI';
            if (lower === 'id') return 'ID';
            return lower ? lower.charAt(0).toUpperCase() + lower.slice(1) : '';
        })
        .join(' ');
}

function getTaskAttributeMatchKeys(attr) {
    const keys = [
        attr && attr.field,
        attr && attr.label,
        attr && attr.attributeID,
        attr && attr.id,
        gAppVersion === 'SNOW' ? serviceNowAttributeLabel(attr) : ''
    ]
        .map(normalizeTaskAttributeKey)
        .filter(Boolean);
    return Array.from(new Set(keys));
}

function resolveTaskAttribute(selection, options = {}) {
    const includeDerivedSla = options === true || options?.includeDerivedSla === true;
    const key = normalizeTaskAttributeKey(selection);
    if (!key) return null;

    for (let i = 0; i < (gTaskAttributes || []).length; i++) {
        const attr = gTaskAttributes[i] || {};
        if (!includeDerivedSla && isServiceNowDerivedSlaAttribute(attr)) continue;
        if (getTaskAttributeMatchKeys(attr).indexOf(key) >= 0) return attr;
    }
    return null;
}

function canonicalTaskAttributeField(selection, options = {}) {
    const attr = resolveTaskAttribute(selection, options);
    if (!attr) return String(selection || '').trim();
    return String(attr.field || attr.attributeID || attr.label || attr.id || selection || '').trim();
}

function canonicalizeTaskAttributeSelections(selections, options = {}) {
    const source = Array.isArray(selections) ? selections : [];
    const canonical = [];
    for (let i = 0; i < source.length; i++) {
        const field = canonicalTaskAttributeField(source[i], options);
        if (field && canonical.indexOf(field) === -1) canonical.push(field);
    }
    return canonical;
}

function displayTaskAttributeName(selection) {
    const attr = typeof selection === 'object' ? selection : resolveTaskAttribute(selection);
    if (attr) return gAppVersion === 'SNOW' ? serviceNowAttributeLabel(attr) : (attr.label || attr.field || attr.attributeID || attr.id || 'Attribute');
    const raw = String(selection || '').trim();
    if (!raw) return 'Attribute';
    return raw
        .replace(/[_\-]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .split(' ')
        .map(word => word ? word.charAt(0).toUpperCase() + word.slice(1) : '')
        .join(' ');
}

export function getTaskAttributesRaw(options = {}) {
    const includeDerivedSla = options === true || options?.includeDerivedSla === true;

    return (gTaskAttributes || [])
        .filter(attr => includeDerivedSla || !isServiceNowDerivedSlaAttribute(attr))
        .map((attr, i) => ({
            id: attr.id || ('ta' + i),
            field: attr.field || attr.label || attr.attributeID || ('Attribute ' + (i + 1)),
            label: gAppVersion === 'SNOW' ? serviceNowAttributeLabel(attr) : (attr.label || attr.field || attr.attributeID || ('Attribute ' + (i + 1))),
            attributeID: attr.attributeID || attr.field || attr.label || attr.id || ('ta' + i),
            schema: attr.schema || 'string'
        }));
}

export function taskAttributes() {
    let tArray = [];
    for (let i = 0; i < gTaskAttributes.length; i++) {
        const attr = gTaskAttributes[i] || {};
        if (isServiceNowDerivedSlaAttribute(attr)) continue;
        if (gAppVersion === 'SNOW' && gSNVisualizerAttributeIDs) {
            const candidates = [attr.attributeID, attr.id, attr.field, attr.label]
                .map(v => String(v || '').trim().toLowerCase())
                .filter(Boolean);
            if (!candidates.some(v => gSNVisualizerAttributeIDs.has(v))) continue;
        }
        let vtp = {};
        vtp['value'] = attr.field;
        vtp['label'] = gAppVersion === 'SNOW' ? serviceNowAttributeLabel(attr) : (attr.label || attr.field);
        tArray.push(vtp);
    }
    return tArray;
}

export function activityTypes() {
    let tArray = [];
    
    gActivityArray.sort((a, b) => a.activity_type.localeCompare(b.activity_type));
    let activityType = ''
    let ctr = 1
    for (let i = 2; i < gActivityArray.length; i++) {   // start at 2 to exclude start/end nodes
        if (gActivityArray[i].activity_type != activityType) {
            let vtp = {};
            vtp['value'] = gActivityArray[i].activity_type
            vtp['label'] = gActivityArray[i].activity_type
            ctr ++
            tArray.push(vtp);
        }
        activityType = gActivityArray[i].activity_type
    }
    return tArray;
}


export function eventAttributes() {
    let tArray = [];
    for (let i = 0; i < gEventAttributes.length; i++) {
        let vtp = {};
        vtp['value'] = gEventAttributes[i].field;
        vtp['label'] = gEventAttributes[i].field;
        tArray.push(vtp);
    }
    return tArray;
}

export function taskEventAttributes() {
    let tArray = [];
    for (let i = 0; i < gTaskAttributes.length; i++) {
        let vtp = {};
        vtp['value'] = gTaskAttributes[i].field;
        vtp['label'] = gTaskAttributes[i].field;
        tArray.push(vtp);
    }
    for (let i = 0; i < gEventAttributes.length; i++) {
        let vtp = {};
        vtp['value'] = gEventAttributes[i].field;
        vtp['label'] = gEventAttributes[i].field;
        tArray.push(vtp);
    }
    return tArray;
}

export function setEventEmitter(eventEmitter) {
    gEventEmitter = eventEmitter;
}

export function getEventEmitter() {
    return gEventEmitter;
}

export function init() {
    gInitialLoad = true;
    gRebuildCtr = 0;
    gInsights = ''

    gSaveModel = false
    gStepFilterGridState = null;
    gActivityFilterGridState = null;
    gTaskAttributeFilterGridState = null;
    gEventAttributeFilterGridState = null;
    gDiscoveryRulesGridState = null;

    gAAGridState = []
    gVariantSlicerGridState = [];
    gVariantSlicerGridFilterState = [];
    gStepFilterGridState = [];
    gCostsGridState = [];
    gActivityFilterGridState = [];
    gActivityTypeFilterGridState = [];
    gTaskAttributeFilterGridState = [];
    gEventAttributeFilterGridState = [];
    gDiscoveryRulesGridState = [];

    gTaskID = '';
    gLoadingStatus = '';

    const tOptions = taskAttributes()
    let attributes = [];
    for (let i = 0; i < tOptions.length; i++) {
        attributes.push(tOptions[i].value)
    }

    gClusterAttributeArray = attributes;
    gClusterAttributes = [];
    gClusterValueType = 'high';
    gClusterMinMetric = 0;
    gClusterMaxMetric = 999999999;
    gClusterRows = 20;

    gDecompositionTreeTaskArray = [];
    gDecompositionTreeValueType = 'high';
    gDecompositionTreeMinMetric = 0;
    gDecompositionTreeMaxMetric = 999999999;
    gDecompositionTreeAttribute = '';
    gDecompositionTreeMetric = 1;

    gInfluenceAnalysisAttributes = attributes;
    gInfluenceAnalysisMetric = 3;
    gInfluenceAnalysisInfluence = 'increase';
    gInfluenceAnalysisMinMetric = 0;
    gInfluenceAnalysisMaxMetric = 999999999;

    gShowDurationDays = true;
    gShowDurationHours = true;
    gShowDurationMinutes = true;
    gShowDurationSeconds = false;

    gStepWidthTasks = true;
    gStepWidthDuration = false;
    gStepWidthStdDeviation = false;

    gHighlightLoops = false;

    gStepColourVolume = false;
    gStepColourDuration = true;
    gStepColourStdDeviation = false;

    gDurationLabel = 'hrs';
    gVariantsVisualizationGraphType = 1;
    gVariantsVisualizationMetric = 1;
    gTasksVisualizationGraphType = 1;
    gTasksVisualizationMetric = 1;
    gTasksVisualizationFilter = 0;
    gTasksVisualizationNumTasks = 30;
    gTasksVisualizationSource = '';
    gTasksVisualizationSort = 0;

    go.Diagram.licenseKey = '298647e0b36648c702d90676423d6bf919a175639c8418a30e0413f6e9083c06329fea2859d3829787ac4eff1f7d90d0dcc03e20c349023fe531dbdb11e18ea9bb3373e5140a4f88a45626969eff2bf1ae6a61f497e571a288288de0fba8c5cc08e0a3';

    // has the DOM been created ?

    loadDiagramDecompositionTree();
    loadDiagramCluster();
    loadDiagramInfluenceAnalysis();

    let $ = go.GraphObject.make;
    // Visualizer diagram

    const getDiagramContextMenuOptions = () => {

        let variantLifeCycle = [
            {
                text: 'Variant Lifecycle',
                event: () => {
                    variantLifecycleModal()
                },
            },
        ]

        let discoveryRules = [
            
            {
                text: 'Save DiscoveryRule',
                        event: () => {
                            let filterSummary = []
                            for (let i = 0; i < gFilterConditions.length; i++) {
                                filterSummary.push({
                                    type: gFilterConditions[i].label,
                                    description: gFilterConditions[i].description,
                                });
                            }
                            openDiscoveryRuleModal({ 
                                data: {
                                    mode: 'new' ,
                                    category: 'Performance',
                                    type: 'Filter',
                                    tasks: gVariantTasksSliced,
                                    filters: gFilterConditions,
                                    filterSummary: filterSummary,
                                    automation_opportunity: false,
                                    calculate_cost_impact: true
                                },
                            });
                        },
            }
        ]

        let zoomToFit = [
            {
                text: 'Zoom to fit',
                event: () => {
                    gDiagramPV.zoomToFit();
                },
            }
        ]
        let insights = [
            {
                text: 'Insights',
                subMenuOptions: [ 
                    {
                        text: 'Clusters',
                        event: () => {
                            diagramContextMenuClusters()
                        },
                    },
                    {
                        text: 'Influencers',
                        event: () => {
                            diagramContextMenuInfluencers()
                        },
                    },
                    {
                        text: 'Decompose',
                        event: () => {
                            generateTasksFilteredArray('diagram', true, 0, 0, 0, 0, 0); 
                            setDiagramDecompositionTree('diagram');
                        },
                    },
                    {
                        text: 'Activity Analysis',  
                        event: () => {
                            gTimeInActivitySource = 'diagram'
                            generateTasksFilteredArray('diagram', true, 0, 0, 0, 0, 0);
                            gTimeInActivitySource = 'diagram';
                            setAction_Time({ eventEmitter: gEventEmitter });

                        },
                    },                                    
                    {
                        text: 'Histogram',
                        event: () => {
                            generateHistogramArray('diagram-tasks', true, 0, 0, 0, 0);
                            histogramModal()
                        },
                    },
                ],
            },
        ]

        let tasks = [
            {
                text: getEntityUpper() + 's',
                subMenuOptions: [
                    {
                        text: 'Detail',
                        event: () => {
                            gDetailSource = 'diagram';
                            taskDetailModal()
                        },
                    },
                    {
                        text: 'History', 
                        event: () => {
                            processAnalytics(0, 0, 0, 0, 0, '' ,'Diagram', 'Selected Variants', getEntityUpper() + 's','diagram')
                        },
                    }, 
                    {
                        text: 'LifeCycle',  
                        event: () => {
                            generateTasksFilteredArray('diagram', true, 0, 0, 0, 0, 0);
                            gTasksVisualizationSource = 'diagram';
                            tasksVisualization();
                            taskLifecycleModal()
                        },
                    },     
                ],
            },
        ]
        let events = [
            {
                text: 'Events',
                subMenuOptions: [

                    {
                        text: 'Detail',
                        event: () => {
                            gDetailSource = 'diagram';
                            eventDetailModal();
                        },
                    },
                    {
                        text: 'Histogram',
                        event: () => {
                            generateHistogramArray('diagram-events', true, 0, 0, 0, 0);
                            histogramModal()
                        },
                    },                    
                ],
            }
        ]

        let comments = [
             {
                 text: 'Comments...',
                 event: () => {
                     let variantType = 'all_variants';
                     let component = 'Variants'
                     let filterSummary = []
                     for (let i = 0; i < gFilterConditions.length; i++) {
                         filterSummary.push({
                             type: gFilterConditions[i].label,
                             description: gFilterConditions[i].description,
                         });
                     }
                     openCommentsModal({ data: {  activity: '', fromNode: '', toNode: '', variantType: variantType, filterSummary: filterSummary, mode: 'new', type: 'Variant', component: component,  source: 'variant' } });
                 },
             }
        ]
            
        let contextMenu = variantLifeCycle
        if (gFilterConditions.length > 0 && gApp === 'PO') contextMenu = contextMenu.concat(discoveryRules)
        contextMenu = contextMenu.concat(insights)
        contextMenu = contextMenu.concat(tasks)
        contextMenu = contextMenu.concat(events)
        contextMenu = contextMenu.concat(zoomToFit)
        return contextMenu

    };

    const contextMenuPEDiagram = $(go.HTMLInfo, {
        show: (obj, diagram) => {
            const { x, y } = diagram.lastInput.viewPoint;
            ``;
            const options = getDiagramContextMenuOptions;
            if (options) {
                showContextMenu({ gEventEmitter, x, y, options });
            }
        },
        hide: (diagram) => {
            hideContextMenu({ gEventEmitter });
        },
    });

    //gDiagramPV  = new go.Diagram("gDiagramDivDT");

    gDiagramPV = $(go.Diagram, {
        defaultScale: 2,
        contextMenu: contextMenuPEDiagram,
        defaultScale: 2,
        initialAutoScale: go.Diagram.Uniform,
        layout: $(go.LayeredDigraphLayout, { direction: 90 }),
        scrollMode: go.Diagram.InfiniteScroll,
        contentAlignment: go.Spot.Center,
        linkReshapingTool: new CurvedLinkReshapingTool(),
        'undoManager.isEnabled': true,
    });

    const element = document.getElementById('gDiagramDivPV');
    gDiagramPV.div = element     
    gCurrentDiagram = gDiagramPV;

    gDiagramPV.toolManager.mouseWheelBehavior = go.ToolManager.WheelZoom;
    gDiagramPV.toolManager.hoverDelay = 300;
    gDiagramPV.toolManager.toolTipDuration = 10000;
    gDiagramPV.addDiagramListener('ViewportBoundsChanged', function (e) {
        e.diagram.commit(function (dia) {
            dia.parts.each(function (part) {
                if (part._viewPosition) {
                    part.position = dia.transformViewToDoc(part._viewPosition);
                    part.scale = 1 / dia.scale;
                }
            });
        }, 'fix Parts');
    });

    const getNodeContextMenuOptions = ({ data: { key, activity } }) => {
        if (key < 2) {
            return;
        }

        let insights =        [
            {
                text: 'Insights',
                subMenuOptions: [

                    {
                        text: 'Clusters',
                        event: () => {
                            activityContextMenuClusters(key)
                        },
                    },
                    {
                        text: 'Influencers',
                        event: () => {
                            activityContextMenuInfluencers(key)
                        },
                    },
                    {
                        text: 'Decompose',
                        event: () => {
                            generateTasksFilteredArray('activity', true, 0, key, 0, 0, 0);
                            setDiagramDecompositionTree('activity');

                        },
                    },
                    {
                        text: 'Activity Analysis',  
                        event: () => {
                            gTimeInActivitySource = 'activity'
                            generateTasksFilteredArray('activity', true, 0, key, 0, 0, 0);
                            gTimeInActivitySource = 'activity';
                            setAction_Time({ eventEmitter: gEventEmitter });
                        },
                    },                    
                    {
                        text: 'Histogram' ,
                        event: () => {
                            generateHistogramArray('activity-tasks', true, 0, key, 0, 0);
                            histogramModal()
                        },
                    },
                ],
            }
        ]
        let tasks = [ {
            text: getEntityUpper() + 's',
            subMenuOptions: [
                {
                    text: 'Detail',
                    event: () => {
                        gDetailActivity = key;
                        gDetailSource = 'activity';
                        taskDetailModal()
                    },
                },
                {
                    text: 'History',
                    event: () => {
                        let activity = '';
                        for (let j = 0; j < gActivityArray.length; j++) {
                            if (gActivityArray[j].id == key) {
                                activity = gActivityArray[j].activity;
                            }
                        }
                        processAnalytics(0, key, 0, 0, 0, '' ,'Activity', activity, getEntityUpper() + 's','diagram')
                    },
                },    
                {
                    text: 'LifeCycle',
                    event: () => {
                        generateTasksFilteredArray('activity', true, 0, key, 0, 0, 0);
                        gTasksVisualizationSource = 'activity';
                        tasksVisualization();
                        taskLifecycleModal()
                    },
                },   

            ],
        },
        ]
        let events = [ {
            text: 'Events',
            subMenuOptions: [
                {
                    text: 'Detail',
                    event: () => {
                        gDetailActivity = key;
                        gDetailSource = 'activity';
                        eventDetailModal();
                    },
                },
                {
                    text: 'Histogram',
                    event: () => {
                        generateHistogramArray('activity-events', true, 0, key, 0, 0);
                        histogramModal()
                    },
                },
            ],
        }]

        let inboundSteps = [{
            text: 'Inbound Steps',
            subMenuOptions: [
                {
                    text: 'All Variants',
                    event: () => {
                        // check if the div has a diagram associated with it (or create new one?)
                        gDetailActivity = key;
                        gASAType = 'Inbound';
                        let activity = '';
                        let percOccurrence = '';
                        for (let j = 0; j < gActivityArray.length; j++) {
                            if (gActivityArray[j].id == key) {
                                activity = gActivityArray[j].activity;
                                percOccurrence =
                                    'Occurs in ' + formatPercentage(gActivityArray[j].tasks / gTasksFiltered, 1) + ' of ' + gEntityLower + 's';
                            }
                        }
                        gASALinks = generateLinks('activity_inbound_all');
                        gASANodes = generateNodes('activity_inbound_all');

                        let maxActivityTasks = '';
                        let maxTasks = 0;
                        for (let j = 0; j < gASANodes.length; j++) {
                            if (gASANodes[j].tasks > maxTasks && activity != gASANodes[j].activity) {
                                maxActivityTasks =
                                    formatPercentage(gASANodes[j].tasks / gASANodes[j].detailActivityTasks, 1) +
                                    ' came from ' +
                                    gASANodes[j].activity;
                                maxTasks = gASANodes[j].tasks;
                            }
                        }
                        openActivityStepAnalysisModal({
                            data: {
                                type: 'Inbound',
                                title: 'Activity Inbound Step Analysis - All Variants',
                                activity: activity,
                                occurrence: percOccurrence,
                                max_activity_tasks: maxActivityTasks,
                            },
                        });
                    },
                },
                {
                    text: 'Selected Variants',
                    event: () => {
                        // check if the div has a diagram associated with it (or create new one?)
                        gDetailActivity = key;
                        gASAType = 'Inbound';
                        let activity = '';
                        let percOccurrence = '';
                        for (let j = 0; j < gActivityArray.length; j++) {
                            if (gActivityArray[j].id == key) {
                                activity = gActivityArray[j].activity;
                                percOccurrence =
                                    'Occurs in ' +
                                    formatPercentage(gActivityArray[j].selected_tasks / gDiagramPVTasks, 1) +
                                    ' of ' +
                                    gEntityLower +
                                    's';
                            }
                        }
                        gASALinks = generateLinks('activity_inbound_selected');
                        gASANodes = generateNodes('activity_inbound_selected');

                        let maxActivityTasks = '';
                        let maxTasks = 0;
                        for (let j = 0; j < gASANodes.length; j++) {
                            if (gASANodes[j].tasks > maxTasks && activity != gASANodes[j].activity) {
                                maxActivityTasks =
                                    formatPercentage(gASANodes[j].tasks / gASANodes[j].detailActivityTasks, 1) +
                                    ' came from ' +
                                    gASANodes[j].activity;
                                maxTasks = gASANodes[j].tasks;
                            }
                        }
                        openActivityStepAnalysisModal({
                            data: {
                                type: 'Inbound',
                                title: 'Activity Inbound Step Analysis - Selected Variants',
                                activity: activity,
                                occurrence: percOccurrence,
                                max_activity_tasks: maxActivityTasks,
                            },
                        });
                    },
                },
            ],
        },
        ]

        let outboundSteps = [
            {
                text: 'Outbound Steps',
                subMenuOptions: [
                    {
                        text: 'All Variants',
                        event: () => {
                            gDetailActivity = key;
                            gASAType = 'Outbound';
                            let activity = '';
                            let percOccurrence = '';
                            for (let j = 0; j < gActivityArray.length; j++) {
                                if (gActivityArray[j].id == key) {
                                    activity = gActivityArray[j].activity;
                                    percOccurrence = 'Occurs in ' + formatPercentage(gActivityArray[j].tasks / gTasksFiltered, 1) + ' of tasks';
                                }
                            }
                            gASALinks = generateLinks('activity_outbound_all');
                            gASANodes = generateNodes('activity_outbound_all');
                            let maxActivityTasks = '';
                            let maxTasks = 0;
                            for (let j = 0; j < gASANodes.length; j++) {
                                if (gASANodes[j].tasks > maxTasks && activity != gASANodes[j].activity) {
                                    maxActivityTasks =
                                        formatPercentage(gASANodes[j].tasks / gASANodes[j].detailActivityTasks, 1) +
                                        ' go to ' +
                                        gASANodes[j].activity;
                                    maxTasks = gASANodes[j].tasks;
                                }
                            }
                            openActivityStepAnalysisModal({
                                data: {
                                    type: 'Outbound',
                                    title: 'Activity Outbound Step Analysis - All Variants',
                                    activity: activity,
                                    occurrence: percOccurrence,
                                    max_activity_tasks: maxActivityTasks,
                                },
                            });
                        },
                    },
                    {
                        text: 'Selected Variants',
                        event: () => {
                            gDetailActivity = key;
                            gASAType = 'Outbound';
                            let activity = '';
                            let percOccurrence = '';
                            for (let j = 0; j < gActivityArray.length; j++) {
                                if (gActivityArray[j].id == key) {
                                    activity = gActivityArray[j].activity;
                                    percOccurrence =
                                        'Occurs in ' +
                                        formatPercentage(gActivityArray[j].selected_tasks / gDiagramPVTasks, 1) +
                                        ' of ' +
                                        gEntityLower +
                                        's';
                                }
                            }
                            gASALinks = generateLinks('activity_outbound_selected');
                            gASANodes = generateNodes('activity_outbound_selected');
                            let maxActivityTasks = '';
                            let maxTasks = 0;
                            for (let j = 0; j < gASANodes.length; j++) {
                                if (gASANodes[j].tasks > maxTasks && activity != gASANodes[j].activity) {
                                    maxActivityTasks =
                                        formatPercentage(gASANodes[j].tasks / gASANodes[j].detailActivityTasks, 1) +
                                        ' go to ' +
                                        gASANodes[j].activity;
                                    maxTasks = gASANodes[j].tasks;
                                }
                            }
                            openActivityStepAnalysisModal({
                                data: {
                                    type: 'Outbound',
                                    title: 'Activity Outbound Step Analysis - Selected Variants',
                                    activity: activity,
                                    occurrence: percOccurrence,
                                    max_activity_tasks: maxActivityTasks,
                                },
                            });
                        },
                    },
                ],
            },
        ]
        let comments = [
            {
                text: 'Comments...',
                event: () => {
                    let variantType = 'all_variants';
                    let taskType = 'all_tasks';
                    if (gFilterConditions.length > 0) {
                        taskType = 'filtered_tasks';
                    }
                    let activity = '';
                    for (let j = 0; j < gActivityArray.length; j++) {
                        if (gActivityArray[j].id == key) {
                            activity = gActivityArray[j].activity;
                        }
                    }
                    let component = 'Activity: ' + activity
                    openCommentsModal({ data: {  activity: key, fromNode: '', toNode: '', variantType: variantType, taskType: taskType, mode: 'new', type: 'Activity', component: component,  source: 'activity' } });
                },
            },
        ]
        let contextMenu = insights
        contextMenu = contextMenu.concat(tasks)
        contextMenu = contextMenu.concat(events)
        contextMenu = contextMenu.concat(inboundSteps)
        contextMenu = contextMenu.concat(outboundSteps)

        return contextMenu

    };
    const getLinkContextMenuOptions = ({ data: { from, to, min_duration, max_duration, end_node, start_node, from_label, to_label , variant} }) => {
        if (end_node) {
            return;
        }
        let linkDetails = []
        for (let j = 0; j < gLinkArray.length; j++) {
            if (parseInt(gLinkArray[j].from) === parseInt(from) && parseInt(gLinkArray[j].variant) === parseInt(variant) && parseInt(gLinkArray[j].to) === parseInt(to)) {
                linkDetails = gLinkArray[j]
                break
            }
        }

        let metrics = [       
            {
                text: 'Metrics...',
                event: () => {

                    openStepMetricsModal({
                        data: {
                            fromActivity: linkDetails.from_label,
                            toActivity: linkDetails.to_label,
                            avg_comments_customer: linkDetails.comment_customer_ctr / linkDetails.tasks,
                            avg_comments_internal: linkDetails.comment_internal_ctr / linkDetails.tasks,
                            avg_duration: linkDetails.duration/linkDetails.tasks,
                            avg_worklogs: linkDetails.worklog_ctr / linkDetails.tasks,
                            comments_customer: linkDetails.comment_customer_ctr ,
                            comments_internal: linkDetails.comment_internal_ctr ,
		                    events: linkDetails.events,
                            tasks: linkDetails.tasks,
                            min_duration: linkDetails.min_duration,
                            max_duration: linkDetails.max_duration,
                            perc_comments_customer: linkDetails.tasks_comments_customer / linkDetails.tasks,  
                            perc_comments_internal: linkDetails.tasks_comments_internal / linkDetails.tasks,  
                            perc_total_tasks: linkDetails.tasks / gTasksFiltered,
                            perc_worklog: linkDetails.tasks_worklog / linkDetails.tasks,  
		                    std_deviation: linkDetails.std_deviation,
                            worklogs: linkDetails.worklog_ctr , 
                            time_spent: linkDetails.time_spent,
                            avg_time_spent: linkDetails.time_spent/ linkDetails.events,

                        },
                    });             
                },
            }
        ]


        let insights = [
            {
                text: 'Insights',
                subMenuOptions: [
                    {
                        text: 'Clusters',
                        event: () => {
                            stepContextMenuClusters(from,to)
                        },
                    },

                    {
                        text: 'Influencers',
                        event: () => {
                            stepContextMenuInfluencers(from,to)
                        },
                    },
                    {
                        text: 'Decompose',
                        event: () => {
                            generateTasksFilteredArray('step', true, 0, 0, from, to, 0);
                            setDiagramDecompositionTree('step');
                        },
                    },
                    {
                        text: 'Activity Analysis',  
                        event: () => {
                            gTimeInActivitySource = 'step'
                            generateTasksFilteredArray('step', true, 0, 0, from, to, 0);
                            gTimeInActivitySource = 'step';
                            setAction_Time({ eventEmitter: gEventEmitter });
                        },
                    },   
                    {
                        text: 'Histogram',
                        event: () => {
                            generateHistogramArray('step-tasks', true, 0, 0, from, to, 0);
                            histogramModal()
                        },
                    },
                ],
            },
        ]

        let tasks = [          
            {
                text: getEntityUpper() + 's',
                subMenuOptions: [
                    {
                        text: 'Detail',
                        event: () => {
                            gDetailNodeFrom = from;
                            gDetailNodeTo = to;
                            gDetailSource = 'step';
                            taskDetailModal()
                        },
                    },
                    {
                        text: 'History',
                        event: () => {
                            let from_str = ''
                            let to_str = ''
                            for (let j = 0; j < gActivityArray.length; j++) {
                                if (gActivityArray[j].id == from) {
                                    from_str = gActivityArray[j].activity;
                                }
                                if (gActivityArray[j].id == to) {
                                    to_str = gActivityArray[j].activity;
                                }
                            }

                            processAnalytics(0, 0, from, to, 0, '' ,'Step', from_str +' - ' + to_str, getEntityUpper() + 's','diagram')
                        },
                    },  
                    {
                        text: 'LifeCycle',
                        event: () => {
                            generateTasksFilteredArray('step', true, 0, 0, from, to, 0);
                            gTasksVisualizationSource = 'step';
                            tasksVisualization();
                            taskLifecycleModal()
                        },
                    },

                ],
            }
        ]

        let events = [
            {
                text: 'Events',
                subMenuOptions: [
                    {
                        text: 'Detail',
                        event: () => {
                            gDetailNodeFrom = from;
                            gDetailNodeTo = to;
                            gDetailSource = 'step';
                            eventDetailModal();
                        },
                    },
                    {
                        text: 'Histogram',
                        event: () => {
                            generateHistogramArray('step-events', true, 0, 0, from, to, 0);
                            histogramModal()
                        },
                    },
                ],
            }
        ]
/*
        let filter = [
            {
                text: 'Filter',
                event: () => {
                    //if (gFilters.length > 0) resetFilters(false,'');
                    gDetailNodeFrom = from;
                    gDetailNodeTo = to;
                    gFilterSelectedSteps = []    
                    const vtp = {};
                    vtp['from_activity'] = from_label
                    vtp['to_activity'] = to_label
                    gFilterSelectedSteps.push(vtp);
                    gStepSelectOperator = 'or'
                    gStepSelectRetention = 'include'
                    applyStepFilter()
                    applyFilterEvents({ eventEmitter: gEventEmitter });
                },
            },

        ]
*/
        let costs = [
            {
                text: 'Cost...', 
                event: () => {
                    let description = 'Cost: ' + from_label + ' -> ' + to_label;
                    let costType = 'total';
                    let variantType = 'all_variants';
                    let issueType = 'all_issues';
                    if (gFilterConditions.length > 0) {
                        issueType = 'filtered_issues';
                    }
                    let cost = 0;
                    let mode = 'new';
                    openStepCostModal({
                        data: {
                            description,
                            fromActivity: from,
                            toActivity: to,
                            fromActivityStr: from_label,
                            toActivityStr: to_label,
                            cost,
                            costType: 'fixed-cost',
                            variantType,
                            issueType,
                            mode,
                            reductionType: 'N/A', 
                            reductionPercentage: 0,
                            reductionCost: 0,
                            reductionValue: 'hrs'
                    
                        },
                    });
                },
            },
        ]

        let comments = [
            {
                text: 'Comments...',
                event: () => {
                    let variantType = 'all_variants';
                    let taskType = 'all_tasks';
                    if (gFilterConditions.length > 0) {
                        taskType = 'filtered_tasks';
                    }
                    let from_str = ''
                    let to_str = ''
                    for (let j = 0; j < gActivityArray.length; j++) {
                        if (gActivityArray[j].id == from) {
                            from_str = gActivityArray[j].activity;
                        }
                        if (gActivityArray[j].id == to) {
                            to_str = gActivityArray[j].activity;
                        }
                    }
                    let component = 'Step: ' + from_str + ' - ' + to_str
                    openCommentsModal({ data: { activity: '', fromNode: from, toNode: to, variantType: variantType, taskType: taskType, mode: 'new',  type: 'Step', component: component, source: 'step' } });
                },
            },
        ]
        let contextMenu = metrics
        contextMenu = contextMenu.concat(insights)
        contextMenu = contextMenu.concat(tasks)
        contextMenu = contextMenu.concat(events)
        //contextMenu = contextMenu.concat(filter)
        contextMenu = contextMenu.concat(costs) 
        return contextMenu

    };
    let contextMenuObj = null;
    const contextMenuPE = $(go.HTMLInfo, {
        show: (obj, diagram) => {
            const { x, y } = diagram.lastInput.viewPoint;
            ``;
            const options = obj.part instanceof go.Link ? getLinkContextMenuOptions(obj) : getNodeContextMenuOptions(obj);
            diagram.toolManager.hideToolTip();
            contextMenuObj && diagram.model.set(contextMenuObj.part.data, 'disableTooltip', false);
            contextMenuObj = obj;
            diagram.model.set(obj.part.data, 'disableTooltip', true);
            if (options) {
                showContextMenu({ gEventEmitter, x, y, options });
            }
        },
        hide: (diagram) => {
            diagram.model.set(contextMenuObj.part.data, 'disableTooltip', false);
            contextMenuObj = null;
            hideContextMenu({ gEventEmitter });
        },
    });

    gDiagramPV.nodeTemplate = $(
        go.Node,
        'Auto',
        { locationSpot: go.Spot.Center, isShadowed: true, contextMenu: contextMenuPE },
        $(
            go.Shape,
            new go.Binding('figure', 'figure'),
            { stroke: 'lightgray' },
            new go.Binding('fill', 'fill_color'),
//            new go.Binding('border', 'text_color') jjjj
        ),
        {
            toolTip: $(
                go.Adornment,
                'Auto',
                $(go.Shape, 'RoundedRectangle', { fill: 'white', stroke: 'gray', strokeWidth: 1 }),
                $(
                    go.TextBlock,
                    {
                        margin: 4,
                        font: '9pt system-ui, arial, system-ui',
                    },
                    new go.Binding('text', 'tooltip')
                ),
                new go.Binding('visible', 'disableTooltip', (disableTooltip) => !disableTooltip)
            ),
        },

        $(
            go.TextBlock, // the label text
            new go.Binding('font', 'font'),
            {
                textAlign: 'center',
                margin: 3,
            },
            new go.Binding('text'),
            new go.Binding('stroke', 'text_color'),
            new go.Binding('visible', 'visible')
        ),
        {
            selectionAdornmentTemplate: $(
                go.Adornment,
                'Auto',
                $(
                    go.Shape,
                    'RoundedRectangle',
                    { fill: null },
                    new go.Binding('stroke', 'highlight_color'),
                    new go.Binding('strokeWidth', 'highlight_width')
                ),
                $(go.Placeholder)
            ), // end Adornment
        }
    );

    gDiagramPV.nodeTemplateMap.add(
        'token',
        $(
            go.Part,
            { locationSpot: go.Spot.Center, layerName: 'Foreground' },
            $(go.Shape, 'Circle', { width: 10, height: 10, strokeWidth: 0 }, new go.Binding('fill', 'color'))
        )
    );

    gDiagramPV.linkTemplate = $(
        go.Link, // the whole link panel
        { curve: go.Link.Bezier, reshapable: true, adjusting: go.Link.Stretch, contextMenu: contextMenuPE },
        $(
            go.Shape,
            new go.Binding('stroke', 'link_color'),
            new go.Binding('strokeWidth', 'width'),
            new go.Binding('visible', 'visible'),
            new go.Binding('strokeDashArray', 'dashes', function (l) {
                return l ? [3, 2] : null;
            })
        ),

        $(go.Shape, { toArrow: 'standard', strokeWidth: 0 }, new go.Binding('fill', 'link_color')),
        {
            toolTip: $(
                go.Adornment,
                'Auto',
                $(go.Shape, 'RoundedRectangle', { fill: 'white', stroke: 'gray', strokeWidth: 1 }),
                $(
                    go.TextBlock,
                    {
                        margin: 4,
                        font: '9pt system-ui, arial, system-ui',
                    },
                    new go.Binding('text', 'tooltip')
                ),
                new go.Binding('visible', 'disableTooltip', (disableTooltip) => !disableTooltip)
            ),
        },
        {
            selectionAdornmentTemplate: $(
                go.Adornment,
                $(go.Shape, { isPanelMain: true }, new go.Binding('stroke', 'highlight_color'), new go.Binding('strokeWidth', 'width'))
            ), // end Adornment
        },
        $(
            go.Panel,
            'Auto',
            $(
                go.Shape, // the label background, which becomes transparent around the edges
                {
                    fill: $(go.Brush, 'Radial', { 0: 'rgb(240, 240, 240)', 0.3: 'rgb(240, 240, 240)', 1: 'rgba(240, 240, 240, 0)' }),
                    stroke: null,
                }
            ),
            $(
                go.TextBlock, // the label text
                {
                    textAlign: 'center',
                    margin: 8,
                },
                new go.Binding('font', 'font'),
                new go.Binding('visible', 'label_visible'),
                new go.Binding('text', 'link_label')
            )
        )
    );

    //requestZoomSliderUpdate();
    rebuildPVDiagram('init');

    for (let j = 0; j < gFilterConditions.length; j++) {
        if (gFilterConditions[j].type === 'filter') setFilterIcon({ eventEmitter: gEventEmitter }); 
        if (gFilterConditions[j].type === 'constraint') setConstraintIcon({ eventEmitter: gEventEmitter }); 
        if (gFilterConditions[j].type === 'discovery') setDiscoveryIcon({ eventEmitter: gEventEmitter });
    }
    return { diagram: gDiagramPV };
}

async function diagramContextMenuClusters() { 
    await openProgressModal({status: 'Processing Clusters'})
    await sleep(50)
    await generateTasksFilteredArray('diagram', true, 0, 0, 0, 0, 0);
    await setDiagramCluster('diagram');
    closeProgressModal()
}

async function diagramContextMenuInfluencers() { 
    await openProgressModal({status: 'Processing Influencer Insights'})
    await sleep(50)
    await generateTasksFilteredArray('diagram', true, 0, 0, 0, 0, 0);
    await setDiagramInfluenceAnalysis('diagram');
    closeProgressModal()
}

async function activityContextMenuClusters(key) { 
    await openProgressModal({status: 'Processing Clusters'})
    await sleep(50)
    await generateTasksFilteredArray('diagram', true, 0, 0, 0, 0, 0);
    await setDiagramCluster('diagram');
    closeProgressModal()
}

async function activityContextMenuInfluencers(key) { 
    await openProgressModal({status: 'Processing Influencer Insights'})
    await sleep(50)
    await generateTasksFilteredArray('activity', true, 0, key, 0, 0, 0);
    await setDiagramInfluenceAnalysis('activity');
    closeProgressModal()
}

async function stepContextMenuClusters(from,to) { 
    await openProgressModal({status: 'Processing Clusters'})
    await sleep(50)
    await generateTasksFilteredArray('step', true, 0, 0, from, to, 0);
    await setDiagramCluster('step');
    closeProgressModal()
}

async function stepContextMenuInfluencers(from,to) { 
    await openProgressModal({status: 'Processing Influencer Insights'})
    await sleep(50)
    await generateTasksFilteredArray('step', true, 0, 0, from, to, 0);
    await setDiagramInfluenceAnalysis('step');
    closeProgressModal()
}

export function setDiagramDecompositionTree(source) {  
    if (source != 'step' && source != 'activity' && source != 'variant' && source != 'diagram' && source != 'discovery_rule' && source != 'tia') {
        if (source === 'dt') generateTasksFilteredArray('dt', false);
    }
    if (source === 'tia') {gRCDescription = 'Selected issues from Activity Analysis'}
    gMinDiagramWidth = 880;
    let defaultNodeArray = []
    defaultNodeArray.push(
        {
            key: 1,
            label: gEntityUpper + 's',
            value: gTasksFilteredArray.length,
            perc: '100%',
            tooltip: '',
            attribute: 'parentNode',
            everExpanded: false,
            width: 185,
            rootdistance: 0,
        }
    )
    rebuildDecompositionTreeDiagram(defaultNodeArray);
    setAction_DecompositionTree({ eventEmitter: gEventEmitter });
    // find the initial node and set the value
    gCurrentDiagram = gDiagramDecompositionTree;
    let data = gDiagramDecompositionTree.model.nodeDataArray[0];
    gDiagramDecompositionTree.model.set(data, 'value', gTasksFilteredArray.length);
}

export async function setDiagramCluster(source, discovery_rule_id) {
    gClusterSource = source
    gClusterDiscoveryRuleID = discovery_rule_id

    if (source != 'step' && source != 'activity' && source != 'variant' && source != 'diagram' && source != 'discovery_rule' && source != 'tia') {
        if (source == 'rc') generateTasksFilteredArray('rc', false);
    }
    if (source === 'tia') {gRCDescription = 'Selected issues from Activity Analysis'}
    gMinDiagramWidth = 880;
    setAction_Cluster({ eventEmitter: gEventEmitter });
    updateDiagramCluster(source);  
    gCurrentDiagram = gDiagramCluster;
}

export async function setDiagramInfluenceAnalysis(source, discovery_rule_id) {
    gInfluenceSource = source
    gInfluenceDiscoveryRuleID = discovery_rule_id

    if (source != 'step' && source != 'activity' && source != 'variant' && source != 'diagram' && source != 'discovery_rule' && source != 'tia') {
        if (source == 'ia') generateTasksFilteredArray('ia', false);
    }
    if (source === 'tia') {gRCDescription = 'Selected issues from Activity Analysis'}
    gMinDiagramWidth = 880;
    setAction_InfluenceAnalysis({ eventEmitter: gEventEmitter });
    updateDiagramInfluenceAnalysis(source);
    gCurrentDiagram = gDiagramInfluenceAnalysis;
}

export function setDiagramVisualizer() {  
    gMinDiagramWidth = 400;
    setAction_Visualizer({ eventEmitter: gEventEmitter });
    rebuildPVDiagram('setDiagramVisualizer');
    gCurrentDiagram = gDiagramPV;
}

export function filterConditionsExport(type) {
    let rows = [];
    for (let i = 0; i < gFilterConditions.length; i++) {
        if (gFilterConditions[i].type === type || type === 'all') {
            rows.push({
                type: gFilterConditions[i].type,
                filter: gFilterConditions[i].description,
                id: gFilterConditions[i].id,
            });
        }
    }
    return rows;
}

export function resetDiscoveryRules() {
    gDiscoveryRules = [];

    for (let i = 0; i < gEventLogArray.length; i++) {
        gEventLogArray[i].pr = 0;
        gEventLogArray[i].pd = 0;
    }

    for (let i = 0; i < gEventLogArray.length; i++) {
        gEventLogArray[i].pr = 0;
        gEventLogArray[i].pd = 0;
    }
    generateTaskAnalyticsArray();

}

export function saveFilterSettings() {
    let tempArray = gFilterConditions;

    const jsonContent = JSON.stringify(tempArray);
    let fileName = gModelFileName + '_filters.json';
    let fileToSave = new Blob([jsonContent], {
        type: 'application/json',
        name: fileName,
    });
    saveAs(fileToSave, fileName);
}
export function saveTransformation() {
    let tempArray = gTransformation;

    const jsonContent = JSON.stringify(tempArray);
    let fileName = gModelFileName + '_transformation.json';
    let fileToSave = new Blob([jsonContent], {
        type: 'application/json',
        name: fileName,
    });
    saveAs(fileToSave, fileName);
}


export async function updateDiscoveryRuleID(discoveryRule) { 
    for (let j = 0; j < gDiscoveryRules.length; j++) {
        if (gDiscoveryRules[j].discovery_rule_id === discoveryRule.discovery_rule_id) gDiscoveryRules[j].id = discoveryRule.id
    }
}

export async function updateDiscoveryRule(discoveryRule,savedDiscoveryRuleID,source) {    
    if (!discoveryRule) {
        console.warn('updateDiscoveryRule called without a discovery rule', { savedDiscoveryRuleID, source });
        return;
    }
    discoveryRule.filters = Array.isArray(discoveryRule.filters) ? discoveryRule.filters : [];
    gSaveModel = true
    // check and generate discoveryRule ID
    let discovery_rule_id = 0;
    if (savedDiscoveryRuleID) discovery_rule_id = savedDiscoveryRuleID
    else {
        if (discoveryRule.mode == 'new') {
            for (let j = 0; j < gDiscoveryRules.length; j++) {
                if (parseInt(gDiscoveryRules[j].discovery_rule_id) > parseInt(discovery_rule_id)) discovery_rule_id = parseInt(gDiscoveryRules[j].discovery_rule_id) 
            }
            discovery_rule_id = discovery_rule_id + 100
        } else {
            discovery_rule_id = discoveryRule.discovery_rule_id;
        }
    }   
    let key = 'f-' + discovery_rule_id    
    gVariantArray.sort((a, b) => a.id - b.id);
    let duration = 0
    await resetFilters(false,'updateDiscoveryRule')


    if (source === 'loadDiscoveryRulesGeneric' || source === 'loadDiscoveryRulesModel' || source === 'saveDiscoveryChildDiscoveryRule' || source === 'saveParentDiscoveryRule' ) { // need to re-process the filters
        await processFilters(discoveryRule.filters,'updateDiscoveryRule',true)  
    }
    if (source === 'processDiscoveryRule'  ) {   // need to regenerate arrays
        await processFilters(discoveryRule.filters,'updateDiscoveryRule',false)  
    }

    if (discoveryRule.mode == 'new' || source === 'processDiscoveryRule') {  
        // gFilters always needs to be correct for mode = 'new'
        // will be if processFilters called above
        // should be for saveDiscoveryChildDiscoveryRule
        for (let i = 0; i < gEventLogArray.length; i++) gEventLogArray[i][key] = 0;
        gEventLogArray.sort((a, b) => a.elid - b.elid);
        for (let i = 0; i < gFilters.length; i++) {
            if (gFilters[i].filter_number === gFilterSets) {
                duration = duration + gEventLogArray[gFilters[i].id].d
                gEventLogArray[gFilters[i].id][key] = 1;
                let discoveryRules = Array.isArray(gEventLogArray[gFilters[i].id].discovery_rules) ? gEventLogArray[gFilters[i].id].discovery_rules : [];
                let vtp = [];
                vtp['discovery_rule_id'] = key;
                discoveryRules.push(vtp);
                gEventLogArray[gFilters[i].id].discovery_rules = discoveryRules;
            }
        }
    }

    if (discoveryRule.mode == 'new') {  

        let vtp = {};

        if (discoveryRule.discovery_rule_type !== 'child') {
            vtp['discovery_rule'] = discoveryRule.discovery_rule;
            vtp['parent_discovery_rule_id'] = ''
            vtp['sub_discovery_rule'] = ''
        } else {
            vtp['discovery_rule'] = discoveryRule.parent_discovery_rule;
            vtp['parent_discovery_rule_id'] = discoveryRule.parent_discovery_rule_id;
            vtp['sub_discovery_rule'] = discoveryRule.discovery_rule
        } 
        vtp['discovery_rule_id'] = discovery_rule_id;
        vtp['id'] = discoveryRule.id;
        vtp['create_time'] = currentDateTime();
        vtp['mode'] = discoveryRule.mode;
        vtp['impact'] = discoveryRule.impact;
        if (discoveryRule.calculate_cost_impact !== undefined) vtp['calculate_cost_impact'] = discoveryRule.calculate_cost_impact
        else vtp['calculate_cost_impact'] = true
        if (discoveryRule.automation_opportunity === 0 || discoveryRule.automation_opportunity === 1) vtp['automation_opportunity'] = false
        else vtp['automation_opportunity'] = discoveryRule.automation_opportunity;

        vtp['category'] = discoveryRule.category;
        vtp['type'] = discoveryRule.type;
        vtp['filters'] = Array.isArray(discoveryRule.filters) ? [...discoveryRule.filters] : [];
        vtp['discovery_rule_type'] = discoveryRule.discovery_rule_type;
        vtp['discovery_rule_detail'] = discoveryRule.discovery_rule_detail;

        let jsonObject = gFilters.map(JSON.stringify);
        let uniqueSet = new Set(jsonObject);
        let events = Array.from(uniqueSet).map(JSON.parse).length
        vtp['tasks'] = countFilteredTasks()
        vtp['events'] = events
        vtp['duration'] = duration

        let conditions = []
        let conditionsVTP = [];
        for (let i = 0; i < discoveryRule.filters.length; i++) {
            if (discoveryRule.filters[i].type === 'filter') {
                conditionsVTP = [];
                conditionsVTP['header'] = 1;
                conditionsVTP['text'] = 'Filters:'
                conditions.push(conditionsVTP);
                break
            }
        }

        for (let i = 0; i < discoveryRule.filters.length; i++) {
            if (discoveryRule.filters[i].type === 'filter') {
                conditionsVTP = [];
                conditionsVTP['header'] = 0;
                conditionsVTP['text'] = discoveryRule.filters[i].description
                conditions.push(conditionsVTP);
            }
        }

        for (let i = 0; i < discoveryRule.filters.length; i++) {
            if (discoveryRule.filters[i].type === 'discovery') {
                conditionsVTP = [];
                conditionsVTP['header'] = 1;
                conditionsVTP['text'] = 'Discovery:'
                conditions.push(conditionsVTP);
                break
            }
        }

        for (let i = 0; i < discoveryRule.filters.length; i++) {
            if (discoveryRule.filters[i].type === 'discovery') {
                conditionsVTP = [];
                conditionsVTP['header'] = 0;
                conditionsVTP['text'] = discoveryRule.filters[i].description
                conditions.push(conditionsVTP);
            }
        }
        vtp['conditions'] = conditions
        vtp['actual_cost'] = 0
        vtp['forecast_cost'] = 0
        vtp['save_activities'] = discoveryRule.save_activities
        vtp['save_steps'] = discoveryRule.save_steps
        vtp['save_variants'] = discoveryRule.save_variants
        vtp['filter_activities'] = discoveryRule.filter_activities
        vtp['filter_steps'] = discoveryRule.filter_steps
        vtp['filter_variants'] = discoveryRule.filter_variants
        gDiscoveryRules.push(vtp);

        //if (source === 'saveParentDiscoveryRule') await resetFilters(false)
        if (gCosts.length > 0) updateDiscoveryRuleCosts() // optimize   
    }

    if (source === 'saveParentDiscoveryRule') {
        // Return to the main Process Miner visualizer after saving a Discovery Rule.
        if (gEventEmitter) setAction_Visualizer({ eventEmitter: gEventEmitter });
        setDiagramVisualizer();
    }
}

function nextFindingID() {
    let id = 0;
    for (let i = 0; i < gFindings.length; i++) {
        const current = parseInt(gFindings[i].findingID || gFindings[i].finding_id || 0);
        if (current > id) id = current;
    }
    return id + 100;
}

function normaliseFindingRecord(finding = {}, savedFindingID = '') {
    const now = new Date().toISOString();
    const findingID = savedFindingID || finding.findingID || finding.finding_id || nextFindingID();
    const filters = Array.isArray(finding.filters) ? finding.filters : [];
    const evidence = Array.isArray(finding.evidence) ? finding.evidence : [];
    return {
        id: finding.id || `finding_${findingID}`,
        findingID,
        finding_id: findingID,
        title: finding.title || finding.finding || finding.summary || 'Untitled finding',
        finding: finding.finding || finding.title || finding.summary || 'Untitled finding',
        category: finding.category || finding.area || 'Performance',
        area: finding.area || finding.category || 'Performance',
        type: finding.type || 'Finding',
        finding_type: finding.finding_type || 'manual',
        severity: finding.severity || 'Medium',
        priority: finding.priority || finding.severity || 'Medium',
        confidence: finding.confidence || 'Moderate',
        status: finding.status || 'New',
        source: finding.source || finding.sourceArea || gActiveAction || 'Process Miner',
        sourceArea: finding.sourceArea || finding.source || gActiveAction || 'Process Miner',
        recommendation: finding.recommendation || '',
        action: finding.action || '',
        owner: finding.owner || '',
        targetDate: finding.targetDate || '',
        consultantNotes: finding.consultantNotes || finding.notes || '',
        automation_opportunity: !!finding.automation_opportunity,
        calculate_cost_impact: !!finding.calculate_cost_impact,
        filters,
        filterSummary: Array.isArray(finding.filterSummary) ? finding.filterSummary : filters.map(f => ({ type: f.label || f.type || 'Filter', description: f.description || '' })),
        finding_detail: Array.isArray(finding.finding_detail) ? finding.finding_detail : [],
        evidence,
        tasks: Number(finding.tasks ?? gTasksFiltered ?? gTaskArray.length ?? 0),
        events: Number(finding.events ?? gEventsFiltered ?? gEventLogArray.length ?? 0),
        percTasks: finding.percTasks ?? (gTasksTotal ? Number(finding.tasks ?? gTasksFiltered ?? gTaskArray.length ?? 0) / gTasksTotal : 0),
        percEvents: finding.percEvents ?? (gEventsTotal ? Number(finding.events ?? gEventsFiltered ?? gEventLogArray.length ?? 0) / gEventsTotal : 0),
        save_activities: !!finding.save_activities,
        save_steps: !!finding.save_steps,
        save_variants: !!finding.save_variants,
        filter_activities: finding.filter_activities || '',
        filter_variants: finding.filter_variants || '',
        filter_steps: finding.filter_steps || '',
        createdAt: finding.createdAt || now,
        updatedAt: now,
    };
}

function syncFindingToWorkspace(record) {
    const workspace = normaliseConsultingWorkspace(gConsultingWorkspace);
    const exists = (workspace.findings || []).some(f => String(f.id) === String(record.id) || String(f.findingID) === String(record.findingID));
    const compact = {
        id: record.id,
        findingID: record.findingID,
        title: record.title,
        finding: record.finding,
        area: record.area,
        severity: record.severity,
        priority: record.priority,
        confidence: record.confidence,
        status: record.status,
        sourceArea: record.sourceArea,
        evidence: record.evidence,
        recommendation: record.recommendation,
        action: record.action,
        owner: record.owner,
        targetDate: record.targetDate,
        consultantNotes: record.consultantNotes,
        filters: record.filters,
        tasks: record.tasks,
        events: record.events,
        createdAt: record.createdAt,
        updatedAt: record.updatedAt,
    };
    workspace.findings = exists
        ? (workspace.findings || []).map(f => (String(f.id) === String(record.id) || String(f.findingID) === String(record.findingID)) ? { ...f, ...compact } : f)
        : [compact, ...(workspace.findings || [])];
    workspace.updatedAt = new Date().toISOString();
    gConsultingWorkspace = normaliseConsultingWorkspace(workspace);
}

export async function updateFinding(finding, savedFindingID = '', source = '') {
    if (!finding) {
        console.warn('updateFinding called without a finding', { savedFindingID, source });
        return;
    }
    gSaveModel = true;
    const record = normaliseFindingRecord(finding, savedFindingID);
    const existingIndex = gFindings.findIndex(f => String(f.findingID) === String(record.findingID) || String(f.id) === String(record.id));
    if (existingIndex >= 0) gFindings[existingIndex] = { ...gFindings[existingIndex], ...record };
    else gFindings.push(record);
    syncFindingToWorkspace(record);
    if (gEventEmitter) {
        updateFindings({ eventEmitter: gEventEmitter });
    }
    return record;
}

export function processFindingsSummary() {
    const workspace = normaliseConsultingWorkspace(gConsultingWorkspace);
    const byKey = new Map();
    [...gFindings, ...(workspace.findings || [])].forEach(f => {
        const record = normaliseFindingRecord(f, f.findingID || f.finding_id || '');
        byKey.set(String(record.findingID || record.id), record);
    });
    return Array.from(byKey.values()).sort((a, b) => String(a.finding || '').localeCompare(String(b.finding || '')));
}

export function processFindingsSummaryRow(finding) {
    return normaliseFindingRecord(finding, finding?.findingID || finding?.finding_id || '');
}

export function deleteFinding(findingID) {
    gFindings = gFindings.filter(f => String(f.findingID) !== String(findingID) && String(f.id) !== String(findingID));
    const workspace = normaliseConsultingWorkspace(gConsultingWorkspace);
    workspace.findings = (workspace.findings || []).filter(f => String(f.findingID) !== String(findingID) && String(f.id) !== String(findingID));
    workspace.updatedAt = new Date().toISOString();
    gConsultingWorkspace = workspace;
    gSaveModel = true;
}

export function setFindingsEdited({ edited }) { gFindingsEdited = edited; }
export function getFindingsEdited() { return gFindingsEdited; }
export function saveFindingsGridState(columnState) { gFindingsGridState = columnState; }
export function getFindingsGridState() { return gFindingsGridState; }
export function updateFindingID(finding) {
    if (!finding) return;
    for (let j = 0; j < gFindings.length; j++) {
        if (String(gFindings[j].findingID) === String(finding.findingID)) gFindings[j].id = finding.id;
    }
}
export function setFindingDeleteRowData(type, row, id) { gCommentSelectedRow = { type, row, id }; }

export function downloadFinding(findingID) {
    const finding = processFindingsSummary().find(f => String(f.findingID) === String(findingID) || String(f.id) === String(findingID));
    if (!finding) return null;
    return finding;
}

export function editFindingModal(findingID) {
    const finding = processFindingsSummary().find(f => String(f.findingID) === String(findingID) || String(f.id) === String(findingID));
    if (!finding || !gEventEmitter) return;
    gEventEmitter.emit('openFindingModal', { data: { ...finding, mode: 'edit', source: 'editFinding', filterSummary: finding.filterSummary || [] } });
}
export function setFindingDetailProps(props = {}) { gFindingDetailProps = props; }
export function saveDiscoveryChildFindings() { return true; }

export function saveActionFromFinding(findingID) {
    const workspace = normaliseConsultingWorkspace(gConsultingWorkspace);
    const finding = (workspace.findings || []).find(f => String(f.findingID) === String(findingID) || String(f.id) === String(findingID));
    if (!finding) return workspace;
    const action = {
        id: `action_${Date.now()}`,
        findingId: finding.id || finding.findingID,
        title: finding.action || finding.recommendation || finding.title || finding.finding || 'New action',
        status: 'Proposed',
        priority: finding.priority || finding.severity || 'Medium',
        owner: finding.owner || '',
        targetDate: finding.targetDate || '',
        expectedValue: finding.valuePotential || 'Medium',
        effort: finding.effort || 'Medium',
        implementationSteps: finding.recommendation || '',
        notes: '',
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
    };
    workspace.actions = [action, ...(workspace.actions || [])];
    workspace.updatedAt = new Date().toISOString();
    gConsultingWorkspace = workspace;
    gSaveModel = true;
    return workspace;
}


export function fitPVDiagram() {
    gDiagramPV.startTransaction('rebuildPVDiagram');
    /*
    gDiagramPV.nodes.each(function (node) {
        if (
            node.visible &&
            !node.findLinksConnected().any(function (l) {
                return l.isVisible();
            })
        ) {
            node.visible = false;
        }
    });
    */
    layout();

    gDiagramPV.commitTransaction('rebuildPVDiagram');
    gDiagramPV.requestUpdate();

    if (gEnvironment != 'JiraForge') {gDiagramPV.layout.layerSpacing = gSpacingLayer}
    gDiagramPV.layout.columnSpacing = gSpacingColumn;
    gDiagramPV.zoomToFit();
}

export function rebuildPVDiagram(source) {
    gDiagramPV.startTransaction('rebuildPVDiagram');
    gDiagramPV.model.linkDataArray = generateLinks('variants');
    gDiagramPV.model.nodeDataArray= generateNodes('variants');
    
    gDiagramPV.nodes.each(function (node) {
        if (
            node.visible &&
            !node.findLinksConnected().any(function (l) {
                return l.isVisible();
            })
        ) {
            node.visible = false;
        }
    });

    layout();

    if (gAnimateVariant != 0 && activePane === SidebarTab.variantsTab) {
        animateVariant();
    }

    stopLifecycleAnimation(gDiagramPV);
    if (gLifecycleVariant != 0 && activePane === SidebarTab.variantsTab) {
        animateLifecycleVariant(generateLifeCycleArray(), gDiagramPV, gAnimateColor);
    }

    gDiagramPV.commitTransaction('rebuildPVDiagram');
    gDiagramPV.requestUpdate();
    gDiagramPV.layout.layerSpacing = parseInt(gSpacingLayer);
    gDiagramPV.layout.columnSpacing = parseInt(gSpacingColumn);
    gDiagramPV.layout.direction = gProcessFlowDirection;

    if (gRebuildCtr >= 1) {
        gInitialLoad = false;
    }
    gRebuildCtr++;
    gDiagramPV.zoomToFit();  
}

export function rebuildDecompositionTreeDiagram(defaultNodeArray) {
    gDiagramDecompositionTree.startTransaction('rebuildDecompositionTreeDiagram');
    gDiagramDecompositionTree.model.nodeDataArray = defaultNodeArray;
    gDiagramDecompositionTree.model.linkDataArray = [];
    gDiagramDecompositionTree.commitTransaction('rebuildDecompositionTreeDiagram');
    gDiagramDecompositionTree.requestUpdate();
}

export const requestZoomSliderUpdate = () => {
    if (gZoomSlider) {
        gZoomSlider.remove();
    }

    gZoomSlider = new ZoomSlider(gDiagramPV, {
        alignment: go.Spot.BottomLeft,
        alignmentFocus: go.Spot.BottomLeft,
        size: 150,
        buttonSize: 25,
        orientation: 'horizontal',
    });
};

function animateVariant() {
    // Animate the flow in the pipes
    let animation = new go.Animation();
    animation.easing = go.Animation.EaseLinear;
    gDiagramPV.links.each(function (link) {
        if (link.data.animate == true) {
            animation.add(link.path, 'strokeDashOffset', 15, 1);
        }
    });

    // Run indefinitely
    animation.runCount = Infinity;
    animation.start();
}

export const updateDiagramColors = ({
    linkColor,
    selectLinkColor,
    animateColor,
    loopColor,
    visualizerBackgroundColor,
    startNodeColor,
    endNodeColor,
}) => {
    gColorStartNode = startNodeColor || gColorStartNode;
    gColorEndNode = endNodeColor || gColorEndNode;
    gColorLink = linkColor || gColorLink;
    gColorLinkSelect = selectLinkColor || gColorLinkSelect;
    gAnimateColor = animateColor || gAnimateColor;
    gLoopColor = loopColor || gLoopColor;
    gVisualizerBackgroundColor = visualizerBackgroundColor || gVisualizerBackgroundColor;
};

export const defaultMinMaxTime = () => {
    resetMinMaxTimes();
    return {
        min_time: gFromTime,
        max_time: gToTime,
    };
};

// reset filters

export async function resetFilters(reGenerateArrays,source) {  

    gSaveModel = true
    for (let i = 0; i < gVariantArray.length; i++) {
        gVariantArray[i].filtered = 0;
    }
    for (let i = 0; i < gEventLogArray.length; i++) {
        gEventLogArray[i].filtered = 0;
    }
    for (let i = 0; i < gTaskArray.length; i++) {
        gTaskArray[i].filtered = 0;
    }
    for (let i = 0; i < gLinkArray.length; i++) {
        gLinkArray[i].filtered = 0;
    }
    for (let i = 0; i < gActivityArray.length; i++) {
        gActivityArray[i].filtered = 0;
    }

    gAttribute = '';
    gAttributeType = '';
    gEventsFiltered = gEventsAll;
    gTasksFiltered = gTasksAll;
    gVariantsFiltered = gVariantsAll;
    gStepsFiltered = gStepsAll;
    gActivitiesFiltered = gActivitiesAll;

    gFilters = [];
    gFilterSets = 0;
    gTaskFilterAttributes = [];
    gTaskFilterTime = [];
    gTaskFilterTasks = [];
    gFilterConditions = [];

    updateVariantMetrics() 
    if (reGenerateArrays === true) {
        generateArrays(false, false, 'resetFilters','');
        updateSlicedVariables();
        updateAttributes();
        generateTaskAnalyticsArray();
        generateEventAnalyticsArray();
    }

};

export const resetTimeFilterDefaults = () => {
    resetMinMaxTimes();
    return [gFromTime, gToTime];
};

export const setAttributesFilter = (selectedAttributes) => {
    gSelectedAttributes = selectedAttributes;
};

function filterConditions(type,timeType) {
    let valueArrayPush = {};
    let vtp = {};
    if (type == 'attributes') {
        gTaskFilterAttributes = []
        vtp = {};
        vtp['attribute'] = gAttribute;
        vtp['attributeType'] = gAttributeType;
        let valueArray = [];
        for (let i = 0; i < gSelectedAttributes.length; i++) {
            valueArrayPush = {};
            valueArrayPush['value'] = gSelectedAttributes[i].value;
            valueArray.push(valueArrayPush);
        }
        vtp['values'] = valueArray;
        gTaskFilterAttributes.push(vtp);

        let attributeStr = '';
        for (let j = 0; j < gTaskFilterAttributes[gTaskFilterAttributes.length - 1].values.length; j++) {
            if (j > 0) {
                attributeStr = attributeStr + ', ';
            }
            attributeStr = attributeStr + gTaskFilterAttributes[gTaskFilterAttributes.length - 1].values[j].value;
        }
        vtp = {};
        vtp['type'] = 'filter';    
        vtp['sub_type'] = 'attribute'; 
        vtp['label'] = 'Filter - Attributes';     
        vtp['description'] =
            gTaskFilterAttributes[gTaskFilterAttributes.length - 1].attributeType +
            ' - ' +
            gTaskFilterAttributes[gTaskFilterAttributes.length - 1].attribute +
            ': ' +
            attributeStr;
        vtp['attribute'] = gAttribute;
        vtp['attribute_type'] = gAttributeType;
        vtp['task_filter_attributes'] = gTaskFilterAttributes;
        vtp['steps'] = [];
        vtp['activities'] = [];
        vtp['variants'] = [];
        vtp['id'] = gFilterSets
        gFilterConditions.push(vtp);
    }
    if (type == 'time') {
        vtp = {};
        let description = ''
        if (timeType === getEntityUpper()) description = gEntityUpper + 's created between ' + gFromTime + ' and ' + gToTime;
        if (timeType === 'Event') description = gEntityUpper + 's with events between ' + gFromTime + ' and ' + gToTime;

        vtp['description'] = description
        vtp['type'] = 'filter';    
        vtp['sub_type'] = 'time';
        vtp['label'] = 'Filter - Time';     
        vtp['time_type'] = timeType;
        vtp['from_time'] = gFromTime;
        vtp['to_time'] = gToTime;
        vtp['steps'] = [];
        vtp['activities'] = [];
        vtp['variants'] = [];
        vtp['id'] = gFilterSets
        gFilterConditions.push(vtp);

        vtp = {};
        gTaskFilterTime.push(vtp);
    }
}

export async function processFilters(filterProps, source, countOnly) {   
    let loadDiscoveryRules = false
    if (source === 'loadDiscoveryRules') loadDiscoveryRules = true
    if (source === 'processDiscoveryRules') loadDiscoveryRules = false
    for (let i = 0; i < filterProps.length; i++) {

        startTime = Date.now()
        if (filterProps[i].type === 'filter' && filterProps[i].sub_type == 'variant') {
            gFilterSelectedVariants = filterProps[i].variants
            applyVariantFilter(filterProps[i],loadDiscoveryRules,countOnly);  
        }

        if (filterProps[i].type === 'filter' && filterProps[i].sub_type == 'variant_discovery') {
            applyVariantDiscoveryFilter(filterProps[i],loadDiscoveryRules,countOnly);  // only ever called for a discovery-child whose parent relates to a variant discovery
        }
        if (filterProps[i].type === 'filter' && filterProps[i].sub_type == 'workflow') {
            applyWorkflowFilter(filterProps[i],loadDiscoveryRules,countOnly);  
        }
        if (filterProps[i].type === 'filter' && filterProps[i].sub_type == 'variant_similar') {
            applySimilarVariantFilter(filterProps[i],loadDiscoveryRules,countOnly);  
        }
        if (filterProps[i].type === 'filter' && filterProps[i].sub_type == 'activity') {
            gActivitySelectOperator = filterProps[i].operator
            gActivitySelectRetention = filterProps[i].retention
            gFilterSelectedActivities = filterProps[i].activities
            applyActivityFilter(filterProps[i],loadDiscoveryRules,countOnly);
        }

        if (filterProps[i].type === 'filter' && filterProps[i].sub_type == 'step') {
            gStepSelectOperator = filterProps[i].operator
            gStepSelectRetention = filterProps[i].retention
            gFilterSelectedSteps = filterProps[i].steps
            applyStepFilter(filterProps[i],loadDiscoveryRules,countOnly);
        }
        if (filterProps[i].type === 'filter' && filterProps[i].sub_type == 'path') {
            gPathFrom = filterProps[i].path_from
            gPathTo =filterProps[i].path_to
            gPathPredicate = filterProps[i].predicate
            gPathSelectRetention = filterProps[i].retention
            applyPathFilter(filterProps[i],loadDiscoveryRules,countOnly);
        }
        if (filterProps[i].type === 'filter' && filterProps[i].sub_type == 'attribute') {
            gAttribute = filterProps[i].attribute;
            gAttributeType = filterProps[i].attribute_type;
            gSelectedAttributes = []
            for (let j = 0; j < filterProps[i].task_filter_attributes[0].values.length; j++) {
                gSelectedAttributes.push(filterProps[i].task_filter_attributes[0].values[j])
            }
            gTaskFilterAttributes = filterProps[i].task_filter_attributes;
            applyAttributesFilter(gAttribute, gAttributeType,source,loadDiscoveryRules,countOnly);
        }
        // process event attributes filter
        if (filterProps[i].type === 'filter' && filterProps[i].sub_type == 'time') {
            gFromTime = filterProps[i].from_time;
            gToTime = filterProps[i].to_time;
       
            applyTimeFilter(gFromTime, gToTime, filterProps[i].time_type, loadDiscoveryRules,countOnly);
        }
        if (filterProps[i].type === 'discovery' && (filterProps[i].sub_type == 'variants' || filterProps[i].sub_type == 'activities' || filterProps[i].sub_type == 'steps'   )) { 
            applyDiscovery(filterProps[i].routes, loadDiscoveryRules,countOnly)
        }
    }
    if (source === 'loadDiscoveryRules' || source === 'processDiscoveryRules') updateDiscoveryRules({ eventEmitter: gEventEmitter });

};

export const applyMetricsFilter = (attribute, attributeType,loadDiscoveryRules,countOnly) => {
    gSaveModel = true
    
    let tasksFiltered = countFilteredTasks()
    if (tasksFiltered > 0) {

        filterConditions('attributes','');
        generateArrays(true, false, 'applyMetricsFilter', loadDiscoveryRules );
        setFilterIcon({ eventEmitter: gEventEmitter });
        alertMessage({
            eventEmitter: gEventEmitter,
            message: tasksFiltered +  ' issues match the filter',
            severity: 'success',
            showAlert: true,
            timeOutActive: true,
            component: 'metricFilter',
        });
    } else {
        gFilterSets--;
        alertMessage({
            eventEmitter: gEventEmitter,
            message: 'No matching issues',
            severity: 'info',
            showAlert: true,
            timeOutActive: true,
            component: 'metricFilter',
        });
    }
};


export const applyAttributesFilter = (attribute, attributeType,loadDiscoveryRules,countOnly) => {
    gSaveModel = true
    gAttribute = attribute;
    gAttributeType = attributeType;
    if (gAttributeType == gEntityUpper) {
        filterAttributesTasks();
    }
    if (gAttributeType == 'Event') {
        filterAttributesEvents();
    }
    let tasksFiltered = countFilteredTasks()
    if (tasksFiltered > 0) {

        filterConditions('attributes','');
        generateArrays(true, false, 'applyAttributesFilter', loadDiscoveryRules );
        setFilterIcon({ eventEmitter: gEventEmitter });
        alertMessage({
            eventEmitter: gEventEmitter,
            message: tasksFiltered +  ' issues match the filter',
            severity: 'success',
            showAlert: true,
            timeOutActive: true,
            component: 'attributeFilter',
        });
    } else {
        gFilterSets--;
        alertMessage({
            eventEmitter: gEventEmitter,
            message: 'No matching issues',
            severity: 'info',
            showAlert: true,
            timeOutActive: true,
            component: 'attributeFilter',
        });
    }
};

export const countFilteredTasks = () => {
    gFilters.sort((a, b) => a.task.localeCompare(b.task) || a.filter_number - b.filter_number );
    let filtered_tasks = 0
    let tasks = 0
    let task
    let filter_number
    let i = 0
    for (i = 0; i < gFilters.length; i++) {
        if (i > 0 && gFilters[i].task !== task) {
            if (tasks === gFilterSets) filtered_tasks ++ 
            tasks = 1
        } else {
            if (gFilters[i].filter_number != filter_number) tasks ++
        }
        
        task = gFilters[i].task
        filter_number = gFilters[i].filter_number

    }
    if (tasks === gFilterSets) filtered_tasks ++ 
    return filtered_tasks
}

export async function applyDiscovery (routesDataArray,loadDiscoveryRules,countOnly) {  
    gSaveModel = true
    startTime = Date.now();
    let routesData = [...routesDataArray]
    let sets = 1
    gVariantArray.sort((a, b) => a.id - b.id);
    gTaskArray.sort((a, b) => a.id - b.id);

    let temp = 0
    for (let j = 0; j < gVariantArray.length; j++) { 
        temp = temp + gVariantArray[j].t
    }
    let variantsDiscovered = []
    let activitiesDiscovered = []
    let stepsDiscovered = []
    let startNode = 0;
    let endNode = 0;
    for (let j = 0; j < gActivityArray.length; j++) {
        if (gActivityArray[j].start_node == true) startNode = gActivityArray[j].id;
        if (gActivityArray[j].end_node == true) endNode = gActivityArray[j].id;
    }
    for (let i = 0; i < routesData.length; i++) {
        if (i > 0 && routesData[i].logic === 'and') sets ++
        routesData[i].from = parseFloat(routesData[i].from)
        routesData[i].to = parseFloat(routesData[i].to)
        if (routesData[i].filter === (gEntityUpper + 's') || routesData[i].filter === 'Steps' || routesData[i].filter === 'Loops') routesData[i].time = ''

        if (routesData[i].type === 'Variants') {

            let relativeArray = []
            if (routesData[i].relative === 'longest duration percentile' 
                || routesData[i].relative === 'shortest duration percentile'
                || routesData[i].relative === 'longest std deviation percentile'
                || routesData[i].relative === 'shortest std deviation percentile'
            ) { 

                let tempVariantArray = []
                for (let k = 0; k < gVariantArray.length; k++) { 
                    tempVariantArray.push(gVariantArray[k])
                }
                let q = routesData[i].from/100  // percentile
                if (routesData[i].relative === 'longest duration percentile') { 
                    tempVariantArray.sort((a, b) => b.ad - a.ad);
                }
                if (routesData[i].relative === 'shortest duration percentile') { 
                    tempVariantArray.sort((a, b) => a.ad - b.ad);
                }
                if (routesData[i].relative === 'longest std deviation percentile') { 
                    tempVariantArray.sort((a, b) => b.sd - a.sd);
                }
                if (routesData[i].relative === 'shortest std deviation percentile') { 
                    tempVariantArray.sort((a, b) => a.sd - b.sd);
                }
                const pos = (tempVariantArray.length - 1) * q
                const percentilePos = Math.floor(pos);
                for (let k = 0; k < tempVariantArray.length; k++) { 
                    if (k <= percentilePos) relativeArray.push(tempVariantArray[k])
                }
            }
            for (let j = 0; j < gVariantArray.length; j++) { 
                let validVariant = false
                if (routesData[i].filter === (gEntityUpper + 's')) if (checkVolume(routesData[i].operator,routesData[i].from,routesData[i].to,'',gVariantArray[j].t) === true) {validVariant = true}
                if (routesData[i].filter === 'Avg Duration') if (checkVolume(routesData[i].operator,routesData[i].from,routesData[i].to,routesData[i].time,gVariantArray[j].ad) === true) {validVariant = true}
                if (routesData[i].filter === 'Std Deviation') if (checkVolume(routesData[i].operator,routesData[i].from,routesData[i].to,routesData[i].time,gVariantArray[j].sd) === true) {validVariant = true}
                if (routesData[i].filter === 'Activities') if (checkVolume(routesData[i].operator,routesData[i].from,routesData[i].to,'',gVariantArray[j].activities) === true) {validVariant = true}
                if (routesData[i].filter === 'Steps') if (checkVolume(routesData[i].operator,routesData[i].from,routesData[i].to,'',gVariantArray[j].steps) === true) {validVariant = true}
                if (routesData[i].filter === 'Loops') if (checkVolume(routesData[i].operator,routesData[i].from,routesData[i].to,'',gVariantArray[j].loops) === true) {validVariant = true}
                if (routesData[i].filter === 'Min Duration') if (checkVolume(routesData[i].operator,routesData[i].from,routesData[i].to,'',gVariantArray[j].min_duration) === true) {validVariant = true}
                if (routesData[i].filter === 'Max Duration') if (checkVolume(routesData[i].operator,routesData[i].from,routesData[i].to,'',gVariantArray[j].max_duration) === true) {validVariant = true}

                
                if (routesData[i].filter === 'Relative') { 
                    //check if variant is in relative array
                    for (let k = 0; k < relativeArray.length; k++) { 
                        if (relativeArray[k].id === gVariantArray[j].id ) validVariant = true
                    }
                }

                if (validVariant === true) {
                    let vtp = {};
                    vtp['id'] = gVariantArray[j].id
                    vtp['variant'] = gVariantArray[j].n
                    vtp[gEntityUpper + 's'] = gVariantArray[j].t
                    vtp['avg_duration'] = gVariantArray[j].ad
                    vtp['std_deviation'] = gVariantArray[j].sd
                    variantsDiscovered.push(vtp)
                }
            }
        }
        if (routesData[i].type === 'Steps') {  

            let relativeArray = []
            if (routesData[i].relative === 'longest duration percentile' 
                || routesData[i].relative === 'shortest duration percentile'
                || routesData[i].relative === 'longest std deviation percentile'
                || routesData[i].relative === 'shortest std deviation percentile'
            ) { 

                let tempStepArray = []
                for (let k = 0; k < gStepArray.length; k++) { 
                    if (parseInt(gStepArray[k].from) !== parseInt(startNode) && parseInt(gStepArray[k].to) !== parseInt(endNode)) tempStepArray.push(gStepArray[k])
                }
                let q = routesData[i].from/100  // percentile
                if (routesData[i].relative === 'longest duration percentile') { 
                    tempStepArray.sort((a, b) => b.avg_duration - a.avg_duration);
                }
                if (routesData[i].relative === 'shortest duration percentile') { 
                    tempStepArray.sort((a, b) => a.avg_duration - b.avg_duration);
                }
                if (routesData[i].relative === 'longest std deviation percentile') { 
                    tempStepArray.sort((a, b) => b.std_deviation - a.std_deviation);
                }
                if (routesData[i].relative === 'shortest std deviation percentile') { 
                    tempStepArray.sort((a, b) => a.std_deviation - b.std_deviation);
                }
                const pos = (tempStepArray.length - 1) * q
                const percentilePos = Math.floor(pos);
                for (let k = 0; k < tempStepArray.length; k++) { 
                    if (k <= percentilePos) relativeArray.push(tempStepArray[k])
                }
            }

            for (let j = 0; j < gStepArray.length; j++) { 
                if (parseInt(gStepArray[j].to) !== parseInt(endNode)) {
                    let validStep = false
                    if (routesData[i].filter === (gEntityUpper + 's')) if (checkVolume(routesData[i].operator,routesData[i].from,routesData[i].to,'',gStepArray[j].tasks) === true) {validStep = true}
                    if (routesData[i].filter === 'Avg Duration') if (checkVolume(routesData[i].operator,routesData[i].from,routesData[i].to,routesData[i].time,gStepArray[j].avg_duration) === true) {validStep = true}
                    if (routesData[i].filter === 'Std Deviation') if (checkVolume(routesData[i].operator,routesData[i].from,routesData[i].to,routesData[i].time,gStepArray[j].std_deviation) === true) {validStep = true}
                    if (routesData[i].filter === 'avg_customer_comments') if (checkVolume(routesData[i].operator,routesData[i].from,routesData[i].to,'',gStepArray[j].tasks_comments_customer/gStepArray[j].tasks) === true) {validStep = true}
                    if (routesData[i].filter === 'avg_internal_comments') if (checkVolume(routesData[i].operator,routesData[i].from,routesData[i].to,'',gStepArray[j].tasks_comments_internal/gStepArray[j].tasks) === true) {validStep = true}
                    if (routesData[i].filter === 'avg_timespent') if (checkVolume(routesData[i].operator,routesData[i].from,routesData[i].to,'',gStepArray[j].time_spent/gStepArray[j].tasks) === true) {validStep = true}
                    if (routesData[i].filter === 'Relative') { 
                        //check if step is in relative array
                        for (let k = 0; k < relativeArray.length; k++) { 
                            if (relativeArray[k].id === gStepArray[j].id ) validStep = true
                        }
                    }

                    if (validStep === true) {
                        let vtp = {};
                        vtp['id'] = gStepArray[j].id
                        vtp['step'] = gStepArray[j].step
                        vtp['from'] = gStepArray[j].from
                        vtp['to'] = gStepArray[j].to
                        vtp['from_label'] = gStepArray[j].from_label
                        vtp['to_label'] = gStepArray[j].to_label
                        vtp[gEntityUpper + 's'] = gStepArray[j].tasks
                        vtp['avg_duration'] = gStepArray[j].avg_duration
                        vtp['std_deviation'] = gStepArray[j].std_deviation
                        stepsDiscovered.push(vtp)
                    }
                }
            }
        }
        if (routesData[i].type === 'Activities') {

            let relativeArray = []
            if (routesData[i].relative === 'longest duration percentile' 
                || routesData[i].relative === 'shortest duration percentile'
                || routesData[i].relative === 'longest std deviation percentile'
                || routesData[i].relative === 'shortest std deviation percentile'
            ) { 

                let tempActivityArray = []
                for (let k = 0; k < gActivityArray.length; k++) { 
                    if (parseInt(gActivityArray[k].id) !== parseInt(startNode) && parseInt(gActivityArray[k].id) !== parseInt(endNode)) tempActivityArray.push(gActivityArray[k])
                }
                let q = routesData[i].from/100  // percentile
                if (routesData[i].relative === 'longest duration percentile') { 
                    tempActivityArray.sort((a, b) => b.avg_duration - a.avg_duration);
                }
                if (routesData[i].relative === 'shortest duration percentile') { 
                    tempActivityArray.sort((a, b) => a.avg_duration - b.avg_duration);
                }
                if (routesData[i].relative === 'longest std deviation percentile') { 
                    tempActivityArray.sort((a, b) => b.std_deviation - a.std_deviation);
                }
                if (routesData[i].relative === 'shortest std deviation percentile') { 
                    tempActivityArray.sort((a, b) => a.std_deviation - b.std_deviation);
                }
                const pos = (tempActivityArray.length - 1) * q
                const percentilePos = Math.floor(pos);
                for (let k = 0; k < tempActivityArray.length; k++) { 
                    if (k <= percentilePos) relativeArray.push(tempActivityArray[k])
                }
            }

            for (let j = 0; j < gActivityArray.length; j++) { 
                if (parseInt(gActivityArray[j].id) !== parseInt(startNode) && parseInt(gActivityArray[j].id) !== parseInt(endNode)) {
                    let validActivity = false
                    if (routesData[i].filter === (gEntityUpper + 's')) if (checkVolume(routesData[i].operator,routesData[i].from,routesData[i].to,'',gActivityArray[j].tasks) === true) {validActivity = true}
                    if (routesData[i].filter === 'Avg Duration') if (checkVolume(routesData[i].operator,routesData[i].from,routesData[i].to,routesData[i].time,gActivityArray[j].avg_duration) === true) {validActivity = true}
                    if (routesData[i].filter === 'Std Deviation') if (checkVolume(routesData[i].operator,routesData[i].from,routesData[i].to,routesData[i].time,gActivityArray[j].std_deviation) === true) {validActivity = true}

                    if (routesData[i].filter === 'Relative') { 
                        //check if step is in relative array
                        for (let k = 0; k < relativeArray.length; k++) { 
                            if (relativeArray[k].id === gActivityArray[j].id ) validActivity = true
                        }
                    }

                    if (validActivity === true) {
                        let vtp = {};   
                        vtp['id'] = gActivityArray[j].id
                        vtp['activity'] = gActivityArray[j].activity 
                        vtp[gEntityUpper + 's'] = gActivityArray[j].tasks
                        vtp['avg_duration'] = gActivityArray[j].avg_duration
                        vtp['std_deviation'] = gActivityArray[j].std_deviation
                        activitiesDiscovered.push(vtp)
                    } 
                }
            }
        }
    }

    gFilterSets++;

    let uniqueStepsDiscovered = []
    let uniqueActivitiesDiscovered = []
    let uniqueVariantsDiscovered = []
    if (routesData[0].type === 'Steps') {
        startTime = Date.now()
        stepsDiscovered.sort((a, b) => a.id - b.id);    
        let steps = 0
        let id 
        let i
        for (i = 0; i < stepsDiscovered.length; i++) {
            if (i > 0 && stepsDiscovered[i].id != id ) {
                if (steps === sets) uniqueStepsDiscovered.push(stepsDiscovered[i-1])
                steps = 0
            }
            steps ++ 
            id = stepsDiscovered[i].id
        }
        if (steps === sets) uniqueStepsDiscovered.push(stepsDiscovered[i-1])

        for (i = 0; i < gStepArray.length; i++) {
            gStepArray[i].discovered = false
            for (let j = 0; j < uniqueStepsDiscovered.length; j++) {
                if (uniqueStepsDiscovered[j].id === gStepArray[i].id) {
                    gStepArray[i].discovered = true
                    break
                }    
            }
        }

        let gEventLogStepArray = [...gEventLogArray.sort((a, b) => a.filtered - b.filtered || a.f - b.f || a.t - b.t || a.k.localeCompare(b.k))]; 
        let gEventLogFilterArray = [...gEventLogArray.sort((a, b) => a.elid - b.elid)];
        gStepArray.sort((a, b) => a.id - b.id)
        let k = ''
        let skipToNext = false
        for (let i = 0; i < gEventLogStepArray.length; i++) {
            if (gEventLogStepArray[i].filtered === 1) break
            if (gStepArray[gEventLogStepArray[i].sid].discovered === true
                && gEventLogStepArray[i].k !== k
                && skipToNext === false
            ) {
                for (let j = gTaskArray[gEventLogStepArray[i].tid].si; j < gTaskArray[gEventLogStepArray[i].tid].fi + 1; j++) {  // 
                    let vtp = {};
                    vtp['type'] = 'discovery';    
                    vtp['sub_type'] = 'steps';    
                    vtp['label'] = 'Discovery - Steps';
                    vtp['filter_number'] = gFilterSets;
                    vtp['id'] = gEventLogFilterArray[j].elid;
                    vtp['duration'] = gEventLogFilterArray[j].d;
                    vtp['task'] = gEventLogFilterArray[j].k;
                    gFilters.push(vtp);
                }
                skipToNext === true
                k = gEventLogStepArray[i].k
            }
        }
    }

    if (routesData[0].type === 'Activities') { 
        activitiesDiscovered.sort((a, b) => a.id - b.id);    
        let activities = 0
        let id 
        let i
        for (i = 0; i < activitiesDiscovered.length; i++) {
            if (i > 0 && activitiesDiscovered[i].id != id ) {
                if (activities === sets) uniqueActivitiesDiscovered.push(activitiesDiscovered[i-1])
                    activities = 0
            }
            activities ++ 
            id = activitiesDiscovered[i].id
        }
        if (activities === sets) uniqueActivitiesDiscovered.push(activitiesDiscovered[i-1])

        for (i = 0; i < gActivityArray.length; i++) {
            gActivityArray[i].discovered = false
            for (let j = 0; j < uniqueActivitiesDiscovered.length; j++) {
                if (uniqueActivitiesDiscovered[j].id === gActivityArray[i].id) {
                    gActivityArray[i].discovered = true
                    break
                }    
            }
        }

        let gEventLogActivityArray = [...gEventLogArray.sort((a, b) => a.filtered - b.filtered || a.k.localeCompare(b.k))]; 
        let gEventLogFilterArray = [...gEventLogArray.sort((a, b) => a.elid - b.elid)];
        gActivityArray.sort((a, b) => a.id - b.id)

        let k = ''
        let skipToNext = false
        for (let i = 0; i < gEventLogActivityArray.length; i++) { 
            if (gEventLogActivityArray[i].filtered === 1) break
            if (gActivityArray[gEventLogActivityArray[i].faid].discovered === true
                && gEventLogActivityArray[i].k !== k
                && skipToNext === false
            ) {
                for (let j = gTaskArray[gEventLogActivityArray[i].tid].si; j < gTaskArray[gEventLogActivityArray[i].tid].fi + 1; j++) {  // 
                    let vtp = {};
                    vtp['type'] = 'discovery';    
                    vtp['sub_type'] = 'activities';    
                    vtp['label'] = 'Discovery - Activities';
                    vtp['filter_number'] = gFilterSets;
                    vtp['id'] = gEventLogFilterArray[j].elid;
                    vtp['duration'] = gEventLogFilterArray[j].d;
                    vtp['task'] = gEventLogFilterArray[j].k;
                    gFilters.push(vtp);
                }
                skipToNext === true
                k = gEventLogActivityArray[i].k
            }
        }
    }

    if (routesData[0].type === 'Variants') {  

        // filter unique variants discovered
        variantsDiscovered.sort((a, b) => a.id - b.id);    
        let variants = 0
        let id 
        let i
        for (i = 0; i < variantsDiscovered.length; i++) {
            if (i > 0 && variantsDiscovered[i].id != id ) {
                if (variants === sets) uniqueVariantsDiscovered.push(variantsDiscovered[i-1])
                    variants = 0
            }
            variants ++ 
            id = variantsDiscovered[i].id
        }
        if (variants === sets) uniqueVariantsDiscovered.push(variantsDiscovered[i-1])  

        // update gVariantArray with selected flag
        for (i = 0; i < gVariantArray.length; i++) {
            gVariantArray[i].discovered = false
            for (let j = 0; j < uniqueVariantsDiscovered.length; j++) {
                if (uniqueVariantsDiscovered[j].id === gVariantArray[i].id) {
                    gVariantArray[i].discovered = true
                    break
                }

            }
        }
        
        let gEventLogVariantArray = [...gEventLogArray.sort((a, b) => a.filtered - b.filtered || a.v - b.v || a.k.localeCompare(b.k))]; 
        let gEventLogFilterArray = [...gEventLogArray.sort((a, b) => a.elid - b.elid)];
        gVariantArray.sort((a, b) => a.id - b.id)

        let k = ''
        let skipToNext = false

        for (let i = 0; i < gEventLogVariantArray.length; i++) {
            if (gEventLogVariantArray[i].filtered === 1) break
            if (gVariantArray[gEventLogVariantArray[i].vid].discovered === true && gEventLogVariantArray[i].k !== k && skipToNext === false) {
                for (let j = gTaskArray[gEventLogVariantArray[i].tid].si; j < gTaskArray[gEventLogVariantArray[i].tid].fi + 1; j++) {   
                    let vtp = {};
                    vtp['type'] = 'discovery';    
                    vtp['sub_type'] = 'variants';    
                    vtp['label'] = 'Discovery - Variants';
                    vtp['filter_number'] = gFilterSets;
                    vtp['id'] = gEventLogFilterArray[j].elid;
                    vtp['duration'] = gEventLogFilterArray[j].d;
                    vtp['task'] = gEventLogFilterArray[j].k;
                    gFilters.push(vtp);
                    ctr ++
                }
                skipToNext === true
                k = gEventLogVariantArray[i].k
            }
        }
    }

    let tasksFiltered = countFilteredTasks() 

    gUniqueVariantsDiscovered = [...new Set(uniqueVariantsDiscovered)] 
    gUniqueStepsDiscovered = [...new Set(uniqueStepsDiscovered)]
    gUniqueActivitiesDiscovered = [...new Set(uniqueActivitiesDiscovered)]
 
    if (countOnly === true) { 

        let events = 0
        for (let i = 0; i < gFilters.length; i++) {
            if (gFilters[i].filter_number == gFilterSets) events ++
        }
        gFilterStats = []

        let vtp = [];
        vtp['tasks'] = tasksFiltered
        vtp['events'] = events - tasksFiltered  // removes the 'to end' event
        gFilterStats.push(vtp);   
        return
    }

    if (tasksFiltered > 0) {

        let descriptionStr = ''
        if (routesData[0].type === 'Variants') descriptionStr = 'Variants: ' 
        if (routesData[0].type === 'Steps') descriptionStr = 'Steps: ' 
        if (routesData[0].type === 'Activities') descriptionStr = 'Activities: ' 

        let sets = 1
        for (let i = 0; i < routesData.length; i++) {

            let valueStr
            if (
                routesData[i].operator === 'between' ||
                routesData[i].operator === 'between or is' ||
                routesData[i].operator === 'outside' ||
                routesData[i].operator === 'outside or is'
            ) {
                valueStr = routesData[i].operator + ' ' + routesData[i].from + ' and ' + routesData[i].to 
            } else {
                valueStr = routesData[i].operator + ' ' + routesData[i].from 
            }
            if (routesData[i].filter === 'Avg Duration' || routesData[i].filter === 'Std Deviation') valueStr = valueStr + ' ' + routesData[i].time ;

            if (i > 0 && routesData[i].logic === 'and') {
                sets ++
                descriptionStr = descriptionStr + ' and ('
            }
            descriptionStr = descriptionStr + routesData[i].filter + ' ' + valueStr


            if (i > 0 && routesData[i].logic === 'or') {
                descriptionStr = descriptionStr + ' or ' + descriptionStr 
            }
        }
        if (sets > 1) descriptionStr =  descriptionStr + ')'

        let vtp = {};
        vtp['type'] = 'discovery';    
        if (routesData[0].type === 'Variants') {
            vtp['sub_type'] = 'variants';    
            vtp['label'] = 'Discovery - Variants';
            vtp['variants'] = [...new Set(uniqueVariantsDiscovered)];
            vtp['activities'] = [...new Set(uniqueActivitiesDiscovered)]; 
            vtp['steps'] = [...new Set(uniqueStepsDiscovered)];
        }
        if (routesData[0].type === 'Steps') {
            vtp['sub_type'] = 'steps';    
            vtp['label'] = 'Discovery - Steps';
            vtp['variants'] = [...new Set(uniqueVariantsDiscovered)];
            vtp['activities'] = [...new Set(uniqueActivitiesDiscovered)]; 
            vtp['steps'] = [...new Set(uniqueStepsDiscovered)];
        }
        if (routesData[0].type === 'Activities') {
            vtp['sub_type'] = 'activities';    
            vtp['label'] = 'Discovery - Activities';
            vtp['variants'] = [...new Set(uniqueVariantsDiscovered)];
            vtp['activities'] = [...new Set(uniqueActivitiesDiscovered)]; 
            vtp['steps'] = [...new Set(uniqueStepsDiscovered)];
        }   

        vtp['routes'] = routesData
        vtp['description'] = descriptionStr
        vtp['id'] = gFilterSets
        gFilterConditions.push(vtp);

        generateArrays(true, false, 'applyDiscovery', loadDiscoveryRules);

        setDiscoveryIcon({ eventEmitter: gEventEmitter });
        alertMessage({
            eventEmitter: gEventEmitter,
            message: tasksFiltered +  ' issues match the discovery',
            severity: 'success',
            showAlert: true,
            timeOutActive: true,
            component: 'discoveryConstraint',
        });  
        setDiscoveryIcon({ eventEmitter: gEventEmitter });
        
    } else {
        gFilterSets--;
        alertMessage({
            eventEmitter: gEventEmitter,
            message: 'No matching issues',
            severity: 'info',
            showAlert: true,
            timeOutActive: true,
            component: 'discoveryConstraint',
        });
    }
    return tasksFiltered
}

export async function  applyStepFilter (filterProps, loadDiscoveryRules, countOnly) {     
    gSaveModel = true
    gFilterSets++;
    gTaskArray.sort((a, b) => a.id - b.id);
    // include, exclude ?? gStepSelectRetention
    if (gStepSelectRetention === 'exclude') {
        gEventLogArray.sort((a, b) => a.elid - b.elid);
        for (let k = 0; k < gFilterSelectedSteps.length; k++) {
            for (let j = 0; j < gActivityArray.length; j++) {
                if (gActivityArray[j].activity.toLowerCase() === gFilterSelectedSteps[k].from_activity.toLowerCase()) gFilterSelectedSteps[k].from_activity_id = gActivityArray[j].id
            }
            for (let j = 0; j < gActivityArray.length; j++) {
                if (gActivityArray[j].activity.toLowerCase() === gFilterSelectedSteps[k].to_activity.toLowerCase()) gFilterSelectedSteps[k].to_activity_id = gActivityArray[j].id
            }
        }
        
        for (let i = 0; i < gTaskArray.length; i++) {

            let validTask = true
            for (let j = gTaskArray[i].si; j < gTaskArray[i].fi + 1; j++) {
                for (let k = 0; k < gFilterSelectedSteps.length; k++) {
                    if (parseInt(gEventLogArray[j].f) === parseInt(gFilterSelectedSteps[k].from_activity_id) && parseInt(gEventLogArray[j].t) === parseInt(gFilterSelectedSteps[k].to_activity_id)) validTask = false
                    break
                }
                if (validTask ===false) break
            }

            if (validTask === true) {
                for (let j = gTaskArray[i].si; j < gTaskArray[i].fi + 1; j++) {
                    let vtp = {};
                    vtp['type'] = 'filter';    
                    vtp['sub_type'] = 'step';    
                    vtp['label'] = 'Filter - Step';
                    vtp['filter_number'] = gFilterSets;
                    vtp['id'] = gEventLogArray[j].elid;
                    vtp['duration'] = gEventLogArray[j].d;
                    vtp['task'] = gEventLogArray[j].k;
                    gFilters.push(vtp);
                }
            }
        }
    }
    if (gStepSelectRetention === 'include') {
        for (let k = 0; k < gFilterSelectedSteps.length; k++) {
            let from_activity_id
            let to_activity_id
            for (let j = 0; j < gActivityArray.length; j++) {
                if (gActivityArray[j].activity.toLowerCase() === gFilterSelectedSteps[k].from_activity.toLowerCase()) from_activity_id = gActivityArray[j].id
            }
            for (let j = 0; j < gActivityArray.length; j++) {
                if (gActivityArray[j].activity.toLowerCase() === gFilterSelectedSteps[k].to_activity.toLowerCase()) to_activity_id = gActivityArray[j].id
            }
            if (filterProps.constraint_type === 'na') {  
                let gEventLogStepArray = [...gEventLogArray.sort((a, b) => a.filtered - b.filtered || a.f - b.f || a.t - b.t || a.k.localeCompare(b.k))]; 
                let gEventLogFilterArray = [...gEventLogArray.sort((a, b) => a.elid - b.elid)];
                let k = ''
                for (let i = 0; i < gEventLogStepArray.length; i++) {
                    if (gEventLogStepArray[i].filtered === 1) break
                    if (parseInt(gEventLogStepArray[i].f) === parseInt(from_activity_id) 
                        && parseInt(gEventLogStepArray[i].t) === parseInt(to_activity_id)
                        && gEventLogStepArray[i].k !== k
                    ) {
                        for (let j = gTaskArray[gEventLogStepArray[i].tid].si; j < gTaskArray[gEventLogStepArray[i].tid].fi + 1; j++) {  // 
                            let vtp = {};
                            vtp['type'] = 'filter';    
                            vtp['sub_type'] = 'step';    
                            vtp['label'] = 'Filter - Step';
                            vtp['filter_number'] = gFilterSets;
                            vtp['id'] = gEventLogFilterArray[j].elid;
                            vtp['duration'] = gEventLogFilterArray[j].d;
                            vtp['task'] = gEventLogFilterArray[j].k;
                            gFilters.push(vtp);
                        }
                        k = gEventLogStepArray[i].k
                    }
                }
            }

            if (filterProps.constraint_type === 'duration' ||
                filterProps.constraint_type === 'customer_comments' ||
                filterProps.constraint_type === 'internal_comments' ||
                filterProps.constraint_type === 'timespent' 
            ) {
                let gEventLogStepArray = [...gEventLogArray.sort((a, b) => a.filtered - b.filtered || a.f - b.f || a.t - b.t || a.k.localeCompare(b.k))]; 
                let gEventLogFilterArray = [...gEventLogArray.sort((a, b) => a.elid - b.elid)];
                let k = ''
                let skipToNextTask 
                for (let i = 0; i < gEventLogStepArray.length; i++) {
                    if (gEventLogStepArray[i].filtered === 1) break

                    if (k !== gEventLogStepArray[i].k ) skipToNextTask = false
                    if (parseInt(gEventLogStepArray[i].f) === parseInt(from_activity_id) 
                        && parseInt(gEventLogStepArray[i].t) === parseInt(to_activity_id)
                        && skipToNextTask === false
                    ) {
                        let checkValue = 0
                        if (filterProps.constraint_type === 'duration') checkValue = gEventLogStepArray[i].d
                        if (filterProps.constraint_type === 'customer_comments') {
                            for (let j = 0; j < gEventLogStepArray[i].comments.length; j++) {
                                if (gEventLogStepArray[i].comments[j].jsdPublic === "true") checkValue ++
                            }
                        }
                        if (filterProps.constraint_type === 'internal_comments') {
                            for (let j = 0; j < gEventLogStepArray[i].comments.length; j++) {
                                if (gEventLogStepArray[i].comments[j].jsdPublic === "false") checkValue ++
                            }
                        } 
                        if (filterProps.constraint_type === 'timespent') {
                            for (let j = 0; j < gEventLogStepArray[i].worklog.length; j++) {
                                 checkValue = checkValue + parseInt(gEventLogStepArray[i].worklog[j].timeSpentSeconds)
                            }
                        }                        

                        let validEvent = checkVolume(filterProps.duration_operator,filterProps.duration_actual_from,filterProps.duration_actual_to,filterProps.value,checkValue)
                        if (validEvent == true && skipToNextTask === false) {
                            // filter all events for the task containing the step event
                            for (let j = gTaskArray[gEventLogStepArray[i].tid].si; j < gTaskArray[gEventLogStepArray[i].tid].fi + 1; j++) {
                                let vtp = {};
                                vtp['type'] = 'filter';    
                                vtp['sub_type'] = 'step';    
                                vtp['label'] = 'Filter - Step';
                                vtp['filter_number'] = gFilterSets;
                                vtp['id'] = gEventLogFilterArray[j].elid;
                                vtp['duration'] = gEventLogFilterArray[j].d;
                                vtp['task'] = gEventLogFilterArray[j].k;
                                gFilters.push(vtp);
                            }
                            skipToNextTask = true
                        }
                        k = gEventLogStepArray[i].k
                    }
                }
            }

            if (filterProps.constraint_type === 'relative') {
                gEventLogArray.sort((a, b) => a.elid - b.elid)
                let avg_duration
                let std_deviation
                for (let j = 0; j < gStepArray.length; j++) {
                    if (parseInt(gStepArray[j].from) === parseInt(from_activity_id) && parseInt(gStepArray[j].to) === parseInt(to_activity_id)) {
                        avg_duration = gStepArray[j].avg_duration
                        std_deviation = gStepArray[j].std_deviation
                    }
                }
                if (filterProps.relative_operator === 'greater than avg duration' ||
                    filterProps.relative_operator === 'less than avg duration' ||
                    filterProps.relative_operator === 'greater than avg duration + std deviation') {

                    let gEventLogStepArray = [...gEventLogArray.sort((a, b) => a.filtered - b.filtered || a.f - b.f || a.t - b.t || a.k.localeCompare(b.k))]; 
                    let gEventLogFilterArray = [...gEventLogArray.sort((a, b) => a.elid - b.elid)];
        
                    let k = ''
                    let skipToNextTask 
                    for (let i = 0; i < gEventLogStepArray.length; i++) {
                        if (gEventLogArray[i].filtered === 1) break
                        if (k !== gEventLogStepArray[i].k ) skipToNextTask = false
                        if (parseInt(gEventLogStepArray[i].f) === parseInt(from_activity_id) 
                            && parseInt(gEventLogStepArray[i].t) === parseInt(to_activity_id)
                            && skipToNextTask === false
                        ) {
                            let validEvent = false
                            if (filterProps.relative_operator === 'greater than avg duration') validEvent = checkVolume('greater than or is',avg_duration,0,'',gEventLogStepArray[i].d)
                            if (filterProps.relative_operator === 'less than avg duration') validEvent = checkVolume('less than or is',avg_duration,0,'',gEventLogStepArray[i].d)
                            if (filterProps.relative_operator === 'greater than avg duration + std deviation') validEvent = checkVolume('greater than or is',avg_duration + std_deviation,0,'',gEventLogStepArray[i].d)
                                
                            if (validEvent == true) {
                                // filter all events for the task containing the step event
                                for (let j = gTaskArray[gEventLogStepArray[i].tid].si; j < gTaskArray[gEventLogStepArray[i].tid].fi + 1; j++) {
                                    let vtp = {};
                                    vtp['type'] = 'filter';    
                                    vtp['sub_type'] = 'step';    
                                    vtp['label'] = 'Filter - Step';
                                    vtp['filter_number'] = gFilterSets;
                                    vtp['id'] = gEventLogFilterArray[j].elid;
                                    vtp['duration'] = gEventLogFilterArray[j].d;
                                    vtp['task'] = gEventLogFilterArray[j].k;
                                    gFilters.push(vtp);
                                }
                                skipToNextTask = true
                            }
                            k = gEventLogStepArray[i].k

                        }
                    }   
                } else {

                    let tempEventLogArray = []
                    for (let i = 0; i < gEventLogArray.length; i++) {
                        if (gEventLogArray[i].filtered === 1) break
                        if (parseInt(gEventLogArray[i].f) === parseInt(from_activity_id) && parseInt(gEventLogArray[i].t) === parseInt(to_activity_id)) {
                            tempEventLogArray.push(gEventLogArray[i])
                        }
                    }
                    if (filterProps.relative_operator === 'Longest duration percentile') tempEventLogArray.sort((a, b) => b.d - a.d);
                    if (filterProps.relative_operator === 'Shortest duration percentile') tempEventLogArray.sort((a, b) => a.d - b.d);

                    let numEvents = (filterProps.percentile/100) * tempEventLogArray.length
                    for (let i = 0; i < tempEventLogArray.length; i++) {
                        for (let j = gTaskArray[tempEventLogArray[i].tid].si; j < gTaskArray[tempEventLogArray[i].tid].fi + 1; j++) {
                            let vtp = {};
                            vtp['type'] = 'filter';    
                            vtp['sub_type'] = 'step';    
                            vtp['label'] = 'Filter - Step';
                            vtp['filter_number'] = gFilterSets;
                            vtp['id'] = gEventLogArray[j].elid;
                            vtp['duration'] = gEventLogArray[j].d;
                            vtp['task'] = gEventLogArray[j].k;
                            gFilters.push(vtp);
                        }
                        if (i > numEvents) break
                    }
                }
            }   

            if (filterProps.constraint_type === 'occurences') {
                gEventLogArray.sort((a, b) => a.filtered - b.filtered || a.tid - b.tid)
                let tid = -1
                let occurences = 0
                let tempArray = []
                for (let i = 0; i < gEventLogArray.length; i++) {
                    if (gEventLogArray[i].filtered === 1) break
                    if (i > 0 && (gEventLogArray[i].tid !== tid)) {
                        let validEvent = checkVolume(filterProps.occurence_operator,filterProps.occurence_actual_from,filterProps.occurence_actual_to,'',occurences)
                        if (validEvent) {
                            for (let j = 0; j < tempArray.length; j++) {
                                let vtp = {};
                                vtp['type'] = 'filter';    
                                vtp['sub_type'] = 'step';    
                                vtp['label'] = 'Filter - Step';
                                vtp['filter_number'] = gFilterSets;
                                vtp['id'] = tempArray[j].id
                                vtp['duration'] = tempArray[j].d
                                vtp['task'] = tempArray[j].k;
                                gFilters.push(vtp);
                            }
                        }
                        occurences = 0
                        tempArray = []
                    }
                    if (parseInt(gEventLogArray[i].f) === parseInt(from_activity_id) && parseInt(gEventLogArray[i].t) === parseInt(to_activity_id)) occurences ++
                    let vtp = [];
                    vtp['id'] = gEventLogArray[i].elid
                    vtp['d'] = gEventLogArray[i].d
                    vtp['k'] = gEventLogArray[i].k
                    tempArray.push(vtp) 
                    tid = gEventLogArray[i].tid
                }
            }   
        }
    }
    
    gFilters = [...new Set(gFilters)] 

    let tasksFiltered = countFilteredTasks()
    if (countOnly === true) { 

        let events = 0
        for (let i = 0; i < gFilters.length; i++) {
            if (gFilters[i].filter_number == gFilterSets) events ++
        }
        gFilterStats = []

        let vtp = [];
        vtp['tasks'] = tasksFiltered
        vtp['events'] = events - tasksFiltered  // removes the 'to end' event
        gFilterStats.push(vtp);   
        return
    }

    if (tasksFiltered > 0) {

        let constraintStr = ''
        if (filterProps.constraint_type === 'duration') constraintStr = 'duration '
        if (filterProps.constraint_type === 'customer_comments') constraintStr = 'customer comments '
        if (filterProps.constraint_type === 'internal_comments') constraintStr = 'internal comments '
        if (filterProps.constraint_type === 'timespent') constraintStr = 'worklog time spent '


        let durationStr = ''
        if (filterProps.constraint_type === 'duration' ||
            filterProps.constraint_type === 'customer_comments' ||
            filterProps.constraint_type === 'internal_comments' ||
            filterProps.constraint_type === 'timespent' 
        ) {
            if (filterProps.duration_operator === 'between' ||
                filterProps.duration_operator === 'between or is' ||
                filterProps.duration_operator === 'outside' ||
                filterProps.duration_operator === 'outside or is'
            ) {
                durationStr = constraintStr + filterProps.duration_operator + ' ' + filterProps.duration_actual_from + ' and ' + filterProps.duration_actual_to + ' ' + filterProps.value;
            } else {
                durationStr = constraintStr + filterProps.duration_operator + ' ' + filterProps.duration_actual_from + ' ' + filterProps.value;
            }
        }

        if (filterProps.constraint_type == 'occurences') {
            if (
                filterProps.occurence_operator === 'between' ||
                filterProps.occurence_operator === 'between or is' ||
                filterProps.occurence_operator === 'outside' ||
                filterProps.occurence_operator === 'outside or is'
            ) {
                durationStr = 'occurences ' + filterProps.occurence_operator + ' ' + filterProps.occurence_actual_from + ' and ' + filterProps.occurence_actual_to
            } else {
                durationStr = 'occurences ' + filterProps.occurence_operator + ' ' + filterProps.occurence_actual_from 
            }
        }

        if (filterProps.constraint_type == 'relative') {
            if (filterProps.relative_operator === 'greater than avg duration') {durationStr = 'duration is greater than average'}
            if (filterProps.relative_operator === 'less than avg duration') {durationStr = 'duration is less than average'}
            if (filterProps.relative_operator === 'greater than avg duration + std deviation') {durationStr = 'duration is greater than average + std deviation'}
            if (filterProps.relative_operator === 'Longest duration percentile') {durationStr = 'duration is in the top ' + filterProps.percentile + '% of issues'}
            if (filterProps.relative_operator === 'Shortest duration percentile') {durationStr = 'duration is in the bottom ' + filterProps.percentile + '% of issues'}
        }

        let textStr = '';
        if (gStepSelectRetention === 'exclude') textStr = 'Exclude steps: '
        else textStr = 'Steps: ';
        for (let i = 0; i < gFilterSelectedSteps.length; i++) {
            textStr = textStr + gFilterSelectedSteps[i].from_activity + ' -> ' + gFilterSelectedSteps[i].to_activity;
            if (i != gFilterSelectedSteps.length - 1) {
                if (gStepSelectRetention === 'exclude') textStr = textStr + ' AND ';
                else textStr = textStr + ' OR ';

            }
        }
        const vtp = {};
        vtp['type'] = 'filter';    
        vtp['sub_type'] = 'step';    
        vtp['label'] = 'Filter - Step';
        
        if (filterProps.constraint_type != 'na') vtp['description'] = textStr + ' where ' + durationStr
        else vtp['description'] = textStr;
        vtp['operator'] = gStepSelectOperator;
        vtp['retention'] = gStepSelectRetention;
        vtp['steps'] = [...gFilterSelectedSteps];
        vtp['activities'] = [];
        vtp['variants'] = [];

        vtp['constraint_type'] = filterProps.constraint_type;
        vtp['duration_operator'] = filterProps.duration_operator;
        vtp['relative_operator'] = filterProps.relative_operator;
        vtp['occurence_operator'] = filterProps.occurence_operator;
        vtp['duration_actual_from'] = filterProps.duration_actual_from;
        vtp['duration_actual_to'] = filterProps.duration_actual_to;
        vtp['occurence_actual_from'] = filterProps.occurence_actual_from;
        vtp['occurence_actual_to'] = filterProps.occurence_actual_to;
        vtp['value'] = filterProps.value;
        vtp['percentile'] = filterProps.percentile;
        vtp['constraint_type'] = filterProps.constraint_type;
        vtp['id'] = gFilterSets
        gFilterConditions.push(vtp);

        generateArrays(true, false, 'applyStepFilter',loadDiscoveryRules);
        setFilterIcon({ eventEmitter: gEventEmitter });
        alertMessage({
            eventEmitter: gEventEmitter,
            message: tasksFiltered +  ' issues match the filter',
            severity: 'success',
            showAlert: true,
            timeOutActive: true,
            component: 'stepFilter',
        });
    } else {
        gFilterSets--;
        alertMessage({
            eventEmitter: gEventEmitter,
            message: 'No matching issues',
            severity: 'info',
            showAlert: true,
            timeOutActive: true,
            component: 'stepFilter',
        });
    }
};

export const applyVariantDiscoveryFilter = (filterProps,loadDiscoveryRules,countOnly) => {  
    gSaveModel = true
    let variant_id
    let variant = filterProps.variants[0].variant
    gFilterSets++;  
    gTaskArray.sort((a, b) => a.id - b.id);
    for (let j = 0; j < gVariantArray.length; j++) {
        if (gVariantArray[j].n === variant) variant_id = gVariantArray[j].id 
    }   
    let gEventLogVariantArray = [...gEventLogArray.sort((a, b) => a.filtered - b.filtered || a.v - b.v || a.k.localeCompare(b.k))]; 
    let gEventLogFilterArray = [...gEventLogArray.sort((a, b) => a.elid - b.elid)];

    let k = ''
    let skipToNextTask = false

    for (let i = 0; i < gEventLogVariantArray.length; i++) {
        if (gEventLogVariantArray[i].filtered === 1) break
        if (k !== gEventLogVariantArray[i].k ) skipToNextTask = false

        if (parseInt(gEventLogVariantArray[i].v) === parseInt(variant_id) 
            && gEventLogVariantArray[i].k !== k
        ) {

            for (let j = gTaskArray[gEventLogVariantArray[i].tid].si; j < gTaskArray[gEventLogVariantArray[i].tid].fi + 1; j++) {  // 
                let vtp = {};
                vtp['type'] = 'filter';    
                vtp['sub_type'] = 'variant_discovery';    
                vtp['label'] = 'Filter - Variant';
                vtp['filter_number'] = gFilterSets;
                vtp['id'] = gEventLogFilterArray[j].elid;
                vtp['duration'] = gEventLogFilterArray[j].d;
                vtp['task'] = gEventLogFilterArray[j].k;
                gFilters.push(vtp);
            }
            k = gEventLogVariantArray[i].k
            skipToNextTask = true
        }
    }

    let tasksFiltered = countFilteredTasks()  
    if (countOnly === true) { 

        let events = 0
        for (let i = 0; i < gFilters.length; i++) {
            if (gFilters[i].filter_number == gFilterSets) events ++
        }
        gFilterStats = []

        let vtp = [];
        vtp['tasks'] = tasksFiltered
        vtp['events'] = events - tasksFiltered  // removes the 'to end' event
        gFilterStats.push(vtp);   
        return
    }

    if (tasksFiltered > 0) {
        const vtp = {};
        vtp['type'] = 'filter';    
        vtp['sub_type'] = 'variant_discovery';    
        vtp['label'] = 'Filter - Variant';
        vtp['description'] = 'Variant: ' + variant
        vtp['id'] = gFilterSets
        gFilterConditions.push(vtp);

        generateArrays(true, false, 'applyVariantFilter',loadDiscoveryRules);
        setFilterIcon({ eventEmitter: gEventEmitter });
        alertMessage({
            eventEmitter: gEventEmitter,
            message: tasksFiltered +  ' issues match the filter',
            severity: 'success',
            showAlert: true,
            timeOutActive: true,
            component: 'variantFilter',
        });
    } else {
        gFilterSets--;
        alertMessage({
            eventEmitter: gEventEmitter,
            message: 'No matching issues',
            severity: 'info',
            showAlert: true,
            timeOutActive: true,
            component: 'variantFilter',
        });
    }
}

export const applyVariantFilter = (filterProps,loadDiscoveryRules,countOnly) => {  

    // gFilterSelectedVariants
    let variants = ''
    gSaveModel = true
    gFilterSets++;  
    gTaskArray.sort((a, b) => a.id - b.id);
    
    for (let j = 0; j < gFilterSelectedVariants.length; j++) {
        let gEventLogVariantArray = [...gEventLogArray.sort((a, b) => a.filtered - b.filtered || a.f - b.f || a.k.localeCompare(b.k))]; 
        let gEventLogFilterArray = [...gEventLogArray.sort((a, b) => a.elid - b.elid)];
        if (j > 0 ) variants = variants + ', '
        variants = variants + gFilterSelectedVariants[j].variant
        let k = ''
        let skipToNextTask = false
        let ctr = 0
        for (let i = 0; i < gEventLogVariantArray.length; i++) {
            if (gEventLogVariantArray[i].filtered === 1) break
            if (k !== gEventLogVariantArray[i].k ) skipToNextTask = false
            if (parseInt(gEventLogVariantArray[i].v) === parseInt(gFilterSelectedVariants[j].variant_id) 
                && gEventLogVariantArray[i].k !== k
                && skipToNextTask === false
            ) {
                for (let j = gTaskArray[gEventLogVariantArray[i].tid].si; j < gTaskArray[gEventLogVariantArray[i].tid].fi + 1; j++) {  // 
                    let vtp = {};
                    vtp['type'] = 'filter';    
                    vtp['sub_type'] = 'variant';    
                    vtp['label'] = 'Filter - Variant';
                    vtp['filter_number'] = gFilterSets;
                    vtp['id'] = gEventLogFilterArray[j].elid;
                    vtp['duration'] = gEventLogFilterArray[j].d;
                    vtp['task'] = gEventLogArray[j].k;
                    gFilters.push(vtp);
                }
                ctr ++
                k = gEventLogVariantArray[i].k
                skipToNextTask = true
            }
        }
    }   

    let tasksFiltered = countFilteredTasks()  
    if (countOnly === true) { 

        let events = 0
        for (let i = 0; i < gFilters.length; i++) {
            if (gFilters[i].filter_number == gFilterSets) events ++
        }
        gFilterStats = []

        let vtp = [];
        vtp['tasks'] = tasksFiltered
        vtp['events'] = events - tasksFiltered  // removes the 'to end' event
        gFilterStats.push(vtp);   
        return
    }

    if (tasksFiltered > 0) {
        const vtp = {};
        vtp['type'] = 'filter';    
        vtp['sub_type'] = 'variant';    
        vtp['label'] = 'Filter - Variant';
        vtp['description'] = 'Variant: ' + variants
        vtp['activities'] = [];
        vtp['steps'] = [];
        vtp['variants'] = [...gFilterSelectedVariants];

        vtp['id'] = gFilterSets
        gFilterConditions.push(vtp);

        generateArrays(true, false, 'applyVariantFilter',loadDiscoveryRules);
        setFilterIcon({ eventEmitter: gEventEmitter });
        alertMessage({
            eventEmitter: gEventEmitter,
            message: tasksFiltered +  ' issues match the filter',
            severity: 'success',
            showAlert: true,
            timeOutActive: true,
            component: 'variantFilter',
        });
    } else {
        gFilterSets--;
        alertMessage({
            eventEmitter: gEventEmitter,
            message: 'No matching issues',
            severity: 'info',
            showAlert: true,
            timeOutActive: true,
            component: 'variantFilter',
        });
    }
}


export const applyActivityFilter = (filterProps,loadDiscoveryRules, countOnly) => {  
    gSaveModel = true
    let activity_id
    let avg_duration
    let std_deviation
    gFilterSets++;  
    gTaskArray.sort((a, b) => a.id - b.id);
    
    if (gActivitySelectRetention === 'exclude') {
        gEventLogArray.sort((a, b) => a.elid - b.elid);

        for (let k = 0; k < gFilterSelectedActivities.length; k++) {
            for (let j = 0; j < gActivityArray.length; j++) {
                if (gActivityArray[j].activity.toLowerCase() === gFilterSelectedActivities[k].activity.toLowerCase()) gFilterSelectedActivities[k].activity_id = gActivityArray[j].id
            }
        }

        for (let i = 0; i < gTaskArray.length; i++) {

            let validTask = true
            for (let j = gTaskArray[i].si; j < gTaskArray[i].fi + 1; j++) {
                for (let k = 0; k < gFilterSelectedActivities.length; k++) {
                    if (parseInt(gEventLogArray[j].f) === parseInt(gFilterSelectedActivities[k].activity_id) ) validTask = false
                    break
                }
                if (validTask ===false) break
            }

            if (validTask === true) {
                for (let j = gTaskArray[i].si; j < gTaskArray[i].fi + 1; j++) {
                    let vtp = {};
                    vtp['type'] = 'filter';    
                    vtp['sub_type'] = 'step';    
                    vtp['label'] = 'Filter - Step';
                    vtp['filter_number'] = gFilterSets;
                    vtp['id'] = gEventLogArray[j].elid;
                    vtp['duration'] = gEventLogArray[j].d;
                    vtp['task'] = gEventLogArray[j].k;
                    gFilters.push(vtp);
                }
            }
        }
    }

    if (gActivitySelectRetention === 'include') {

        for (let k = 0; k < gFilterSelectedActivities.length; k++) {
            for (let j = 0; j < gActivityArray.length; j++) {
                if (gActivityArray[j].activity.toLowerCase() === gFilterSelectedActivities[k].activity.toLowerCase()) activity_id = gActivityArray[j].id
            }   

            if (filterProps.constraint_type === 'na') { 

                let gEventLogActivityArray = [...gEventLogArray.sort((a, b) => a.filtered - b.filtered || a.f - b.f || a.k.localeCompare(b.k))]; 
                let gEventLogFilterArray = [...gEventLogArray.sort((a, b) => a.elid - b.elid)];

                let k = ''
                let skipToNextTask = false
                let ctr = 0
                for (let i = 0; i < gEventLogActivityArray.length; i++) {
                    if (gEventLogActivityArray[i].filtered === 1) break
                    if (k !== gEventLogActivityArray[i].k ) skipToNextTask = false

                    if (parseInt(gEventLogActivityArray[i].f) === parseInt(activity_id) 
                        && gEventLogActivityArray[i].k !== k
                        && skipToNextTask === false
                    ) {

                        for (let j = gTaskArray[gEventLogActivityArray[i].tid].si; j < gTaskArray[gEventLogActivityArray[i].tid].fi + 1; j++) {  // 
                            let vtp = {};
                            vtp['type'] = 'filter';    
                            vtp['sub_type'] = 'activity';    
                            vtp['label'] = 'Filter - Activity';
                            vtp['filter_number'] = gFilterSets;
                            vtp['id'] = gEventLogFilterArray[j].elid;
                            vtp['duration'] = gEventLogFilterArray[j].d;
                            vtp['task'] = gEventLogArray[j].k;
                            gFilters.push(vtp);
                        }
                        ctr ++
                        k = gEventLogActivityArray[i].k
                        skipToNextTask = true
                    }
                }
            }

            if (filterProps.constraint_type === 'duration') {

                let gEventLogActivityArray = [...gEventLogArray.sort((a, b) => a.filtered - b.filtered || a.f - b.f || a.t - b.t || a.k.localeCompare(b.k))]; 
                let gEventLogFilterArray = [...gEventLogArray.sort((a, b) => a.elid - b.elid)];

                let k = ''
                let skipToNextTask = false
                for (let i = 0; i < gEventLogActivityArray.length; i++) {
                    if (gEventLogActivityArray[i].filtered === 1) break

                    if (gEventLogActivityArray[i].k !== k) skipToNextTask = false
                    if (parseInt(gEventLogActivityArray[i].f) === parseInt(activity_id) 
                        && skipToNextTask === false
                    ) {
                        let validEvent = checkVolume(filterProps.duration_operator,filterProps.duration_actual_from,filterProps.duration_actual_to,filterProps.value,gEventLogActivityArray[i].d)
                        if (validEvent == true) {
                            // filter all events for the task containing the step event
                            for (let j = gTaskArray[gEventLogActivityArray[i].tid].si; j < gTaskArray[gEventLogActivityArray[i].tid].fi + 1; j++) {
                                let vtp = {};
                                vtp['type'] = 'filter';    
                                vtp['sub_type'] = 'activity';    
                                vtp['label'] = 'Filter - Activity';
                                vtp['filter_number'] = gFilterSets;
                                vtp['id'] = gEventLogFilterArray[j].elid;
                                vtp['duration'] = gEventLogFilterArray[j].d;
                                vtp['task'] = gEventLogFilterArray[j].k;
                                gFilters.push(vtp);
                            }
                        }
                        k = gEventLogActivityArray[i].k
                        skipToNextTask = true
                    }
                }
            }

            if (filterProps.constraint_type === 'relative') {
                gEventLogArray.sort((a, b) => a.elid - b.elid)
                for (let j = 0; j < gActivityArray.length; j++) {
                    if (parseInt(gActivityArray[j].id) === parseInt(activity_id) ) {
                        avg_duration = gActivityArray[j].avg_duration
                        std_deviation = gActivityArray[j].std_deviation
                    }
                }
                if (filterProps.relative_operator === 'greater than avg duration' ||
                    filterProps.relative_operator === 'less than avg duration' ||
                    filterProps.relative_operator === 'greater than avg duration + std deviation') {

                    let gEventLogActivityArray = [...gEventLogArray.sort((a, b) => a.filtered - b.filtered || a.f - b.f || a.k.localeCompare(b.k))]; 
                    let gEventLogFilterArray = [...gEventLogArray.sort((a, b) => a.elid - b.elid)];
    
                    for (let i = 0; i < gEventLogActivityArray.length; i++) {
                        if (gEventLogActivityArray[i].filtered === 1) break
                        if (parseInt(gEventLogActivityArray[i].f) === parseInt(activity_id) ) {

                            let validEvent = false
                            if (filterProps.relative_operator === 'greater than avg duration') validEvent = checkVolume('greater than or is',avg_duration,0,'',gEventLogActivityArray[i].d)
                            if (filterProps.relative_operator === 'less than avg duration') validEvent = checkVolume('less than or is',avg_duration,0,'',gEventLogActivityArray[i].d)
                            if (filterProps.relative_operator === 'greater than avg duration + std deviation') validEvent = checkVolume('greater than or is',avg_duration + std_deviation,0,'',gEventLogActivityArray[i].d)
                                
                            if (validEvent == true) {
                                // filter all events for the task containing the step event
                                for (let j = gTaskArray[gEventLogActivityArray[i].tid].si; j < gTaskArray[gEventLogActivityArray[i].tid].fi + 1; j++) {
                                    let vtp = {};
                                    vtp['type'] = 'filter';    
                                    vtp['sub_type'] = 'activity';    
                                    vtp['label'] = 'Filter - Activity';
                                    vtp['filter_number'] = gFilterSets;
                                    vtp['id'] = gEventLogFilterArray[j].elid;
                                    vtp['duration'] = gEventLogFilterArray[j].d;
                                    vtp['task'] = gEventLogFilterArray[j].k;
                                    gFilters.push(vtp);
                                }
                            }
                        }
                    }
                } else {

                    let tempEventLogArray = []
                    for (let i = 0; i < gEventLogArray.length; i++) {
                        if (parseInt(gEventLogArray[i].f) === parseInt(activity_id) ) {
                            tempEventLogArray.push(gEventLogArray[i])
                        }   
                    }
                    if (filterProps.relative_operator === 'Longest duration percentile') tempEventLogArray.sort((a, b) => b.d - a.d);
                    if (filterProps.relative_operator === 'Shortest duration percentile') tempEventLogArray.sort((a, b) => a.d - b.d);

                    let numEvents = (filterProps.percentile/100) * tempEventLogArray.length
                    for (let i = 0; i < tempEventLogArray.length; i++) {
                        for (let j = gTaskArray[tempEventLogArray[i].tid].si; j < gTaskArray[tempEventLogArray[i].tid].fi + 1; j++) {
                            let vtp = {};
                            vtp['type'] = 'filter';    
                            vtp['sub_type'] = 'activity';    
                            vtp['label'] = 'Filter - Activity';
                            vtp['filter_number'] = gFilterSets;
                            vtp['id'] = gEventLogArray[j].elid;
                            vtp['duration'] = gEventLogArray[j].d;
                            vtp['task'] = gEventLogArray[j].k;
                            gFilters.push(vtp);
                        }
                        if (i > numEvents) break
                    }   
                }
            }
            if (filterProps.constraint_type === 'occurences') { 
                gEventLogArray.sort((a, b) => a.filtered - b.filtered || a.tid - b.tid )
                let tid = -1
                let occurences = 0
                let tempArray = []
                for (let i = 0; i < gEventLogArray.length; i++) {
                    if (gEventLogArray[i].filtered === 1) break
                    if (i > 0 && (gEventLogArray[i].tid !== tid)) {
                        let validEvent = checkVolume(filterProps.occurence_operator,filterProps.occurence_actual_from,filterProps.occurence_actual_to,'',occurences)
                        if (validEvent) {
                            for (let j = 0; j < tempArray.length; j++) {
                                let vtp = {};
                                vtp['type'] = 'filter';    
                                vtp['sub_type'] = 'activity';    
                                vtp['label'] = 'Filter - Activity';
                                vtp['filter_number'] = gFilterSets;
                                vtp['id'] = tempArray[j].id
                                vtp['duration'] = tempArray[j].d
                                vtp['task'] = tempArray[j].k
                                gFilters.push(vtp);
                            }
                        }
                        occurences = 0
                        tempArray = []
                    }
                    if (parseInt(gEventLogArray[i].t) === parseInt(activity_id)) occurences ++
                    let vtp = [];
                    vtp['id'] = gEventLogArray[i].elid
                    vtp['d'] = gEventLogArray[i].d
                    vtp['k'] = gEventLogArray[i].k
                    tempArray.push(vtp) 
                    tid = gEventLogArray[i].tid
                }
            }
        }
    }   
    let tasksFiltered = countFilteredTasks()  

    if (countOnly === true) { 

        let events = 0
        for (let i = 0; i < gFilters.length; i++) {
            if (gFilters[i].filter_number == gFilterSets) events ++
        }
        gFilterStats = []

        let vtp = [];
        vtp['tasks'] = tasksFiltered
        vtp['events'] = events - tasksFiltered  // removes the 'to end' event
        gFilterStats.push(vtp);   
        return
    }
    if (tasksFiltered > 0) {
        let durationStr = ''

        if (filterProps.constraint_type == 'duration') {
            if (
                filterProps.duration_operator === 'between' ||
                filterProps.duration_operator === 'between or is' ||
                filterProps.duration_operator === 'outside' ||
                filterProps.duration_operator === 'outside or is'
            ) {
                durationStr = 'duration ' + filterProps.duration_operator + ' ' + filterProps.duration_actual_from + ' and ' + filterProps.duration_actual_to + ' ' + filterProps.value;
            } else {
                durationStr = 'duration ' + filterProps.duration_operator + ' ' + filterProps.duration_actual_from + ' ' + filterProps.value;
            }
        }

        if (filterProps.constraint_type == 'occurences') {
            if (
                filterProps.occurence_operator === 'between' ||
                filterProps.occurence_operator === 'between or is' ||
                filterProps.occurence_operator === 'outside' ||
                filterProps.occurence_operator === 'outside or is'
            ) {
                durationStr = 'occurences ' + filterProps.occurence_operator + ' ' + filterProps.occurence_actual_from + ' and ' + filterProps.occurence_actual_to
            } else {
                durationStr = 'occurences ' + filterProps.occurence_operator + ' ' + filterProps.occurence_actual_from 
            }
        }

        if (filterProps.constraint_type == 'relative') {
            if (filterProps.relative_operator === 'greater than avg duration') {durationStr = 'duration is greater than average'}
            if (filterProps.relative_operator === 'less than avg duration') {durationStr = 'duration is less than average'}
            if (filterProps.relative_operator === 'greater than avg duration + std deviation') {durationStr = 'duration is greater than average + std deviation'}
            if (filterProps.relative_operator === 'Longest duration percentile') {durationStr = 'duration is in the top ' + filterProps.percentile + '% of issues'}
            if (filterProps.relative_operator === 'Shortest duration percentile') {durationStr = 'duration is in the bottom ' + filterProps.percentile + '% of issues'}
        }
        let textStr = '';
        if (gActivitySelectRetention === 'exclude') textStr = 'Exclude activities: '
        else textStr = 'Activity: ';

        for (let i = 0; i < gFilterSelectedActivities.length; i++) {
            textStr = textStr + gFilterSelectedActivities[i].activity ;
            if (i != gFilterSelectedActivities.length - 1) {
                if (gStepSelectRetention === 'exclude') textStr = textStr + ' AND ';
                else textStr = textStr + ' OR ';
            }
        }

        const vtp = {};
        vtp['type'] = 'filter';    
        vtp['sub_type'] = 'activity';    
        vtp['label'] = 'Filter - Activity';
        if (filterProps.constraint_type != 'na') vtp['description'] = textStr + ' where ' + durationStr
        else vtp['description'] = textStr;
        vtp['operator'] = gActivitySelectOperator;
        vtp['retention'] = gActivitySelectRetention;
        vtp['activities'] = [...gFilterSelectedActivities];
        vtp['steps'] = [];
        vtp['variants'] = [];

        vtp['constraint_type'] = filterProps.constraint_type
        vtp['duration_operator'] = filterProps.duration_operator
        vtp['relative_operator'] = filterProps.relative_operator
        vtp['occurence_operator'] = filterProps.occurence_operator
        vtp['duration_actual_from'] = filterProps.duration_actual_from
        vtp['duration_actual_to'] = filterProps.duration_actual_to
        vtp['occurence_actual_from'] = filterProps.occurence_actual_from
        vtp['occurence_actual_to'] = filterProps.occurence_actual_to
        vtp['value'] = filterProps.value
        vtp['percentile'] = filterProps.percentile
        vtp['id'] = gFilterSets
        gFilterConditions.push(vtp);

        generateArrays(true, false, 'applyActivityFilter',loadDiscoveryRules);
        setFilterIcon({ eventEmitter: gEventEmitter });
        alertMessage({
            eventEmitter: gEventEmitter,
            message: tasksFiltered +  ' issues match the filter',
            severity: 'success',
            showAlert: true,
            timeOutActive: true,
            component: 'activityFilter',
        });
    } else {
        gFilterSets--;
        alertMessage({
            eventEmitter: gEventEmitter,
            message: 'No matching issues',
            severity: 'info',
            showAlert: true,
            timeOutActive: true,
            component: 'activityFilter',
        });
    }
};

export const applyPathFilter = (filterProps,loadDiscoveryRules,countOnly) => {  
    gSaveModel = true
    let predicate = filterProps.predicate
    let operator = filterProps.duration_operator
    let actual_from = filterProps.actual_from
    let actual_to = filterProps.actual_to
    let value = filterProps.value

    gLinkArray.sort((a, b) => a.variant - b.variant || a.sort_key - b.sort_key);
    gPathPredicate = predicate;
    gFilterSets++;

    let tPathFrom = [...gPathFrom]
    let tPathTo = [...gPathTo]

    for (let i = 0; i < tPathFrom.length; i++) {
        for (let j = 0; j < gActivityArray.length; j++) {
            if (gActivityArray[j].activity === tPathFrom[i].activity) {
                tPathFrom[i].activity_id = gActivityArray[j].id
                break
            }
        }
    }

    for (let i = 0; i < tPathTo.length; i++) {
        for (let j = 0; j < gActivityArray.length; j++) {
            if (gActivityArray[j].activity === tPathTo[i].activity) {
                tPathTo[i].activity_id = gActivityArray[j].id
                break
            }
        }
    }

    for (let i = 0; i < gEventLogArray.length; i++) gEventLogArray[i].selected = false

    gEventLogArray = gEventLogArray.sort((a, b) => a.filtered - b.filtered || a.k.localeCompare(b.k) || a.elid - b.elid);
    gTaskArray.sort((a, b) => a.id - b.id);
    if (predicate === 'Directly Followed') {  

        let k = ''
        let skipToNext = false
        for (let i = 0; i < gEventLogArray.length; i++) {
            if (gEventLogArray[i].filtered === 1) break
            if (gEventLogArray[i].k !== k) skipToNext = false

            if (skipToNext === false) {
                let from = false
                for (let k = 0; k < tPathFrom.length; k++) { 
                    if (tPathFrom[k].activity_id === gEventLogArray[i].f) {
                        from = true
                        break
                    }       
                }
                let to = false
                for (let k = 0; k < tPathTo.length; k++) {
                    if (tPathTo[k].activity_id === gEventLogArray[i].t) {
                        to = true
                        break
                    }       
                }
                if (from === true && to === true ) {
                    let validEvent = true
                    if (filterProps.constraint_type === 'duration') { 
                        validEvent = checkVolume(operator,actual_from,actual_to,value,gEventLogArray[i].d)
                    }
                    if (filterProps.constraint_type === 'same_resource') { 
//                        validEvent = false
//                        if (gEventLogArray[i].u === gEventLogArray[i+1].u) validEvent = true
                    }
                    if (validEvent == true) {
                        for (let j = gTaskArray[gEventLogArray[i].tid].si; j < gTaskArray[gEventLogArray[i].tid].fi + 1; j++) {
                            gEventLogArray[j].selected = true
                        }   
                        skipToNext = true  // task is already in the filter, not need to add if another event matches path 
                    }
                }
            }
            k = gEventLogArray[i].k
        }
    }
    if (predicate === 'Eventually Followed') {  
        let k = ''
        let skipToNext = false
        for (let i = 0; i < gEventLogArray.length; i++) {
            if (gEventLogArray[i].filtered === 1) break

            if (k !== gEventLogArray[i].k) skipToNext = false
            if (skipToNext === false) {

                let from = false
                for (let k = 0; k < tPathFrom.length; k++) {
                    if (tPathFrom[k].activity_id === gEventLogArray[i].f) {
                        from = true
                        break
                    }       
                }

                if (from === true) {
                    let to = false  // need to check all future events -- is array sorted by timestamp/elid

                    for (let s = i; s < gEventLogArray.length; s++) {
                        for (let k = 0; k < tPathTo.length; k++) {
                            if (tPathTo[k].activity_id === gEventLogArray[i].t) to = true
                        }
                        if (to === true || gEventLogArray[s].k !== k ) break
                    }

                    if (to === true) {  // we have an event for the issue that matches the path
                        let validEvent = true
                        if (filterProps.constraint_type === 'duration') { 
                            validEvent = checkVolume(operator,actual_from,actual_to,value,gEventLogArray[i].d)
                        }

                        if (validEvent == true) {
                            // filter all events for the task containing the step event
                            for (let j = gTaskArray[gEventLogArray[i].tid].si; j < gTaskArray[gEventLogArray[i].tid].fi + 1; j++) {
                                gEventLogArray[j].selected = true
                            }   
                            skipToNext = true  // task is already in the filter, not need to add if another event matches path 
                        }
                    }
                }
            }
        }
    }
    for (let i = 0; i < gEventLogArray.length; i++) {
        if (gEventLogArray[i].filtered === 1) break

        let validEvent = false
        if (gEventLogArray[i].selected == true && gPathSelectRetention == 'include') validEvent = true
        if (gEventLogArray[i].selected == false && gPathSelectRetention == 'exclude') validEvent = true

        if (validEvent === true) {

            let vtp = {};
            vtp['type'] = 'filter';    
            if (filterProps.constraint_type === 'na') {
                vtp['sub_type'] = 'path';    
                vtp['label'] = 'Filter - Path';
            }
            if (filterProps.constraint_type === 'duration') {
                vtp['sub_type'] = 'path-duration';    
                vtp['label'] = 'Filter - Path Duration';
            }
            vtp['filter_number'] = gFilterSets;
            vtp['id'] = gEventLogArray[i].elid;
            vtp['duration'] = gEventLogArray[i].d;
            vtp['task'] = gEventLogArray[i].k;
            gFilters.push(vtp);
        }
    }

    let tasksFiltered = countFilteredTasks()
    if (tasksFiltered > 0) {
        let durationStr
        if (filterProps.constraint_type === 'duration') { 
            if (
                operator === 'between' ||
                operator === 'between or is' ||
                operator === 'outside' ||
                operator === 'outside or is'
            ) {
            durationStr = 'duration ' + operator + ' ' + actual_from + ' and ' + actual_to + ' ' + value;
            } else {
                durationStr = 'duration ' + operator + ' ' + actual_from + ' ' + value;
            }
        }

        let textStr = ''
        let fromStr = '';
        let toStr = '';
        for (let i = 0; i < gPathFrom.length; i++) {
            fromStr = fromStr + gPathFrom[i].activity;
            if (i < gPathFrom.length - 1) {
                fromStr = fromStr + ', ';
            }
        }
        for (let i = 0; i < gPathTo.length; i++) {
            toStr = toStr + gPathTo[i].activity;
            if (i < gPathTo.length - 1) {
                toStr = toStr + ', ';
            }
        }
        textStr = textStr + '(' + fromStr + ') ' + gPathPredicate.toLowerCase() + ' by (' + toStr + ')';

        let vtp = {};
        vtp['type'] = 'filter';    
        if (filterProps.constraint_type === 'na') {
            vtp['sub_type'] = 'path';    
            vtp['label'] = 'Filter - Path';
            vtp['description'] = 'Path: ' + textStr

        }
        if (filterProps.constraint_type === 'duration') {
            vtp['sub_type'] = 'path-duration';    
            vtp['label'] = 'Filter - Path Duration';
            vtp['description'] = 'Path: ' + gPathSelectRetention + ' - ' + textStr + ' where ' + durationStr
        }
        if (filterProps.constraint_type === 'same_resource') {
            vtp['sub_type'] = 'path-resource';    
            vtp['label'] = 'Filter - Path Resource';
        }
        vtp['path_from'] = gPathFrom
        vtp['path_to'] = gPathTo
        vtp['predicate'] = gPathPredicate
        vtp['retention'] = gPathSelectRetention
        vtp['constraint_type'] = filterProps.constraint_type
        vtp['duration_operator'] = operator
        vtp['actual_from'] = actual_from
        vtp['actual_to'] = actual_to
        vtp['value'] = value
        vtp['steps'] = [];
        vtp['activities'] = [];
        vtp['variants'] = [];
        vtp['id'] = gFilterSets
        gFilterConditions.push(vtp);

        generateArrays(true, false, 'applyPathFilter',loadDiscoveryRules);
        setFilterIcon({ eventEmitter: gEventEmitter });
        alertMessage({
            eventEmitter: gEventEmitter,
            message: tasksFiltered +  ' issues match the filter',
            severity: 'success',
            showAlert: true,
            timeOutActive: true,
            component: 'pathFilter',
        });
    } else {
        alertMessage({
            eventEmitter: gEventEmitter,
            message: 'No matching issues',
            severity: 'info',
            showAlert: true,
            timeOutActive: true,
            component: 'pathFilter',
        });
    }
    
}

export const applyPathConstraintResource = (attribute,loadDiscoveryRules) => {  
    gSaveModel = true
    gPathPredicate = attribute;
    if (gPathFrom.length == 0 || gPathTo.length == 0) {
        return;
    }

    gLinkArray.sort((a, b) => a.variant - b.variant || a.sort_key - b.sort_key);
    gPathPredicate = attribute;

    let from_activity = gPathFrom[0].activity
    let to_activity = gPathTo[0].activity
    
    let from_activity_id
    let to_activity_id

    for (let j = 0; j < gActivityArray.length; j++) {
        if (gActivityArray[j].activity === from_activity) from_activity_id = gActivityArray[j].id
    }
    for (let j = 0; j < gActivityArray.length; j++) {
        if (gActivityArray[j].activity === to_activity) to_activity_id = gActivityArray[j].id
    }

    gFilterSets++;
    gEventLogArray.sort((a, b) => a.elid - b.elid);
    gTaskArray.sort((a, b) => a.id - b.id);

    if (attribute === 'Directly Followed') {  
        for (let i = 0; i < gEventLogArray.length; i++) {
            if (parseInt(gEventLogArray[i].f) === parseInt(from_activity_id) && parseInt(gEventLogArray[i].t) === parseInt(to_activity_id)) {
                // find the to activity and check the resource
                let validEvent = false

                if (validEvent == true) {
                    // filter all events for the task containing the step event
                    for (let j = gTaskArray[gEventLogArray[i].tid].si; j < gTaskArray[gEventLogArray[i].tid].fi + 1; j++) {
                        let vtp = {};
                        vtp['type'] = 'constraint';    
                        vtp['sub_type'] = 'path-resource';    
                        vtp['label'] = 'Constraint - Path Resource';
                        vtp['filter_number'] = gFilterSets;
                        vtp['id'] = gEventLogArray[j].elid;
                        vtp['duration'] = gEventLogArray[j].d;
                        vtp['task'] = gEventLogArray[j].k;
                        gFilters.push(vtp);
                    }   
                }
            }
        }
    }

    if (attribute === 'Eventually Followed') {  
        for (let i = 0; i < gEventLogArray.length; i++) {
            let validIssue = false
            if (parseInt(gEventLogArray[i].f) === parseInt(from_activity_id)) {
                // check all subsequent events for the issue and sum up the duration    
                let duration = 0
                let task = gEventLogArray[i].k
                for (let j = i + 1; j < gEventLogArray.length; j++) {

                    if (parseInt(gEventLogArray[i].t) === parseInt(to_activity_id) && gEventLogArray[i].u === gEventLogArray[j].u) { 
                        validIssue = true
                        break
                    }
                    if (gEventLogArray[i].k !== task) break     
                }

                if (validIssue === true) {
                    for (let j = gTaskArray[gEventLogArray[i].tid].si; j < gTaskArray[gEventLogArray[i].tid].fi + 1; j++) {
                        let vtp = {};
                        vtp['type'] = 'path_constraint_resource';
                        vtp['filter_number'] = gFilterSets;
                        vtp['id'] = gEventLogArray[j].elid;
                        vtp['duration'] = gEventLogArray[j].d;
                        vtp['task'] = gEventLogArray[j].k;
                        gFilters.push(vtp);
                    }
                }
            }
        }
    }

    let tasksFiltered = countFilteredTasks()
    if (tasksFiltered > 0) {

        let vtp = {};
        vtp['type'] = 'constraint';    
        vtp['sub_type'] = 'path-resource';    
        vtp['label'] = 'Constraint - Path Resource';
        vtp['description'] = 'Path: ' + from_activity + ' ' + attribute +  ' ' + to_activity + ' where resource is the same'
        vtp['from_activity'] = gPathFrom
        vtp['to_activity'] = gPathTo
        vtp['steps'] = [];
        vtp['activities'] = [];
        vtp['variants'] = [];
        vtp['id'] = gFilterSets

        gFilterConditions.push(vtp);

        generateArrays(true, false, 'applyPathFilter',loadDiscoveryRules);
        setConstraintIcon({ eventEmitter: gEventEmitter });
        alertMessage({
            eventEmitter: gEventEmitter,
            message: tasksFiltered +  ' issues match the filter',
            severity: 'success',
            showAlert: true,
            timeOutActive: true,
            component: 'pathFilter',
        });
    } else {
        gFilterSets--;
        alertMessage({
            eventEmitter: gEventEmitter,
            message: 'No matching issues',
            severity: 'info',
            showAlert: true,
            timeOutActive: true,
            component: 'pathFilter',
        });
    }
    
}

export const applyTimeFilterAsync = async (fromTime, toTime, type, loadDiscoveryRules) => {
    gSaveModel = true;
    if (fromTime == '') {
        gFromTime = gFromTime.substring(0,10).replaceAll('-', '/');
        gToTime   = gToTime.substring(0,10).replaceAll('-', '/');
    } else {
        gFromTime = fromTime.replaceAll('-', '/');
        gToTime   = toTime.replaceAll('-', '/');
    }
    gFilterTimeType = type;
    filterTime(type);
    const tasksFiltered = countFilteredTasks();
    if (tasksFiltered > 0) {
        filterConditions('time', type);
        await generateArrays(true, false, 'applyTimeFilterAsync', loadDiscoveryRules);
    }
    return tasksFiltered;
};

export const applyTimeFilter = (fromTime, toTime, type, loadDiscoveryRules, countOnly) => {
    gSaveModel = true
    if (fromTime == '') {
        gFromTime = gFromTime.substring(0,10).replaceAll("-", "/");
        gToTime = gToTime.substring(0,10).replaceAll("-", "/");

    } else {
        gFromTime = fromTime.replaceAll("-", "/");
        gToTime = toTime.replaceAll("-", "/");
    }
    gFilterTimeType = type
    filterTime(type);

    let tasksFiltered = countFilteredTasks()

    if (tasksFiltered > 0) {
        filterConditions('time',type);
        generateArrays(true, false, 'applyTimeFilter',loadDiscoveryRules);
        setFilterIcon({ eventEmitter: gEventEmitter });
        alertMessage({
            eventEmitter: gEventEmitter,
            message: tasksFiltered +  ' issues match the filter',
            severity: 'success',
            showAlert: true,
            timeOutActive: true,
            component: 'activityFilter',
        });
    } else {
        gFilterSets--;
        alertMessage({
            eventEmitter: gEventEmitter,
            message: 'No matching issues',
            severity: 'info',
            showAlert: true,
            timeOutActive: true,
            component: 'timeFilter',
        });
    }
    return tasksFiltered
};

export const getDiagramColors = () => ({
    linkColor: gColorLink,
    startNodeColor: gColorStartNode,
    endNodeColor: gColorEndNode,
    selectLinkColor: gColorLinkSelect,
    animateColor: gAnimateColor,
    loopColor: gLoopColor,
    visualizerBackgroundColor: gVisualizerBackgroundColor,
});

export const updateDiagramDurationFormat = ({ days, hours, minutes, seconds }) => {
    gShowDurationDays = days ?? gShowDurationDays;
    gShowDurationHours = hours ?? gShowDurationHours;
    gShowDurationMinutes = minutes ?? gShowDurationMinutes;
    gShowDurationSeconds = seconds ?? gShowDurationSeconds;
};

export const getDiagramDurationFormat = () => ({
    days: gShowDurationDays,
    hours: gShowDurationHours,
    minutes: gShowDurationMinutes,
    seconds: gShowDurationSeconds,
});

export const updateDiagramStepLabels = ({
    tasks,
    avg_duration,
    total,

}) => {
    gShowLinkTasks = tasks ?? gShowLinkTasks;
    gShowLinkAvgDuration = avg_duration ?? gShowLinkAvgDuration;
    gShowLinkPercTotal = total ?? gShowLinkPercTotal;

};

export const getDiagramStepLabels = () => ({
    tasks: gShowLinkTasks,
    avg_duration: gShowLinkAvgDuration,
    total: gShowLinkPercTotal,
});

export const updateDiagramStepTooltip = ({
    tasks,
    avg_duration,
    med_duration,
    min_duration,
    max_duration,
    total,
    deviation,
    comments_customer,
    avg_comments_customer,
    comments_internal,
    avg_comments_internal,
    worklogs,
    avg_worklogs,
    perc_comments_internal,
    perc_comments_customer,
    perc_worklogs,
    total_timespent,
    avg_timespent,
}) => {
    gShowTooltipTasks = tasks ?? gShowTooltipTasks;
    gShowTooltipAvgDuration = avg_duration ?? gShowTooltipAvgDuration;
    gShowTooltipMedDuration = med_duration ?? gShowTooltipMedDuration;
    gShowTooltipMinDuration = min_duration ?? gShowTooltipMinDuration;
    gShowTooltipMaxDuration = max_duration ?? gShowTooltipMaxDuration;
    gShowTooltipPercTotal = total ?? gShowTooltipPercTotal;
    gShowTooltipDeviation = deviation ?? gShowTooltipDeviation;
    gShowTooltipCommentsCustomer = comments_customer ?? gShowTooltipCommentsCustomer;
    gShowTooltipAvgCommentsCustomer = avg_comments_customer ?? gShowTooltipAvgCommentsCustomer;
    gShowTooltipCommentsInternal = comments_internal ?? gShowTooltipCommentsInternal;
    gShowTooltipAvgCommentsInternal = avg_comments_internal ?? gShowTooltipAvgCommentsInternal;
    gShowTooltipWorklogs = worklogs ?? gShowTooltipWorklogs;
    gShowTooltipAvgWorklogs = avg_worklogs ?? gShowTooltipAvgWorklogs; 
    gShowTooltipPercCommentsInternal = perc_comments_internal ?? gShowTooltipPercCommentsInternal;
    gShowTooltipPercCommentsCustomer = perc_comments_customer ?? gShowTooltipPercCommentsCustomer;
    gShowTooltipPercWorklogs = perc_worklogs ?? gShowTooltipPercWorklogs;
    gShowTooltipTotalTimespent = total_timespent ?? gShowTooltipTotalTimespent;
    gShowTooltipAvgTimespent = avg_timespent ?? gShowTooltipAvgTimespent;
};

export const getDiagramStepTooltip = () => ({
    tasks: gShowTooltipTasks,
    avg_duration: gShowTooltipAvgDuration,
    med_duration: gShowTooltipMedDuration,
    min_duration: gShowTooltipMinDuration,
    max_duration: gShowTooltipMaxDuration,
    total: gShowTooltipPercTotal,
    deviation: gShowTooltipDeviation,
    comments_customer: gShowTooltipCommentsCustomer, 
    avg_comments_customer: gShowTooltipAvgCommentsCustomer,
    comments_internal: gShowTooltipCommentsInternal, 
    avg_comments_internal: gShowTooltipAvgCommentsInternal,
    worklogs: gShowTooltipWorklogs,
    avg_worklogs: gShowTooltipAvgWorklogs,
    perc_comments_internal: gShowTooltipPercCommentsInternal,
    perc_comments_customer: gShowTooltipPercCommentsCustomer,
    perc_worklogs: gShowTooltipPercWorklogs,
    total_timespent: gShowTooltipTotalTimespent,
    avg_timespent: gShowTooltipAvgTimespent,
});

export const updateDurationLabel = ({ duration }) => {
    gDurationLabel = duration ?? gDurationLabel;
};

export const getDurationLabel = () => ({
    duration: gDurationLabel,
});

export const updateDiagramNodeLabels = ({ tasks, perc_total }) => {
    gShowNodeTasks = tasks ?? gShowNodeTasks;
    gShowNodePercTotal = perc_total ?? gShowNodePercTotal;
};

export const setStepDetailProps = ({ from, to }) => {
    gDetailNodeFrom = from ?? gDetailNodeFrom;
    gDetailNodeTo = to ?? gDetailNodeTo;
    gDetailSource = 'stepgrid';
};

export const setActivityDetailProps = ({ activity }) => {
    gDetailActivity = activity ?? gDetailActivity;
    gDetailSource = 'activitygrid';
};

export const setDiscoveryRuleDetailProps = ({ discoveryRule, discovery_rule }) => {
    const value = discoveryRule ?? discovery_rule ?? gDetailDiscoveryRule;
    gDetailDiscoveryRule = value == null ? value : String(value).replace(/^f-/, '');
    gDetailSource = 'discoveryRulegrid';
};

export const setVariantDetailProps = ({ variant }) => {
    gDetailVariant = variant ?? gDetailVariant;
    gDetailSource = 'variantgrid';
};

export const updateDiagramStartLabel = ({ visible }) => {
    gShowStartLabel = visible ?? gShowStartLabel;
};

export const updateDiagramNodeShape = ({ node_shape }) => {
    gActivityShape = node_shape ?? gActivityShape;
};


export const updateDiagramZoomToFit = ({ visible }) => {
    gZoomToFit = visible ?? gZoomToFit;
};

export const updateDiagramShowColors = ({ visible }) => {
    gTimeColors = visible ?? gTimeColors;
};


export const updateDiagramSaveFilteredOnly = ({ filteredOnly }) => {
    gSaveFilteredOnly = filteredOnly ?? gSaveFilteredOnly;
};

export const updateIncludeStart = ({ includeStart }) => {
    gIncludeStart = includeStart ?? gIncludeStart;
};

export const updateDiagramEndLabel = ({ visible }) => {
    gShowEndLabel = visible ?? gShowEndLabel;
};

export const updateDiagramProcessFlowDirection = ({ direction }) => {
    gProcessFlowDirection = direction ?? gProcessFlowDirection;
};

export const updateDiagramSpacing = ({ layer, column }) => {
    gSpacingLayer = layer ?? gSpacingLayer;
    gSpacingColumn = column ?? gSpacingColumn;
};

export const getDiagramSpacing = () => ({
    layer: gSpacingLayer,
    column: gSpacingColumn,
});

export const updateDiagramPercOfEvents = ({ gauge }) => {
    gGaugePercEvents = gauge ?? gGaugePercEvents;
};

export const getDiagramPercOfEvents = () => ({
    gauge: gGaugePercEvents,
});

export const updateDiagramPercOfTasks = ({ gauge }) => {
    gGaugePercTasks = gauge ?? gGaugePercTasks;
};

export const getDiagramPercOfTasks = () => ({
    gauge: gGaugePercTasks,
});

export const getDiagramProcessFlowDirection = () => ({
    direction: gProcessFlowDirection,
});

export const updateDiagramXofYVariants = ({ gauge }) => {
    gGaugeXofYVariants = gauge ?? gGaugeXofYVariants;
};

export const getDiagramXofYVariants = () => ({
    gauge: gGaugeXofYVariants,
});

export const updateDiagramXofYSteps = ({ gauge }) => {
    gGaugeXofYSteps = gauge ?? gGaugeXofYSteps;
};

export const getDiagramXofYSteps = () => ({
    gauge: gGaugeXofYSteps,
});

export const updateDiagramXofYActivities = ({ gauge }) => {
    gGaugeXofYActivities = gauge ?? gGaugeXofYActivities;
};

export const getDiagramXofYActivities = () => ({
    gauge: gGaugeXofYActivities,
});


export const getDiagramStepLabelFontSize = () => ({
    font_size: gStepLabelFontSize,
});

export const updateDiagramStepLabelFontSize = ({ font_size }) => {
    gStepLabelFontSize = font_size ?? gStepLabelFontSize;
};

export const getDiagramNodeLabelFontSize = () => ({
    font_size: gNodeLabelFontSize,
});

export const updateDiagramNodeLabelFontSize = ({ font_size }) => {
    gNodeLabelFontSize = font_size ?? gNodeLabelFontSize;
};

export const getDetailEventSummaryAttribute = () => ({
    attribute: gDetailEventSummaryAttribute,
});

export const updateDetailEventSummaryAttribute = ({ attribute }) => {
    gDetailEventSummaryAttribute = attribute ?? gDetailEventSummaryAttribute;
};

export const getDetailTaskSummaryAttribute = () => ({
    attribute: gDetailTaskSummaryAttribute,
});

export const updateDetailTaskSummaryAttribute = ({ attribute }) => {
    gDetailTaskSummaryAttribute = attribute ?? gDetailTaskSummaryAttribute;
};

export const getAnalyticsTaskAttribute = () => ({
    attribute: gAnalyticsTaskAttribute,
});

export const getAnalyticsTaskAttributeMetric = () => ({
    metric: gAnalyticsTaskAttributeMetric,
});

export const updateAnalyticsTaskAttributeMetric = ({ metric }) => {
    gAnalyticsTaskAttributeMetric = metric ?? gAnalyticsTaskAttributeMetric;
};

export const getAnalyticsTaskHistoryMetric = () => ({
    metric: gAnalyticsTaskHistoryMetric,
});

export const updateAnalyticsTaskHistoryMetric = ({ metric }) => {
    gAnalyticsTaskHistoryMetric = metric ?? gAnalyticsTaskHistoryMetric;
};

export const updateAnalyticsTaskAttribute = ({ attribute }) => {
    gAnalyticsTaskAttribute = attribute ?? gAnalyticsTaskAttribute;
};

export const updateAnalyticsEventAttribute = ({ attribute }) => {
    gAnalyticsEventAttribute = attribute ?? gAnalyticsEventAttribute;
};

export const getDiagramNodeLabels = () => ({
    tasks: gShowNodeTasks,
    perc_total: gShowNodePercTotal,
});

export const getDiagramStartLabel = () => ({
    visible: gShowStartLabel,
});

export const getDiagramNodeShape = () => ({
    node_shape: gActivityShape,
});

export const getDiagramZoomToFit = () => ({
    visible: gZoomToFit,
});

export const getDiagramShowColors = () => ({
    visible: gTimeColors,
});


export const getDiagramEndLabel = () => ({
    visible: gShowEndLabel,
});

export const updateDiagramStepWidth = ({ tasks, duration, std_deviation }) => {
    gStepWidthTasks = tasks ?? gStepWidthTasks;
    gStepWidthDuration = duration ?? gStepWidthDuration;
    gStepWidthStdDeviation = std_deviation ?? gStepWidthStdDeviation;
};

export const setTaskDetailExtract = ({ type }) => {
    gTaskDetailExtract = type ?? gTaskDetailExtract;
};

export const setEventDetailExtract = ({ type }) => {
    gEventDetailExtract = type ?? gEventDetailExtract;
};

export const changeStepSelectRetention = ({ mode }) => {
    gStepSelectRetention = mode ?? gStepSelectRetention;
};

export const changePathSelectRetention = ({ mode }) => {
    gPathSelectRetention = mode ?? gPathSelectRetention;
};

export const changeActivitySelectRetention = ({ mode }) => {
    gActivitySelectRetention = mode ?? gActivitySelectRetention;
};

export const changeStepSelectOperator = ({ mode }) => {
    gStepSelectOperator = mode ?? gStepSelectOperator;
};

export const changePathSelectOperator = ({ mode }) => {
    gPathSelectOperator = mode ?? gPathSelectOperator;
};

export const changeActivitySelectOperator = ({ mode }) => {
    gActivitySelectOperator = mode ?? gActivitySelectOperator;
};

export const getDiagramStepWidth = () => ({
    tasks: gStepWidthTasks,
    duration: gStepWidthDuration,
    std_deviation: gStepWidthStdDeviation,
});


export const updateDiagramHighlight = ({
    highlightLoops,
    stepColourVolume,
    stepColourDuration,
    stepColourStdDeviation,
}) => {
    gHighlightLoops = highlightLoops ?? gHighlightLoops;
    gStepColourVolume = stepColourVolume ?? gStepColourVolume;
    gStepColourDuration = stepColourDuration ?? gStepColourDuration;
    gStepColourStdDeviation = stepColourStdDeviation ?? gStepColourStdDeviation;
};

export const getDiagramHighlight = () => ({
    highlightLoops: gHighlightLoops,
    stepColourVolume: gStepColourVolume,
    stepColourDuration: gStepColourDuration,
    stepColourStdDeviation: gStepColourStdDeviation,
});

export const updateDiagramShowNodes = ({ start, end }) => {
    gShowStartNode = start ?? gShowStartNode;
    gShowEndNode = end ?? gShowEndNode;
};

export const getDiagramShowNodes = () => ({
    start: gShowStartNode,
    end: gShowEndNode,
});

export const updateDiagramLoopDashes = ({ loopDashes }) => {
    gLoopDashes = loopDashes ?? gLoopDashes;
};

export const updateVisualizerBackgroundColorDiagram = ({ visualizerBackgroundColor }) => {
    gVisualizerBackgroundColor = visualizerBackgroundColor ?? gVisualizerBackgroundColor;
};

export const getDiagramLoopDashes = () => ({
    loopDashes: gLoopDashes,
});

export function getVisualizerBackgroundColorDiagram() {
    return gVisualizerBackgroundColor;
}

export function getDetailSource() {
    return gDetailSource;
}

export const getTaskTable = () => ({
    taskTable: gTaskTable,
});

export function changeActivePane(pane) {
    previousPane = activePane;
    activePane = pane;
}

export function getActivePane() {
    return activePane;
}

export const updateDiagramSelectAction = ({ isolate, animate, lifecycle }) => {
    gVariantIsolate = isolate ?? gVariantIsolate;
    gVariantAnimate = animate ?? gVariantAnimate;
    gVariantLifecycle = lifecycle ?? gVariantLifecycle;

    if (gVariantIsolate == false) {
        gIsolateVariant = 0;
    }
    if (gVariantAnimate == false) {
        gAnimateVariant = 0;
    }
    if (gVariantLifecycle == false) {
        gLifecycleVariant = 0;
    }
};

export const getDiagramSelectAction = () => ({
    isolate: gVariantIsolate,
    animate: gVariantAnimate,
    lifecycle: gVariantLifecycle,
});

export const getVariantArray = () => gVariantArray.filter(sliced == true);

export function variantFilterLoops(readOnly, checked, indeterminate) {
    gVariantLoops = null;
    if (checked == true && indeterminate == false) {
        gVariantLoops = false;
    }
    if (checked == false && indeterminate == true) {
        gVariantLoops = true;
    }
}

function generateLifeCycleArray() {
    let lifeCycleVariant = 0;
    for (let i = 0; i < gVariantArray.length; i++) {
        if (gVariantArray[i].s == gLifecycleVariant) {
            lifeCycleVariant = gVariantArray[i].v;
        }
    }
    let tArray = [];
    for (let i = 0; i < gLinkArray.length; i++) {
        if (gLinkArray[i].variant == lifeCycleVariant && gLinkArray[i].duplicate === false) {
            let linkOK = true;
            if ((gLinkArray[i].to_label === 'End' && gShowEndLabel === false) || (gLinkArray[i].to_label === 'Start' && gShowStartLabel === false)) {
                linkOK = false;
            }

            if (linkOK === true) {
                tArray.push(gLinkArray[i]);
            }
        }
    }
    return tArray.sort((a, b) => a.sort_key - b.sort_key);
}

function layout() {
    gDiagramPV.startTransaction('layout');
    let lay = gDiagramPV.layout;

    lay.layeringOption = go.LayeredDigraphLayout.LayerOptimalLinkLength;
    lay.initializeOption = go.LayeredDigraphLayout.InitDepthFirstIn;
    lay.aggressiveOption = go.LayeredDigraphLayout.AggressiveMore;
    lay.packOption = 2;

    gDiagramPV.commitTransaction('layout');
}

function generateNodes(nodeType) {
    return generateNodesPV(nodeType, {
        gActivityArray,
        gLinkArray,
        gVariantArray,
        gVariantPaneVariants,
        gDetailActivity,
        gShowStartNode,
        gShowEndNode,
        gShowStartLabel,
        gShowEndLabel,
        gShowNodeTasks,
        gShowNodePercTotal,
        gDiagramPVTasks,
        gEntityUpper,
        gActivityShape,
        gNodeLabelFontSize,
        gColorStartNode,
        gColorEndNode,
        numberWithCommas,
    });
}

function generateLinks(linkType) {
    // The extracted generatePV module cannot directly mutate the module-level
    // gDiagramPV* counters (because state destructuring creates const bindings).
    // So we pass a mutable `counters` object and then sync the globals after.
    const counters = {
        steps: gDiagramPVSteps,
        loops: gDiagramPVLoops,
        taskLoops: gDiagramPVTaskLoops,
        activities: gDiagramPVActivities,
    };

    const linkArray = generateLinksPV(linkType, {
        gLinkArray,
        gVariantArray,
        gVariantPaneVariants,
        gActivityArray,
        gDetailActivity,
        gEntityUpper,
        gAnimateVariant,
        gLifecycleVariant,
        gIsolateVariant,
        gVariantLoops,
        gDiagramPVTasks,
        counters,
        gShowStartNode,
        gShowEndNode,
        gShowStartLabel,
        gShowEndLabel,
        gShowLinkTasks,
        gShowLinkPercTotal,
        gShowLinkAvgDuration,
        gShowTooltipTasks,
        gShowTooltipPercTotal,
        gShowTooltipAvgDuration,
        gShowTooltipDeviation,
        gShowTooltipMaxDuration,
        gShowTooltipMinDuration,
        gShowTooltipCommentsInternal,
        gShowTooltipCommentsCustomer,
        gShowTooltipAvgCommentsInternal,
        gShowTooltipAvgCommentsCustomer,
        gShowTooltipWorklogs,
        gShowTooltipAvgWorklogs,
        gShowTooltipPercWorklogs,
        gShowTooltipPercCommentsInternal,
        gShowTooltipPercCommentsCustomer,
        gShowTooltipTotalTimespent,
        gShowTooltipAvgTimespent,
        gStepWidthTasks,
        gStepWidthDuration,
        gStepWidthStdDeviation,
        gStepLabelFontSize,
        gStepColourVolume,
        gStepColourDuration,
        gStepColourStdDeviation,
        gColorLink,
        gColorLinkSelect,
        gAnimateColor,
        gHighlightLoops,
        gLoopColor,
        gLoopDashes,
        numberWithCommas,
        formatDuration,
        formatDecimal,
        getStandardDeviation,
        getMedianDuration,
    });

    // Sync counters back to the existing globals
    if (counters) {
        gDiagramPVSteps = counters.steps;
        gDiagramPVLoops = counters.loops;
        gDiagramPVTaskLoops = counters.taskLoops;
        gDiagramPVActivities = counters.activities;
    }

    return linkArray;
}

export function numberWithCommas(x) {
    return Number(x).toLocaleString();
}

export function formatDecimal(x, y) {
    return numberWithCommas(x.toFixed(y));
}

export function formatPercentage(x, decimals) {
    return (x * 100).toFixed(decimals) + '%';
}

export function formatDuration(totalSeconds) {
    if (totalSeconds === undefined) return ''
    let years = Math.floor(totalSeconds / 31536000);
    totalSeconds %= 31536000;
    let days = Math.floor(totalSeconds / 86400);
    totalSeconds %= 86400;
    let hours = Math.floor(totalSeconds / 3600);
    totalSeconds %= 3600;
    let minutes = Math.floor(totalSeconds / 60);
    totalSeconds %= 60;
    let seconds = Math.floor(totalSeconds);

    let duration_str = '';
    if (days >= 1 && gShowDurationDays == true) {

        if (years > 0) {duration_str = duration_str + years + 'y '}
        duration_str = duration_str + days + 'd ';
    }
    if (hours >= 1 && gShowDurationHours == true) {
        if (gShowDurationDays == false && days >= 1) {
            hours = hours + days * 24;
        }
        duration_str = duration_str + hours + 'h ';
    }
    if (minutes >= 1 && gShowDurationMinutes == true) {
        if (gShowDurationHours == false && hours >= 1) {
            minutes = minutes + hours * 60;
        }
        duration_str = duration_str + minutes + 'm ';
    }
    if (seconds >= 1 && gShowDurationSeconds == true) {
        if (gShowDurationMinutes == false && gShowDurationHours == false && gShowDurationDays == false) {
            seconds = seconds + (minutes * 60) + (days * 84600) + (hours * 3600)
        }
        if (gShowDurationMinutes == false && gShowDurationHours == false && gShowDurationDays == true) {
            seconds = seconds + (minutes * 60) + (hours * 3600)
        }
        duration_str = duration_str + seconds + 's ';
    }
    if (duration_str.includes('Na')) {
        duration_str = '';
    }
    if (duration_str == '' && gShowDurationDays == true) {
        duration_str = '0d ';
    }
    if (duration_str == '0d ' && gShowDurationHours == true) {
        duration_str = '0h ';
    }
    if (duration_str == '0h ' && gShowDurationMinutes == true) {
        duration_str = '0m ';
    }
    if (duration_str == '0m ' && gShowDurationSeconds == true) {
        duration_str = '0s ';
    }
    return duration_str;
}

export function formatDurationMinutes(totalMinutes) {
    let days = Math.floor(totalMinutes / 1440);
    totalMinutes %= 1440;
    let hours = Math.floor(totalMinutes / 60);
    totalMinutes %= 60;
    let minutes = Math.floor(totalMinutes);

    let duration_str = '';
    if (days >= 1) {
        duration_str = days + 'd ' + hours + 'h ' + minutes + 'm ';
    } else {
        duration_str = hours + 'h ' + minutes + 'm ';
    }
    if (duration_str.includes('Na')) {
        duration_str = '';
    }
    return duration_str;
}

export function formatImpactDuration(seconds) {
    let days = Math.floor(seconds / 86400);
    seconds %= 86400;
    let hours = Math.floor(seconds / 3600);
    seconds %= 3600;

    let duration_str = '';
    if (days >= 1) {
        duration_str = duration_str + days + 'd ';
    }
    if (hours >= 1) {
        if (gShowDurationDays == false && days >= 1) {
            hours = hours + days * 24;
        }
        duration_str = duration_str + hours + 'h ';
    }
    return duration_str;
}

export function VariantSelected(selectedVariant) {
    if (gAnimateVariant == selectedVariant) {
        gAnimateVariant = 0;
    } else if (gVariantAnimate) {
        gAnimateVariant = selectedVariant;
    }
    if (gIsolateVariant == selectedVariant) {
        gIsolateVariant = 0;
    } else if (gVariantIsolate) {
        gIsolateVariant = selectedVariant;
    }

    if (gLifecycleVariant == selectedVariant) {
        gLifecycleVariant = 0;
    } else if (gVariantLifecycle) {
        gLifecycleVariant = selectedVariant;
    }
    runWithoutLayoutAnimation(gDiagramPV, rebuildPVDiagram);
}

export const changeMaxVariantsStep = (max) => {
    gMaxselectedVariants = max;
};

export function processAttributesTable(attribute, attributeType, source) { 
    const rows = [];
    for (let i = 0; i < gAttributeArray.length; i++) {
        if (gAttributeArray[i].type == attributeType && gAttributeArray[i].field == attribute) {
            rows.push({
                value: gAttributeArray[i].value,
                tasks: gAttributeArray[i].tasks,
                events: gAttributeArray[i].events,
                perc_total_tasks: gAttributeArray[i].perc_total_tasks,
                perc_total_events: gAttributeArray[i].perc_total_events,
                avg_duration: gAttributeArray[i].avg_duration,
                std_deviation: gAttributeArray[i].std_deviation,
                selected: gAttributeArray[i].selected,
            });
        }
    }
    return rows.map((row, id) => ({ id, ...row }));
}

export function processStepsTable(sortColumn) {
    let totalEvents = gEventsFiltered;
    // gTasksFiltered may still be 0 if called before generateTasksFilteredArray completes.
    // Fall back to summing unique tasks across all visible steps so percentages are meaningful.
    let totalTasks = gTasksFiltered || gTaskArray.length || 0;
    const rows = [];
    let tasks1 = 0
    for (let i = 0; i < gStepArray.length; i++) {
        if (gStepArray[i].filtered == 0) {
            let from_activity = '';
            let to_activity = '';
            for (let j = 0; j < gActivityArray.length; j++) {
                if (gActivityArray[j].id == gStepArray[i].from) {
                    from_activity = gActivityArray[j].activity;
                }
                if (gActivityArray[j].id == gStepArray[i].to) {
                    to_activity = gActivityArray[j].activity;
                }
            }
            let year = gStepArray[i].max_timestamp.substr(0, 4);
            let month = gStepArray[i].max_timestamp.substr(5, 2) - 1;
            let day = gStepArray[i].max_timestamp.substr(8, 2);
            let maxDate = new Date(year, month, day);
            var currentDate =   new Date();   
            if (to_activity != 'End') {
                tasks1 = tasks1 + gStepArray[i].tasks
                rows.push({
                    from_activity: from_activity,
                    to_activity: to_activity,
                    from_activity_id: gStepArray[i].from,
                    to_activity_id: gStepArray[i].to,
                    step: from_activity + ' - ' + to_activity,
                    events: gStepArray[i].events,
                    tasks: gStepArray[i].tasks,
                    total_duration: gStepArray[i].total_duration,
                    avg_duration: gStepArray[i].avg_duration,
                    std_deviation: gStepArray[i].std_deviation,
                    avg_duration_days: gStepArray[i].avg_duration / 86400,
                    avg_duration_hrs: gStepArray[i].avg_duration / 3600,
                    std_deviation_days: gStepArray[i].std_deviation / 86400,
                    std_deviation_hrs: gStepArray[i].std_deviation / 3600,
                    min_duration: gStepArray[i].min_duration,
                    max_duration: gStepArray[i].max_duration,
                    loop: gStepArray[i].loop,
                    perc_total_events: gStepArray[i].events / totalEvents,
                    perc_total_tasks: totalTasks > 0 ? gStepArray[i].tasks / totalTasks : 0,
                    event_actual_cost: gStepArray[i].actual_cost / gStepArray[i].events, 
                    event_forecast_cost: gStepArray[i].forecast_cost / gStepArray[i].events,
                    event_cost_savings: gStepArray[i].actual_cost / gStepArray[i].events - gStepArray[i].forecast_cost / gStepArray[i].events,
                    step_actual_cost: gStepArray[i].actual_cost,
                    step_forecast_cost: gStepArray[i].forecast_cost,
                    step_cost_savings: gStepArray[i].actual_cost - gStepArray[i].forecast_cost,
                    comments_customer: gStepArray[i].comment_customer_ctr ,
                    comments_internal: gStepArray[i].comment_internal_ctr ,
                    perc_comments_customer: gStepArray[i].tasks_comments_customer / gStepArray[i].tasks,  
                    perc_comments_internal: gStepArray[i].tasks_comments_internal / gStepArray[i].tasks,  
                    perc_worklog: gStepArray[i].tasks_worklog / gStepArray[i].tasks,  
                    avg_comments_customer: gStepArray[i].comment_customer_ctr / gStepArray[i].events,
                    avg_comments_internal: gStepArray[i].comment_internal_ctr / gStepArray[i].events,
                    worklogs: gStepArray[i].worklog_ctr , 
                    avg_worklogs: gStepArray[i].worklog_ctr / gStepArray[i].events,
                    time_spent: gStepArray[i].time_spent,
                    avg_time_spent: gStepArray[i].time_spent/ gStepArray[i].events,
                    age: diffDays(maxDate,currentDate)
                });
            }
        }
    }
    if (sortColumn.sortColumn !== undefined) {
        if (sortColumn.sortColumn === 'issues' ) rows.sort((a, b) => b.tasks - a.tasks);
        if (sortColumn.sortColumn === 'avg_duration') rows.sort((a, b) => b.avg_duration - a.avg_duration);

    } else rows.sort((a, b) => b.tasks - a.tasks);

    let tasks2 = 0
    for (let i = 0; i < rows.length; i++) {
        tasks2 = tasks2 + rows[i].tasks
    }
    return rows.map((row, id) => ({ id, ...row }));;
}

export function getInitialLoad() {
    return gInitialLoad;
}

export function getInitialAALoad() {
    return gInitialAALoad;
}

export function setInitialAALoad(value) {
    gInitialAALoad = value;
}


export function processVariantsTable(sortColumn) {
    let totalEvents = 0;
    let totalTasks = 0;
    gVariantArray.sort((a, b) => a.filtered - b.filtered);

    for (let i = 0; i < gVariantArray.length; i++) {
        if (gVariantArray[i].filtered == 1) {
            break;
        }
        if (gVariantArray[i].sliced == true) {
            totalTasks = totalTasks + gVariantArray[i].t;
            totalEvents = totalEvents + gVariantArray[i].e;
        }
    }
    const rows = [];
    for (let i = 0; i < gVariantArray.length; i++) {
        if (gVariantArray[i].filtered == 1) {
            break;
        }
        if (gVariantArray[i].sliced == true) {

            let year = gVariantArray[i].max_timestamp.substr(0, 4);
            let month = gVariantArray[i].max_timestamp.substr(5, 2) - 1;
            let day = gVariantArray[i].max_timestamp.substr(8, 2);
            let maxDate = new Date(year, month, day);
            var currentDate = new Date();   
            rows.push({
                variant: gVariantArray[i].n,
                sequence: gVariantArray[i].s,
                tasks: gVariantArray[i].t,
                avg_duration: gVariantArray[i].ad,
                min_duration: gVariantArray[i].min_duration,
                max_duration: gVariantArray[i].max_duration,
                total_duration: gVariantArray[i].total_duration,
                std_deviation: gVariantArray[i].sd,
                avg_duration_days: (Math.round((gVariantArray[i].ad / 86400) * 100) / 100).toFixed(2),
                avg_duration_hrs: (Math.round((gVariantArray[i].ad / 3600) * 100) / 100).toFixed(2),
                std_deviation_days: (Math.round((gVariantArray[i].sd / 86400) * 100) / 100).toFixed(2),
                std_deviation_hrs: (Math.round((gVariantArray[i].sd / 3600) * 100) / 100).toFixed(2),
                task_actual_cost: gVariantArray[i].actual_cost / gVariantArray[i].t,
                task_forecast_cost: gVariantArray[i].forecast_cost / gVariantArray[i].t,
                task_cost_savings: gVariantArray[i].actual_cost / gVariantArray[i].t - gVariantArray[i].forecast_cost / gVariantArray[i].t,
                variant_actual_cost: gVariantArray[i].actual_cost,
                variant_forecast_cost: gVariantArray[i].forecast_cost,
                variant_cost_savings: gVariantArray[i].actual_cost - gVariantArray[i].forecast_cost,
                loop: gVariantArray[i].l,
                loops: gVariantArray[i].loops,
                events: gVariantArray[i].e,
                variant_id: gVariantArray[i].v,
                selected: gVariantArray[i].selected,
                perc_total_tasks: gVariantArray[i].t / totalTasks,
                perc_total_events: gVariantArray[i].e / totalEvents,
                steps: gVariantArray[i].steps,
                activities: gVariantArray[i].activities,
                age: diffDays(maxDate,currentDate)
            });
        }
    }

    if (sortColumn !== undefined) {
        if (sortColumn === (gEntityUpper + 's') ) rows.sort((a, b) => b.tasks - a.tasks);
        if (sortColumn === 'avg_duration') rows.sort((a, b) => b.avg_duration - a.avg_duration);

    } else rows.sort((a, b) => b.tasks - a.tasks);
    gVariants = rows.length;
    return rows;
}

export function processActivitiesTable(sortColumn) {
    let totalTasks = gTasksFiltered;
    const rows = [];
    for (let i = 0; i < gActivityArray.length; i++) {
        if (gActivityArray[i].activity !== 'End' && gActivityArray[i].activity !== 'Start' && gActivityArray[i].filtered == 0) {
            let year = gActivityArray[i].max_timestamp.substr(0, 4);
            let month = gActivityArray[i].max_timestamp.substr(5, 2) - 1;
            let day = gActivityArray[i].max_timestamp.substr(8, 2);
            let maxDate = new Date(year, month, day);
            var currentDate =   new Date();   

            rows.push({
                activity: gActivityArray[i].activity,
                activity_type: gActivityArray[i].activity_type,
                activity_id: gActivityArray[i].id,
                tasks: gActivityArray[i].tasks,
                perc_total: gActivityArray[i].tasks / totalTasks,
                total_duration: gActivityArray[i].total_duration,
                avg_duration: gActivityArray[i].avg_duration,
                std_deviation: gActivityArray[i].std_deviation,
                avg_duration_days: gActivityArray[i].avg_duration / 86400,
                avg_duration_hrs: gActivityArray[i].avg_duration / 3600,
                std_deviation_days: gActivityArray[i].std_deviation / 86400,
                std_deviation_hrs: gActivityArray[i].std_deviation / 3600,
                age: diffDays(maxDate,currentDate)
            });
        }
    }

    if (sortColumn.sortColumn !== undefined) {
        if (sortColumn.sortColumn === (gEntityUpper + 's') ) rows.sort((a, b) => b.tasks - a.tasks);
        if (sortColumn.sortColumn === 'avg_duration') rows.sort((a, b) => b.avg_duration - a.avg_duration);

    } else rows.sort((a, b) => b.tasks - a.tasks);
    rows.map((row, id) => ({ id, ...row }));;
    return rows;
}

export function processActivityTypeTable() {
    const rows = [];
    for (let i = 0; i < gActivityTypes.length; i++) {

        rows.push({
            activity_type: gActivityTypes[i].activity_type,
            name: gActivityTypes[i].name,
            id: gActivityTypes[i].id,
            events: gActivityTypes[i].events,
            });
    }
    rows.map((row, id) => ({ id, ...row }));;
    return rows;
}

export function processTasksTable() {
    const rows = [];
    for (let i = 0; i < gTaskArray.length; i++) {
        if (gTaskArray[i].filtered == 0) {
            rows.push({
                task: gTaskArray[i].k,
                duration: gTaskArray[i].d,
                actual_cost: gTaskArray[i].actual_cost,
                forecast_cost: gTaskArray[i].forecast_cost,
                duration_days: (Math.round((gTaskArray[i].d / 86400) * 100) / 100).toFixed(2),
                duration_hrs: (Math.round((gTaskArray[i].d / 3600) * 100) / 100).toFixed(2),
                variant_id: gTaskArray[i].vid,
            });
        }
    }
    return rows;
}

export function processDetailEventSummary() {
    
    gDetailDescription = '';
    if (gDetailSource === 'step' || gDetailSource === 'stepgrid') {
        let fromStr = '';
        let toStr = '';
        for (let i = 0; i < gActivityArray.length; i++) {
            if (gActivityArray[i].id === parseInt(gDetailNodeFrom)) {
                fromStr = gActivityArray[i].activity;
            }
            if (gActivityArray[i].id === parseInt(gDetailNodeTo)) {
                toStr = gActivityArray[i].activity;
            }
        }
        gDetailDescription = 'Step: ' + fromStr + ' - ' + toStr;
    }
    if (gDetailSource === 'activity' || gDetailSource === 'activitygrid') {
        let activityStr = '';
        for (let i = 0; i < gActivityArray.length; i++) {
            if (gActivityArray[i].id === parseInt(gDetailActivity)) {
                activityStr = gActivityArray[i].activity;
            }
        }
        gDetailDescription = 'Activity: ' + activityStr;
    }

    if (gDetailSource === 'variantgrid') {
        let variantStr = '';
        for (let i = 0; i < gVariantArray.length; i++) {
            if (gVariantArray[i].v === gDetailVariant) {
                variantStr = gVariantArray[i].n;
            }
        }
        gDetailDescription = 'Variant: ' + variantStr;
    }
    if (gDetailSource === 'diagram') {
        gDetailDescription = 'Current variants in visualizer';
    }
    if (gDetailSource === 'dt_node') {
        gDetailDescription = 'decomposition_tree';
    }
    if (gDetailSource === 'ia_node') {
        gDetailDescription = 'influence_analysis';
    }
    if (gDetailSource === 'rc_node') {
        gDetailDescription = 'cluster_insights';
    }
    if (gDetailSource === 'task' || gDetailSource === 'tia') {  
        gDetailDescription = getEntityUpper() + ': ' + gTaskID;
    }

    gEventLogArray.sort((a, b) => a.elid - b.elid);
    gTaskArray.sort((a, b) => a.filtered - b.filtered);
    gVariantArray.sort((a, b) => a.id - b.id);

    let detailTaskArray1 = [];
    let detailTaskArray2 = [];

    if (gDetailSource === 'dt_node') {
        detailTaskArray1 = gDecompositionTreeTaskArray;
    }
    if (gDetailSource === 'rc_node' || gDetailSource === 'ia_node') {
        let tempArray = gTaskStr.split('^');
        gTaskArray.sort((a, b) => a.id - b.id);
        for (let i = 0; i < tempArray.length; i++) {
            detailTaskArray1.push(gTaskArray[parseInt(tempArray[i])]);
        }
    }

    if (
        gDetailSource === 'step' ||
        gDetailSource === 'activity' ||
        gDetailSource === 'diagram' ||
        gDetailSource === 'task' ||
        gDetailSource === 'all' ||
        gDetailSource === 'stepgrid' ||
        gDetailSource === 'activitygrid' ||
        gDetailSource === 'variantgrid'
    ) {
        detailTaskArray1 = gTaskArray;
    }
    for (let i = 0; i < detailTaskArray1.length; i++) {
        if (detailTaskArray1[i].filtered === 1) {
            break;
        }
        let validTask = true;

        if (gDetailSource === 'step') {
            validTask = false;
            for (let f = detailTaskArray1[i].si; f < detailTaskArray1[i].fi + 1; f++) {
                if (parseInt(gEventLogArray[f].f) === parseInt(gDetailNodeFrom) && parseInt(gEventLogArray[f].t) === parseInt(gDetailNodeTo)) {
                    for (let j = 0; j < gVariantPaneVariants.length; j++) {
                        if (detailTaskArray1[i].v == gVariantPaneVariants[j].v) {
                            validTask = true;
                            break;
                        }
                    }
                    if (validTask == true) {
                        break;
                    }
                }
            }
        }
        if (gDetailSource === 'stepgrid') {
            validTask = false;
            for (let f = detailTaskArray1[i].si; f < detailTaskArray1[i].fi + 1; f++) {
                if (parseInt(gEventLogArray[f].f) === parseInt(gDetailNodeFrom) && parseInt(gEventLogArray[f].t) === parseInt(gDetailNodeTo)) {
                    validTask = true;
                    break;
                }
            }
        }
        if (gDetailSource === 'activity') {
            validTask = false;
            for (let f = detailTaskArray1[i].si; f < detailTaskArray1[i].fi + 1; f++) {
                if (parseInt(gEventLogArray[f].t) === parseInt(gDetailActivity)) {
                    for (let j = 0; j < gVariantPaneVariants.length; j++) {
                        if (detailTaskArray1[i].v == gVariantPaneVariants[j].v) {
                            validTask = true;
                            break;
                        }
                    }
                    if (validTask == true) {
                        break;
                    }
                }
            }
        }

        if (gDetailSource === 'task') {
            validTask = false;
            if (detailTaskArray1[i].k === gTaskID) {
                validTask = true;
            }
        }

        if (gDetailSource === 'activitygrid') {
            validTask = false;
            for (let f = detailTaskArray1[i].si; f < detailTaskArray1[i].fi + 1; f++) {
                if (parseInt(gEventLogArray[f].t) === parseInt(gDetailActivity)) {
                    validTask = true;
                    break;
                }
            }
        }
        if (gDetailSource === 'diagram') {
            validTask = false;
            for (let f = detailTaskArray1[i].si; f < detailTaskArray1[i].fi + 1; f++) {
                for (let j = 0; j < gVariantPaneVariants.length; j++) {
                    if (detailTaskArray1[i].v == gVariantPaneVariants[j].v) {
                        validTask = true;
                        break;
                    }
                }
                if (validTask == true) {
                    break;
                }
            }
        }
        if (gDetailSource === 'variantgrid') {
            validTask = false;
            if (detailTaskArray1[i].v === gDetailVariant) {
                validTask = true;
            }
        }
        if (gDetailSource === 'all') validTask = true;
        if (validTask === true) {
            detailTaskArray2.push(detailTaskArray1[i]);
        }
    }
    let endNode = 0;
    for (let j = 0; j < gActivityArray.length; j++) {
        if (gActivityArray[j].end_node == true) {
            endNode = gActivityArray[j].id;
        }
    }

    let eventArray = [];
    for (let i = 0; i < detailTaskArray2.length; i++) {
        // extract events based on detailTaskArray2
        if (gDetailSource === 'step' || gDetailSource === 'stepgrid') {
            for (let f = detailTaskArray2[i].si; f < detailTaskArray2[i].fi; f++) {
                if (parseInt(gEventLogArray[f].f) === parseInt(gDetailNodeFrom) && parseInt(gEventLogArray[f].t) === parseInt(gDetailNodeTo) && gEventLogArray[f].filtered === 0) {
                    eventArray.push(gEventLogArray[f]);
                }
            }
        }
        if (gDetailSource === 'activity' || gDetailSource === 'activitygrid') {
            for (let f = detailTaskArray2[i].si; f < detailTaskArray2[i].fi; f++) {
                if (parseInt(gEventLogArray[f].t) === parseInt(gDetailActivity)  && gEventLogArray[f].filtered === 0) {
                    eventArray.push(gEventLogArray[f]);
                }
            }
        }

        if (
            gDetailSource === 'diagram' ||
            gDetailSource === 'variantgrid' ||
            gDetailSource === 'task' ||
            gDetailSource === 'rc_node' ||
            gDetailSource === 'ia_node' ||
            gDetailSource === 'all' ||
            gDetailSource === 'dt_node'
        ) {
            for (let f = detailTaskArray2[i].si; f < detailTaskArray2[i].fi; f++) {
                if ( gEventLogArray[f].filtered === 0) eventArray.push(gEventLogArray[f]);
            }
        }
    }
    const rows = [];
    if (gEventDetailExtract === 'summary') {
        let eventAttribute = '';
        if (gDetailEventSummaryAttribute == '') {
            eventAttribute = 'u'; // resource
        } else {
            if (gDetailEventSummaryAttribute == 'Resource') {
                eventAttribute = 'u';
            } else {
                for (let i = 0; i < gEventAttributes.length; i++) {
                    if (gEventAttributes[i].field == gDetailEventSummaryAttribute) {
                        eventAttribute = gEventAttributes[i].id;
                    }
                }
            }
        }

        eventArray.sort((a, b) => a[eventAttribute].localeCompare(b[eventAttribute]));
        let totalEvents = eventArray.length;
        let events = 0;
        let duration = 0;
        let min_duration = 999999999999;
        let max_duration = 0;
        let actual_cost = 0;
        let forecast_cost = 0;
        let sdArray = [];
        let sd_seconds = 0;

        let attributeValue = '';
        let i = 0;
        for (i = 0; i < eventArray.length; i++) {
            if (i > 0 && eventArray[i][eventAttribute] != attributeValue) {
                rows.push({
                    attribute: attributeValue,
                    events: events,
                    avg_duration: duration / events,
                    min_duration: min_duration,
                    max_duration: max_duration,
                    avg_duration_days: (Math.round((duration / events / 86400) * 100) / 100).toFixed(2),
                    avg_duration_hrs: (Math.round((duration / events / 3600) * 100) / 100).toFixed(2),
                    std_deviation: getStandardDeviation(sdArray),
                    std_deviation_days: (Math.round((getStandardDeviation(sdArray) / 86400) * 100) / 100).toFixed(2),
                    std_deviation_hrs: (Math.round((getStandardDeviation(sdArray) / 3600) * 100) / 100).toFixed(2),
                    perc_total_events: events / totalEvents,
					event_actual_cost: actual_cost / events,
                    event_forecast_cost: forecast_cost / events,
                    event_cost_savings: actual_cost / events - forecast_cost / events,
                    
                });
                events = 0;
                duration = 0;
                min_duration = 999999999999;
                max_duration = 0;
                actual_cost = 0;
                forecast_cost = 0;
                sdArray = [];
                sd_seconds = 0;
            }
            attributeValue = eventArray[i][eventAttribute];
            events++;
            duration = duration + eventArray[i].d;
            if (eventArray[i].d < min_duration) {
                min_duration = eventArray[i].d;
            }
            if (eventArray[i].d > max_duration) {
                max_duration = eventArray[i].d;
            }
            actual_cost = actual_cost + eventArray[i].actual_cost;
            forecast_cost = forecast_cost + eventArray[i].forecast_cost;
            sdArray.push(parseInt(eventArray[i].d));
        }
        if (i > 0) {
            rows.push({
                attribute: attributeValue,
                events: events,
                avg_duration: duration / events,
                min_duration: min_duration,
                max_duration: max_duration,
                avg_duration_days: (Math.round((duration / events / 86400) * 100) / 100).toFixed(2),
                avg_duration_hrs: (Math.round((duration / events / 3600) * 100) / 100).toFixed(2),
                std_deviation: getStandardDeviation(sdArray),
                std_deviation_days: (Math.round((getStandardDeviation(sdArray) / 86400) * 100) / 100).toFixed(2),
                std_deviation_hrs: (Math.round((getStandardDeviation(sdArray) / 3600) * 100) / 100).toFixed(2),
                perc_total_events: events / totalEvents,
				event_actual_cost: actual_cost / events,
                event_forecast_cost: forecast_cost / events,
                event_cost_savings: actual_cost / events - forecast_cost / events,
                
            });
        }
        rows.sort((a, b) => (b.events > a.events ? 1 : -1));
    } else {
        gTaskArray.sort((a, b) => a.id - b.id);
        for (let i = 0; i < eventArray.length; i++) {
            let fromActivity = '';
            let toActivity = '';
            for (let j = 0; j < gActivityArray.length; j++) {
                if (gActivityArray[j].id == eventArray[i].f) {
                    fromActivity = gActivityArray[j].activity;
                }
                if (gActivityArray[j].id == eventArray[i].t) {
                    toActivity = gActivityArray[j].activity;
                }
            }
            let vtp = {};
            vtp[gEntityUpper + ' #'] = eventArray[i].k;
            vtp['From Activity'] = fromActivity;
            vtp['To Activity'] = toActivity;
            vtp['Duration'] = eventArray[i].d ;
            vtp['Timestamp'] = eventArray[i].ts;

            if (gEventDetailExtract != 'tia') {
                for (let j = 0; j < gTaskAttributes.length; j++) {
                    const rawVal = gTaskArray[eventArray[i].tid]?.[gTaskAttributes[j].id];
                    vtp[gTaskAttributes[j].field] = rawVal != null ? String(rawVal).replaceAll('^^', ',') : '';
                }
            }

            let customer_comments = 0;
            let internal_comments = 0;
            let worklogs = 0
            let time_spent = 0

            let comments = eventArray[i].comments  
            let worklog = eventArray[i].worklog
            if (comments !== undefined) {
                for (let c = 0; c < comments.length; c++) {
                    if (comments[c].jsdPublic === 'true') customer_comments ++
                    else internal_comments ++
                }
            }
            if (worklog !== undefined) {
                for (let w = 0; w < worklog.length; w++) {
                    worklogs ++
                    time_spent = time_spent + parseInt(worklog[w].timeSpentSeconds)  
                }         
            }

            for (let j = 0; j < gEventAttributes.length; j++) {
                if (gEventAttributes[j].field == 'Resource') {
                    vtp[gEventAttributes[j].field] = eventArray[i].u;
                } else {
                    vtp[gEventAttributes[j].field] = eventArray[i][gEventAttributes[j].id];
                }
            }

            vtp['Internal Comments'] = internal_comments;
            vtp['Customer Comments'] = customer_comments;
            vtp['Worklogs'] = worklogs;
            vtp['Time Spent'] = time_spent;

			vtp['Actual Cost'] = eventArray[i].actual_cost;
            vtp['Forecast Cost'] = eventArray[i].forecast_cost;
            vtp['ID'] = eventArray[i].elid;

            vtp['k'] = eventArray[i].k

            rows.push(vtp);
        }
    }
    return rows;
}

export function updateNodeTaskArrayforTaskLifecyle() {
    gTasksFilteredArray = [];

    if (gTasksVisualizationSource === 'dt_node') {
        gTasksFilteredArray = gDecompositionTreeTaskArray;
    }
    if (gTasksVisualizationSource === 'rc_node' || gTasksVisualizationSource === 'ia_node') {
        let tempArray = gTaskStr.split('^');
        gTaskArray.sort((a, b) => a.id - b.id);
        for (let i = 0; i < tempArray.length; i++) {
            gTasksFilteredArray.push(gTaskArray[parseInt(tempArray[i])]);
        }
    }
}

export function processDetailTaskSummary() { 

    if (gTaskAttributes.length == 0) {
        return [];
    }
    gEventLogArray.sort((a, b) => a.elid - b.elid);
    gVariantArray.sort((a, b) => a.id - b.id);
    gTaskArray.sort((a, b) => a.id - b.id);

    gDetailDescription = '';

    if (gDetailSource === 'step' || gDetailSource === 'stepgrid') {
        let fromStr = '';
        let toStr = '';
        for (let i = 0; i < gActivityArray.length; i++) {
            if (gActivityArray[i].id === parseInt(gDetailNodeFrom)) {
                fromStr = gActivityArray[i].activity;
            }
            if (gActivityArray[i].id === parseInt(gDetailNodeTo)) {
                toStr = gActivityArray[i].activity;
            }
        }
        gDetailDescription = 'Step: ' + fromStr + ' - ' + toStr;
    }
    if (gDetailSource === 'activity' || gDetailSource === 'activitygrid') {
        let activityStr = '';
        for (let i = 0; i < gActivityArray.length; i++) {
            if (gActivityArray[i].id === parseInt(gDetailActivity)) {
                activityStr = gActivityArray[i].activity;
            }
        }
        gDetailDescription = 'Activity: ' + activityStr;
    }
    if (gDetailSource === 'discovery_rule' || gDetailSource === 'discoveryRulegrid') {  
        let discoveryRuleStr = '';
        let temp = processDiscoveryRulesSummary()
        for (let i = 0; i < temp.length; i++) {
            if (temp[i].discovery_rule_id === parseInt(gDetailDiscoveryRule)) {
                discoveryRuleStr = temp[i].discovery_rule;
            }
        }
        gDetailDescription = 'Discovery Rule: ' + discoveryRuleStr;
    }
    if (gDetailSource === 'variantgrid') {
        let variantStr = '';
        for (let i = 0; i < gVariantArray.length; i++) {
            if (gVariantArray[i].v === gDetailVariant) {
                variantStr = gVariantArray[i].n;
            }
        }
        gDetailDescription = 'Variant: ' + variantStr;
    }
    if (gDetailSource === 'diagram') {
        gDetailDescription = 'Current variants in visualizer';
    }
    if (gDetailSource === 'dt_node') {
        gDetailDescription = 'decomposition_tree';
    }
    if (gDetailSource === 'ia_node') {
        gDetailDescription = 'influence_analysis';
    }
    if (gDetailSource === 'rc_node') {
        gDetailDescription = 'cluster_insights';
    }

    let detailTaskArray1 = [];
    let detailTaskArray2 = [];

    if (gDetailSource === 'dt_node') {
        detailTaskArray1 = gDecompositionTreeTaskArray;
    }
    if (gDetailSource === 'rc_node' || gDetailSource === 'ia_node') {
        let tempArray = gTaskStr.split('^');
        for (let i = 0; i < tempArray.length; i++) {
            detailTaskArray1.push(gTaskArray[parseInt(tempArray[i])]);
        }
    }
    if (
        gDetailSource === 'step' ||
        gDetailSource === 'discoveryRulegrid' ||
        gDetailSource === 'activity' ||
        gDetailSource === 'diagram' ||
        gDetailSource === 'stepgrid' ||
        gDetailSource === 'activitygrid' ||
        gDetailSource === 'all' ||
        gDetailSource === 'variantgrid'
    ) {
        detailTaskArray1 = gTaskArray;
    }
    gTaskArray.sort((a, b) => a.filtered - b.filtered);
    for (let i = 0; i < detailTaskArray1.length; i++) {
        if (detailTaskArray1[i].filtered === 1) {
            break;
        }
        let validTask = true;
        let ctr = 0
        if (gDetailSource === 'discoveryRulegrid') { 
            validTask = false;
            for (let f = detailTaskArray1[i].si; f < detailTaskArray1[i].fi + 1; f++) {
                const eventDiscoveryRules = Array.isArray(gEventLogArray[f]?.discovery_rules) ? gEventLogArray[f].discovery_rules : [];
                for (let j = 0; j < eventDiscoveryRules.length; j++) {
                    if (eventDiscoveryRules[j].discovery_rule_id == gDetailDiscoveryRule) { 
                        ctr ++
                        validTask = true;
                        break;
                    }
                }
                if (validTask == true) {
                    break;
                }
            }
        }

        if (gDetailSource === 'step') {
            validTask = false;
            for (let f = detailTaskArray1[i].si; f < detailTaskArray1[i].fi + 1; f++) {
                if (parseInt(gEventLogArray[f].f) === parseInt(gDetailNodeFrom) && parseInt(gEventLogArray[f].t) === parseInt(gDetailNodeTo)) {
                    for (let j = 0; j < gVariantPaneVariants.length; j++) {
                        if (detailTaskArray1[i].v == gVariantPaneVariants[j].v) {
                            validTask = true;
                            break;
                        }
                    }
                    if (validTask == true) {
                        break;
                    }
                }
            }
        }
        if (gDetailSource === 'stepgrid') {
            validTask = false;
            for (let f = detailTaskArray1[i].si; f < detailTaskArray1[i].fi + 1; f++) {
                if (parseInt(gEventLogArray[f].f) === parseInt(gDetailNodeFrom) && parseInt(gEventLogArray[f].t) === parseInt(gDetailNodeTo)) {
                    validTask = true;
                    break;
                }
            }
        }
        if (gDetailSource === 'activity') {
            validTask = false;
            for (let f = detailTaskArray1[i].si; f < detailTaskArray1[i].fi + 1; f++) {
                if (parseInt(gEventLogArray[f].t) === parseInt(gDetailActivity)) {
                    for (let j = 0; j < gVariantPaneVariants.length; j++) {
                        if (detailTaskArray1[i].v == gVariantPaneVariants[j].v) {
                            validTask = true;
                            break;
                        }
                    }
                    if (validTask == true) {
                        break;
                    }
                }
            }
        }
        if (gDetailSource === 'activitygrid') {
            validTask = false;
            for (let f = detailTaskArray1[i].si; f < detailTaskArray1[i].fi + 1; f++) {
                if (parseInt(gEventLogArray[f].t) === parseInt(gDetailActivity)) {
                    validTask = true;
                    break;
                }
            }
        }
        if (gDetailSource === 'diagram') {
            validTask = false;
            for (let f = detailTaskArray1[i].si; f < detailTaskArray1[i].fi + 1; f++) {
                for (let j = 0; j < gVariantPaneVariants.length; j++) {
                    if (detailTaskArray1[i].v == gVariantPaneVariants[j].v) {
                        validTask = true;
                        break;
                    }
                }
                if (validTask == true) {
                    break;
                }
            }
        }
        if (gDetailSource === 'variantgrid') {
            validTask = false;
            if (detailTaskArray1[i].v === gDetailVariant) {
                validTask = true;
            }
        }
        if (gDetailSource === 'all') {
            validTask = true;
        }
        if (validTask === true) {
            detailTaskArray2.push(detailTaskArray1[i]);
        }
    }

    const rows = [];
    
    if (gTaskDetailExtract === 'summary') {
        let taskAttribute = '';
        let taskAttributeType = '';
        if (gDetailTaskSummaryAttribute == '') {
            taskAttribute = gTaskAttributes[0].id;
            taskAttributeType = gTaskAttributes[0].schema;
        } else {
            for (let i = 0; i < gTaskAttributes.length; i++) {
                if (gTaskAttributes[i].field == gDetailTaskSummaryAttribute) {
                    taskAttribute = gTaskAttributes[i].id;
                    taskAttributeType = gTaskAttributes[i].schema;
                }
            }
        }
        detailTaskArray2.sort((a, b) => a[taskAttribute].localeCompare(b[taskAttribute]));
        let detailTaskArray3 = []  

        if (taskAttributeType === 'array' || taskAttributeType === 'stagil_asset_forge') {
            for (let i = 0; i < detailTaskArray2.length; i++) {
                let tempArray = detailTaskArray2[i][taskAttribute].split('^^');
                if (tempArray.length === 1) detailTaskArray3.push (detailTaskArray2[i])
                else {
                    for (let m = 0; m < tempArray.length; m++) {
                        var newObject = JSON.parse(JSON.stringify(detailTaskArray2[i]));
                        newObject[taskAttribute] = tempArray[m]
                        detailTaskArray3.push (newObject)
                    }
                }
            }
        } else {
            detailTaskArray3 = detailTaskArray2
        }
        let totalTasks = detailTaskArray2.length;
        let tasks = 0;
        let duration = 0;
        let min_duration = 999999999999;
        let max_duration = 0;
        let actual_cost = 0;
        let forecast_cost = 0;
        let customer_comments = 0;
        let internal_comments = 0;
        let worklogs = 0
        let time_spent = 0
        let sdArray = [];
        let sd_seconds = 0;

        let attributeValue = '';
        let i = 0;
        for (i = 0; i < detailTaskArray3.length; i++) {
            if (i > 0 && detailTaskArray3[i][taskAttribute] != attributeValue) {
                rows.push({
                    attribute: attributeValue.replaceAll('^^',','),
                    tasks: tasks,
                    avg_duration: duration / tasks,
                    min_duration: min_duration,
                    max_duration: max_duration,
                    avg_duration_days: (Math.round((duration / tasks / 86400) * 100) / 100).toFixed(2),
                    avg_duration_hrs: (Math.round((duration / tasks / 3600) * 100) / 100).toFixed(2),
                    task_actual_cost: actual_cost / tasks,
                    task_forecast_cost: forecast_cost / tasks,
                    task_cost_savings: actual_cost / tasks - forecast_cost / tasks,
                    std_deviation: getStandardDeviation(sdArray),
                    std_deviation_days: (Math.round((getStandardDeviation(sdArray) / 86400) * 100) / 100).toFixed(2),
                    std_deviation_hrs: (Math.round((getStandardDeviation(sdArray) / 3600) * 100) / 100).toFixed(2),
                    perc_total_tasks: tasks / totalTasks,
                    customer_comments: customer_comments,
                    avg_customer_comments: customer_comments/tasks,
                    internal_comments: internal_comments,
                    avg_internal_comments: internal_comments/tasks,
                    worklogs: worklogs,
                    avg_worklogs: worklogs/tasks,
                    time_spent: time_spent,
                    avg_time_spent: time_spent/tasks,

                });

                tasks = 0;
                duration = 0;
                min_duration = 999999999999;
                max_duration = 0;
                customer_comments = 0;
                internal_comments = 0;
                worklogs = 0
                time_spent = 0
                actual_cost = 0;
                forecast_cost = 0;
                sdArray = [];
                sd_seconds = 0;
            }
            attributeValue = detailTaskArray3[i][taskAttribute];
            tasks++;
            duration = duration + detailTaskArray3[i].d;
            if (detailTaskArray3[i].d < min_duration) min_duration = detailTaskArray3[i].d;
            if (detailTaskArray3[i].d > max_duration) max_duration = detailTaskArray3[i].d;
            actual_cost = actual_cost + detailTaskArray3[i].actual_cost;
            forecast_cost = forecast_cost + detailTaskArray3[i].forecast_cost;

            let comments = detailTaskArray3[i].comments
            let worklog = detailTaskArray3[i].worklog
            if (comments !== undefined && (comments.length > 0 && comments[0] !== undefined)) {
                for (let c = 0; c < comments.length; c++) {
                    if (comments[c].jsdPublic === 'true') customer_comments ++
                    else internal_comments ++
                }
            }
            if (worklog !== undefined && (worklog.length > 0 && worklog[0] !== undefined)) {
                for (let w = 0; w < worklog.length; w++) {
                    worklogs ++
                    time_spent = time_spent + parseInt(worklog[w].timeSpentSeconds)  
                }         
            }
            sdArray.push(parseInt(detailTaskArray3[i].d));
        }
        if (i > 0) {
            rows.push({
                attribute: attributeValue.replaceAll('^^',','),
                tasks: tasks,
                avg_duration: duration / tasks,
                min_duration: min_duration,
                max_duration: max_duration,
                avg_duration_days: (Math.round((duration / tasks / 86400) * 100) / 100).toFixed(2),
                avg_duration_hrs: (Math.round((duration / tasks / 3600) * 100) / 100).toFixed(2),
                task_actual_cost: actual_cost / tasks,
                task_forecast_cost: forecast_cost / tasks,
                task_cost_savings: actual_cost / tasks - forecast_cost / tasks,
                std_deviation: getStandardDeviation(sdArray),
                std_deviation_days: (Math.round((getStandardDeviation(sdArray) / 86400) * 100) / 100).toFixed(2),
                std_deviation_hrs: (Math.round((getStandardDeviation(sdArray) / 3600) * 100) / 100).toFixed(2),
                perc_total_tasks: tasks / totalTasks,
                customer_comments: customer_comments,
                avg_customer_comments: customer_comments/tasks,
                internal_comments: internal_comments,
                avg_internal_comments: internal_comments/tasks,
                worklogs: worklogs,
                avg_worklogs: worklogs/tasks,
                time_spent: time_spent,
                avg_time_spent: time_spent/tasks,
            });
        }
        rows.sort((a, b) => (b.tasks > a.tasks ? 1 : -1));
    } 
    if (gTaskDetailExtract === 'detail') { 
        for (let i = 0; i < detailTaskArray2.length; i++) {
            let vtp = {};
            vtp[gEntityUpper + ' #'] = detailTaskArray2[i].k;
            vtp['Create Time'] = detailTaskArray2[i].t1;
            vtp['Close Time'] = detailTaskArray2[i].t2;
            vtp['Duration'] = detailTaskArray2[i].d  ; 

            let customer_comments = 0;
            let internal_comments = 0;
            let worklogs = 0
            let time_spent = 0

            let comments = detailTaskArray2[i].comments  
            let worklog = detailTaskArray2[i].worklog
            if (comments !== undefined && (comments.length > 0 && comments[0] !== undefined)) {
                for (let c = 0; c < comments.length; c++) {
                    if (comments[c].jsdPublic === 'true') customer_comments ++
                    else internal_comments ++
                }
            }
            if (worklog !== undefined && (worklog.length > 0 && worklog[0] !== undefined)) {
                for (let w = 0; w < worklog.length; w++) {
                    worklogs ++
                    time_spent = time_spent + parseInt(worklog[w].timeSpentSeconds)  
                }         
            }
            for (let j = 0; j < gTaskAttributes.length; j++) {
                if (gTaskAttributes[j].schema === 'array' || gTaskAttributes[j].schema === 'stagil_asset_forge') {
                    vtp[gTaskAttributes[j].field] = detailTaskArray2[i][gTaskAttributes[j].id].replaceAll('^^',',');
                } else {
                    vtp[gTaskAttributes[j].field] = detailTaskArray2[i][gTaskAttributes[j].id];
                }
            }
            vtp['Customer Comments'] = customer_comments
            vtp['Internal Comments'] = internal_comments
            vtp['Worklogs'] = worklogs
            vtp['Time Spent'] = time_spent
			vtp['Actual Cost'] = detailTaskArray2[i].actual_cost;
            vtp['Forecast Cost'] = detailTaskArray2[i].forecast_cost;
            vtp['vid'] = detailTaskArray2[i].vid;
            vtp['id'] = detailTaskArray2[i].id;
            vtp['k'] = detailTaskArray2[i].k;
            rows.push(vtp);
        }
    }
    if (gTaskDetailExtract === 'analytic') { 
        for (let i = 0; i < detailTaskArray2.length; i++) {
            let vtp = {};
            vtp[gEntityUpper + ' #'] = detailTaskArray2[i].k;
            vtp['Create Time'] = detailTaskArray2[i].t1;
            vtp['Close Time'] = detailTaskArray2[i].t2;

            vtp['Duration (Hrs)'] = detailTaskArray2[i].d/3600  ; 
            vtp['Duration (Days)'] = detailTaskArray2[i].d/86400  ; 
            vtp['Count'] = 1;
			//vtp['Actual Cost'] = detailTaskArray2[i].actual_cost;
            //vtp['Forecast Cost'] = detailTaskArray2[i].forecast_cost;

            for (let j = 0; j < gTaskAttributes.length; j++) {
                vtp[gTaskAttributes[j].field] = detailTaskArray2[i][gTaskAttributes[j].id].replaceAll('^^',',');
            }
            
            rows.push(vtp);
        }
    }


    return rows;
}

export function processDetailVariants() {
    // populates Visuals -> Activities -> Variants

    let totalEvents = 0;
    let totalTasks = 0;
    let variants = [];
    if (gDetailSource === 'activity') {
        for (let i = 0; i < gLinkArray.length; i++) {
            if (gDetailActivity == gLinkArray[i].to && gLinkArray[i].duplicate === false) {
                for (let j = 0; j < gVariantPaneVariants.length; j++) {
                    if (gLinkArray[i].variant == gVariantPaneVariants[j].v) {
                        let variantExists = false;
                        for (let k = 0; k < variants.length; k++) {
                            if (variants[k] == gLinkArray[i].variant) {
                                variantExists = true;
                                break;
                            }
                        }
                        if (variantExists == false) {
                            variants.push(gLinkArray[i].variant);
                        }
                    }
                }
            }
        }
    }
    if (gDetailSource === 'step') {
        for (let i = 0; i < gLinkArray.length; i++) {
            if (gDetailNodeFrom == gLinkArray[i].from && gDetailNodeTo == gLinkArray[i].to && gLinkArray[i].duplicate === false) {
                for (let j = 0; j < gVariantPaneVariants.length; j++) {
                    if (gLinkArray[i].variant == gVariantPaneVariants[j].v) {
                        let variantExists = false;
                        for (let k = 0; k < variants.length; k++) {
                            if (variants[k] == gLinkArray[i].variant) {
                                variantExists = true;
                                break;
                            }
                        }
                        if (variantExists == false) {
                            variants.push(gLinkArray[i].variant);
                        }
                    }
                }
            }
        }
    }

    let variantArray = [];
    for (let i = 0; i < variants.length; i++) {
        for (let h = 0; h < gVariantArray.length; h++) {
            if (gVariantArray[h].v == variants[i] && gVariantArray[h].sliced == true) {
                const vtp = {};
                vtp['variant_id'] = gVariantArray[h].v;
                vtp['variant'] = gVariantArray[h].n;
                vtp['sequence'] = gVariantArray[h].s;
                vtp['tasks'] = gVariantArray[h].t;
                vtp['avg_duration'] = gVariantArray[h].ad;
                vtp['std_deviation'] = gVariantArray[h].sd;
                vtp['min_duration'] = gVariantArray[h].min_duration;
                vtp['max_duration'] = gVariantArray[h].max_duration;
                vtp['avg_duration_days'] = (Math.round((gVariantArray[h].ad / 86400) * 100) / 100).toFixed(2);
                vtp['avg_duration_hrs'] = (Math.round((gVariantArray[h].ad / 3600) * 100) / 100).toFixed(2);
                vtp['std_deviation_days'] = (Math.round((gVariantArray[h].sd / 86400) * 100) / 100).toFixed(2);
                vtp['std_deviation_hrs'] = (Math.round((gVariantArray[h].sd / 3600) * 100) / 100).toFixed(2);
                vtp['actual_cost'] = gVariantArray[h].actual_cost / gVariantArray[h].t;
                vtp['forecast_cost'] = gVariantArray[h].forecast_cost / gVariantArray[h].t;
                vtp['loop'] = gVariantArray[h].l;
                vtp['events'] = gVariantArray[h].e;
                vtp['variant_id'] = gVariantArray[h].v;
                (vtp['steps'] = gVariantArray[i].steps),
                    (vtp['task_actual_cost'] = gVariantArray[i].actual_cost / gVariantArray[i].t),
                    (vtp['task_forecast_cost'] = gVariantArray[i].forecast_cost / gVariantArray[i].t),
                    (vtp['task_cost_savings'] =
                        gVariantArray[i].actual_cost / gVariantArray[i].t - gVariantArray[i].forecast_cost / gVariantArray[i].t),
                    (vtp['variant_actual_cost'] = gVariantArray[i].actual_cost),
                    (vtp['variant_forecast_cost'] = gVariantArray[i].forecast_cost),
                    (vtp['variant_cost_savings'] = gVariantArray[i].actual_cost - gVariantArray[i].forecast_cost),
                    variantArray.push(vtp);
                totalTasks = totalTasks + gVariantArray[h].t;
                totalEvents = totalEvents + gVariantArray[h].e;
                break;
            }
        }
    }

    const rows = [];
    for (let i = 0; i < variantArray.length; i++) {
        rows.push({
            sequence: variantArray[i].sequence,
            variant: variantArray[i].variant,
            tasks: variantArray[i].tasks,
            events: variantArray[i].events,
            steps: variantArray[i].steps,
            perc_total_tasks: variantArray[i].tasks / totalTasks,
            avg_duration: variantArray[i].avg_duration,
            min_duration: variantArray[i].min_duration,
            max_duration: variantArray[i].max_duration,
            std_deviation: variantArray[i].std_deviation,
            loop: variantArray[i].l,
            task_actual_cost: variantArray[i].task_actual_cost,
            task_forecast_cost: variantArray[i].task_forecast_cost,
            task_cost_savings: variantArray[i].task_cost_savings,
            variant_actual_cost: variantArray[i].variant_actual_cost,
            variant_forecast_cost: variantArray[i].variant_forecast_cost,
            variant_cost_savings: variantArray[i].variant_cost_savings,
            perc_total_events: variantArray[i].events / totalEvents,
            avg_duration_days: variantArray[i].avg_duration_days,
            std_deviation_days: variantArray[i].std_deviation_days,
            avg_duration_hrs: variantArray[i].avg_duration_hrs,
            std_deviation_hrs: variantArray[i].std_deviation_hrs,
            variant_id: variantArray[i].variant_id,
            actual_cost: variantArray[i].actual_cost,
            forecast_cost: variantArray[i].forecast_cost,
        });
    }
    return rows;
}

export function processActivityResourceTable() {
    let resourceArray = [];
    gEventLogArray.sort((a, b) => a.f - b.f || a.t - b.t || a.v - b.v);
    let tEventLogArray = [];
    // filter eventlog array
    gEventLogArray = gEventLogArray.sort((a, b) => a.filtered - b.filtered);
    for (let i = 0; i < gEventLogArray.length; i++) {
        if (gEventLogArray[i].filtered == 1) {
            break;
        }
        if (gEventLogArray[i].t == gActivity) {
            for (let j = 0; j < gVariantPaneVariants.length; j++) {
                if (gEventLogArray[i].v == gVariantPaneVariants[j].v) {
                    tEventLogArray.push(gEventLogArray[i]);
                }
            }
        }
    }
    tEventLogArray.sort((a, b) => a.u.localeCompare(b.u) || a.k.localeCompare(b.k));

    let sdArray = [];
    sdArray.length = 0;
    let tasks = 0;
    let duration_seconds = 0;
    let sd_seconds = 0;
    let from = '';
    let to = '';
    let resource = '';
    let min_duration = 1000000000;
    let max_duration = 0;

    for (let i = 0; i < tEventLogArray.length; i++) {
        if (i == 0) {
            tasks++;
            duration_seconds = duration_seconds + parseInt(tEventLogArray[i].d);
            min_duration = duration_seconds;
            max_duration = duration_seconds;
            sdArray.push(parseInt(tEventLogArray[i].d));
        } else {
            if (tEventLogArray[i - 1].u != tEventLogArray[i].u) {
                let vtp = {};
                vtp['resource'] = tEventLogArray[i - 1].u.toString();
                vtp['tasks'] = tasks;
                sd_seconds = getStandardDeviation(sdArray);
                vtp['duration'] = duration_seconds;
                vtp['avg_duration'] = duration_seconds / tasks;
                vtp['min_duration'] = min_duration;
                vtp['max_duration'] = max_duration;
                vtp['std_deviation'] = sd_seconds;
                vtp['avg_duration_days'] = (Math.round((duration_seconds / 86400 / tasks) * 100) / 100).toFixed(2);
                vtp['std_deviation_days'] = (Math.round((sd_seconds / 86400) * 100) / 100).toFixed(2);
                vtp['avg_duration_hrs'] = (Math.round((duration_seconds / 3600 / tasks) * 100) / 100).toFixed(2);
                vtp['std_deviation_hrs'] = (Math.round((sd_seconds / 3600) * 100) / 100).toFixed(2);
                resourceArray.push(vtp);
                tasks = 1;
                sdArray = [];
                sdArray.length = 0;
                sdArray.push(parseInt(tEventLogArray[i].d));
                duration_seconds = parseInt(tEventLogArray[i].d);
                min_duration = duration_seconds;
                max_duration = duration_seconds;
            } else {
                if (tEventLogArray[i - 1].k != tEventLogArray[i].k) {
                    tasks++;
                }
                duration_seconds = duration_seconds + parseInt(tEventLogArray[i].d);
                if (duration_seconds < min_duration) {
                    min_duration = duration_seconds;
                }
                if (duration_seconds > max_duration) {
                    max_duration = duration_seconds;
                }
                sdArray.push(parseInt(tEventLogArray[i].d));
            }
        }
        if (i == tEventLogArray.length - 1) {
            from = tEventLogArray[i].f;
            to = tEventLogArray[i].t;
            resource = tEventLogArray[i].u;
        }
    }
    if (resource != '') {
        let vtp = {};
        vtp['resource'] = resource;
        vtp['tasks'] = tasks;
        sd_seconds = getStandardDeviation(sdArray);
        vtp['avg_duration'] = duration_seconds / tasks;
        vtp['min_duration'] = min_duration;
        vtp['max_duration'] = max_duration;
        vtp['std_deviation'] = sd_seconds;
        vtp['avg_duration_days'] = (Math.round((duration_seconds / 86400 / tasks) * 100) / 100).toFixed(2);
        vtp['std_deviation_days'] = (Math.round((sd_seconds / 86400) * 100) / 100).toFixed(2);
        vtp['avg_duration_hrs'] = (Math.round((duration_seconds / 3600 / tasks) * 100) / 100).toFixed(2);
        vtp['std_deviation_hrs'] = (Math.round((sd_seconds / 3600) * 100) / 100).toFixed(2);
        resourceArray.push(vtp);
    }

    const rows = [];
    for (let i = 0; i < resourceArray.length; i++) {
        if (resourceArray[i].resource != '') {
            rows.push({
                resource: resourceArray[i].resource,
                tasks: resourceArray[i].tasks,
                avg_duration: resourceArray[i].avg_duration,
                min_duration: resourceArray[i].min_duration,
                max_duration: resourceArray[i].max_duration,
                std_deviation: resourceArray[i].std_deviation,
                avg_duration_days: resourceArray[i].avg_duration_days,
                std_deviation_days: resourceArray[i].std_deviation_days,
                avg_duration_hrs: resourceArray[i].avg_duration_hrs,
                std_deviation_hrs: resourceArray[i].std_deviation_hrs,
            });
        }
    }
    return rows;
}

export function processActivityEventTable() {
    let rows = [];
    gEventLogArray = gEventLogArray.sort((a, b) => a.filtered - b.filtered);
    gTaskArray = gTaskArray.sort((a, b) => a.id - b.id);
    for (let i = 0; i < gEventLogArray.length; i++) {
        if (gEventLogArray[i].filtered == 1) {
            break;
        }
        if (gEventLogArray[i].t == gActivity) {
            for (let j = 0; j < gVariantPaneVariants.length; j++) {
                if (gEventLogArray[i].v == gVariantPaneVariants[j].v) {
                    // variant activity combination exists
                    // custom attributes
                    const vtp = {};
                    vtp['Resource'] = gEventLogArray[i].u;
                    vtp['Task'] = gEventLogArray[i].k;
                    vtp['Timestamp'] = gEventLogArray[i].ts;
                    for (let z = 0; z < gTaskAttributes.length; z++) {
                        let key = 'ta' + z;
                        vtp[gTaskAttributes[z].field] = gTaskArray[gEventLogArray[i].tid][key];
                    }
                    vtp['Duration'] = gTaskArray[gEventLogArray[i].tid].d / 60;
                    vtp['Variant'] = gVariantArray[gEventLogArray[i].vid].n;
                    vtp['Events'] = 1;
                    rows.push(vtp);
                }
            }
        }
    }
    rows.sort((a, b) => b.t > a.t);
    return rows;
}

export function processStepEventTable() {
    let rows = [];
    gEventLogArray = gEventLogArray.sort((a, b) => a.filtered - b.filtered);
    gTaskArray = gTaskArray.sort((a, b) => a.id - b.id);
    for (let i = 0; i < gEventLogArray.length; i++) {
        if (gEventLogArray[i].filtered == 1) {
            break;
        }
        if (gEventLogArray[i].f == gDetailNodeFrom && gEventLogArray[i].t == gDetailNodeTo) {
            for (let j = 0; j < gVariantPaneVariants.length; j++) {
                if (gEventLogArray[i].v == gVariantPaneVariants[j].v) {
                    const vtp = {};
                    vtp['Resource'] = gEventLogArray[i].u;
                    vtp['Task'] = gEventLogArray[i].k;
                    vtp['Timestamp'] = gEventLogArray[i].ts;
                    for (let z = 0; z < gActivityArray.length; z++) {
                        if (gEventLogArray[i].t == gActivityArray[z].a) {
                            vtp['Activity'] = gActivityArray[z].activity;
                            break;
                        }
                    }
                    for (let z = 0; z < gTaskAttributes.length; z++) {
                        let key = 'ta' + z;
                        vtp[gTaskAttributes[z].field] = gTaskArray[gEventLogArray[i].tid][key];
                    }
                    vtp['Duration'] = gTaskArray[gEventLogArray[i].tid].d / 60;
                    vtp['Variant'] = gVariantArray[gEventLogArray[i].vid].n;
                    vtp['Events'] = 1;
                    rows.push(vtp);
                }
            }
        }
    }
    rows.sort((a, b) => b.t > a.t);
    return rows;
}

export function processStepResourceTable() {
    let resourceArray = [];
    gEventLogArray.sort((a, b) => a.filtered - b.filtered || a.f - b.f || a.t - b.t || a.v - b.v);
    let tEventLogArray = [];
    // filter eventlog array
    for (let i = 0; i < gEventLogArray.length; i++) {
        if (gEventLogArray[i].filtered == 1) {
            break;
        }
        if (gEventLogArray[i].f == gDetailNodeFrom && gEventLogArray[i].t == gDetailNodeTo) {
            for (let j = 0; j < gVariantPaneVariants.length; j++) {
                if (gEventLogArray[i].v == gVariantPaneVariants[j].v) {
                    tEventLogArray.push(gEventLogArray[i]);
                }
            }
        }
    }
    tEventLogArray.sort((a, b) => a.u.localeCompare(b.u) || a.k.localeCompare(b.k));
    let sdArray = [];
    sdArray.length = 0;
    let tasks = 0;
    let duration_seconds = 0;
    let sd_seconds = 0;
    let from = '';
    let to = '';
    let resource = '';
    let min_duration = 1000000000;
    let max_duration = 0;
    for (let i = 0; i < tEventLogArray.length; i++) {
        if (i == 0) {
            tasks++;
            duration_seconds = duration_seconds + parseInt(tEventLogArray[i].d);
            min_duration = duration_seconds;
            max_duration = duration_seconds;
            sdArray.push(parseInt(tEventLogArray[i].d));
        } else {
            if (tEventLogArray[i - 1].u != tEventLogArray[i].u) {
                let vtp = {};
                vtp['resource'] = tEventLogArray[i - 1].u.toString();
                vtp['tasks'] = tasks;
                sd_seconds = getStandardDeviation(sdArray);
                vtp['avg_duration'] = duration_seconds / tasks;
                vtp['min_duration'] = min_duration;
                vtp['max_duration'] = max_duration;
                vtp['std_deviation'] = sd_seconds;
                vtp['avg_duration_days'] = (Math.round((duration_seconds / 86400 / tasks) * 100) / 100).toFixed(2);
                vtp['std_deviation_days'] = (Math.round((sd_seconds / 86400) * 100) / 100).toFixed(2);
                vtp['avg_duration_hrs'] = (Math.round((duration_seconds / 3600 / tasks) * 100) / 100).toFixed(2);
                vtp['std_deviation_hrs'] = (Math.round((sd_seconds / 3600) * 100) / 100).toFixed(2);
                resourceArray.push(vtp);
                tasks = 1;
                sdArray = [];
                sdArray.length = 0;
                sdArray.push(parseInt(tEventLogArray[i].d));
                duration_seconds = parseInt(tEventLogArray[i].d);
                min_duration = duration_seconds;
                max_duration = duration_seconds;
            } else {
                if (tEventLogArray[i - 1].k != tEventLogArray[i].k) {
                    tasks++;
                }
                duration_seconds = duration_seconds + parseInt(tEventLogArray[i].d);
                if (duration_seconds < min_duration) {
                    min_duration = duration_seconds;
                }
                if (duration_seconds > max_duration) {
                    max_duration = duration_seconds;
                }
                sdArray.push(parseInt(tEventLogArray[i].d));
            }
        }
        if (i == tEventLogArray.length - 1) {
            from = tEventLogArray[i].f;
            to = tEventLogArray[i].t;
            resource = tEventLogArray[i].u;
        }
    }
    if (resource != '') {
        let vtp = {};
        vtp['resource'] = resource;
        vtp['tasks'] = tasks;
        sd_seconds = getStandardDeviation(sdArray);
        vtp['avg_duration'] = duration_seconds / tasks;
        vtp['min_duration'] = min_duration;
        vtp['max_duration'] = max_duration;
        vtp['std_deviation'] = sd_seconds;
        vtp['avg_duration_days'] = (Math.round((duration_seconds / 86400 / tasks) * 100) / 100).toFixed(2);
        vtp['std_deviation_days'] = (Math.round((sd_seconds / 86400) * 100) / 100).toFixed(2);
        vtp['avg_duration_hrs'] = (Math.round((duration_seconds / 3600 / tasks) * 100) / 100).toFixed(2);
        vtp['std_deviation_hrs'] = (Math.round((sd_seconds / 3600) * 100) / 100).toFixed(2);
        resourceArray.push(vtp);
    }

    const rows = [];
    for (let i = 0; i < resourceArray.length; i++) {
        if (resourceArray[i].resource != '') {
            rows.push({
                resource: resourceArray[i].resource,
                tasks: resourceArray[i].tasks,
                avg_duration: resourceArray[i].avg_duration,
                min_duration: resourceArray[i].min_duration,
                max_duration: resourceArray[i].max_duration,
                std_deviation: resourceArray[i].std_deviation,
                avg_duration_days: resourceArray[i].avg_duration_days,
                std_deviation_days: resourceArray[i].std_deviation_days,
                avg_duration_hrs: resourceArray[i].avg_duration_hrs,
                std_deviation_hrs: resourceArray[i].std_deviation_hrs,
            });
        }
    }
    return rows;
}

export function updateVariantSlicerVariantChart() {
    let variantArray = [];
    let gVariantsTasksSelected = 0;
    for (let i = 0; i < gVariantPaneVariants.length; i++) {
        for (let j = 0; j < gVariantArray.length; j++) {
            if (gVariantArray[j].v == gVariantPaneVariants[i].v && gVariantArray[j].sliced == true) {
                gVariantsTasksSelected = gVariantsTasksSelected + gVariantArray[j].t;
                variantArray.push(gVariantArray[j]);
            }
        }
    }
    variantArray.sort((a, b) => (b.t > a.t ? 1 : -1));
    return variantArray;
}

export const selectVariantSlicerGridData = (selection, source) => { 
    gVariantPaneVariants.length = 0;
    gIsolateVariant = 0;
    gAnimateVariant = 0;
    gLifecycleVariant = 0;
    gDiagramPVTasks = 0;
    gDiagramPVEvents = 0;
    gAnimateVariant = '';
    let variantID;
    let variant = '';
    let variantSequence = '';
    let variantIndex = 0;
    for (let j = 0; j < gVariantArray.length; j++) {
        gVariantArray[j].selected = 0;
    }
    for (let i = 0; i < selection.length; i++) {
        for (let j = 0; j < gVariantArray.length; j++) {
            if (gVariantArray[j].s == selection[i].sequence && gVariantArray[j].sliced == true) {
                gVariantArray[j].selected = 1;
                variantID = gVariantArray[j].v;
                variant = gVariantArray[j].n;
                variantSequence = gVariantArray[j].s;
                variantIndex = gVariantArray[j].id;
                gDiagramPVTasks = gDiagramPVTasks + gVariantArray[j].t;
                gDiagramPVEvents = gDiagramPVEvents + gVariantArray[j].e;
                break;
            }
        }
        const vtp = {};
        vtp['v'] = variantID;
        vtp['n'] = variant;
        vtp['s'] = variantSequence;
        vtp['id'] = variantIndex;
        gVariantPaneVariants.push(vtp);
    }
    gDiagramPVVariants = gVariantPaneVariants.length;
};

export const setTaskDetailVariants = () => {
    gVariantPaneVariants.length = 0;
    gIsolateVariant = 0;
    gAnimateVariant = 0;
    gLifecycleVariant = 0;
    gDiagramPVTasks = 0;
    gDiagramPVEvents = 0;
    gAnimateVariant = '';
    let variantID;
    let variant = '';
    let variantSequence = '';
    let variantIndex = 0;
    for (let j = 0; j < gVariantArray.length; j++) {
        gVariantArray[j].selected = 0;
    }
    for (let i = 0; i < gDetailTaskVariantsSelected.length; i++) {
        for (let j = 0; j < gVariantArray.length; j++) {
            if (gVariantArray[j].id == gDetailTaskVariantsSelected[i].vid && gVariantArray[j].sliced == true) {
                gVariantArray[j].selected = 1;
                variantID = gVariantArray[j].v;
                variant = gVariantArray[j].n;
                variantSequence = gVariantArray[j].s;
                variantIndex = gVariantArray[j].id;
                gDiagramPVTasks = gDiagramPVTasks + gVariantArray[j].t;
                gDiagramPVEvents = gDiagramPVEvents + gVariantArray[j].e;
                break;
            }
        }
        const vtp = {};
        vtp['v'] = variantID;
        vtp['n'] = variant;
        vtp['s'] = variantSequence;
        vtp['id'] = variantIndex;
        gVariantPaneVariants.push(vtp);
    }
    gDiagramPVVariants = gVariantPaneVariants.length;
};


export function modelInfo() {
    const rows = [];
    rows.push({
        events: numberWithCommas(gEventsAll),
        tasks: numberWithCommas(gTasksAll),
        variants: numberWithCommas(gVariantsAll),
        activities: numberWithCommas(gActivitiesAll),
        steps: numberWithCommas(gStepsAll),
    });
    rows.push({
        events: numberWithCommas(gEventsFiltered),
        tasks: numberWithCommas(gTasksFiltered),
        variants: numberWithCommas(gVariantsFiltered),
        activities: numberWithCommas(gActivitiesFiltered),
        steps: numberWithCommas(gStepsFiltered),
    });

    rows.push({
        events: numberWithCommas(gDiagramPVEvents),
        tasks: numberWithCommas(gDiagramPVTasks),
        variants: numberWithCommas(gDiagramPVVariants),
        activities: numberWithCommas(gDiagramPVActivities),
        steps: numberWithCommas(gDiagramPVSteps),
    });
    return rows;
}

export const selectAttributesGridData = (selection) => {
    gSelectedProcessSteps.length = 0;
    if (selection.length == 0) {
        return;
    }

    for (let i = 0; i < selection.length; i++) {
        let from_activity = '';
        let to_activity = '';
        for (let j = 0; j < gActivityArray.length; j++) {
            if (gActivityArray[j].activity == selection[i].from_activity) {
                from_activity = gActivityArray[j].id;
            }
            if (gActivityArray[j].activity == selection[i].to_activity) {
                to_activity = gActivityArray[j].id;
            }
        }

        const vtp = {};
        vtp['from_activity'] = from_activity;
        vtp['to_activity'] = to_activity;
        gSelectedProcessSteps.push(vtp);
    }
};

export const selectStepVisualStepGridData = (selection) => {
    gSelectedProcessSteps.length = 0;
    if (selection.length == 0) {
        return;
    }

    for (let i = 0; i < selection.length; i++) {
        let from_activity = '';
        let to_activity = '';
        for (let j = 0; j < gActivityArray.length; j++) {
            if (gActivityArray[j].activity == selection[i].from_activity) {
                from_activity = gActivityArray[j].id;
            }
            if (gActivityArray[j].activity == selection[i].to_activity) {
                to_activity = gActivityArray[j].id;
            }
        }

        const vtp = {};
        vtp['from_activity'] = from_activity;
        vtp['to_activity'] = to_activity;
        gSelectedProcessSteps.push(vtp);
    }
};


function filterTime(type) {  
    // remove existing
    for (let i = 0; i < gFilters.length; i++) {
        if (gFilters[i].type == 'Filter - Time') {
            gFilters.splice(i, 1);
        }
    }
    gFilterSets++;
    gEventLogArray.sort((a, b) => a.elid - b.elid);
    let fromDate = gFromTime
    let toDate = gToTime
    if (type === gEntityUpper) {
        gAttributeType = ''
        for (let i = 0; i < gTaskArray.length; i++) {
            let year = gTaskArray[i].t1.substr(0, 4);
            let month = gTaskArray[i].t1.substr(5, 2) ;
            let day = gTaskArray[i].t1.substr(8, 2);
            let tempDate = year + '/' + month + '/' + day
            if (tempDate >= fromDate && tempDate < toDate) {
                for (let j = gTaskArray[i].si; j < gTaskArray[i].fi + 1; j++) {
                    let vtp = {};
                    vtp['type'] = 'filter';    
                    vtp['sub_type'] = 'time';    
                    vtp['label'] = 'Filter - Time';
                    vtp['filter_number'] = gFilterSets;
                    vtp['id'] = gEventLogArray[j].elid;
                    vtp['duration'] = gEventLogArray[j].d;
                    vtp['task'] = gEventLogArray[j].k;
                    gFilters.push(vtp);
                }
            }
        }
    }
    if (type === 'Event') {
        gAttributeType = 'Event'
        let tempCtr = 0
        for (let i = 0; i < gEventLogArray.length; i++) {
            let year = gEventLogArray[i].ts.substr(0, 4);
            let month = gEventLogArray[i].ts.substr(5, 2) ;
            let day = gEventLogArray[i].ts.substr(8, 2);
            let tempDate = year + '/' + month + '/' + day
            if (tempDate >= fromDate && tempDate < toDate) {
                let vtp = {};
                vtp['type'] = 'filter';    
                vtp['sub_type'] = 'time';    
                vtp['label'] = 'Filter - Time';
                vtp['filter_number'] = gFilterSets;
                vtp['id'] = gEventLogArray[i].elid;
                vtp['duration'] = gEventLogArray[i].d;
                vtp['task'] = gEventLogArray[i].k;
                gFilters.push(vtp);
                tempCtr ++
            }
        }
    }
}

function filterAttributesTasks() {
    let id = '';
    let isArray = false
    for (let i = 0; i < gTaskAttributes.length; i++) {
        if (gTaskAttributes[i].field == gAttribute) {
            id = gTaskAttributes[i].id;
            if (gTaskAttributes[i].schema === 'array' || gTaskAttributes[i].schema === 'stagil_asset_forge') isArray = true
        }
    }

    for (let i = 0; i < gFilters.length; i++) {
        if (gFilters[i].type == 'Filter - Task Attribute' && gFilters[i].attribute == id) {
            gFilters.splice(i, 1);
        }
    }
    gFilterSets++;
    gEventLogArray.sort((a, b) => a.elid - b.elid);
    // is is key e.g. ta0, ta1
    for (let i = 0; i < gTaskArray.length; i++) {
        let validRec = false;


        for (let j = 0; j < gSelectedAttributes.length; j++) {
            if (isArray === false) {
                if (gTaskArray[i][id] == gSelectedAttributes[j].value) {
                    validRec = true;
                    break;
                }
            } else {
                let tempArray = gTaskArray[i][id].split('^^');
                for (let m = 0; m < tempArray.length; m++) {
                    if (tempArray[m] === gSelectedAttributes[j].value) {
                        validRec = true;
                        break;
                    }
                }
            }
        }

        if (validRec == true) {
            for (let j = gTaskArray[i].si; j <= gTaskArray[i].fi; j++) {
                let vtp = {};
                vtp['type'] = 'filter';    
                vtp['sub_type'] = 'task';    
                vtp['label'] = 'Filter - Task Attribute';
                vtp['filter_number'] = gFilterSets;
                vtp['attribute'] = id;
                vtp['id'] = gEventLogArray[j].elid;
                vtp['duration'] = gEventLogArray[j].d;
                vtp['task'] = gEventLogArray[j].k;
                gFilters.push(vtp);
            }
        }
    }
}

function filterAttributesEvents() {
    let id = '';
    if (gAttribute == 'Resource') {
        id = 'u';
    } else {
        for (let i = 0; i < gEventAttributes.length; i++) {
            if (gEventAttributes[i].field == gAttribute) {
                id = gEventAttributes[i].id;
            }
        }
    }
    for (let i = 0; i < gFilters.length; i++) {
        if (gFilters[i].type == 'Filter - Event Attribute' && gFilters[i].attribute == id) {
            gFilters.splice(i, 1);
        }
    }
    gFilterSets++;
    gEventLogArray.sort((a, b) => a.elid - b.elid);

    for (let i = 0; i < gEventLogArray.length; i++) {
        let validRec = false;
        for (let j = 0; j < gSelectedAttributes.length; j++) {
            if (gEventLogArray[i][id] == gSelectedAttributes[j].value) {
                validRec = true;
                break;
            }
        }
        if (validRec == true) {
            let vtp = {};
            vtp['type'] = 'filter';    
            vtp['sub_type'] = 'task';    
            vtp['label'] = 'Filter - Task Attribute';
            vtp['filter_number'] = gFilterSets;
            vtp['attribute'] = id;
            vtp['id'] = gEventLogArray[i].elid;
            vtp['duration'] = gEventLogArray[i].d;
            vtp['task'] = gEventLogArray[i].k;
            gFilters.push(vtp);
        }
    }
}


function updateVariantMetrics() {  
    gTaskArray.sort((a, b) => a.filtered - b.filtered || a.v - b.v || a.k.localeCompare(b.k) || a.s - b.s);
    gVariantArray.sort((a, b) => a.id - b.id );

    for (let i = 0; i < gVariantArray.length; i++) {
        gVariantArray[i].filtered = 1;
        gVariantArray[i].s = i + 1;
    }
    let sdArray = [];
    sdArray.length = 0;
    let tasks = 0;
    let events = 0;
    let duration = 0;
    let variant = '';
    let i = 0;
    for (i = 0; i < gTaskArray.length; i++) {
        if (gTaskArray[i].filtered == 1) {
            break;
        }
        gTaskArray[i].filtered = 0;
        if (i == 0) {
            tasks++;
            let tempEvents = 0
            for (let k = parseInt(gTaskArray[i].si); k <= parseInt(gTaskArray[i].fi - 1); k++) {
                if (gEventLogArray[k].filtered == 0) tempEvents ++ 
            }
            events = tempEvents
            duration = parseInt(gTaskArray[i].d);
            sdArray.push(parseInt(gTaskArray[i].d));
            variant = gTaskArray[i].v;
        } else {
            if (gTaskArray[i - 1].v != gTaskArray[i].v) {
                let ad = duration / tasks;
                let sd = getStandardDeviation(sdArray);
                gVariantArray[gTaskArray[i - 1].vid].ad = ad;
                gVariantArray[gTaskArray[i - 1].vid].sd = sd;
                gVariantArray[gTaskArray[i - 1].vid].t = tasks;
                gVariantArray[gTaskArray[i - 1].vid].e = events;
                gVariantArray[gTaskArray[i - 1].vid].filtered = 0;
                gVariantArray[gTaskArray[i - 1].vid].actual_cost = 0;
                gVariantArray[gTaskArray[i - 1].vid].forecast_cost = 0;
                gVariantArray[gTaskArray[i - 1].vid].sliced = true;

                tasks = 0;
                events = 0;
                sdArray.length = 0;
                duration = 0;
                variant = gTaskArray[i].v;
            }
            tasks++;

            let tempEvents = 0
            for (let k = parseInt(gTaskArray[i].si); k <= parseInt(gTaskArray[i].fi - 1); k++) {
                if (gEventLogArray[k].filtered == 0) tempEvents ++ 
            }
            events = events + tempEvents
            duration = duration + parseInt(gTaskArray[i].d);
            sdArray.push(parseInt(gTaskArray[i].d));
        }
    }
    if (i > 0) {
        if (gTaskArray[i - 1].filtered == 0) {
            let ad = duration / tasks;
            let sd = getStandardDeviation(sdArray);

            gVariantArray[gTaskArray[i - 1].vid].ad = ad;
            gVariantArray[gTaskArray[i - 1].vid].sd = sd;
            gVariantArray[gTaskArray[i - 1].vid].t = tasks;
            gVariantArray[gTaskArray[i - 1].vid].e = events;
            gVariantArray[gTaskArray[i - 1].vid].filtered = 0;
            gVariantArray[gTaskArray[i - 1].vid].actual_cost = 0;
            gVariantArray[gTaskArray[i - 1].vid].forecast_cost = 0;
            gVariantArray[gTaskArray[i - 1].vid].sliced = true;
        }
    }
    gVariantArray.sort((a, b) => b.t - a.t);
    for (let i = 0; i < gVariantArray.length; i++) {
        gVariantArray[i].s = i + 1;
    }
}

function filterArrays() {  

    // but if all events are filtered, the task will be filtered

    let jsonObject = gFilters.map(JSON.stringify);
    let uniqueSet = new Set(jsonObject);
    gFilters = Array.from(uniqueSet).map(JSON.parse)

    let endNode = 0;
    for (let j = 0; j < gActivityArray.length; j++) {
        if (gActivityArray[j].end_node == true) {
            endNode = parseInt(gActivityArray[j].id);
            break;
        }
    }
    gEventLogArray.sort((a, b) => a.elid - b.elid);
    gTaskArray.sort((a, b) => a.id - b.id);
    // figure out how many filter sets an event is in
    for (let i = 0; i < gEventLogArray.length; i++) {
        gEventLogArray[i].filtered = 0;
    }
    for (let i = 0; i < gTaskArray.length; i++) {
        gTaskArray[i].filtered = 1;
    }
    for (let i = 0; i < gFilters.length; i++) {
        gEventLogArray[gFilters[i].id].filtered++;
    }
    // has to be in all filter sets to survive, else filtered = 1
    for (let i = 0; i < gEventLogArray.length; i++) {
        if (gEventLogArray[i].filtered == gFilterSets) {
            gEventLogArray[i].filtered = 0;
        } else {
            gEventLogArray[i].filtered = 1;
        }
    }
    if (gFilterTimeType === getEntityUpper()) {
        let ctr = 0
        for (let i = 0; i < gTaskArray.length; i++) {
            for (let k = parseInt(gTaskArray[i].si); k <= parseInt(gTaskArray[i].fi - 1); k++) {
                if (gEventLogArray[k].filtered == 0) {
                    gTaskArray[i].filtered = 0;
                    ctr ++
                    break;
                }
            }
            if (gAttributeType == 'Event') {
                if (gTaskArray[i].filtered == 0) {
                    for (let k = parseInt(gTaskArray[i].si); k <= parseInt(gTaskArray[i].fi - 1); k++) {
                        gEventLogArray[k].filtered = 0;
                    }
                }
            }
        }   
    } else {
        for (let i = 0; i < gEventLogArray.length; i++) {
            if (gEventLogArray[i].filtered == 0) {
                gTaskArray[gEventLogArray[i].tid].filtered = 0
            }
        }
        gFilterTimeType = getEntityUpper()  // reset to default
    }


    // reset filter globals
    gFromTime = '';
    gToTime = '';
    gAttribute = '';
    gAttributeType = '';

    let ctr = 0
    for (let i = 0; i < gEventLogArray.length; i++) {
        if (gEventLogArray[i].filtered == 0) ctr ++
    }

}

export const reGenerateArrays = () => {
    generateArrays(false, false, 'regenerate','');
};


export async function generateArrays(applyFilters, firstBuild, source, loadDiscoveryRules ) {
    const result = generateArraysImpl(applyFilters, firstBuild, source, loadDiscoveryRules, {
        // keep module-scoped perf timing behavior from the pre-refactor implementation
        setStartTime: (v) => { startTime = v; },
        // state arrays
        gLinkArray,
        gActivityArray,
        gEventLogArray,
        gVariantArray,
        gTaskArray,
        gStepArray,
        // shared counters / UI stats
        gEventsAll, gEventsFiltered,
        gTasksAll, gTasksFiltered,
        gVariantsAll, gVariantsFiltered,
        gStepsAll, gStepsFiltered,
        gActivitiesAll, gActivitiesFiltered,
        gDiagramPVTasks, gDiagramPVVariants, gDiagramPVEvents,
        gVariants, gVariantPaneVariants, gDefaultVariantsSelected,
        gProcessingModelMetrics,
        gEventEmitter,
        // local functions used by generateArrays
        updateVariantMetrics,
        filterArrays,
        updateSlicedVariables,
        generateTaskAnalyticsArray,
        generateTasksFilteredArray,
        generateEventAnalyticsArray,
        processVariantsTable,
        updateActivitTypeEvents,
        updateAttributes,
        updateFilterAttributes,
        entityUpper: gEntityUpper,
    });
    
    // Write back counters BEFORE modelMetrics — processStepsTable/variantsTable
    // need correct denominators immediately after generateArraysImpl completes.
    if (result) {
        if (result.gTasksAll      != null) gTasksAll      = result.gTasksAll;
        if (result.gEventsAll     != null) gEventsAll     = result.gEventsAll;
        if (result.gVariantsAll   != null) gVariantsAll   = result.gVariantsAll;
        if (result.gStepsAll      != null) gStepsAll      = result.gStepsAll;
        if (result.gActivitiesAll != null) gActivitiesAll = result.gActivitiesAll;
        gTasksFiltered      = result.gTasksFiltered;
        gEventsFiltered     = result.gEventsFiltered;
        gVariantsFiltered   = result.gVariantsFiltered;
        gStepsFiltered      = result.gStepsFiltered;
        gActivitiesFiltered = result.gActivitiesFiltered;
    }

    if (applyFilters === true) {
        await modelMetrics('month', 6);
        if (gEventEmitter) updateDashboard({ eventEmitter: gEventEmitter });
    }

    applyProcessArrayEnrichment();
}


function updateActivitTypeEvents() {  
    
    gEventLogArray.sort((a, b) => a.at.localeCompare(b.at));

    let events = 0
    let activity_type = ''
    for (let i = 0; i < gEventLogArray.length; i++) {
        if (i > 0 && gEventLogArray[i].at !== activity_type ) {
            for (let j = 0; j < gActivityTypes.length; j++) {
                if (gActivityTypes[j].activity_type === activity_type) gActivityTypes[j].events = events
            }
            events = 0
        }
        events ++
        activity_type = gEventLogArray[i].at
    }
    for (let j = 0; j < gActivityTypes.length; j++) {
        if (gActivityTypes[j].activity_type === activity_type) gActivityTypes[j].events = events
    }
}

function generateEventAnalyticsArray() {
    let endActivity = 0;
    for (let j = 0; j < gActivityArray.length; j++) {
        if (gActivityArray[j].en == true) {
            endActivity = gActivityArray[j].a;
        }
    }
    gAnalyticsEventArray = [];
    gEventLogArray = gEventLogArray.sort((a, b) => a.filtered - b.filtered);
    gVariantArray = gVariantArray.sort((a, b) => a.id - b.id);
    for (let i = 0; i < gEventLogArray.length; i++) {
        if (gEventLogArray[i].filtered == 1) {
            break;
        }
    
        if (gEventLogArray[i].t != endActivity && gVariantArray[gEventLogArray[i].vid].sliced == true) {
            let vtp = {};
            vtp['Duration'] = gEventLogArray[i].d;
            vtp['Resource'] = gEventLogArray[i].u;
            for (let z = 0; z < gEventAttributes.length; z++) {
                if (gEventAttributes[z].field != 'Resource') {
                    let key = 'ea' + z;
                    vtp[gEventAttributes[z].field] = gEventLogArray[i][key];
                }
            }
            vtp['Events'] = 1;
            vtp['Timestamp'] = gEventLogArray[i].ts;
            let year = parseInt(gEventLogArray[i].ts.substring(0, 4));
            let month = parseInt(gEventLogArray[i].ts.substring(5, 7));
            let day = parseInt(gEventLogArray[i].ts.substring(8, 10));
            vtp['UTC'] = Date.UTC(year, month - 1, day);
            gAnalyticsEventArray.push(vtp);
        }
    }
}

export async function generateTasksFilteredArray(type, variantPaneVariants, variant, activity, from, to, discovery_rule_id, groups, task) {   

    gClusterSourceDetails = []
    let vtp = {};
    vtp['type'] = type
    vtp['variantPaneVariants'] = variantPaneVariants
    vtp['variant'] = variant
    vtp['activity'] = activity
    vtp['from'] = from
    vtp['to'] = to
    vtp['discovery_rule_id'] = discovery_rule_id
    vtp['groups'] = groups
    gClusterSourceDetails.push(vtp)
    gRCDescription = '';
    let discoveryRuleKey = '';
    if (type === 'dt' || type === 'rc' || type === 'ia') {
        gRCDescription = 'All ' + gEntityUpper + 's';
    }
    if (type === 'dt_sv' || type === 'rc_sv' || type === 'ia_sv') {
        gRCDescription = gEntityUpper + 's for selected variants';
    }
    if (type === 'diagram') {
        gRCDescription = gEntityUpper + 's for selected variants';
    }
    if (type === 'step') {
        let fromStr = '';
        let toStr = '';
        for (let i = 0; i < gActivityArray.length; i++) {
            if (gActivityArray[i].id === parseInt(from)) {
                fromStr = gActivityArray[i].activity;
            }
            if (gActivityArray[i].id === parseInt(to)) {
                toStr = gActivityArray[i].activity;
            }
        }
        gRCDescription = 'From step: ' + fromStr + ', To step: ' + toStr;
    }
    if (type === 'activity') {
        let activityStr = '';
        for (let i = 0; i < gActivityArray.length; i++) {
            if (parseInt(gActivityArray[i].id) === parseInt(activity)) {
                activityStr = gActivityArray[i].activity;
            }
        }
        gRCDescription = 'Activity: ' + activityStr;
    }

    if (type === 'variant') {
        let variantStr = '';
        for (let i = 0; i < gVariantArray.length; i++) {
            if (parseInt(gVariantArray[i].v) === parseInt(variant)) {
                variantStr = gVariantArray[i].n;
                break;
            }
        }
        gRCDescription = 'Variant: ' + variantStr;
    }
    if (type === 'discovery_rule') {
        for (let i = 0; i < gDiscoveryRules.length; i++) {
            if (gDiscoveryRules[i].discovery_rule_id === discovery_rule_id) {
                gRCDescription = 'DiscoveryRule: ' + gDiscoveryRules[i].discovery_rule;
            }
        }
        discoveryRuleKey = 'f-' + discovery_rule_id;
    }
    if (type === 'tia_variant') {
        gRCDescription = 'Selected Variants' 
    }
    if (type === 'tia') {
        gRCDescription = 'All ' + getEntityUpper() + 's'
    }
    if (type === 'task_detail') {
        gRCDescription = getEntityUpper() + ' # ' + task
    }

    for (let i = 0; i < gEventLogArray.length; i++) {
        gEventLogArray[i].sliced = false
    }

    if (type === 'ia_node') gRCDescription = 'Selected Influence Analysis Node'
    if (type === 'rc_node') gRCDescription = 'Selected Cluster Node'
    if (type === 'dt_node')  gRCDescription = 'Selected decomposition_tree Node'
    if (type === 'ia_node' || type === 'rc_node' || type === 'dt_node') {  
        let tempArray = []
        let tempTaskArray = gTaskStr.split('^');
        gTaskArray.sort((a, b) => a.id - b.id);
        for (let i = 0; i < tempTaskArray.length; i++) {
            tempArray.push(gTaskArray[parseInt(tempTaskArray[i])])
        }
        gTasksFilteredArray = tempArray
    } else {

        gTasksFilteredArray = [];
        gTaskArray = gTaskArray.sort((a, b) => a.filtered - b.filtered);
        gEventLogArray.sort((a, b) => a.elid - b.elid);
        gVariantArray.sort((a, b) => a.id - b.id);
        for (let i = 0; i < gTaskArray.length; i++) {
            gTaskArray[i].sliced = false
            if (gTaskArray[i].filtered != 1 && gVariantArray[gTaskArray[i].vid].sliced == true) {
                let validTask = true;
                if (variantPaneVariants == true || type == 'diagram') {
                    validTask = false;
                    for (let j = 0; j < gVariantPaneVariants.length; j++) {
                        if (gTaskArray[i].v == gVariantPaneVariants[j].v) {
                            validTask = true;
                            break;
                        }
                    }
                }
                if (validTask == true) {
                    if (type == 'tia' || type == 'tia_variant' ) {
                        gTasksFilteredArray.push(gTaskArray[i]);
                        gTaskArray[i].sliced = true
                        for (let f = gTaskArray[i].si; f < gTaskArray[i].fi + 1; f++) {
                            gEventLogArray[f].sliced = true
                        }
                    }

                    if (type == 'diagram') {
                        gTasksFilteredArray.push(gTaskArray[i]);
                        gTaskArray[i].sliced = true
                        for (let f = gTaskArray[i].si; f < gTaskArray[i].fi + 1; f++) {
                            gEventLogArray[f].sliced = true
                        }
                    }
                    if (type == 'variant') {
                        if (gTaskArray[i].v == variant) {
                            gTasksFilteredArray.push(gTaskArray[i]);
                            gTaskArray[i].sliced = true
                            for (let f = gTaskArray[i].si; f < gTaskArray[i].fi + 1; f++) {
                                gEventLogArray[f].sliced = true
                            }
                        }
                    }
                    if (type == 'activity') {
                        for (let f = gTaskArray[i].si; f < gTaskArray[i].fi + 1; f++) {
                            if (gEventLogArray[f].t == parseInt(activity)) {
                                gTasksFilteredArray.push(gTaskArray[i]);
                                gTaskArray[i].sliced = true
                                gEventLogArray[f].sliced = true
                                break;
                            }
                        }
                    }
                    if (type == 'step') {
                        for (let f = gTaskArray[i].si; f < gTaskArray[i].fi + 1; f++) {
                            if (gEventLogArray[f].f == parseInt(from) && gEventLogArray[f].t == parseInt(to)) {
                                gTasksFilteredArray.push(gTaskArray[i]);
                                gTaskArray[i].sliced = true
                                gEventLogArray[f].sliced = true
                                validTask = true;
                                break;
                            }
                        }
                    }
                    if (type === 'rc' || type === 'dt' || type === 'ia' || type === 'rc_sv' || type === 'dt_sv' || type === 'ia_sv') {
                        validTask = true;
                        gTasksFilteredArray.push(gTaskArray[i]);
                        gTaskArray[i].sliced = true
                        for (let f = gTaskArray[i].si; f < gTaskArray[i].fi + 1; f++) {
                            gEventLogArray[f].sliced = true
                        }
                    }

                    if (type === 'discovery_rule') {
                        for (let f = gTaskArray[i].si; f < gTaskArray[i].fi + 1; f++) {
                            if (gEventLogArray[f][discoveryRuleKey] === 1) {
                                gTasksFilteredArray.push(gTaskArray[i]);
                                gTaskArray[i].sliced = true
                                gEventLogArray[f].sliced = true
                                break;
                            }
                        }
                    }
                    if (type === 'task_detail' ) {
                        if (gTaskArray[i].k === task ) {
                            gTasksFilteredArray.push(gTaskArray[i]);
                            gTaskArray[i].sliced = true
                            for (let f = gTaskArray[i].si; f < gTaskArray[i].fi + 1; f++) {
                                gEventLogArray[f].sliced = true
                            }
                        }
                    }
                }
            }
        }
    }
    if ( gTasksFilteredArray.length > 0 ) {
        gClusterMaxTasks = gTasksFilteredArray.length
        gInfluenceAnalysisMaxTasks = gTasksFilteredArray.length
        gDecompositionTreeMaxTasks = gTasksFilteredArray.length
    }
}

function generateTaskAnalyticsArray() {
    gAnalyticsTaskArray = [];
    gTaskArray = gTaskArray.sort((a, b) => a.id - b.id);
    gVariantArray = gVariantArray.sort((a, b) => a.id - b.id);
    for (let i = 0; i < gTaskArray.length; i++) {
        if (gTaskArray[i].filtered != 1 && gVariantArray[gTaskArray[i].vid].sliced == true) {
            let vtp = {};

            for (let z = 0; z < gTaskAttributes.length; z++) {
                let key = 'ta' + z;
                vtp[gTaskAttributes[z].field] = gTaskArray[i][key];
            }
            vtp['Duration'] = gTaskArray[i].d;
            vtp['Tasks'] = 1;
            vtp['Number'] = gTaskArray[i].k;
            vtp['Timestamp'] = gTaskArray[i].t1;
            vtp['Comments'] = gTaskArray[i].comments;
            vtp['Worklogs'] = gTaskArray[i].worklog;
            let year = parseInt(gTaskArray[i].t1.substring(0, 4));
            let month = parseInt(gTaskArray[i].t1.substring(5, 7));
            let day = parseInt(gTaskArray[i].t1.substring(8, 10));
            vtp['UTC'] = Date.UTC(year, month - 1, day);
            vtp['Variant'] = gVariantArray[gTaskArray[i].vid].n;
            vtp['ActualCost'] = gVariantArray[gTaskArray[i].vid].actual_cost / gVariantArray[gTaskArray[i].vid].t;
            vtp['ForecastCost'] = gVariantArray[gTaskArray[i].vid].forecast_cost / gVariantArray[gTaskArray[i].vid].t;

            gAnalyticsTaskArray.push(vtp);
        }
    }
}

export function analyticsEventHistory(metric) { 
    gAnalyticsEventArray.sort((a, b) => a.UTC - b.UTC);
    let rows = [];
    let UTC = null;
    let events = 0;
    if (metric.metric === 'events') {
        for (let i = 0; i < gAnalyticsEventArray.length; i++) {
            if (i > 0 && gAnalyticsEventArray[i].UTC != gAnalyticsEventArray[i - 1].UTC) {
                rows.push([gAnalyticsEventArray[i-1].UTC, events]);
                events = 0;
            }
            events++;
            UTC = gAnalyticsEventArray[i].UTC;
        }
        rows.push([UTC, events]);
    }

    return rows;
}

export function analyticsTaskAttributes() {
    let rows = [];
    if (gTaskAttributes.length == 0) {
        return rows;
    }
    if (gAnalyticsTaskAttribute == '') {
        gAnalyticsTaskAttribute = gTaskAttributes[0].field;
    }
    if (gAnalyticsTaskAttribute != '') {
        gAnalyticsTaskArray = gAnalyticsTaskArray.sort((a, b) => a[gAnalyticsTaskAttribute].localeCompare(b[gAnalyticsTaskAttribute]));

        let attributeLabel = null;
        let tasks = 0;
        let duration = 0;
        let actualCost = 0;
        let forecastCost = 0;
        let customer_comments = 0
        let internal_comments = 0
        let worklogs = 0
        let time_spent = 0

        for (let i = 0; i < gAnalyticsTaskArray.length; i++) {
            if (i > 0 && gAnalyticsTaskArray[i][gAnalyticsTaskAttribute] != gAnalyticsTaskArray[i - 1][gAnalyticsTaskAttribute]) {
                if (gAnalyticsTaskAttributeMetric == 1) rows.push([gAnalyticsTaskArray[i - 1][gAnalyticsTaskAttribute].replaceAll('^^',','), tasks]);
                if (gAnalyticsTaskAttributeMetric == 2) rows.push([gAnalyticsTaskArray[i - 1][gAnalyticsTaskAttribute].replaceAll('^^',','), duration / tasks / 60]);
                if (gAnalyticsTaskAttributeMetric == 3) rows.push([gAnalyticsTaskArray[i - 1][gAnalyticsTaskAttribute].replaceAll('^^',','), duration / tasks / 3600]);
                if (gAnalyticsTaskAttributeMetric == 4) rows.push([gAnalyticsTaskArray[i - 1][gAnalyticsTaskAttribute].replaceAll('^^',','), duration / tasks / 62400]);
                if (gAnalyticsTaskAttributeMetric == 5) rows.push([gAnalyticsTaskArray[i - 1][gAnalyticsTaskAttribute].replaceAll('^^',','), actualCost]);
                if (gAnalyticsTaskAttributeMetric == 6) rows.push([gAnalyticsTaskArray[i - 1][gAnalyticsTaskAttribute].replaceAll('^^',','), forecastCost]);
                if (gAnalyticsTaskAttributeMetric == 7) rows.push([gAnalyticsTaskArray[i - 1][gAnalyticsTaskAttribute].replaceAll('^^',','), actualCost - forecastCost]);
                if (gAnalyticsTaskAttributeMetric == 8) rows.push([gAnalyticsTaskArray[i - 1][gAnalyticsTaskAttribute].replaceAll('^^',','), actualCost / tasks]);
                if (gAnalyticsTaskAttributeMetric == 9) rows.push([gAnalyticsTaskArray[i - 1][gAnalyticsTaskAttribute].replaceAll('^^',','), forecastCost / tasks]);
                if (gAnalyticsTaskAttributeMetric == 10) rows.push([gAnalyticsTaskArray[i - 1][gAnalyticsTaskAttribute], (actualCost - forecastCost) / tasks]);
                if (gAnalyticsTaskAttributeMetric == 11) rows.push([gAnalyticsTaskArray[i - 1][gAnalyticsTaskAttribute], customer_comments]);
                if (gAnalyticsTaskAttributeMetric == 12) rows.push([gAnalyticsTaskArray[i - 1][gAnalyticsTaskAttribute], internal_comments]);
                if (gAnalyticsTaskAttributeMetric == 13) rows.push([gAnalyticsTaskArray[i - 1][gAnalyticsTaskAttribute], worklogs]);
                if (gAnalyticsTaskAttributeMetric == 14) rows.push([gAnalyticsTaskArray[i - 1][gAnalyticsTaskAttribute], (time_spent/60)/tasks]);
                if (gAnalyticsTaskAttributeMetric == 15) rows.push([gAnalyticsTaskArray[i - 1][gAnalyticsTaskAttribute], (time_spent/60)]);
                tasks = 0;
                duration = 0;
                actualCost = 0;
                forecastCost = 0;
                customer_comments = 0
                internal_comments = 0
                worklogs = 0
                time_spent = 0
            }
            tasks++;
            duration = duration + gAnalyticsTaskArray[i].Duration;
            actualCost = actualCost + gAnalyticsTaskArray[i].ActualCost;
            forecastCost = forecastCost + gAnalyticsTaskArray[i].ForecastCost;
            attributeLabel = gAnalyticsTaskArray[i][gAnalyticsTaskAttribute].replaceAll('^^',',');
		    let comments = gAnalyticsTaskArray[i].Comments  
            let worklog = gAnalyticsTaskArray[i].Worklogs
            if (comments !== undefined && comments[0] !== undefined) {
                for (let c = 0; c < comments.length; c++) {
                    if (comments[c].jsdPublic === 'true') customer_comments ++
                    else internal_comments ++
                }
            }
            if (worklog !== undefined  && worklog[0] !== undefined) {
                for (let w = 0; w < worklog.length; w++) {
                    worklogs ++
                    time_spent = time_spent + parseInt(worklog[w].timeSpentSeconds)  
                }         
            }

        }
        if (gAnalyticsTaskAttributeMetric == 1) rows.push([attributeLabel, tasks]);
        if (gAnalyticsTaskAttributeMetric == 2) rows.push([attributeLabel, duration / tasks / 60]);
        if (gAnalyticsTaskAttributeMetric == 3) rows.push([attributeLabel, duration / tasks / 3600]);
        if (gAnalyticsTaskAttributeMetric == 4) rows.push([attributeLabel, duration / tasks / 62400]);
        if (gAnalyticsTaskAttributeMetric == 5) rows.push([attributeLabel, actualCost]);
        if (gAnalyticsTaskAttributeMetric == 6) rows.push([attributeLabel, forecastCost]);
        if (gAnalyticsTaskAttributeMetric == 7) rows.push([attributeLabel, actualCost - forecastCost]);
        if (gAnalyticsTaskAttributeMetric == 8) rows.push([attributeLabel, actualCost / tasks]);
        if (gAnalyticsTaskAttributeMetric == 9) rows.push([attributeLabel, forecastCost / tasks]);
        if (gAnalyticsTaskAttributeMetric == 10) rows.push([attributeLabel, (actualCost - forecastCost) / tasks]);
        if (gAnalyticsTaskAttributeMetric == 11) rows.push([attributeLabel, customer_comments]);
        if (gAnalyticsTaskAttributeMetric == 12) rows.push([attributeLabel, internal_comments]);
        if (gAnalyticsTaskAttributeMetric == 13) rows.push([attributeLabel, worklogs]);
        if (gAnalyticsTaskAttributeMetric == 14) rows.push([attributeLabel, (time_spent/60)/tasks]);
        if (gAnalyticsTaskAttributeMetric == 15) rows.push([attributeLabel, time_spent/60]);
    }
    return rows;
}

function dateToYMD(date) {
    var d = date.getDate();
    var m = date.getMonth() + 1; //Month from 0 to 11
    var y = date.getFullYear();
    return '' + y + '-' + (m<=9 ? '0' + m : m) + '-' + (d <= 9 ? '0' + d : d);
}

export function processAnalyticsHistory(params) { 
    let discoveryRule = ''
    if (params.type == 'DiscoveryRule' ) discoveryRule = 'f-' + params.discovery_rule_id;
    
    let startDate = new Date(parseInt(gModelFromDate.substring(0, 4)), parseInt(gModelFromDate.substring(5, 7))-1, parseInt(gModelFromDate.substring(8, 10)));
    let endDate = new Date(parseInt(gModelToDate.substring(0, 4)), parseInt(gModelToDate.substring(5, 7))-1, parseInt(gModelToDate.substring(8, 10)));
    let dateArray = []

    let k = 0
    for (let d = startDate; d <= endDate; d.setDate(d.getDate() + 1)) {
        let year = d.getFullYear();
        let month = d.getMonth() ;
        let day = d.getDate();
        let vtp = {};
        vtp['UTC'] = Date.UTC(year, month , day)
        vtp['id'] = k
        vtp['el_sid'] = 0
        vtp['el_fid'] = 0
        dateArray.push(vtp)
        k ++
    }
    
    gTaskArray.sort((a, b) => a.filtered - b.filtered  || a.utc - b.utc);
    gVariantArray = gVariantArray.sort((a, b) => a.id - b.id);
    let tempArray = []
    if (params.source === 'ia_node' || params.source === 'rc_node' || params.source === 'dt_node') {  
        let tempTaskArray = gTaskStr.split('^');
        gTaskArray.sort((a, b) => a.id - b.id);
        for (let i = 0; i < tempTaskArray.length; i++) {
            tempArray.push(gTaskArray[parseInt(tempTaskArray[i])])
        }
    }
    else {
        for (let i = 0; i < gTaskArray.length; i++) {
            if (gTaskArray[i].filtered == 1) {break}
    
            let validTask = true
            if (params.source == 'diagram') {
                if (gVariantArray[gTaskArray[i].vid].sliced == false) {validTask = false}
                if (validTask == true) {
                    validTask = false
                    for (let k = 0; k < gVariantPaneVariants.length; k++) {
                        if (gTaskArray[i].v == gVariantPaneVariants[k].v) {validTask = true; break}
                    }
                }
            }
            if (validTask == true ) {tempArray.push(gTaskArray[i])}
        }
    }
    let tTaskArray = []
    let previousUTC = 0
    let startID = 0
    let i = 0
    tempArray = tempArray.sort((a, b) => a.utc - b.utc);
    for (i = 0; i < tempArray.length; i++) {

        let vtp = {};
        vtp['utc'] = tempArray[i].utc
        vtp['v'] = tempArray[i].v
        vtp['si'] = tempArray[i].si
        vtp['fi'] = tempArray[i].fi
        vtp['tid'] = tempArray[i].id
        vtp['id'] = i
        tTaskArray.push(vtp)
        if (tempArray[i].utc != previousUTC && i > 0) {

            for (let j = 0; j < dateArray.length; j++) {
                let dateFound = false
                if (dateArray[j].UTC == previousUTC) {
                    dateArray[j].t_sid = startID
                    dateArray[j].t_fid = i - 1
                    dateFound = true
                }
                if (dateFound == true) {break}
            }
            startID = i
        }
        previousUTC = tempArray[i].utc
        
    }
    for (let j = 0; j < dateArray.length; j++) {
        if (dateArray[j].UTC == previousUTC) {
            dateArray[j].t_sid = startID
            dateArray[j].t_fid = i - 1
        }
    }
    gEventLogArray.sort((a, b) => a.elid - b.elid );
    tTaskArray.sort((a, b) => a.id - b.id );
    gTaskArray.sort((a, b) => a.id - b.id );
    let rows = []  
    for (let j = 0; j < dateArray.length; j++) { 
        let tasks = 0;
        let duration = 0;
        let customer_comments = 0
        let internal_comments = 0
        let worklogs = 0
        let time_spent = 0

        if (params.type == 'Variant') {
            for (let i = dateArray[j].t_sid; i <= dateArray[j].t_fid; i++) {
                if (params.variant == tTaskArray[i].v ) {
                    tasks ++
                    duration = duration + gTaskArray[tTaskArray[i].id].d
                    let comments = gTaskArray[tTaskArray[i].id].comments  
                    let worklog = gTaskArray[tTaskArray[i].id].worklog
                    if (comments !== undefined && comments[0] !== undefined) {
                        for (let c = 0; c < comments.length; c++) {
                            if (comments[c].jsdPublic === 'true') customer_comments ++
                            else internal_comments ++
                        }
                    }
                    if (worklog !== undefined  && worklog[0] !== undefined) {
                        for (let w = 0; w < worklog.length; w++) {
                            worklogs ++
                            time_spent = time_spent + parseInt(worklog[w].timeSpentSeconds)  
                        }         
                    }                    
                }
            }
        } 
        if (params.type == 'Activity') {
            for (let i = dateArray[j].t_sid; i <= dateArray[j].t_fid; i++) {
                for (let k = gEventLogArray[tTaskArray[i].si].elid; k <= gEventLogArray[tTaskArray[i].fi].elid; k++) {
                    if (params.activity == gEventLogArray[k].t && gEventLogArray[k].loop == false && gEventLogArray[k].duplicate == false) {
                        duration = duration + gTaskArray[tTaskArray[i].id].d
                        let comments = gTaskArray[tTaskArray[i].id].comments  
                        let worklog = gTaskArray[tTaskArray[i].id].worklog
                        if (comments !== undefined && comments[0] !== undefined) {
                            for (let c = 0; c < comments.length; c++) {
                                if (comments[c].jsdPublic === 'true') customer_comments ++
                                else internal_comments ++
                            }
                        }   
                        if (worklog !== undefined  && worklog[0] !== undefined) {
                            for (let w = 0; w < worklog.length; w++) {
                                worklogs ++
                                time_spent = time_spent + parseInt(worklog[w].timeSpentSeconds)  
                            }         
                        }                    
                        tasks ++
                    }
                }            
            }
        }       

        if (params.type == 'Step') {
            for (let i = dateArray[j].t_sid; i <= dateArray[j].t_fid; i++) {
                for (let k = gEventLogArray[tTaskArray[i].si].elid; k <= gEventLogArray[tTaskArray[i].fi].elid; k++) {
                    if (params.from == gEventLogArray[k].f && params.to == gEventLogArray[k].t ) {
                        duration = duration + gTaskArray[tTaskArray[i].id].d
                        let comments = gTaskArray[tTaskArray[i].id].comments  
                        let worklog = gTaskArray[tTaskArray[i].id].worklog
                        if (comments !== undefined && comments[0] !== undefined) {
                            for (let c = 0; c < comments.length; c++) {
                                if (comments[c].jsdPublic === 'true') customer_comments ++
                                else internal_comments ++
                            }
                        }   
                        if (worklog !== undefined  && worklog[0] !== undefined) {
                            for (let w = 0; w < worklog.length; w++) {
                                worklogs ++
                                time_spent = time_spent + parseInt(worklog[w].timeSpentSeconds)  
                            }         
                        }                    
                        tasks ++
                    }
                }            
            }
        }   

        if (params.type == 'Diagram') {
            for (let i = dateArray[j].t_sid; i <= dateArray[j].t_fid; i++) {

                for (let k = 0; k < gVariantPaneVariants.length; k++) {
                    if (tTaskArray[i].v == gVariantPaneVariants[k].v) {
                        tasks++;
                        duration = duration + gTaskArray[tTaskArray[i].id].d
                        let comments = gTaskArray[tTaskArray[i].id].comments  
                        let worklog = gTaskArray[tTaskArray[i].id].worklog
                        if (comments !== undefined && comments[0] !== undefined) {
                            for (let c = 0; c < comments.length; c++) {
                                if (comments[c].jsdPublic === 'true') customer_comments ++
                                else internal_comments ++
                            }
                        }   
                        if (worklog !== undefined  && worklog[0] !== undefined) {
                            for (let w = 0; w < worklog.length; w++) {
                                worklogs ++
                                time_spent = time_spent + parseInt(worklog[w].timeSpentSeconds)  
                            }         
                        }                    
                        break
                    }
                }
            }
        }  

        if (params.source === 'ia_node' || params.source === 'rc_node' || params.source === 'dt_node') {  
            for (let i = dateArray[j].t_sid; i <= dateArray[j].t_fid; i++) {
                tasks ++
                duration = duration + gTaskArray[tTaskArray[i].id].d
                let comments = gTaskArray[tTaskArray[i].id].comments  
                let worklog = gTaskArray[tTaskArray[i].id].worklog
                if (comments !== undefined && comments[0] !== undefined) {
                    for (let c = 0; c < comments.length; c++) {
                        if (comments[c].jsdPublic === 'true') customer_comments ++
                        else internal_comments ++
                    }
                }   
                if (worklog !== undefined  && worklog[0] !== undefined) {
                    for (let w = 0; w < worklog.length; w++) {
                        worklogs ++
                        time_spent = time_spent + parseInt(worklog[w].timeSpentSeconds)  
                    }         
                }                    
            }
        }
        
        if (params.type == 'DiscoveryRule') {
            for (let i = dateArray[j].t_sid; i <= dateArray[j].t_fid; i++) {
                for (let k = gEventLogArray[tTaskArray[i].si].elid; k <= gEventLogArray[tTaskArray[i].fi].elid; k++) {
                    for (let l = 0; l < gEventLogArray[k].discovery_rules.length; l++) {
                        if (gEventLogArray[k].discovery_rules[l].discovery_rule_id == params.discovery_rule_id) { 
                            let comments = gTaskArray[tTaskArray[i].id].comments  
                            let worklog = gTaskArray[tTaskArray[i].id].worklog
                            if (comments !== undefined && comments[0] !== undefined) {
                                for (let c = 0; c < comments.length; c++) {
                                    if (comments[c].jsdPublic === 'true') customer_comments ++
                                    else internal_comments ++
                                }
                            }   
                            if (worklog !== undefined  && worklog[0] !== undefined) {
                                for (let w = 0; w < worklog.length; w++) {
                                    worklogs ++
                                    time_spent = time_spent + parseInt(worklog[w].timeSpentSeconds)  
                                }         
                            }                    
                            duration = duration + gTaskArray[tTaskArray[i].id].d
                            tasks ++
                        }
                    }
                }            
            }
        }
        if (gAnalyticsTaskAttributeMetric == 1) rows.push([dateArray[j].UTC, tasks]);
        if (gAnalyticsTaskAttributeMetric == 2) rows.push([dateArray[j].UTC, duration / tasks / 60]);
        if (gAnalyticsTaskAttributeMetric == 3) rows.push([dateArray[j].UTC, duration / tasks / 3600]);
        if (gAnalyticsTaskAttributeMetric == 4) rows.push([dateArray[j].UTC, duration / tasks / 62400]);
        if (gAnalyticsTaskAttributeMetric == 5) rows.push([dateArray[j].UTC, customer_comments]);
        if (gAnalyticsTaskAttributeMetric == 6) rows.push([dateArray[j].UTC, internal_comments]);
        if (gAnalyticsTaskAttributeMetric == 7) rows.push([dateArray[j].UTC, worklogs]);
        if (gAnalyticsTaskAttributeMetric == 8) rows.push([dateArray[j].UTC, (time_spent/60)/tasks]);
        if (gAnalyticsTaskAttributeMetric == 9) rows.push([dateArray[j].UTC, time_spent/60]);
    }
    return rows
}

export function analyticsTaskHistory() {  
    gAnalyticsTaskArray.sort((a, b) => a.UTC - b.UTC);
    let rows = [];
    let UTC = null;
    let tasks = 0;
    let duration = 0;
    let actualCost = 0;
    let forecastCost = 0;
    let customer_comments = 0
    let internal_comments = 0
    let worklogs = 0
    let time_spent = 0
    for (let i = 0; i < gAnalyticsTaskArray.length; i++) {
        if (i > 0 && gAnalyticsTaskArray[i].UTC != gAnalyticsTaskArray[i - 1].UTC) {
            if (gAnalyticsTaskHistoryMetric == 1) rows.push([gAnalyticsTaskArray[i - 1].UTC, tasks]);
            if (gAnalyticsTaskHistoryMetric == 2) rows.push([gAnalyticsTaskArray[i - 1].UTC, duration / tasks / 60]);
            if (gAnalyticsTaskHistoryMetric == 3) rows.push([gAnalyticsTaskArray[i - 1].UTC, duration / tasks / 3600]);
            if (gAnalyticsTaskHistoryMetric == 4) rows.push([gAnalyticsTaskArray[i - 1].UTC, duration / tasks / 62400]);
            if (gAnalyticsTaskHistoryMetric == 5) rows.push([gAnalyticsTaskArray[i - 1].UTC, actualCost]);
            if (gAnalyticsTaskHistoryMetric == 6) rows.push([gAnalyticsTaskArray[i - 1].UTC, forecastCost]);
            if (gAnalyticsTaskHistoryMetric == 7) rows.push([gAnalyticsTaskArray[i - 1].UTC, actualCost - forecastCost]);
            if (gAnalyticsTaskHistoryMetric == 8) rows.push([gAnalyticsTaskArray[i - 1].UTC, actualCost / tasks]);
            if (gAnalyticsTaskHistoryMetric == 9) rows.push([gAnalyticsTaskArray[i - 1].UTC, forecastCost / tasks]);
            if (gAnalyticsTaskHistoryMetric == 10) rows.push([gAnalyticsTaskArray[i - 1].UTC, (actualCost - forecastCost) / tasks]);  
            if (gAnalyticsTaskHistoryMetric == 11) rows.push([gAnalyticsTaskArray[i - 1].UTC, customer_comments]);
            if (gAnalyticsTaskHistoryMetric == 12) rows.push([gAnalyticsTaskArray[i - 1].UTC, internal_comments]);
            if (gAnalyticsTaskHistoryMetric == 13) rows.push([gAnalyticsTaskArray[i - 1].UTC, worklogs]);
            if (gAnalyticsTaskHistoryMetric == 14) rows.push([gAnalyticsTaskArray[i - 1].UTC, (time_spent/60)/tasks]);
            if (gAnalyticsTaskHistoryMetric == 15) rows.push([gAnalyticsTaskArray[i - 1].UTC, time_spent/60]);

            tasks = 0;
            duration = 0;
            actualCost = 0;
            forecastCost = 0;
            customer_comments = 0
            internal_comments = 0
            worklogs = 0
            time_spent = 0
        }
        tasks++;
        duration = duration + gAnalyticsTaskArray[i].Duration;
        actualCost = actualCost + gAnalyticsTaskArray[i].ActualCost;
        forecastCost = forecastCost + gAnalyticsTaskArray[i].ForecastCost;
        UTC = gAnalyticsTaskArray[i].UTC;
		let comments = gAnalyticsTaskArray[i].Comments  
        let worklog = gAnalyticsTaskArray[i].Worklogs
        if (comments !== undefined && comments[0] !== undefined) {
            for (let c = 0; c < comments.length; c++) {
                if (comments[c].jsdPublic === 'true') customer_comments ++
                else internal_comments ++
            }
        }
        if (worklog !== undefined  && worklog[0] !== undefined) {
            for (let w = 0; w < worklog.length; w++) {
                worklogs ++
                time_spent = time_spent + parseInt(worklog[w].timeSpentSeconds)  
            }         
        }
    }
    if (gAnalyticsTaskHistoryMetric == 1) rows.push([UTC, tasks]);
    if (gAnalyticsTaskHistoryMetric == 2) rows.push([UTC, duration / tasks / 60]);
    if (gAnalyticsTaskHistoryMetric == 3) rows.push([UTC, duration / tasks / 3600]);
    if (gAnalyticsTaskHistoryMetric == 4) rows.push([UTC, duration / tasks / 62400]);
    if (gAnalyticsTaskHistoryMetric == 5) rows.push([UTC, actualCost]);
    if (gAnalyticsTaskHistoryMetric == 6) rows.push([UTC, forecastCost]);
    if (gAnalyticsTaskHistoryMetric == 7) rows.push([UTC, actualCost - forecastCost]);
    if (gAnalyticsTaskHistoryMetric == 8) rows.push([UTC, actualCost / tasks]);
    if (gAnalyticsTaskHistoryMetric == 9) rows.push([UTC, forecastCost / tasks]);
    if (gAnalyticsTaskHistoryMetric == 10) rows.push([UTC, (actualCost - forecastCost) / tasks]);
    if (gAnalyticsTaskHistoryMetric == 11) rows.push([UTC, customer_comments]);
    if (gAnalyticsTaskHistoryMetric == 12) rows.push([UTC, internal_comments]);
    if (gAnalyticsTaskHistoryMetric == 13) rows.push([UTC, worklogs]);
    if (gAnalyticsTaskHistoryMetric == 14) rows.push([UTC, (time_spent/60)/tasks]);
    if (gAnalyticsTaskHistoryMetric == 15) rows.push([UTC, time_spent/60]);
    
    return rows;
}

export function analyticsEventAttributes(metric) {
    let rows = [];
    if (gEventAttributes.length == 0) {
        return rows;
    }
    if (gAnalyticsEventAttribute == '') {
        gAnalyticsEventAttribute = gEventAttributes[0].field;
    }
    if (gAnalyticsEventAttribute != '') {
        gAnalyticsEventArray = gAnalyticsEventArray.sort((a, b) => a[gAnalyticsEventAttribute].localeCompare(b[gAnalyticsEventAttribute]));

        let attributeLabel = null;
        let events = 0;
        for (let i = 0; i < gAnalyticsEventArray.length; i++) {
            if (i > 0 && gAnalyticsEventArray[i][gAnalyticsEventAttribute] != gAnalyticsEventArray[i - 1][gAnalyticsEventAttribute]) {
                if (metric.metric === 'events') {
                    rows.push([gAnalyticsEventArray[i - 1][gAnalyticsEventAttribute], events]);
                }

                events = 0;
            }
            events = events + gAnalyticsEventArray[i].Events;
            attributeLabel = gAnalyticsEventArray[i][gAnalyticsEventAttribute];
        }
        if (metric.metric === 'events') {
            rows.push([attributeLabel, events]);
        }
    }
    return rows;
}

function updateAttributes() {

    let endActivity = 0;
    let startActivity = 0;
    for (let j = 0; j < gActivityArray.length; j++) {
        if (gActivityArray[j].activity == 'Start') {
            startActivity = gActivityArray[j].id;
        }
        if (gActivityArray[j].activity == 'End') {
            endActivity = gActivityArray[j].id;
        }
    }

    gAttributeArray.length = 0;
    gTaskArray.sort((a, b) => a.id - b.id);
    let resourceExists = false;
    for (let i = 0; i < gEventAttributes.length; i++) {
        if (gEventAttributes[i].field == 'Resource') {
            resourceExists = true;
        }
    }
    let k = 0;
    gVariantArray.sort((a, b) => a.id - b.id);
    for (k = 0; k < gEventAttributes.length; k++) {
        if (gEventAttributes[k].field != 'Resource') {
            let key = 'ea' + k;
            gEventLogArray.sort((a, b) => a.filtered - b.filtered || a[key].localeCompare(b[key]) || a.k.localeCompare(b.k));
            let attribute = null;
            let task = '';
            let sdArray = [];
            let tasks = 0;
            let events = 0;
            let duration = 0;
            let i = 0;
            for (let i = 0; i < gEventLogArray.length; i++) {
                if (gEventLogArray[i].filtered == 1) {
                    break;
                }
                let validRec = true;
                if (gVariantArray[gEventLogArray[i].vid].sliced === false) {
                    validRec = false;
                }
                if (validRec === true) {
                    if (gEventLogArray[i].t != endActivity) {
                        if (attribute != gEventLogArray[i][key] && i > 0) {
                            let vtp = {};
                            vtp['type'] = 'Event';
                            vtp['field'] = gEventAttributes[k].field;
                            vtp['value'] = attribute;
                            vtp['selected'] = false;
                            vtp['tasks'] = tasks;
                            vtp['events'] = events;
                            vtp['avg_duration'] = duration / tasks;
                            vtp['std_deviation'] = getStandardDeviation(sdArray);
                            gAttributeArray.push(vtp);

                            tasks = 1;
                            events = 1;
                            sdArray.length = 0;
                            sdArray.push(parseInt(gEventLogArray[i].d));
                            duration = parseInt(gEventLogArray[i].d);
                        } else {
                            if (task != gEventLogArray[i].k) {
                                tasks++;
                            }
                            events++;
                            duration = duration + parseInt(gEventLogArray[i].d);
                            sdArray.push(parseInt(gEventLogArray[i].d));
                        }
                    }
                    task = gEventLogArray[i].k;
                    attribute = gEventLogArray[i][key];
                }
            }
            if (i > 0) {
                let validRec = true;
                if (gVariantArray[gEventLogArray[i - 1].vid].sliced === false) {
                    validRec = false;
                }
                if (validRec === true) {
                    let vtp = {};
                    vtp['type'] = 'Event';
                    vtp['field'] = gEventAttributes[k].field;
                    vtp['value'] = gEventLogArray[i - 1][key];
                    vtp['selected'] = false;
                    vtp['tasks'] = tasks;
                    vtp['events'] = events;
                    vtp['avg_duration'] = duration / tasks;
                    vtp['std_deviation'] = getStandardDeviation(sdArray);
                    gAttributeArray.push(vtp);
                }
            }
        }
    }

    if (resourceExists == true) {
        let user = '';
        let task = '';
        let sdArray = [];
        let tasks = 0;
        let events = 0;
        let duration = 0;
        gEventLogArray.sort((a, b) => a.filtered - b.filtered || a.u.localeCompare(b.u) || a.k.localeCompare(b.k));
        let i = 0;
        for (let i = 0; i < gEventLogArray.length; i++) {
            if (gEventLogArray[i].filtered == 1) {
                break;
            }
            if (gEventLogArray[i].t != endActivity) {
                let validRec = true;
                if (gVariantArray[gEventLogArray[i].vid].sliced === false) {
                    validRec = false;
                }
                if (validRec === true) {
                    if (user != gEventLogArray[i].u && i > 0) {
                        let vtp = {};
                        vtp['type'] = 'Event';
                        vtp['field'] = 'Resource';
                        vtp['value'] = user;
                        vtp['selected'] = false;
                        vtp['tasks'] = tasks;
                        vtp['events'] = events;
                        vtp['avg_duration'] = duration / tasks;
                        vtp['std_deviation'] = getStandardDeviation(sdArray);
                        gAttributeArray.push(vtp);

                        tasks = 1;
                        events = 1;

                        sdArray.length = 0;
                        sdArray.push(parseInt(gEventLogArray[i].d));
                        duration = parseInt(gEventLogArray[i].d);
                    } else {
                        if (task != gEventLogArray[i].k) {
                            tasks++;
                        }
                        events++;
                        duration = duration + parseInt(gEventLogArray[i].d);
                        sdArray.push(parseInt(gEventLogArray[i].d));
                    }
                }
                user = gEventLogArray[i].u;
                task = gEventLogArray[i].k;
            }
        }
        if (i > 0) {
            let validRec = true;
            if (gVariantArray[gEventLogArray[i - 1].vid].sliced === false) {
                validRec = false;
            }
            if (validRec === true) {
                let vtp = {};
                vtp['type'] = 'Event';
                vtp['field'] = 'Resource';
                vtp['value'] = user;
                vtp['selected'] = false;
                vtp['tasks'] = tasks;
                vtp['events'] = events;
                vtp['avg_duration'] = duration / tasks;
                vtp['std_deviation'] = getStandardDeviation(sdArray);
                gAttributeArray.push(vtp);
            }
        }
    }

    // task attributes
    gEventLogArray.sort((a, b) => a.eid - b.eid);
    for (let k = 0; k < gTaskAttributes.length; k++) {
        let key = 'ta' + k;
        let gTempTaskArray = []
        if (gTaskAttributes[k].schema === 'array' || gTaskAttributes[k].schema === 'stagil_asset_forge') {

            for (let i = 0; i < gTaskArray.length; i++) {
                let tempArray = gTaskArray[i][key].split('^^');
                if (tempArray.length === 1) gTempTaskArray.push (gTaskArray[i])
                else {
                    for (let m = 0; m < tempArray.length; m++) {
                        var newObject = JSON.parse(JSON.stringify(gTaskArray[i]));
                        newObject[key] = tempArray[m]
                        gTempTaskArray.push (newObject)
                    }
                }
            }

        } else {
            gTempTaskArray = JSON.parse(JSON.stringify(gTaskArray));
        }
        // Defensive sorting: some tasks may not have this attribute populated (undefined/null)
        // (e.g., legacy stored logs or blank attribute values). Treat missing values as empty strings.
        gTempTaskArray.sort((a, b) => {
            const af = (a && typeof a.filtered === 'number') ? a.filtered : 0;
            const bf = (b && typeof b.filtered === 'number') ? b.filtered : 0;
            if (af !== bf) return af - bf;
            const av = (a && a[key] != null) ? String(a[key]) : '';
            const bv = (b && b[key] != null) ? String(b[key]) : '';
            const c1 = av.localeCompare(bv);
            if (c1 !== 0) return c1;
            const ak = (a && a.k != null) ? String(a.k) : '';
            const bk = (b && b.k != null) ? String(b.k) : '';
            return ak.localeCompare(bk);
        });
        let previousAttribute = '^^^'
        let task = null;
        let tasks = 0;
        let events = 0;
        let duration = 0;
        let actualCost = 0;
        let forecastCost = 0;
        let sdArray = [];
        let i = 0;
        let attributeRecs = 0
        let attributeSaved = false
        for (i = 0; i < gTempTaskArray.length; i++) {
            if (gTempTaskArray[i].filtered == 0 && gVariantArray[gTempTaskArray[i].vid].sliced === true) {
                if (gTempTaskArray[i][key] != previousAttribute && attributeRecs > 0) {
                    // attribute changed
                    let vtp = {};
                    vtp['type'] = gEntityUpper;
                    vtp['field'] = gTaskAttributes[k].field;
                    vtp['value'] = previousAttribute;
                    vtp['selected'] = false;
                    vtp['tasks'] = tasks;
                    vtp['events'] = events;
                    vtp['actual_cost'] = actualCost;
                    vtp['forecast_cost'] = forecastCost;
                    vtp['avg_duration'] = duration / tasks;
                    vtp['std_deviation'] = getStandardDeviation(sdArray);
                    gAttributeArray.push(vtp);
                    sdArray = [];
                    tasks = 1;
                    events = 0;
                    actualCost = gTempTaskArray[i].actual_cost;
                    forecastCost = gTempTaskArray[i].forecast_cost;
                    duration = parseInt(gTempTaskArray[i].d);
                    sdArray.push(parseInt(gTempTaskArray[i].d));
                    for (let j = gTempTaskArray[i].si + 1; j < gTempTaskArray[i].fi + 1; j++) {
                        events++;
                    }
                    attributeSaved = true
                } else {
                    actualCost = actualCost + gTempTaskArray[i].actual_cost;
                    forecastCost = forecastCost + gTempTaskArray[i].forecast_cost;
                    duration = duration + parseInt(gTempTaskArray[i].d);
                    sdArray.push(parseInt(gTempTaskArray[i].d));
                    tasks++;
                    for (let j = gTempTaskArray[i].si + 1; j < gTempTaskArray[i].fi + 1; j++) {
                        events++;
                    }
                    attributeSaved = false
                }
                attributeRecs ++
                previousAttribute = gTempTaskArray[i][key];
                task = gTempTaskArray[i].k;
            }
        }
        let vtp = {};
        vtp['type'] = gEntityUpper;
        vtp['field'] = gTaskAttributes[k].field;
        vtp['value'] = previousAttribute;
        vtp['selected'] = false;
        vtp['tasks'] = tasks;
        vtp['events'] = events;
        vtp['actual_cost'] = actualCost;
        vtp['forecast_cost'] = forecastCost;
        vtp['avg_duration'] = duration / tasks;
        vtp['std_deviation'] = getStandardDeviation(sdArray);
        gAttributeArray.push(vtp);
    }
    if (gEventAttributes.length > 0 || gTaskAttributes.length > 0) {
        // task attributes
        gAttributeArray.sort((a, b) => a.type.localeCompare(b.type) || a.field.localeCompare(b.field));
        let type = '';
        let field = '';
        let tasks = 0;
        let events = 0;
        for (let i = 0; i < gAttributeArray.length; i++) {
            if (type != gAttributeArray[i].type || field != gAttributeArray[i].field) {
                tasks = 0;
                events = 0;
                for (k = 0; k < gAttributeArray.length; k++) {
                    if (gAttributeArray[k].type == gAttributeArray[i].type && gAttributeArray[k].field == gAttributeArray[i].field) {
                        tasks = tasks + gAttributeArray[k].tasks;
                        events = events + gAttributeArray[k].events;
                    }
                }
            }
            type = gAttributeArray[i].type;
            field = gAttributeArray[i].field;
            gAttributeArray[i].perc_total_tasks = parseInt(gAttributeArray[i].tasks) / tasks;
            gAttributeArray[i].perc_total_events = parseInt(gAttributeArray[i].events) / events;
            let perc_cost_savings = 0;
            if (gAttributeArray[i].actual_cost > 0) {
                perc_cost_savings = (gAttributeArray[i].actual_cost - gAttributeArray[i].forecast_cost) / gAttributeArray[i].actual_cost;
            }
            gAttributeArray[i].perc_cost_savings = perc_cost_savings;
            let avg_task_cost = 0;
            if (gAttributeArray[i].actual_cost > 0) {
                avg_task_cost = gAttributeArray[i].actual_cost / gAttributeArray[i].tasks;
            }
            gAttributeArray[i].avg_task_cost = avg_task_cost;
        }
    }
}

export function resetMinMaxTimes() {
    if (gTaskArray.length > 0) {
        gTaskArray.sort((a, b) => a.t1.localeCompare(b.t1));

        gFromTime = gTaskArray[0].t1;
        gToTime = gTaskArray[gTaskArray.length - 1].t1;
    }
}

function updateEventLogArray() {
    gEventLogArray.sort((a, b) => a.v - b.v || a.k.localeCompare(b.k) || a.s - b.s);
    let tVariantSteps = [];
    let task = '';
    let loop = false;
    let duplicate = false;

    for (let i = 0; i < gEventLogArray.length; i++) {
        gEventLogArray[i].filtered = 0;
        if (task != gEventLogArray[i].k && i > 0) {
            tVariantSteps = [];
        }
        task = gEventLogArray[i].k;

        duplicate = false;
        for (let j = 0; j < tVariantSteps.length; j++) {
            if (gEventLogArray[i].f == tVariantSteps[j].f && gEventLogArray[i].t == tVariantSteps[j].t) {
                duplicate = true;
                break;
            }
        }
        loop = false;
        if (duplicate == false) {
            for (let j = 0; j < tVariantSteps.length; j++) {
                if (gEventLogArray[i].t == tVariantSteps[j].t) {
                    let stepExists = false;
                    if (stepExists == false) {
                        loop = true;
                        break;
                    }
                }
            }
        }

        gEventLogArray[i].loop = loop;
        gEventLogArray[i].duplicate = duplicate;

        let vtp = {};
        vtp['f'] = gEventLogArray[i].f;
        vtp['t'] = gEventLogArray[i].t;
        tVariantSteps.push(vtp);
    }
}

export function metrics() {
    gMetricArray = []
    let vtp = {};
    vtp['m'] = 'Duration';
    vtp['t'] = 'duration';   // duration, amount
    vtp['du'] = null;
    vtp['id'] = 1;
    gMetricArray.push(vtp);

    let tArray = [];
    if (gMetricArray) {
        for (let i = 0; i < gMetricArray.length; i++) {
            let vtp = {};
            vtp['value'] = gMetricArray[i].m;
            vtp['label'] = gMetricArray[i].m;
            vtp['type'] = gMetricArray[i].t;
            tArray.push(vtp);
        }
    }
    return tArray;
}

export function setDiscoveryRuleDeleteRowData(type, row, id) {
    for (let i = 0; i < gDiscoveryRuleSelectedRow.length; i++) {
        if (gDiscoveryRuleSelectedRow[i].type == type) {
            gDiscoveryRuleSelectedRow.splice(i, 1);
            break;
        }
    }
    let vtp = {};
    vtp['type'] = type;
    vtp['row'] = row;
    vtp['id'] = id;
    gDiscoveryRuleSelectedRow.push(vtp);
}

export function setFilterDeleteRowData(row) {
    gFilterSelectedRow = row;
}

export async function deleteFilter() {
    gSaveModel = true
    for (let i = 0; i < gFilterConditions.length; i++) {
        if (gFilterConditions[i].id === gFilterSelectedRow) {
            gFilterConditions.splice(i, 1);
        }
    }
    let tempConditions = [...gFilterConditions]    
    await resetFilters(true,'deleteFilter')
    await processFilters(tempConditions,'deleteFilter',false);    
 
}

export function setDeleteTransformationRow(field) {
    gSelectedTransformationMapping = field;
}

export function deleteTransformationRow() {
    if (
        gSelectedTransformationMapping === 'Activity' ||
        gSelectedTransformationMapping === gEntityUpper + ' ID' ||
        gSelectedTransformationMapping === 'Timestamp'
    ) {
        for (let i = 0; i < gTransformation.length; i++) {
            if (gTransformation[i].mapping == gSelectedTransformationMapping) {
                gTransformation[i].field = '';
                gTransformation[i].status = false;
                if (gSelectedTransformationMapping === gEntityUpper + ' ID') {
                    gTransformation[i].issue = 'Please select the Task ID column';
                }
                if (gSelectedTransformationMapping === 'Activity') {
                    gTransformation[i].issue = 'Please select the Activity column';
                }
                if (gSelectedTransformationMapping === 'Timestamp') {
                    gTransformation[i].issue = 'Please select the Timestamp column';
                }
            }
        }
    } else {
        for (let i = 0; i < gTransformation.length; i++) {
            if (gTransformation[i].mapping == gSelectedTransformationMapping) {
                gTransformation.splice(i, 1);
                break;
            }
        }
    }
}

export function resetTransformation() {
    gTransformation = [];
}

export function deleteDiscoveryRule(discovery_rule_id) {
    for (let i = 0; i < gDiscoveryRules.length; i++) {
        if (parseInt(gDiscoveryRules[i].discovery_rule_id) == parseInt(discovery_rule_id)) {
            gDiscoveryRules.splice(i, 1);
        }
    }
    for (let k = 0; k < gDiscoveryRules.length; k++) {
        if (gDiscoveryRules[k].parent_discovery_rule_id == discovery_rule_id) {
            gDiscoveryRules.splice(k, 1);
            k--
        }
    }
    let key = 'f-' + discovery_rule_id    
    for (let i = 0; i < gEventLogArray.length; i++) {
        if (gEventLogArray[i][key] === 1) {
            gEventLogArray[i][key] = 0;
            for (let j = 0; j < gEventLogArray[i].discovery_rules.length; j++) {
                if (gEventLogArray[i].discovery_rules[j].discovery_rule_id === key) {
                    gEventLogArray[i].discovery_rules.splice(j, 1);
                    break;
                }
            }
        }
    }
}

export function histogramModal() {
    openHistogramModal({
        props: {
            source: '',
            title: '',
        },
    });
}

export function editDiscoveryRuleModal(props) {   
    let filterSummary = [];
    for (let i = 0; i < props.filters.length; i++) {
        filterSummary.push({
            type: props.filters[i].label,
            description: props.filters[i].description,
        });
    }
    openDiscoveryRuleModal({ 
        data: {
            discovery_rule_id: props.discovery_rule_id,
            discovery_rule: props.discovery_rule,
            category: props.category,
            type: props.type,
            discovery_rule_type: props.discovery_rule_type,
            tasks: props.tasks,
            events: props.events,
            automation_opportunity: props.automation_opportunity,
            filters: props.filters,
            filterSummary: filterSummary,
            calculate_cost_impact: props.calculate_cost_impact,
            save_activities: props.save_activities,
            save_steps: props.save_steps,
            save_variants: props.save_variants,
            filter_activities: props.filter_activities,
            filter_variants: props.filter_variants,
            filter_steps: props.filter_steps,
            mode: 'edit'
        },
    });
}


export function taskDetailModal() {
    openTaskDetailModal({
        props: {
            param: '',
        },
    });
}

export function variantLifecycleModal() {
    openVariantLifecycleModal({
        props: {
            param: '',
        },
    });
}

export function taskLifecycleModal() {
    openLifecycleModalMulti({
        props: {
            param: '',
        },
    });
}


export function eventDetailModal() {
    openEventDetailModal({
        props: {
            param: '',
        },
    });
}

export function processAnalytics(variant, activity, from, to, discovery_rule_id, discovery_rule_type, object_type, object_name, series_name, source) {
    openProcessAnalyticsModal({
        props: {
            variant: variant,
            activity: activity,
            from: from,
            to: to,
            discovery_rule_id: discovery_rule_id,
            discovery_rule_type: discovery_rule_type,
            object_type: object_type,
            object_name: object_name,
            series_name:  series_name,
            source: source
        },
    });
}

export function updateSlicedVariables() {
    let startNode = 0;
    let endNode = 0;
    for (let j = 0; j < gActivityArray.length; j++) {
        if (gActivityArray[j].start_node == true) {
            startNode = gActivityArray[j].a;
        }
        if (gActivityArray[j].end_node == true) {
            endNode = gActivityArray[j].a;
        }
    }

    gVariantsSliced = 0;
    gVariantEventsSliced = 0;
    gVariantTasksSliced = 0;

    gVariantArray.sort((a, b) => a.filtered - b.filtered);
    for (let i = 0; i < gVariantArray.length; i++) {
        if (gVariantArray[i].filtered == true) {
            break;
        }
        if (gVariantArray[i].sliced == true) {
            gVariantsSliced++;
            gActualCost = gActualCost + gVariantArray[i].actual_cost;
            gForecastCost = gForecastCost + gVariantArray[i].forecast_cost;
            gVariantEventsSliced = gVariantEventsSliced + gVariantArray[i].e;
            gVariantTasksSliced = gVariantTasksSliced + gVariantArray[i].t;
        }
    }

    let selectedActivities = [];
    for (let j = 0; j < gLinkArray.length; j++) {
        if (gLinkArray[j].duplicate === false) {
            let sliced = false;
            for (let i = 0; i < gVariantArray.length; i++) {
                if (gLinkArray[j].variant == gVariantArray[i].v && gVariantArray[i].sliced == true && gVariantArray[i].filtered == 0) {
                    sliced = true;
                    break;
                }
            }
            if (sliced == true) {
                let exists = false;
                for (let k = 0; k < selectedActivities.length; k++) {
                    if (gLinkArray[j].from == selectedActivities[k].a) {
                        exists = true;
                        break;
                    }
                }
                if (exists == false && gLinkArray[j].from != startNode) {
                    const vtp = [];
                    vtp['a'] = gLinkArray[j].from;
                    selectedActivities.push(vtp);
                }
                exists = false;
                for (let k = 0; k < selectedActivities.length; k++) {
                    if (gLinkArray[j].to == selectedActivities[k].a) {
                        exists = true;
                        break;
                    }
                }
                if (exists == false && gLinkArray[j].to != endNode) {
                    const vtp = [];
                    vtp['a'] = gLinkArray[j].to;
                    selectedActivities.push(vtp);
                }
            }
        }
    }

    gVariantActivitiesSliced = selectedActivities.length - 2; // don't count start and end

    gLinkArray.sort((a, b) => a.variant - b.variant || a.from - b.from || a.to - b.to);
    let selectedSteps = [];
    for (let i = 0; i < gLinkArray.length; i++) {
        if (gLinkArray[i].duplicate === false) {
            for (let j = 0; j < gVariantArray.length; j++) {
                if (gVariantArray[j].v == gLinkArray[i].variant && gVariantArray[j].sliced == true) {
                    let exists = false;
                    for (let k = 0; k < selectedSteps.length; k++) {
                        if (selectedSteps[k].f == gLinkArray[i].from && selectedSteps[k].t == gLinkArray[i].to) {
                            exists = true;
                            break;
                        }
                    }
                    if (exists == false && gLinkArray[i].end_node == false) {
                        const vtp = [];
                        vtp['f'] = gLinkArray[i].from;
                        vtp['t'] = gLinkArray[i].to;
                        selectedSteps.push(vtp);
                    }
                }
            }
        }
    }
    gVariantStepsSliced = selectedSteps.length;
    gVariantArray.sort((a, b) => a.s - b.s);
    gAnimateVariant = 0;
    gLifecycleVariant = 0;
}

export const selectStepFilterGridData = (selection) => { 
    if (selection == '') {
        if (gStepFilterSelection.length > 0) {
            selection = gStepFilterSelection;
        } else {
            return;
        }
    } else {
        if (selection.length == 0) {
            return;
        }
    }
    gStepFilterSelection = selection;

    gFilterSelectedSteps = [];
    for (let i = 0; i < selection.length; i++) {
        const vtp = {};
        vtp['from_activity'] = selection[i].from_activity;
        vtp['to_activity'] = selection[i].to_activity;
        gFilterSelectedSteps.push(vtp);
    }
};

export const selectVariantFilterGridData = (selection) => { 
    if (selection == '') {
        if (gVariantFilterSelection.length > 0) {
            selection = gVariantFilterSelection;
        } else {
            return;
        }
    } else {
        if (selection.length == 0) {
            return;
        }
    }
    gVariantFilterSelection = selection;
    gFilterSelectedVariants = []; 
    for (let i = 0; i < selection.length; i++) {
        const vtp = {};
        vtp['id'] = selection[i].id;
        vtp['variant_id'] = selection[i].variant_id;
        vtp['variant'] = selection[i].variant;
        gFilterSelectedVariants.push(vtp);
    }
};

export const setTaskDetailSelectedData = (selection) => {
    gDetailTaskVariantsSelected = [];
    gDetailTaskTasksSelected = [];
    let vtp = {};
    for (let i = 0; i < selection.length; i++) {
        var exists = false;
        for (let j = 0; j < gDetailTaskVariantsSelected.length; j++) {
            if (gDetailTaskVariantsSelected[j].vid === selection[i].vid) {
                exists = true;
                break;
            }
        }

        if (exists === false) {
            vtp = {};
            vtp['vid'] = selection[i].vid;
            gDetailTaskVariantsSelected.push(vtp);
        }

        let id
        for (let j = 0; j < gTaskArray.length; j++) {
            if (gTaskArray[j].k === selection[i].k) {
                id = gTaskArray[j].id
                break
            }

        }
        vtp = {};
        vtp['id'] = id;
        vtp['k'] = selection[i].k;
        gDetailTaskTasksSelected.push(vtp);
    }
};

export const selectActivityFilterGridData = (selection) => {
    if (selection == '') {
        if (gActivityFilterSelection.length > 0) {
            selection = gActivityFilterSelection;
        } else {
            return;
        }
    } else {
        if (selection.length == 0) {
            return;
        }
    }

    gActivityFilterSelection = selection;
    gFilterSelectedActivities = [];
    for (let i = 0; i < selection.length; i++) {
        const vtp = {};
        vtp['activity'] = selection[i].activity;
        gFilterSelectedActivities.push(vtp);
    }

};

 export const selectActivityTypeFilterGridData = (selection) => {
    if (selection == '') {
        if (gActivityTypeFilterSelection.length > 0) {
            selection = gActivityTypeFilterSelection;
        } else {
            return;
        }
    } else {
        if (selection.length == 0) {
            return;
        }
    }

    gActivityTypeFilterSelection = selection;
};

export const selectPathFilterGridData = (selection, type) => {
    let activity;
    if (type == 'from') {
        gPathFrom.length = 0;
        for (let i = 0; i < selection.length; i++) {
            let vtp = {};
            vtp['activity'] = selection[i].activity;
            gPathFrom.push(vtp);
        }
    }
    if (type == 'to') {
        gPathTo.length = 0;
        for (let i = 0; i < selection.length; i++) {
            let vtp = {};
            vtp['activity'] = selection[i].activity;
            gPathTo.push(vtp);
        }
    }
};

// import csv functions - start

export function setDataType(field, type) {
    let fieldExists = false;
    let index = null;

    for (let i = 0; i < gTransformation.length; i++) {
        if (gTransformation[i].field === field) {
            fieldExists = true;
            index = i;
        }
    }
    let status = true;
    let issue = '';
    if (index != null) {
        if (gTransformation[index].mapping === gEntityUpper + ' ID' && type != 'Text') {
            status = false;
            issue = gEntityUpper + ' ID must be mapped to data type text';
        }
        if (gTransformation[index].mapping === 'Activity' && type != 'Text') {
            status = false;
            issue = 'Activity must be mapped to data type text';
        }
        if (gTransformation[index].mapping === 'Timestamp' && type != 'Datetime') {
            status = false;
            issue = 'Timestamp must be mapped to data type datetime';
        }
        if (gTransformation[index].mapping === 'Resource' && type != 'Text') {
            status = false;
            issue = 'Resource must be mapped to data type text';
        }
        if (gTransformation[index].mapping === gEntityUpper + ' Create Time' && type != 'Datetime') {
            status = false;
            issue = gEntityUpper + ' Create Time must be mapped to data type datetime';
        }
        if (gTransformation[index].mapping === gEntityUpper + ' Closed Time' && type != 'Datetime') {
            status = false;
            issue = gEntityUpper + ' Close Time must be mapped to data type datetime';
        }

        if (gTransformation[index].dataType === '') {
            status = false;
            issue = 'Please choose a data mapping';
        }
        if (gTransformation[index].mapping === '') {
            status = false;
            issue = 'Please choose a column mapping';
        }
    }

    // number
    // datetime
    if (type === 'Number') {
        for (let i = 0; i < gUploadFileArray.length; i++) {
            if (isNaN(gUploadFileArray[i][field])) {
                status = false;
                issue = 'Field is not a number';
                break;
            }
        }
    }
    if (type === 'Datetime') {
        for (let i = 0; i < gUploadFileArray.length; i++) {
            if (isNaN(Date.parse(gUploadFileArray[i][field]))) {
                status = false;
                issue = 'Field is not a datetime';
                break;
            }
        }
    }

    if (fieldExists === true) {
        gTransformation[index].status = false;
        gTransformation[index].dataType = type;
        gTransformation[index].field = field;
        gTransformation[index].status = status;
        gTransformation[index].issue = issue;
    } else {
        let vtp = {};
        vtp['field'] = field;
        vtp['dataType'] = type;
        vtp['mapping'] = '';
        vtp['status'] = status;
        vtp['work_item'] = issue;
        gTransformation.push(vtp);
    }
}

export function setDataMapping(field, mapping) {
    let mappingExists = false;
    let fieldExists = false;
    let index = null;

    let allowMultipleMappings = true;
    if (
        mapping === gEntityUpper + ' ID' ||
        mapping === 'Activity' ||
        mapping === 'Activity Type' ||
        mapping === 'Work Type' ||
        mapping === 'Timestamp' ||
        mapping === 'Resource' ||
        mapping === gEntityUpper + ' Create Time' ||
        mapping === gEntityUpper + ' Close Time'
    ) {
        allowMultipleMappings = false;
    }
    for (let i = 0; i < gTransformation.length; i++) {
        if (gTransformation[i].field === field && fieldExists == false) {
            fieldExists = true;
            index = i;
        }
        if (gTransformation[i].mapping === mapping && allowMultipleMappings === false) {
            mappingExists = true;
        }
        if (gTransformation[i].mapping === mapping && gTransformation[i].status === false) {
            mappingExists = true;
            index = i;
        }
    }
    let status = true;
    let issue = '';
    if (index != null) {
        if (mapping === gEntityUpper + ' ID' && gTransformation[index].dataType != 'Text') {
            status = false;
            issue = gEntityUpper + ' ID must be mapped to data type text';
        }
        if (mapping === 'Activity' && gTransformation[index].dataType != 'Text') {
            status = false;
            issue = 'Activity must be mapped to data type text';
        }
        if (mapping === 'Timestamp' && gTransformation[index].dataType != 'Datetime') {
            status = false;
            issue = 'Timestamp must be mapped to data type datetime';
        }
        if (mapping === 'Resource' && gTransformation[index].dataType != 'Text') {
            status = false;
            issue = 'Resource must be mapped to data type text';
        }
        if (mapping === gEntityUpper + ' Create Time' && gTransformation[index].dataType != 'Datetime') {
            status = false;
            issue = gEntityUpper + ' Create Time must be mapped to data type datetime';
        }
        if (mapping === gEntityUpper + ' Closed Time' && gTransformation[index].dataType != 'Datetime') {
            status = false;
            issue = gEntityUpper + ' Close Time must be mapped to data type datetime';
        }
        if (gTransformation[index].dataType === '') {
            status = false;
            issue = 'Please choose a data mapping';
        }
        if (mapping === '') {
            status = false;
            issue = 'Please choose a column mapping';
        }
        if (gTransformation[index].dataType === 'Number') {
            for (let i = 0; i < gUploadFileArray.length; i++) {
                if (isNaN(gUploadFileArray[i][field])) {
                    status = false;
                    issue = 'Field is not a number';
                    break;
                }
            }
        }
        if (gTransformation[index].dataType === 'Datetime') {
            for (let i = 0; i < gUploadFileArray.length; i++) {
                if (isNaN(Date.parse(gUploadFileArray[i][field]))) {
                    status = false;
                    issue = 'Field is not a datetime';
                    break;
                }
            }
        }
    }
    if (mappingExists === false && fieldExists === false) {
        let vtp = {};
        vtp['field'] = field;
        vtp['status'] = false;
        vtp['dataType'] = 'Text'; // default to text
        if (mapping == 'Timestamp') {
            vtp['dataType'] = 'Datetime';
        }
        if (mapping == gEntityUpper + ' Create Time') {
            vtp['dataType'] = 'Datetime';
        }
        if (mapping == gEntityUpper + ' Close Time') {
            vtp['dataType'] = 'Datetime';
        }
        if (mapping == gEntityUpper + ' Close Time') {
            vtp['dataType'] = 'Datetime';
        }
        if (mapping == 'Metric - True/False') {
            vtp['dataType'] = 'Text';
        }
        if (mapping == 'Metric - Duration') {
            vtp['dataType'] = 'Number';
        }
        if (mapping == 'Metric - Amount') {
            vtp['dataType'] = 'Number';
        }
        vtp['mapping'] = mapping;
        vtp['status'] = status;
        vtp['work_item'] = issue;
        if (allowMultipleMappings === true ) vtp['attribute'] = true
        else vtp['attribute'] = false
        gTransformation.push(vtp);
    }
    if (mappingExists === false && fieldExists === true) {
        gTransformation[index].mapping = mapping;
        gTransformation[index].status = status;
        gTransformation[index].issue = issue;
    }
    if (mappingExists === true && fieldExists === false) {
        gTransformation[index].field = field;
        gTransformation[index].status = status;
        gTransformation[index].issue = issue;
    }
}

export function retrieveDataTransformation() {
    const rows = [];
    for (let i = 0; i < gTransformation.length; i++) {
        rows.push({
            field: gTransformation[i].field,
            mapping: gTransformation[i].mapping,
            datatype: gTransformation[i].dataType,
            status: gTransformation[i].status,
            issue: gTransformation[i].issue,
        });
    }
    return rows;
}


export function saveEventLogCSV() { 
    let csv = '';
    let csvLine = '';
    csvLine = '"ActivityType","Activity","Issue","Timestamp","Resource"'    

    for (let i = 0; i < gTaskAttributes.length - 1; i++) {
        csvLine = csvLine + ',"' + gTaskAttributes[i].field + '"'
    }
    csv = csv + csvLine + '\r\n';

    for (let i = 0; i < gImportEventLogArray.length - 1; i++) {
        csvLine = '"' + gImportEventLogArray[i].activity_type + '","' + 
                        gImportEventLogArray[i].activity + '","' + 
                        gImportEventLogArray[i].task + '","' + 
                        gImportEventLogArray[i].timestamp.replace('T',' ') + '","' + 
                        gImportEventLogArray[i].resource  + '"'

        for (let j = 0; j < gTaskAttributes.length - 1; j++) {
            csvLine = csvLine + ',"' + gImportEventLogArray[i][gTaskAttributes[j].id] + '"'
         }                
        csv = csv + csvLine + '\r\n';
    }
    let fileName = gModelFileName + 'event_log.csv';
    let fileToSave = new Blob([csv], {
        type: 'application/text',
        name: fileName,
    });
    saveAs(fileToSave, fileName);

}


export function taskCount() {
    if (gSaveFilteredOnly == false) {
        return gTasksAll;
    } else {
        return gTasksFiltered;
    }
}

export function eventCount() {
    if (gSaveFilteredOnly == false) {
        return gEventsAll;
    } else {
        return gEventsFiltered;
    }
}

export function validateDataTransformation() {
    let validTransformation = false;
    let validTask = false;
    let validActivity = false;
    let validTimestamp = false;
    let validOther = true;
    for (let i = 0; i < gTransformation.length; i++) {
        if (gTransformation[i].status == true && gTransformation[i].mapping == gEntityUpper + ' ID') {
            validTask = true;
        }
        if (gTransformation[i].status == true && gTransformation[i].mapping == 'Activity') {
            validActivity = true;
        }
        if (gTransformation[i].status == true && gTransformation[i].mapping == 'Timestamp') {
            validTimestamp = true;
        }
        if (
            gTransformation[i].status == false &&
            gTransformation[i].mapping != gEntityUpper + ' ID' &&
            gTransformation[i].mapping != 'Activity' &&
            gTransformation[i].mapping != 'Timestamp'
        ) {
            validOther = false;
        }
    }

    if (validTask == true && validActivity == true && validTimestamp == true && validOther == true) {
        validTransformation = true;
    }
    return validTransformation;
}

export function importTransformation(importedTransformation) {
    let tempArray;
    try {
        tempArray = JSON.parse(importedTransformation);
    } catch (e) {
        alertMessage({
            eventEmitter: gEventEmitter,
            message: 'Invalid discoveryRules file',
            severity: 'error',
            showAlert: true,
            timeOutActive: true,
            component: 'discovery_rules',
        });
        return;
    }
    gTransformation = tempArray;
}

export function retrieveModelComments() {
    return gModelComments;
}

export function retrieveIssueComments() {
    return gIssueComments;
}

export function retrieveIssueWorklogs() {
    return gIssueWorklogs;
}

export function updateComments(data) {  
    let vtp = [];
    vtp = {};
    vtp['activity'] = parseInt(data.activity);
    vtp['fromNode'] = parseInt(data.fromNode);
    vtp['toNode'] = parseInt(data.toNode);
    vtp['comment'] = data.comment;
    vtp['createdBy'] = data.createdBy;
    vtp['createTime'] = currentDateTime().replace('T',' ')
    vtp['component'] = data.component;    
    vtp['variantType'] = data.variantType
    vtp['filterConditions'] = gFilterConditions
    vtp['type'] = data.variantType
    vtp['commentID'] = gModelComments.length + 1;
    gModelComments.push(vtp);
    if (gEventEmitter) {
        updateCommentsEvent({ eventEmitter: gEventEmitter });
    }
}

export function updateAnalytic(data) {  
    gAnalytic = data.analytic;
    updateAnalyticEvent({ eventEmitter: gEventEmitter });
}

export function updateStepAnalytics(data) {  
    gStepAnalytics = data
}

export function retrieveStepAnalytics() {  
    return gStepAnalytics
}

export function updateActivityAnalytics(data) {  
    gActivityAnalytics = data
}

export function retrieveActivityAnalytics() {  
    return gActivityAnalytics
}

export function updateIssueAnalytics(data) {  
    gIssueAnalytics = data
}

export function retrieveIssueAnalytics() {  
    return gIssueAnalytics
}

export function updateEventAnalytics(data) {  
    gEventAnalytics = data
}

export function retrieveEventAnalytics() {  
    return gEventAnalytics
}

export function retrieveAnalytic() {  
    return gAnalytic
}

export function setCommentDeleteRow(row) {
    gCommentSelectedRow = row;
}

export function deleteComment(commentID) {

    for (let i = 0; i < gModelComments.length; i++) {
        if (gModelComments[i].commentID === commentID) {
            gModelComments.splice(i, 1);
            break;
        }
    }

    if (gEventEmitter) {
        updateCommentsEvent({ eventEmitter: gEventEmitter });
    }
}
export function exportEventLog() {
    let tempArray = [];
    let vtp = {};
    vtp['Event ID'] = 'Event ID';
    vtp[gEntityUpper + ' ID'] = gEntityUpper + ' ID';
    vtp['From Activity'] = 'From Activity';
    vtp['To Activity'] = 'To Activity';
    vtp['Variant ID'] = 'Variant ID';
    vtp['Variant'] = 'Variant';
    vtp['Resource'] = 'Resource';
    vtp['Timestamp'] = 'Timestamp';
    vtp['Duration'] = 'Duration';
    vtp[gEntityUpper] = gEntityUpper;
    vtp['Loop'] = 'Loop';
    vtp['Filtered'] = 'Filtered';
    for (let j = 0; j < gTaskAttributes.length; j++) {
        vtp[gTaskAttributes[j].field] = gTaskAttributes[j].field;
    }
    for (let j = 0; j < gEventAttributes.length; j++) {
        if (gEventAttributes[j].field != 'Resource') {
            vtp[gEventAttributes[j].field] = gEventAttributes[j].field;
        }
    }

    tempArray.push(vtp);

    for (let i = 0; i < gEventLogArray.length; i++) {
        vtp = {};
        vtp['Event ID'] = gEventLogArray[i].elid;
        vtp[gEntityUpper + ' ID'] = gEventLogArray[i].tid;
        vtp['From Activity'] = '';
        vtp['To Activity'] = '';
        for (let j = 0; j < gActivityArray.length; j++) {
            if (gActivityArray[j].id === gEventLogArray[i].f && vtp['From Activity'] === '') {
                vtp['From Activity'] = gActivityArray[j].activity;
            }
            if (gActivityArray[j].id === gEventLogArray[i].t && vtp['To Activity'] === '') {
                vtp['To Activity'] = gActivityArray[j].activity;
            }
            if (vtp['From Activity'] != '' && vtp['To Activity'] != '') {
                break;
            }
        }
        for (let j = 0; j < gVariantArray.length; j++) {
            if (gVariantArray[j].v == gEventLogArray[i].v) {
                vtp['Variant ID'] = gVariantArray[j].id;
                vtp['Variant'] = gVariantArray[j].n;
                break;
            }
        }
        vtp['Resource'] = gEventLogArray[i].u;
        vtp['Timestamp'] = gEventLogArray[i].ts;
        vtp['Duration'] = gEventLogArray[i].d;
        vtp[gEntityUpper] = gEventLogArray[i].k;
        if (gEventLogArray[i].loop === true) {
            vtp['Loop'] = 1;
        } else {
            vtp['Loop'] = 0;
        }
        vtp['Filtered'] = gEventLogArray[i].filtered;
        for (let j = 0; j < gTaskAttributes.length; j++) {
            let key = 'ta' + j;
            vtp[gTaskAttributes[j].field] = gEventLogArray[i][key];
        }
        for (let j = 0; j < gEventAttributes.length; j++) {
            if (gEventAttributes[j].field != 'Resource') {
                let key = 'ea' + j;
                vtp[gEventAttributes[j].field] = gEventLogArray[i][key];
            }
        }

        if (vtp['To Activity'] != 'End') {
            tempArray.push(vtp);
        }
    }

    let fileName = gModelFileName + '_eventLog.csv';
    let fileToSave = new Blob([convertToCSV(tempArray)], {
        type: 'application/csv',
        name: fileName,
    });
    //saveAs(fileToSave,fileName)
}

export function retrieveFiltersArray() {
    return gFilterConditions;
}

export function retrieveCommentsArray() {
    return gModelComments;
}
export function filteredTasksCount() {
    return gTasksFiltered;
}
export function filteredEventsCount() {
    return gEventsFiltered;
}
export function slicedTasksCount() {
    return gVariantTasksSliced;
}
export function slicedEventsCount() {
    return gVariantEventsSliced;
}

export function retrieveDiscoveryRules() {
    return gDiscoveryRules;
}

export function retrieveCosts() {
    return gCosts;
}

export function retrieveEventLogArray() {
    return gImportEventLogArray;
}

export function retrieveVisualizerSettings() {
    let tempArray = [];
    let vtp = {};

    vtp['ProcessFlowDirection'] = gProcessFlowDirection;

    vtp['ShowLinkTasks'] = gShowLinkTasks;
    vtp['ShowLinkAvgDuration'] = gShowLinkAvgDuration;
    vtp['ShowLinkPercTotal'] = gShowLinkPercTotal;

    vtp['ShowTooltipTasks'] = gShowTooltipTasks;
    vtp['ShowTooltipAvgDuration'] = gShowTooltipAvgDuration;
    vtp['ShowTooltipMedDuration'] = gShowTooltipMedDuration;
    vtp['ShowTooltipMinDuration'] = gShowTooltipMinDuration;
    vtp['ShowTooltipMaxDuration'] = gShowTooltipMaxDuration;
    vtp['ShowTooltipAvgCost'] = gShowTooltipAvgCost;
    vtp['ShowTooltipPercTotal'] = gShowTooltipPercTotal;
    vtp['ShowTooltipDeviation'] = gShowTooltipDeviation;
    vtp['ShowTooltipCommentsCustomer'] = gShowTooltipCommentsCustomer;
    vtp['ShowTooltipAvgCommentsCustomer'] = gShowTooltipAvgCommentsCustomer;
    vtp['ShowTooltipCommentsInternal'] = gShowTooltipCommentsInternal;
    vtp['ShowTooltipAvgCommentsInternal'] = gShowTooltipAvgCommentsInternal;
    vtp['ShowTooltipWorklogs'] = gShowTooltipWorklogs;
    vtp['ShowTooltipAvgWorklogs'] = gShowTooltipAvgWorklogs;
    vtp['ShowTooltipPercCommentsInternal'] = gShowTooltipPercCommentsInternal
    vtp['ShowTooltipPercCommentsCustomer'] = gShowTooltipPercCommentsCustomer
    vtp['ShowTooltipPercWorklogs'] = gShowTooltipPercWorklogs
    vtp['ShowTooltipTotalTimespent'] = gShowTooltipTotalTimespent
    vtp['ShowTooltipAvgTimespent'] = gShowTooltipAvgTimespent


    vtp['ShowStartLabel'] = gShowStartLabel;
    vtp['ShowEndLabel'] = gShowEndLabel;

    vtp['ShowStartNode'] = gShowStartNode;
    vtp['ShowEndNode'] = gShowEndNode;

    vtp['StepLabelFontSize'] = gStepLabelFontSize;

    vtp['ShowNodeTasks'] = gShowNodeTasks;
    vtp['ShowNodePercTotal'] = gShowNodePercTotal;

    vtp['NodeLabelFontSize'] = gNodeLabelFontSize;

    vtp['ShowDurationDays'] = gShowDurationDays;
    vtp['ShowDurationHours'] = gShowDurationHours;
    vtp['ShowDurationMinutes'] = gShowDurationMinutes;
    vtp['ShowDurationSeconds'] = gShowDurationSeconds;

    vtp['StepWidthTasks'] = gStepWidthTasks;
    vtp['StepWidthDuration'] = gStepWidthDuration;
    vtp['StepWidthStdDeviation'] = gStepWidthStdDeviation;

    vtp['ColorStartNode'] = gColorStartNode;
    vtp['ColorEndNode'] = gColorEndNode;
    vtp['ColorLink'] = gColorLink;
    vtp['ColorLinkSelect'] = gColorLinkSelect;
    vtp['AnimateColor'] = gAnimateColor;
    vtp['LoopColor'] = gLoopColor;
    vtp['VisualizerBackgroundColor'] = gVisualizerBackgroundColor;

    vtp['SpacingColumn'] = gSpacingColumn;
    vtp['SpacingLayer'] = gSpacingLayer;

    vtp['ZoomToFit'] = gZoomToFit;
    tempArray.push(vtp);
    return tempArray;
}

export function metricsExist() {
    let metricsExists = false;
    if (gMetricArray.length > 0) {
        metricsExists = true;
    }
    return metricsExist;
}

export function resetVisualizerSettings() {
    gProcessFlowDirection = 90;

    gShowLinkTasks = true;
    gShowLinkAvgDuration = true;
    gShowLinkPercTotal = true;

    gShowTooltipTasks = true;
    gShowTooltipPercTotal = true;
    gShowTooltipAvgDuration = true;
    gShowTooltipDeviation = true;
    gShowTooltipMinDuration = true;
    gShowTooltipMaxDuration = true;
    gShowTooltipMedDuration = false;
    gShowTooltipCommentsCustomer = false;
    gShowTooltipAvgCommentsCustomer = false;
    gShowTooltipCommentsInternal = false;
    gShowTooltipAvgCommentsInternal = false;
    gShowTooltipWorklogs = false;
    gShowTooltipAvgWorklogs = false;
    gShowTooltipAvgCost = false;
    gShowTooltipPercCommentsInternal = false;
    gShowTooltipPercCommentsCustomer = false;
    gShowTooltipPercWorklogs = false;
    gShowTooltipTotalTimespent = false;
    gShowTooltipAvgTimespent = false;

    gZoomToFit = false;

    gShowStartLabel = true;
    gShowEndLabel = true;
    gShowStartNode = true;
    gShowEndNode = true;

    gStepLabelFontSize = '6pt';
    gShowNodeTasks = true;
    gShowNodePercTotal = false;

    gNodeLabelFontSize = '7pt';

    gShowDurationDays = true;
    gShowDurationHours = true;
    gShowDurationMinutes = true;
    gShowDurationSeconds = false;

    gStepWidthTasks = false;
    gStepWidthDuration = true;
    gStepWidthStdDeviation = false;

    gHighlightLoops = false;


    gStepColourVolume = false;
    gStepColourCost = false;
    gStepColourDuration = true;
    gStepColourStdDeviation = false;

    gAnalyticsTaskAttribute = '';
    gAnalyticsTaskHistoryMetric = 1;
    gAnalyticsTaskAttributeMetric = 1;
    gAnalyticsEventAttribute = '';

    gColorLink = '#FDC819';
    gColorLinkSelect = '#727171';
    gAnimateColor = '#4A90E2'
    gLoopColor = '#0C78F6';
    gVisualizerBackgroundColor = '#FFFFFF';
    gColorStartNode = '#A09E9E';
    gColorEndNode = '#A09E9E';

    gSpacingColumn = 40;
    gSpacingLayer = 30;
}

function expandDecompositionTreeNode(node) {
    let diagram = node.diagram;
    diagram.startTransaction('CollapseExpandTree');
    let data = node.data;
    diagram.model.setDataProperty(data, 'everExpanded', true);

    if (node.isTreeExpanded) {
        diagram.commandHandler.collapseTree(node);
    } else {
        createDecompositionTreeSubTree(data);
        diagram.commandHandler.expandTree(node);
    }
    diagram.commitTransaction('CollapseExpandTree');

    let it = diagram.nodes;
    while (it.next()) {
        let node = it.value;
        node.findObject('TREEBUTTON').visible = true;
    }
}

function createDecompositionTreeSubTree(parentdata) { 

    //if (gTaskAttributes.length = 0) return
    let attribute = gDecompositionTreeAttribute;
    if (attribute == '') {
        attribute = 'step';
        gDecompositionTreeAttribute = 'step';
    } else {
        for (let i = 0; i < gTaskAttributes.length; i++) {
            if (gTaskAttributes[i].field === attribute) {
                attribute = gTaskAttributes[i].id;
            }
        }
    }
    let model = gDiagramDecompositionTree.model;
    let parent = gDiagramDecompositionTree.findNodeForData(parentdata);

    let attributeTree = [];
    let grandparent = parent.findTreeParentNode();
    while (grandparent) {
        let vtp = [];
        vtp['attribute'] = grandparent.data.attribute;
        vtp['value'] = grandparent.data.label;
        vtp['field'] = grandparent.data.field;
        vtp['rootDistance'] = grandparent.data.rootdistance;
        attributeTree.push(vtp);
        grandparent = grandparent.findTreeParentNode();
    }

    let vtp = [];
    vtp['attribute'] = parent.data.attribute;
    vtp['value'] = parent.data.label;
    vtp['field'] = parent.data.field;
    vtp['rootDistance'] = parent.data.rootdistance;
    attributeTree.push(vtp);
    let rows = analyticsTaskAttributesDecompositionTree(attributeTree, attribute);
    if (gDecompositionTreeValueType == 'high') {
        rows.sort((a, b) => b.value - a.value);
    } else {
        rows.sort((a, b) => a.value - b.value);
    }

    let numChildren = rows.length;

    if (rows.length > 10) {
        numChildren = 10;
    }
    // parent is the node that has been clicked, we need to delete any existing children
    // need recursive iteration
    let p = parent.findTreeChildrenNodes();
    while (p.next()) {
        let child1 = p.value;
        let c1 = child1.findTreeChildrenNodes();
        while (c1.next()) {
            let child2 = c1.value;
            let c2 = child2.findTreeChildrenNodes();
            while (c2.next()) {
                let child3 = c2.value;
                let c3 = child3.findTreeChildrenNodes();
                while (c3.next()) {
                    let child4 = c3.value;
                    let c4 = child4.findTreeChildrenNodes();
                    while (c4.next()) {
                        let child5 = c4.value;
                        gDiagramDecompositionTree.remove(child5);
                    }
                    gDiagramDecompositionTree.remove(child4);
                }
                gDiagramDecompositionTree.remove(child3);
            }
            gDiagramDecompositionTree.remove(child2);
        }
        gDiagramDecompositionTree.remove(child1);
    }

    let degrees = 1;
    grandparent = parent.findTreeParentNode();
    while (grandparent) {
        degrees++;
        grandparent = grandparent.findTreeParentNode();
    }
    for (let i = 0; i < numChildren; i++) {
        let width = 1;
        if (rows[i].percMax > 0.01) {
            width = parseInt(rows[i].percMax * 185);
        }

        let toolTip =
            'Attribute: ' + gDecompositionTreeAttribute + '\r\n' + 'Value: ' + rows[i].attribute + '\r\n' + 'Metric: ' + rows[i].metric + '\r\n';
        toolTip =
            toolTip +
            gEntityUpper +
            's:' +
            rows[i].tasks +
            '\r\n' +
            ' % ' +
            gEntityUpper +
            's: ' +
            (rows[i].percTotal * 100).toFixed(1) +
            '%' +
            '\r\n';
        toolTip = toolTip + '% Maximum: ' + formatPercentage(rows[i].percMax, 1);

        let tasks_label = '';
        if (gDecompositionTreeMetric = 1) {
            tasks_label = (rows[i].percTotal * 100).toFixed(1) + '% of total'
        }

        if (gDecompositionTreeMetric != 1) {
            tasks_label = gEntityUpper + 's:' + rows[i].tasks;
        }

        let vtp = [];
        let filter = [];
        vtp['attribute'] = gDecompositionTreeAttribute;
        vtp['field'] = gDecompositionTreeAttribute;
        vtp['value'] = rows[i].attribute;
        vtp['rootDistance'] = -1;
        filter.push(vtp);

        let displayValue = rows[i].metric;
        if (gDecompositionTreeMetric == 5 || gDecompositionTreeMetric == 6 || gDecompositionTreeMetric == 7) {
            displayValue = formatCostDecimal(rows[i].metric);
        }
        let childdata = {
            key: rows[i].attribute + '\r\n' + rows[i].metric,
            label: rows[i].attribute,
            attribute: attribute,
            value: displayValue,
            field: gDecompositionTreeAttribute,
            tasks_label: tasks_label,
            width: width,
            tooltip: toolTip,
            parent: parentdata.key,
            rootdistance: degrees,
            taskArray: rows[i].taskArray,
            filterArray: attributeTree.concat(filter),
        };

        // add to model.nodeDataArray and create a Node
        model.addNodeData(childdata);
        // position the new child node close to the parent
        let child = gDiagramDecompositionTree.findNodeForData(childdata);
        child.location = parent.location;
    }
    return numChildren;
}

function analyticsTaskAttributesDecompositionTree(attributeTree, attribute) {  
    if (gTaskAttributes.length == 0) {
        return [];
    }
    let slicedArray = []
    gStepArray.sort((a, b) => a.id - b.id);
    gEventLogArray.sort((a, b) => a.filtered - b.filtered);

    let j = 0
    for (let i = 0; i < gEventLogArray.length; i++) {
        if (gEventLogArray[i].filtered == 1) break
        if (gEventLogArray[i].sliced == true ) {
            slicedArray.push(gEventLogArray[i])
            slicedArray[j].step = gStepArray[gEventLogArray[i].sid].step
            j++
        }
    }
    slicedArray.sort((a, b) => a.k - b.k);
    attributeTree.sort((a, b) => a.rootDistance - b.rootDistance);
    if (attributeTree.length == 1) {
        slicedArray.sort((a, b) => a[attribute].localeCompare(b[attribute]) || a.k.localeCompare(b.k));
    }
    if (attributeTree.length == 2) {
        slicedArray.sort(
            (a, b) => a[attributeTree[1].attribute].localeCompare(b[attributeTree[1].attribute]) || a[attribute].localeCompare(b[attribute])
            || a.k.localeCompare(b.k));
    }
    if (attributeTree.length == 3) {
        slicedArray.sort( 
            (a, b) =>
                a[attributeTree[2].attribute].localeCompare(b[attributeTree[2].attribute]) ||
                a[attributeTree[1].attribute].localeCompare(b[attributeTree[1].attribute]) ||
                a[attribute].localeCompare(b[attribute])
                || a.k.localeCompare(b.k));
    }
    if (attributeTree.length == 4) {
        slicedArray.sort(
            (a, b) =>
                a[attributeTree[3].attribute].localeCompare(b[attributeTree[3].attribute]) ||
                a[attributeTree[2].attribute].localeCompare(b[attributeTree[2].attribute]) ||
                a[attributeTree[1].attribute].localeCompare(b[attributeTree[1].attribute]) ||
                a[attribute].localeCompare(b[attribute])
                || a.k.localeCompare(b.k));
    }
    if (attributeTree.length == 5) {
        slicedArray.sort(
            (a, b) =>
                a[attributeTree[4].attribute].localeCompare(b[attributeTree[4].attribute]) ||
                a[attributeTree[3].attribute].localeCompare(b[attributeTree[3].attribute]) ||
                a[attributeTree[2].attribute].localeCompare(b[attributeTree[2].attribute]) ||
                a[attributeTree[1].attribute].localeCompare(b[attributeTree[1].attribute]) ||
                a[attribute].localeCompare(b[attribute])
                || a.k.localeCompare(b.k));
    }
    if (attributeTree.length == 6) {
        slicedArray.sort(
            (a, b) =>
                a[attributeTree[5].attribute].localeCompare(b[attributeTree[5].attribute]) ||
                a[attributeTree[4].attribute].localeCompare(b[attributeTree[4].attribute]) ||
                a[attributeTree[3].attribute].localeCompare(b[attributeTree[3].attribute]) ||
                a[attributeTree[2].attribute].localeCompare(b[attributeTree[2].attribute]) ||
                a[attributeTree[1].attribute].localeCompare(b[attributeTree[1].attribute]) ||
                a[attribute].localeCompare(b[attribute])
                || a.k.localeCompare(b.k));

        0;
    }
    if (attributeTree.length == 7) {
        slicedArray.sort(
            (a, b) =>
                a[attributeTree[6].attribute].localeCompare(b[attributeTree[6].attribute]) ||
                a[attributeTree[5].attribute].localeCompare(b[attributeTree[5].attribute]) ||
                a[attributeTree[4].attribute].localeCompare(b[attributeTree[4].attribute]) ||
                a[attributeTree[3].attribute].localeCompare(b[attributeTree[3].attribute]) ||
                a[attributeTree[2].attribute].localeCompare(b[attributeTree[2].attribute]) ||
                a[attributeTree[1].attribute].localeCompare(b[attributeTree[1].attribute]) ||
                a[attribute].localeCompare(b[attribute])
                || a.k.localeCompare(b.k));
    }
    if (attributeTree.length == 8) {
        slicedArray.sort(
            (a, b) =>
                a[attributeTree[7].attribute].localeCompare(b[attributeTree[7].attribute]) ||
                a[attributeTree[6].attribute].localeCompare(b[attributeTree[6].attribute]) ||
                a[attributeTree[5].attribute].localeCompare(b[attributeTree[5].attribute]) ||
                a[attributeTree[4].attribute].localeCompare(b[attributeTree[4].attribute]) ||
                a[attributeTree[3].attribute].localeCompare(b[attributeTree[3].attribute]) ||
                a[attributeTree[2].attribute].localeCompare(b[attributeTree[2].attribute]) ||
                a[attributeTree[1].attribute].localeCompare(b[attributeTree[1].attribute]) ||
                a[attribute].localeCompare(b[attribute])
                || a.k.localeCompare(b.k));
    }
    if (attributeTree.length == 9) {
        slicedArray.sort(
            (a, b) =>
                a[attributeTree[8].attribute].localeCompare(b[attributeTree[8].attribute]) ||
                a[attributeTree[7].attribute].localeCompare(b[attributeTree[7].attribute]) ||
                a[attributeTree[6].attribute].localeCompare(b[attributeTree[6].attribute]) ||
                a[attributeTree[5].attribute].localeCompare(b[attributeTree[5].attribute]) ||
                a[attributeTree[4].attribute].localeCompare(b[attributeTree[4].attribute]) ||
                a[attributeTree[3].attribute].localeCompare(b[attributeTree[3].attribute]) ||
                a[attributeTree[2].attribute].localeCompare(b[attributeTree[2].attribute]) ||
                a[attributeTree[1].attribute].localeCompare(b[attributeTree[1].attribute]) ||
                a[attribute].localeCompare(b[attribute])
                || a.k.localeCompare(b.k));
    }
    attributeTree.sort((a, b) => a.rootDistance - b.rootDistance);
    gTaskArray.sort((a, b) => a.id - b.id);
    let tasks = 0;
    let maxTasks = 0;
    let maxDuration = 0;
    let maxAvgCost = 0;
    let maxActualCost = 0;
    let maxAvgCostSaving = 0;
    let maxCustomerComments = 0
    let maxInternalComments = 0
    let maxWorklogs = 0
    let maxTimeSpent = 0
    let maxAvgTimeSpent = 0
    let actualCost = 0;
    let forecastCost = 0;
    let totalTasks = 0;
    let duration = 0;
    let validRec = false;
    let attributeLabel = null;
    let customer_comments = 0
    let internal_comments = 0
    let worklogs = 0
    let time_spent = 0
    let i = 0;
    for (i = 0; i < slicedArray.length; i++) {
        validRec = true;
        for (let j = 0; j < attributeTree.length; j++) {
            if (parseInt(attributeTree[j].rootDistance) != 0) {
                if (slicedArray[i][attributeTree[j].attribute] != attributeTree[j].value) {
                    validRec = false;
                    break;
                } 
            }
        }
        if (validRec == true) {
            // check min/max
            if ((i > 0 && slicedArray[i][attribute] != slicedArray[i - 1][attribute]) || (i === 0)) {
                validRec = false;
                if (gDecompositionTreeMetric == 1 && tasks <= gDecompositionTreeMaxMetric && tasks >= gDecompositionTreeMinMetric) validRec = true;
                if (
                    gDecompositionTreeMetric == 2 &&
                    duration / tasks / 60 <= gDecompositionTreeMaxMetric &&
                    duration / tasks / 60 >= gDecompositionTreeMinMetric
                ) validRec = true;
                if (
                    gDecompositionTreeMetric == 3 &&
                    duration / tasks / 3600 <= gDecompositionTreeMaxMetric &&
                    duration / tasks / 3600 >= gDecompositionTreeMinMetric
                ) validRec = true;
                if (
                    gDecompositionTreeMetric == 4 &&
                    duration / tasks / 62400 <= gDecompositionTreeMaxMetric &&
                    duration / tasks / 62400 >= gDecompositionTreeMinMetric
                ) validRec = true;
                if (gDecompositionTreeMetric == 5 && actualCost <= gDecompositionTreeMaxMetric && actualCost >= gDecompositionTreeMinMetric) validRec = true;
                if (
                    gDecompositionTreeMetric == 6 &&
                    actualCost / tasks <= gDecompositionTreeMaxMetric &&
                    actualCost / tasks >= gDecompositionTreeMinMetric
                ) validRec = true;
                if (
                    gDecompositionTreeMetric == 7 &&
                    (actualCost - forecastCost) / tasks <= gDecompositionTreeMaxMetric &&
                    (actualCost - forecastCost) / tasks >= gDecompositionTreeMinMetric
                ) validRec = true;
                if (gDecompositionTreeMetric == 10 && customer_comments <= gDecompositionTreeMaxMetric && customer_comments >= gDecompositionTreeMinMetric) validRec = true;
                if (gDecompositionTreeMetric == 11 && internal_comments <= gDecompositionTreeMaxMetric && internal_comments >= gDecompositionTreeMinMetric) validRec = true;
                if (gDecompositionTreeMetric == 12 && worklogs <= gDecompositionTreeMaxMetric && worklogs >= gDecompositionTreeMinMetric) validRec = true;
                if (
                    gDecompositionTreeMetric == 13 &&   
                    time_spent / tasks / 60 <= gDecompositionTreeMaxMetric &&
                    time_spent / tasks / 60 >= gDecompositionTreeMinMetric
                ) validRec = true;
                if (gDecompositionTreeMetric == 14 && (time_spent/60) <= gDecompositionTreeMaxMetric && (time_spent/60) >= gDecompositionTreeMinMetric) validRec = true;


                if (tasks > gDecompositionTreeMaxTasks || tasks < gDecompositionTreeMinTasks) validRec = false;
                if (validRec == true) {
                    if (gDecompositionTreeMetric == 1) {if (tasks > maxTasks) maxTasks = tasks;}
                    if (gDecompositionTreeMetric == 2) {if ((duration / tasks) / 60 > maxDuration) maxDuration = (duration / tasks) / 60;}
                    if (gDecompositionTreeMetric == 3) {if ((duration / tasks) / 3600 > maxDuration) maxDuration = (duration / tasks) / 3600;}
                    if (gDecompositionTreeMetric == 4) {if ((duration / tasks) / 62400 > maxDuration) maxDuration = (duration / tasks) / 62400;}
                    if (gDecompositionTreeMetric == 5) {if (actualCost > maxActualCost) maxActualCost = actualCost;}
                    if (gDecompositionTreeMetric == 6) {if (actualCost / tasks > maxAvgCost) maxAvgCost = actualCost / tasks;}
                    if (gDecompositionTreeMetric == 7) {if ((actualCost - forecastCost) / tasks > maxAvgCostSaving) maxAvgCostSaving = (actualCost - forecastCost) / tasks;}
                    
                    if (gDecompositionTreeMetric == 10) {if ((customer_comments) > maxCustomerComments) maxCustomerComments = customer_comments}
                    if (gDecompositionTreeMetric == 11) {if ((internal_comments) > maxInternalComments) maxInternalComments = internal_comments}
                    if (gDecompositionTreeMetric == 12) {if ((worklogs) > maxWorklogs) maxWorklogs = worklogs}
                    if (gDecompositionTreeMetric == 13) {if (time_spent / tasks > maxAvgTimeSpent) maxAvgTimeSpent = time_spent / tasks;}
                    if (gDecompositionTreeMetric == 14) {if ((time_spent) > maxTimeSpent) maxTimeSpent = time_spent}
                }
                tasks = 0;
                duration = 0;
                actualCost = 0;
                forecastCost = 0;
                customer_comments = 0
                internal_comments = 0
                worklogs = 0
                time_spent = 0
            }

            if ((i > 0 && slicedArray[i].k != slicedArray[i - 1].k) || i == 0) {
                totalTasks++;
                tasks++;
                duration = duration + gTaskArray[slicedArray[i].tid].d;
                actualCost = actualCost + gTaskArray[slicedArray[i].tid].actual_cost;
                forecastCost = forecastCost + gTaskArray[slicedArray[i].tid].forecast_cost;
                let comments = gTaskArray[slicedArray[i].tid].comments  
                let worklog = gTaskArray[slicedArray[i].tid].worklog
                if (comments !== undefined && comments[0] !== undefined) {
                    for (let c = 0; c < comments.length; c++) {
                        if (comments[c].jsdPublic === 'true') customer_comments ++
                        else internal_comments ++
                    }
                }
                if (worklog !== undefined  && worklog[0] !== undefined) {
                    for (let w = 0; w < worklog.length; w++) {
                        worklogs ++
                        time_spent = time_spent + parseInt(worklog[w].timeSpentSeconds)  
                    }         
                }
            }
        }
    }
    validRec = false;

    if (gDecompositionTreeMetric == 1 && tasks <= gDecompositionTreeMaxMetric && tasks >= gDecompositionTreeMinMetric) validRec = true;
    if (gDecompositionTreeMetric == 2 && duration / tasks / 60 <= gDecompositionTreeMaxMetric && duration / tasks / 60 >= gDecompositionTreeMinMetric) validRec = true;
    if (
        gDecompositionTreeMetric == 3 &&
        duration / tasks / 3600 <= gDecompositionTreeMaxMetric &&
        duration / tasks / 3600 >= gDecompositionTreeMinMetric
    ) validRec = true;
    if (
        gDecompositionTreeMetric == 4 &&
        duration / tasks / 62400 <= gDecompositionTreeMaxMetric &&
        duration / tasks / 62400 >= gDecompositionTreeMinMetric
    ) validRec = true;
    if (gDecompositionTreeMetric == 5 && actualCost <= gDecompositionTreeMaxMetric && actualCost >= gDecompositionTreeMinMetric) validRec = true;
    if (gDecompositionTreeMetric == 6 && actualCost / tasks <= gDecompositionTreeMaxMetric && actualCost / tasks >= gDecompositionTreeMinMetric) validRec = true;
    if (
        gDecompositionTreeMetric == 7 &&
        (actualCost - forecastCost) / tasks <= gDecompositionTreeMaxMetric &&
        (actualCost - forecastCost) / tasks >= gDecompositionTreeMinMetric
    ) validRec = true;
    if (gDecompositionTreeMetric == 10 && customer_comments <= gDecompositionTreeMaxMetric && customer_comments >= gDecompositionTreeMinMetric) validRec = true;
    if (gDecompositionTreeMetric == 11 && internal_comments <= gDecompositionTreeMaxMetric && internal_comments >= gDecompositionTreeMinMetric) validRec = true;
    if (gDecompositionTreeMetric == 12 && worklogs <= gDecompositionTreeMaxMetric && worklogs >= gDecompositionTreeMinMetric) validRec = true;
    if (
        gDecompositionTreeMetric == 13 &&
        time_spent / tasks / 60 <= gDecompositionTreeMaxMetric &&
        time_spent / tasks / 60 >= gDecompositionTreeMinMetric
    ) validRec = true;

    if (validRec == true) {
        if (gDecompositionTreeMetric == 1) {if (tasks > maxTasks) {maxTasks = tasks;}}
        if (gDecompositionTreeMetric == 2) {if ((duration / tasks) / 60 > maxDuration) {maxDuration = (duration / tasks) / 60;}}
        if (gDecompositionTreeMetric == 3) {if ((duration / tasks) / 3600 > maxDuration) {maxDuration = (duration / tasks) / 3600;}}
        if (gDecompositionTreeMetric == 4) {if ((duration / tasks) / 62400 > maxDuration) {maxDuration = (duration / tasks) / 62400;}}
        if (gDecompositionTreeMetric == 5) {if (actualCost > maxActualCost) {maxActualCost = actualCost;}}
        if (gDecompositionTreeMetric == 6) {if (actualCost / tasks > maxAvgCost) {maxAvgCost = actualCost / tasks;}}
        if (gDecompositionTreeMetric == 7) {if ((actualCost - forecastCost) / tasks > maxAvgCostSaving) {maxAvgCostSaving = (actualCost - forecastCost) / tasks;}}
        if (gDecompositionTreeMetric == 10) {if ((customer_comments) > maxCustomerComments) maxCustomerComments = customer_comments}
        if (gDecompositionTreeMetric == 11) {if ((internal_comments) > maxInternalComments) maxInternalComments = internal_comments}
        if (gDecompositionTreeMetric == 12) {if ((worklogs) > maxWorklogs) maxWorklogs = worklogs}
        if (gDecompositionTreeMetric == 13) {if (time_spent / tasks > maxAvgTimeSpent) maxAvgTimeSpent = time_spent / tasks;}
        if (gDecompositionTreeMetric == 14) {if ((time_spent) > maxTimeSpent) maxTimeSpent = time_spent}        
    }
    
    let vtp = [];
    let tempTaskArray = [];
    let rows = [];
    let currentAttribute = ''
    tasks = 0;
    duration = 0;
    actualCost = 0;
    forecastCost = 0;
    customer_comments = 0
    internal_comments = 0
    worklogs = 0
    time_spent = 0

    i = 0;
    for (i = 0; i < slicedArray.length; i++) {
        validRec = true;
        for (let j = 0; j < attributeTree.length; j++) {
            if (parseInt(attributeTree[j].rootDistance) != 0) {
                if (slicedArray[i][attributeTree[j].attribute] != attributeTree[j].value) {
                    validRec = false;
                    break;
                }
            }
        }
        if (validRec == true) {
            if (i > 0 && slicedArray[i][attribute] != slicedArray[i - 1][attribute] && tasks > 0) {
                validRec = false;

                if (gDecompositionTreeMetric == 1 && tasks <= gDecompositionTreeMaxMetric && tasks >= gDecompositionTreeMinMetric) validRec = true;
                if (
                    gDecompositionTreeMetric == 2 &&
                    duration / tasks / 60 <= gDecompositionTreeMaxMetric &&
                    duration / tasks / 60 >= gDecompositionTreeMinMetric
                ) validRec = true;
                if (
                    gDecompositionTreeMetric == 3 &&
                    duration / tasks / 3600 <= gDecompositionTreeMaxMetric &&
                    duration / tasks / 3600 >= gDecompositionTreeMinMetric
                ) validRec = true;
                if (
                    gDecompositionTreeMetric == 4 &&
                    duration / tasks / 62400 <= gDecompositionTreeMaxMetric &&
                    duration / tasks / 62400 >= gDecompositionTreeMinMetric
                ) validRec = true;
                if (gDecompositionTreeMetric == 5 && actualCost <= gDecompositionTreeMaxMetric && actualCost >= gDecompositionTreeMinMetric) validRec = true;
                if (
                    gDecompositionTreeMetric == 6 &&
                    actualCost / tasks <= gDecompositionTreeMaxMetric &&
                    actualCost / tasks >= gDecompositionTreeMinMetric
                ) validRec = true;
                if (
                    gDecompositionTreeMetric == 7 &&
                    (actualCost - forecastCost) / tasks <= gDecompositionTreeMaxMetric &&
                    (actualCost - forecastCost) / tasks >= gDecompositionTreeMinMetric
                ) validRec = true;
                if (gDecompositionTreeMetric == 10 && customer_comments <= gDecompositionTreeMaxMetric && customer_comments >= gDecompositionTreeMinMetric) validRec = true;
                if (gDecompositionTreeMetric == 11 && internal_comments <= gDecompositionTreeMaxMetric && internal_comments >= gDecompositionTreeMinMetric) validRec = true;
                if (gDecompositionTreeMetric == 12 && worklogs <= gDecompositionTreeMaxMetric && worklogs >= gDecompositionTreeMinMetric) validRec = true;
                if (
                    gDecompositionTreeMetric == 13 &&
                    (time_spent / 60/ tasks) <= gDecompositionTreeMaxMetric &&
                    (time_spent / 60/ tasks) >= gDecompositionTreeMinMetric
                ) validRec = true;
                if (gDecompositionTreeMetric == 14 && time_spent/60 <= gDecompositionTreeMaxMetric && time_spent/60 >= gDecompositionTreeMinMetric) validRec = true;
                if (tasks > gDecompositionTreeMaxTasks || tasks < gDecompositionTreeMinTasks) validRec = false;

                if (validRec == true) {
                    vtp = {};
                    vtp['attribute'] = slicedArray[i - 1][attribute].replaceAll('^^',',');
                    currentAttribute = slicedArray[i - 1][attribute].replaceAll('^^',',')
                    vtp['tasks'] = numberWithCommas(tasks);
                    vtp['percTotal'] = tasks / totalTasks;
                    if (gDecompositionTreeMetric == 1) {
                        vtp['metric'] = numberWithCommas(tasks);
                        vtp['value'] = tasks;
                        vtp['percMax'] = tasks / maxTasks;
                    }
                    if (gDecompositionTreeMetric == 2) {
                        vtp['metric'] = (duration / tasks / 60).toFixed(2);
                        vtp['value'] = duration / tasks / 60;
                        vtp['percMax'] = ((duration / tasks) / 60) / maxDuration;
                    }
                    if (gDecompositionTreeMetric == 3) {
                        vtp['metric'] = (duration / tasks / 3600).toFixed(2);
                        vtp['value'] = duration / tasks / 3660;
                        vtp['percMax'] = ((duration / tasks) / 3600) / maxDuration; 
                    }
                    if (gDecompositionTreeMetric == 4) {
                        vtp['metric'] = (duration / tasks / 62400).toFixed(2);
                        vtp['value'] = duration / tasks / 62400;
                        vtp['percMax'] = duration / tasks / 62400 / maxDuration;
                    }
                    if (gDecompositionTreeMetric == 5) {
                        vtp['metric'] = actualCost;
                        vtp['value'] = actualCost;
                        vtp['percMax'] = actualCost / maxActualCost;
                    }
                    if (gDecompositionTreeMetric == 6) {
                        vtp['metric'] = actualCost / tasks;
                        vtp['value'] = actualCost / tasks;
                        vtp['percMax'] = actualCost / tasks / maxAvgCost;
                    }
                    if (gDecompositionTreeMetric == 7) {
                        vtp['metric'] = (actualCost - forecastCost) / tasks;
                        vtp['value'] = (actualCost - forecastCost) / tasks;
                        vtp['percMax'] = (actualCost - forecastCost) / tasks / maxAvgCostSaving;
                    }
                    if (gDecompositionTreeMetric == 10) {
                        vtp['metric'] = numberWithCommas(customer_comments);
                        vtp['value'] = customer_comments;
                        vtp['percMax'] = customer_comments / maxCustomerComments;
                    }
                    if (gDecompositionTreeMetric == 11) {
                        vtp['metric'] = numberWithCommas(internal_comments);
                        vtp['value'] = internal_comments;
                        vtp['percMax'] = internal_comments / maxInternalComments;
                    }
                    if (gDecompositionTreeMetric == 12) {
                        vtp['metric'] = numberWithCommas(worklogs);
                        vtp['value'] = worklogs;
                        vtp['percMax'] = worklogs / maxWorklogs;
                    }
                    if (gDecompositionTreeMetric == 13) {
                        vtp['metric'] =  (time_spent / tasks / 60).toFixed(2);
                        vtp['value'] = (time_spent / tasks / 60)
                        vtp['percMax'] = (time_spent / tasks / 60) / maxTimeSpent;
                    }
                    if (gDecompositionTreeMetric == 14) {
                        vtp['metric'] = numberWithCommas(time_spent);
                        vtp['value'] = time_spent;
                        vtp['percMax'] = time_spent / maxTimeSpent;
                    }
                    vtp['taskArray'] = tempTaskArray;
                    rows.push(vtp);
                }
                tempTaskArray = [];
                tasks = 0;
                duration = 0;
                actualCost = 0;
                forecastCost = 0;
                customer_comments = 0
                internal_comments = 0
                worklogs = 0
                time_spent = 0
            }

            if ((i > 0 && slicedArray[i].k != slicedArray[i - 1].k) || i == 0) {
                tasks++;

                duration = duration + gTaskArray[slicedArray[i].tid].d;
                actualCost = actualCost + gTaskArray[slicedArray[i].tid].actual_cost;
                forecastCost = forecastCost + gTaskArray[slicedArray[i].tid].forecast_cost;
                tempTaskArray.push(gTaskArray[slicedArray[i].tid]);
                let comments = gTaskArray[slicedArray[i].tid].comments  
                let worklog = gTaskArray[slicedArray[i].tid].worklog
                if (comments !== undefined && comments[0] !== undefined) {
                    for (let c = 0; c < comments.length; c++) {
                        if (comments[c].jsdPublic === 'true') customer_comments ++
                        else internal_comments ++
                    }
                }
                if (worklog !== undefined  && worklog[0] !== undefined) {
                    for (let w = 0; w < worklog.length; w++) {
                        worklogs ++
                        time_spent = time_spent + parseInt(worklog[w].timeSpentSeconds)  
                    }         
                }
            }
            attributeLabel = slicedArray[i][attribute].replaceAll('^^',',');
        }
    }
    if (attributeLabel !== currentAttribute || currentAttribute === '') {
        validRec = false;

        if (gDecompositionTreeMetric == 1 && tasks <= gDecompositionTreeMaxMetric && tasks >= gDecompositionTreeMinMetric) validRec = true;
        if (
            gDecompositionTreeMetric == 2 &&
            duration / tasks / 60 <= gDecompositionTreeMaxMetric &&
            duration / tasks / 60 >= gDecompositionTreeMinMetric
        ) validRec = true;
        if (
            gDecompositionTreeMetric == 3 &&
            duration / tasks / 3600 <= gDecompositionTreeMaxMetric &&
            duration / tasks / 3600 >= gDecompositionTreeMinMetric
        ) validRec = true;
        if (
            gDecompositionTreeMetric == 4 &&
            duration / tasks / 62400 <= gDecompositionTreeMaxMetric &&
            duration / tasks / 62400 >= gDecompositionTreeMinMetric
        ) validRec = true;
        if (gDecompositionTreeMetric == 5 && actualCost <= gDecompositionTreeMaxMetric && actualCost >= gDecompositionTreeMinMetric) validRec = true;
        if (
            gDecompositionTreeMetric == 6 &&
            actualCost / tasks <= gDecompositionTreeMaxMetric &&
            actualCost / tasks >= gDecompositionTreeMinMetric
        ) validRec = true;
        if (
            gDecompositionTreeMetric == 7 &&
            (actualCost - forecastCost) / tasks <= gDecompositionTreeMaxMetric &&
            (actualCost - forecastCost) / tasks >= gDecompositionTreeMinMetric
        ) validRec = true;
        if (tasks > gDecompositionTreeMaxTasks || tasks < gDecompositionTreeMinTasks)validRec = false;

        if (validRec == true) {
            vtp = {};
            vtp['attribute'] = attributeLabel;
            vtp['tasks'] = numberWithCommas(tasks);
            vtp['percTotal'] = tasks / totalTasks;
            if (gDecompositionTreeMetric == 1) {
                vtp['metric'] = numberWithCommas(tasks);
                vtp['value'] = tasks;
                vtp['percMax'] = tasks / maxTasks;
            }
            if (gDecompositionTreeMetric == 2) {
                vtp['metric'] = (duration / tasks / 60).toFixed(2);
                vtp['value'] = duration / tasks / 60;
                vtp['percMax'] = ((duration / tasks) / 60) / maxDuration;
            }
            if (gDecompositionTreeMetric == 3) {
                vtp['metric'] = (duration / tasks / 3600).toFixed(2);
                vtp['value'] = duration / tasks / 3660;
                vtp['percMax'] = ((duration / tasks) / 3600) / maxDuration;
            }
            if (gDecompositionTreeMetric == 4) {
                vtp['metric'] = (duration / tasks / 62400).toFixed(2);
                vtp['value'] = duration / tasks / 62400;
                vtp['percMax'] = duration / tasks / 62400 / maxDuration;
            }
            if (gDecompositionTreeMetric == 5) {
                vtp['metric'] = actualCost;
                vtp['value'] = actualCost;
                vtp['percMax'] = actualCost / maxActualCost;
            }
            if (gDecompositionTreeMetric == 6) {
                vtp['metric'] = actualCost / tasks;
                vtp['value'] = actualCost / tasks;
                vtp['percMax'] = actualCost / tasks / maxAvgCost;
            }
            if (gDecompositionTreeMetric == 7) {
                vtp['metric'] = (actualCost - forecastCost) / tasks;
                vtp['value'] = (actualCost - forecastCost) / tasks;
                vtp['percMax'] = (actualCost - forecastCost) / tasks / maxAvgCostSaving;
            }
            vtp['taskArray'] = tempTaskArray;
            rows.push(vtp);
        }
        tempTaskArray = [];
        tasks = 0;
        duration = 0;
        customer_comments = 0
        internal_comments = 0
        worklogs = 0
        time_spent = 0
    }
    rows.sort((a, b) => (b.Metric > a.Metric ? 1 : -1));
    return rows;
}

export function getCurrentDiagram() {
    return gCurrentDiagram;
}


function loadDiagramDecompositionTree() {
    let $ = go.GraphObject.make;
    gDiagramDecompositionTree = $(go.Diagram, {
        layout: $(go.TreeLayout),
        initialScale: 1,
    });

    let lay = gDiagramDecompositionTree.layout;
    lay.nodeSpacing = 10;
    lay.layerSpacing = 55;
    gDiagramDecompositionTree.contentAlignment = go.Spot.TopLeft;
    gDiagramDecompositionTree.toolManager.mouseWheelBehavior = go.ToolManager.WheelZoom;
    gDiagramDecompositionTree.toolManager.toolTipDuration = 10000;
    //gDiagramDecompositionTree.padding.left = 32;

    const element = document.getElementById('gDiagramDivDT');
    gDiagramDecompositionTree.div = element

    const getNodeContextMenuOptions = ({ data: { key, taskArray, filterArray } }) => {
        if (key < 2) {
            return;
        }

        let tasks = [
            {
                text: getEntityUpper() + 's',
                subMenuOptions: [
                    {
                        text: 'Detail',
                        event: () => {
                            gDetailSource = 'dt_node';
                            gDecompositionTreeTaskArray = taskArray;
                            taskDetailModal()
                        },
                    },
                    {
                        text: 'History',
                        event: () => {

                            let taskStr = ''
                            for (let i = 0; i < taskArray.length; i++) {        
                                if  (i > 0) {taskStr = taskStr + '^'}
                                taskStr = taskStr + taskArray[i].id  
                            }
                            gTasksVisualizationSource = 'dt_node';
                            gTaskStr = taskStr;
                            processAnalytics(0, 0, 0, 0, 0, '' ,'decomposition_tree', 'decomposition_tree', getEntityUpper() + 's','dt_node')
                        },
                    },
                    {
                        text: 'Histogram',
                        event: () => {
                            let taskStr = ''
                            for (let i = 0; i < taskArray.length; i++) {        
                                if  (i > 0) {taskStr = taskStr + '^'}
                                taskStr = taskStr + taskArray[i].id  
                            }
                            gTasksVisualizationSource = 'dt_node';
                            gTaskStr = taskStr;
                            generateHistogramArray('influencers',true,0,0,0,0)
                            histogramModal()
                        },
                    },
                    {
                        text: 'LifeCycle',
                        event: () => {
                            gTasksVisualizationSource = 'dt_node';
                            gDecompositionTreeTaskArray = taskArray;
                            updateNodeTaskArrayforTaskLifecyle();
                            tasksVisualization();
                            taskLifecycleModal()
                        },
                    },
                    {
                        text: 'Activity Analysis',  
                        event: () => {
                            let taskStr = ''
                            for (let i = 0; i < taskArray.length; i++) {        
                                if  (i > 0) {taskStr = taskStr + '^'}
                                taskStr = taskStr + taskArray[i].id  
                            }
                            gTaskStr = taskStr;
                            generateTasksFilteredArray('dt_node', true, 0, 0, 0, 0, 0);
                            setAction_Time({ eventEmitter: gEventEmitter });

                        },
                    },                      
                ]
            }
        ]

        let events = [
            {
                text: 'Events',
                subMenuOptions: [
                    
                    {
                        text: 'Detail',
                        event: () => {
                            gDetailSource = 'dt_node';
                            gDecompositionTreeTaskArray = taskArray;
                            eventDetailModal();
                        },
                    },
                ],
            },
        ]

        let contextMenu = tasks
        contextMenu = contextMenu.concat(events)
        return contextMenu
          
    };

    let contextMenuObj = null;
    const contextMenuDecompositionTree = $(go.HTMLInfo, {
        show: (obj, diagram) => {
            const { x, y } = diagram.lastInput.viewPoint;
            ``;
            const options = obj.part instanceof go.Node ? getNodeContextMenuOptions(obj) : '';
            diagram.toolManager.hideToolTip();
            contextMenuObj = obj;
            if (options) {
                showContextMenu({ gEventEmitter, x, y, options });
            }
        },
        hide: (diagram) => {
            contextMenuObj = null;
            hideContextMenu({ gEventEmitter });
        },
    });

    gDiagramDecompositionTree.nodeTemplate = $(
        go.Node,
        'Spot',
        {
            isShadowed: true,
            selectionObjectName: 'PANEL',
            selectionAdorned: false,
            isTreeExpanded: false,
            isTreeLeaf: false,
            contextMenu: contextMenuDecompositionTree,
        },

        {
            toolTip: $(
                go.Adornment,
                'Auto',
                $(go.Shape, 'RoundedRectangle', { fill: 'white', stroke: 'gray', strokeWidth: 1 }),
                $(
                    go.TextBlock,
                    {
                        margin: 4,
                        font: '9pt system-ui, arial, system-ui',
                    },
                    new go.Binding('text', 'tooltip')
                )
            ),
        },
        $(go.Shape, 'Border', { fill: 'whitesmoke', stroke: 'white', strokeWidth: 0, width: 200, height: 50 }),
        // the expand/collapse button, at the top-right corner
        $('TreeExpanderButton', {
            name: 'TREEBUTTON',
            width: 20,
            height: 20,
            visible: true,
            alignment: go.Spot.TopRight,
            alignmentFocus: go.Spot.Center,
            click: (e, obj) => {
                // OBJ is the Button
                let node = obj.part; // get the Node containing this Button
                if (node === null) return;
                e.handled = true;
                expandDecompositionTreeNode(node);
            },
        }),

        $(
            go.Panel,
            'Table',
            { defaultAlignment: go.Spot.Left },
            $(
                go.Shape,
                'Rectangle',
                { row: 0, column: 0, fill: '#0B66E4', strokeWidth: 0, margin: new go.Margin(0, 0, 0, 5), height: 15, columnSpan: 2 },
                new go.Binding('width', 'width')
            ),
            $(
                go.TextBlock,
                {
                    row: 1,
                    column: 0,
                    font: '9pt system-ui',
                    spacingAbove: 5,
                    margin: new go.Margin(0, 0, 0, 5),
                    stretch: go.GraphObject.Horizontal,
                    overflow: go.TextBlock.OverflowEllipsis,
                    width: 195,
                    columnSpan: 2,
                },
                new go.Binding('text', 'label')
            ),
            $(
                go.TextBlock,
                { row: 2, column: 0, font: '9pt system-ui', spacingAbove: 5, margin: new go.Margin(0, 0, 0, 5), width: 105 },
                new go.Binding('text', 'value')
            ),
            $(
                go.TextBlock,
                { row: 2, column: 1, font: '8pt system-ui', spacingAbove: 5, width: 85 },
                new go.Binding('text', 'tasks_label')
            )
        )
    ); // end Node

    gDiagramDecompositionTree.linkTemplate = $(
        go.Link,
        { curve: go.Link.Bezier },
        $(go.Shape, { strokeWidth: 1, stroke: '#0B66E4' }) // the link shape, with the default black stroke
    );

    // create the model with a root node data

    if (gTasksFilteredArray.length === 0 ) gTasksFilteredArray =  gTaskArray

    gDiagramDecompositionTree.model = new go.TreeModel([
        {
            key: 1,
            label: gEntityUpper + 's',
            value: gTasksFilteredArray.length,
            perc: '100%',
            tooltip: '',
            attribute: 'parentNode',
            everExpanded: false,
            width: 185,
            rootdistance: 0,
        },
    ]);
}

function loadDiagramCluster() {
    const $ = go.GraphObject.make; // for conciseness in defining templates

    gDiagramCluster = $(
        go.Diagram, // must be the ID or reference to div
        {
            layout: $(go.LayeredDigraphLayout, { direction: 90 }),
            scrollMode: go.Diagram.InfiniteScroll,
            initialPosition: new go.Point(-35, -10),
            //                contentAlignment: go.Spot.TopLeft,
        }
    );

    gDiagramCluster.layout.layerSpacing = 10;

    const element = document.getElementById('gDiagramDivRC');
    gDiagramCluster.div = element     

    // define the Node template

    const getNodeContextMenuOptions = ({ data: { task_str, attributeArray } }) => { 

        let tasks = [
            {
                text: getEntityUpper() + 's',
                subMenuOptions: [
                    {
                        text: 'Detail',
                        event: () => {
                            gDetailSource = 'rc_node';
                            for (let i = 0; i < attributeArray.length; i++) {
                                attributeArray[i].id = attributeArray[i].id1; // bug in Go.JS storage of array in node
                            }
                            gClusterAttributeArray = attributeArray;
                            gTaskStr = task_str;
                            taskDetailModal()
                        },
                    },
                    {
                        text: 'History',
                        event: () => { 
                            gTasksVisualizationSource = 'rc_node';
                            gTaskStr = task_str;
                            gClusterAttributeArray = attributeArray
                            processAnalytics(0, 0, 0, 0, 0, '' ,'Cluster Node', 'Cluster Node', getEntityUpper() + 's','rc_node')
                        },
                    },
                    {
                        text: 'Histogram',
                        event: () => {
                            gTasksVisualizationSource = 'rc_node';
                            gClusterAttributeArray = attributeArray;
                            gTaskStr = task_str;
                            generateHistogramArray('influencers',true,0,0,0,0)
                            histogramModal()
                        },
                    },
                    {
                        text: 'LifeCycle',
                        event: () => {
                            gTasksVisualizationSource = 'rc_node';
                            gClusterAttributeArray = attributeArray;
                            gTaskStr = task_str;
                            updateNodeTaskArrayforTaskLifecyle();
                            tasksVisualization();
                            taskLifecycleModal()
                        },
                    },
                    {
                        text: 'Activity Analysis',  
                        event: () => {
                            gTaskStr = task_str;
                            generateTasksFilteredArray('rc_node', true, 0, 0, 0, 0, 0);
                            setAction_Time({ eventEmitter: gEventEmitter });
                        },
                    },                       


                ]
            }]

            let events = [
                {
                    text: 'Events',
                    subMenuOptions: [
                        
                        {
                            text: 'Detail',
                            event: () => {
                                gDetailSource = 'ia_node';
                                for (let i = 0; i < attributeArray.length; i++) {
                                    attributeArray[i].id = attributeArray[i].id1; // bug in Go.JS storage of array in node
                                }
                                gClusterAttributeArray = attributeArray;
                                gTaskStr = task_str;
                                eventDetailModal();
                            },
                        },
                    ],
                }
            ]
    
        let filterAttributes = [
            {
                text: 'Filter (attributes)',
                event: () => {
                    setDiagramVisualizer();
                    setAction_Visualizer({ eventEmitter: gEventEmitter });
                    if (gFilters.length > 0) resetFilters(false,'');
                    for (let i = 0; i < attributeArray.length; i++) {
                        if (attributeArray[i].attribute !== 'Step') {
                            if (attributeArray[i].value !== undefined) {
                                gAttribute = attributeArray[i].field;
                                gAttributeType = gEntityUpper;
                                let vtp = [];
                                vtp['value'] = attributeArray[i].value;
                                gSelectedAttributes = [];
                                gSelectedAttributes.push(vtp);
                                applyAttributesFilter(gAttribute, gAttributeType,'',false);
                            }
                        }
                    }
                    applyFilterEvents({ eventEmitter: gEventEmitter });
                },
            },

        ]
        let contextMenu = tasks
        contextMenu = contextMenu.concat(events)
        contextMenu = contextMenu.concat(filterAttributes)
        return contextMenu
    };


    const getNodeContextMenuOptionsDiscoveryRule = ({ data: { task_str, attributeArray } }) => { 

        let tasks = [
            {
                text: getEntityUpper() + 's',
                subMenuOptions: [
                    {
                        text: 'Detail',
                        event: () => {
                            gDetailSource = 'rc_node';
                            for (let i = 0; i < attributeArray.length; i++) {
                                attributeArray[i].id = attributeArray[i].id1; // bug in Go.JS storage of array in node
                            }
                            gClusterAttributeArray = attributeArray;
                            gTaskStr = task_str;
                            taskDetailModal()
                        },
                    },
                    {
                        text: 'History',
                        event: () => { 
                            gTasksVisualizationSource = 'rc_node';
                            gTaskStr = task_str;
                            gClusterAttributeArray = attributeArray
                            processAnalytics(0, 0, 0, 0, 0, '' ,'Cluster Node', 'Cluster Node', getEntityUpper() + 's','rc_node')
                        },
                    },
                    {
                        text: 'Histogram',
                        event: () => {
                            gTasksVisualizationSource = 'rc_node';
                            gClusterAttributeArray = attributeArray;
                            gTaskStr = task_str;
                            generateHistogramArray('influencers',true,0,0,0,0)
                            histogramModal()
                        },
                    },
                    {
                        text: 'LifeCycle',
                        event: () => {
                            gTasksVisualizationSource = 'rc_node';
                            gClusterAttributeArray = attributeArray;
                            gTaskStr = task_str;
                            updateNodeTaskArrayforTaskLifecyle();
                            tasksVisualization();
                            taskLifecycleModal()
                        },
                    },
                    {
                        text: 'Activity Analysis',  
                        event: () => {
                            gTaskStr = task_str;
                            generateTasksFilteredArray('rc_node', true, 0, 0, 0, 0, 0);
                            setAction_Time({ eventEmitter: gEventEmitter });
                        },
                    },                       


                ]
            }
        ]

        let events = [
            {
                text: 'Events',
                subMenuOptions: [
                    {
                        text: 'Detail',
                        event: () => {
                            gDetailSource = 'ia_node';
                            for (let i = 0; i < attributeArray.length; i++) {
                                attributeArray[i].id = attributeArray[i].id1; // bug in Go.JS storage of array in node
                            }
                            gClusterAttributeArray = attributeArray;
                            gTaskStr = task_str;
                            eventDetailModal();
                        },
                    },
                ],
            }
        ]
    
        let filterAttributes = [
            {
                text: 'Filter (attributes)',
                event: () => {
                    setDiagramVisualizer();
                    setAction_Visualizer({ eventEmitter: gEventEmitter });
                    if (gFilters.length > 0) resetFilters(false),'';
                    for (let i = 0; i < attributeArray.length; i++) {
                        if (attributeArray[i].attribute !== 'Step') {
                            if (attributeArray[i].value !== undefined) {
                                gAttribute = attributeArray[i].field;
                                gAttributeType = gEntityUpper;
                                let vtp = [];
                                vtp['value'] = attributeArray[i].value;
                                gSelectedAttributes = [];
                                gSelectedAttributes.push(vtp);
                                applyAttributesFilter(gAttribute, gAttributeType,'',false);
                            }
                        }
                    }
                    applyFilterEvents({ eventEmitter: gEventEmitter });
                },
            },

        ]
        let contextMenu = tasks
        contextMenu = contextMenu.concat(events)
        contextMenu = contextMenu.concat(filterDiscoveryRules)
        contextMenu = contextMenu.concat(filterAttributes)
        return contextMenu
    };

    let contextMenuObj = null;
    const contextMenuInsights = $(go.HTMLInfo, {
        show: (obj, diagram) => {
            const { x, y } = diagram.lastInput.viewPoint;
            let options
            if (gClusterSource === 'discovery_rule') {
                options = obj.part instanceof go.Node ? getNodeContextMenuOptionsDiscoveryRule(obj) : '';
            } else {
                options = obj.part instanceof go.Node ? getNodeContextMenuOptions(obj) : '';
            }
            contextMenuObj = obj;
            showContextMenu({ gEventEmitter, x, y, options });
        },
        hide: (diagram) => {
            contextMenuObj = null;
            hideContextMenu({ gEventEmitter });
        },
    });

    gDiagramCluster.toolManager.hoverDelay = 200;
    gDiagramCluster.toolManager.toolTipDuration = 10000;

        gDiagramCluster.nodeTemplate = $(
        go.Node,
        'Auto',
        { locationSpot: go.Spot.Top, isShadowed: true, contextMenu: contextMenuInsights },
        new go.Binding('text', 'text'),
        new go.Binding('visible', 'visible'),
        $(go.Shape, 'Border', { fill: 'whitesmoke', stroke: 'white', strokeWidth: 0, width: 800 }),
        {
            toolTip: $(
                go.Adornment,
                'Auto',
                $(go.Shape, 'RoundedRectangle', { fill: 'white', stroke: 'gray', strokeWidth: 1 }),
                $(
                    go.TextBlock,
                    {
                        margin: 4,
                        font: '9pt system-ui, arial, system-ui',
                    },
                    new go.Binding('text', 'attributes')
                ),
                new go.Binding('visible', 'disableTooltip', (disableTooltip) => !disableTooltip)
            ),
        },
        $(
            go.Panel,
            'Table',
            { defaultAlignment: go.Spot.Left },
            $(
                go.TextBlock,  
                {
                    row: 0,
                    column: 0,
                    font: '9pt system-ui',
                    spacingAbove: 5,
                    height: 25,
                    stroke: "#FFFFFF",
                    margin: new go.Margin(0, 0, 0, 20),
                    overflow: go.TextBlock.OverflowEllipsis,
                    background: "#0B66E4"
                },
                new go.Binding('text', 'header'),
                new go.Binding('width', 'width'),
            ),

            $(
                go.TextBlock,
                {
                    row: 1,
                    column: 0,
                    font: '9pt system-ui',
                    spacingAbove: 5,
                    width: 780,
                    height: 20,
                    margin: new go.Margin(5, 0, 0, 20),
                    overflow: go.TextBlock.OverflowEllipsis,
                },
                new go.Binding('text', 'attributes'),
            ),
        )
    );

    // define the Link template
    gDiagramCluster.linkTemplate = $(
        go.Link,
        {
            routing: go.Link.Orthogonal,
            selectable: false,
        },
        $(go.Shape, { strokeWidth: 0 })
    );
}


async function insightsFilterCurrentDiscoveryRule(attributeArray) {
    if (gFilters.length > 0) resetFilters(false);

    let discoveryRule
    for (let i = 0; i < gDiscoveryRules.length; i++) {
        if (gDiscoveryRules[i].discovery_rule_id === gClusterDiscoveryRuleID) discoveryRule = gDiscoveryRules[i]
    }
    // delete discoveryRule
    discoveryRule.mode = 'delete'
    updateDiscoveryRule(discoveryRule)

    // apply original discoveryRule filters
    await processFilters(discoveryRule.filters,'insightsFilterCurrentDiscoveryRule',false)  

    // apply new discoveryRule filters
    for (let i = 0; i < attributeArray.length; i++) {
        if (attributeArray[i].attribute !== 'Step') {
            if (attributeArray[i].value !== undefined) {
                gAttribute = attributeArray[i].field;
                gAttributeType = gEntityUpper;
                let vtp = [];
                vtp['value'] = attributeArray[i].value;
                gSelectedAttributes = [];  
                gSelectedAttributes.push(vtp);
                applyAttributesFilter(gAttribute, gAttributeType,'',false);
            }
        }
    }
    discoveryRule.category = 'Filtered Best Practice'
    discoveryRule.mode = 'new'
    discoveryRule.filters = gFilterConditions
    await updateDiscoveryRule(discoveryRule);  

    // navigate to discoveryRules
    //applyFilterEvents({ eventEmitter: gEventEmitter });

}


async function insightsCreateNewDiscoveryRule(attributeArray) {
    if (gFilters.length > 0) resetFilters(false);

    let discoveryRule
    for (let i = 0; i < gDiscoveryRules.length; i++) {
        if (gDiscoveryRules[i].discovery_rule_id === gClusterDiscoveryRuleID) discoveryRule = gDiscoveryRules[i]
    }
    // delete discoveryRule
    discoveryRule.mode = 'delete'
    updateDiscoveryRule(discoveryRule)

    // apply original discoveryRule filters
    await processFilters(discoveryRule.filters,'insightsCreateNewDiscoveryRule',false)  

    // apply new discoveryRule filters
    for (let i = 0; i < attributeArray.length; i++) {
        if (attributeArray[i].attribute !== 'Step') {
            if (attributeArray[i].value !== undefined) {
                gAttribute = attributeArray[i].field;
                gAttributeType = gEntityUpper;
                let vtp = [];
                vtp['value'] = attributeArray[i].value;
                gSelectedAttributes = [];
                gSelectedAttributes.push(vtp);
                applyAttributesFilter(gAttribute, gAttributeType,'',false);
            }
        }
    }
    
    // create new discoveryRule
    discoveryRule.mode = 'new'
    await updateDiscoveryRule(discoveryRule);  

    // navigate to discoveryRules
    //applyFilterEvents({ eventEmitter: gEventEmitter });

}

function loadDiagramInfluenceAnalysis() {
    let $ = go.GraphObject.make;
    gDiagramInfluenceAnalysis = $(go.Diagram, {
        'undoManager.isEnabled': true,
        scrollMode: go.Diagram.InfiniteScroll,
        initialPosition: new go.Point(-385, -25),
    });
    const element = document.getElementById('gDiagramDivIA');
    gDiagramInfluenceAnalysis.div = element     

    gDiagramInfluenceAnalysis.contentAlignment = go.Spot.TopLeft;
    const getNodeContextMenuOptions = ({ data: { task_str, attribute_array , step, from, to, from_label, to_label} }) => {

        let tasks = 
        [
            {
                text: getEntityUpper() + 's',
                subMenuOptions: [
                    {
                        text: 'Detail',
                        event: () => {
                            gDetailSource = 'ia_node';
                            for (let i = 0; i < attribute_array.length; i++) {
                                attribute_array[i].id = attribute_array[i].id1; // bug in Go.JS storage of array in node
                            }
                            gClusterAttributeArray = attribute_array;
                            gTaskStr = task_str;
                            taskDetailModal()
                        },
                    },
                    {
                        text: 'History',
                        event: () => {
                            gTasksVisualizationSource = 'ia_node';
                            gClusterAttributeArray = attribute_array;
                            gTaskStr = task_str;
                            processAnalytics(0, 0, 0, 0, 0, '' ,'Influence Node', 'Influencer Node', getEntityUpper() + 's','ia_node')
                        },
                    },
                    {
                        text: 'Histogram',
                        event: () => {
                            gTasksVisualizationSource = 'ia_node';
                            gClusterAttributeArray = attribute_array;
                            gTaskStr = task_str;
                            generateHistogramArray('influencers',true,0,0,0,0)
                            histogramModal()
                        },
                    },
                    {
                        text: 'LifeCycle',
                        event: () => {
                            gTasksVisualizationSource = 'ia_node';
                            gClusterAttributeArray = attribute_array;
                            gTaskStr = task_str;
                            updateNodeTaskArrayforTaskLifecyle();
                            tasksVisualization();
                            taskLifecycleModal()
                        },
                    },
                    {
                        text: 'Activity Analysis',  
                        event: () => {
                            gTaskStr = task_str;
                            generateTasksFilteredArray('ia_node', true, 0, 0, 0, 0, 0);
                            setAction_Time({ eventEmitter: gEventEmitter });
                        },
                    },                       
                ]
            }
        ]

        let events = [
            {
                text: 'Events',
                subMenuOptions: [
                    
                    {
                        text: 'Detail',
                        event: () => {
                            gDetailSource = 'ia_node';
                            for (let i = 0; i < attribute_array.length; i++) {
                                attribute_array[i].id = attribute_array[i].id1; // bug in Go.JS storage of array in node
                            }
                            gClusterAttributeArray = attribute_array;
                            gTaskStr = task_str;
                            eventDetailModal();
                        },
                    },
                ],
            },
        ]

        let filterAttributes = [
            {
                text: 'Filter (attributes)',
                event: () => {
                    if (gFilters.length > 0) {
                        resetFilters(false);
                    }
                    for (let i = 0; i < attribute_array.length; i++) {
                        if (attribute_array[i].field != 'step') {
                            gAttribute = attribute_array[i].field;
                            gAttributeType = gEntityUpper
                            let vtp = [];
                            vtp['value'] = attribute_array[i].value;
                            gSelectedAttributes = [];
                            gSelectedAttributes.push(vtp);
                            applyAttributesFilter(gAttribute, gAttributeType,'',false);
                        }
                    }
                    applyFilterEvents({ eventEmitter: gEventEmitter });
                    setDiagramVisualizer();
                    setAction_Visualizer({ eventEmitter: gEventEmitter });
                },
            },   
        ]

        let contextMenu = tasks
        contextMenu = contextMenu.concat(events)
        contextMenu = contextMenu.concat(filterAttributes)
        return contextMenu
    };


    const getNodeContextMenuOptionsStep = ({ data: { task_str, attribute_array , step, from, to, from_label, to_label} }) => {  

        let tasks = [
            {
                text: getEntityUpper() + 's',
                subMenuOptions: [
                    {
                        text: 'Detail',
                        event: () => {
                            gDetailSource = 'ia_node';
                            for (let i = 0; i < attribute_array.length; i++) {
                                attribute_array[i].id = attribute_array[i].id1; // bug in Go.JS storage of array in node
                            }
                            gClusterAttributeArray = attribute_array;
                            gTaskStr = task_str;
                            taskDetailModal()
                        },
                    },
                    {
                        text: 'History',
                        event: () => {
                            gTasksVisualizationSource = 'ia_node';
                            gClusterAttributeArray = attribute_array;
                            gTaskStr = task_str;
                            processAnalytics(0, 0, 0, 0, 0, '' ,'Influence Node', 'Influencer Node', getEntityUpper() + 's','ia_node')
                        },
                    },
                    {
                        text: 'Histogram',
                        event: () => {
                            gTasksVisualizationSource = 'ia_node';
                            gClusterAttributeArray = attribute_array;
                            gTaskStr = task_str;
                            generateHistogramArray('influencers',true,0,0,0,0)
                            histogramModal()
                        },
                    },
                    {
                        text: 'LifeCycle',
                        event: () => {
                            gTasksVisualizationSource = 'ia_node';
                            gClusterAttributeArray = attribute_array;
                            gTaskStr = task_str;
                            updateNodeTaskArrayforTaskLifecyle();
                            tasksVisualization();
                            taskLifecycleModal()
                        },
                    },
                    {
                        text: 'Activity Analysis',  
                        event: () => {
                            gTaskStr = task_str;
                            generateTasksFilteredArray('ia_node', true, 0, 0, 0, 0, 0);
                            setAction_Time({ eventEmitter: gEventEmitter });
                        },
                    },    

                ]
            }
        ]

        let events = [
        {
            text: 'Events',
            subMenuOptions: [
                
                {
                    text: 'Detail',
                    event: () => {
                        gDetailSource = 'ia_node';
                        for (let i = 0; i < attribute_array.length; i++) {
                            attribute_array[i].id = attribute_array[i].id1; // bug in Go.JS storage of array in node
                        }
                        gClusterAttributeArray = attribute_array;
                        gTaskStr = task_str;
                        eventDetailModal();
                    },
                },
            ],
        }]

        let filterAttributes = [
            {
                text: 'Filter (attributes)',
                event: () => {
                    if (gFilters.length > 0) {
                        resetFilters(false);
                    }
                    for (let i = 0; i < attribute_array.length; i++) {
                        if (attribute_array[i].field != 'step') {
                            gAttribute = attribute_array[i].field;
                            gAttributeType = gEntityUpper
                            let vtp = [];
                            vtp['value'] = attribute_array[i].value;
                            gSelectedAttributes = [];
                            gSelectedAttributes.push(vtp);
                            applyAttributesFilter(gAttribute, gAttributeType,'',false);
                        }
                    }
                    applyFilterEvents({ eventEmitter: gEventEmitter });
                    setDiagramVisualizer();
                    setAction_Visualizer({ eventEmitter: gEventEmitter });
                },
            },
        ]

        let contextMenu = []
        contextMenu = contextMenu.concat(tasks)
        contextMenu = contextMenu.concat(events)
        contextMenu = contextMenu.concat(filterAttributes)
        return contextMenu

    };

    let contextMenuObj = null;
    const contextMenuInfluenceAnalysis = $(go.HTMLInfo, {
        show: (obj, diagram) => {
            const { x, y } = diagram.lastInput.viewPoint;
            let options
            if (gInfluenceAnalysisSteps == false ) {
                options = obj.part instanceof go.Node ? getNodeContextMenuOptions(obj) : '';
            } else {
                options = obj.part instanceof go.Node ? getNodeContextMenuOptionsStep(obj) : '';
            }
            contextMenuObj = obj;
            showContextMenu({ gEventEmitter, x, y, options });
        },
        hide: (diagram) => {
            contextMenuObj = null;
            hideContextMenu({ gEventEmitter });
        },
    });

    gDiagramInfluenceAnalysis.nodeTemplate = $(
        go.Node,
        'Auto',
        { isShadowed: true, contextMenu: contextMenuInfluenceAnalysis },
        new go.Binding('location', 'loc', go.Point.parse).makeTwoWay(go.Point.stringify),
        $(
            go.Shape,
            { stroke: 'lightgray', strokeWidth: 1 },
            new go.Binding('figure', 'fig'),
            new go.Binding('width', 'width'),
            new go.Binding('height', 'height'),
            new go.Binding('fill', 'color')
        ),
        $(
            go.Panel,
            'Vertical',
            
            $(
                go.TextBlock,
                { visible: false }, 
                { margin: 2, textAlign: 'start', stroke: '#0B66E4', font: 'bold 9pt system-ui', maxSize: new go.Size(320, NaN) },
                new go.Binding('text', 'step'),
                new go.Binding('visible', 'step_visible')
            ),
            $(
                go.TextBlock, 
                { margin: 1, textAlign: 'start',  font: '9pt system-ui', maxSize: new go.Size(320, NaN) },
                new go.Binding('stroke', 'stroke'),
                new go.Binding('text', 'text')
            )
        )
    );

    gDiagramInfluenceAnalysis.linkTemplate = $(
        'Link',
        $('Shape', { stroke: '#0B66E4', strokeWidth: 2 }),
        $('Shape', { fill: '#0B66E4', stroke: null, toArrow: 'Triangle' })
    );
}


export function updateDiagramInfluenceAnalysis(source,activity) { 
    //if (gInfluenceAnalysisAttributes.length == 0) {return}
    let influenceNodes = 20;

    let duration_mins = 0;
    let duration_hrs = 0;
    let duration_days = 0;
    let cost_savings = 0;
    let actual_cost = 0;
    let actual_cost_savings = 0;
    let customer_comments = 0
    let internal_comments = 0
    let worklogs = 0
    let time_spent = 0

    for (let i = 0; i < gTasksFilteredArray.length; i++) {
        duration_mins = duration_mins + gTasksFilteredArray[i].d / 60;
        duration_hrs = duration_hrs + gTasksFilteredArray[i].d / 3600;
        duration_days = duration_days + gTasksFilteredArray[i].d / 86400;
        cost_savings = cost_savings + (gTasksFilteredArray[i].actual_cost - gTasksFilteredArray[i].forecast_cost);
        actual_cost = actual_cost + gTasksFilteredArray[i].actual_cost;
        actual_cost_savings = actual_cost_savings + (gTasksFilteredArray[i].actual_cost - gTasksFilteredArray[i].forecast_cost);

    }
    let avg_cost = actual_cost / gTasksFilteredArray.length;
    let avg_cost_savings = actual_cost_savings / gTasksFilteredArray.length;

    let avg_duration_mins = duration_mins / gTasksFilteredArray.length;
    let avg_duration_hrs = duration_hrs / gTasksFilteredArray.length;
    let avg_duration_days = duration_days / gTasksFilteredArray.length;

    const f = (A, i = 0) => (i == A.length ? [[]] : f(A, i + 1).flatMap((x) => [x, [A[i]].concat(x)]));
    let attributeCombinations = f(gInfluenceAnalysisAttributes);
    let attributeInfluencers = [];
    attributeInfluencers = [];
    let tempArray = [];
    let vtp = [];
    let i = 1; 
    for (i = 1; i < attributeCombinations.length; i++) {
        tempArray = TaskAttributeAnalysis(attributeCombinations[i], gClusterMetric, gInfluenceAnalysisSteps, source);
        for (let j = 0; j < tempArray.length; j++) {
            vtp = {};
            vtp['attribute_str'] = tempArray[j].attribute_str;
            vtp['step'] = tempArray[j].step
            if (gInfluenceAnalysisSteps == true) {vtp['step_visible'] = true} else {vtp['step_visible'] = false}
            vtp['from'] = tempArray[j].from
            vtp['to'] = tempArray[j].to
            vtp['from_label'] = tempArray[j].from_label
            vtp['to_label'] = tempArray[j].to_label
            vtp['attribute_array'] = tempArray[j].attribute_array;
            vtp['attributes'] = tempArray[j].attributes;
            vtp['tasks'] = tempArray[j].tasks;
            vtp['task_str'] = tempArray[j].taskID;
            //vtp['task_str'] = "abcdef^asdasd"
            vtp['duration'] = tempArray[j].duration;
            vtp['actual_cost'] = tempArray[j].actual_cost;
            vtp['forecast_cost'] = tempArray[j].forecast_cost;
            vtp['avg_duration_mins'] = tempArray[j].duration / tempArray[j].tasks / 60;
            vtp['avg_duration_hrs'] = tempArray[j].duration / tempArray[j].tasks / 3600;
            vtp['avg_duration_days'] = tempArray[j].duration / tempArray[j].tasks / 86400;
            vtp['total_cost'] = tempArray[j].actual_cost;
            vtp['avg_cost'] = tempArray[j].actual_cost / tempArray[j].tasks;
            vtp['avg_cost_savings'] = (tempArray[j].actual_cost - tempArray[j].forecast_cost) / tempArray[j].tasks;
            attributeInfluencers.push(vtp);
        }
    }

    // remove duplicate combinations
    /*
    attributeInfluencers.sort((a, b) => a.task_str.localeCompare(b.task_str) || a.attributes - b.attributes);
    let task_str = '';
    for (let i = 0; i < attributeInfluencers.length; i++) {
        if (i > 0 && task_str == attributeInfluencers[i].task_str) {
            attributeInfluencers.splice(i, 1);
            i--;
        }
        task_str = attributeInfluencers[i].task_str;
    }
    if (i > 0 && task_str == attributeInfluencers[attributeInfluencers.length - 1].task_str) {
        attributeInfluencers.splice(i, 1);
    }
    */

    let influenceResults = [];
    vtp = [];
    if (gInfluenceAnalysisMetric == 2) {
        // Duration (mins)
        if (gInfluenceAnalysisInfluence == 'increase') {
            attributeInfluencers.sort((a, b) => b.avg_duration_mins - a.avg_duration_mins);
        } else {
            attributeInfluencers.sort((a, b) => a.avg_duration_mins - b.avg_duration_mins);
        }
        for (let i = 0; i < attributeInfluencers.length; i++) {
            if (
                attributeInfluencers[i].tasks >= gInfluenceAnalysisMinTasks &&
                attributeInfluencers[i].tasks <= gInfluenceAnalysisMaxTasks &&
                attributeInfluencers[i].avg_duration_mins >= gInfluenceAnalysisMinMetric &&
                attributeInfluencers[i].avg_duration_mins <= gInfluenceAnalysisMaxMetric
            ) {
                vtp = [];
                vtp['attribute_str'] = attributeInfluencers[i].attribute_str;
                vtp['attribute_array'] = attributeInfluencers[i].attribute_array;
                vtp['step'] = attributeInfluencers[i].step
                if (gInfluenceAnalysisSteps == true) {vtp['step_visible'] = true} else {vtp['step_visible'] = false}
                vtp['from'] = attributeInfluencers[i].from
                vtp['to'] = attributeInfluencers[i].to
                vtp['from_label'] = attributeInfluencers[i].from_label
                vtp['to_label'] = attributeInfluencers[i].to_label
                vtp['value'] = attributeInfluencers[i].avg_duration_mins;
                vtp['average'] = avg_duration_mins;
                vtp['tasks'] = attributeInfluencers[i].tasks;
                vtp['total_tasks'] = gTasksFilteredArray.length;
                vtp['task_str'] = attributeInfluencers[i].task_str;
                vtp['difference'] = attributeInfluencers[i].avg_duration_mins - avg_duration_mins;
                influenceResults.push(vtp);
            }
        }
    }
    if (gInfluenceAnalysisMetric == 3) {
        // Duration (hrs)
        if (gInfluenceAnalysisInfluence == 'increase') {
            attributeInfluencers.sort((a, b) => b.avg_duration_hrs - a.avg_duration_hrs);
        } else {
            attributeInfluencers.sort((a, b) => a.avg_duration_hrs - b.avg_duration_hrs);
        }
        for (let i = 0; i < attributeInfluencers.length; i++) {
            if (
                attributeInfluencers[i].tasks >= gInfluenceAnalysisMinTasks &&
                attributeInfluencers[i].tasks <= gInfluenceAnalysisMaxTasks &&
                attributeInfluencers[i].avg_duration_hrs >= gInfluenceAnalysisMinMetric &&
                attributeInfluencers[i].avg_duration_hrs <= gInfluenceAnalysisMaxMetric
            ) {
                vtp = [];
                vtp['attribute_str'] = attributeInfluencers[i].attribute_str;
                vtp['attribute_array'] = attributeInfluencers[i].attribute_array;
                vtp['step'] = attributeInfluencers[i].step
                if (gInfluenceAnalysisSteps == true) {vtp['step_visible'] = true} else {vtp['step_visible'] = false}
                vtp['from'] = attributeInfluencers[i].from
                vtp['to'] = attributeInfluencers[i].to
                vtp['from_label'] = attributeInfluencers[i].from_label
                vtp['to_label'] = attributeInfluencers[i].to_label
                vtp['value'] = attributeInfluencers[i].avg_duration_hrs;
                vtp['average'] = avg_duration_hrs;
                vtp['tasks'] = attributeInfluencers[i].tasks;
                vtp['total_tasks'] = gTasksFilteredArray.length;
                vtp['task_str'] = attributeInfluencers[i].task_str;
                influenceResults.push(vtp);
            }
        }
    }
    if (gInfluenceAnalysisMetric == 4) {
        // Duration (days)
        if (gInfluenceAnalysisInfluence == 'increase') {
            attributeInfluencers.sort((a, b) => b.avg_duration_days - a.avg_duration_days);
        } else {
            attributeInfluencers.sort((a, b) => a.avg_duration_days - b.avg_duration_days);
        }
        for (let i = 0; i < attributeInfluencers.length; i++) {
            if (
                attributeInfluencers[i].tasks >= gInfluenceAnalysisMinTasks &&
                attributeInfluencers[i].tasks <= gInfluenceAnalysisMaxTasks &&
                attributeInfluencers[i].avg_duration_days >= gInfluenceAnalysisMinMetric &&
                attributeInfluencers[i].avg_duration_days <= gInfluenceAnalysisMaxMetric
            ) {
                vtp = [];
                vtp['attribute_str'] = attributeInfluencers[i].attribute_str;
                vtp['attribute_array'] = attributeInfluencers[i].attribute_array;
                vtp['step'] = attributeInfluencers[i].step
                if (gInfluenceAnalysisSteps == true) {vtp['step_visible'] = true} else {vtp['step_visible'] = false}
                vtp['from'] = attributeInfluencers[i].from
                vtp['to'] = attributeInfluencers[i].to
                vtp['from_label'] = attributeInfluencers[i].from_label
                vtp['to_label'] = attributeInfluencers[i].to_label
                vtp['value'] = attributeInfluencers[i].avg_duration_days;
                vtp['average'] = avg_duration_days;
                vtp['tasks'] = attributeInfluencers[i].tasks;
                vtp['total_tasks'] = gTasksFilteredArray.length;
                vtp['task_str'] = attributeInfluencers[i].task_str;
                influenceResults.push(vtp);
            }
        }
    }
    if (gInfluenceAnalysisMetric == 6) {
        // avg cost
        if (gInfluenceAnalysisInfluence == 'increase') {
            attributeInfluencers.sort((a, b) => b.avg_cost - a.avg_cost);
        } else {
            attributeInfluencers.sort((a, b) => a.avg_cost - b.avg_cost);
        }
        for (let i = 0; i < attributeInfluencers.length; i++) {
            if (
                attributeInfluencers[i].tasks >= gInfluenceAnalysisMinTasks &&
                attributeInfluencers[i].tasks <= gInfluenceAnalysisMaxTasks &&
                attributeInfluencers[i].avg_cost >= gInfluenceAnalysisMinMetric &&
                attributeInfluencers[i].avg_cost <= gInfluenceAnalysisMaxMetric
            ) {
                vtp = [];
                vtp['attribute_str'] = attributeInfluencers[i].attribute_str;
                vtp['attribute_array'] = attributeInfluencers[i].attribute_array;
                vtp['step'] = attributeInfluencers[i].step
                if (gInfluenceAnalysisSteps == true) {vtp['step_visible'] = true} else {vtp['step_visible'] = false}
                vtp['from'] = attributeInfluencers[i].from
                vtp['to'] = attributeInfluencers[i].to
                vtp['from_label'] = attributeInfluencers[i].from_label
                vtp['to_label'] = attributeInfluencers[i].to_label
                vtp['value'] = attributeInfluencers[i].avg_cost;
                vtp['average'] = avg_cost;
                vtp['tasks'] = attributeInfluencers[i].tasks;
                vtp['total_tasks'] = gTasksFilteredArray.length;
                vtp['task_str'] = attributeInfluencers[i].task_str;
                influenceResults.push(vtp);
            }
        }
    }
    if (gInfluenceAnalysisMetric == 7) {
        // avg cost savings
        if (gInfluenceAnalysisInfluence == 'increase') {
            attributeInfluencers.sort((a, b) => b.avg_cost - a.avg_cost);
        } else {
            attributeInfluencers.sort((a, b) => a.avg_cost - b.avg_cost);
        }
        for (let i = 0; i < attributeInfluencers.length; i++) {
            if (
                attributeInfluencers[i].tasks >= gInfluenceAnalysisMinTasks &&
                attributeInfluencers[i].tasks <= gInfluenceAnalysisMaxTasks &&
                attributeInfluencers[i].avg_cost_savings >= gInfluenceAnalysisMinMetric &&
                attributeInfluencers[i].avg_cost_savings <= gInfluenceAnalysisMaxMetric
            ) {
                vtp = [];
                vtp['attribute_str'] = attributeInfluencers[i].attribute_str;
                vtp['attribute_array'] = attributeInfluencers[i].attribute_array;
                vtp['step'] = attributeInfluencers[i].step
                if (gInfluenceAnalysisSteps == true) {vtp['step_visible'] = true} else {vtp['step_visible'] = false}
                vtp['from'] = attributeInfluencers[i].from
                vtp['to'] = attributeInfluencers[i].to
                vtp['from_label'] = attributeInfluencers[i].from_label
                vtp['to_label'] = attributeInfluencers[i].to_label
                vtp['value'] = attributeInfluencers[i].avg_cost_savings;
                vtp['average'] = avg_cost_savings;
                vtp['tasks'] = attributeInfluencers[i].tasks;
                vtp['total_tasks'] = gTasksFilteredArray.length;
                vtp['task_str'] = attributeInfluencers[i].task_str;
                influenceResults.push(vtp);
            }
        }
    }
    if (gInfluenceAnalysisMetric == 8) {
        // compliance
        if (gInfluenceAnalysisInfluence == 'increase') {
            attributeInfluencers.sort((a, b) => b.avg_compliance - a.avg_compliance);
        } else {
            attributeInfluencers.sort((a, b) => a.avg_compliance - b.avg_compliance);
        }
        for (let i = 0; i < attributeInfluencers.length; i++) {
            if (
                attributeInfluencers[i].tasks >= gInfluenceAnalysisMinTasks &&
                attributeInfluencers[i].tasks <= gInfluenceAnalysisMaxTasks &&
                attributeInfluencers[i].avg_compliance >= gInfluenceAnalysisMinMetric / 100 &&
                attributeInfluencers[i].avg_compliance <= gInfluenceAnalysisMaxMetric / 100
            ) {
                vtp = [];
                vtp['attribute_str'] = attributeInfluencers[i].attribute_str;
                vtp['attribute_array'] = attributeInfluencers[i].attribute_array;
                vtp['step'] = attributeInfluencers[i].step
                if (gInfluenceAnalysisSteps == true) {vtp['step_visible'] = true} else {vtp['step_visible'] = false}
                vtp['from'] = attributeInfluencers[i].from
                vtp['to'] = attributeInfluencers[i].to
                vtp['from_label'] = attributeInfluencers[i].from_label
                vtp['to_label'] = attributeInfluencers[i].to_label
                vtp['value'] = attributeInfluencers[i].avg_compliance;
                vtp['average'] = avg_compliance;
                vtp['tasks'] = attributeInfluencers[i].tasks;
                vtp['total_tasks'] = gTasksFilteredArray.length;
                vtp['task_str'] = attributeInfluencers[i].task_str;
                influenceResults.push(vtp);
            }
        }
    }

    if (gInfluenceAnalysisInfluence == 'increase') {
        influenceResults.sort((a, b) => b.value - a.value);
    } else {
        influenceResults.sort((a, b) => a.value - b.value);
    }
    let influenceRows = [];
    for (let i = 0; i < influenceNodes; i++) {
        if (i < influenceResults.length) {
            influenceRows.push(influenceResults[i]);
        }
    }
   influenceDiagram(influenceRows);

}

function influenceDiagram(influenceRows) {
    const greenArr = new Gradient().setColorGradient('#1C8B2F', '94F793').setMidpoint(influenceRows.length).getColors();
    let metric = metricStr(gInfluenceAnalysisMetric);
    let nodeDataArray = [];
    let linkDataArray = [];
    let spacingStart = 0;
    let spacing = 80;

    let locXAttribute = -350;
    let locXValueMax = 300;
    let maxValue = 0;
    let minValue = 999999999;
    let key = 1;
    for (let j = 0; j < influenceRows.length; j++) {
        if (influenceRows[j].value > maxValue) {
            maxValue = influenceRows[j].value;
        }
        if (influenceRows[j].value < minValue) {
            minValue = influenceRows[j].value;
        }

        let loc = locXAttribute + ' ' + (spacingStart + j * spacing);

        let vtp = [];
        vtp['key'] = key;
        vtp['color'] = 'white';
        vtp['loc'] = loc;
        vtp['stroke'] = '#000000';
        vtp['fig'] = 'Border';
        vtp['width'] = 330;
        vtp['height'] = 50;
        vtp['text'] = influenceRows[j].attribute_str;
        vtp['step'] = influenceRows[j].step
        vtp['step_visible'] = influenceRows[j].step_visible
        vtp['from'] = influenceRows[j].from
        vtp['to'] = influenceRows[j].to
        vtp['from_label'] = influenceRows[j].from_label
        vtp['to_label'] = influenceRows[j].to_label
        vtp['attribute_array'] = influenceRows[j].attribute_array;
        vtp['fill'] = greenArr[j];
        vtp['task_str'] = influenceRows[j].task_str;
        nodeDataArray.push(vtp);

        vtp = [];
        vtp['from'] = key;
        vtp['to'] = key + 1;
        linkDataArray.push(vtp);

        key = key + 2;
    }

    key = 2;
    for (let j = 0; j < influenceRows.length; j++) {
        let value = '';
        if (gInfluenceAnalysisMetric == 2 || gInfluenceAnalysisMetric == 3 || gInfluenceAnalysisMetric == 4) {
            value = formatDecimal(influenceRows[j].value, 2);
        }
        if (gInfluenceAnalysisMetric == 6 || gInfluenceAnalysisMetric == 7) {
            value = formatCostDecimal(influenceRows[j].value);
        }
        if (gInfluenceAnalysisMetric == 8) {
            value = formatPercentage(influenceRows[j].value);
        }

        let ratio = locXValueMax - ((maxValue - influenceRows[j].value) / (maxValue - minValue)) * locXValueMax;
        if (!ratio && ratio != 0) {
            ratio = locXValueMax;
        }
        let loc = ratio + ' ' + (spacingStart + j * spacing);

        let average = 0;
        if (influenceRows[j].value != 0) {
            average = (influenceRows[j].value - influenceRows[j].average) / influenceRows[j].value;
        }
        let directionText = ' above average';
        if (average < 0) {
            directionText = ' below average';
            average = Math.abs(average)
        }
        let nodeText =
            metric +
            ': ' +
            value +
            '\r\n' +
            formatPercentage(average, 1) +
            directionText +
            '\r\n' +
            numberWithCommas(influenceRows[j].tasks) +
            ' - ' +
            formatPercentage(influenceRows[j].tasks / influenceRows[j].total_tasks, 1) +
            ' of ' +
            gEntityLower +
            's';

        let vtp = [];
        vtp['key'] = key;
        vtp['color'] = '#0B66E4';
        vtp['loc'] = loc;
        vtp['fig'] = 'RoundedRectangle';
        vtp['stroke'] = 'white';
        vtp['width'] = 150;
        vtp['height'] = 50;
        vtp['text'] = nodeText;
        vtp['fill'] = greenArr[j];
        vtp['step'] = influenceRows[j].step
        vtp['step_visible'] = false
        vtp['from'] = influenceRows[j].from
        vtp['to'] = influenceRows[j].to
        vtp['from_label'] = influenceRows[j].from_label
        vtp['to_label'] = influenceRows[j].to_label

        vtp['attribute_array'] = influenceRows[j].attribute_array;
        vtp['task_str'] = influenceRows[j].task_str;
        nodeDataArray.push(vtp);
        key = key + 2;
    }
    gDiagramInfluenceAnalysis.model.nodeDataArray = nodeDataArray;  
    gDiagramInfluenceAnalysis.model.linkDataArray = linkDataArray;
}

function TaskAttributeAnalysis(attributes, metricID, includeSteps, source) {   

    if (source != '') gAnalysisSource = source
    attributes = canonicalizeTaskAttributeSelections(attributes);
    let clusterAttributes = [];
    for (let i = 0; i < attributes.length; i++) {
        const matched = resolveTaskAttribute(attributes[i]);
        if (matched && clusterAttributes.indexOf(matched) === -1) clusterAttributes.push(matched);
    }
    if (attributes.length === 0 || clusterAttributes.length !== attributes.length) return [];

    let vtp = [];
    let arr;
    let result;
    if (includeSteps === false ) {
        let tempTasks = [];
        let index = 0;
    
        for (let i = 0; i < gTasksFilteredArray.length; i++) {
            vtp = [];
            let attributeStr = '';
            for (let j = 0; j < clusterAttributes.length; j++) {
                index = clusterAttributes[j].id;
                vtp[index] = gTasksFilteredArray[i][index];
                if (j > 0) attributeStr = attributeStr + ', ';
                let field = ''
                if (clusterAttributes[j].schema === 'array' || clusterAttributes[j].schema == 'stagil_asset_forge') field = gTasksFilteredArray[i][index].replaceAll('^^',',')
                else field = gTasksFilteredArray[i][index]

                attributeStr = attributeStr + displayTaskAttributeName(clusterAttributes[j]) + " is '" + field + "'";
            }
            vtp['step'] = '';
            vtp['from'] = ''; 
            vtp['to'] = ''; 
            vtp['from_label'] = ''; 
            vtp['to_label'] = ''; 
            vtp['attribute_str'] = attributeStr;
            vtp['task'] = gTasksFilteredArray[i].k;
            vtp['taskID'] = gTasksFilteredArray[i].id.toString();
            vtp['tasks'] = 1;
            vtp['duration'] = gTasksFilteredArray[i].d;
            vtp['actual_cost'] = gTasksFilteredArray[i].actual_cost;
            vtp['forecast_cost'] = gTasksFilteredArray[i].forecast_cost;

            let customer_comments = 0;
            let internal_comments = 0;
            let worklogs = 0
            let time_spent = 0

            let comments = gTasksFilteredArray[i].comments  
            let worklog = gTasksFilteredArray[i].worklog
            if (comments !== undefined && comments[0] !== undefined) {
                for (let c = 0; c < comments.length; c++) {
                    if (comments[c].jsdPublic === 'true') customer_comments ++
                    else internal_comments ++
                }
            }
            if (worklog !== undefined  && worklog[0] !== undefined) {
                for (let w = 0; w < worklog.length; w++) {
                    worklogs ++
                    time_spent = time_spent + parseInt(worklog[w].timeSpentSeconds)  
                }         
            }
            vtp['customer_comments'] = customer_comments;
            vtp['internal_comments'] = internal_comments;
            vtp['worklogs'] = worklogs;
            vtp['time_spent'] = time_spent;

            tempTasks.push(vtp);
        }
        arr = tempTasks;

        let helper = {};
        result = arr.reduce(function (r, o) {

            let key = '';
            for (let j = 0; j < clusterAttributes.length; j++) {
                index = clusterAttributes[j].id;
                if (key !== '') key = key + '-' 
                key =  key + o[index]
            }

            if (!helper[key]) {
                helper[key] = Object.assign({}, o);
                helper[key]['attributes'] = attributes.length;
                r.push(helper[key]);
            } else {
                helper[key]['tasks'] += o['tasks'];
                helper[key]['duration'] += o['duration'];
                helper[key]['actual_cost'] += o['actual_cost'];
                helper[key]['forecast_cost'] += o['forecast_cost'];
                helper[key]['customer_comments'] += o['customer_comments'];
                helper[key]['internal_comments'] += o['internal_comments'];
                helper[key]['worklogs'] += o['worklogs'];
                helper[key]['time_spent'] += o['time_spent'];
                helper[key]['taskID'] = helper[key]['taskID'] + '^' + o['taskID'];
            }
            return r;
        }, []);
        let attributeArray = [];

        vtp = [];
        for (let i = 0; i < result.length; i++) {
            attributeArray = [];
            for (let j = 0; j < clusterAttributes.length; j++) {
                vtp = [];
                vtp['field'] = clusterAttributes[j].field;
                vtp['value'] = result[i][clusterAttributes[j].id];
                attributeArray.push(vtp);
            }
            result[i].attribute_array = attributeArray;
        }
    } else {
        let tempEvents = [];
        let index = 0;
        gEventLogArray = gEventLogArray.sort((a, b) => a.elid - b.elid);
        gStepArray = gStepArray.sort((a, b) => a.id - b.id);
        let i = 0;
        for (i = 0; i < gTasksFilteredArray.length; i++) {

            for (let f = gTasksFilteredArray[i].si; f < gTasksFilteredArray[i].fi + 1; f++) {

                let validEvent = true
                if ((gAnalysisSource === 'tia' && gEventLogArray[f].t != gTimeActivity) || gEventLogArray[f].filtered === 1 ) validEvent = false
                if (validEvent === true) {
                    vtp = [];
                    let attributeStr = '';
                    for (let j = 0; j < clusterAttributes.length; j++) {
                        index = clusterAttributes[j].id;
    
                        vtp[index] = gEventLogArray[f][index];
                        if (j > 0) attributeStr = attributeStr + ', '
                        attributeStr = attributeStr + displayTaskAttributeName(clusterAttributes[j]) + " is '" + gEventLogArray[f][index] + "'";
                    }
                    vtp['step'] = gStepArray[gEventLogArray[f].sid].step;
                    vtp['from'] = gStepArray[gEventLogArray[f].sid].from; 
                    vtp['to'] = gStepArray[gEventLogArray[f].sid].to; 
                    vtp['from_label'] = gStepArray[gEventLogArray[f].sid].from_label; 
                    vtp['to_label'] = gStepArray[gEventLogArray[f].sid].to_label; 
                    vtp['attribute_str'] = attributeStr;
                    vtp['task'] = gEventLogArray[f].k;
                    vtp['taskID'] = gEventLogArray[f].tid.toString();
                    vtp['tasks'] = 1;
                    vtp['duration'] = gEventLogArray[f].d;
                    vtp['actual_cost'] = gEventLogArray[f].actual_cost;
                    vtp['forecast_cost'] = gEventLogArray[f].forecast_cost;


                    let customer_comments = 0;
                    let internal_comments = 0;
                    let worklogs = 0
                    let time_spent = 0
                    let comments = gEventLogArray[f].comments  
                    let worklog = gEventLogArray[f].worklog
                    if (comments !== undefined) {
                        for (let c = 0; c < comments.length; c++) {
                            if (comments[c].jsdPublic === 'true') customer_comments ++
                            else internal_comments ++
                        }
                    }
                    if (worklog !== undefined) {
                        for (let w = 0; w < worklog.length; w++) {
                            worklogs ++
                            time_spent = time_spent + parseInt(worklog[w].timeSpentSeconds)  
                        }         
                    }
                    vtp['customer_comments'] = customer_comments;
                    vtp['internal_comments'] = internal_comments;
                    vtp['worklogs'] = worklogs;
                    vtp['time_spent'] = time_spent;

                    tempEvents.push(vtp);
                }
            }
        }

        let helper = {};
        arr = tempEvents;
        result = arr.reduce(function (r, o) {
            const key =
                o.step + '-' + o.ta0 + '-' + o.ta1 + '-' + o.ta2 + '-' + o.ta3 + '-' + o.ta4 + '-' + o.ta5 + '-' + o.ta6 + '-' + o.ta7 + '-' + o.ta8 + '-' + o.ta9;
                o.step0 + ' - ' + o.ta00 + '-' + o.ta01 + '-' + o.ta02 + '-' + o.ta03 + '-' + o.ta04 + '-' + o.ta05 + '-' + o.ta06 + '-' + o.ta07 + '-' + o.ta08 + '-' + o.ta09;
            if (!helper[key]) {
                helper[key] = Object.assign({}, o);
                helper[key]['attributes'] = attributes.length;
                r.push(helper[key]);
            } else {
                helper[key]['tasks'] += o['tasks'];
                helper[key]['duration'] += o['duration'];
                helper[key]['actual_cost'] += o['actual_cost'];
                helper[key]['forecast_cost'] += o['forecast_cost'];
                helper[key]['customer_comments'] += o['customer_comments'];
                helper[key]['internal_comments'] += o['internal_comments'];
                helper[key]['worklogs'] += o['worklogs'];
                helper[key]['time_spent'] += o['time_spent'];                
                helper[key]['taskID'] = helper[key]['taskID'] + '^' + o['taskID'];
            }
            return r;
        }, []);
        let attributeArray = [];
        vtp = [];
        for (let i = 0; i < result.length; i++) {
            attributeArray = [];
            for (let j = 0; j < clusterAttributes.length; j++) {
                vtp = [];
                vtp['field'] = clusterAttributes[j].field;
                vtp['value'] = result[i][clusterAttributes[j].id];
                attributeArray.push(vtp);
            }
            vtp = [];
            vtp['field'] = 'Step';
            vtp['value'] = result[i].step;
            attributeArray.push(vtp);

            result[i].attribute_array = attributeArray;
        }        
    }
    return result;
}

function metricStr(metricNumber) {
    let metric = '';
    if (metricNumber == 1) metric = gEntityUpper + 's';
    if (metricNumber == 2) metric = 'Duration (mins)';
    if (metricNumber == 3) metric = 'Duration (hrs)';
    if (metricNumber == 4) metric = 'Duration (days)';
    if (metricNumber == 5) metric = 'Total Cost';
    if (metricNumber == 6) metric = 'Avg Cost';
    if (metricNumber == 7) metric = 'Avg Cost Savings';
    if (metricNumber == 10) metric = 'Customer Comments';
    if (metricNumber == 11) metric = 'Internal Comments';
    if (metricNumber == 12) metric = 'Worklogs';
    if (metricNumber == 13) metric = 'Avg TimeSpent (mins)';
    if (metricNumber == 14) metric = 'Total Time Spent (mins)';

    return metric;
}

function getCombinations(array) {
    const result = [];
 
    function recurse(cur, rem) {
       if (rem.length === 0) {
       result.push(cur);
       } else {
          for (let i = 0; i < rem.length; i++) {
             recurse([...cur, rem[i]], rem.slice(i + 1));
          }
       }
    }
    recurse([], array);
    return result;
}


export function updateDiagramCluster(source) { 
    if (gClusterAttributes.length === 0) {
      const tOptions = taskAttributes()
      for (var i = 0; i < tOptions.length; i++) {
          gClusterAttributes.push(tOptions[i].value)
      }
    }

    let combinations = getCombinations(gClusterAttributes)
    let result = []
    for (let i = 0; i < combinations.length; i++) { 
        if (!combinations[i] || combinations[i].length === 0) continue;
        result = result.concat(TaskAttributeAnalysis(combinations[i], gClusterMetric, gClusterAnalysisSteps, source))
    }
    let attributes = canonicalizeTaskAttributeSelections(gClusterAttributes);
    gClusterAttributes = attributes;
    let clusterAttributes = [];
    if (gClusterAnalysisSteps == true) {
        let vtp = [];
        vtp['id'] = 'step'
        vtp['field'] = 'Step'
        clusterAttributes.push(vtp)
    }
    for (let i = 0; i < attributes.length; i++) {
        const matched = resolveTaskAttribute(attributes[i]);
        if (matched && clusterAttributes.indexOf(matched) === -1) clusterAttributes.push(matched);
    }

    let total_tasks = gTasksFilteredArray.length
    let metric = metricStr(gClusterMetric)
    let rows = gClusterRows;
    let minMetric = gClusterMinMetric;
    let maxMetric = gClusterMaxMetric;
    if (gClusterMetric === 8) {
        minMetric = minMetric / 100;
        maxMetric = maxMetric / 100;
    }

    for (let i = 0; i < result.length; i++) {
        result[i][gEntityUpper + 's'] = result[i].tasks;

        result[i]['Duration (mins)'] = result[i].duration / 60 / result[i].tasks;
        result[i]['Duration (hrs)'] = result[i].duration / 3600 / result[i].tasks;
        result[i]['Duration (days)'] = result[i].duration / 86400 / result[i].tasks;
        result[i]['Total Cost'] = result[i].actual_cost;
        result[i]['Avg Cost'] = result[i].actual_cost / result[i].tasks;
        result[i]['Avg Cost Savings'] = (result[i].actual_cost - result[i].forecast_cost) / result[i].tasks;
        result[i]['Customer Comments'] = result[i].customer_comments
        result[i]['Internal Comments'] = result[i].internal_comments
        result[i]['Worklogs'] = result[i].worklogs
        result[i]['Avg TimeSpent (mins)'] = result[i].time_spent/ 60 / result[i].tasks
        result[i]['Total Time Spent (mins)']  = result[i].time_spent/60
        
        let splice = false;
        if (result[i][metric] < minMetric) {
            result.splice(i, 1);
            splice = true;
            i--;
        } else {
            if (result[i][metric] > maxMetric) {
                result.splice(i, 1);
                splice = true;
                i--;
            }
        }
        if (splice === false) {
            if (result[i].tasks < gClusterMinTasks) {
                result.splice(i, 1);
                splice = true;
                i--;
            } else {
                if (result[i].tasks > gClusterMaxTasks) {
                    result.splice(i, 1);
                    splice = true;
                    i--;
                }
            }
        }
    }
    if (gClusterValueType === 'high') {
        result.sort((a, b) => b[metric] - a[metric]);
    } else {
        result.sort((a, b) => a[metric] - b[metric]);
    }
    let tempArray = result.slice(0, rows);

    let nodeDataArray = [{ key: 0, visible: false, name: '' }];
    let key = 1;

    let tempMin = 999999999999999.99
    let tempMax = 0.00
    for (let j = 0; j < tempArray.length; j++) {
        if (gClusterMetric === 1)  {
            if (tempMin > tempArray[j].tasks ) tempMin = tempArray[j].tasks
            if (tempMax < tempArray[j].tasks ) tempMax = tempArray[j].tasks
        }
        if (gClusterMetric == 2 || gClusterMetric == 3 || gClusterMetric == 4) {
            if (tempMin > (tempArray[j].duration/tempArray[j].tasks) ) tempMin = tempArray[j].duration/tempArray[j].tasks
            if (tempMax < (tempArray[j].duration/tempArray[j].tasks) ) tempMax = tempArray[j].duration/tempArray[j].tasks
        }
        if (gClusterMetric === 10)  {
            if (tempMin > tempArray[j].customer_comments ) tempMin = tempArray[j].customer_comments
            if (tempMax < tempArray[j].customer_comments ) tempMax = tempArray[j].customer_comments
        }
        if (gClusterMetric === 11)  {
            if (tempMin > tempArray[j].internal_comments ) tempMin = tempArray[j].internal_comments
            if (tempMax < tempArray[j].internal_comments ) tempMax = tempArray[j].internal_comments
        }
        if (gClusterMetric === 12)  {
            if (tempMin > tempArray[j].worklogs ) tempMin = tempArray[j].worklogs
            if (tempMax < tempArray[j].worklogs ) tempMax = tempArray[j].worklogs
        }
        if (gClusterMetric === 13)  {
            if (tempMin > (tempArray[j].time_spent/tempArray[j].tasks) ) tempMin = tempArray[j].time_spent/tempArray[j].tasks
            if (tempMax < (tempArray[j].time_spent/tempArray[j].tasks) ) tempMax = tempArray[j].time_spent/tempArray[j].tasks
        }
        if (gClusterMetric === 14)  {
            if (tempMin > tempArray[j].time_spent ) tempMin = tempArray[j].time_spent
            if (tempMax < tempArray[j].time_spent ) tempMax = tempArray[j].time_spent
        }
    }
    for (let j = 0; j < tempArray.length; j++) {
        let vtp = [];
        vtp['key'] = key;
        vtp['visible'] = true;
        if (j > 0) {
            vtp['parent'] = key - 1;
        } else {
            vtp['parent'] = 0;
        }

        let attributesStr = '';
        let valuesStr = '';
        let index = 0;
        let attributeArray = [];
        for (let i = 0; i < clusterAttributes.length; i++) {
            index = clusterAttributes[i].id;
            if (i > 0) {
                valuesStr = valuesStr + '\r\n';
                attributesStr = attributesStr + '\r\n';
            }
            attributesStr = attributesStr + displayTaskAttributeName(clusterAttributes[i]);
            valuesStr = valuesStr + tempArray[j][index];
            let vtp = [];
            vtp['field'] = clusterAttributes[i].field;
            vtp['value'] = tempArray[j][index];
            attributeArray.push(vtp);
        }

        let header = ' '
        if (gClusterMetric == 1 || gClusterMetric == 10 || gClusterMetric == 11 || gClusterMetric == 12 || gClusterMetric == 14) {
            header = ' ' + metric + ' - ' + numberWithCommas(tempArray[j][metric]) ;
            header = header + ', ' + formatPercentage(tempArray[j].tasks / total_tasks, 1) + ' of total';
        } else {
            header = ' ' + metric + ' - ' + tempArray[j][metric].toFixed(2);
            header = header + ', ' + gEntityUpper + 's - '  + numberWithCommas(tempArray[j].tasks) + ', ' + formatPercentage(tempArray[j].tasks / total_tasks, 1) + ' of total';
        }
        vtp['header'] = header

        // add steps
        if (gClusterAnalysisSteps === true) vtp['attributes'] = "Step is '" + tempArray[j].step + "', " + tempArray[j].attribute_str;
        else vtp['attributes'] = tempArray[j].attribute_str;
        
        vtp['attributeArray'] = attributeArray;
        vtp['values'] = valuesStr;
        vtp['task_str'] = tempArray[j].taskID;
        vtp['step'] = tempArray[j].step 
        if (gClusterMetric === 1)  {
            let width = 300 + ((((tempArray[j].tasks) - tempMin) / (tempMax - tempMin))* 470)
            vtp['width'] = width 
        } 
        if (gClusterMetric == 2 || gClusterMetric == 3 || gClusterMetric == 4) {
            let width = 300 + ((((tempArray[j].duration/tempArray[j].tasks) - tempMin) / (tempMax - tempMin))* 470)
            vtp['width'] = width 
        }
        if (gClusterMetric === 10)  {
            let width = 300 + ((((tempArray[j].customer_comments) - tempMin) / (tempMax - tempMin))* 470)
            vtp['width'] = width 
        }
        if (gClusterMetric === 11)  {
            let width = 300 + ((((tempArray[j].internal_comments) - tempMin) / (tempMax - tempMin))* 470)
            vtp['width'] = width 
        }
        if (gClusterMetric === 12)  {
            let width = 300 + ((((tempArray[j].worklogs) - tempMin) / (tempMax - tempMin))* 470)
            vtp['width'] = width 
        }
        if (gClusterMetric === 13)  {
            let width = 300 + ((((tempArray[j].time_spent/tempArray[j].tasks) - tempMin) / (tempMax - tempMin))* 470)
            vtp['width'] = width 
        }
        if (gClusterMetric === 14)  {
            let width = 300 + ((((tempArray[j].time_spent) - tempMin) / (tempMax - tempMin))* 470)
            vtp['width'] = width 
        }

        nodeDataArray.push(vtp);
        key++;
    }
    if (gClusterAttributes.length == 0) {
        nodeDataArray = [];
    }
    gDiagramCluster.model = new go.TreeModel(nodeDataArray);
}

export function setDecompositionTreeMetricFilter(filter) {
    gDecompositionTreeMetric = filter;
}

export function setInfluenceAnalysisMetricFilter(filter) {
    gInfluenceAnalysisMetric = filter;
}

export function setDecompositionTreeValueFilter(filter) {
    gDecompositionTreeValueType = filter;
}

export function getDecompositionTreeValueFilter() {
    return gDecompositionTreeValueType;
}

export function getClusterValueFilter() {
    return gClusterValueType;
}

export function getInfluenceAnalysisValueFilter() {
    return gInfluenceAnalysisInfluence;
}

export function setClusterValueFilter(filter) {
    gClusterValueType = filter;
}

export function setInfluenceAnalysisValueFilter(filter) {
    gInfluenceAnalysisInfluence = filter;
}

export function setClusterAttributes(attributes) {
    gClusterAttributes = canonicalizeTaskAttributeSelections(attributes);
}

export function setInfluenceAnalysisAttributes(attributes) {
    gInfluenceAnalysisAttributes = canonicalizeTaskAttributeSelections(attributes);
}

export function getInfluenceAnalysisAttributes() {
    return canonicalizeTaskAttributeSelections(gInfluenceAnalysisAttributes);
}


export function setInfluenceShowSteps(show_steps) {
    gInfluenceAnalysisSteps = show_steps;
}

export function setClusterShowSteps(show_steps) {
    gClusterAnalysisSteps = show_steps;
}

export function getClusterAttributes() {
    return canonicalizeTaskAttributeSelections(gClusterAttributes);
}

export const getInfluenceShowSteps = () => ({
    show_steps: gInfluenceAnalysisSteps,
});

export const getClusterShowSteps = () => ({
    show_steps: gClusterAnalysisSteps,
});


export const setClusterMinMaxMetric = ({ min, max }) => {
    gClusterMinMetric = min ?? gClusterMinMetric;
    gClusterMaxMetric = max ?? gClusterMaxMetric;
};

export const getClusterMinMaxMetric = () => ({
    min: gClusterMinMetric,
    max: gClusterMaxMetric,
});

export const setClusterMinMaxTasks = ({ min, max }) => {
    gClusterMinTasks = min ?? gClusterMinTasks;
    gClusterMaxTasks = max ?? gClusterMaxTasks;
};

export const getClusterMinMaxTasks = () => ({
    min: gClusterMinTasks,
    max: gClusterMaxTasks,
});

export const setInfluenceAnalysisMinMaxMetric = ({ min, max }) => {
    gInfluenceAnalysisMinMetric = min ?? gInfluenceAnalysisMinMetric;
    gInfluenceAnalysisMaxMetric = max ?? gInfluenceAnalysisMaxMetric;
};

export const getInfluenceAnalysisMinMaxMetric = () => ({
    min: gInfluenceAnalysisMinMetric,
    max: gInfluenceAnalysisMaxMetric,
});

export const setInfluenceAnalysisMinMaxTasks = ({ min, max }) => {
    gInfluenceAnalysisMinTasks = min ?? gInfluenceAnalysisMinTasks;
    gInfluenceAnalysisMaxTasks = max ?? gInfluenceAnalysisMaxTasks;
};

export const getInfluenceAnalysisMinMaxTasks = () => ({
    min: gInfluenceAnalysisMinTasks,
    max: gInfluenceAnalysisMaxTasks,
});

export const setDecompositionTreeMinMaxTasks = ({ min, max }) => {
    gDecompositionTreeMinTasks = min ?? gDecompositionTreeMinTasks;
    gDecompositionTreeMaxTasks = max ?? gDecompositionTreeMaxTasks;
};

export const getDecompositionTreeMinMaxTasks = () => ({
    min: gDecompositionTreeMinTasks,
    max: gDecompositionTreeMaxTasks,
});

export const setDecompositionTreeMinMaxMetric = ({ min, max }) => {
    gDecompositionTreeMinMetric = min ?? gDecompositionTreeMinMetric;
    gDecompositionTreeMaxMetric = max ?? gDecompositionTreeMaxMetric;
};

export const setMinPercTasks = ({ min }) => {
    gASAMinTasks = min ?? gASAMinTasks;
};

export const setDetailSource = ({ source }) => {
    gDetailSource = source ?? gDetailSource;
};

export const getDecompositionTreeMinMaxMetric = () => ({
    min: gDecompositionTreeMinMetric,
    max: gDecompositionTreeMaxMetric,
});

export function setDecompositionTreeAttributeFilter(filter) {
    gDecompositionTreeAttribute = filter;
}

export function setClusterMetricFilter(filter) {
    gClusterMetric = filter;
}

export function getClusterMetricFilter() {
    return gClusterMetric;
}

export function getDecompositionTreeMetricFilter() {
    return gDecompositionTreeMetric;
}

export function getInfluenceAnalysisMetricFilter() {
    return gInfluenceAnalysisMetric;
}

class GradientColor {
    constructor(startColor = '', endColor = '', minNum = 0, maxNum = 10) {
        this.setColorGradient = (colorStart, colorEnd) => {
            startColor = getHexColor(colorStart);
            endColor = getHexColor(colorEnd);
        };

        this.setMidpoint = (minNumber, maxNumber) => {
            minNum = minNumber;
            maxNum = maxNumber;
        };

        this.getColor = (numberValue) => {
            if (numberValue) {
                return (
                    '#' +
                    generateHex(numberValue, startColor.substring(0, 2), endColor.substring(0, 2)) +
                    generateHex(numberValue, startColor.substring(2, 4), endColor.substring(2, 4)) +
                    generateHex(numberValue, startColor.substring(4, 6), endColor.substring(4, 6))
                );
            }
        };

        const generateHex = (number, start, end) => {
            if (number < minNum) {
                number = minNum;
            } else if (number > maxNum) {
                number = maxNum;
            }

            const midPoint = maxNum - minNum;
            const startBase = parseInt(start, 16);
            const endBase = parseInt(end, 16);
            const average = (endBase - startBase) / midPoint;
            const finalBase = Math.round(average * (number - minNum) + startBase);
            const balancedFinalBase = finalBase < 16 ? '0' + finalBase.toString(16) : finalBase.toString(16);
            return balancedFinalBase;
        };

        const getHexColor = (color) => {
            return color.substring(color.length - 6, color.length);
        };
    }
}

class Gradient {
    constructor(colorGradients = '', maxNum = 10, colors = ['', ''], intervals = []) {
        const setColorGradient = (gradientColors) => {
            if (gradientColors.length < 2) {
                throw new Error(`setColorGradient should have more than ${gradientColors.length} color`);
            } else {
                const increment = maxNum / (gradientColors.length - 1);
                const firstColorGradient = new GradientColor();
                const lower = 0;
                const upper = 0 + increment;
                firstColorGradient.setColorGradient(gradientColors[0], gradientColors[1]);
                firstColorGradient.setMidpoint(lower, upper);
                colorGradients = [firstColorGradient];
                intervals = [
                    {
                        lower,
                        upper,
                    },
                ];

                for (let i = 1; i < gradientColors.length - 1; i++) {
                    const gradientColor = new GradientColor();
                    const lower = 0 + increment * i;
                    const upper = 0 + increment * (i + 1);
                    gradientColor.setColorGradient(gradientColors[i], gradientColors[i + 1]);
                    gradientColor.setMidpoint(lower, upper);
                    colorGradients[i] = gradientColor;
                    intervals[i] = {
                        lower,
                        upper,
                    };
                }
                colors = gradientColors;
            }
        };

        this.setColorGradient = (...gradientColors) => {
            setColorGradient(gradientColors);
            return this;
        };

        this.getColors = () => {
            const gradientColorsArray = [];
            for (let j = 0; j < intervals.length; j++) {
                const interval = intervals[j];
                const start = interval.lower === 0 ? 1 : Math.ceil(interval.lower);
                const end = interval.upper === maxNum ? interval.upper + 1 : Math.ceil(interval.upper);
                for (let i = start; i < end; i++) {
                    gradientColorsArray.push(colorGradients[j].getColor(i));
                }
            }
            return gradientColorsArray;
        };

        this.getColor = (numberValue) => {
            if (isNaN(numberValue)) {
                throw new TypeError(`getColor should be a number`);
            } else if (numberValue <= 0) {
                throw new TypeError(`getColor should be greater than ${numberValue}`);
            } else {
                const toInsert = numberValue + 1;
                const segment = (maxNum - 0) / colorGradients.length;
                const index = Math.min(Math.floor((Math.max(numberValue, 0) - 0) / segment), colorGradients.length - 1);
                return colorGradients[index].getColor(toInsert);
            }
        };

        this.setMidpoint = (maxNumber) => {
            if (!isNaN(maxNumber) && maxNumber >= 0) {
                maxNum = maxNumber;
                setColorGradient(colors);
            } else if (maxNumber <= 0) {
                throw new RangeError(`midPoint should be greater than ${maxNumber}`);
            } else {
                throw new RangeError('midPoint should be a number');
            }
            return this;
        };
    }
}

export function getMinDiagramWidth() {
    return gMinDiagramWidth;
}

export function saveDiscoveryRulesGridState(columnState) {
    gDiscoveryRulesGridState = columnState;
}

export function getDiscoveryRulesGridState() {
    return gDiscoveryRulesGridState;
}

export function saveVariantSlicerGridState(columnState) {
    gVariantSlicerGridState = columnState;
}

export function saveVariantSlicerGridFilterState(filterState) {
    gVariantSlicerGridFilterState = filterState;
}

export function getVariantSlicerGridState() {
    return gVariantSlicerGridState;
}

export function getVariantSlicerGridFilterState() {
    return gVariantSlicerGridFilterState;
}

export function getAAGridState() {
    return gAAGridState;
}

export function saveAAGridState(columnState) {
    gAAGridState = columnState;
}


export function saveStepFilterGridState(columnState) {
    gStepFilterGridState = columnState;
}

export function saveVariantFilterGridState(columnState) {
    gVariantFilterGridState = columnState;
}

export function getStepFilterGridState() {
    return gStepFilterGridState;
}

export function getVariantFilterGridState() {
    return gVariantFilterGridState; 
}

export function saveActivityFilterGridState(columnState) {
    gActivityFilterGridState = columnState;
}

export function getActivityFilterGridState() {
    return gActivityFilterGridState;
}

export function saveActivityTypeFilterGridState(columnState) {
    gActivityTypeFilterGridState = columnState;
}

export function getActivityTypeFilterGridState() {
    return gActivityTypeFilterGridState;
}


export function saveTaskAttributeFilterGridState(columnState) {
    gTaskAttributeFilterGridState = columnState;
}

export function getTaskAttributeFilterGridState() {
    return gTaskAttributeFilterGridState;
}

export function saveEventAttributeFilterGridState(columnState) {
    gEventAttributeFilterGridState = columnState;
}

export function getEventAttributeFilterGridState() {
    return gEventAttributeFilterGridState;
}

export const getRCDescription = () => {
    return gRCDescription;
};

function loadDiagramASA() {
    let $ = go.GraphObject.make;
    gDiagramASA = $(go.Diagram, {
        layout: $(go.LayeredDigraphLayout, { direction: 0 }),
        defaultScale: 1.2,
        initialAutoScale: go.Diagram.Uniform,
        contentAlignment: go.Spot.Center,
    });

    const element = document.getElementById('gDiagramDivASA');
    gDiagramASA.div = element     

    gDiagramASA.toolManager.mouseWheelBehavior = go.ToolManager.WheelZoom;
    gDiagramASA.toolManager.hoverDelay = 300;
    gDiagramASA.toolManager.toolTipDuration = 10000;

    gDiagramASA.nodeTemplate = $(
        go.Node,
        'Auto',
        { locationSpot: go.Spot.Center, isShadowed: true },
        $(
            go.Shape,
            new go.Binding('figure', 'figure'),
            { stroke: 'lightgray' },
            new go.Binding('fill', 'fill_color'),
//            new go.Binding('border', 'text_color') jjjj
        ),
        {
            toolTip: $(
                go.Adornment,
                'Auto',
                $(go.Shape, 'RoundedRectangle', { fill: 'white', stroke: 'gray', strokeWidth: 1 }),
                $(
                    go.TextBlock,
                    {
                        margin: 4,
                        font: '9pt system-ui, arial, system-ui',
                    },
                    new go.Binding('text', 'tooltip')
                ),
                new go.Binding('visible', 'disableTooltip', (disableTooltip) => !disableTooltip)
            ),
        },

        $(
            go.TextBlock, // the label text
            new go.Binding('font', 'font'),
            {
                textAlign: 'center',
                margin: 3,
            },
            new go.Binding('text'),
            new go.Binding('stroke', 'text_color'),
            new go.Binding('visible', 'visible')
        ),
        {
            selectionAdornmentTemplate: $(
                go.Adornment,
                'Auto',
                $(
                    go.Shape,
                    'RoundedRectangle',
                    { fill: null },
                    new go.Binding('stroke', 'highlight_color'),
                    new go.Binding('strokeWidth', 'highlight_width')
                ),
                $(go.Placeholder)
            ), // end Adornment
        }
    );

    gDiagramASA.linkTemplate = $(
        go.Link, // the whole link panel
        { curve: go.Link.Bezier, reshapable: true, adjusting: go.Link.Stretch },
        $(
            go.Shape,
            new go.Binding('stroke', 'link_color'),
            new go.Binding('strokeWidth', 'width'),
            new go.Binding('visible', 'visible'),
            new go.Binding('strokeDashArray', 'dashes', function (l) {
                return l ? [3, 2] : null;
            })
        ),

        $(go.Shape, { toArrow: 'standard', strokeWidth: 0 }, new go.Binding('fill', 'link_color')),
        {
            toolTip: $(
                go.Adornment,
                'Auto',
                $(go.Shape, 'RoundedRectangle', { fill: 'white', stroke: 'gray', strokeWidth: 1 }),
                $(
                    go.TextBlock,
                    {
                        margin: 4,
                        font: '9pt system-ui, arial, system-ui',
                    },
                    new go.Binding('text', 'tooltip')
                ),
                new go.Binding('visible', 'disableTooltip', (disableTooltip) => !disableTooltip)
            ),
        },
        $(
            go.Panel,
            'Auto',
            $(
                go.Shape, // the label background, which becomes transparent around the edges
                {
                    fill: $(go.Brush, 'Radial', { 0: 'rgb(240, 240, 240)', 0.3: 'rgb(240, 240, 240)', 1: 'rgba(240, 240, 240, 0)' }),
                    stroke: null,
                }
            ),
            $(
                go.TextBlock, // the label text
                {
                    textAlign: 'center',
                    margin: 8,
                },
                new go.Binding('font', 'font'),
                new go.Binding('visible', 'label_visible'),
                new go.Binding('text', 'link_label')
            )
        )
    );
}

export function rebuildASA() {
    loadDiagramASA();
    reloadASAData();
}

export function reloadASAData() {
    const tempLinks = [...gASALinks];
    const tempNodes = [...gASANodes];
    for (let i = 0; i < tempNodes.length; i++) {
        tempNodes[i].visible = true;

        if ((tempNodes[i].perc_total <= gASAMinTasks && tempNodes[i].selected_activity === false) || tempNodes[i].tasks === 0) {
            for (let j = 0; j < tempLinks.length; j++) {
                if (gASAType === 'Inbound') {
                    if (parseInt(tempLinks[j].from) === parseInt(tempNodes[i].key)) {
                        tempLinks.splice(j, 1);
                        j--;
                    }
                }
                if (gASAType === 'Outbound') {
                    if (parseInt(tempLinks[j].to) === parseInt(tempNodes[i].key)) {
                        tempLinks.splice(j, 1);
                        j--;
                    }
                }
            }
            tempNodes.splice(i, 1);
            i--;
        }
        if (tempNodes[i].start_node === true) {
            // check that a link exists with start key = 1
            let startLinkExists = false;
            for (let j = 0; j < gASALinks.length; j++) {
                if (parseInt(gASALinks[j].from) === 1) {
                    startLinkExists = true;
                }
            }
            if (startLinkExists === false) {
                tempNodes[i].visible = false;
            }
        }
        if (tempNodes[i].end_node === true) {
            tempNodes[i].visible = false;
        }
    }

    for (let i = 0; i < tempNodes.length; i++) {
        if (tempNodes[i].visible === false) {
            tempNodes.splice(i, 1);
            i--;
        }
    }

    gDiagramASA.model.linkDataArray = tempLinks;
    gDiagramASA.model.nodeDataArray = tempNodes;
    gDiagramASA.layout.layerSpacing = 80;
    gDiagramASA.layout.rowSpacing = 30;
    gDiagramASA.zoomToFit();
}

export function processDiscoveryRulesSummary() {
    let processDiscoveryRulesArray = [];
    for (let i = 0; i < gDiscoveryRules.length; i++) {
      
        if (gDiscoveryRules[i].discovery_rule_type !== 'child') {
            let vtp = processDiscoveryRulesSummaryRow(gDiscoveryRules[i])
            processDiscoveryRulesArray.push(vtp);
        }
    }
    processDiscoveryRulesArray.sort((a, b) => a.discovery_rule.localeCompare(b.discovery_rule));
    return processDiscoveryRulesArray;
}


export function processDiscoveryRulesSummaryRow(discoveryRule) {    

    let vtp = [];
    vtp['id'] = discoveryRule.id;
    vtp['discovery_rule_id'] = discoveryRule.discovery_rule_id;
    vtp['issue_type'] = discoveryRule.issue_type;
    vtp['category'] = discoveryRule.category;
    vtp['type'] = discoveryRule.type;
    vtp['discovery_rule_type'] = discoveryRule.discovery_rule_type;

    vtp['discovery_rule'] = discoveryRule.discovery_rule;
    vtp['sub_discovery_rule'] = discoveryRule.sub_discovery_rule;

    // discoveryRule detail -- slicers + filters
    if (discoveryRule.create_time !== undefined) {vtp['create_time']= discoveryRule.create_time.replace('T',' ')}
    else {vtp['create_time'] = ''}
    vtp['events'] = discoveryRule.events;
    vtp['tasks'] = discoveryRule.tasks;
    vtp['conditions'] = discoveryRule.conditions;
    vtp['calculate_cost_impact'] = discoveryRule.calculate_cost_impact;
    vtp['automation_opportunity'] = discoveryRule.automation_opportunity;
    vtp['save_activities'] = discoveryRule.save_activities;
    vtp['save_steps'] = discoveryRule.save_steps;
    vtp['save_variants'] = discoveryRule.save_variants;
    vtp['filter_activities'] = discoveryRule.filter_activities;
    vtp['filter_variants'] = discoveryRule.filter_variants;
    vtp['filter_steps'] = discoveryRule.filter_steps;
    vtp['discoveryRuleDetail'] =  discoveryRule.discovery_rule_detail

    if (discoveryRule.calculate_cost_impact === true) {
        vtp['actual_cost'] = discoveryRule.actual_cost;
        vtp['forecast_cost'] = discoveryRule.forecast_cost;
        vtp['cost_saving'] = discoveryRule.actual_cost - discoveryRule.forecast_cost;
        if (discoveryRule.actual_cost === discoveryRule.forecast_cost) vtp['perc_cost_saving'] = -1
        else vtp['perc_cost_saving'] = ((discoveryRule.actual_cost - discoveryRule.forecast_cost) /  discoveryRule.actual_cost);
    } else {
        vtp['actual_cost'] = -1
        vtp['forecast_cost'] = -1
        vtp['cost_saving'] = -1
        vtp['perc_cost_saving'] = -1
    }

    vtp['filters'] = discoveryRule.filters;
    let filterSummary = [];
    for (let j = 0; j < discoveryRule.filters.length; j++) {
        filterSummary.push({
            type: discoveryRule.filters[j].label,
            description: discoveryRule.filters[j].description,
        });
    }

    vtp['filterSummary'] = filterSummary;

    if (discoveryRule.events > 0) {
        vtp['totalImpactDuration'] = discoveryRule.duration
        vtp['avgImpactDurationEvents'] = discoveryRule.duration/discoveryRule.events;
        vtp['avgImpactDurationTasks'] = discoveryRule.duration/discoveryRule.tasks;
        vtp['percTasks'] = discoveryRule.tasks/ gTasksTotal
        vtp['percEvents'] = discoveryRule.events/ gEventsTotal
    } else {
        vtp['totalImpactDuration'] = 0
        vtp['avgImpactDurationEvents'] = 0
        vtp['avgImpactDurationTasks'] = 0
        vtp['percTasks'] = 0
        vtp['percEvents'] = 0
    }
    return vtp
}


export const setVariantsVisualizationGraphType = (graphType) => {
    gVariantsVisualizationGraphType = graphType;
};

export const setVariantsVisualizationMetric = (metric) => {
    gVariantsVisualizationMetric = metric;
};

export function variantsVisualization() {

    gLinkArray.sort((a, b) => a.variant_sequence - b.variant_sequence || a.sort_key - b.sort_key);
    let v = -1;
    let seriesData = [];
    let categoryData = [];
    let vtp = {}
    for (let i = 0; i < gLinkArray.length; i++) {
        let validVariant = false;

        for (let j = 0; j < gVariantPaneVariants.length; j++) {
            if (gLinkArray[i].variant === gVariantPaneVariants[j].v) {
                validVariant = true;
                break;
            }
        }

        if (validVariant === true) {
            if (gLinkArray[i].end_node === false && gLinkArray[i].start_node === false) {

                if (v != gLinkArray[i].variant_id) {
                    if (i > 0 && vtp.key !== undefined) {
                        seriesData.push(vtp)
                    }

                    let variant = ''
                    for (let j = 0; j < gVariantArray.length; j++) {
                        if (gLinkArray[i].variant_id === gVariantArray[j].id) {
                            variant = gVariantArray[j].n
                            break;
                        }
                    }

                    vtp = {}
                    vtp['key'] = variant
                }
                v = gLinkArray[i].variant_id;
                let value = 0;
                if (gVariantsVisualizationMetric === 0) value = gLinkArray[i].duration / gLinkArray[i].tasks / 60;
                if (gVariantsVisualizationMetric === 1) value = gLinkArray[i].duration / gLinkArray[i].tasks / 3600;
                if (gVariantsVisualizationMetric === 2) value = gLinkArray[i].duration / gLinkArray[i].tasks / 86400;
                if (gVariantsVisualizationMetric === 3) value = gLinkArray[i].actual_cost;
                if (gVariantsVisualizationMetric === 4) value = gLinkArray[i].forecast_cost;
                if (gVariantsVisualizationMetric === 5) value = gLinkArray[i].actual_cost - gLinkArray[i].forecast_cost;
                if (gVariantsVisualizationMetric === 6) value = gLinkArray[i].actual_cost / gLinkArray[i].tasks;
                if (gVariantsVisualizationMetric === 7) value = gLinkArray[i].forecast_cost / gLinkArray[i].tasks;
                if (gVariantsVisualizationMetric === 8) value = (gLinkArray[i].actual_cost - gLinkArray[i].forecast_cost) / gLinkArray[i].tasks;
                let activity = gLinkArray[i].from_label.toLowerCase().replaceAll(' ','-');
                vtp[activity] = Number(value.toPrecision(2))
        
                let activityExists = false
                for (let j = 0; j < categoryData.length; j++) {
                    if (categoryData[j].yKey === activity) {
                        activityExists = true
                        break
                    }
                }
                if (activityExists === false) {
                    let vtp = {}
                    vtp['type'] = 'bar'
                    vtp['direction'] = 'horizontal'
                    vtp['xKey'] = 'key'
                    vtp['yKey'] = activity
                    vtp['yName'] = gLinkArray[i].from_label
                    vtp['stacked'] = true
                    categoryData.push(vtp)
                }
            }
        }
    }
    gLifecycleSeries = [...seriesData];
    gLifecycleCategory = [...categoryData];
}

export function tasksVisualization() {  
    let startNode = 0;
    let endNode = 0;

    for (let j = 0; j < gActivityArray.length; j++) {
        if (gActivityArray[j].start_node == true) {
            startNode = gActivityArray[j].id;
        }
        if (gActivityArray[j].end_node == true) {
            endNode = gActivityArray[j].id;
        }
    }
    let eventArray = [];
    gEventLogArray.sort((a, b) => a.id - b.id);
    if (
        gTasksVisualizationSource === 'step' ||
        gTasksVisualizationSource === 'diagram' ||
        gTasksVisualizationSource === 'activity' ||
        gTasksVisualizationSource === 'variant' ||
        gTasksVisualizationSource === 'dt_node' ||
        gTasksVisualizationSource === 'rc_node' ||
        gTasksVisualizationSource === 'ia_node' ||
        gTasksVisualizationSource === 'discovery_rule' 
    ) {
        if (gTasksVisualizationFilter === 0) {
            if (gTasksVisualizationSort === 0) {
                gTasksFilteredArray.sort((a, b) => b.d - a.d);
            }
            if (gTasksVisualizationSort === 1) {
                gTasksFilteredArray.sort((a, b) => b.d - a.d);
            }
            if (gTasksVisualizationSort === 2) {
                gTasksFilteredArray.sort((a, b) => a.k.localeCompare(b.k));
            }
        }
        if (gTasksVisualizationFilter === 1) {
            if (gTasksVisualizationSort === 0) {
                gTasksFilteredArray.sort((a, b) => b.actual_cost - a.actual_cost);
            }
            if (gTasksVisualizationSort === 1) {
                gTasksFilteredArray.sort((a, b) => b.actual_cost - a.actual_cost);
            }
            if (gTasksVisualizationSort === 2) {
                gTasksFilteredArray.sort((a, b) => a.k.localeCompare(b.k));
            }
        }
        if (gTasksVisualizationFilter === 2) {
            if (gTasksVisualizationSort === 0) {
                gTasksFilteredArray.sort((a, b) => b.forecast_cost - a.forecast_cost);
            }
            if (gTasksVisualizationSort === 1) {
                gTasksFilteredArray.sort((a, b) => b.forecast_cost - a.forecast_cost);
            }
            if (gTasksVisualizationSort === 2) {
                gTasksFilteredArray.sort((a, b) => a.k.localeCompare(b.k));
            }
        }
        if (gTasksVisualizationFilter === 3) {
            if (gTasksVisualizationSort === 0) {
                gTasksFilteredArray.sort((a, b) => b.actual_cost - b.forecast_cost - (a.actual_cost - a.forecast_cost));
            }
            if (gTasksVisualizationSort === 1) {
                gTasksFilteredArray.sort((a, b) => a.actual_cost - a.forecast_cost - (b.actual_cost - b.forecast_cost));
            }
            if (gTasksVisualizationSort === 2) {
                gTasksFilteredArray.sort((a, b) => a.k.localeCompare(b.k));
            }
        }
        for (let i = 0; i < gTasksFilteredArray.length; i++) {
            for (let f = gTasksFilteredArray[i].fi; f > gTasksFilteredArray[i].si; f--) {
                if (gEventLogArray[f].f != startNode && gEventLogArray[f].t != endNode) {
                    let vtp = [];
                    for (let j = 0; j < gActivityArray.length; j++) {
                        if (gActivityArray[j].id == gEventLogArray[f].f) {
                            vtp['fromNode'] = gActivityArray[j].activity;
                            break;
                        }
                    }

                    let customer_comments = 0
                    let internal_comments = 0
                    let time_spent = 0
                    let work_logs = 0
                    for (let j = 0; j < gEventLogArray[f].comments.length; j++) {
                        if (gEventLogArray[f].comments[j].jsdPublic === 'true') customer_comments ++
                        else  internal_comments ++
                    }

                    for (let j = 0; j < gEventLogArray[f].worklog.length; j++) {
                        work_logs ++
                        time_spent = time_spent + gEventLogArray[f].worklog[j].timeSpentSeconds
                    }

                    vtp['d'] = gEventLogArray[f].d;
                    vtp['actual_cost'] = gEventLogArray[f].actual_cost;
                    vtp['forecast_cost'] = gEventLogArray[f].forecast_cost;
                    vtp['sort'] = gEventLogArray[f].s;
                    vtp['customer_comments'] = customer_comments
                    vtp['internal_comments'] = internal_comments
                    vtp['time_spent'] = time_spent
                    vtp['work_logs'] = work_logs
                    vtp['k'] = gTasksFilteredArray[i].k;
                    eventArray.push(vtp);
                }
            }
            if (i > gTasksVisualizationNumTasks) {
                break;
            }
        }
    }
    if (gTasksVisualizationSource === 'detail' || gTasksVisualizationSource === 'tia') {
        gTaskArray.sort((a, b) => a.id - b.id);
        let vtp = [];
        for (let i = 0; i < gDetailTaskTasksSelected.length; i++) {
            for (let f = gTaskArray[gDetailTaskTasksSelected[i].id].fi; f > gTaskArray[gDetailTaskTasksSelected[i].id].si; f--) {
                if (gEventLogArray[f].t != endNode) {
                    vtp = [];
                    for (let j = 0; j < gActivityArray.length; j++) {
                        if (gActivityArray[j].id == gEventLogArray[f].f) {
                            vtp['fromNode'] = gActivityArray[j].activity;
                            break;
                        }
                    }
                    vtp['d'] = gEventLogArray[f].d;
                    vtp['actual_cost'] = gEventLogArray[f].actual_cost;
                    vtp['forecast_cost'] = gEventLogArray[f].forecast_cost;
                    vtp['sort'] = gEventLogArray[f].s;

                    let customer_comments = 0
                    let internal_comments = 0
                    let time_spent = 0
                    let work_logs = 0
                    for (let j = 0; j < gEventLogArray[f].comments.length; j++) {
                        if (gEventLogArray[f].comments[j].jsdPublic === 'true') customer_comments ++
                        else  internal_comments ++
                    }

                    for (let j = 0; j < gEventLogArray[f].worklog.length; j++) {
                        work_logs ++
                        time_spent = time_spent + gEventLogArray[f].worklog[j].timeSpentSeconds
                    }
                    vtp['customer_comments'] = customer_comments
                    vtp['internal_comments'] = internal_comments
                    vtp['time_spent'] = time_spent
                    vtp['work_logs'] = work_logs

                    vtp['k'] = gEventLogArray[f].k;
                    eventArray.push(vtp);
                }
            }
        }
    }
    let k = '';
    let seriesData = [];
    let categoryData = [];
    let vtp = [];
    eventArray.sort((a, b) => a.k.localeCompare(b.k) || a.sort - b.sort);

    let i
    for (i = 0; i < eventArray.length; i++) {
        
        if (k != eventArray[i].k) {
            if (i > 0) {
                categoryData.push(vtp)
            }
            vtp = {}
            vtp['key'] = eventArray[i].k
        }
        k = eventArray[i].k;

        let value = 0;
        if (gTasksVisualizationMetric === 0) value = eventArray[i].d / 60;
        if (gTasksVisualizationMetric === 1) value = eventArray[i].d / 3600;
        if (gTasksVisualizationMetric === 2) value = eventArray[i].d / 86400;
        let activity = eventArray[i].fromNode.toLowerCase().replaceAll(' ','-');
        vtp[activity] = Number(value.toPrecision(2))

        let activityExists = false
        for (let j = 0; j < seriesData.length; j++) {
            if (seriesData[j].yKey === activity) {
                activityExists = true
                break
            }
        }
        if (activityExists === false) {
            let vtpSeries = {}
            vtpSeries['type'] = 'bar'
            vtpSeries['direction'] = 'horizontal'
            vtpSeries['xKey'] = 'key'
            vtpSeries['yKey'] = activity
            vtpSeries['yName'] = eventArray[i].fromNode
            vtpSeries['stacked'] = true
            seriesData.push(vtpSeries)
        }
    }
    categoryData.push(vtp)
    gLifecycleSeries = [...seriesData];
    gLifecycleCategory = [...categoryData];
}

export function getHistogramArray() {
    return gHistogramArray;
}

export function getDetailDescription() {
    return gDetailDescription;
}

export function getActiveAction() {
    return gActiveAction;
}

export function setActiveAction(action) {
    gActiveAction = action;
}

export const setTasksVisualizationGraphType = (graphType) => {
    gTasksVisualizationGraphType = graphType;
};

export const setTasksVisualizationMetric = (metric) => {
    gTasksVisualizationMetric = metric;
};

export const setTasksVisualizationNumTasks = (numTasks) => {
    gTasksVisualizationNumTasks = numTasks;
};

export const setTasksVisualizationFilter = (filter) => {
    gTasksVisualizationFilter = filter;
};

export const setTasksVisualizationSource = (source) => {
    gTasksVisualizationSource = source;
};

export const setTasksVisualizationSort = (sort) => {
    gTasksVisualizationSort = sort;
};

export function generateHistogramArray(type, variantPaneVariants, variant, activity, from, to, discovery_rule_id) {
    gHistogramArray = [];
    gHistogramDescription = '';
    gHistogramTotal = '';

    if (type === 'step-events' || type === 'step-tasks') {
        let fromStr = '';
        let toStr = '';
        for (let i = 0; i < gActivityArray.length; i++) {
            if (gActivityArray[i].id === parseInt(from)) {
                fromStr = gActivityArray[i].activity;
            }
            if (gActivityArray[i].id === parseInt(to)) {
                toStr = gActivityArray[i].activity;
            }
        }
        if (type === 'step-events') {
            gHistogramDescription = ' Event Duration Histogram (^^^) for Step = ' + fromStr + ', to Step = ' + toStr;
        }
        if (type === 'step-tasks') {
            gHistogramDescription = ' Task Duration Histogram (^^^) for Step = ' + fromStr + ', to Step = ' + toStr;
        }
    }
    if (type === 'activity-events' || type === 'activity-tasks') {
        let activityStr = '';
        for (let i = 0; i < gActivityArray.length; i++) {
            if (gActivityArray[i].id === parseInt(activity)) {
                activityStr = gActivityArray[i].activity;
            }
        }
        if (type === 'activity-events') {
            gHistogramDescription = ' Event Duration Histogram ^^^ for Activity = ' + activityStr;
        }
        if (type === 'activity-tasks') {
            gHistogramDescription = ' Task Duration Histogram ^^^ for Activity = ' + activityStr;
        }
    }
    if (type === 'variant-events' || type === 'variant-tasks') {
        let variantStr = '';
        for (let i = 0; i < gVariantArray.length; i++) {
            if (parseInt(gVariantArray[i].v) === parseInt(variant)) {
                variantStr = gVariantArray[i].n;
                break;
            }
        }
        if (type === 'variant-events') {
            gHistogramDescription = ' Event Duration Histogram ^^^ for Variant = ' + variantStr;
        }
        if (type === 'variant-tasks') {
            gHistogramDescription = ' Task Duration Histogram ^^^ for Variant = ' + variantStr;
        }
    }
    if (type === 'diagram-events') {
        gHistogramDescription = ' Event Duration Histogram ^^^ for selected variants';
    }
    if (type === 'diagram-tasks') {
        gHistogramDescription = ' Task Duration Histogram ^^^ for selected variants';
    }

    if (type === 'discovery_rule') {
        let discoveryRule = ''
        for (let j = 0; j < gDiscoveryRules.length; j++) {
            if (gDiscoveryRules[j].discovery_rule_id === discovery_rule_id) discoveryRule = gDiscoveryRules[j].discovery_rule
        }
        gHistogramDescription = ' Task Duration Histogram ^^^ for DiscoveryRule ' + discoveryRule;

        let key = 'f-' + discovery_rule_id  
        gEventLogArray.sort((a, b) => a.tid - b.tid);
        gTaskArray.sort((a, b) => a.id - b.id);
        let taskID = '' 
        let discoveryRuleExists = false
        let i = 0
        for (i = 0; i < gEventLogArray.length; i++) {
            if (i > 0 && (gEventLogArray[i].k != taskID)) {
                if (discoveryRuleExists === true) {
                    let vtp = [];
                    vtp.task = gTaskArray[gEventLogArray[i-1].tid].k;
                    vtp.secs = parseFloat(gTaskArray[gEventLogArray[i-1].tid].d.toFixed(2));
                    vtp.mins = parseFloat((gTaskArray[gEventLogArray[i-1].tid].d / 60).toFixed(2));
                    vtp.hrs = parseFloat((gTaskArray[gEventLogArray[i-1].tid].d / 3600).toFixed(2));
                    vtp.days = parseFloat((gTaskArray[gEventLogArray[i-1].tid].d / 86400).toFixed(2));
                    gHistogramArray.push(vtp);
                }
                discoveryRuleExists = false
            }
            if (gEventLogArray[i][key] === 1) discoveryRuleExists = true
            taskID = gEventLogArray[i].k
        }
        if (discoveryRuleExists === true) {
            let vtp = [];
            vtp.secs = parseFloat(gTaskArray[gEventLogArray[i-1].tid].d.toFixed(2));
            vtp.mins = parseFloat((gTaskArray[gEventLogArray[i-1].tid].d / 60).toFixed(2));
            vtp.hrs = parseFloat((gTaskArray[gEventLogArray[i-1].tid].d / 3600).toFixed(2));
            vtp.days = parseFloat((gTaskArray[gEventLogArray[i-1].tid].d / 86400).toFixed(2));
            gHistogramArray.push(vtp);
        }
    }

    if (type === 'step-events') {
        gVariantArray.sort((a, b) => a.id - b.id);
        for (let i = 0; i < gEventLogArray.length; i++) {
            if (gEventLogArray[i].filtered != 1 && gVariantArray[gEventLogArray[i].vid].sliced == true) {
                if (gEventLogArray[i].f == parseInt(from) && gEventLogArray[i].t == parseInt(to)) {
                    let validEvent = true;
                    if (variantPaneVariants == true) {
                        validEvent = false;
                        for (let j = 0; j < gVariantPaneVariants.length; j++) {
                            if (gEventLogArray[i].v == gVariantPaneVariants[j].v) {
                                validEvent = true;
                                break;
                            }
                        }
                    }

                    if (validEvent === true) {
                        let vtp = [];
                        vtp.secs = parseFloat(gEventLogArray[i].d.toFixed(2));
                        vtp.mins = parseFloat((gEventLogArray[i].d / 60).toFixed(2));
                        vtp.hrs = parseFloat((gEventLogArray[i].d / 3600).toFixed(2));
                        vtp.days = parseFloat((gEventLogArray[i].d / 86400).toFixed(2));
                        gHistogramArray.push(vtp);
                    }
                }
            }
        }
    }
    if (type === 'influencers') {
        let tempArray = gTaskStr.split('^');
        gTaskArray.sort((a, b) => a.id - b.id);
        for (let i = 0; i < tempArray.length; i++) {
            let vtp = [];
            vtp.secs = parseFloat(gTaskArray[parseInt(tempArray[i])].d.toFixed(2));
            vtp.mins = parseFloat((gTaskArray[parseInt(tempArray[i])].d / 60).toFixed(2));
            vtp.hrs = parseFloat((gTaskArray[parseInt(tempArray[i])].d / 3600).toFixed(2));
            vtp.days = parseFloat((gTaskArray[parseInt(tempArray[i])].d/ 86400).toFixed(2));
            gHistogramArray.push(vtp);
        }
    }

    if (type === 'activity-events') {
        gVariantArray.sort((a, b) => a.id - b.id);
        for (let i = 0; i < gEventLogArray.length; i++) {
            if (gEventLogArray[i].filtered != 1 && gVariantArray[gEventLogArray[i].vid].sliced == true) {
                if (gEventLogArray[i].t == parseInt(activity)) {
                    let validEvent = true;
                    if (variantPaneVariants == true) {
                        validEvent = false;
                        for (let j = 0; j < gVariantPaneVariants.length; j++) {
                            if (gEventLogArray[i].v == gVariantPaneVariants[j].v) {
                                validEvent = true;
                                break;
                            }
                        }
                    }

                    if (validEvent === true) {
                        let vtp = [];
                        vtp.secs = parseFloat(gEventLogArray[i].d.toFixed(2));
                        vtp.mins = parseFloat((gEventLogArray[i].d / 60).toFixed(2));
                        vtp.hrs = parseFloat((gEventLogArray[i].d / 3600).toFixed(2));
                        vtp.days = parseFloat((gEventLogArray[i].d / 86400).toFixed(2));
                        gHistogramArray.push(vtp);
                    }
                }
            }
        }
    }
    let endNode = 0;
    for (let j = 0; j < gActivityArray.length; j++) {
        if (gActivityArray[j].end_node == true) {
            endNode = gActivityArray[j].id;
        }
    }
    if (type === 'variant-events') {
        gVariantArray.sort((a, b) => a.id - b.id);
        for (let i = 0; i < gEventLogArray.length; i++) {
            if (gEventLogArray[i].filtered != 1 && gVariantArray[gEventLogArray[i].vid].sliced == true) {
                if (gEventLogArray[i].v == parseInt(variant) && gEventLogArray[i].t != endNode) {
                    let vtp = [];
                    vtp.secs = parseFloat(gEventLogArray[i].d.toFixed(2));
                    vtp.mins = parseFloat((gEventLogArray[i].d / 60).toFixed(2));
                    vtp.hrs = parseFloat((gEventLogArray[i].d / 3600).toFixed(2));
                    vtp.days = parseFloat((gEventLogArray[i].d / 86400).toFixed(2));
                    gHistogramArray.push(vtp);
                }
            }
        }
    }
    if (type === 'diagram-events') {
        gVariantArray.sort((a, b) => a.id - b.id);
        for (let i = 0; i < gEventLogArray.length; i++) {
            if (gEventLogArray[i].filtered != 1 && gVariantArray[gEventLogArray[i].vid].sliced == true && gEventLogArray[i].t != endNode) {
                let validEvent = true;
                if (variantPaneVariants == true) {
                    validEvent = false;
                    for (let j = 0; j < gVariantPaneVariants.length; j++) {
                        if (gEventLogArray[i].v == gVariantPaneVariants[j].v) {
                            validEvent = true;
                            break;
                        }
                    }
                }

                if (validEvent === true) {
                    let vtp = [];
                    vtp.secs = parseFloat(gEventLogArray[i].d.toFixed(2));
                    vtp.mins = parseFloat((gEventLogArray[i].d / 60).toFixed(2));
                    vtp.hrs = parseFloat((gEventLogArray[i].d / 3600).toFixed(2));
                    vtp.days = parseFloat((gEventLogArray[i].d / 86400).toFixed(2));
                    gHistogramArray.push(vtp);
                }
            }
        }
    }

    if (type === 'step-tasks' || type === 'activity-tasks' || type === 'variant-tasks' || type === 'diagram-tasks') {
        gVariantArray.sort((a, b) => a.id - b.id);
        gEventLogArray.sort((a, b) => a.elid - b.elid);
        for (let i = 0; i < gTaskArray.length; i++) {
            if (gTaskArray[i].filtered != 1 && gVariantArray[gTaskArray[i].vid].sliced == true) {
                let validTask = true;
                if (variantPaneVariants == true) {
                    validTask = false;
                    for (let j = 0; j < gVariantPaneVariants.length; j++) {
                        if (gTaskArray[i].v == gVariantPaneVariants[j].v) {
                            validTask = true;
                            break;
                        }
                    }
                }
                if (validTask == true) {
                    if (type != 'diagram-tasks') {
                        validTask = false;
                    }
                    if (type == 'variant-tasks') {
                        if (gTaskArray[i].v == variant) {
                            validTask = true;
                        }
                    }
                    if (type == 'activity-tasks') {
                        for (let f = gTaskArray[i].si; f < gTaskArray[i].fi + 1; f++) {
                            if (gEventLogArray[f].t == parseInt(activity)) {
                                validTask = true;
                                break;
                            }
                        }
                    }
                    if (type == 'step-tasks') {
                        for (let f = gTaskArray[i].si; f < gTaskArray[i].fi + 1; f++) {
                            if (gEventLogArray[f].f == parseInt(from) && gEventLogArray[f].t == parseInt(to)) {
                                validTask = true;
                                break;
                            }
                        }
                    }
                    if (validTask == true) {
                        let vtp = [];
                        vtp.secs = parseFloat(gTaskArray[i].d.toFixed(2));
                        vtp.mins = parseFloat((gTaskArray[i].d / 60).toFixed(2));
                        vtp.hrs = parseFloat((gTaskArray[i].d / 3600).toFixed(2));
                        vtp.days = parseFloat((gTaskArray[i].d / 86400).toFixed(2));
                        gHistogramArray.push(vtp);
                    }
                }
            }
        }
    }

    if (type.includes('event') === true) {
        gHistogramTotal = 'Total Events: ' + gHistogramArray.length;
        gHistogramType = 'Events';
    }
    if (type.includes('task') === true) {
        gHistogramTotal = gEntityUpper + 's: ' + gHistogramArray.length;
        gHistogramType = getEntityUpper() + 's';
    }
}

export function getHistogramDescription() {
    return gHistogramDescription;
}

export function getHistogramTotal() {
    return gHistogramTotal;
}

export function getTaskAttributeCount() {
    return gTaskAttributes.length;
}

export function getHistogramType() {
    return gHistogramType;
}

export function getInsightTaskCount() {
    return gTasksFilteredArray.length
}

export function retrieveTaskAttributes() {
    return gTaskAttributes
}

export function retrieveEventAttributes() {
    return gEventAttributes;
}

export function getFieldUsage() {
    // Build a summarised field usage dataset from gAttributeArray.
    // Groups by field, listing top values with task counts and percentages.
    // Mirrors what's shown in the Attributes filter panel.
    const fieldMap = {};

    for (const entry of gAttributeArray) {
        if (!entry.field || entry.value == null || entry.value === '^^^') continue;
        if (entry.type === 'Event') continue;
        const key = `${entry.type}::${entry.field}`;
        if (!fieldMap[key]) {
            fieldMap[key] = {
                field:      entry.field,
                type:       entry.type,
                values:     [],
                totalTasks: 0,
            };
        }
        fieldMap[key].values.push({
            value:           entry.value,
            tasks:           entry.tasks,
            perc_total_tasks: entry.perc_total_tasks != null
                ? Number((entry.perc_total_tasks * 100).toFixed(1))
                : null,
        });
        fieldMap[key].totalTasks += entry.tasks || 0;
    }

    return Object.values(fieldMap).map(f => ({
        field:  f.field,
        type:   f.type,
        totalTasks: f.totalTasks,  // full count across ALL distinct values - do not
                                    // derive population/usage from summing `values`
                                    // below, since that list is capped to the top 10
        values: f.values
            .sort((a, b) => b.tasks - a.tasks)
            .slice(0, 10),          // top 10 values per field (display only)
    }));
}


export function retrieveMetricArray() {
    return gMetricArray
}

export function getLifecycleSeries() {
    return gLifecycleSeries.sort((a, b) => b.sort - a.sort);
}

export function getLifecycleCategory() {
    return gLifecycleCategory;
}

export function getEnvironment() {
    return gEnvironment;
}

export function getDev() {
    return gDev;
}

export function getURLHost() {
    return urlHost;
}

export function getModelID() {
    return gModelID;
}

export function getLoadingStatus() {
    return gLoadingStatus;
}

export function getUserSessionToken() {
    return userSessionToken;
}


function checkVolume(durationOperator, durationActualFrom, durationActualTo, durationValue, duration) {
    let validEvent = false;
    let durationActual = parseFloat(duration)
    durationActualFrom = parseFloat(durationActualFrom)
    durationActualTo = parseFloat(durationActualTo)

    let durationFrom = durationActualFrom;
    let durationTo = durationActualTo;
    if (durationValue === 'mins') {
        durationFrom = durationActualFrom * 60;
        durationTo = durationActualTo * 60;
    }
    if (durationValue === 'hrs') {
        durationFrom = durationActualFrom * 3600;
        durationTo = durationActualTo * 3600;
    }
    if (durationValue === 'days') {
        durationFrom = durationActualFrom * 86400;
        durationTo = durationActualTo * 86400;
    }

    if (durationOperator === 'greater than') {
        if (durationActual > durationFrom) {
            validEvent = true;
        }
    }
    if (durationOperator === 'greater than or is') {
        if (durationActual >= durationFrom) {
            validEvent = true;
        }
    }
    if (durationOperator === 'less than') {
        if (durationActual < durationFrom) {
            validEvent = true;
        }
    }
    if (durationOperator === 'less than or is') {
        if (durationActual <= durationFrom) {
            validEvent = true;
        }
    }
    if (durationOperator === 'equal to') {
        if (durationActual === durationFrom) {
            validEvent = true;
        }
    }
    if (durationOperator === 'not equal to') {
        if (durationActual !== durationFrom) {
            validEvent = true;
        }
    }
    if (durationOperator === 'between') {
        if (durationActual > durationFrom && durationActual < durationTo) {
            validEvent = true;
        }
    }
    if (durationOperator === 'between or is') {
        if (durationActual >= durationFrom && durationActual <= durationTo) {
            validEvent = true;
        }
    }
    if (durationOperator === 'outside') {
        if (durationActual < durationFrom && durationActual > durationTo) {
            validEvent = true;
        }
    }
    if (durationOperator === 'outside or is') {
        if (durationActual <= durationFrom && durationActual >= durationTo) {
            validEvent = true;
        }
    }
    return validEvent;
}

// Calculate the difference of two dates in total days
function diffDays(d1, d2)
{
  var ndays;
  var tv1 = d1.valueOf();  // msec since 1970
  var tv2 = d2.valueOf();

  ndays = (tv2 - tv1) / 1000 / 86400;
  ndays = Math.round(ndays - 0.5);
  return ndays;
}

export function jiraURL() {
    return gJiraURL
}

export function getAppVersion() {
    return gAppVersion
}

export function getSourceSystem() {
    return getSourceSystemFromAppVersion(gAppVersion);
}

export function getSourceCapabilities() {
    return getCapabilitiesForSource(getSourceSystem());
}


export function getContextPath() {
    return gContextPath
}

function currentDateTime() {
    let now = new Date();
    // correct time zone offset for generating iso string
    now.setMinutes(now.getMinutes() - now.getTimezoneOffset())
    now = now.toISOString();
    return now.slice(0, 16)
  }


function normalizeActivityAnalysisType(value, fieldValue = '') {
    const raw = String(value || '').trim().toLowerCase();
    const field = String(fieldValue || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');

    if (raw === 'resolver_group_routing') return 'routing_group';
    if (raw === 'assignee_ownership') return 'ownership';
    if (raw === 'approval_flow') return 'approval_state';
    if (raw === 'priority_classification') return 'classification';
    if (raw === 'change_phase') return 'change_phase';
    if (raw === 'change_state_lifecycle') return 'change_lifecycle';
    if (raw === 'change_approval_authorization') return 'change_approval';
    if (raw === 'change_risk_impact') return 'change_risk';
    if (raw === 'change_type_model') return 'change_type_model';
    if (raw === 'change_assignment_cab') return 'change_assignment_cab';

    if (['lifecycle_status', 'routing_group', 'ownership', 'approval_state', 'classification', 'change_phase', 'change_lifecycle', 'change_approval', 'change_risk', 'change_type_model', 'change_assignment_cab', 'custom_activity_field'].includes(raw)) {
        return raw;
    }

    if (!raw || raw === 'audit workflow' || raw === 'audit_workflow') {
        if (['state', 'status', 'stage', 'workflow_state', 'workflow_status'].includes(field)) return 'lifecycle_status';
        if (field === 'assignment_group' || field === 'assignmentgroup') return 'routing_group';
        if (field === 'assigned_to' || field === 'assignedto' || field === 'assignee' || field === 'owner') return 'ownership';
        if (field.includes('approval')) return 'approval_state';
        if (['priority', 'impact', 'urgency', 'severity', 'category', 'subcategory'].includes(field)) return 'classification';
    }

    return 'custom_activity_field';
}

function activityAnalysisLabel(kind) {
    switch (kind) {
        case 'lifecycle_status': return 'Lifecycle / Status';
        case 'routing_group': return 'Resolver Group Routing';
        case 'ownership': return 'Assignee Ownership';
        case 'approval_state': return 'Approval Flow';
        case 'classification': return 'Priority / Classification';
        case 'change_phase': return 'Change Phase';
        case 'change_lifecycle': return 'Change State / Lifecycle';
        case 'change_approval': return 'Change Approval / Authorization';
        case 'change_risk': return 'Change Risk / Impact';
        case 'change_type_model': return 'Change Type / Model';
        case 'change_assignment_cab': return 'Change Assignment / CAB Routing';
        case 'custom_activity_field': return 'Custom Audited Field';
        default: return 'Selected Activity Field';
    }
}

function activityAnalysisInterpretation(kind) {
    switch (kind) {
        case 'lifecycle_status': return 'Activities represent lifecycle/status progression through the work item workflow.';
        case 'routing_group': return 'Activities represent routing or handoff between responsible resolver groups or queues. Use resolver-group dwell, handoff, escalation, and fragmentation language rather than lifecycle-status wording.';
        case 'ownership': return 'Activities represent ownership or assignment changes between people. Use ownership, reassignment, and assignee dwell language rather than lifecycle-status wording.';
        case 'approval_state': return 'Activities represent approval-state movement rather than lifecycle status movement.';
        case 'classification': return 'Activities represent changes in a classification field; interpret the map as segmentation/escalation movement, not a normal workflow lifecycle.';
        case 'change_phase': return 'Activities represent ServiceNow Change phase movement. Use change governance language such as assess, authorize, schedule, implement, review, and close.';
        case 'change_lifecycle': return 'Activities represent Change lifecycle/state movement. Use change-state and governance lifecycle wording.';
        case 'change_approval': return 'Activities represent Change approval or authorization movement. Use approval delay, CAB, authorization, and re-approval wording.';
        case 'change_risk': return 'Activities represent Change risk, impact, or severity classification movement.';
        case 'change_type_model': return 'Activities represent Change type/model movement. Interpret as standardisation and change model behaviour.';
        case 'change_assignment_cab': return 'Activities represent Change assignment, CAB routing, or responsible group movement.';
        case 'custom_activity_field': return 'Activities represent a custom audited field. Status-specific evidence and time-bucket interpretations are limited.';
        default: return 'Activities represent the selected process-mining activity field; do not assume they are statuses.';
    }
}

export function getActivityContext() {
    const first = Array.isArray(gActivityTypes) && gActivityTypes.length > 0 ? gActivityTypes[0] : {};
    const field = first.field || first.activity_type || '';
    const kind = normalizeActivityAnalysisType(first.type, field);
    const label = first.name || field || activityAnalysisLabel(kind);

    return {
        platform: gAppVersion,
        table: first.table || first.source_table || '',
        activity_field: field,
        activity_label: label,
        activity_kind: kind,
        analysis_type: kind,
        analysis_type_label: activityAnalysisLabel(kind),
        interpretation: activityAnalysisInterpretation(kind),
        valid_metric_families: kind === 'lifecycle_status'
            ? ['lifecycle', 'status', 'wait', 'queue', 'touch', 'admin', 'rework', 'bottleneck']
            : kind === 'routing_group'
                ? ['routing', 'handoff', 'resolver_group_dwell', 'fragmentation', 'escalation']
                : kind === 'ownership'
                    ? ['ownership', 'reassignment', 'assignee_dwell', 'workload_concentration']
                    : kind === 'approval_state'
                        ? ['approval_dwell', 'approval_loops', 'approval_handoffs']
                        : kind === 'classification'
                            ? ['classification_stability', 'escalation', 'data_quality', 'category_concentration']
                            : kind === 'change_phase'
                                ? ['change_phase_dwell', 'authorize_delay', 'implement_delay', 'review_lag', 'phase_backtracking']
                                : kind === 'change_approval'
                                    ? ['change_approval_dwell', 'cab_delay', 'authorization_loops']
                                    : kind === 'change_risk'
                                        ? ['risk_classification_churn', 'impact_urgency_coverage']
                                        : kind === 'change_type_model'
                                            ? ['change_model_standardisation', 'type_churn']
                                            : kind === 'change_assignment_cab'
                                                ? ['cab_routing', 'assignment_handoffs', 'group_dwell']
                                                : ['activity_dwell', 'transitions', 'variants'],
        invalid_interpretations: kind === 'lifecycle_status'
            ? []
            : ['Do not call activity values statuses.', 'Do not treat queue/wait/touch/admin buckets as literal lifecycle-status evidence.', 'Do not infer lifecycle status progression unless the activity type is Lifecycle / Status.'],
    };
}


function debugSNOWSavedDatasetPayloadState(reason = 'debug', details = {}) {
    if (gAppVersion !== 'SNOW') return;

    const activityContext = typeof getActivityContext === 'function' ? getActivityContext() : null;
    const taskAttributeHeaders = (gTaskAttributes || []).map((a, index) => ({
        index,
        id: a?.id,
        field: a?.field,
        label: a?.label,
        attributeID: a?.attributeID,
        schema: a?.schema,
    }));
    const firstImportedEvent = Array.isArray(gImportEventLogArray) && gImportEventLogArray.length > 0
        ? gImportEventLogArray[0]
        : null;
    const firstProcessedEvent = Array.isArray(gEventLogArray) && gEventLogArray.length > 0
        ? gEventLogArray[0]
        : null;
    const taskAttributeValuesFromFirstEvent = {};
    if (firstImportedEvent) {
        taskAttributeHeaders.forEach((attr, index) => {
            taskAttributeValuesFromFirstEvent[`ta${index}`] = firstImportedEvent[`ta${index}`];
        });
    }

    const debugPayload = {
        reason,
        modelID: details.modelID || gModelID,
        modelName: details.model?.name || details.model?.NAME || gProcessModelTitle,
        modelTable: snValHelper(details.model?.table) || snValHelper(details.model?.issue_types) || '',
        modelActivityTypesRaw: details.model?.activity_types,
        activityTypesResolved: (gActivityTypes || []).map((a) => ({
            id: a?.id,
            sys_id: a?.sys_id,
            name: a?.name,
            field: a?.field,
            activity_type: a?.activity_type,
            type: a?.type,
            table: a?.table,
            source_table: a?.source_table,
            events: a?.events,
        })),
        activityContext,
        counts: {
            importedEvents: Array.isArray(gImportEventLogArray) ? gImportEventLogArray.length : 0,
            processedEvents: Array.isArray(gEventLogArray) ? gEventLogArray.length : 0,
            tasks: Array.isArray(gTaskArray) ? gTaskArray.length : 0,
            activities: Array.isArray(gActivityArray) ? gActivityArray.length : 0,
            transitions: Array.isArray(gStepArray) ? gStepArray.length : 0,
            variants: Array.isArray(gVariantArray) ? gVariantArray.length : 0,
            metricsRows: Array.isArray(gModelMetrics) ? gModelMetrics.length : 0,
        },
        taskAttributeHeaders,
        firstImportedEvent,
        firstProcessedEvent,
        taskAttributeValuesFromFirstEvent,
        modelMetricsTotal: gModelMetricsTotal,
        finalStats: details.finalStats || null,
    };

    try {
        window.__PROCESS_ADVISOR_SNOW_REOPEN_DEBUG__ = debugPayload;
    } catch (_) {}

    const isLifecycle = activityContext?.analysis_type === 'lifecycle_status';
    if (!isLifecycle && debugPayload.activityContext?.analysis_type) {
        console.info('[Process Advisor][SNOW reopen debug] Non-lifecycle activity type loaded. AI should avoid status/queue/wait wording.', {
            analysis_type: activityContext.analysis_type,
            activity_field: activityContext.activity_field,
            activity_label: activityContext.activity_label,
        });
    }

}

export function getActivityType() {
/*
    let activityTypes = []
    for (let i = 2; i < gActivityTypes.length; i++) {   // start at 2 to exclude start/end nodes
        activityTypes.push(gActivityTypes[i].activity_type)
    }
*/
    return (gActivityTypes && gActivityTypes[0] && gActivityTypes[0].activity_type) ? gActivityTypes[0].activity_type : ''
}

export function getIssueTypes() {
    return gIssueTypes
}

export const getActivityColors = () => ({
    
    fill_color1: gActivityColors[0].color_fill,
    text_color1: gActivityColors[0].color_text,
    select_color1: gActivityColors[0].color_select,
    fill_color2: gActivityColors[1].color_fill,
    text_color2: gActivityColors[1].color_text,
    select_color2: gActivityColors[1].color_select,
    fill_color3: gActivityColors[2].color_fill,
    text_color3: gActivityColors[2].color_text,
    select_color3: gActivityColors[2].color_select
});

export const changeActivityColors = ({
    fill_color1,
    text_color1,
    select_color1,
    fill_color2,
    text_color2,
    select_color2,
    fill_color3,
    text_color3,
    select_color3,
}) => {
    gActivityColors[0].color_fill = fill_color1 || gActivityColors[0].color_fill;
    gActivityColors[0].color_text = text_color1 || gActivityColors[0].color_text;
    gActivityColors[0].color_select = select_color1 || gActivityColors[0].color_select;
    gActivityColors[1].color_fill = fill_color2 || gActivityColors[1].color_fill;
    gActivityColors[1].color_text = text_color2 || gActivityColors[1].color_text;
    gActivityColors[1].color_select = select_color2 || gActivityColors[1].color_select;
    gActivityColors[2].color_fill = fill_color3 || gActivityColors[2].color_fill;
    gActivityColors[2].color_text = text_color3 || gActivityColors[2].color_text;
    gActivityColors[2].color_select = select_color3 || gActivityColors[2].color_select;

    gActivityArray.sort((a, b) => a.activity_type.localeCompare(b.activity_type));
    let activityType = ''
    let index = 0
    for (let i = 2; i < gActivityArray.length; i++) {   // start at 2 to excluded start/end nodes
        if (i > 2 && gActivityArray[i].activity_type != activityType) {
            index ++
        }
        gActivityArray[i].color_fill = gActivityColors[index].color_fill
        gActivityArray[i].color_text = gActivityColors[index].color_text
        gActivityArray[i].color_select = gActivityColors[index].color_select

        activityType = gActivityArray[i].activity_type
    }
};

export const setTimeAggregation = (aggregation) => {
    gTimeAggregation = aggregation;
};
export const setTimeMetric = (metric) => {
    gTimeMetric = metric;
    if (gTimeMetric === 'count') gTimeAggregation = 'sum'
    if (gTimeMetric === 'duration') gTimeAggregation = 'avg'
    if (gTimeMetric === 'worklogs') gTimeAggregation = 'avg'

};
export const setTimeActivity = (activity) => {
    gTimeActivity = activity;
};
export const setTimeEndActivity = (end_activity) => {
    gTimeEndActivity = end_activity;
};

export const setTimeActivityType = (activity) => {
    if (activity != gTimeActivityType) setInitialAALoad(true)
    gTimeActivityType = activity;
};

export const setTimeDurationFormat = (durationFormat) => {
    gTimeDurationFormat = durationFormat;
};
export const getTimeDurationFormat = () => {
    return gTimeDurationFormat ;
};

export const getTimeMetric = () => {
    return gTimeMetric ;
};

export const getTimeActivityType = () => {
    return gTimeActivityType ;
};


export const getTimeAggregation = () => {
    return gTimeAggregation ;
};

export function getTimeData () {  
    // make sure gauges are showing if display option is set
    updateGauges({ eventEmitter: gEventEmitter });

    const rows = [];
    let activityArray = getTimeActivities()
    gTaskArray.sort((a, b) => a.id - b.id);
    gEventLogArray.sort((a, b) => a.k.localeCompare(b.k) || a.t - b.t  );
    gTasksFilteredArray.sort((a, b) => a.id - b.id);
    let tempActivityArray = [...activityArray];
    for (let j = 0; j < tempActivityArray.length; j++) {
        tempActivityArray[j].min = 999999999999
        tempActivityArray[j].max = 0
        tempActivityArray[j].duration = -1
        tempActivityArray[j].count = -1
        tempActivityArray[j].worklogs = -1
        tempActivityArray[j].customer_comments = -1
        tempActivityArray[j].internal_comments = -1
        tempActivityArray[j].time_spent = -1
    }
    let i = 0  
    for (i = 0; i < gTasksFilteredArray.length; i++) {

        let endActivityExists = false
        let lastTime = ''
        for (let f = gTasksFilteredArray[i].si; f < gTasksFilteredArray[i].fi + 1; f++) {
            for (let j = 0; j < tempActivityArray.length; j++) {
                if (tempActivityArray[j].id === gEventLogArray[f].f) {
                    if (tempActivityArray[j].activity === gTimeEndActivity) endActivityExists = true

                    if (gEventLogArray[f].ts > lastTime) {
                        lastTime = gEventLogArray[f].ts
                        tempActivityArray[j].last_activity = true
                    } else {tempActivityArray[j].last_activity = false}

                    if (tempActivityArray[j].duration === -1 ) tempActivityArray[j].duration = 0
                    if (tempActivityArray[j].count === -1 ) tempActivityArray[j].count = 0
                    if (tempActivityArray[j].worklogs === -1 ) tempActivityArray[j].worklogs = 0
                    tempActivityArray[j].duration = tempActivityArray[j].duration + gEventLogArray[f].d
                    tempActivityArray[j].count = tempActivityArray[j].count + 1
                    tempActivityArray[j].worklogs = gEventLogArray[f].worklog.length

                    let customer_comments = 0
                    let internal_comments = 0
                    let time_spent = 0
                    for (let j = 0; j < gEventLogArray[f].comments.length; j++) {
                        if (gEventLogArray[f].comments[j].jsdPublic === 'true') customer_comments ++
                        else  internal_comments ++
                    }

                    for (let j = 0; j < gEventLogArray[f].worklog.length; j++) {
                        time_spent = time_spent + gEventLogArray[f].worklog[j].timeSpentSeconds
                    }

                    tempActivityArray[j].customer_comments = customer_comments
                    tempActivityArray[j].internal_comments = internal_comments
                    tempActivityArray[j].time_spent = time_spent
                    break
                }
            }
        }
        // if the end activity does not exist, create a dummy record
        if (endActivityExists === false && gTimeEndActivity != 'N/A') {
            for (let j = 0; j < tempActivityArray.length; j++) {
                if (tempActivityArray[j].last_activity === true) {
                    let currentDateTime = new Date().getFullYear() + '-' + (new Date().getMonth()+1) + '-' + new Date().getDate() + ' ' + new Date().getHours() + ':' + new Date().getMinutes() 
                    tempActivityArray[j].duration = tempActivityArray[j].duration + (new Date(currentDateTime) - new Date(lastTime))/1000
                    tempActivityArray[j].count = tempActivityArray[j].count + 1
                    tempActivityArray[j].worklogs = 0
                    tempActivityArray[j].customer_comments = 0
                    tempActivityArray[j].internal_comments = 0
                    tempActivityArray[j].time_spent = 0
                    break
                }
            }
        }

        let vtp = []
        vtp[getEntityUpper() +  ' #'] = gTasksFilteredArray[i].k
        vtp['k'] = gTasksFilteredArray[i].k
        for (let j = 0; j < gTaskAttributes.length; j++) {
            vtp[gTaskAttributes[j].field] = gTasksFilteredArray[i][gTaskAttributes[j].id].replaceAll('^^',',')
        }

        for (let j = 0; j < tempActivityArray.length; j++) {
            if (gTimeMetric === 'duration') {
                if (tempActivityArray[j].duration === -1) {vtp[tempActivityArray[j].activity] = null}
                else {
                    vtp[tempActivityArray[j].activity] = tempActivityArray[j].duration
                    if (tempActivityArray[j].duration < tempActivityArray[j].min) {tempActivityArray[j].min = tempActivityArray[j].duration}
                    if (tempActivityArray[j].duration > tempActivityArray[j].max) {tempActivityArray[j].max = tempActivityArray[j].duration}
                }
            }
            if (gTimeMetric === 'count') {
                if (tempActivityArray[j].count === -1) {vtp[tempActivityArray[j].activity] = null}
                else {
                    vtp[tempActivityArray[j].activity] = tempActivityArray[j].count
                    if (tempActivityArray[j].count < tempActivityArray[j].min) {tempActivityArray[j].min = tempActivityArray[j].count}
                    if (tempActivityArray[j].count > tempActivityArray[j].max) {tempActivityArray[j].max = tempActivityArray[j].count}
                }
            }
            if (gTimeMetric === 'worklogs') {
                if (tempActivityArray[j].worklogs === -1) {vtp[tempActivityArray[j].activity] = null}
                else {
                    vtp[tempActivityArray[j].activity] = tempActivityArray[j].worklogs
                    if (tempActivityArray[j].worklogs < tempActivityArray[j].min) {tempActivityArray[j].min = tempActivityArray[j].worklogs}
                    if (tempActivityArray[j].worklogs > tempActivityArray[j].max) {tempActivityArray[j].max = tempActivityArray[j].worklogs}
                }
            }
            if (gTimeMetric === 'customer_comments') {
                if (tempActivityArray[j].customer_comments === -1) {vtp[tempActivityArray[j].activity] = null}
                else {
                    vtp[tempActivityArray[j].activity] = tempActivityArray[j].customer_comments
                    if (tempActivityArray[j].worklogs < tempActivityArray[j].min) {tempActivityArray[j].min = tempActivityArray[j].customer_comments}
                    if (tempActivityArray[j].worklogs > tempActivityArray[j].max) {tempActivityArray[j].max = tempActivityArray[j].customer_comments}
                }
            }
            if (gTimeMetric === 'internal_comments') {
                if (tempActivityArray[j].customer_comments === -1) {vtp[tempActivityArray[j].activity] = null}
                else {
                    vtp[tempActivityArray[j].activity] = tempActivityArray[j].internal_comments
                    if (tempActivityArray[j].worklogs < tempActivityArray[j].min) {tempActivityArray[j].min = tempActivityArray[j].internal_comments}
                    if (tempActivityArray[j].worklogs > tempActivityArray[j].max) {tempActivityArray[j].max = tempActivityArray[j].internal_comments}
                }
            }
            if (gTimeMetric === 'time_spent') {
                if (tempActivityArray[j].customer_comments === -1) {vtp[tempActivityArray[j].activity] = null}
                else {
                    vtp[tempActivityArray[j].activity] = tempActivityArray[j].time_spent
                    if (tempActivityArray[j].worklogs < tempActivityArray[j].min) {tempActivityArray[j].min = tempActivityArray[j].time_spent}
                    if (tempActivityArray[j].worklogs > tempActivityArray[j].max) {tempActivityArray[j].max = tempActivityArray[j].time_spent}
                }
            }
        }
        vtp['ID'] = gTasksFilteredArray[i].id
        vtp['Variant'] = gTasksFilteredArray[i].v
        vtp['ProcessTime'] = now()
        vtp['Summary'] = gTasksFilteredArray[i].summary
        vtp['Close Time'] = gTasksFilteredArray[i].t2
        vtp['Create Time'] = gTasksFilteredArray[i].t1
        vtp['Duration'] = gTasksFilteredArray[i].d
        vtp['Worklogs'] = gTasksFilteredArray[i].worklog.length
       
        rows.push(vtp)            
        for (let j = 0; j < tempActivityArray.length; j++) {
            tempActivityArray[j].duration = -1
            tempActivityArray[j].count = -1
            tempActivityArray[j].worklogs = -1
            tempActivityArray[j].customer_comments = -1
            tempActivityArray[j].internal_comments = -1
            tempActivityArray[j].time_spent = -1
        }
    }

    // remove columns that contain all null values
    gAAValidKeys = []
    for(var key  in rows[0]){ 
        let keyOK = false
        for (let i = 0; i < rows.length; i++) { 
            if (rows[i][key] !== null && rows[i][key] !== '') {keyOK = true; gAAValidKeys.push(key); break}
        }
    }
    gAARows = []
    for (let i = 0; i < rows.length; i++) { 
        let vtp = []
        for (let j = 0; j < gAAValidKeys.length; j++) { 
            let key = gAAValidKeys[j]
            vtp[key] = rows[i][key]
        }
        gAARows.push(vtp)
    }
    gInitialAALoad = true
    if (gTimeColors === true) {
        for (let i = 0; i < tempActivityArray.length; i++) {
            let activity = tempActivityArray[i].activity

            let validActivity = false
            for (let j = 0; j < gAAValidKeys.length; j++) { 
                if ( gAAValidKeys[j] === activity) validActivity = true
            }
            if (validActivity === true) {
            // find out the min and max and add the range value columns
                let min = tempActivityArray[i].min
                let max = tempActivityArray[i].max
                let range = (max - min) / 10
                for (let j = 0; j < gAARows.length; j++) {
                    let v = gAARows[j][activity]
                    let color = ''
                    if (v !== null) {
                        if (gTimeMetric === 'duration' || gTimeMetric === 'count'|| gTimeMetric === 'timespent' ) {
                            if (v >= min && v <= min + (range * 1)) color = '#198C00' 
                            if (v > min + (range * 1) && v <= min + (range * 2)) color = '#4BA500' 
                            if (v > min + (range * 2) && v <= min + (range * 3)) color = '#7DBF00' 
                            if (v > min + (range * 3) && v <= min + (range * 4)) color = '#AED700' 
                            if (v > min + (range * 4) && v <= min + (range * 5)) color = '#EBF500' 
                            if (v > min + (range * 5) && v <= min + (range * 6)) color = '#FFE800' 
                            if (v > min + (range * 6) && v <= min + (range * 7)) color = '#FFB401' 
                            if (v > min + (range * 7) && v <= min + (range * 8)) color = '#FF8100' 
                            if (v > min + (range * 8) && v <= min + (range * 9)) color = '#FF4F00' 
                            if (v > min + (range * 9) && v <= min + (range * 10)) color = '#FF1A00' 
                        } else {
                            if (v >= min && v <= min + (range * 1)) color = '#FF1A00' 
                            if (v > min + (range * 1) && v <= min + (range * 2)) color = '#FF4F00' 
                            if (v > min + (range * 2) && v <= min + (range * 3)) color = '#FF8100' 
                            if (v > min + (range * 3) && v <= min + (range * 4)) color = '#FFB401' 
                            if (v > min + (range * 4) && v <= min + (range * 5)) color = '#FFB401' 
                            if (v > min + (range * 5) && v <= min + (range * 6)) color = '#FFE800' 
                            if (v > min + (range * 6) && v <= min + (range * 7)) color = '#AED700' 
                            if (v > min + (range * 7) && v <= min + (range * 8)) color = '#7DBF00' 
                            if (v > min + (range * 8) && v <= min + (range * 9)) color = '#4BA500' 
                            if (v > min + (range * 9) && v <= min + (range * 10)) color = '#198C00' 
                        }
                        gAARows[j][activity + '_bc'] = color
                    }
                }
            }
        }

    }
    return gAARows
}

export function getTimeColumns () {  
    let activityArray = getTimeActivities()
    let rows = []
    let vtp = {}
    vtp['headername'] = getEntityUpper() + ' #'
    vtp['field']  = getEntityUpper() + ' #'
    vtp['enableRowGroup'] = false
    vtp['hide'] = false
    rows.push(vtp)

    vtp = {}
    vtp['headername'] = 'Summary'
    vtp['field']  = 'Summary'
    vtp['enableRowGroup'] = false
    vtp['hide'] = true
    rows.push(vtp)

    vtp = {}
    vtp['headername'] = 'Create Time'
    vtp['field']  = 'Create Time'
    vtp['enableRowGroup'] = false
    vtp['hide'] = true
    vtp['filter'] = 'agDateColumnFilter',
    rows.push(vtp)

    vtp = {}
    vtp['headername'] = 'Close Time'
    vtp['field']  = 'Close Time'
    vtp['enableRowGroup'] = false
    vtp['hide'] = true
    vtp['filter'] = 'agDateColumnFilter',
    rows.push(vtp)

    vtp = {}
    vtp['headername'] = 'Duration'
    vtp['field']  = 'Duration'
    vtp['enableRowGroup'] = false
    vtp['hide'] = true
    vtp['filter'] = 'agNumberColumnFilter'
    vtp['aggFunc'] = gTimeAggregation
    rows.push(vtp)

    for (let j = 0; j < gTaskAttributes.length; j++) {
        vtp = {}
        vtp['headername'] = gTaskAttributes[j].field
        vtp['field'] = gTaskAttributes[j].field
        vtp['enableRowGroup'] = true
        vtp['hide'] = true
        rows.push(vtp)
    }
    
    for (let j = 0; j < activityArray.length; j++) {

        let validActivity = false
        for (let i = 0; i < gAAValidKeys.length; i++) {
            if (gAAValidKeys[i] === activityArray[j].activity) {validActivity = true; break}
        }

        if (validActivity === true ) {
            vtp = {}
            vtp['headername'] = activityArray[j].activity
            vtp['field'] = '^^^' + activityArray[j].activity
            vtp['enableRowGroup'] = false
            vtp['hide'] = false
            vtp['filter'] = 'agSetColumnFilter'
            vtp['aggFunc'] = gTimeAggregation
            rows.push(vtp)

            vtp = {}
            vtp['field'] = activityArray[j].activity + '_bc'
            vtp['hide'] = true
            vtp['suppressColumnsToolPanel'] = true
            vtp['suppressFiltersToolPanel'] = true
            rows.push(vtp)
        }
    }
    vtp = {}
    vtp['headername'] = 'Variant'
    vtp['field'] = 'Variant'
    vtp['enableRowGroup'] = false
    vtp['hide'] = true
    vtp['filter'] = 'agNumberColumnFilter'
    rows.push(vtp)

    vtp = {}
    vtp['headername'] = 'ID'
    vtp['field'] = 'ID'
    vtp['enableRowGroup'] = false
    vtp['hide'] = true
    vtp['filter'] = 'agNumberColumnFilter'
    vtp['suppressColumnsToolPanel'] = true
    vtp['suppressFiltersToolPanel'] = true
    rows.push(vtp)

    vtp = {}
    vtp['headername'] = 'ProcessTime'
    vtp['field'] = 'ProcessTime'
    vtp['enableRowGroup'] = false
    vtp['hide'] = true
    vtp['filter'] = ''
    vtp['suppressColumnsToolPanel'] = true
    vtp['suppressFiltersToolPanel'] = true
    rows.push(vtp)

    vtp = {}
    vtp['headername'] = 'k'
    vtp['field']  = 'k'
    vtp['enableRowGroup'] = false
    vtp['hide'] = true
    vtp['suppressColumnsToolPanel'] = true
    vtp['suppressFiltersToolPanel'] = true
    rows.push(vtp)

    return rows
}

export async function setSelectedTimeTasks(tasks,groups) {
    let ctr = 0
    gTaskArray.sort((a, b) => a.id - b.id);
    gTasksFilteredArray = []
    for (let i = 0; i < tasks.length; i++) {

        let validRec = true

        for (let j = 0; j < groups.length; j++) {
            if (tasks[i][groups[j].field] !== groups[j].value) {
                validRec = false
                break
            }
        }
        if (validRec === true) gTasksFilteredArray.push(gTaskArray[tasks[i].id])
    }
}

function getTimeActivities () {

    gTaskArray.sort((a, b) => a.k.localeCompare(b.k));
    gEventLogArray.sort((a, b) => a.eid - b.eid);

    gActivityArray.sort((a, b) => a.activity_type.localeCompare(b.activity_type));
    if (gTimeActivityType === '') gTimeActivityType = gActivityArray[2].activity_type

    let endNode = 0;
    for (let j = 0; j < gActivityArray.length; j++) {
        if (gActivityArray[j].end_node == true ) {
            endNode = gActivityArray[j].id;
        }
    }
    let activityArray = []
    for (let i = 0; i < gTaskArray.length; i++) {

        for (let j = gTaskArray[i].si; j < gTaskArray[i].fi + 1; j++) {
            if (gEventLogArray[j].t != endNode && gEventLogArray[j].at === gTimeActivityType) {
                let activityExists = false
                for (let k = 0; k < activityArray.length; k++) {
                    if (activityArray[k].id === gEventLogArray[j].t) {
                        activityExists = true
                        break
                    }
                }
                if (activityExists === false) {
                    let vtp = {}
                    vtp['id'] = gEventLogArray[j].t
                    vtp['activity'] = ''
                    vtp['duration'] = 0
                    vtp['count'] = 0
                    activityArray.push(vtp)
                }
            }
        }
    }

    for (let i = 0; i < activityArray.length; i++) {
        for (let j = 0; j < gActivityArray.length; j++) {
            if (gActivityArray[j].id === activityArray[i].id) {
                activityArray[i].activity = gActivityArray[j].activity
                break
            }
        }
    }
    return activityArray

}


export function formatTime (totalSeconds) {
    if (totalSeconds === null || totalSeconds === undefined) return '-'

    let ShowDurationDays = false
    let ShowDurationHours = false
    let ShowDurationMinutes = false
    let ShowDurationSeconds = false

    if (gTimeDurationFormat === 'DD:HH:MM' ) {
        ShowDurationDays = true
        ShowDurationHours = true
        ShowDurationMinutes = true
        ShowDurationSeconds = false
    }
    if (gTimeDurationFormat === 'DD:HH:MM:SS' ) {
        ShowDurationDays = true
        ShowDurationHours = true
        ShowDurationMinutes = true
        ShowDurationSeconds = true
    }
    if (gTimeDurationFormat === 'DD:HH' ) {
        ShowDurationDays = true
        ShowDurationHours = true
        ShowDurationMinutes = false
        ShowDurationSeconds = false
    }
    if (gTimeDurationFormat === 'DD' ) {
        ShowDurationDays = true
        ShowDurationHours = false
        ShowDurationMinutes = false
        ShowDurationSeconds = false
    }
    if (gTimeDurationFormat === 'HH:MM' ) {
        ShowDurationDays = false
        ShowDurationHours = true
        ShowDurationMinutes = true
        ShowDurationSeconds = false
    }
    if (gTimeDurationFormat === 'HH:MM:SS' ) {
        ShowDurationDays = false
        ShowDurationHours = true
        ShowDurationMinutes = true
        ShowDurationSeconds = true
    }
    if (gTimeDurationFormat === 'HH' ) {
        ShowDurationDays = false
        ShowDurationHours = true
        ShowDurationMinutes = false
        ShowDurationSeconds = false
    }

        // if days not selected, add days * 24 to hours
        let days = Math.floor(totalSeconds / 86400);
        totalSeconds %= 86400;
        let hours = Math.floor(totalSeconds / 3600);
        totalSeconds %= 3600;
        let minutes = Math.floor(totalSeconds / 60);
        totalSeconds %= 60;
        let seconds = Math.floor(totalSeconds);
    
        let duration_str = '';
        if (days >= 1 && ShowDurationDays == true) {
            duration_str = duration_str + days + 'd ';
        }
        if (hours >= 1 && ShowDurationHours == true) {
            if (ShowDurationDays == false && days >= 1) {
                hours = hours + days * 24;
            }
            duration_str = duration_str + hours + 'h ';
        }
        if (minutes >= 1 && ShowDurationMinutes == true) {
            if (ShowDurationHours == false && hours >= 1) {
                minutes = minutes + hours * 60;
            }
            duration_str = duration_str + minutes + 'm ';
        }
        if (seconds >= 1 && ShowDurationSeconds == true) {
            if (ShowDurationMinutes == false && ShowDurationHours == false && ShowDurationDays == false) {
                seconds = seconds + (minutes * 60) + (days * 84600) + (hours * 3600)
            }
            if (ShowDurationMinutes == false && ShowDurationHours == false && ShowDurationDays == true) {
                seconds = seconds + (minutes * 60) + (hours * 3600)
            }
            duration_str = duration_str + seconds + 's ';
        }
        if (duration_str.includes('Na')) {
            duration_str = '';
        }
        if (duration_str == '' && ShowDurationDays == true) {
            duration_str = '0d ';
        }
        if (duration_str == '0d ' && ShowDurationHours == true) {
            duration_str = '0h ';
        }
        if (duration_str == '0h ' && ShowDurationMinutes == true) {
            duration_str = '0m ';
        }
        if (duration_str == '0m ' && ShowDurationSeconds == true) {
            duration_str = '0s ';
        }
        return duration_str;

}

export function getProcessModelTitle() {
    return gProcessModelTitle
}


export function getAiConsultantContent(column) {
    const map = {
        ai_process_health_assessment:       gAiExecutiveAssessment,
        ai_intelligence:  gAiImprovementOpportunities,
        ai_consulting_report:              gAiOpportunities,
        ai_blueprint:                  gAiBlueprint,
        ai_execution_strategy:     gAiImplementationRoadmap,
        ai_framework_assessment:   gAiFrameworkAssessment,
    };
    return map[column] || null;
}

export function getActivityArray() {
    return gActivityArray
}


export function getTimeInActivitySource() {
    return gTimeInActivitySource
}

export const setTimeInActivitySource = (source) => {
    gTimeInActivitySource = source
}

export function setDiagram(diagram) {
    if (diagram === 'process_miner') gCurrentDiagram = gDiagramPV
    if (diagram === 'decomposition_tree') gCurrentDiagram = gDiagramDecompositionTree
    if (diagram === 'cluster_insights') gCurrentDiagram = gDiagramCluster
    if (diagram === 'influence_analysis') gCurrentDiagram = gDiagramInfluenceAnalysis
}

export function getDiagram(diagram) {
    if (diagram === 'process_miner') return gDiagramPV
    if (diagram === 'decomposition_tree') return gDiagramDecompositionTree
    if (diagram === 'cluster_insights') return gDiagramCluster
    if (diagram === 'influence_analysis') return gDiagramInfluenceAnalysis
}

export function homeStats() {
    if (gSaveFilteredOnly == false) {
        return gEventsAll;
    } else {
        return gEventsFiltered;
    }
}

export function tempib() {
    let ctr = 0
    for (let i = 0; i < gVariantArray.length; i++) {
        if (gVariantArray[i].selected === 1) ctr ++
    }
    return ctr
}


  function calculateDuration(fromTime,toTime,task) {
    if (gCalendarExists === true) return calculateBusinessDuration(fromTime, toTime);
    const date1 = new Date(String(fromTime || '').replace(' ', 'T'));
    const date2 = new Date(String(toTime || '').replace(' ', 'T'));
    if (!Number.isFinite(date1.getTime()) || !Number.isFinite(date2.getTime()) || date2 <= date1) return 0;
    return (date2 - date1) / 1000;

  }
  
  function endOfDay (currentDate) {
    const today = new Date()
    const tomorrowTemp = new Date(currentDate)
    tomorrowTemp.setDate(tomorrowTemp.getDate() + 1)
    var tomorrow_date = tomorrowTemp.getDate();
    var tomorrow_month = tomorrowTemp.getMonth() + 1;
    var tomorrow_year = tomorrowTemp.getFullYear();
    return new Date(tomorrow_year + '-' + tomorrow_month + '-' + tomorrow_date )
  }
  
  function startOfDay (currentDate) {
    const today = new Date()
    const tomorrowTemp = new Date(currentDate)
    tomorrowTemp.setDate(tomorrowTemp.getDate())
    var tomorrow_date = tomorrowTemp.getDate();
    var tomorrow_month = tomorrowTemp.getMonth() + 1;
    var tomorrow_year = tomorrowTemp.getFullYear();
    return new Date(tomorrow_year + '-' + tomorrow_month + '-' + tomorrow_date )
  }
  
  function daysArray (start, end) {
      for(var arr=[],dt=new Date(start); dt<=new Date(end); dt.setDate(dt.getDate()+1)){arr.push(new Date(dt));}
      return arr;
  };


export function getDiscoveryRules() {
    return gDiscoveryRules
}


export function getDiscoveryRulesEdited() {
    return gDiscoveryRulesEdited
}

export function getFilters() {
    return gFilters
}

export const setDiscoveryRulesEdited = (edited) => {
    gDiscoveryRulesEdited = edited
}

const sleep = ms => new Promise(r => setTimeout(r, ms));

//cost functions
export function costsSummary() {
    let vtp = [];
    let costsArray = [];
    for (let i = 0; i < gCosts.length; i++) {
        vtp = [];
        vtp['costID'] = gCosts[i].costID;
        vtp['description'] = gCosts[i].description;
        vtp['type'] = gCosts[i].type;
        vtp['fromActivity'] = gCosts[i].fromActivityStr;
        vtp['toActivity'] = gCosts[i].toActivityStr;
        vtp['events'] = gCosts[i].events;
        vtp[gEntityUpper + 's'] = gCosts[i].issues;
        vtp['actual_cost'] = gCosts[i].actual_cost
        if (gCosts[i].reductionType === 'N/A') {
            vtp['forecast_cost'] = -1
            vtp['cost_saving'] = -1
            vtp['perc_cost_saving'] = -1
        }
        else {
            vtp['forecast_cost'] = gCosts[i].forecast_cost
            vtp['cost_saving'] = gCosts[i].actual_cost - gCosts[i].forecast_cost
            vtp['perc_cost_saving'] = ((gCosts[i].actual_cost - gCosts[i].forecast_cost) /  gCosts[i].actual_cost);
        }
        
        if (gCosts[i].costType === 'fixed-cost') vtp['costType'] = 'Fixed Cost';
        if (gCosts[i].costType === 'perday') vtp['costType'] = 'Per day';
        if (gCosts[i].costType === 'perhour') vtp['costType'] = 'Per hour';
        if (gCosts[i].costType === 'perminute') vtp['costType'] = 'Per minute';
        vtp['cost'] = gCosts[i].cost;

        if (gCosts[i].reductionType === 'N/A') vtp['forecast_cost_calculation'] = 'N/A'
        if (gCosts[i].reductionType === 'fixed-cost') vtp['forecast_cost_calculation'] = 'Fixed Cost'
        if (gCosts[i].reductionType === 'duration-actual') vtp['forecast_cost_calculation'] = 'Duration - Actual'
        if (gCosts[i].reductionType === 'duration-percentage') vtp['forecast_cost_calculation'] = 'Duration - %'

        if (gCosts[i].variantType === 'all_variants') vtp['variantType'] = 'All variants'
        if (gCosts[i].variantType === 'selected_variants') vtp['variantType'] = 'Selected variants'
        if (gCosts[i].issueType === 'all_issues') vtp['issueType'] = 'All'
        if (gCosts[i].issueType === 'filtered_issues') vtp['issueType'] = 'Filtered'
        let details = []
        if (gCosts[i].variantType === 'selected_variants')
        {
            let detailVTP = [];
            detailVTP['header'] = 1;
            detailVTP['text'] = 'Variants'
            details.push(detailVTP);
            for (let j = 0; j < gCosts[i].selectedVariants.length; j++) {
                detailVTP = [];
                detailVTP['header'] = 0;
                detailVTP['text'] = gCosts[i].selectedVariants[j].n
                details.push(detailVTP);
            }
        }

        vtp['details'] = details

        costsArray.push(vtp);
    }
    costsArray.sort((a, b) => a.description.localeCompare(b.description));
    return costsArray;
}


export function deleteCostRule(costID) {
    let costRule
    for (let j = 0; j < gCosts.length; j++) {
        if (gCosts[j].costID = costID) {
            costRule = gCosts[j]
            break
        }
    }   
    costRule.mode = 'delete'
    updateStepCost(costRule,'deleteCostRule')
}

export function updateStepCost(costRule,source) {
    let fromActivityStr = '';
    let toActivityStr = '';
    if (costRule.mode == 'new' || costRule.mode == 'edit') {
        if (costRule.type == 'step') {
            let vtp = [];
            vtp['fromActivity'] = parseInt(costRule.fromActivity);
            for (let j = 0; j < gActivityArray.length; j++) {
                if (gActivityArray[j].id == parseInt(costRule.fromActivity)) {
                    fromActivityStr = gActivityArray[j].activity;
                    break;
                }
            }
            vtp['toActivity'] = parseInt(costRule.toActivity);
            for (let j = 0; j < gActivityArray.length; j++) {
                if (gActivityArray[j].id == parseInt(costRule.toActivity)) {
                    toActivityStr = gActivityArray[j].activity;
                    break;
                }
            }
        }
    }
    if (costRule.mode == 'edit' || costRule.mode == 'delete') {
        for (let k = 0; k < gCosts.length; k++) {
            if (gCosts[k].costID === costRule.costID) {
                gCosts.splice(k, 1);
                break;
            }
        }
    }

    let vtp = {};
    if (costRule.mode == 'new' || costRule.mode == 'edit') {

        let costID = 0;
        for (let j = 0; j < gCosts.length; j++) {
            if (gCosts[j].costID > costID) costID = gCosts[j].costID;
        }   
        costID = costID + 100;

        vtp['costID'] = costID
        vtp['description'] = costRule.description.trim();
        vtp['type'] = costRule.type; // step
        vtp['fromActivity'] = costRule.fromActivity;
        vtp['fromActivityStr'] = fromActivityStr;
        vtp['toActivity'] = costRule.toActivity;
        vtp['toActivityStr'] = toActivityStr;

        vtp['variantType'] = costRule.variantType;
        vtp['selectedVariants'] = gVariantPaneVariants

        vtp['issueType'] = costRule.issueType;
        vtp['conditionsArray'] = gFilterConditions;

        vtp['costType'] = costRule.costType;
        vtp['cost'] = costRule.cost;
        vtp['reductionType'] = costRule.reductionType;
        vtp['reductionPercentage'] = Number(costRule.reductionPercentage);
        vtp['reductionCost'] = Number(costRule.reductionCost);
        vtp['reductionDuration'] = Number(costRule.reductionDuration);
        vtp['reductionValue'] = costRule.reductionValue;

       
        gCosts.push(vtp);
        processCost(vtp, costRule.mode, source);
    }

    if (costRule.mode == 'delete') {
        processCost(costRule, 'delete', source);
    }
    updateCost({ eventEmitter: gEventEmitter });
}

export function processCost(cost, mode, source) { 
    gSaveModel = true
    let vtp = [];
    let events = 0;
    let tasks = 0;
    let key = '';
    key = '$r-' + cost.costID;
    if (mode == 'delete' || mode == 'edit') {
        for (let i = 0; i < gEventLogArray.length; i++) {
            if (gEventLogArray[i][key] === 1) {
                gEventLogArray[i][key] = 0;
                for (let j = 0; j < gEventLogArray[i].costs.length; j++) {
                    if (gEventLogArray[i].costs[j].costID === key) {
                        gEventLogArray[i].actual_cost = gEventLogArray[i].actual_cost - gEventLogArray[i].costs[j].actualCost;
                        gEventLogArray[i].costs.splice(j, 1);
                        break;
                    }
                }
            }
        }
    }

    if (mode == 'new' || mode == 'edit') {
        gEventLogArray.sort((a, b) => a.filtered - b.filtered || a.k.localeCompare(b.k));
        gTaskArray = gTaskArray.sort((a, b) => a.id - b.id);

        // determine valid variants
        let validVariants = [];
        for (let i = 0; i < gVariantArray.length; i++) {
            let validVariant = true;
            if (cost.variantType == 'selected_variants') {
                validVariant = false;
                for (let j = 0; j < gVariantPaneVariants.length; j++) {
                    if (gVariantArray[i].v == gVariantPaneVariants[j].v) {
                        validVariant = true;
                        break;
                    }
                }
            }
            if (validVariant == true) {
                vtp = [];
                vtp['v'] = parseInt(gVariantArray[i].v);
                validVariants.push(vtp);
            }
        }

        let task = '';

        let fromActivityInt = 0
        let toActivityInt = 0

        for (let j = 0; j < gActivityArray.length; j++) {
            if (gActivityArray[j].activity == cost.fromActivityStr) {fromActivityInt = gActivityArray[j].id}
            if (gActivityArray[j].activity == cost.toActivityStr) {toActivityInt = gActivityArray[j].id}
            if (fromActivityInt > 0 && toActivityInt > 0) {break}
        }

        let total_actual_cost = 0
        let total_forecast_cost = 0
        for (let i = 0; i < gEventLogArray.length; i++) {
            gEventLogArray[i][key] = 0;
            if (gEventLogArray[i].filtered == 1 && cost.issueType == 'filtered_tasks') {
                break;
            }

            let validEvent = false

            if (
                parseInt(gEventLogArray[i].f) == fromActivityInt &&
                parseInt(gEventLogArray[i].t) == toActivityInt
            ) {
                validEvent = true;
            }
            if (validEvent == true) {
                validEvent = false;
                for (let j = 0; j < validVariants.length; j++) {
                    if (gEventLogArray[i].v == validVariants[j].v) {
                        validEvent = true;
                        break;
                    }
                }

                if (validEvent == true) {
                    events++;
                    if (task != gEventLogArray[i].k) {
                        tasks++;
                    }
                    gEventLogArray[i][key] = 1;

                    let actualCost = 0;
                    let duration = 0;
                    let forecastCost = null;

                    if (cost.costType === 'fixed-cost') actualCost = cost.cost;
                    if (cost.costType === 'perday') actualCost = cost.cost * (gEventLogArray[i].d / 86400);
                    if (cost.costType === 'perhour') actualCost = cost.cost * (gEventLogArray[i].d / 3600);
                    if (cost.costType === 'permin') actualCost = cost.cost * (gEventLogArray[i].d / 60);

                    if (cost.reductionType != 'N/A') {
                        if (cost.reductionType === 'fixed-cost') {
                            forecastCost = actualCost - cost.reductionCost
                            if (forecastCost < 0) forecastCost = 0
                        }
                        if (cost.reductionType === 'duration-percentage' && gEventLogArray[i].d != 0) {
                            duration = gEventLogArray[i].d * ((100 - parseFloat(cost.reductionPercentage)) / 100);
                            if (duration < 0) duration = 0;
                            if (gEventLogArray[i].d > 0) forecastCost = (duration / gEventLogArray[i].d) * actualCost;
                        }

                        if (cost.reductionType === 'duration-actual') {
                            let reductionDuration = 0
                            if (cost.reductionValue === 'mins') reductionDuration = cost.reductionDuration * 60;
                            if (cost.reductionValue === 'hrs') reductionDuration = cost.reductionDuration * 3600;
                            if (cost.reductionValue === 'days') reductionDuration = cost.reductionDuration * 86400;
    
                            duration = gEventLogArray[i].d - reductionDuration;
                            if (duration < 0) duration = 0;
                            if (gEventLogArray[i].d > 0) forecastCost = (duration / gEventLogArray[i].d) * actualCost;
                        }
                    }

                    let vtp = [];
                    let costs = gEventLogArray[i].costs;
                    vtp['costID'] = key;
                    vtp['actualCost'] = actualCost;
                    vtp['forecastCost'] = forecastCost;
                    costs.push(vtp);
                    gEventLogArray[i].costs = costs;

                    // calculate total actual cost from costs
                    actualCost = 0;
                    forecastCost = 0
                    for (let j = 0; j < gEventLogArray[i].costs.length; j++) {
                        if (gEventLogArray[i].costs[j].costID.startsWith('$') === true) {
                            actualCost = actualCost + gEventLogArray[i].costs[j].actualCost;
                            forecastCost = forecastCost + gEventLogArray[i].costs[j].forecastCost;
                        }
                    }
                    gEventLogArray[i].actual_cost = actualCost;
                    gEventLogArray[i].forecast_cost = forecastCost;
                    task = gEventLogArray[i].k;
                    total_actual_cost = total_actual_cost + actualCost
                    total_forecast_cost = total_forecast_cost + forecastCost

                }
            }
        }

        let i = 0
        for (i = 0; i < gCosts.length; i++) {
            if (gCosts[i].costID === cost.costID) break
        }
        gCosts[i].actual_cost = total_actual_cost
        gCosts[i].forecast_cost = total_forecast_cost
        gCosts[i].events = events
        gCosts[i].issues = tasks

    }
    
    if (source != 'model_import') {
        //updateForecastCost();
        updateDiscoveryRuleCosts()
        updateCostMetrics('processCost');
        generateTaskAnalyticsArray();
        updateSlicedVariables();
        updateAttributes();
        rebuildPVDiagram('processCost');
    }
}

function updateCostMetrics(source) {
    // update variant cost
    for (let i = 0; i < gVariantArray.length; i++) {
        gVariantArray[i].actual_cost = 0;
        gVariantArray[i].forecast_cost = 0;
    }
    let variant = '';
    let variantActualCost = 0;
    let variantForecastCost = 0;

    gEventLogArray = gEventLogArray.sort((a, b) => a.filtered - b.filtered || a.v - b.v);
    gVariantArray = gVariantArray.sort((a, b) => a.id - b.id);

    // update variant cost
    for (let i = 0; i < gEventLogArray.length; i++) {
        if (gEventLogArray[i].filtered == 1) {
            break;
        }

        if (i > 0 && variant != gEventLogArray[i].v) {
            gVariantArray[gEventLogArray[i - 1].vid].actual_cost = variantActualCost;
            gVariantArray[gEventLogArray[i - 1].vid].forecast_cost = variantForecastCost;
            variantActualCost = 0;
            variantForecastCost = 0;
        }
        variantActualCost = variantActualCost + gEventLogArray[i].actual_cost;
        variantForecastCost = variantForecastCost + gEventLogArray[i].forecast_cost;
        variant = gEventLogArray[i].v;
    }

    gVariantArray[gEventLogArray[gEventLogArray.length - 1].vid].actual_cost == variantActualCost;
    gVariantArray[gEventLogArray[gEventLogArray.length - 1].vid].forecast_cost == variantForecastCost;

    // update task cost
    for (let i = 0; i < gTaskArray.length; i++) {
        gTaskArray[i].actual_cost = 0;
        gTaskArray[i].forecast_cost = 0;
    }

    let task = '';
    let taskActualCost = 0;
    let taskForecastCost = 0;

    gEventLogArray.sort((a, b) => a.filtered - b.filtered || a.k.localeCompare(b.k));
    gTaskArray = gTaskArray.sort((a, b) => a.id - b.id);
    gActualCost = 0;
    gForecastCost = 0;

    for (let i = 0; i < gEventLogArray.length; i++) {
        if (gEventLogArray[i].filtered == 1) {break}

        if (i > 0 && task != gEventLogArray[i].k) {
            gTaskArray[gEventLogArray[i - 1].tid].actual_cost = taskActualCost;
            gTaskArray[gEventLogArray[i - 1].tid].forecast_cost = taskForecastCost;
            taskActualCost = 0;
            taskForecastCost = 0;
        }
        taskActualCost = taskActualCost + gEventLogArray[i].actual_cost;
        taskForecastCost = taskForecastCost + gEventLogArray[i].forecast_cost;
        task = gEventLogArray[i].k;
        gActualCost = gActualCost + gEventLogArray[i].actual_cost;
        gForecastCost = gForecastCost + gEventLogArray[i].forecast_cost;
    }

    gTaskArray[gEventLogArray[gEventLogArray.length - 1].tid].actual_cost == taskActualCost;
    gTaskArray[gEventLogArray[gEventLogArray.length - 1].tid].forecast_cost == taskForecastCost;

    gPercCostSaving = 0;
    gCostSaving = 0;
    if (gActualCost != 0 && gForecastCost != 0) {
        gPercCostSaving = ((gActualCost - gForecastCost) / gActualCost) * 100;
        gCostSaving = gActualCost - gForecastCost;
    }


    let variantCost = 0
    let taskCost = 0

    for (let i = 0; i < gTaskArray.length; i++) {
        taskCost = taskCost + gTaskArray[i].actual_cost
    }

    for (let i = 0; i < gVariantArray.length; i++) {
        variantCost = variantCost + gVariantArray[i].actual_cost
    }
}

export async function processCosts(costs) {   
    for (let i = 0; i < costs.length; i++) {
        gLoadingStatus = 'Processing costs ' + (i + 1)  + ' of ' + costs.length ;  
        updateLoadingStatus({ eventEmitter: gEventEmitter });
        await wait();

        costs[i].mode = 'new'
        updateStepCost(costs[i], 'model_import')
    }
}

export function formatCost(x) {
    if (x < 0 || x === undefined) return ''
    else return '$' + numberWithCommas(x.toFixed(2));
}

export function formatCostDecimal(x) {
    return '$' + numberWithCommas(x.toFixed(2));
}

export function saveCostsGridState(columnState) {
    gCostsGridState = columnState;
}

export function getCostsGridState() {
    return gCostsGridState;
}

export function getSaveModel() {
    return gSaveModel;
}

export function setSaveModel(saveModel) { 
    gSaveModel = saveModel
}

export function editCostModal(props) {   

    let i = 0
    for (i = 0; i < gCosts.length; i++) {
        if (gCosts[i].costID === props.costID) break
    }
    
    openStepCostModal({
        data: {
            description: gCosts[i].description,
            fromActivity: gCosts[i].fromActivity,
            toActivity: gCosts[i].toActivity,
            fromActivityStr: gCosts[i].fromActivityStr,
            toActivityStr: gCosts[i].toActivityStr,
            cost: gCosts[i].cost,
            costID: gCosts[i].costID,
            costType: gCosts[i].costType,
            variantType: gCosts[i].variantType,
            issueType: gCosts[i].issueType,
            mode: 'edit',
            reductionType: gCosts[i].reductionType, 
            reductionPercentage: gCosts[i].reductionPercentage,
            reductionCost: gCosts[i].reductionCost,
            reductionValue: gCosts[i].reductionValue,
            reductionDuration: gCosts[i].reductionDuration,
        },
    });
}

async function updateDiscoveryRuleCosts() { 

    for (let i = 0; i < gDiscoveryRules.length; i++) {
        gDiscoveryRules[i].actual_cost = 0
        gDiscoveryRules[i].forecast_cost = 0
    }
    for (let i = 0; i < gEventLogArray.length; i++) {
        if (gEventLogArray[i].discovery_rules.length > 0 && gEventLogArray[i].costs.length > 0 ) {
            for (let j = 0; j < gEventLogArray[i].discovery_rules.length; j++) {
                let discovery_rule_id =  parseInt(gEventLogArray[i].discovery_rules[j].discovery_rule_id.substring(2,10).trim())
                for (let k = 0; k < gDiscoveryRules.length; k++) {
                    if (gDiscoveryRules[k].discovery_rule_id === discovery_rule_id && gDiscoveryRules[k].calculate_cost_impact === true) {
                        gDiscoveryRules[k].actual_cost = gDiscoveryRules[k].actual_cost + gEventLogArray[i].actual_cost
                        gDiscoveryRules[k].forecast_cost = gDiscoveryRules[k].forecast_cost + gEventLogArray[i].forecast_cost
                        break
                    }
                }
            }
        }
    }
}

function normaliseDiscoveryRuleValue(value, fallback = '') {
    if (value && typeof value === 'object') {
        if (value.value !== undefined) return value.value;
        if (value.display_value !== undefined) return value.display_value;
    }
    return value !== undefined && value !== null ? value : fallback;
}

function normaliseDiscoveryRuleBool(value) {
    value = normaliseDiscoveryRuleValue(value, false);
    if (value === true || value === 1) return true;
    if (value === false || value === 0 || value === null || value === undefined) return false;
    return ['true', '1', 'yes', 'y'].includes(String(value).trim().toLowerCase());
}

function normaliseDiscoveryRuleFilters(value) {
    value = normaliseDiscoveryRuleValue(value, []);
    if (Array.isArray(value)) return value;
    if (!value) return [];
    if (typeof value === 'string') {
        try {
            const parsed = JSON.parse(value);
            return Array.isArray(parsed) ? parsed : [];
        } catch (err) {
            console.warn('Discovery rule filters could not be parsed', err);
            return [];
        }
    }
    return [];
}

function normaliseMasterDiscoveryRule(rule = {}) {
    const issueType = normaliseDiscoveryRuleValue(rule.issue_type, normaliseDiscoveryRuleValue(rule.record_type, normaliseDiscoveryRuleValue(rule.table, 'Generic'))) || 'Generic';
    const discoveryRuleType = normaliseDiscoveryRuleValue(rule.discovery_rule_type, normaliseDiscoveryRuleValue(rule.type, 'Filter'));
    return {
        ...rule,
        id: normaliseDiscoveryRuleValue(rule.sys_id, normaliseDiscoveryRuleValue(rule.id, '')),
        discovery_rule: normaliseDiscoveryRuleValue(rule.discovery_rule, normaliseDiscoveryRuleValue(rule.finding, '')),
        issue_type: issueType,
        record_type: normaliseDiscoveryRuleValue(rule.record_type, issueType),
        activity_type: normaliseDiscoveryRuleValue(rule.activity_type, ''),
        category: normaliseDiscoveryRuleValue(rule.category, ''),
        type: normaliseDiscoveryRuleValue(rule.type, discoveryRuleType),
        discovery_rule_type: discoveryRuleType,
        calculate_cost_impact: normaliseDiscoveryRuleBool(rule.calculate_cost_impact),
        automation_opportunity: normaliseDiscoveryRuleBool(rule.automation_opportunity),
        save_variants: normaliseDiscoveryRuleBool(rule.save_variants),
        save_activities: normaliseDiscoveryRuleBool(rule.save_activities),
        save_steps: normaliseDiscoveryRuleBool(rule.save_steps),
        filters: normaliseDiscoveryRuleFilters(rule.filters || rule.conditions_json || rule.conditions),
    };
}

async function retrieveMasterDiscoveryRules() {
    try {
        if (gAppVersion === 'FORGE') {
            const { invoke } = await loadForgeModule();
            return await invoke('getDiscoveryRules', {});
        }

        if (gAppVersion === 'SNOW') {
            const snApi = await getSnApi();
            if (snApi && typeof snApi.getDiscoveryRules === 'function') {
                return await snApi.getDiscoveryRules();
            }
            console.warn('ServiceNow discovery rules API is not available');
        }
    } catch (err) {
        console.warn('Could not load master discovery rules', err);
    }
    return [];
}

function discoveryRuleMatchesCurrentModel(rule, type, issueType, activityType) {
    const ruleIssueType = String(rule.issue_type || rule.record_type || 'Generic').trim();
    const ruleIssueTypeLower = ruleIssueType.toLowerCase();
    const ruleActivityType = String(rule.activity_type || '').trim().toLowerCase();
    const currentIssueTypes = Array.isArray(issueType) ? issueType : [issueType];
    const currentIssueTypeValues = currentIssueTypes
        .map(value => String(value || '').trim().toLowerCase())
        .filter(Boolean);
    const currentActivityType = String(activityType || '').trim().toLowerCase();

    let issueTypeOK = false;

    if (type === 'issueType') {
        issueTypeOK = currentIssueTypeValues.includes(ruleIssueTypeLower);
    }

    if (type === 'generic') {
        issueTypeOK = ruleIssueTypeLower === 'generic' || ruleIssueTypeLower === '';
    }

    if (!issueTypeOK) return false;

    // ServiceNow master rules are intentionally generic across state/activity fields.
    // Do not reject them because the current model activity type is incident_state,
    // state, lifecycle_state, etc. The rule filters themselves determine applicability.
    if (gAppVersion === 'SNOW') return true;

    // Jira/Forge rules may still be activity-type specific. Blank means applies to any
    // current model activity type.
    return !ruleActivityType || !currentActivityType || ruleActivityType === currentActivityType;
}

async function loadAutomatedDiscoveryRules(type) {

    const issueType = gIssueTypes;
    const activityType = gActivityTypes && gActivityTypes.length > 0 ? gActivityTypes[0].activity_type : '';
    const discoveryRules = (await retrieveMasterDiscoveryRules()).map(normaliseMasterDiscoveryRule);

    if (!discoveryRules || discoveryRules.length === 0) {
        console.warn('No master discovery rules returned for Explorer', { appVersion: gAppVersion, type });
        return;
    }

    const matchingRules = discoveryRules.filter(rule => discoveryRuleMatchesCurrentModel(rule, type, issueType, activityType));

    let discoveryRuleNum = 1;
    for (let k = 0; k < matchingRules.length; k++) {
        const rule = matchingRules[k];
        gLoadingStatus = 'Processing DiscoveryRules ' + discoveryRuleNum + ' of ' + matchingRules.length;
        updateLoadingStatus({ eventEmitter: gEventEmitter });

        await updateDiscoveryRule({
            discovery_rule: rule.discovery_rule,
            id: rule.id,
            mode: 'new',
            category: rule.category,
            type: rule.type,
            discovery_rule_type: rule.discovery_rule_type,
            calculate_cost_impact: rule.calculate_cost_impact,
            discovery_rule_detail: [],
            automation_opportunity: rule.automation_opportunity,
            filters: rule.filters,
            save_variants: rule.save_variants,
            save_activities: rule.save_activities,
            save_steps: rule.save_steps,
        }, '', 'loadDiscoveryRulesGeneric');

        if (String(rule.discovery_rule_type || '').toLowerCase() === 'parent_discovery') {
            await saveDiscoveryChildDiscoveryRules();
        }
        discoveryRuleNum++;
    }
}

export async function loadDiscoveryRulesForCurrentModel() {
    await loadAutomatedDiscoveryRules('issueType');
    await loadAutomatedDiscoveryRules('generic');
}

export function getDataType() {
    return gDataLoadType;
}

export function getFilterStats() {
    return gFilterStats;
}

export async function saveModel(AppVersion) {   
    if (String(AppVersion || '').toUpperCase() === 'WEB') {
        try {
            if (typeof window !== 'undefined') {
                window.dispatchEvent(new CustomEvent('process-advisor-web-save-request', {
                    detail: { modelID: gModelID, canonicalDataset: gCanonicalDataset }
                }));
            }
        } finally {
            return true;
        }
    }
    openProgressModal({status: 'Saving model'})
    await sleep(20) // needed to display Progress
    
    let tempDiscoveryRules = [...gDiscoveryRules]
    /*
    for (let i = 0; i < tempDiscoveryRules.length; i++) {
        for (let k = 0; k < tempDiscoveryRules[i].filters.length; k++) {
            tempDiscoveryRules[i].filters[k].variants = []
        }
    }
    */
    const filters = JSON.stringify(retrieveFiltersArray())
    const visualizer_settings = JSON.stringify(retrieveVisualizerSettings())
    const discoveryRules = JSON.stringify(tempDiscoveryRules)
    const costs = JSON.stringify(retrieveCosts())
    const workflow_configuration = JSON.stringify(getWorkflowConfiguration())
    const workflow_transitions = JSON.stringify(getWorkflowTransitions())
    const workflow_variants = JSON.stringify(getWorkflowVariants())
    if (AppVersion === 'FORGE') {
        const { invoke } = await loadForgeModule();
        let req = await invoke('getProcessModel', {modelID: gModelID });
        let processModels = req[0]

    await invoke('deleteProcessModel', {id: gModelID });
        try {
            await invoke('createProcessModel', {
            id: getModelID(),
            ...preserveProcessModelBillingFields(processModels),
            customer_id: processModels.customer_id,
            name: processModels.name,
            description: processModels.description,
            projects: processModels.projects ,  
            issue_types: processModels.issue_types ,
            activity_types: processModels.activity_types,
            attributes: processModels.attributes,
            jql: processModels.jql,
            from_date: processModels.from_date,
            to_date: processModels.to_date,
            total_issues: processModels.total_issues,
            anonymize: processModels.anonymize,
            attribute_privacy: processModels.attribute_privacy || null,
                consulting_workspace: JSON.stringify(gConsultingWorkspace || createDefaultConsultingWorkspace()),
                ai_report_scope: processModels.ai_report_scope || null,
            calendar: processModels.calendar,
            category: processModels.category,
            schedule_start: processModels.schedule_start,
            schedule_repeat: processModels.schedule_repeat,
            schedule_every: processModels.schedule_every,
            schedule_mon: processModels.schedule_mon,
            schedule_tue: processModels.schedule_tue,
            schedule_wed: processModels.schedule_wed,
            schedule_thu: processModels.schedule_thu,
            schedule_fri: processModels.schedule_fri,
            schedule_sat: processModels.schedule_sat,
            schedule_sun: processModels.schedule_sun,
            schedule_time: processModels.schedule_time,
            schedule_timezone: processModels.schedule_timezone,
            next_schedule_time: processModels.next_schedule_time,
            previous_schedule_time: processModels.previous_schedule_time,
            sample: processModels.sample,
            discovery_rules: discoveryRules,
            issue_comments: processModels.issue_comments,
            issue_worklogs: processModels.issue_worklogs,
            model_comments: processModels.model_comments,
            confluence_space : processModels.confluence_space,
            confluence_parent_page : processModels.confluence_parent_page,
            export_to_confluence : processModels.export_to_confluence,        
            costs: costs,
            filters: filters,
            settings: visualizer_settings,
            workflow_configuration: workflow_configuration,
            workflow_transitions: workflow_transitions,
            workflow_variants: workflow_variants,
            metric_array: processModels.metric_array,
            filtered_count: String(gTasksFiltered || ''),
            ai_process_health_assessment: processModels.ai_process_health_assessment || null,
            ai_intelligence: processModels.ai_intelligence || null,
            ai_consulting_report: processModels.ai_consulting_report || null,
            ai_trend_analysis: processModels.ai_trend_analysis || null,
            ai_execution_strategy: processModels.ai_execution_strategy || null,
            ai_framework_assessment: processModels.ai_framework_assessment || null,
            ai_quick_healthcheck: processModels.ai_quick_healthcheck || null,
            event_log_saved: processModels.event_log_saved || 'true',
            schedule_active: processModels.schedule_active,
            gauges: processModels.gauges,
            show_gauges: processModels.show_gauges,
            activity_group_mappings: processModels.activity_group_mappings || null,
            });
        } catch (err) {
        }  
        
        // NEW: Save filtered event log if filters exist
        
        // Import the filtered event log utilities
        const { saveFilteredEventLog } = await import('@process-advisor/lib/filteredEventLogUtils');
        
        if (filters && filters !== '[]' && filters !== '' && gFilterConditions && gFilterConditions.length > 0) {
            try {
                
                // SIMPLE: Just filter where filtered = 0 (not filtered out)
                const filteredEventLogArray = gEventLogArray.filter(event => event.filtered === 0);
                
                // IMPORTANT: Pass FULL taskArray, not filtered!
                // The filteredEventLogArray has event.tid indices that point to the FULL taskArray
                const result = await saveFilteredEventLog(
                    gModelID,
                    gTaskArray,              // ← FULL taskArray (for index lookups)
                    filteredEventLogArray,   // ← FILTERED events
                    gActivityArray,
                    gTaskAttributes,
                    filters,
                    loadForgeModule
                );
                
                if (result.success) {
                } else {
                    console.error('[SAVE MODEL] ❌ Failed to save filtered event log:', result.error);
                }
            } catch (error) {
                console.error('[SAVE MODEL] ❌ Error saving filtered event log:', error);
            }
        } else {
            try {
                await invoke('clearFilteredEventLog', { modelId: gModelID });
            } catch (error) {
                console.error('[SAVE MODEL] ❌ Error clearing filtered event log:', error);
            }
        }
    }
    if (AppVersion === 'SNOW') {
        const snApi = await getSnApi();
        const processModels = await snApi.getProcessModel(gModelID);
        const payload = {
            // Store in both fields. `findings` is the legacy ServiceNow column used before
            // the UI wording changed to Discovery Rules. `discovery_rules` is used when
            // the newer column exists. The REST update endpoint ignores fields that do
            // not exist, so this is safe across restored/older instances.
            discovery_rules: discoveryRules,
            findings: discoveryRules,
            filters: filters,
            settings: visualizer_settings,
            costs: costs,
            filtered_count: String(gTasksFiltered || ''),
            activity_group_mappings: processModels?.activity_group_mappings || null,
        };
        await snApi.updateProcessModel(gModelID, payload);
    }
    setSaveModel(false)
    closeProgressModal()
}

export function saveDiscoveryRuleModal () {

    let filterSummary = []
    for (let i = 0; i < gFilterConditions.length; i++) {
        filterSummary.push({
            type: gFilterConditions[i].label,
            description: gFilterConditions[i].description,
        });
    }
    openDiscoveryRuleModal({ 
        data: {
            mode: 'new' ,
            source : 'Model',
            category: 'Performance',
            tasks: gVariantTasksSliced,
            filters: gFilterConditions,
            filterSummary: filterSummary,
            automation_opportunity: false,
            calculate_cost_impact: true
        },
    });
}

export async function saveDiscoveryChildDiscoveryRules() {     
    // currentDiscoveryRule should have filter_steps
    let currentDiscoveryRule = gDiscoveryRules[gDiscoveryRules.length - 1]
    let discovery_rule_detail = []
    let parent_discovery_rule = gDiscoveryRules.length-1
    if (currentDiscoveryRule.save_steps === true ) {
        for (let i = 0; i < gUniqueStepsDiscovered.length; i++) { // create a filter discoveryRule for each step     
            let statusText = 'Discovery ' + (i+1) + ' of ' + gUniqueStepsDiscovered.length
            updateProgressModal({status: statusText})       
            let stepFilter = []
            let vtp = []
            vtp['activities'] = []
            vtp['constraint_type'] = 'na'
            vtp['description'] = "Step: " + gUniqueStepsDiscovered[i].from_label + ' -> ' + gUniqueStepsDiscovered[i].to_label
            vtp['duration_actual_from'] = 0
            vtp['duration_actual_to'] = 0
            vtp['duration_operator'] = ''
            vtp['label'] = 'Filter - Step'
            vtp['occurence_actual_from'] = 0
            vtp['occurence_actual_to'] = 0
            vtp['occurence_operator'] = ''
            vtp['operator'] = ''
            vtp['percentile'] = 
            vtp['relative_operator'] = ''
            vtp['retention'] = 'include'
            let vtpSteps = []
            vtpSteps['from_activity'] = gUniqueStepsDiscovered[i].from_label
            vtpSteps['to_activity'] = gUniqueStepsDiscovered[i].to_label
            let steps = []
            steps.push(vtpSteps)
            vtp['steps'] = steps
            vtp['sub_type'] = 'step'
            vtp['type'] = 'filter'
            vtp['value'] = ''
            vtp['variants'] = []
            stepFilter.push(vtp)
            
            // process filter and count issues/events
            processFilters(stepFilter,'',true)
            let filterStats = getFilterStats()

            await updateDiscoveryRule({
                discovery_rule: currentDiscoveryRule.discovery_rule + ': ' + gUniqueStepsDiscovered[i].from_label + ' -> ' + gUniqueStepsDiscovered[i].to_label,
                automation_opportunity: currentDiscoveryRule.automation_opportunity,
                id: '',
                mode: 'new',
                category: currentDiscoveryRule.category,
                filters: stepFilter,
                tasks: filterStats[0].tasks,
                events: filterStats[0].events,
                calculate_cost_impact: currentDiscoveryRule.calculate_cost_impact,
                save_activities: false,
                save_steps: false,
                save_variants: false,
                filter_activities: false,
                filter_variants: false,
                filter_steps: false,
                type: 'Discovery',
                discovery_rule_type: 'child',
                discovery_rule_detail: [],
                parent_discovery_rule: currentDiscoveryRule.discovery_rule,
                parent_discovery_rule_id: currentDiscoveryRule.discovery_rule_id
            },'','saveDiscoveryChildDiscoveryRule')
        }
    }
    if (currentDiscoveryRule.save_activities === true ) {
        for (let i = 0; i < gUniqueActivitiesDiscovered.length; i++) { // create a filter discoveryRule for each step            
            let activityFilter = []
            let vtp = []
            vtp['sub_type'] = 'activity'
            vtp['type'] = 'filter'
            vtp['constraint_type'] = 'na'
            vtp['description'] = "Activity: " + gUniqueActivitiesDiscovered[i].activity 
            vtp['duration_actual_from'] = 0
            vtp['duration_actual_to'] = 0
            vtp['duration_operator'] = ''
            vtp['label'] = 'Filter - Activity'
            vtp['occurence_actual_from'] = 0
            vtp['occurence_actual_to'] = 0
            vtp['occurence_operator'] = ''
            vtp['operator'] = ''
            vtp['percentile'] = 
            vtp['relative_operator'] = ''
            vtp['retention'] = 'include'
            let vtpActivities = []
            vtpActivities['activity'] = gUniqueActivitiesDiscovered[i].activity
            let activities = []
            activities.push(vtpActivities)
            vtp['activities'] = activities
            vtp['variants'] = []
            vtp['steps'] = []
            vtp['value'] = ''
            activityFilter.push(vtp)

            // process filter and count issues/events
            processFilters(activityFilter,'',true)
            let filterStats = getFilterStats()
            await updateDiscoveryRule({
                discovery_rule: currentDiscoveryRule.discovery_rule + ': ' + gUniqueActivitiesDiscovered[i].activity,
                automation_opportunity: currentDiscoveryRule.automation_opportunity,
                id: '',
                mode: 'new',
                category: currentDiscoveryRule.category,
                filters: activityFilter,
                tasks: filterStats[0].tasks,
                events: filterStats[0].events,
                calculate_cost_impact: currentDiscoveryRule.calculate_cost_impact,
                save_activities: false,
                save_steps: false,
                save_variants: false,
                filter_activities: false,
                filter_variants: false,
                filter_steps: false,
                type: 'Discovery',
                discovery_rule_type: 'child',
                discovery_rule_detail: [],
                parent_discovery_rule: currentDiscoveryRule.discovery_rule,
                parent_discovery_rule_id: currentDiscoveryRule.discovery_rule_id
            },'','saveDiscoveryChildDiscoveryRule')
        }
    }                    
    if (currentDiscoveryRule.save_variants === true ) {
        for (let i = 0; i < gUniqueVariantsDiscovered.length; i++) { // create a filter discoveryRule for each variant            
            let variantFilter = []
            let vtp = []
            vtp['sub_type'] = 'variant_discovery'
            vtp['type'] = 'filter'
            vtp['constraint_type'] = 'na'
            vtp['description'] = "Variant: " + gUniqueVariantsDiscovered[i].variant
            vtp['duration_actual_from'] = 0
            vtp['duration_actual_to'] = 0
            vtp['duration_operator'] = ''
            vtp['label'] = 'Filter - Variant'
            vtp['occurence_actual_from'] = 0
            vtp['occurence_actual_to'] = 0
            vtp['occurence_operator'] = ''
            vtp['operator'] = ''
            vtp['percentile'] = 
            vtp['relative_operator'] = ''
            vtp['retention'] = 'include'
            let vtpVariants = []
            vtpVariants['variant'] = gUniqueVariantsDiscovered[i].variant
            let variants = []
            variants.push(vtpVariants)
            vtp['variants'] = variants
            vtp['activities'] = []
            vtp['steps'] = []
            vtp['value'] = ''
            variantFilter.push(vtp)

            // process filter and count issues/events
            processFilters(variantFilter,'',true)
            let filterStats = getFilterStats()
            await updateDiscoveryRule({
                discovery_rule: currentDiscoveryRule.discovery_rule + ': ' + gUniqueVariantsDiscovered[i].variant,
                automation_opportunity: currentDiscoveryRule.automation_opportunity,
                id: '',
                mode: 'new',
                category: currentDiscoveryRule.category,
                filters: variantFilter,
                tasks: filterStats[0].tasks,
                events: filterStats[0].events,
                calculate_cost_impact: currentDiscoveryRule.calculate_cost_impact,
                save_activities: false,
                save_steps: false,
                save_variants: false,
                filter_activities: false,
                filter_variants: false,
                filter_steps: false,
                type: 'Discovery',
                discovery_rule_type: 'child',
                discovery_rule_detail: [],
                parent_discovery_rule: currentDiscoveryRule.discovery_rule,
                parent_discovery_rule_id: currentDiscoveryRule.discovery_rule_id
            },'','saveDiscoveryChildDiscoveryRule')

            let discoveryRules = getDiscoveryRules()

            discovery_rule_detail.push(processDiscoveryRulesSummaryRow(discoveryRules[discoveryRules.length - 1]))
        }
    }      
    gDiscoveryRules[parent_discovery_rule].discovery_rule_detail = discovery_rule_detail
}


  export async function downloadDiscoveryRule(mode) {
    await createDownload()
    const canvas = document.getElementById('downloadCanvas');
    var image = canvas.toDataURL();
    var aDownloadLink = document.createElement('a');
    aDownloadLink.download = gModelFileName + '.png';
    aDownloadLink.href = image;
    aDownloadLink.click();

  }

  export async function downloadDiagram(mode) {
    const canvas = document.getElementById('downloadCanvas');
    const ctx = canvas.getContext('2d')
    let diagram = await processDiagram()
    ctx.drawImage(diagram, 500, 120);

    var image = canvas.toDataURL();
    var aDownloadLink = document.createElement('a');
    aDownloadLink.download = gModelFileName + '.png';
    aDownloadLink.href = image;
    aDownloadLink.click();

  }

  export async function createDownload() {
    
    const canvas = document.getElementById('downloadCanvas');
    const ctx = canvas.getContext('2d')

    let gauges = await processGauges()
    ctx.drawImage(gauges, 500, 10);

    let text = await processDetails()
    ctx.drawImage(text, 10, 10);

    let diagram = await processDiagram()
    ctx.drawImage(diagram, 500, 120);

    return canvas

  }

  export async function processDiagram() {
    let svgImage = gDiagramPV.makeSvg({scale: 1.30});
    var xml = new XMLSerializer().serializeToString(svgImage);
    var svg64 = btoa(xml);
    var b64Start = 'data:image/svg+xml;base64,';
    var image64 = b64Start + svg64;
    var img = new Image();
    img.src = image64
    return img
  }
  
  export async function processGauges() {
    const svgImage = elementToSVG(document.getElementById('#gauges'))
    await inlineResources(svgImage.documentElement)

    var xml = new XMLSerializer().serializeToString(svgImage);
    var svg64 = btoa(xml);
    var b64Start = 'data:image/svg+xml;base64,';
    var image64 = b64Start + svg64;
    var img = new Image();
    img.src = image64
    return img
  }

  export async function processDetails() {
    const svgImage = elementToSVG(document.getElementById('#discoveryRuleDetails'))
    await inlineResources(svgImage.documentElement)

    var xml = new XMLSerializer().serializeToString(svgImage);
    var svg64 = btoa(ToBinary(xml));


    var b64Start = 'data:image/svg+xml;base64,';
    var image64 = b64Start + svg64;
    var img = new Image();
    img.src = image64
    return img
  }

function ToBinary(str)
{
    let result="";

    str=encodeURIComponent(str);

    for(let i=0;i<str.length;i++)
        if(str[i]=="%")
        {
            result+=String.fromCharCode(parseInt(str.substring(i+1,i+3),16));
            i+=2;
        }
        else
            result+=str[i];

    return result;
}

/*

    if (mode === 'process_miner') var blob = gDiagramPV.makeImageData({ background: "white", returnType: "blob", callback: diagramCallback }); 
    if (mode === 'decomposition_tree') var blob = gDiagramDecompositionTree.makeImageData({ background: "white", returnType: "blob", callback: diagramCallback }); 
    if (mode === 'cluster_insights') var blob = gDiagramCluster.makeImageData({ background: "white", returnType: "blob", callback: diagramCallback }); 
    if (mode === 'influence_analysis') var blob = gDiagramInfluenceAnalysis.makeImageData({ background: "white", returnType: "blob", callback: diagramCallback });    
     
function diagramCallback() { 


    var url = window.URL.createObjectURL(blob);
    var filename = gModelFileName + '.png';

    var a = document.createElement("a");
    a.style = "display: none";
    a.href = url;
    a.download = filename;

    // IE 11
    if (window.navigator.msSaveBlob !== undefined) {
      window.navigator.msSaveBlob(blob, filename);
      return;
    }

    document.body.appendChild(a);
    requestAnimationFrame(() => {
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    });
}
    */


export async function applySimilarVariantFilter(filterProps,loadDiscoveryRules,countOnly) {

    let variant_id = filterProps.variant_id
    let filter_type = filterProps.filter_type
    let steps = []

    if (filter_type !== 'variant') {    
        for(let i=0; i <gLinkArray.length; i++) {
            if (gLinkArray[i].variant_id === variant_id && gLinkArray[i].end_node === false) {
                let step = {};
                step['from'] = gLinkArray[i].from
                step['from_label'] = gLinkArray[i].from_label
                step['to'] = gLinkArray[i].to
                step['to_label'] = gLinkArray[i].to_label
                steps.push(step);
            }
        }
    }

    if (filter_type === 'variant') {
        for (let i=0; i < gVariantArray.length; i++) {
            gVariantArray[i].similar = false
            if (gVariantArray[i].id === variant_id) gVariantArray[i].similar = true
        }
    }

    if (filter_type === 'same_steps') {  // each step has to exist with no other steps i.e. loops
        for (let i=0; i < gVariantArray.length; i++) {
            gVariantArray[i].similar = false
            if (gVariantArray[i].id !== variant_id) {

                for (let k = 0; k < steps.length; k++) {
                    steps[k].exists = false
                }

                let similar = true
                for (let j=0; j < gLinkArray.length; j++) { 
                    if (gLinkArray[j].variant_id === gVariantArray[i].id && gLinkArray[j].end_node === false) {  // search variant steps

                        let stepExists = false  // linkarray step must exist in steps[]
                        for (let k=0; k < steps.length; k++) {
                            if (parseInt(steps[k].from) === parseInt(gLinkArray[j].from) && parseInt(steps[k].to) === parseInt(gLinkArray[j].to) ) {
                                stepExists = true
                                steps[k].exists = true
                            }
                        }
                        if (stepExists === false) {
                            similar = false
                            break
                        }
                    }
                }
                if (similar === true) {
                    let sameSteps = true
                    for (let k = 0; k < steps.length; k++) {
                        if (steps[k].exists === false) sameSteps = false
                    }
                    if (sameSteps === true) gVariantArray[i].similar = true
                } 
            } else {
                gVariantArray[i].similar = true
            }
        }
    }

    if (filter_type === 'similar_steps') { // each step has to exist, other steps can exist
        for (let i=0; i < gVariantArray.length; i++) {
            gVariantArray[i].similar = false
            if (gVariantArray[i].id !== variant_id) {

                let similar = true
                for (let k=0; k < steps.length; k++) {
                    let stepFound = false
                    for (let j=0; j < gLinkArray.length; j++) { 
                        if (gLinkArray[j].variant_id === gVariantArray[i].id && gLinkArray[j].end_node === false) {
                            if (parseInt(steps[k].from) === parseInt(gLinkArray[j].from) && parseInt(steps[k].to) === parseInt(gLinkArray[j].to) ) {
                                stepFound = true
                                break
                            }
                        }
                    }
                    if (stepFound === false) {
                        similar = false
                        break
                    }
                }
                if (similar === true) gVariantArray[i].similar = true
            } else {
                gVariantArray[i].similar = true
            }
        }
    }

    for (let i = 0; i < gVariantArray.length; i++) {
        if (gVariantArray[i].id == variant_id) filterProps.variant = gVariantArray[i].n
    }
    gSaveModel = true
    gFilterSets++;  

    gVariantArray.sort((a, b) => a.id - b.id)

    for (let i = 0; i < gEventLogArray.length; i++) {  // variant_id
        if (gEventLogArray[i].filtered === 0) {
            if (gVariantArray[gEventLogArray[i].vid].similar === true) {
                let vtp = {};
                vtp['type'] = 'filter';    
                vtp['sub_type'] = 'variant_similar';    
                vtp['label'] = 'Filter - Variant';
                vtp['filter_number'] = gFilterSets;
                vtp['id'] = gEventLogArray[i].elid;
                vtp['duration'] = gEventLogArray[i].d;
                vtp['task'] = gEventLogArray[i].k;
                gFilters.push(vtp);
            }
        }   
    }

    let tasksFiltered = countFilteredTasks()  
    if (countOnly === true) { 

        let events = 0
        for (let i = 0; i < gFilters.length; i++) {
            if (gFilters[i].filter_number == gFilterSets) events ++
        }
        gFilterStats = []

        let vtp = [];
        vtp['tasks'] = tasksFiltered
        vtp['events'] = events - tasksFiltered  // removes the 'to end' event
        gFilterStats.push(vtp);   
        return
    }

    if (tasksFiltered > 0) {

        const vtp = {};
        vtp['type'] = 'filter';    
        if (filterProps.filter_type === 'variant') {
            vtp['sub_type'] = 'variant_similar';    
            vtp['label'] = 'Filter - Variant';
            vtp['description'] = 'Variant ' + filterProps.variant
        }
        if (filterProps.filter_type === 'similar_steps') {
            vtp['sub_type'] = 'variant_similar';    
            vtp['label'] = 'Filter - Variant similar steps';
            vtp['description'] = 'Similar steps as variant ' + filterProps.variant
        }
        if (filterProps.filter_type === 'same_steps') {
            vtp['sub_type'] = 'variant_similar';    
            vtp['label'] = 'Filter - Variant same steps';
            vtp['description'] = 'Same steps as variant ' + filterProps.variant
        }
        vtp['filter_type'] = filterProps.filter_type
        vtp['variant_id'] = filterProps.variant_id
        vtp['id'] = gFilterSets
        gFilterConditions.push(vtp);
            
        generateArrays(true, false, 'applyVariantFilter',loadDiscoveryRules);
        setFilterIcon({ eventEmitter: gEventEmitter });
        alertMessage({
            eventEmitter: gEventEmitter,
            message: tasksFiltered +  ' issues match the filter',
            severity: 'success',
            showAlert: true,
            timeOutActive: true,
            component: 'variantFilter',
        });
    } else {
        gFilterSets--;
        alertMessage({
            eventEmitter: gEventEmitter,
            message: 'No matching issues',
            severity: 'info',
            showAlert: true,
            timeOutActive: true,
            component: 'variantFilter',
        });
    }
}


export async function applyWorkflowFilter(filterProps,loadDiscoveryRules,countOnly) {
    let variantArray = filterProps.matching_variants
    gVariantArray.sort((a, b) => a.id - b.id);
    gSaveModel = true
    gFilterSets++;  
    
    let ctr = 0
    for (let i = 0; i < gVariantArray.length; i++) {
        gVariantArray[i].similar = false
        for (let j = 0; j < variantArray.length; j++) {
            if (variantArray[j] === gVariantArray[i].id ) {
                gVariantArray[i].similar = true
                ctr ++
            }
        }
    }

     for (let i = 0; i < gEventLogArray.length; i++) {  
        if (gVariantArray[gEventLogArray[i].vid].similar === true) {
            let vtp = {};
            vtp['type'] = 'filter';    
            vtp['sub_type'] = 'workflow';    
            vtp['label'] = 'Filter - Workflow';
            vtp['filter_number'] = gFilterSets;
            vtp['id'] = gEventLogArray[i].elid;
            vtp['duration'] = gEventLogArray[i].d;
            vtp['task'] = gEventLogArray[i].k;
            gFilters.push(vtp);
        }   
    }

    let tasksFiltered = countFilteredTasks()  
    if (countOnly === true) { 

        let events = 0
        for (let i = 0; i < gFilters.length; i++) {
            if (gFilters[i].filter_number == gFilterSets) events ++
        }
        gFilterStats = []

        let vtp = [];
        vtp['tasks'] = tasksFiltered
        vtp['events'] = events - tasksFiltered  // removes the 'to end' event
        gFilterStats.push(vtp);   
        return
    }

    if (tasksFiltered > 0) {

        const vtp = {};
        vtp['type'] = 'filter';    
        vtp['sub_type'] = 'variant_similar';    
        vtp['label'] = 'Filter - Workflow';
        vtp['description'] = 'Workflow ' + filterProps.workflow
        vtp['matching_variants'] = filterProps.matching_variants
        vtp['id'] = gFilterSets
        gFilterConditions.push(vtp);
            
        generateArrays(true, false, 'applyWorkflowFilter',loadDiscoveryRules);
        setFilterIcon({ eventEmitter: gEventEmitter });
        alertMessage({
            eventEmitter: gEventEmitter,
            message: tasksFiltered +  ' issues match the filter',
            severity: 'success',
            showAlert: true,
            timeOutActive: true,
            component: 'workflowFilter',
        });
    } else {
        gFilterSets--;
        alertMessage({
            eventEmitter: gEventEmitter,
            message: 'No matching issues',
            severity: 'info',
            showAlert: true,
            timeOutActive: true,
            component: 'workflowFilter',
        });
    }
}


export function getWorkflowConfiguration() {
    return gWorkflowConfiguration;
}

export function getWorkflowTransitions() {
    return gWorkflowTransitions;
}

export function getWorkflowVariants() {
    return gWorkflowVariants;
}

export function setWorkflowConfiguration(props) {
    gWorkflowConfiguration = props;
    gSaveModel = false
}

export function setWorkflowTransitions(props) {
    gWorkflowTransitions = props;
    gSaveModel = false
}

export function setWorkflowVariants(props) {
    gWorkflowVariants = props;
    gSaveModel = false
}

export function setInsights(props) {
    gInsights = props;
}

export function getInsights() {
    return gInsights
}

export function getLinkArray() {
    return gLinkArray;
}

export function getTaskArray() {
    return gTaskArray;
}

export function getVariantArrayUnfiltered() {
    return gVariantArray;
}

export function getEventLogArray() {
    return gEventLogArray;
}

export function getModelMetrics() {
    return gModelMetrics;
}

export function getModelMetricsTotal() {
    return gModelMetricsTotal;
}

export function getModelDateRange() {
    // Returns { from: 'YYYY-MM-DD', to: 'YYYY-MM-DD' } based on the actual
    // work item creation dates in gTaskArray (unfiltered items only).
    // Falls back to gModelFromDate/gModelToDate if no tasks are loaded yet.
    if (gTaskArray && gTaskArray.length > 0) {
        let minDate = '2500/01/01';
        let maxDate = '1900/01/01';
        for (let i = 0; i < gTaskArray.length; i++) {
            if (gTaskArray[i].filtered === 0 && gTaskArray[i].t1) {
                if (gTaskArray[i].t1 < minDate) minDate = gTaskArray[i].t1;
                if (gTaskArray[i].t1 > maxDate) maxDate = gTaskArray[i].t1;
            }
        }
        if (minDate !== '2500/01/01' && maxDate !== '1900/01/01') {
            return {
                from: minDate.substring(0, 10).replaceAll('/', '-'),
                to:   maxDate.substring(0, 10).replaceAll('/', '-'),
            };
        }
    }
    // Fallback to configured model dates
    if (!gModelFromDate || !gModelToDate) return null;
    return {
        from: gModelFromDate.substring(0, 10).replaceAll('/', '-'),
        to:   gModelToDate.substring(0, 10).replaceAll('/', '-'),
    };
}

export function getTasksFilteredCount() {
    // Returns the current count of filtered (visible) tasks.
    // Updated by generateArrays after any filter is applied.
    return gTasksFiltered;
}

export function getActiveTimeFilter() {
    // Returns the currently applied time filter as { from: 'YYYY-MM-DD', to: 'YYYY-MM-DD' },
    // or null if no time filter is active.
    // gTaskFilterTime is pushed to by filterConditions() when a time filter is applied
    // and cleared to [] by resetFilters() — it's the reliable signal for an active time filter.
    if (!gTaskFilterTime || gTaskFilterTime.length === 0) return null;
    if (!gFromTime || !gToTime) return null;
    return {
        from: gFromTime.substring(0, 10).replaceAll('/', '-'),
        to:   gToTime.substring(0, 10).replaceAll('/', '-'),
    };
}

export function getStatusTypeMappings() {
    return gStatusTypeMappings;
}

export function getStatusTypeSummary() {
    return gStatusTypeSummary;
}

export function getStepArray() {
    return gStepArray;
}

export function getApp() {
    return gApp;
}

export function viewWorkflowModal(props) {   
    let filterSummary = [];
    let linkDataArray = []
    for (let i = 0; i < props.linkDataArray.length; i++) {
        if (props.linkDataArray[i].workflow = props.workflow) linkDataArray.push(props.linkDataArray[i])
    }
    let nodeDataArray = []
    for (let i = 0; i < props.nodeDataArray.length; i++) {
        if (props.nodeDataArray[i].workflow = props.workflow) nodeDataArray.push(props.nodeDataArray[i])
    }
    openWorkflowModal({ 
        data: {
            workflow: props.workflow,
            linkDataArray: linkDataArray,
            nodeDataArray: nodeDataArray,
        },
    });
}

/*function createDenormalisedTaskArray (taskArray) {

    let newArray = []
    for (let i = 0; i < taskArray.length; i++) {
    
        for (let j = 0; j < gAttributes.length; j++) {
            if (gAttributes[j].schema === array) {


            } else {
                newArray

            }
        }
        


        let tempArray = detailTaskArray2[i][taskAttribute].split('^^');
                if (tempArray.length === 1) detailTaskArray3.push (detailTaskArray2[i])
                else {
                    for (let m = 0; m < tempArray.length; m++) {
                        var newObject = JSON.parse(JSON.stringify(detailTaskArray2[i]));
                        newObject[taskAttribute] = tempArray[m]
                        detailTaskArray3.push (newObject)
                    }
                }
            }
        } else {
            detailTaskArray3 = detailTaskArray2
        }

    return newArray

}
*/
export function getActivityTypes() {

    let tempArray = []
    for (let m = 0; m < gActivityTypes.length; m++) {
        tempArray.push(gActivityTypes[m].name)

    }
    return tempArray
}

export function importVisualizerSettings(importedSettings) {
    let tempArray;
    tempArray = importedSettings
    gProcessFlowDirection = tempArray[0].ProcessFlowDirection;

    gShowLinkTasks = tempArray[0].ShowLinkTasks;
    gShowLinkAvgDuration = tempArray[0].ShowLinkAvgDuration;
    gShowLinkPercTotal = tempArray[0].ShowLinkPercTotal;

    gShowTooltipTasks = tempArray[0].ShowTooltipTasks;
    gShowTooltipAvgDuration = tempArray[0].ShowTooltipAvgDuration;
    gShowTooltipMedDuration = tempArray[0].ShowTooltipMedDuration;
    gShowTooltipMinDuration = tempArray[0].ShowTooltipMinDuration;
    gShowTooltipMaxDuration = tempArray[0].ShowTooltipMaxDuration;
    gShowTooltipPercTotal = tempArray[0].ShowTooltipPercTotal;
    gShowTooltipDeviation = tempArray[0].ShowTooltipDeviation;
    gShowTooltipCommentsCustomer = tempArray[0].ShowTooltipCommentsCustomer;
    gShowTooltipAvgCommentsCustomer = tempArray[0].ShowTooltipAvgCommentsCustomer;
    gShowTooltipCommentsInternal = tempArray[0].ShowTooltipCommentsInternal;
    gShowTooltipAvgCommentsInternal = tempArray[0].ShowTooltipAvgCommentsInternal;
    gShowTooltipWorklogs = tempArray[0].ShowTooltipWorklogs;
    gShowTooltipAvgWorklogs = tempArray[0].ShowTooltipAvgWorklogs;
    gShowTooltipPercCommentsInternal = tempArray[0].gShowTooltipPercCommentsInternal
    gShowTooltipPercCommentsCustomer = tempArray[0].gShowTooltipPercCommentsCustomer
    gShowTooltipPercWorklogs = tempArray[0].gShowTooltipPercWorklogs
    gShowTooltipTotalTimespent = tempArray[0].gShowTooltipTotalTimespent
    gShowTooltipAvgTimespent  = tempArray[0].gShowTooltipAvgTimespent

    if (gShowTooltipTasks === undefined) gShowTooltipTasks = true
    if (gShowTooltipAvgDuration === undefined) gShowTooltipAvgDuration = true
    if (gShowTooltipPercTotal === undefined) gShowTooltipPercTotal = true
    if (gShowTooltipDeviation === undefined) gShowTooltipDeviation = true
    if (gShowTooltipMinDuration === undefined) gShowTooltipMinDuration = true
    if (gShowTooltipMaxDuration === undefined) gShowTooltipMaxDuration = true
    if (gShowTooltipPercCommentsInternal === undefined) gShowTooltipPercCommentsInternal= false
    if (gShowTooltipPercCommentsCustomer === undefined) gShowTooltipPercCommentsCustomer= false
    if (gShowTooltipPercWorklogs === undefined) gShowTooltipPercWorklogs= false
    if (gShowTooltipTotalTimespent === undefined) gShowTooltipTotalTimespent= false
    if (gShowTooltipAvgTimespent === undefined) gShowTooltipAvgTimespent = false


    if (gShowTooltipMedDuration === undefined) gShowTooltipMedDuration = false
    if (gShowTooltipCommentsCustomer === undefined) gShowTooltipCommentsCustomer = false
    if (gShowTooltipAvgCommentsCustomer === undefined) gShowTooltipAvgCommentsCustomer = false
    if (gShowTooltipCommentsInternal === undefined) gShowTooltipCommentsInternal = false
    if (gShowTooltipAvgCommentsInternal === undefined) gShowTooltipAvgCommentsInternal = false
    if (gShowTooltipWorklogs === undefined) gShowTooltipWorklogs = false
    if (gShowTooltipAvgWorklogs === undefined) gShowTooltipAvgWorklogs = false

    gShowStartLabel = tempArray[0].ShowStartLabel;
    gShowEndLabel = tempArray[0].ShowEndLabel;

    gShowStartNode = tempArray[0].ShowStartNode;
    gShowEndNode = tempArray[0].ShowEndNode;

    gStepLabelFontSize = tempArray[0].StepLabelFontSize;

    gShowNodeTasks = tempArray[0].ShowNodeTasks;
    gShowNodePercTotal = tempArray[0].ShowNodePercTotal;

    gNodeLabelFontSize = tempArray[0].NodeLabelFontSize;

    gShowDurationDays = tempArray[0].ShowDurationDays;
    gShowDurationHours = tempArray[0].ShowDurationHours;
    gShowDurationMinutes = tempArray[0].ShowDurationMinutes;

    gStepWidthTasks = tempArray[0].StepWidthTasks;
    gStepWidthDuration = tempArray[0].StepWidthDuration;
    gStepWidthStdDeviation = tempArray[0].StepWidthStdDeviation;

    gActivityShape = tempArray[0].ActivityShape;
    gColorStartNode = tempArray[0].ColorStartNode;
    gColorEndNode = tempArray[0].ColorEndNode;
    gColorLink = tempArray[0].ColorLink;
    gColorLinkSelect = tempArray[0].ColorLinkSelect;
    gAnimateColor = tempArray[0].AnimateColor;
    gLoopColor = tempArray[0].LoopColor;
    gVisualizerBackgroundColor = tempArray[0].VisualizerBackgroundColor;

    gSpacingColumn = tempArray[0].SpacingColumn;
    gSpacingLayer = tempArray[0].SpacingLayer;

    gZoomToFit = tempArray[0].ZoomToFit;
    changeBackgroundColor({ eventEmitter: gEventEmitter });
}


export const retrieveWorkFlowTransitions = async (AppVersion,contextPath) => {

        const sleep = ms => new Promise(r => setTimeout(r, ms));
        await sleep(200) // needed to display Progress
        openProgressModal({status: 'Retrieving Projects'})
        let projectList = await retrieveProjects(AppVersion,contextPath)
        updateProgressModal({status: 'Retrieving Status Codes'})       
        let statusList = await retrieveStatus(AppVersion,contextPath)
        updateProgressModal({status: 'Retrieving Work Types'})       
        let issueTypeList = await retrieveIssueTypes(AppVersion,contextPath)
        updateProgressModal({status: 'Retrieving Workflows'})       
        let workFlowList = await retrieveWorkFlows(AppVersion,contextPath,projectList,issueTypeList)
        
        let modelStats = modelStatistics()
        let total_issues = Number(modelStats[0].tasks)
        let total_variants = Number(modelStats[0].variants)
        let workflowConfiguration = []
        for (let k = 0; k < workFlowList.length; k++) {
            let vtpWorkflow = {}
            vtpWorkflow['project'] = workFlowList[k].project
            vtpWorkflow['workflow'] = workFlowList[k].name
            vtpWorkflow['statuses'] = workFlowList[k].statuses

            let transitions = 0
            let workFlowTransitions = []
            if (workFlowList[k].transitions !== undefined) {
                for (let l = 0; l < workFlowList[k].transitions.length; l++) {
                    if (workFlowList[k].transitions[l].links.length > 0 ) {                       // ????
                        for (let m = 0; m < workFlowList[k].transitions[l].links.length; m++) {
                            let vtpTransitions = {}
                            vtpTransitions['project'] = workFlowList[k].project
                            vtpTransitions['workflow'] = workFlowList[k].name
                            let from_status = getStatus(workFlowList[k].transitions[l].links[m].fromStatusReference,statusList)
                            let to_status = getStatus(workFlowList[k].transitions[l].toStatusReference,statusList)
                            vtpTransitions['from_status'] = from_status
                            vtpTransitions['to_status'] = to_status
                            vtpTransitions['from_id'] = getStatusID(from_status,statusList)
                            vtpTransitions['to_id'] = getStatusID(to_status,statusList)
                            vtpTransitions['from'] = workFlowList[k].transitions[l].links[m].fromStatusReference
                            vtpTransitions['to'] = workFlowList[k].transitions[l].toStatusReference
                            vtpTransitions['work_items'] = 0
                            vtpTransitions['transition'] = from_status + ' -> ' + to_status
                            if (from_status !== '') {
                                workFlowTransitions.push(vtpTransitions)
                                transitions ++
                            }
                        }
                    }
                }    
            }
            vtpWorkflow['transitions'] = transitions

            let temp = getIssueCountforWorkflow_Within(workFlowTransitions)
            let matching_issues = temp[0]
            let matching_variants = temp[1]

            let transition_detail = updateIssueCountforTransitions(workFlowTransitions, matching_issues)
            vtpWorkflow['transition_detail'] =  transition_detail
            let unused_transitions = 0
            for (let m = 0; m < transition_detail.length; m++) if (transition_detail[m].issues === 0 ) unused_transitions ++

            vtpWorkflow['unused_transitions'] = unused_transitions
            vtpWorkflow['issues_within'] = matching_issues.length
            vtpWorkflow['variants_within'] = matching_variants.length
            vtpWorkflow['perc_issues_within'] = matching_issues.length/total_issues
            vtpWorkflow['perc_variants_within'] = matching_variants.length/total_variants
            vtpWorkflow['matching_issues'] = matching_issues
            vtpWorkflow['matching_variants'] = matching_variants

            let nodeDataArray = []
            let linkDataArray = []
            let data = workFlowList[k]
            for (let j = 0; j < data.statuses.length; j++) {         
                let vtp = {}
                vtp['key'] = data.statuses[j].statusReference
                vtp['text'] = getStatus(data.statuses[j].statusReference,statusList)
                vtp['work_items'] = workFlowTransitions[j].work_items
                if (data.statuses[j].layout !== undefined) vtp['loc'] = data.statuses[j].layout.x + ' ' + data.statuses[j].layout.y
                nodeDataArray.push(vtp)
            }
            for (let j = 0; j < workFlowTransitions.length; j++) {         
                let vtp = {}
                vtp['from'] = workFlowTransitions[j].from
                vtp['to'] = workFlowTransitions[j].to
                vtp['tooltip'] = workFlowTransitions[j].transition + '\r\n' + (gEntityUpper + 's: ') + workFlowTransitions[j].work_items
                vtp['work_items'] = workFlowTransitions[j].work_items
                vtp['visible'] = true
                vtp['label_visible'] = true
                if (workFlowTransitions[j].issues === 0) {vtp['fill'] = '#FF7F7F'} else {vtp['fill'] = '#3F7F47'}
                linkDataArray.push(vtp)
            }
            vtpWorkflow['nodeDataArray'] = nodeDataArray
            vtpWorkflow['linkDataArray'] = linkDataArray
            workflowConfiguration.push(vtpWorkflow)
        }
        closeProgressModal()
        return workflowConfiguration
    }


    function getIssueCountforWorkflow_Within (workFlowTransitions) {
        //Which variants only have steps that are contained in the workflow

        let issues = 0
        let variants = 0

        let linkArray = getLinkArray()
        let variantArray = getVariantArrayUnfiltered().sort((a, b) => a.id - b.id);
        let taskArray = getTaskArray()
        let matchingIssues = []
        let matchingVariants = []

        for (let i=0; i < variantArray.length; i++) {
   
            let similar = true
            for (let j=0; j < linkArray.length; j++) { 
                if (linkArray[j].variant_id === variantArray[i].id && linkArray[j].end_node === false && linkArray[j].start_node === false) {  // search variant steps
                    let stepExists = false  // linkarray step must exist in steps[]
                    for (let k=0; k < workFlowTransitions.length; k++) {
                        if (workFlowTransitions[k].from_status === linkArray[j].from_label && workFlowTransitions[k].to_status === linkArray[j].to_label ) stepExists = true
                    }
                    if (stepExists === false) {
                        similar = false
                        break
                    }
                }
            }
            if (similar === true) variantArray[i].match = true
        }

        for (let i=0; i < variantArray.length; i++) { 
            if (variantArray[i].match === true) {
                for (let j=0; j < taskArray.length; j++) { 
                    if (taskArray[j].vid === variantArray[i].id) {
                        let vtp = {}
                        vtp['k'] = taskArray[j].k
                        vtp['si'] = taskArray[j].si
                        vtp['id'] = taskArray[j].id
                        vtp['fi'] = taskArray[j].fi
                        matchingIssues.push(vtp)
                    }
                }
                matchingVariants.push(variantArray[i].id)
            }
        }
        return [matchingIssues,matchingVariants]
    }

    function  updateIssueCountforTransitions(workflowTransitions, matching_issues) {  
        let eventLogArray = getEventLogArray().sort((a, b) => a.elid - b.elid);
        let activityArray = getActivityArray()
        for (let i = 0; i < matching_issues.length; i++) {
            for (let j = matching_issues[i].si; j <= matching_issues[i].fi; j++) {  
                let from = ''
                let to = ''
                for (let m = 0; m < activityArray.length; m++) if (activityArray[m].id === eventLogArray[j].f) from = activityArray[m].activity
                for (let m = 0; m < activityArray.length; m++) if (activityArray[m].id === eventLogArray[j].t) to = activityArray[m].activity

                for (let k = 0; k < workflowTransitions.length; k++) {
                    if (workflowTransitions[k].from_status === from && workflowTransitions[k].to_status === to) workflowTransitions[k].work_items ++
                }
            }
        }
        return workflowTransitions
    }

 
    function getStatus (id,statusList) {
        let status = ''
        for (let k = 0; k < statusList.length; k++) {
            if (statusList[k].id === id) status = statusList[k].name
        }
        return status
    }

    function getStatusID (activity) {

        let activityArray = getActivityArray()
        let id = 0
        for (let k = 0; k < activityArray.length; k++) {
            if (activityArray[k].activity === activity) id = activityArray[k].id
        }
        return id
    }

    const retrieveWorkFlows  = async (AppVersion,contextPath,projectList,issueTypeList) => {
        let workFlowList = []
        if (AppVersion === 'FORGE') {
            const { requestJira } = await loadForgeModule();
            let startAt = 0
            let tempArray = []
            for (let i = 0; i <  issueTypeList.length; i++) {
                for (let j = 0; j <  projectList.length; j++) {
                    updateProgressModal({status: 'Retrieving Workflows: ' + issueTypeList[i].name + ' - ' + projectList[j].name})       

                    let vtp = {}
                    vtp['issueTypeId'] = issueTypeList[i].id
                    vtp['projectId'] = projectList[j].id
                    tempArray.push(vtp)

                    let tempBody = {}
                    tempBody['projectAndIssueTypes'] = tempArray
                    var bodyData = JSON.stringify(tempBody)

                    let response = await requestJira(`/rest/api/3/workflows`, {
                        method: 'POST',
                        headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                        },
                        body: bodyData
                    });

                    let res = await response.json()
                    if (res.workflows !== undefined) {
                        res.workflows[0]['project'] = projectList[j].name
                        workFlowList = workFlowList.concat(res.workflows)  
                    }   
                }
            }
        }
        return workFlowList
    }

    const retrieveStatus  = async (AppVersion,contextPath) => {

        let response
        let statusList
        if (AppVersion === 'FORGE') {
            const { requestJira } = await loadForgeModule();
            response = await requestJira('/rest/api/3/status');
        }
        if (false)  response = await fetch(contextPath + '/rest/api/2/status')

        const data = await response.json();
        
        statusList = data.map((status) => {
            const id = status.id;
            const name = status.name;
            return {
                id: id,
                name: name,
              }
        })
        return statusList
    }

    const retrieveProjects  = async (AppVersion,contextPath) => {

        let projectList = []
        let attribute = 'Project'
        let attributeType = gEntityUpper
        let projects = processAttributesTable( attribute, attributeType );

        let response
        if (AppVersion === 'FORGE') {
            const { requestJira } = await loadForgeModule();
             response = await requestJira('/rest/api/3/project');
        }
        if (false)  response = await fetch(contextPath + '/rest/api/2/project')
        const data = await response.json();
        for (let i = 0; i <  data.length; i++) {
            let validProject = false
            for (let j = 0; j <  projects.length; j++) {
                if (projects[j].value === data[i].name.trim()) validProject = true
            }
            if (validProject === true) {
                let vtp = {} 
                vtp['name'] = data[i].name.trim()
                vtp['id'] = data[i].id
                vtp['value'] = data[i].value
                projectList.push(vtp)
            }
        }
        return projectList
    }
    
    const retrieveIssueTypes  = async (AppVersion,contextPath) => {

        let response
        let issueTypeList = []
        if (AppVersion === 'FORGE') {
            const { requestJira } = await loadForgeModule();
            response = await requestJira('/rest/api/3/issuetype');
        }
        if (false)  response = await fetch(contextPath + '/rest/api/2/issuetype')

        const data = await response.json();

        let issueTypes = getIssueTypes()
        for (let i = 0; i <  data.length; i++) {
            let validIssueType = false
            for (let j = 0; j <  issueTypes.length; j++) {
                if (issueTypes[j].trim() === data[i].name.trim()) validIssueType = true
            }
            if (validIssueType === true) {
                let vtp = {} 
                vtp['name'] = data[i].name.trim()
                vtp['id'] = data[i].id
                vtp['value'] = data[i].value
                issueTypeList.push(vtp)
            }
        }
        return issueTypeList
    }


export function taskJSON(sampleLimit = 100) {
    // Only sample from tasks that are visible in the current filtered view (filtered === 0).
    // IMPORTANT: this function is called by Advisor / AI Data UI. The old implementation
    // filtered the full task array and then randomly sorted it on every call. With large
    // ServiceNow models (50K+ tasks) that can block the browser when Advisor opens.
    // This implementation samples without sorting or cloning the full task array.
    const limit = Math.max(1, Math.min(1000, Number.isFinite(Number(sampleLimit)) ? Math.round(Number(sampleLimit)) : 100));
    const source = Array.isArray(gTaskArray) ? gTaskArray : [];
    const rows = [];
    const used = new Set();

    const pushTask = (task) => {
        if (!task || task.filtered !== 0 || rows.length >= limit) return false;
        const taskKey = task.id ?? task.k ?? rows.length;
        if (used.has(taskKey)) return false;
        used.add(taskKey);

        let vtp = {};

        const workItemKey = gEntityUpper + ' #';
        const workItemRule = getAttributePrivacyRule(workItemKey);
        if (workItemRule !== 'exclude') {
            vtp[workItemKey] = workItemRule === 'anonymize'
                ? anonymizePrivacyValue(workItemKey, task.k)
                : task.k;
        }

        vtp['Variant ID'] = task.vid;

        const summaryRule = getAttributePrivacyRule('Summary');
        if (summaryRule !== 'exclude') {
            vtp['Summary'] = summaryRule === 'anonymize'
                ? anonymizePrivacyValue('Summary', task.summary)
                : task.summary;
        }

        vtp['Duration'] = task.d;

        for (let j = 0; j < gTaskAttributes.length; j++) {
            const attr = gTaskAttributes[j];
            const field = attr.field;
            const rule = getAttributePrivacyRule(attr);

            // Skip fields excluded from AI prompts.
            if (rule === 'exclude') continue;

            let value;
            if (attr.schema === 'array' || attr.schema == 'stagil_asset_forge') {
                value = String(task[attr.id] ?? '').replaceAll('^^', ',');
            } else {
                value = task[attr.id];
            }

            vtp[field] = rule === 'anonymize'
                ? anonymizePrivacyValue(field, value)
                : value;
        }
        rows.push(vtp);
        return true;
    };

    // Random attempts give a representative sample without O(n log n) sorting.
    const maxRandomAttempts = Math.min(source.length * 2, Math.max(limit * 8, 250));
    for (let attempts = 0; attempts < maxRandomAttempts && rows.length < limit; attempts++) {
        const idx = Math.floor(Math.random() * source.length);
        pushTask(source[idx]);
    }

    // Sequential fallback ensures sparse filtered views still return enough rows.
    for (let i = 0; i < source.length && rows.length < limit; i++) {
        pushTask(source[i]);
    }

    return rows;
}

/**
 * Returns current attribute privacy rules for the loaded model.
 * Used by consultant tabs to apply anonymization via applySampleItemPrivacy().
 */
export function getAttributePrivacyRules() {
    // Return a DISPLAY-ONLY, de-duplicated rule map for AI prompt helpers / AI Data panel.
    //
    // Internally gAttributePrivacy deliberately contains many aliases for matching
    // (attributeID, display label, normalized key, taN id). Returning that raw map
    // causes UI artefacts such as an extra "ta3 EXCL" column and inflated AI Data
    // counts. The caller only needs one canonical key per real field.
    rebuildAttributePrivacyByLabel();

    const rules = {};

    const addRule = (displayName, attrOrField) => {
        const label = String(displayName || '').trim();
        if (!label) return;

        // Never surface internal task attribute ids (ta0/ta1/ta2...) in the UI or
        // prompt privacy map. They are implementation aliases, not real columns.
        if (/^ta\d+$/i.test(label)) return;

        const rule = getAttributePrivacyRule(attrOrField || label);
        if (rule === 'exclude' || rule === 'anonymize') {
            rules[label] = rule;
        }
    };

    // System/sample fields are not normally configured by the process-model privacy
    // editor, but keep this here so any future rules for them are still represented
    // once and by their display names.
    addRule(gEntityUpper + ' #', gEntityUpper + ' #');
    addRule('Summary', 'Summary');

    // Dataset attributes: canonicalise to the field label used by taskJSON().
    (gTaskAttributes || []).forEach((attr) => {
        const displayName = attr?.field || attr?.label || attr?.attributeID || attr?.id;
        addRule(displayName, attr);
    });

    return rules;
}

// --- TEST: Generate HTML export after model load ---
export async function testGenerateContentExport({
  title = 'AI Process Optimizer — Data Model Export',
  subtitle = '',
  topNVariants = 10,
  topNSteps = 10,
  filenameBase = 'process-model-export'
} = {}) {
  try {
    // Ensure the diagram has completed layout/rendering before exporting.
    // (GoJS can export an empty SVG if called too early.)
    try {
      const diagramReady =
        gDiagramPV &&
        gDiagramPV.nodes &&
        typeof gDiagramPV.nodes.count === 'number' &&
        gDiagramPV.nodes.count > 0 &&
        gDiagramPV.documentBounds &&
        gDiagramPV.documentBounds.width > 1 &&
        gDiagramPV.documentBounds.height > 1;

      if (!diagramReady) {
        setTimeout(() => {
          try {
            testGenerateContentExport({ title, subtitle, topNVariants, topNSteps, filenameBase });
          } catch (e) {
            console.error('testGenerateContentExport retry failed', e);
          }
        }, 1200);

        return { ok: false, pending: true, reason: 'diagram-not-ready' };
      }
    } catch {}

    const resolveActivityLabel = (val) => {
      if (val === null || val === undefined) return '';
      const s = String(val);
      // If it's numeric, treat as activity id and look up label
      if (/^\d+$/.test(s)) {
        const id = parseInt(s, 10);
        for (let i = 0; i < (gActivityArray || []).length; i++) {
          if (parseInt(gActivityArray[i].id) === id) return gActivityArray[i].activity || '';
        }
      }
      return s;
    };

    const variantRows = (gVariantArray || [])
      .slice()
      .sort((a, b) => (b.t || 0) - (a.t || 0))
      .slice(0, topNVariants)
      .map((v) => ({
        id: v.id,
        // Variant label is stored as 'n' in your variant objects
        name: v.n || v.name || v.variant || '',
        tasks: v.t ?? v.tasks ?? '',
        // Some builds track events as 'e' (others don't); fall back to ''
        events: v.e ?? v.events ?? '',
        steps: v.s ?? v.steps ?? ''
      }));

    const stepRows = (gStepArray || [])
      .slice()
      .sort((a, b) => ((b.tasks ?? b.t ?? 0) - (a.tasks ?? a.t ?? 0)))
      .slice(0, topNSteps)
      .map((s) => ({
        // Step objects often use 'f'/'t' rather than 'from'/'to'
        from: resolveActivityLabel(s.from ?? s.f ?? ''),
        to: resolveActivityLabel(s.to ?? s.t ?? ''),
        name: s.name || s.step_name || '',
        tasks: s.tasks ?? s.t ?? '',
        events: s.events ?? s.e ?? '',
        avg_duration: s.avg_duration ?? s.ad ?? ''
      }));

    // If step name is missing, derive a friendly label
    for (let i = 0; i < stepRows.length; i++) {
      if (!stepRows[i].name) stepRows[i].name = `${stepRows[i].from} → ${stepRows[i].to}`;
    }

    const workItemRows = (gTaskArray || []).map((t) => ({
      id: t.id,
      key: t.key || t.k || '',
      summary: t.summary || t.s || '',
      start: t.t0 || t.start || '',
      end: t.t1 || t.end || '',
      duration: t.d || t.duration || '',
      variant: t.v || t.variant || ''
    }));

    // Render a PNG for Confluence (Confluence Cloud often strips inline SVG).
    let diagramPngDataUrl = '';
    try {
      if (gDiagramPV && typeof gDiagramPV.makeImageData === 'function') {
        diagramPngDataUrl = gDiagramPV.makeImageData({
          background: 'white',
          type: 'image/png',
          scale: 1
        });
      }
    } catch (e) {
      console.warn('Unable to generate diagram PNG', e);
    }

    const html = generateAndDownloadContent({
      title,
      subtitle,
      entityLabel: gEntityUpper,
      diagram: gDiagramPV,
      variants: {
        columns: [
          { headerName: 'ID', field: 'id' },
          { headerName: 'Variant', field: 'name' },
          { headerName: 'Tasks', field: 'tasks' },
          { headerName: 'Events', field: 'events' },
          { headerName: 'Steps', field: 'steps' }
        ],
        rows: variantRows
      },
      steps: {
        columns: [
          { headerName: 'From', field: 'from' },
          { headerName: 'To', field: 'to' },
          { headerName: 'Name', field: 'name' },
          { headerName: 'Tasks', field: 'tasks' },
          { headerName: 'Events', field: 'events' },
          { headerName: 'Avg Duration', field: 'avg_duration' }
        ],
        rows: stepRows
      },
      workItems: {
        columns: [
          { headerName: 'ID', field: 'id' },
          { headerName: 'Key', field: 'key' },
          { headerName: 'Summary', field: 'summary' },
          { headerName: 'Start', field: 'start' },
          { headerName: 'End', field: 'end' },
          { headerName: 'Duration', field: 'duration' },
          { headerName: 'Variant', field: 'variant' }
        ],
        rows: workItemRows
      },
      filenameBase
    });

    // Create Confluence page in the backend
    // IMPORTANT: must use Forge bridge invoke (loaded dynamically) in Forge, otherwise nothing happens.
    try {
      const { invoke } = await loadForgeModule();
      const res = await invoke('createConfluenceExportPage', {
        modelID: gModelID,
        pageTitle: title,
        html,
        diagramPngDataUrl,
        variants: variantRows,
        steps: stepRows,
        workItems: workItemRows,
      });
    } catch (e) {
      console.warn('[Export] Confluence create failed:', e);
    }

    return { ok: true, bytes: html.length };
  } catch (e) {
    console.error('testGenerateContentExport failed', e);
    return { ok: false, error: e?.message || String(e) };
  }
}

/**
 * Generate diagram data (nodes and links) from process arrays
 * This is a stateless wrapper for external use (e.g., HTML export)
 * @param {Object} arrays - The arrays from processEventLogTransform
 * @returns {Object} {nodeDataArray, linkDataArray}
 */
/**
 * Generate diagram data (nodes and links) from process arrays
 * This is a stateless wrapper for external use (e.g., HTML export)
 * @param {Object} arrays - The arrays from processEventLogTransform
 * @returns {Object} {nodeDataArray, linkDataArray}
 */
/**
 * Generate diagram data (nodes and links) from process arrays
 * This is a stateless wrapper for external use (e.g., HTML export)
 * @param {Object} arrays - The arrays from processEventLogTransform
 * @returns {Object} {nodeDataArray, linkDataArray}
 */
/**
 * Generate diagram data (nodes and links) from process arrays
 * This is a stateless wrapper for external use (e.g., HTML export)
 * @param {Object} arrays - The arrays from processEventLogTransform
 * @returns {Object} {nodeDataArray, linkDataArray}
 */
/**
 * Generate diagram data (nodes and links) from process arrays
 * This is a stateless wrapper for external use (e.g., HTML export)
 * @param {Object} arrays - The arrays from processEventLogTransform
 * @returns {Object} {nodeDataArray, linkDataArray}
 */
/**
 * Generate diagram data (nodes and links) from process arrays
 * This is a stateless wrapper for external use (e.g., HTML export)
 * @param {Object} arrays - The arrays from processEventLogTransform
 * @returns {Object} {nodeDataArray, linkDataArray}
 */
/**
 * Generate diagram data (nodes and links) from process arrays
 * Bypasses generateLinks and builds links directly from gLinkArray
 */
/**
 * Generate diagram data using the exact same flow as the visualizer
 */
/**
 * Generate diagram data - fixes duplicate link issue
 */
/**
 * Generate diagram data - properly sets gVariantPaneVariants BEFORE generateArrays
 */
/**
 * Generate diagram data with ALL required globals
 */
/**
 * Generate diagram data - clean version with minimal logging
 */
/**
 * Generate diagram data with ALL required globals set
 */
/**
 * Generate diagram data with ALL required globals set
 */
export function generateDiagramData(arrays) {
  const saved = {
    gActivityArray, gStepArray, gVariantArray, gTaskArray, gEventLogArray, gLinkArray,
    gVariantPaneVariants, gActivityShape, gNodeLabelFontSize, gColorStartNode, gColorEndNode,
    gShowStartNode, gShowEndNode, gShowStartLabel, gShowEndLabel, gShowNodeTasks, gShowNodePercTotal,
    gDiagramPVTasks, gEntityUpper, gDetailActivity, gAnimateVariant, gLifecycleVariant, gIsolateVariant,
    gVariantLoops, gShowLinkTasks, gShowLinkPercTotal, gShowLinkAvgDuration, gColorLink, gStepLabelFontSize
  };
  
  try {
    // Set data arrays
    gActivityArray = arrays.activityArray || [];
    gStepArray = arrays.stepArray || [];
    gVariantArray = arrays.variantArray || [];
    gTaskArray = arrays.taskArray || [];
    gEventLogArray = arrays.eventLogArray || [];
    gVariantPaneVariants = gVariantArray.map((v, idx) => ({ v: idx, s: 0 }));
    
    // Set ALL display/visual globals to their defaults
    gShowStartNode = true;
    gShowEndNode = true;
    gShowStartLabel = true;
    gShowEndLabel = true;
    gShowNodeTasks = true;
    gShowNodePercTotal = false;
    gDiagramPVTasks = gTaskArray.length;
    gEntityUpper = gEntityUpper || 'Work Item';
    gActivityShape = 'RoundedRectangle';
    gNodeLabelFontSize = '7pt';
    gColorStartNode = '#A09E9E';
    gColorEndNode = '#A09E9E';
    gDetailActivity = null;
    gAnimateVariant = 0;
    gLifecycleVariant = 0;
    gIsolateVariant = 0;
    gVariantLoops = null;
    gShowLinkTasks = true;
    gShowLinkPercTotal = true;
    gShowLinkAvgDuration = true;
    gColorLink = '#FDC819';
    gStepLabelFontSize = '6pt';
    
    // CRITICAL: Call updateActivityColors() to set color_fill on activities
    updateActivityColors();
    
    // Generate arrays
    generateArrays(false, true, 'export', '');
    
    // Fix duplicate flags - only for regular activity links, not start/end node links
    // Start/end node duplicate links must stay hidden to prevent duplicate Start/End nodes in diagram
    gLinkArray.forEach(link => {
      if (link.duplicate === true && link.start_node !== true && link.end_node !== true) {
        link.duplicate = false;
        link.visible = true;
      }
    });
    
    // Generate diagram data
    const linkDataArray = generateLinks('variants');
    const nodeDataArray = generateNodes('variants');

    // Deduplicate sentinel nodes: if a real Jira activity is named 'Start' or 'End',
    // it gets a different node ID from the sentinel, causing duplicate named nodes in the diagram.
    const sentinelS = nodeDataArray.find(n => n.start_node === true);
    const sentinelE = nodeDataArray.find(n => n.end_node   === true);
    const mergeMap0 = {};
    nodeDataArray.forEach(node => {
      if (sentinelS && !node.start_node && !node.end_node && node.text === sentinelS.text) {
        mergeMap0[node.key] = sentinelS.key;
      }
      if (sentinelE && !node.start_node && !node.end_node && node.text === sentinelE.text) {
        mergeMap0[node.key] = sentinelE.key;
      }
    });
    let finalNodeDataArray = nodeDataArray;
    let finalLinkDataArray = linkDataArray;
    if (Object.keys(mergeMap0).length > 0) {
      linkDataArray.forEach(link => {
        if (mergeMap0[link.from]) link.from = mergeMap0[link.from];
        if (mergeMap0[link.to])   link.to   = mergeMap0[link.to];
      });
      finalNodeDataArray = nodeDataArray.filter(node => !mergeMap0[node.key]);
      finalLinkDataArray = linkDataArray.filter(link => link.from !== link.to);
    }
    
    return { nodeDataArray: finalNodeDataArray, linkDataArray: finalLinkDataArray };
    
  } catch (error) {
    console.error('Error generating diagram data:', error);
    throw error;
  } finally {
    Object.assign(globalThis, saved);
  }
}

/**
 * Generate all export data (diagram, variants table, steps table) in one call
 * This ensures globals are set consistently for all three
 */
export function generateExportData(arrays) {
  const saved = {
    gActivityArray, gVariantArray, gTaskArray, gEventLogArray, gLinkArray,
    gVariantPaneVariants, gActivityShape, gNodeLabelFontSize, gColorStartNode, gColorEndNode,
    gShowStartNode, gShowEndNode, gShowStartLabel, gShowEndLabel, gShowNodeTasks, gShowNodePercTotal,
    gDiagramPVTasks, gEntityUpper, gDetailActivity, gAnimateVariant, gLifecycleVariant, gIsolateVariant,
    gVariantLoops, gShowLinkTasks, gShowLinkPercTotal, gShowLinkAvgDuration, gColorLink, gStepLabelFontSize,
    gStepWidthTasks, gStepWidthDuration, gStepWidthStdDeviation,
    gStepColourVolume, gStepColourDuration, gStepColourStdDeviation
  };
  // NOTE: Not saving gStepArray because generateArrays() should create it fresh
  
  try {
    // Set arrays
    gActivityArray = arrays.activityArray || [];
    gStepArray = arrays.stepArray || [];
    gVariantArray = arrays.variantArray || [];
    gTaskArray = arrays.taskArray || [];
    gEventLogArray = arrays.eventLogArray || [];
    
    
    // Set display defaults
    gShowStartNode = true;
    gShowEndNode = true;
    gShowStartLabel = true;
    gShowEndLabel = true;
    gShowNodeTasks = true;
    gShowNodePercTotal = false;
    gDiagramPVTasks = gTaskArray.length;
    gEntityUpper = gEntityUpper || 'Work Item';
    gActivityShape = 'RoundedRectangle';
    gNodeLabelFontSize = '7pt';
    gColorStartNode = '#A09E9E';
    gColorEndNode = '#A09E9E';
    gDetailActivity = null;
    gAnimateVariant = 0;
    gLifecycleVariant = 0;
    gIsolateVariant = 0;
    gVariantLoops = null;
    gShowLinkTasks = true;
    gShowLinkPercTotal = true;
    gShowLinkAvgDuration = true;
    gColorLink = '#FDC819';
    gStepLabelFontSize = '6pt';
    
    // Link width and color settings (determines visual appearance)
    gStepWidthTasks = true;
    gStepWidthDuration = false;
    gStepWidthStdDeviation = false;
    gStepColourVolume = false;
    gStepColourDuration = true;
    gStepColourStdDeviation = false;
    
    updateActivityColors();
    
    // Call these functions like visualizer does before generateArrays
    updateEventLogArray();
    resetMinMaxTimes();
    
    generateArrays(false, true, 'export', '');
    
    // NOW select top 20 variants by task count (after generateArrays populated the counts)
    const topVariants = gVariantArray
      .slice()
      .sort((a, b) => (b.t || 0) - (a.t || 0))
      .slice(0, 20);
    
    // Set gVariantPaneVariants with actual variant IDs and sequential sort order
    gVariantPaneVariants = topVariants.map((variant, index) => ({ 
      v: variant.v,           // Actual variant ID
      n: variant.n,           // Variant name/path
      s: index + 1,           // Sequential sort order (1-based)
      id: variant.id          // Variant ID
    }));
    
    // Fix duplicate flags - only for regular activity links, not start/end node links
    // Start/end node duplicate links must stay hidden to prevent duplicate Start/End nodes in diagram
    gLinkArray.forEach(link => {
      if (link.duplicate === true && link.start_node !== true && link.end_node !== true) {
        link.duplicate = false;
        link.visible = true;
      }
    });
    
    // Generate all three outputs while globals are set
    const linkDataArray = generateLinks('variants');
    const nodeDataArray = generateNodes('variants');
    
    // Filter out disconnected nodes (activities with no links in the top variants)
    const connectedNodeKeys = new Set();
    linkDataArray.forEach(link => {
      connectedNodeKeys.add(link.from);
      connectedNodeKeys.add(link.to);
    });
    let filteredNodeDataArray = nodeDataArray.filter(node => connectedNodeKeys.has(node.key));

    // Deduplicate sentinel nodes: if a real Jira activity is named 'Start' or 'End',
    // it gets a different node ID from the sentinel, causing duplicate named nodes in the diagram.
    // Fix by merging non-sentinel nodes with the same display name into the sentinel node.
    const sentinelStart = filteredNodeDataArray.find(n => n.start_node === true);
    const sentinelEnd   = filteredNodeDataArray.find(n => n.end_node   === true);
    const mergeMap = {};
    filteredNodeDataArray.forEach(node => {
      if (sentinelStart && !node.start_node && !node.end_node && node.text === sentinelStart.text) {
        mergeMap[node.key] = sentinelStart.key;
      }
      if (sentinelEnd && !node.start_node && !node.end_node && node.text === sentinelEnd.text) {
        mergeMap[node.key] = sentinelEnd.key;
      }
    });
    if (Object.keys(mergeMap).length > 0) {
      // Remap link endpoints and remove the now-redundant non-sentinel nodes
      linkDataArray.forEach(link => {
        if (mergeMap[link.from]) link.from = mergeMap[link.from];
        if (mergeMap[link.to])   link.to   = mergeMap[link.to];
      });
      filteredNodeDataArray = filteredNodeDataArray.filter(node => !mergeMap[node.key]);
      // Drop any self-loops created by the merge (e.g. Start->Start)
      const dedupedLinks = linkDataArray.filter(link => link.from !== link.to);
      linkDataArray.length = 0;
      dedupedLinks.forEach(l => linkDataArray.push(l));
    }
    
    const variants = processVariantsTable();
    const allSteps = processStepsTable({});
    const steps = allSteps.slice(0, 20); // Top 20 steps
    
    return { 
      diagramData: { nodeDataArray: filteredNodeDataArray, linkDataArray },
      variants,
      steps,
      totalSteps: allSteps.length
    };
    
  } catch (error) {
    console.error('Error generating export data:', error);
    throw error;
  } finally {
    Object.assign(globalThis, saved);
  }
}

/**
 * Generates export data AFTER applying saved model filters (processModel.filters).
 * Used by HTML/Confluence exports so they match what the visualizer shows.
 *
 * @param {Object} arrays Processed arrays from processEventLogTransform
 * @param {string|Array} modelFiltersJson processModel.filters (JSON string) or parsed array
 * @returns {{diagramData:any, variants:any[], steps:any[]}}
 */
export function generateFilteredExportData(arrays, modelFiltersJson) {
  const saved = {
    gActivityArray, gStepArray, gVariantArray, gTaskArray, gEventLogArray, gLinkArray, gVariantPaneVariants,
    gActivityShape, gNodeLabelFontSize, gColorStartNode, gColorEndNode,
    gShowStartNode, gShowEndNode, gShowStartLabel, gShowEndLabel, gShowNodeTasks, gShowNodePercTotal,
    gDiagramPVTasks, gEntityUpper, gDetailActivity, gAnimateVariant, gLifecycleVariant, gIsolateVariant,
    gVariantLoops, gShowLinkTasks, gShowLinkPercTotal, gShowLinkAvgDuration, gColorLink, gStepLabelFontSize,
    gStepWidthTasks, gStepWidthDuration, gStepWidthStdDeviation,
    gStepColourVolume, gStepColourDuration, gStepColourStdDeviation
  };

  try {
    // Seed globals from processed arrays (same as generateExportData)
    gActivityArray = arrays.activityArray || [];
    gStepArray = arrays.stepArray || [];
    gVariantArray = arrays.variantArray || [];
    gTaskArray = arrays.taskArray || [];
    gEventLogArray = arrays.eventLogArray || [];
    // gLinkArray is rebuilt by generateArrays; start empty to be safe
    gLinkArray = arrays.linkArray || [];

    // Set the same export defaults
    gShowStartNode = true;
    gShowEndNode = true;
    gShowStartLabel = true;
    gShowEndLabel = true;
    gShowNodeTasks = true;
    gShowNodePercTotal = false;
    gDiagramPVTasks = gTaskArray.length;
    gEntityUpper = gEntityUpper || 'Work Item';
    gActivityShape = 'RoundedRectangle';
    gNodeLabelFontSize = '7pt';
    gColorStartNode = '#A09E9E';
    gColorEndNode = '#A09E9E';
    gDetailActivity = null;
    gAnimateVariant = 0;
    gLifecycleVariant = 0;
    gIsolateVariant = 0;
    gVariantLoops = null;
    gShowLinkTasks = true;
    gShowLinkPercTotal = true;
    gShowLinkAvgDuration = true;
    gColorLink = '#FDC819';
    gStepLabelFontSize = '6pt';
    gStepWidthTasks = true;
    gStepWidthDuration = false;
    gStepWidthStdDeviation = false;
    gStepColourVolume = false;
    gStepColourDuration = true;
    gStepColourStdDeviation = false;

    updateActivityColors();
    updateEventLogArray();
    resetMinMaxTimes();

    // Apply saved filters (if any) BEFORE generating arrays/diagram
    let filterProps = [];
    try {
      if (typeof modelFiltersJson === 'string') {
        const s = (modelFiltersJson || '').trim();
        if (s && s !== '[]') filterProps = JSON.parse(s);
      } else if (Array.isArray(modelFiltersJson)) {
        filterProps = modelFiltersJson;
      }
    } catch (e) {
      console.warn('Could not parse model.filters for export; exporting without filters:', e);
      filterProps = [];
    }

    if (Array.isArray(filterProps) && filterProps.length > 0) {
      // Mirrors visualizer behavior
      processFilters(filterProps, 'loadJiraModel', false);
    }

    // Now generate arrays and export outputs (same as generateExportData)
    generateArrays(false, true, 'export', '');

    const topVariants = gVariantArray
      .slice()
      .sort((a, b) => (b.t || 0) - (a.t || 0))
      .slice(0, 20);

    gVariantPaneVariants = topVariants.map((variant, index) => ({
      v: variant.v,
      n: variant.n,
      s: index + 1,
      id: variant.id
    }));

    gLinkArray.forEach(link => {
      if (link.duplicate === true && link.start_node !== true && link.end_node !== true) {
        link.duplicate = false;
        link.visible = true;
      }
    });

    const nodeDataArray = (gNodeArray || []).slice();
    const linkDataArray = (gLinkArray || []).slice();
    const variants = (gVariantArray || []).slice().sort((a, b) => (b.t || 0) - (a.t || 0)).slice(0, 20);
    const steps = (gStepArray || []).slice().sort((a, b) => (b.t || 0) - (a.t || 0));

    // remove hidden nodes for export
    let filteredNodeDataArray = nodeDataArray.filter(n => n && n.visible !== false);

    // Deduplicate sentinel nodes: if a real Jira activity is named 'Start' or 'End',
    // it gets a different node ID from the sentinel, causing duplicate named nodes in the diagram.
    const sentinelStart2 = filteredNodeDataArray.find(n => n.start_node === true);
    const sentinelEnd2   = filteredNodeDataArray.find(n => n.end_node   === true);
    const mergeMap2 = {};
    filteredNodeDataArray.forEach(node => {
      if (sentinelStart2 && !node.start_node && !node.end_node && node.text === sentinelStart2.text) {
        mergeMap2[node.key] = sentinelStart2.key;
      }
      if (sentinelEnd2 && !node.start_node && !node.end_node && node.text === sentinelEnd2.text) {
        mergeMap2[node.key] = sentinelEnd2.key;
      }
    });
    if (Object.keys(mergeMap2).length > 0) {
      linkDataArray.forEach(link => {
        if (mergeMap2[link.from]) link.from = mergeMap2[link.from];
        if (mergeMap2[link.to])   link.to   = mergeMap2[link.to];
      });
      filteredNodeDataArray = filteredNodeDataArray.filter(node => !mergeMap2[node.key]);
      const dedupedLinks2 = linkDataArray.filter(link => link.from !== link.to);
      linkDataArray.length = 0;
      dedupedLinks2.forEach(l => linkDataArray.push(l));
    }

    return {
      diagramData: { nodeDataArray: filteredNodeDataArray, linkDataArray },
      variants,
      steps: steps.slice(0, 20)
    };
  } finally {
    // Restore globals
    gActivityArray = saved.gActivityArray;
    gStepArray = saved.gStepArray;
    gVariantArray = saved.gVariantArray;
    gTaskArray = saved.gTaskArray;
    gEventLogArray = saved.gEventLogArray;
    gLinkArray = saved.gLinkArray;
    gVariantPaneVariants = saved.gVariantPaneVariants;

    gActivityShape = saved.gActivityShape;
    gNodeLabelFontSize = saved.gNodeLabelFontSize;
    gColorStartNode = saved.gColorStartNode;
    gColorEndNode = saved.gColorEndNode;
    gShowStartNode = saved.gShowStartNode;
    gShowEndNode = saved.gShowEndNode;
    gShowStartLabel = saved.gShowStartLabel;
    gShowEndLabel = saved.gShowEndLabel;
    gShowNodeTasks = saved.gShowNodeTasks;
    gShowNodePercTotal = saved.gShowNodePercTotal;
    gDiagramPVTasks = saved.gDiagramPVTasks;
    gEntityUpper = saved.gEntityUpper;
    gDetailActivity = saved.gDetailActivity;
    gAnimateVariant = saved.gAnimateVariant;
    gLifecycleVariant = saved.gLifecycleVariant;
    gIsolateVariant = saved.gIsolateVariant;
    gVariantLoops = saved.gVariantLoops;
    gShowLinkTasks = saved.gShowLinkTasks;
    gShowLinkPercTotal = saved.gShowLinkPercTotal;
    gShowLinkAvgDuration = saved.gShowLinkAvgDuration;
    gColorLink = saved.gColorLink;
    gStepLabelFontSize = saved.gStepLabelFontSize;
    gStepWidthTasks = saved.gStepWidthTasks;
    gStepWidthDuration = saved.gStepWidthDuration;
    gStepWidthStdDeviation = saved.gStepWidthStdDeviation;
    gStepColourVolume = saved.gStepColourVolume;
    gStepColourDuration = saved.gStepColourDuration;
    gStepColourStdDeviation = saved.gStepColourStdDeviation;
  }
}

// Sprint 1 canonical-model observability for callers/tests.
export function getCanonicalDataset() { return gCanonicalDataset; }
export function getCanonicalProcessMetrics() { return gCanonicalProcessMetrics; }
export function getCanonicalEvidenceMetrics() { return gCanonicalEvidenceMetrics; }
export function getCanonicalFilteredDataset() { return gCanonicalFilteredDataset; }
export function getCanonicalFilteredEvidenceMetrics() { return gCanonicalFilteredEvidenceMetrics; }
export function refreshCanonicalEvidenceProjection() { return refreshCanonicalFilterProjection('manual-refresh'); }
